import React, { useState, useEffect, useRef } from "react";
import ReactDom from "react-dom/client";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import grapesjs from "grapesjs";
import gjsBlockBasic from "grapesjs-blocks-basic";
import "../../styles/main.scss";
import { useParams } from "react-router-dom";
import { API_HOST } from "../../api_utils/index";
import {
  deviceManager,
  layerManager,
  panels,
  selectorManager,
  storageManager,
  styleManager,
  traitManager,
  parserCss,
} from "../../api_utils/geditor_utils";
import axios from "axios";
import $ from "jquery";
import uniqid from "uniqid";
import grapesjsBlockBootstrap from "grapesjs-blocks-bootstrap4";

import grapesjsPluginExport from "grapesjs-plugin-export";

import { templateRedsling } from "../../templates/templateComponents/Redsling";
import { templateEcommProductPage } from "../../templates/templateComponents/EcommProductPage";
import { templateDetailsPage } from "../../templates/templateComponents/DetailsPage";
import { templateProductPage } from "../../templates/templateComponents/ProductPage";
import { templateCheckoutPage } from "../../templates/templateComponents/CheckoutPage";
import { templateReceiptPage } from "../../templates/templateComponents/ReceiptPage";
import { templatePaymentPage } from "../../templates/templateComponents/PaymentPage";
import { templateDashboardPage } from "../../templates/templateComponents/DashboardPage";
import { templateAddNewProductPage } from "../../templates/templateComponents/AddNewProductPage";

import BusinessDashboardTemplate from "../../templates/templatePlugins/BusinessDashboardTemplate";
// import QuestionnaireTemplate from "./templates/templatePlugins/QuestionnaireTemplate";

import PatchupProviderPlugin from "../../plugins/PatchupProviderPlugin";

// import { HeaderTemplate } from './templates/templateComponents/Header';

// import { DashBoardFuntional } from './templates/DashBoardFuntional'
import { useNavigate, useLocation } from "react-router-dom";

import manageInputTagTraits from "../../ManageTraits/manageInputTagTraits";
import manageButtonTagTraits from "../../ManageTraits/manageButtonTagTraits";
import manageTableTagTraits from "../../ManageTraits/manageTableTagTraits";
import { getAllModels } from "../../Redux/Actions/customTableActions";
import { getPageByProjectId } from "../../Redux/Actions/pageActions";
import { getAllProject } from "../../Redux/Actions/projectActions";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// imports for graph component
// import chartLibComponent from './plugins/charts/components';
// import { Colors } from 'chart.js';

import { CiMobile2 } from "react-icons/ci";
import { BsTabletLandscape, BsLaptop } from "react-icons/bs";

// for 3D graphs
// import Plotly from 'plotly.js-dist-min';

// importing dynamic/custom components
import {
  createTable,
  createGrid,
  createNavBar,
  createNavBarMob,
  createBasicForm,
  createMobBasicForm,
  appendIcon,
  createCarousel,
  createArrNavCarousel,
  createCaptionCarousel,
  createAccordion,
  createMobBasicAccordion,
  createMobInsetXBasicAccordion,
  createMobMultipleAccordion,
  createDropDown,
  createDirectionalDropDown,
  createFullCard1,
  createFullCard2,
  createTitleCard,
  createMobTitleCard,
  createProjectTable,
  createFormTable,
  createPageDataGrid,
  createProjectDataGrid,
  createPageDataForm,
  createProjectDataForm,
  createButtonCard,
  createListCard,
  createBoundedRippleButton,
  storeConnectionForm,
  createDynamicApiCallResponseTable,
  createMobSelect,
  createMobToggle,
  createSegmentButton,
  createIndividualSegmentButton,
  //createMobTabs,
  createIonicTabs,
  createIonicSearchBar,
  createIonicList,
  createIonicItem,
  createIonicMenu,
  createIonicAction,
  createIonicDateTime,
  createIonicFloatingBtn,
  createIonicModal,
  createIonicPopover,
  createIonicCheckbox,
  createIonicHeader,
  createIonicFooter,
  createIonicContent,
  createIonicToggle,
  createIonicToast,
  createIonicAlert,
  // createIonicRadio,
  createIonicSegment,
  createIonicSelect,
  createBasicButton,
  authenticateUser,
  storeConnectionForm2,
  dynamicApiCall2,
  createFileUploadButton,
  createImageUpload,
} from "../../creatorFunctions";
import {
  BugReportTwoTone,
  ConstructionOutlined,
  EditRoad,
} from "@mui/icons-material";
import Mobile from "../../PreviewApp/Mobile";
import {
  Avatar,
  Box,
  FormControlLabel,
  Grid,
  Paper,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import DeleteIcon from "@mui/icons-material/Delete";
import RestoreIcon from "@mui/icons-material/Restore";
import UpdateIcon from "@mui/icons-material/Update";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import CottageIcon from "@mui/icons-material/Cottage";
import WidgetsIcon from "@mui/icons-material/Widgets";
import ConstructionIcon from "@mui/icons-material/Construction";
import RedeemIcon from "@mui/icons-material/Redeem";
import AutoAwesomeMosaicIcon from "@mui/icons-material/AutoAwesomeMosaic";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ThunderstormIcon from "@mui/icons-material/Thunderstorm";
import AddReactionIcon from "@mui/icons-material/AddReaction";
import SmartButtonIcon from "@mui/icons-material/SmartButton";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DnsIcon from "@mui/icons-material/Dns";
import AddchartIcon from "@mui/icons-material/Addchart";
import WindowIcon from "@mui/icons-material/Window";
import Groups2Icon from "@mui/icons-material/Groups2";
import AnchorIcon from "@mui/icons-material/Anchor";
import LayersIcon from "@mui/icons-material/Layers";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import LogoutIcon from "@mui/icons-material/Logout";
import Scrollbar from "react-scrollbars-custom";
import SettingsIcon from "@mui/icons-material/Settings";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import PreviewIcon from "@mui/icons-material/Preview";

import LinearProgress from "@mui/material/LinearProgress";

import ReactDOM from "react-dom";

// import 'datatables.net-dt/css/jquery.dataTables.css';
// import grapesjsCkEditor from 'grapesjs-plugin-ckeditor';
// import grapesjsCkEditor from "grapesjs-plugin-ckeditor";
import grapesjsTuiImageEditor from "grapesjs-tui-image-editor";
import { connect } from "react-redux";
import { getAllFunctionsOfProject } from "../../Redux/Actions/functionActions";

import PageInModal from "../../PopupContainer/PageInModal";
import JSZip from "jszip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import TabletIcon from "@mui/icons-material/Tablet";
import LaptopMacIcon from "@mui/icons-material/LaptopMac";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import CustomTablePlugin from "../../Screens/CustomPlugins/CustomTablePlugin";
import CustomTablePluginNew from "../../Screens/CustomPlugins/CustomTablePluginNew";
// import CustomTablePluginNew from "./Screens/CustomPlugins/CustomTablePluginNew_TestComp3";
import MobileTabPlugin from "../../Screens/CustomPlugins/MobileTabPlugin";
import CustomCardPlugin from "../../Screens/CustomPlugins/CustomCardPlugin";
import customCardListPlugin from "../../Screens/CustomPlugins/customCardListPlugin";
import customFormElements from "../../Screens/CustomPlugins/customFormElements";
import customCardFH from "../../Screens/CustomPlugins/customCardFH";
//import KoreBotPlugin from "./Screens/CustomPlugins/KoreBotPlugin";
//import CalendyScreen from "./Screens/CalendyScreen";
import * as acorn from "acorn";
import { simple } from "acorn-walk";
import Blockly from "blockly";
// import plugin from "grapesjs-blockly";
import plugin from "../../Screens/CustomPlugins/grapesjs-blockly";

// importing function to handle excel file
import handleFile, { viewImport } from "../../handleImports";

// PDF files
import { pdfPreviewButton } from "../../plugins/PDFPlugin";
import { useReactToPrint } from "react-to-print";
import PdfPreview from "../../plugins/PDFPreview";

// Drill-Down Data Visualization
import DrillDownBarChartV2 from "../../plugins/DataVisualizationPlugin/DrillDownBarChartV2";
import ThreeDCharts from "../../plugins/DataVisualizationPlugin/ThreeDCharts_copy";
import TwoDCharts from "../../plugins/DataVisualizationPlugin/TwoDCharts";

import CustomDynamicCarouselPlugin from "../../plugins/CustomDynamicCarouselPlugin";

import { logout } from "../../Redux/Actions/userActions";
import grapesjsGradient from "grapesjs-style-gradient";

// importing google maps
// import { Loader } from "@googlemaps/js-api-loader";
import { Map } from "google-maps";
// import grapesjsTailwind from "grapesjs-tailwind";
var calendyClientSecret,
  calendyTokenUrl,
  calendyClientID,
  calendyAuthCode,
  calendyToken,
  calendyRefreshToken,
  calendyInviteURL,
  calendyUserUrl;

//const calendy = CalendyScreen();

function readTextFile(file) {
  var rawFile = new XMLHttpRequest();
  rawFile.open("GET", file, false);
  rawFile.onreadystatechange = function () {
    if (rawFile.readyState === 4) {
      if (rawFile.status === 200 || rawFile.status == 0) {
        var allText = rawFile.responseText;
        // alert(allText);
        // return allText;
      }
    }
  };
  rawFile.send(null);
  console.log("rawfile.responseText:", rawFile.responseText);
  return rawFile.responseText;
}

function readFile(file) {
  var rawFile = new XMLHttpRequest();
  rawFile.open("GET", file, false);
  rawFile.onreadystatechange = function () {
    if (rawFile.readyState === 4) {
      if (rawFile.status === 200 || rawFile.status == 0) {
        var allText = rawFile.responseText;
        // alert(allText);
        // return allText;
      }
    }
  };
  rawFile.send(null);
  console.log("rawfile.responseText:", rawFile.response);
  return rawFile.response;
}

const TraitManager = ({ editor }) => {
  // Access the TraitManager instance passed from the editor
  const traitManager = editor.TraitManager;

  // Customize and configure the TraitManager as needed
  traitManager.addType("customTrait", {
    // Custom trait configuration
    createInput({ trait }) {
      const input = document.createElement("input");
      input.type = "text";
      input.value = trait.get("value");

      input.addEventListener("change", () => {
        trait.set("value", input.value);
      });

      return input;
    },
    setValue({ elInput, value }) {
      elInput.value = value;
    },
    getValue({ elInput }) {
      return elInput.value;
    },
    onUpdate({ elInput, trait }) {
      elInput.value = trait.get("value");
    },
    onRemove({ trait }) {
      console.log("Trait removed:", trait);
    },
    // ... other custom trait methods and configuration
  });

  return <div>Trait Manager</div>;
};

const notifyTheme = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};

const successTheme = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};

// toast notification for empty tables
const infoTheme = {
  position: "top-right",
  autoClose: 10000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};

export var baseUrlData,
  baseUrl1,
  baseUrl2,
  baseUrl3,
  baseUrl4,
  baseUrl5,
  baseUrl1BearerToken,
  baseUrl2BearerToken,
  baseUrl3BearerToken,
  baseUrl4BearerToken,
  baseUrl5BearerToken;

let baseUrlDataFromStorage = localStorage.getItem("baseUrlData");
if (baseUrlDataFromStorage) {
  baseUrlData = JSON.parse(baseUrlDataFromStorage);
}

const Quill = require("quill");

const FragmentEditor = () => {
  // NOW STARTS:::::::::::
  const [editor, setEditor] = useState(null);
  const [gjsEditor, setGJSEditor] = useState(null);
  const [assets, setAssets] = useState([]);
  const [modal, setModal] = useState(false);
  const mobileViewport = useRef(null);
  const editorRef = useRef(null);
  const customTablesRef = useRef(null);
  const [tableData, setTableData] = useState(null);
  const [formData, setFormData] = useState([]);
  const [gridTableName, setGridTableName] = useState("");
  const [tableName, setTableName] = useState("");
  const [dynamicFormData, setDynamicFormData] = useState("");
  const buttonRef = useRef(null);
  const [showPrevOptions, setShowPrevOptions] = useState(false);
  const [isEditorLoading, setIsEditorLoading] = useState(true);
  const xlFileInputRef = useRef(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [disableScreensBtn, setDisableScreensBtn] = useState(false);

  const [loggedOut, setLoggedOut] = useState(false);

  const [printPDF, setPrintPDF] = useState(false);
  const componentRef = useRef();

  const { pageId } = useParams();

  const [activeEditorScreen, setActiveEditorScreen] = useState("100%");

  const removeExportButton = (panelsObj) => {
    const updatedPanels = panelsObj.defaults.map((panel) => {
      if (panel.id === "editor-actions") {
        // Filtering out the "export" button if the panel id is "editor-actions"
        const filteredButtons = panel.buttons.filter(
          (button) => button.id !== "export"
        );
        return {
          ...panel,
          buttons: filteredButtons,
        };
      }
      return panel;
    });

    return { ...panelsObj, defaults: updatedPanels };
  };

  let updatedPanels;

  let removeDownloadButton = true;
  //const { secretToken } = useParams();
  //const params = ;
  //  const secretToken1 = params.get('secretToken');
  // if(new URLSearchParams(window.location.search).get('secretToken')){
  //   console.log("secretToken" + new URLSearchParams(window.location.search).get('secretToken'));
  // }else{
  //   console.log("no secretToken");
  // }

  if (
    new URLSearchParams(window.location.search).get("secretToken") &&
    new URLSearchParams(window.location.search).get("secretToken") ===
      "canDownloadHtmlCssR3dslingInternal"
  ) {
    removeDownloadButton = false;
  }

  if (removeDownloadButton) {
    updatedPanels = removeExportButton(panels);
  } else {
    updatedPanels = panels;
  }

  console.log("pageId : = ", pageId);
  const [pageName, setPageName] = useState("");

  let navigate = useNavigate();
  const location = useLocation();
  let dispatch = useDispatch();

  const { userInfo } = useSelector((state) => state.userLogin);
  const { customTables } = useSelector((state) => state.customTables);
  const { pageByProjectData } = useSelector((state) => state.pageByProject_id);
  const { allProjectData, loading, error, emptyProject } = useSelector(
    (state) => state.allProjectData
  );

  // states for hover(siderbar)
  const [hoverStart, setHoverStart] = useState(false);
  const [pinSidebar, setPinSideBar] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const [showDashboardSub, setShowDashboardSub] = useState(false);
  const [showWidgetSub, setShowWidgetSub] = useState(false);
  const [showUiKitSub, setShowUiKitSub] = useState(false);
  const [showBonusSub, setShowBonusSub] = useState(false);
  const [showLayoutSub, setShowLayoutSub] = useState(false);
  const [showBuilderSub, setShowBuilderSub] = useState(false);
  const [showAnimationSub, setShowAnimationSub] = useState(false);
  const [showIconSub, setShowIconSub] = useState(false);
  const [showFormSub, setShowFormSub] = useState(false);
  const [showTableSub, setShowTableSub] = useState(false);
  const [showChartSub, setShowChartSub] = useState(false);
  const [showPagesSub, setShowPagesSub] = useState(false);
  const [isTraits, setIsTraits] = useState(false);
  const [isLayerManager, setIsLayerManager] = useState(false);
  const [isStyles, setIsStyles] = useState(false);
  const [isSelector, setIsSelector] = useState(false);
  const [showDesign, setShowDesign] = useState(false);
  // const [showAppSub, setShowAppSub] = useState(false)
  // const [showOtherSub, setShowOtherSub] = useState(false)

  // STATES FOR LINKING LEFT AND RIGHT SIDEBAR:
  const [userSelectedActionFromLeftBar, setUserSelectedActionFromLeftBar] =
    useState("");
  const [showRightSideBar, setShowRightSideBar] = useState(false);
  const [showButtonBlocks, setShowButtonBlocks] = useState(false);
  const designAndLayoutRef = useRef(null);
  const traitManagerRef = useRef(null);

  const functionList = useRef([]);
  const tempVarList = useRef([]);
  const fraunhoferUserData = useRef(null);

  const project_id = location.search ? location.search.split("=")[1] : "/";
  localStorage.setItem("project_id", project_id);
  customTablesRef.current = customTables;
  buttonRef.current = pageByProjectData;
  const [filteredBlocks, setFilteredBlocks] = useState([]);
  const wrapperRef = useRef(null);

  const currentProject = allProjectData?.filter(
    (prj) => prj._id === project_id
  )[0];

  if (currentProject != undefined) {
    baseUrl1 = currentProject.baseUrl1;
    baseUrl2 = currentProject.baseUrl2;
    baseUrl3 = currentProject.baseUrl3;
    baseUrl4 = currentProject.baseUrl4;
    baseUrl5 = currentProject.baseUrl5;
  }

  console.log("baseUrlData::::::::::::::", baseUrlData);

  // extracting token values from base URLs from baseUrlData
  if (baseUrlData) {
    try {
      if (`baseUrl1_${project_id}` in baseUrlData) {
        baseUrl1BearerToken = baseUrlData[`baseUrl1_${project_id}`].token;
      }
      if (`baseUrl2_${project_id}` in baseUrlData) {
        baseUrl2BearerToken = baseUrlData[`baseUrl2_${project_id}`].token;
      }
      if (`baseUrl3_${project_id}` in baseUrlData) {
        baseUrl3BearerToken = baseUrlData[`baseUrl3_${project_id}`].token;
      }
      if (`baseUrl4_${project_id}` in baseUrlData) {
        baseUrl4BearerToken = baseUrlData[`baseUrl4_${project_id}`].token;
      }
      if (`baseUrl5_${project_id}` in baseUrlData) {
        baseUrl5BearerToken = baseUrlData[`baseUrl5_${project_id}`].token;
      }
    } catch (e) {
      // statements
      console.log(e);
    }
  }

  console.log(
    "baseUrl1, baseUrl2, baseUrl3, baseUrl4, baseUrl5",
    baseUrl1,
    baseUrl2,
    baseUrl3,
    baseUrl4,
    baseUrl5
  );
  console.log(
    "baseUrl1BearerToken, baseUrl2BearerToken, baseUrl3BearerToken, baseUrl4BearerToken, baseUrl5BearerToken",
    baseUrl1BearerToken,
    baseUrl2BearerToken,
    baseUrl3BearerToken,
    baseUrl4BearerToken,
    baseUrl5BearerToken
  );

  const showPrintDialog = useReactToPrint({
    content: () => componentRef.current,
    onBeforePrint: () => {
      //actions before the print
    },
    onAfterPrint: () => {
      //actions after the print
      const GjsContainer = document.getElementById("editor");
      GjsContainer.style.display = "block";
      setPrintPDF(false);
    },
  });

  const handlePreviewPdf = (editor) => {
    if (editor && editor.DomComponents.getComponents().models.length > 0) {
      const GjsContainer = document.getElementById("editor");
      GjsContainer.style.display = "none";
      setPrintPDF(true);
    } else {
      alert("Enter content to check PDF Preview!");
    }
  };

  function getAllNestedComponents(component) {
    var nestedComponents = [];

    function traverse(component) {
      nestedComponents.push(component);

      if (component?.components?.length > 0) {
        component.components.each(function (childComponent) {
          traverse(childComponent);
        });
      }
    }

    console.log("nestedComponents111", nestedComponents);

    traverse(component);

    return nestedComponents;
  }

  function getAllComponents(editor) {
    var allComponents = [];

    function traverse(component) {
      allComponents.push(component);

      if (component.get("components")) {
        component.get("components").models.forEach(function (childComponent) {
          traverse(childComponent);
        });
      }
    }

    editor.DomComponents.getComponents().forEach(function (component) {
      traverse(component);
    });

    console.log("allComponents111", allComponents);

    return allComponents;
  }

  const resizeEditor = function (editorRef, screen) {
    // set screen sizes using deviceManager from geditor_utils.js file
    if (screen === "Desktop") {
      editor.setDevice("Desktop");
      localStorage.setItem(
        "device",
        JSON.stringify({ width: "100%", height: "100%", name: "Default" })
      );
      setActiveEditorScreen("Default - 100%");
    } else if (screen === "Laptop1024px") {
      editor.setDevice("Laptop1024px");
      localStorage.setItem(
        "device",
        JSON.stringify({
          width: "1024px",
          height: "100%",
          name: "Laptop1024px",
        })
      );
      setActiveEditorScreen("Laptop - 1024px");
    } else if (screen === "MacBookAir") {
      editor.setDevice("MacBookAir");
      localStorage.setItem(
        "device",
        JSON.stringify({ width: "1280px", height: "100%", name: "MacBook Air" })
      );
      setActiveEditorScreen("MacBook Air - 1280px");
    } else if (screen === "Laptop1440px") {
      editor.setDevice("Laptop1440px");
      localStorage.setItem(
        "device",
        JSON.stringify({
          width: "1440px",
          height: "100%",
          name: "Laptop1440px",
        })
      );
      setActiveEditorScreen("Laptop - 1440px");
    } else if (screen === "MacBookPro14") {
      editor.setDevice("MacBookPro14");
      localStorage.setItem(
        "device",
        JSON.stringify({
          width: "1512px",
          height: "100%",
          name: "MacBook Pro 14",
        })
      );
      setActiveEditorScreen("MacBook Pro 14 - 1512px");
    } else if (screen === "MacBookPro16") {
      editor.setDevice("MacBookPro16");
      localStorage.setItem(
        "device",
        JSON.stringify({
          width: "1728px",
          height: "100%",
          name: "MacBook Pro 16",
        })
      );
      setActiveEditorScreen("MacBook Pro 16 - 1728px");
    } else if (screen === "Desktop2560px") {
      editor.setDevice("Desktop2560px");
      localStorage.setItem(
        "device",
        JSON.stringify({
          width: "2560px",
          height: "100%",
          name: "Desktop2560px",
        })
      );
      setActiveEditorScreen("Desktop - 2560px");
    } else if (screen === "Mobile") {
      editor.setDevice("Mobile");
      localStorage.setItem(
        "device",
        JSON.stringify({ width: "480px", height: "100%", name: "Mobile" })
      );
      setActiveEditorScreen("Mobile");
    } else if (screen === "Android") {
      editor.setDevice("Android");
      localStorage.setItem(
        "device",
        JSON.stringify({ width: "360px", height: "100%", name: "Android" })
      );
      setActiveEditorScreen("Android");
    } else if (screen === "iPhoneSE") {
      editor.setDevice("iPhoneSE");
      localStorage.setItem(
        "device",
        JSON.stringify({ width: "375px", height: "667px", name: "iPhoneSE" })
      );
      setActiveEditorScreen("iPhoneSE");
    } else if (screen === "iPhoneXR") {
      editor.setDevice("iPhoneXR");
      localStorage.setItem(
        "device",
        JSON.stringify({ width: "414px", height: "896px", name: "iPhoneXR" })
      );
      setActiveEditorScreen("iPhoneXR");
    } else if (screen === "iPhone12Pro") {
      editor.setDevice("iPhone12Pro");
      localStorage.setItem(
        "device",
        JSON.stringify({
          width: "390px",
          height: "844px",
          name: "iPhone 12 Pro",
        })
      );
      setActiveEditorScreen("iPhone 12 Pro");
    } else if (screen === "iPhone13Mini") {
      editor.setDevice("iPhone13Mini");
      localStorage.setItem(
        "device",
        JSON.stringify({
          width: "375px",
          height: "812px",
          name: "iPhone 13 Mini",
        })
      );
      setActiveEditorScreen("iPhone 13 Mini");
    } else if (screen === "iPhone14Plus") {
      editor.setDevice("iPhone14Plus");
      localStorage.setItem(
        "device",
        JSON.stringify({
          width: "428px",
          height: "926px",
          name: "iPhone 14 Plus",
        })
      );
      setActiveEditorScreen("iPhone 14 Plus");
    } else if (screen === "iPhone14ProMax") {
      editor.setDevice("iPhone14ProMax");
      localStorage.setItem(
        "device",
        JSON.stringify({
          width: "430px",
          height: "932px",
          name: "iPhone 14 Pro Max",
        })
      );
      setActiveEditorScreen("iPhone 14 Pro Max");
    } else if (screen === "Pixel7") {
      editor.setDevice("Pixel7");
      localStorage.setItem(
        "device",
        JSON.stringify({ width: "412px", height: "915px", name: "Pixel 7" })
      );
      setActiveEditorScreen("Pixel 7");
    } else if (screen === "SamsungGalaxyS8") {
      editor.setDevice("SamsungGalaxyS8");
      localStorage.setItem(
        "device",
        JSON.stringify({ width: "360px", height: "740px", name: "Galaxy S8" })
      );
      setActiveEditorScreen("Galaxy S8");
    } else if (screen === "SamsungGalaxyS20Ultra") {
      editor.setDevice("SamsungGalaxyS20Ultra");
      localStorage.setItem(
        "device",
        JSON.stringify({
          width: "412px",
          height: "915px",
          name: "Galaxy S20 Ultra",
        })
      );
      setActiveEditorScreen("Galaxy S20 Ultra");
    } else if (screen === "GalaxyFold") {
      editor.setDevice("GalaxyFold");
      localStorage.setItem(
        "device",
        JSON.stringify({ width: "280px", height: "653px", name: "Galaxy Fold" })
      );
      setActiveEditorScreen("Galaxy Fold");
    } else if (screen === "SamsungGalaxyA5171") {
      editor.setDevice("SamsungGalaxyA5171");
      localStorage.setItem(
        "device",
        JSON.stringify({
          width: "412px",
          height: "914px",
          name: "Galaxy A51/71",
        })
      );
      setActiveEditorScreen("Galaxy A51/71");
    }
  };

  const myNewComponentTypes = (editor) => {
    const Chart = require("chart.js");

    const calenderId = uniqid("calender-");
    const calenderInputId = uniqid("calender1-");
    const calenderLabelId = uniqid("calender2-");
    const calenderItemId = uniqid("calender3-");
    const calenderDateId = uniqid("calender4-");

    if (editor !== null && editor !== undefined) {
      const defaultType = editor.DomComponents.getType("default");
      const defaultModel = defaultType.model;
      const defaultView = defaultType.view;

      // define image component definition to solve the image error
      // editor.DomComponents.addType("image", {
      //   isComponent: (el) => el.tagName === "div" && el.type === "image",

      //   model: {
      //     defaults: {
      //       tagName: "div",
      //       type: "image",
      //     },
      //   },

      //   view: {
      //     onRender({ el, model }) {
      //       // el.tagName = 'image';
      //       model.attributes.tagName = "img";
      //       // model.attributes.attributes.hoverable = false;
      //       console.log("el >>", el, model);
      //     },
      //   },
      // });

      editor.DomComponents.addType("image", {
        isComponent: (el) => el.tagName === "div" && el.type === "image",

        model: {
          defaults: {
            tagName: 'img',
            type: 'image',
            traits: [
              {
                type: 'text', // You can use 'text' or 'src' here
                label: 'Image URL',
                name: 'src', // Name of the attribute we are updating
                changeProp: 1, // Triggers the change when the value is updated
              }
            ],
          },

          init() {
            this.listenTo(this, 'change:src', this.updateAssetManager);
          },

          updateAssetManager() {
            const src = this.get('src');
            if (src) {
              // Check if the image is already in the asset manager
              const existingAsset = editor.AssetManager.getAll().filter(asset => asset.get('src') === src);
              if (!existingAsset.length) {
                editor.AssetManager.add({
                  src,
                  name: 'Custom Image'
                });
              }
            }
          }
        },

        view: {
          onRender({ el, model }) {
            // el.tagName = 'image';
            model.attributes.tagName = "img";
            // model.attributes.attributes.hoverable = false;
            console.log("el >>", el, model);
          },
        },
      });

      // define video component definition to solve the video error
      editor.DomComponents.addType("video", {
        isComponent: (el) => el.tagName === "div" && el.type === "video",

        model: {
          defaults: {
            tagName: "div",
            type: "image",
          },
        },

        view: {
          onRender({ el, model }) {
            // el.tagName = 'image';
            model.attributes.tagName = "video";
            // model.attributes.attributes.hoverable = false;
            console.log("el >>", el, model);
          },
        },
      });

      editor.DomComponents.addType("empty-form-container", {
        // console.log("HEREEEE 22")
        model: {
          defaults: {
            tagName: "form",
            attributes: { id: "empty-form-container" },
            styles: `
                        #empty-form-container {
                            width: 100%;
                            height: 50%;
                            padding: 1em;
                        }
                        `,
            Functions: "",
            traits: [
              "name",
              {
                type: "select",
                name: "Functions",
                label: "Functions",
                changeProp: true,
                options:
                  functionList && functionList.current !== null
                    ? [
                        ...functionList.current.map((x) => ({
                          value: x._id,
                          name: x.name,
                        })),
                        { value: "none", name: "None" },
                      ]
                    : [{ value: "none", name: "None" }],
              },
            ],
            "script-props": ["Functions"],
          },
        },

        view: {
          init() {
            this.listenTo(
              this.model,
              "change:Functions",
              this.handleFunctionChange
            );
            if (functionList.current !== null) {
              console.log("REDNER NOT NULL");
              this.on("render", this.handleFunctionChange);
              this.listenTo(this.model, "updated", this.handleFunctionChange);
            }
          },
          // onRender() {
          //     this.handleFunctionChange();
          // },
          handleFunctionChange(e) {
            // e.preventDefault();
            var selectedFunction = this.model.get("Functions");
            const components = this.model.components();

            let allSelectedVariables = [];
            let allSelectedVariablesValue = [];

            let functionToBeExecuted = functionList.current.find(
              (a) => a._id === selectedFunction
            );
            console.log("components FORM", components);
            console.log("IN HANDLE CHANGE ");
            if (functionToBeExecuted) {
              components.forEach((component) => {
                console.log("inside COMP", component);
                if (
                  component.attributes.attributes.id !== "submit-regular" &&
                  component.attributes.TempVar &&
                  component.attributes.TempVar !== "none"
                ) {
                  let findTempVarName = tempVarList.current.find(
                    (a) => a._id === component.attributes.TempVar
                  );
                  let userInputValue = component.view.$el.find("input").val();
                  if (findTempVarName && userInputValue) {
                    let renderedName = {
                      name: findTempVarName.name,
                      value: userInputValue,
                    };
                    return allSelectedVariablesValue.push(renderedName.value);
                  }
                }

                if (component.attributes.attributes.id === "submit-regular") {
                  component.view.$el.on("click", function () {
                    console.log("allSelectedVariables", allSelectedVariables);
                    console.log("functionToBeExecuted", functionToBeExecuted);
                    // executeFunction(functionToBeExecuted, tempVarList.current, userInfo, allSelectedVariablesValue)
                  });
                }
              });
            }
          },
        },
      });

      editor.DomComponents.addType("login_universal", {
        model: {
          defaults: {
            tagName: "div",
            type: "default",
            style: {
              display: "flex",
              "justify-content": "start",
              "align-items": "center",
              width: "100%",
            },
            components: [
              {
                type: "image",
                attributes: {
                  src: "https://images.unsplash.com/photo-1510074377623-8cf13fb86c08?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1172&q=80",
                },
                style: {
                  height: "500px",
                  width: "50%",
                },
              },
              {
                type: "complete_form_wrapper",
                attributes: {
                  class: "login_container",
                },
                style: {
                  width: "50%",
                  "padding-left": "2rem",
                  "padding-right": "2rem",
                  display: "block",
                  // "align-items": "center",
                },
                components: [
                  {
                    type: "form_title",
                  },
                  {
                    type: "form_email_field",
                    style: {
                      "margin-top": "3rem",
                      display: "flex",
                      "align-items": "center",
                    },
                  },
                  {
                    type: "form_password_field",
                    style: {
                      "margin-top": "1rem",
                      display: "flex",
                      "align-items": "center",
                    },
                  },
                  {
                    type: "form_submit_field",
                    style: {
                      "margin-top": "3rem",
                    },
                  },
                  {
                    type: "default",
                    tagName: "div",
                    style: {
                      display: "flex",
                      "justify-content": "center",
                      "align-items": "center",
                      "margin-top": "1rem",
                    },
                    components: [
                      {
                        type: "text",
                        content: "New User Registration ? ",
                      },
                      {
                        type: "link",
                        content: "Click Here",
                        style: {
                          "margin-left": "8px",
                          color: "#22d3ee",
                        },
                        attributes: {
                          class: "register_now_link",
                        },
                      },
                    ],
                  },
                ],
              },
              {
                type: "complete_form_wrapper",
                attributes: {
                  class: "signup_container",
                },
                style: {
                  width: "50%",
                  "padding-left": "2rem",
                  "padding-right": "2rem",
                  display: "none",
                },
                components: [
                  {
                    type: "form_title",
                  },
                  {
                    type: "form_email_field",
                    style: {
                      "margin-top": "3rem",
                    },
                  },
                  {
                    type: "form_password_field",
                    style: {
                      "margin-top": "1rem",
                    },
                  },
                  {
                    type: "form_submit_field",
                    style: {
                      "margin-top": "3rem",
                    },
                  },
                  {
                    type: "default",
                    tagName: "div",
                    style: {
                      display: "flex",
                      "justify-content": "center",
                      "align-items": "center",
                      "margin-top": "1rem",
                    },
                    components: [
                      {
                        type: "text",
                        content: "Already registered ? ",
                      },
                      {
                        type: "link",
                        content: "Login Here",
                        style: {
                          "margin-left": "8px",
                          color: "#22d3ee",
                        },
                        attributes: {
                          class: "login_now_link",
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
        },
        view: {
          init({ model }) {},
          onRender() {},
        },
      });

      // editor.DomComponents.addType('search_sort_table', {
      //     model: {
      //         defaults: {
      //             tagName: 'div',
      //             pageSize: 3,
      //             visibleKeys: Object.keys(fraunhoferUserData && fraunhoferUserData.current ? fraunhoferUserData.current[0] : []).map((key) => ({ id: key, name: key })),
      //             data: JSON.stringify(fraunhoferUserData && fraunhoferUserData.current ? fraunhoferUserData.current[0] : []),
      //             traits: [
      //                 { type: 'number', name: 'pageSize', label: 'Page Size', default: 10, changeProp: true },
      //             ],
      //             'script-props': ['pageSize', 'data'],
      //         },
      //     },
      //     view: {
      //         init({ model }) {
      //             this.listenTo(this, 'change:pageSize', this.onPageSizeChange);
      //         },
      //         onRender() {
      //             const model = this.model;
      //             const data = fraunhoferUserData && fraunhoferUserData.current ? fraunhoferUserData.current : [];
      //             const pageSize = model.get('pageSize');
      //             const userToken = JSON.parse(localStorage.getItem('userInfo'))

      //             console.log('Rendering table component');

      //             console.log('data::::::::::', data)

      //             if (this.tableComponent) {

      //                 this.tableComponent.destroy();
      //             }

      //             if (data && data.length > 0) {
      //                 this.tableComponent = new CustomTableComponent({
      //                     el: this.el,
      //                     data: data,
      //                     pageSize,
      //                     token: userToken ? userToken.token : ''
      //                 });
      //             } else {
      //                 console.log('Data is not available yet');
      //             }
      //         },
      //         onPageSizeChange() {
      //             console.log('Page size changed');
      //             this.onRender();
      //         },
      //     },
      // });

      // editor.DomComponents.addType('data-table', {
      //     model: {
      //         defaults: {
      //             tagName: 'div',
      //             components: [
      //                 {
      //                     tagName: 'input',
      //                     attributes: { type: 'text', placeholder: 'Search' },
      //                     classes: ['search-input'],
      //                 },
      //                 {
      //                     tagName: 'table',
      //                     classes: ['data-table'],
      //                     components: [
      //                         {
      //                             tagName: 'thead',
      //                             components: [
      //                                 {
      //                                     tagName: 'tr',
      //                                     components: Object.keys(data[0]).map((key) => ({
      //                                         tagName: 'th',
      //                                         content: key,
      //                                         classes: ['sortable'],
      //                                         attributes: { 'data-sort-field': key },
      //                                     })),
      //                                 },
      //                             ],
      //                         },
      //                         {
      //                             tagName: 'tbody',
      //                             components: data.map((item) => ({
      //                                 tagName: 'tr',
      //                                 components: Object.values(item).map((value) => ({
      //                                     tagName: 'td',
      //                                     content: value,
      //                                 })),
      //                             })),
      //                         },
      //                     ],
      //                 },
      //                 {
      //                     tagName: 'div',
      //                     classes: ['pagination'],
      //                 },
      //             ],
      //         },
      //     },
      //     view: {
      //         onRender({ el }) {
      //             console.log('el::::::::::', el)
      //             console.log('this', this)
      //             // Get the table element
      //             const table = el.children.find((component) => component.tagName === 'table');
      //             const components = editor.DomComponents.get

      //             console.log('table:', table);

      //             // Get the table body element
      //             const tbody = table.querySelector('tbody');

      //             // Get the sortable column headers
      //             const sortableHeaders = table.querySelectorAll('.sortable');

      //             // Add click event listener to each sortable header
      //             sortableHeaders.forEach((header) => {
      //                 header.addEventListener('click', () => {
      //                     // Get the field to sort based on from the header's data attribute
      //                     const sortField = header.getAttribute('data-sort-field');

      //                     // Get the current sort order (ascending or descending) from the header's data attribute
      //                     const currentSortOrder = header.getAttribute('data-sort-order');

      //                     // Toggle the sort order
      //                     const newSortOrder = currentSortOrder === 'asc' ? 'desc' : 'asc';

      //                     // Set the data-sort-order attribute on all sortable headers
      //                     sortableHeaders.forEach((sortableHeader) => {
      //                         sortableHeader.removeAttribute('data-sort-order');
      //                     });
      //                     header.setAttribute('data-sort-order', newSortOrder);

      //                     // Sort the data based on the selected field and sort order
      //                     const sortedData = this.model.data.sort((a, b) => {
      //                         if (newSortOrder === 'asc') {
      //                             return a[sortField].localeCompare(b[sortField]);
      //                         } else {
      //                             return b[sortField].localeCompare(a[sortField]);
      //                         }
      //                     });

      //                     // Clear the table body
      //                     tbody.innerHTML = '';

      //                     // Populate the table body with the sorted data
      //                     sortedData.forEach((item) => {
      //                         const row = document.createElement('tr');
      //                         Object.values(item).forEach((value) => {
      //                             const cell = document.createElement('td');
      //                             cell.textContent = value;
      //                             row.appendChild(cell);
      //                         });
      //                         tbody.appendChild(row);
      //                     });
      //                 });
      //             });
      //         },
      //     },

      // });

      editor.DomComponents.addType("login_fraunhofer", {
        model: {
          defaults: {
            script: function (props) {
              function handleSignIn() {
                // Get the values of the username and password inputs
                const usernameInput = document.getElementById("username");
                const passwordInput = document.getElementById("password");
                const username = usernameInput.value;
                const password = passwordInput.value;

                // Check if both fields are non-empty
                if (username.trim() === "" || password.trim() === "") {
                  alert("Please enter both username and password");
                  return;
                }

                // Make an API call with the username and password
                // Replace the URL and API call with your actual implementation
                fetch("https://your-api-url.com/login", {
                  method: "POST",
                  body: JSON.stringify({ username, password }),
                  headers: {
                    "Content-Type": "application/json",
                  },
                })
                  .then((response) => response.json())
                  .then((data) => {
                    // Handle the API response
                    console.log(data);
                  })
                  .catch((error) => {
                    // Handle any errors
                    console.error(error);
                  });
              }

              // Add event listeners to the username and password inputs
              const usernameInput = document.getElementById("username");
              usernameInput.addEventListener("input", () => {
                console.log("Username:", usernameInput.value);
              });

              const passwordInput = document.getElementById("password");
              passwordInput.addEventListener("input", () => {
                console.log("Password:", passwordInput.value);
              });

              // Add click event listener to the submit button
              const signInButton = document.querySelector(".text-teal-100");
              signInButton.addEventListener("click", handleSignIn);
            },

            components: `
                    <div class="grid grid-cols-5 gap-x-4 items-center h-full">
                      <div class="col-span-3">
                        <div class="w-full h-full relative">

                        <img src="https://images.unsplash.com/photo-1510074377623-8cf13fb86c08?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1172&q=80" class="h-full"/>


                        <div class=" z-20 p-8 heroHeadCircle text-white bg-gradient-to-b from-gray-800 via-teal-500 to-teal-800 flex justify-center items-center absolute top-20 right-20 w-2/3 h-2/3 rounded-full" >
                        <p class="tracking-wider text-center">
                        <strong class="text-lg">Bin Picking</strong> is a robot vision solution that guides your robot to pick and place a wide range of products for various service
                        </p>
                        </div>

                        </div>
                       
                      </div>
                      <div class="col-span-2">
                       <div class="w-full flex justify-end mb-8">
                        <p class="w-10 h-10 rounded-full bg-green-500"></p>
                       </div>

                       <div class="flex space-x-4 items-center justify-start mb-4">

                       <div class="flex items-end space-x-2 justify-start">
                       <p class="w-6 h-8 bg-blue-500"></p>
                       <p class="font-bold text-xl tracking-wider">Fraunhofer</p>
                       </div>

                       <p class="w-1 h-8 rounded-lg bg-gray-400"></p>

                       <div class="relative">
                       <p class="w-8 h-8 bg-yellow-400 rounded-full absolute top-0 left-4 " style="z-index:-1"></p>
                       <p class="font-bold text-xl tracking-wider" style="z-index:1">Bin Picking</p>
                       </div>
                       
                       </div>

                       <p class="text-gray-500 tracking-wider text-md mb-4">Welcome back! Please login to your account.</p>

                       <div class="space-y-2 mb-4">
                       <label for="username">User Name</label>
                       <input id="username" type="text" placeholder="Enter Your Username" class="w-full px-2 py-1 border boder-gray-400 rounded-md text-gray-500 outline-none"/>
                       </div>

                       <div class="space-y-2 mb-4">
                       <label for="password">Password</label>
                       <input id="password" type="password" placeholder="Enter Your Password" class="w-full px-2 py-1 border boder-gray-400 rounded-md text-gray-500 outline-none"/>
                       </div>

                       <div class="flex justify-between items-center ">

                       
                         <input type="checkbox" >
                       
                       


                       <button id="submitButton" class="text-teal-100 bg-teal-500 px-6 py-2 rounded-md hover:text-teal-500 hover:bg-teal-100 transition duration-300 hover:shadow-xl">
                       Sign In
                       </button>


                       </div>

                      </div>


                    </div>

                    <script type="text/javascript">

                    const usernameInput = document.getElementById('username');
                    usernameInput.addEventListener('input', () => {
                      console.log('Username:', usernameInput.value);
                    });
            
                    const passwordInput = document.getElementById('password');
                    passwordInput.addEventListener('input', () => {
                      console.log('Password:', passwordInput.value);
                    });
            
            
                    const signInButton = document.querySelector('#submitButton');
                    signInButton.addEventListener('click', () => {
                      const username = usernameInput.value;
                      const password = passwordInput.value;
            
            
                      if (username.trim() === '' || password.trim() === '') {
                        alert('Please enter both username and password');
                        return;
                      }
            
                      fetch('http://localhost:8085/customroutes/login', {
                        method: 'POST',
                        body: JSON.stringify({ username, password }),
                        headers: {
                          'Content-Type': 'application/json',
                        },
                      })
                        .then((response) => response.json())
                        .then((data) => {
                          // Handle the API response
                          console.log(data);
                        })
                        .catch((error) => {
                          // Handle any errors
                          console.error(error);
                        });
                    });
                  </script>

                 
                    `,
          },
        },
      });

      // graph components

      editor.DomComponents.addType("lineChart", {
        model: {
          defaults: {
            script: function (props) {
              const initLib = async function () {
                // this helper function recursively scans an object and its nests until it finds the key and returns its value
                function findKeyInNestedObject(response, key) {
                  let values = [];

                  function traverseObject(obj) {
                    for (let prop in obj) {
                      if (typeof obj[prop] === "object") {
                        traverseObject(obj[prop]);
                      } else if (Array.isArray(obj[prop])) {
                        for (let item of obj[prop]) {
                          if (typeof item === "object") {
                            traverseObject(item);
                          }
                        }
                      } else if (prop === key) {
                        values.push(Number(obj[prop]));
                      }
                    }
                  }

                  traverseObject(response);

                  return values;
                }

                // this helper function checks if an object has multiple levels of nesting
                function isNestedObject(response) {
                  if (typeof response !== "object") {
                    return false; // Not an object
                  }

                  for (let prop in response) {
                    if (typeof response[prop] === "object") {
                      return true; // Found nested object
                    }
                  }

                  return false; // No nested object found
                }

                // this helper function checks if there is an array of objects in a response object
                function hasArrayofObjects(obj) {
                  for (let prop in obj) {
                    if (
                      Array.isArray(obj[prop]) &&
                      obj[prop].length > 0 &&
                      typeof obj[prop][0] === "object"
                    ) {
                      return true; // Array of objects found
                    }
                  }
                  return false; // Array of objects not found
                }

                let username = props.Username;
                let password = props.Password;
                let apiKey = props.API_key;
                let moreHeaders = props.More_Headers;

                let xAxis = [];
                let yAxis = [];

                console.log(
                  "Graph props:",
                  props,
                  "\n\nusername:",
                  username,
                  "\npassword:",
                  password,
                  "\napiKey:",
                  apiKey,
                  "\nmoreHeaders:",
                  moreHeaders
                );

                if (props.Graph_API) {
                  try {
                    // By Invoice URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

                    // By Date URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

                    // By Customer URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

                    // By Coin URL
                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

                    // By Month URL
                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

                    // when api, username and password is provided but not api key
                    if (username && password && apiKey === undefined) {
                      let apiData;
                      let config = {
                        headers: {
                          Authorization:
                            "Basic " + btoa(username + ":" + password),
                        },
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait, if provided
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      const response = await fetch(
                        `${props.Graph_API}`,
                        config
                      );

                      const responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        responseData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        responseData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    // when api and api key is provided but not username and password
                    else if (!username && !password && apiKey !== undefined) {
                      let apiData;
                      let config = {
                        headers: {
                          "X-API-KEY": `${apiKey}`,
                        },
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      let response = await fetch(`${props.Graph_API}`, config);

                      let responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        responseData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        responseData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    // when everything is provided
                    else if (username && password && apiKey !== undefined) {
                      let apiData;
                      let config = {
                        headers: {
                          Authorization:
                            "Basic " + btoa(username + ":" + password),
                          "X-API-KEY": `${apiKey}`,
                        },
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      let response = await fetch(`${props.Graph_API}`, config);

                      let responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        responseData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        responseData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    // when api is provided but nothing else is provided
                    else if (!username && !password && apiKey === undefined) {
                      console.log(
                        "inside else if block - when nothing is provided except api"
                      );
                      let apiData;
                      // to hadd multiple header attributes
                      let config = {
                        headers: {},
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          config.headers[key] = val;

                          console.log("[key, val]:\n", key, val);
                        });
                      }

                      console.log("config:", config);

                      let response = await fetch(`${props.Graph_API}`, config);

                      let responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        apiData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        apiData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

                    // const labels = [
                    //   "January",
                    //   "February",
                    //   "March",
                    //   "April",
                    //   "May",
                    //   "June",
                    // ];

                    // animations
                    let animate;
                    let transition;
                    let delayed;

                    if (props.Animation === "delay") {
                      animate = {
                        onComplete: () => {
                          delayed = true;
                        },

                        delay: (context) => {
                          let delay = 0;
                          if (
                            context.type === "data" &&
                            context.mode === "default" &&
                            !delayed
                          ) {
                            delay =
                              context.dataIndex * 300 +
                              context.datasetIndex * 100;
                          }
                          return delay;
                        },
                      };
                    } else if (props.Animation === "hideAndShow") {
                      animate = {};
                      transition = {
                        show: {
                          animations: {
                            x: {
                              from: 0,
                            },
                            y: {
                              from: 0,
                            },
                          },
                        },

                        hide: {
                          animations: {
                            x: {
                              to: 0,
                            },
                            y: {
                              to: 0,
                            },
                          },
                        },
                      };
                    }

                    const data = {
                      // x-axis
                      labels: xAxis,
                      datasets: [
                        {
                          label: props.Abscissa,
                          // backgroundColor: ['red', 'green', 'blue'],
                          backgroundColor: !props.Bar_Colors
                            ? ["red", "green", "blue"]
                            : props.Bar_Colors.split(","),
                          borderColor: !props.Border_Color
                            ? "rgb(255, 99, 132)"
                            : props.Border_Color,
                          borderWidth: !props.Border_Width
                            ? 2
                            : props.Border_Width,
                          // y-axis
                          data: yAxis,
                          // color: ['red', 'green', 'blue'],
                        },
                      ],
                    };

                    const config = {
                      type: "line",
                      data: data,
                      options: {
                        animation: animate,
                        transitions: transition,
                        stacked: false,
                        responsive: true,
                      },
                    };

                    const ctx = document
                      .getElementById("lineChart")
                      .getContext("2d");
                    const myChart = new Chart(ctx, config);
                  } catch (e) {
                    console.log(e);
                  }
                }
              };

              if (typeof Chart == "undefined") {
                const script = document.createElement("script");
                script.onload = initLib;
                script.src = "https://cdn.jsdelivr.net/npm/chart.js";
                document.body.appendChild(script);
              } else {
                console.log("InitLib");
                initLib();
              }
            },

            Graph_API: "",
            Username: "",
            Password: "",
            API_Key: "",
            More_Headers: "", // input should be like: a:b,c:d,e:f

            Animation: "",
            Abscissa: "",
            Ordinate: "",
            Bar_Colors: "",
            Border_Width: "",
            Border_Color: "",
            // Fill: "",

            traits: [
              {
                type: "text",
                name: "Graph_API",
                label: "Graph API",
                changeProp: true,
              },
              {
                type: "text",
                name: "Username",
                label: "Username",
                changeProp: true,
              },
              {
                type: "text",
                name: "Password",
                label: "Password",
                changeProp: true,
              },
              {
                type: "text",
                name: "API_Key",
                label: "API Key",
                changeProp: true,
              },
              {
                type: "text",
                name: "More_Headers",
                label: "More Headers",
                changeProp: true,
              },
              {
                type: "select",
                name: "Animation",
                label: "Pre-defined Graph Animations",
                options: [
                  { id: "delay", name: "Delay" },
                  { id: "hideAndShow", name: "Hide And Show" },
                ],
                changeProp: true,
              },
              {
                type: "text",
                name: "Abscissa",
                label: "Abscissa",
                changeProp: true,
              },
              {
                type: "text",
                name: "Ordinate",
                label: "Ordinates",
                changeProp: true,
              },
              {
                type: "text",
                name: "Bar_Colors",
                label: "Datapoint Colors",
                changeProp: true,
              },
              {
                type: "range",
                min: "0",
                max: "20",
                name: "Border_Width",
                label: "Border Width [0px to 20px]",
                changeProp: true,
              },
              {
                type: "text",
                name: "Border_Color",
                label: "Border Color",
                changeProp: true,
              },
              // {
              //     type: 'checkbox',
              //     name: 'Fill',
              //     label: 'Fill Area',
              //     changeProp: true,
              // },
            ],

            changeProp: true,

            "script-props": [
              "Graph_API",
              "Username",
              "Password",
              "API_Key",
              "More_Headers",
              "Animation",
              "Abscissa",
              "Ordinate",
              "Bar_Colors",
              "Border_Width",
              "Border_Color",
            ],
          },
        },
        isComponent: (el) => {
          if (
            el.getAttribute &&
            el.getAttribute("data-gjs-type") == "lineChart"
          ) {
            return "lineChart";
          }
        },
        view: defaultView.extend({
          init({ model }) {},
        }),
      });

      editor.DomComponents.addType("barChart", {
        model: {
          defaults: {
            script: function (props) {
              const initLib = async function () {
                // this helper function recursively scans an object and its nests until it finds the key and returns its value
                function findKeyInNestedObject(response, key) {
                  let values = [];

                  function traverseObject(obj) {
                    for (let prop in obj) {
                      if (typeof obj[prop] === "object") {
                        traverseObject(obj[prop]);
                      } else if (Array.isArray(obj[prop])) {
                        for (let item of obj[prop]) {
                          if (typeof item === "object") {
                            traverseObject(item);
                          }
                        }
                      } else if (prop === key) {
                        values.push(Number(obj[prop]));
                      }
                    }
                  }

                  traverseObject(response);

                  return values;
                }

                // this helper function checks if an object has multiple levels of nesting
                function isNestedObject(response) {
                  if (typeof response !== "object") {
                    return false; // Not an object
                  }

                  for (let prop in response) {
                    if (typeof response[prop] === "object") {
                      return true; // Found nested object
                    }
                  }

                  return false; // No nested object found
                }

                // this helper function checks if there is an array of objects in a response object
                function hasArrayofObjects(obj) {
                  for (let prop in obj) {
                    if (
                      Array.isArray(obj[prop]) &&
                      obj[prop].length > 0 &&
                      typeof obj[prop][0] === "object"
                    ) {
                      return true; // Array of objects found
                    }
                  }
                  return false; // Array of objects not found
                }

                let username = props.Username;
                let password = props.Password;
                let apiKey = props.API_key;
                let moreHeaders = props.More_Headers;

                let xAxis = [];
                let yAxis = [];

                console.log(
                  "Graph props:",
                  props,
                  "\n\nusername:",
                  username,
                  "\npassword:",
                  password,
                  "\napiKey:",
                  apiKey,
                  "\nmoreHeaders:",
                  moreHeaders
                );

                if (props.Graph_API) {
                  try {
                    // By Invoice URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

                    // By Date URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

                    // By Customer URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

                    // By Coin URL
                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

                    // By Month URL
                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

                    // when api, username and password is provided but not api key
                    if (username && password && apiKey === undefined) {
                      let apiData;
                      let config = {
                        headers: {
                          Authorization:
                            "Basic " + btoa(username + ":" + password),
                        },
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait, if provided
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      const response = await fetch(
                        `${props.Graph_API}`,
                        config
                      );

                      const responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        responseData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        responseData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    // when api and api key is provided but not username and password
                    else if (!username && !password && apiKey !== undefined) {
                      let apiData;
                      let config = {
                        headers: {
                          "X-API-KEY": `${apiKey}`,
                        },
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      let response = await fetch(`${props.Graph_API}`, config);

                      let responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        responseData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        responseData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    // when everything is provided
                    else if (username && password && apiKey !== undefined) {
                      let apiData;
                      let config = {
                        headers: {
                          Authorization:
                            "Basic " + btoa(username + ":" + password),
                          "X-API-KEY": `${apiKey}`,
                        },
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      let response = await fetch(`${props.Graph_API}`, config);

                      let responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        responseData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        responseData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    // when api is provided but nothing else is provided
                    else if (!username && !password && apiKey === undefined) {
                      let apiData;
                      let config = {
                        headers: {},
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      let response = await fetch(`${props.Graph_API}`, config);

                      let responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        apiData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        apiData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

                    // const labels = [
                    //   "January",
                    //   "February",
                    //   "March",
                    //   "April",
                    //   "May",
                    //   "June",
                    // ];

                    // animations
                    let animate;
                    let transition;
                    let delayed;

                    if (props.Animation === "delay") {
                      animate = {
                        onComplete: () => {
                          delayed = true;
                        },

                        delay: (context) => {
                          let delay = 0;
                          if (
                            context.type === "data" &&
                            context.mode === "default" &&
                            !delayed
                          ) {
                            delay =
                              context.dataIndex * 300 +
                              context.datasetIndex * 100;
                          }
                          return delay;
                        },
                      };
                    } else if (props.Animation === "hideAndShow") {
                      animate = {};
                      transition = {
                        show: {
                          animations: {
                            x: {
                              from: 0,
                            },
                            y: {
                              from: 0,
                            },
                          },
                        },

                        hide: {
                          animations: {
                            x: {
                              to: 0,
                            },
                            y: {
                              to: 0,
                            },
                          },
                        },
                      };
                    }

                    const data = {
                      // x-axis
                      labels: xAxis,
                      datasets: [
                        {
                          label: props.Abscissa,
                          // backgroundColor: ['red', 'green', 'blue'],
                          backgroundColor: !props.Bar_Colors
                            ? ["red", "green", "blue"]
                            : props.Bar_Colors.split(","),
                          borderColor: !props.Border_Color
                            ? "rgb(255, 99, 132)"
                            : props.Border_Color,
                          borderWidth: !props.Border_Width
                            ? 2
                            : props.Border_Width,
                          // y-axis
                          data: yAxis,
                          // color: ['red', 'green', 'blue'],
                        },
                      ],
                    };

                    const config = {
                      type: "bar",
                      data: data,
                      options: {
                        animation: animate,
                        transitions: transition,
                        stacked: false,
                        responsive: true,
                      },
                    };

                    const ctx = document
                      .getElementById("barChart")
                      .getContext("2d");
                    const myChart = new Chart(ctx, config);
                  } catch (e) {
                    console.log(e);
                  }
                }
              };

              if (typeof Chart == "undefined") {
                const script = document.createElement("script");
                script.onload = initLib;
                script.src = "https://cdn.jsdelivr.net/npm/chart.js";
                document.body.appendChild(script);
              } else {
                console.log("InitLib");
                initLib();
              }
            },

            Graph_API: "",
            Username: "",
            Password: "",
            API_Key: "",
            More_Headers: "", // input should be like: a:b,c:d,e:f

            Animation: "",
            Abscissa: "",
            Ordinate: "",
            Bar_Colors: "",
            Border_Width: "",
            Border_Color: "",
            // Fill: "",

            traits: [
              {
                type: "text",
                name: "Graph_API",
                label: "Graph API",
                changeProp: true,
              },
              {
                type: "text",
                name: "Username",
                label: "Username",
                changeProp: true,
              },
              {
                type: "text",
                name: "Password",
                label: "Password",
                changeProp: true,
              },
              {
                type: "text",
                name: "API_Key",
                label: "API Key",
                changeProp: true,
              },
              {
                type: "text",
                name: "More_Headers",
                label: "More Headers",
                changeProp: true,
              },
              {
                type: "select",
                name: "Animation",
                label: "Pre-defined Graph Animations",
                options: [
                  { id: "delay", name: "Delay" },
                  { id: "hideAndShow", name: "Hide And Show" },
                ],
                changeProp: true,
              },
              {
                type: "text",
                name: "Abscissa",
                label: "Abscissa",
                changeProp: true,
              },
              {
                type: "text",
                name: "Ordinate",
                label: "Ordinates",
                changeProp: true,
              },
              {
                type: "text",
                name: "Bar_Colors",
                label: "Datapoint Colors",
                changeProp: true,
              },
              {
                type: "range",
                min: "0",
                max: "20",
                name: "Border_Width",
                label: "Border Width [0px to 20px]",
                changeProp: true,
              },
              {
                type: "text",
                name: "Border_Color",
                label: "Border Color",
                changeProp: true,
              },
              // {
              //     type: 'checkbox',
              //     name: 'Fill',
              //     label: 'Fill Area',
              //     changeProp: true,
              // },
            ],

            changeProp: true,

            "script-props": [
              "Graph_API",
              "Username",
              "Password",
              "API_Key",
              "More_Headers",
              "Animation",
              "Abscissa",
              "Ordinate",
              "Bar_Colors",
              "Border_Width",
              "Border_Color",
            ],
          },
        },
        isComponent: (el) => {
          if (
            el.getAttribute &&
            el.getAttribute("data-gjs-type") == "barChart"
          ) {
            return "barChart";
          }
        },
        view: defaultView.extend({
          init({ model }) {},
        }),
      });

      editor.DomComponents.addType("bubbleChart", {
        model: {
          defaults: {
            script: function (props) {
              const initLib = async function () {
                // this helper function recursively scans an object and its nests until it finds the key and returns its value
                function findKeyInNestedObject(response, key) {
                  let values = [];

                  function traverseObject(obj) {
                    for (let prop in obj) {
                      if (typeof obj[prop] === "object") {
                        traverseObject(obj[prop]);
                      } else if (Array.isArray(obj[prop])) {
                        for (let item of obj[prop]) {
                          if (typeof item === "object") {
                            traverseObject(item);
                          }
                        }
                      } else if (prop === key) {
                        values.push(Number(obj[prop]));
                      }
                    }
                  }

                  traverseObject(response);

                  return values;
                }

                // this helper function checks if an object has multiple levels of nesting
                function isNestedObject(response) {
                  if (typeof response !== "object") {
                    return false; // Not an object
                  }

                  for (let prop in response) {
                    if (typeof response[prop] === "object") {
                      return true; // Found nested object
                    }
                  }

                  return false; // No nested object found
                }

                // this helper function checks if there is an array of objects in a response object
                function hasArrayofObjects(obj) {
                  for (let prop in obj) {
                    if (
                      Array.isArray(obj[prop]) &&
                      obj[prop].length > 0 &&
                      typeof obj[prop][0] === "object"
                    ) {
                      return true; // Array of objects found
                    }
                  }
                  return false; // Array of objects not found
                }

                let username = props.Username;
                let password = props.Password;
                let apiKey = props.API_key;
                let moreHeaders = props.More_Headers;

                let xAxis = [];
                let yAxis = [];
                let radius = [];

                console.log(
                  "Graph props:",
                  props,
                  "\n\nusername:",
                  username,
                  "\npassword:",
                  password,
                  "\napiKey:",
                  apiKey,
                  "\nmoreHeaders:",
                  moreHeaders
                );

                if (props.Graph_API) {
                  try {
                    // By Invoice URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

                    // By Date URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

                    // By Customer URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

                    // By Coin URL
                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

                    // By Month URL
                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

                    // when api, username and password is provided but not api key
                    if (username && password && apiKey === undefined) {
                      let apiData;
                      let config = {
                        headers: {
                          Authorization:
                            "Basic " + btoa(username + ":" + password),
                        },
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait, if provided
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      const response = await fetch(
                        `${props.Graph_API}`,
                        config
                      );

                      const responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        responseData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        responseData[props.Ordinate]
                      );
                      let radiusIsNested = isNestedObject(
                        responseData[props.Radius]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis, radius for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }

                        for (let objR of apiData) {
                          radius.push(objR[!props.Radius ? "" : props.Radius]);
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis, radius for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate]) &&
                          props.Radius &&
                          Array.isArray(apiData[props.Radius])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];

                          let rContainsString = apiData[props.Radius].some(
                            (element) => typeof element === "string"
                          );
                          radius = !rContainsString
                            ? apiData[props.Radius]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          (responseData[props.Ordinate] === null &&
                            props.Radius &&
                            typeof responseData[props.Radius] !== "object") ||
                          responseData[props.Radius] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                          radius.push(apiData[props.Radius]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested &&
                          props.Radius &&
                          radiusIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );
                          let rValue = findKeyInNestedObject(
                            apiData[props.Radius],
                            props.Radius
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue) &&
                            Array.isArray(rValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                            radius = rValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              rValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              !Array.isArray(rValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            (yValue === null && typeof rValue !== "object") ||
                            rValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                            radius.push(rValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          props.Radius &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );
                          let rValue = findKeyInNestedObject(
                            apiData,
                            props.Radius
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                            radius = rValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && typeof rValue !== 'object' || rValue === null && xValue !== 'NaN' && yValue !== 'NaN' && rValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number" &&
                            typeof Number(rValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                            radius.push(Number(rValue));
                          }
                        }
                      }
                    }

                    // when api and api key is provided but not username and password
                    else if (!username && !password && apiKey !== undefined) {
                      let apiData;
                      let config = {
                        headers: {
                          "X-API-KEY": `${apiKey}`,
                        },
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      let response = await fetch(`${props.Graph_API}`, config);

                      let responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        responseData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        responseData[props.Ordinate]
                      );
                      let radiusIsNested = isNestedObject(
                        responseData[props.Radius]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis, radius for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }

                        for (let objR of apiData) {
                          radius.push(objR[!props.Radius ? "" : props.Radius]);
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis, radius for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate]) &&
                          props.Radius &&
                          Array.isArray(apiData[props.Radius])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];

                          let rContainsString = apiData[props.Radius].some(
                            (element) => typeof element === "string"
                          );
                          radius = !rContainsString
                            ? apiData[props.Radius]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          (responseData[props.Ordinate] === null &&
                            props.Radius &&
                            typeof responseData[props.Radius] !== "object") ||
                          responseData[props.Radius] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                          radius.push(apiData[props.Radius]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested &&
                          props.Radius &&
                          radiusIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );
                          let rValue = findKeyInNestedObject(
                            apiData[props.Radius],
                            props.Radius
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue) &&
                            Array.isArray(rValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                            radius = rValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              rValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              !Array.isArray(rValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            (yValue === null && typeof rValue !== "object") ||
                            rValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                            radius.push(rValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          props.Radius &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );
                          let rValue = findKeyInNestedObject(
                            apiData,
                            props.Radius
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                            radius = rValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && typeof rValue !== 'object' || rValue === null && xValue !== 'NaN' && yValue !== 'NaN' && rValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number" &&
                            typeof Number(rValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                            radius.push(Number(rValue));
                          }
                        }
                      }
                    }

                    // when everything is provided
                    else if (username && password && apiKey !== undefined) {
                      let apiData;
                      let config = {
                        headers: {
                          Authorization:
                            "Basic " + btoa(username + ":" + password),
                          "X-API-KEY": `${apiKey}`,
                        },
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      let response = await fetch(`${props.Graph_API}`, config);

                      let responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        responseData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        responseData[props.Ordinate]
                      );
                      let radiusIsNested = isNestedObject(
                        responseData[props.Radius]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis, radius for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }

                        for (let objR of apiData) {
                          radius.push(objR[!props.Radius ? "" : props.Radius]);
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis, radius for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate]) &&
                          props.Radius &&
                          Array.isArray(apiData[props.Radius])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];

                          let rContainsString = apiData[props.Radius].some(
                            (element) => typeof element === "string"
                          );
                          radius = !rContainsString
                            ? apiData[props.Radius]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          (responseData[props.Ordinate] === null &&
                            props.Radius &&
                            typeof responseData[props.Radius] !== "object") ||
                          responseData[props.Radius] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                          radius.push(apiData[props.Radius]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested &&
                          props.Radius &&
                          radiusIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );
                          let rValue = findKeyInNestedObject(
                            apiData[props.Radius],
                            props.Radius
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue) &&
                            Array.isArray(rValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                            radius = rValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              rValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              !Array.isArray(rValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            (yValue === null && typeof rValue !== "object") ||
                            rValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                            radius.push(rValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          props.Radius &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );
                          let rValue = findKeyInNestedObject(
                            apiData,
                            props.Radius
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                            radius = rValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && typeof rValue !== 'object' || rValue === null && xValue !== 'NaN' && yValue !== 'NaN' && rValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number" &&
                            typeof Number(rValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                            radius.push(Number(rValue));
                          }
                        }
                      }
                    }

                    // when api is provided but nothing else is provided
                    else if (!username && !password && apiKey === undefined) {
                      let apiData;
                      let config = {
                        headers: {},
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      let response = await fetch(`${props.Graph_API}`, config);

                      let responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        responseData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        responseData[props.Ordinate]
                      );
                      let radiusIsNested = isNestedObject(
                        responseData[props.Radius]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis, radius for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }

                        for (let objR of apiData) {
                          radius.push(objR[!props.Radius ? "" : props.Radius]);
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis, radius for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate]) &&
                          props.Radius &&
                          Array.isArray(apiData[props.Radius])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];

                          let rContainsString = apiData[props.Radius].some(
                            (element) => typeof element === "string"
                          );
                          radius = !rContainsString
                            ? apiData[props.Radius]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          (responseData[props.Ordinate] === null &&
                            props.Radius &&
                            typeof responseData[props.Radius] !== "object") ||
                          responseData[props.Radius] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                          radius.push(apiData[props.Radius]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested &&
                          props.Radius &&
                          radiusIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );
                          let rValue = findKeyInNestedObject(
                            apiData[props.Radius],
                            props.Radius
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue) &&
                            Array.isArray(rValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                            radius = rValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              rValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              !Array.isArray(rValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            (yValue === null && typeof rValue !== "object") ||
                            rValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                            radius.push(rValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          props.Radius &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );
                          let rValue = findKeyInNestedObject(
                            apiData,
                            props.Radius
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                            radius = rValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && typeof rValue !== 'object' || rValue === null && xValue !== 'NaN' && yValue !== 'NaN' && rValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number" &&
                            typeof Number(rValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                            radius.push(Number(rValue));
                          }
                        }
                      }
                    }

                    console.log(
                      "xAxis:",
                      xAxis,
                      "\nyAxis:",
                      yAxis,
                      "\nradius:",
                      radius
                    );

                    // const labels = [
                    //   "January",
                    //   "February",
                    //   "March",
                    //   "April",
                    //   "May",
                    //   "June",
                    // ];

                    // animations
                    let animate;
                    let transition;
                    let delayed;

                    if (props.Animation === "delay") {
                      animate = {
                        onComplete: () => {
                          delayed = true;
                        },

                        delay: (context) => {
                          let delay = 0;
                          if (
                            context.type === "data" &&
                            context.mode === "default" &&
                            !delayed
                          ) {
                            delay =
                              context.dataIndex * 300 +
                              context.datasetIndex * 100;
                          }
                          return delay;
                        },
                      };
                    } else if (props.Animation === "hideAndShow") {
                      animate = {};
                      transition = {
                        show: {
                          animations: {
                            x: {
                              from: 0,
                            },
                            y: {
                              from: 0,
                            },
                          },
                        },

                        hide: {
                          animations: {
                            x: {
                              to: 0,
                            },
                            y: {
                              to: 0,
                            },
                          },
                        },
                      };
                    }

                    // to populate data of dataset of bubble graph
                    let bubbleData = [];

                    for (let i = 0; i < xAxis.length; i++) {
                      xAxis.length > 0 &&
                        yAxis.length > 0 &&
                        radius.length > 0 &&
                        bubbleData.push({
                          x: xAxis[i],
                          y: yAxis[i],
                          r: radius[i],
                        });
                    }

                    console.log("bubbleData:", bubbleData);

                    const data = {
                      datasets: [
                        {
                          label: !props.Label ? "Bubble Chart" : props.Label,
                          // backgroundColor: ['red', 'green', 'blue'],
                          backgroundColor: !props.Bar_Colors
                            ? ["red", "green", "blue"]
                            : props.Bar_Colors.split(","),
                          borderColor: !props.Border_Color
                            ? "rgb(255, 99, 132)"
                            : props.Border_Color,
                          borderWidth: !props.Border_Width
                            ? 2
                            : props.Border_Width,
                          data: bubbleData,
                        },
                      ],
                    };

                    const config = {
                      type: "bubble",
                      data: data,
                      options: {
                        animation: animate,
                        transitions: transition,
                      },
                    };

                    const ctx = document
                      .getElementById("bubbleChart")
                      .getContext("2d");
                    const myChart = new Chart(ctx, config);
                  } catch (e) {
                    console.log(e);
                  }
                }
              };

              if (typeof Chart == "undefined") {
                const script = document.createElement("script");
                script.onload = initLib;
                script.src = "https://cdn.jsdelivr.net/npm/chart.js";
                document.body.appendChild(script);
              } else {
                console.log("InitLib");
                initLib();
              }
            },

            Graph_API: "",
            Username: "",
            Password: "",
            API_Key: "",
            More_Headers: "", // input should be like: a:b,c:d,e:f

            Animation: "",
            Label: "",
            Abscissa: "",
            Ordinate: "",
            Radius: "",
            Bar_Colors: "",
            Border_Width: "",
            Border_Color: "",

            traits: [
              {
                type: "text",
                name: "Graph_API",
                label: "Graph API",
                changeProp: true,
              },
              {
                type: "text",
                name: "Username",
                label: "Username",
                changeProp: true,
              },
              {
                type: "text",
                name: "Password",
                label: "Password",
                changeProp: true,
              },
              {
                type: "text",
                name: "API_Key",
                label: "API Key",
                changeProp: true,
              },
              {
                type: "text",
                name: "More_Headers",
                label: "More Headers",
                changeProp: true,
              },
              {
                type: "select",
                name: "Animation",
                label: "Pre-defined Graph Animations",
                options: [
                  { id: "delay", name: "Delay" },
                  { id: "hideAndShow", name: "Hide And Show" },
                ],
                changeProp: true,
              },
              {
                type: "text",
                name: "Abscissa",
                label: "Abscissa",
                changeProp: true,
              },
              {
                type: "text",
                name: "Ordinate",
                label: "Ordinates",
                changeProp: true,
              },
              {
                type: "text",
                name: "Radius",
                label: "Radius",
                changeProp: true,
              },
              {
                type: "text",
                name: "Bar_Colors",
                label: "Datapoint Colors",
                changeProp: true,
              },
              {
                type: "range",
                min: "0",
                max: "20",
                name: "Border_Width",
                label: "Border Width [0px to 20px]",
                changeProp: true,
              },
              {
                type: "text",
                name: "Border_Color",
                label: "Border Color",
                changeProp: true,
              },
            ],

            changeProp: true,

            "script-props": [
              "Graph_API",
              "Username",
              "Password",
              "API_Key",
              "More_Headers",
              "Animation",
              "Abscissa",
              "Ordinate",
              "Radius",
              "Bar_Colors",
              "Border_Width",
              "Border_Color",
            ],
          },
        },
        isComponent: (el) => {
          if (
            el.getAttribute &&
            el.getAttribute("data-gjs-type") == "bubbleChart"
          ) {
            return "bubbleChart";
          }
        },
        view: defaultView.extend({
          init({ model }) {},
        }),
      });

      editor.DomComponents.addType("doughnutChart", {
        model: {
          defaults: {
            script: function (props) {
              const initLib = async function () {
                // this helper function recursively scans an object and its nests until it finds the key and returns its value
                function findKeyInNestedObject(response, key) {
                  let values = [];

                  function traverseObject(obj) {
                    for (let prop in obj) {
                      if (typeof obj[prop] === "object") {
                        traverseObject(obj[prop]);
                      } else if (Array.isArray(obj[prop])) {
                        for (let item of obj[prop]) {
                          if (typeof item === "object") {
                            traverseObject(item);
                          }
                        }
                      } else if (prop === key) {
                        values.push(Number(obj[prop]));
                      }
                    }
                  }

                  traverseObject(response);

                  return values;
                }

                // this helper function checks if an object has multiple levels of nesting
                function isNestedObject(response) {
                  if (typeof response !== "object") {
                    return false; // Not an object
                  }

                  for (let prop in response) {
                    if (typeof response[prop] === "object") {
                      return true; // Found nested object
                    }
                  }

                  return false; // No nested object found
                }

                // this helper function checks if there is an array of objects in a response object
                function hasArrayofObjects(obj) {
                  for (let prop in obj) {
                    if (
                      Array.isArray(obj[prop]) &&
                      obj[prop].length > 0 &&
                      typeof obj[prop][0] === "object"
                    ) {
                      return true; // Array of objects found
                    }
                  }
                  return false; // Array of objects not found
                }

                let username = props.Username;
                let password = props.Password;
                let apiKey = props.API_key;
                let moreHeaders = props.More_Headers;

                let xAxis = [];
                let yAxis = [];

                console.log(
                  "Graph props:",
                  props,
                  "\n\nusername:",
                  username,
                  "\npassword:",
                  password,
                  "\napiKey:",
                  apiKey,
                  "\nmoreHeaders:",
                  moreHeaders
                );

                if (props.Graph_API) {
                  try {
                    // By Invoice URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

                    // By Date URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

                    // By Customer URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

                    // By Coin URL
                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

                    // By Month URL
                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

                    // when api, username and password is provided but not api key
                    if (username && password && apiKey === undefined) {
                      let apiData;
                      let config = {
                        headers: {
                          Authorization:
                            "Basic " + btoa(username + ":" + password),
                        },
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait, if provided
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      const response = await fetch(
                        `${props.Graph_API}`,
                        config
                      );

                      const responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        responseData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        responseData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    // when api and api key is provided but not username and password
                    else if (!username && !password && apiKey !== undefined) {
                      let apiData;
                      let config = {
                        headers: {
                          "X-API-KEY": `${apiKey}`,
                        },
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      let response = await fetch(`${props.Graph_API}`, config);

                      let responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        responseData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        responseData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    // when everything is provided
                    else if (username && password && apiKey !== undefined) {
                      let apiData;
                      let config = {
                        headers: {
                          Authorization:
                            "Basic " + btoa(username + ":" + password),
                          "X-API-KEY": `${apiKey}`,
                        },
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      let response = await fetch(`${props.Graph_API}`, config);

                      let responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        responseData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        responseData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    // when api is provided but nothing else is provided
                    else if (!username && !password && apiKey === undefined) {
                      console.log(
                        "inside else if block - when nothing is provided except api"
                      );
                      let apiData;
                      // to hadd multiple header attributes
                      let config = {
                        headers: {},
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          config.headers[key] = val;

                          console.log("[key, val]:\n", key, val);
                        });
                      }

                      console.log("config:", config);

                      let response = await fetch(`${props.Graph_API}`, config);

                      let responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        apiData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        apiData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

                    // const labels = [
                    //   "January",
                    //   "February",
                    //   "March",
                    //   "April",
                    //   "May",
                    //   "June",
                    // ];

                    // animations
                    let animate;
                    let transition;
                    let delayed;

                    if (props.Animation === "delay") {
                      animate = {
                        onComplete: () => {
                          delayed = true;
                        },

                        delay: (context) => {
                          let delay = 0;
                          if (
                            context.type === "data" &&
                            context.mode === "default" &&
                            !delayed
                          ) {
                            delay =
                              context.dataIndex * 300 +
                              context.datasetIndex * 100;
                          }
                          return delay;
                        },
                      };
                    } else if (props.Animation === "hideAndShow") {
                      animate = {};
                      transition = {
                        show: {
                          animations: {
                            x: {
                              from: 0,
                            },
                            y: {
                              from: 0,
                            },
                          },
                        },

                        hide: {
                          animations: {
                            x: {
                              to: 0,
                            },
                            y: {
                              to: 0,
                            },
                          },
                        },
                      };
                    }

                    const data = {
                      datasets: [
                        {
                          backgroundColor: !props.Bar_Colors
                            ? ["red", "green", "blue"]
                            : props.Bar_Colors.split(","),
                          borderColor: !props.Border_Color
                            ? "rgb(255, 99, 132)"
                            : props.Border_Color,
                          borderWidth: !props.Border_Width
                            ? 2
                            : props.Border_Width,
                          hoverOffset: 4,
                          // data: [10, 20, 30]
                          data: yAxis,
                        },
                      ],

                      labels: xAxis,
                    };

                    const config = {
                      type: "doughnut",
                      data: data,
                      options: {
                        animation: animate,
                        transitions: transition,
                        responsive: true,
                      },
                    };

                    const ctx = document
                      .getElementById("doughnutChart")
                      .getContext("2d");
                    const myChart = new Chart(ctx, config);
                  } catch (e) {
                    console.log(e);
                  }
                }
              };

              if (typeof Chart == "undefined") {
                const script = document.createElement("script");
                script.onload = initLib;
                script.src = "https://cdn.jsdelivr.net/npm/chart.js";
                document.body.appendChild(script);
              } else {
                console.log("InitLib");
                initLib();
              }
            },

            Graph_API: "",
            Username: "",
            Password: "",
            API_Key: "",
            More_Headers: "", // input should be like: a:b,c:d,e:f

            Animation: "",
            Abscissa: "",
            Ordinate: "",
            Bar_Colors: "",
            Border_Width: "",
            Border_Color: "",
            // Fill: "",

            traits: [
              {
                type: "text",
                name: "Graph_API",
                label: "Graph API",
                changeProp: true,
              },
              {
                type: "text",
                name: "Username",
                label: "Username",
                changeProp: true,
              },
              {
                type: "text",
                name: "Password",
                label: "Password",
                changeProp: true,
              },
              {
                type: "text",
                name: "API_Key",
                label: "API Key",
                changeProp: true,
              },
              {
                type: "text",
                name: "More_Headers",
                label: "More Headers",
                changeProp: true,
              },
              {
                type: "select",
                name: "Animation",
                label: "Pre-defined Graph Animations",
                options: [
                  { id: "delay", name: "Delay" },
                  { id: "hideAndShow", name: "Hide And Show" },
                ],
                changeProp: true,
              },
              {
                type: "text",
                name: "Abscissa",
                label: "Abscissa",
                changeProp: true,
              },
              {
                type: "text",
                name: "Ordinate",
                label: "Ordinates",
                changeProp: true,
              },
              {
                type: "text",
                name: "Bar_Colors",
                label: "Datapoint Colors",
                changeProp: true,
              },
              {
                type: "range",
                min: "0",
                max: "20",
                name: "Border_Width",
                label: "Border Width [0px to 20px]",
                changeProp: true,
              },
              {
                type: "text",
                name: "Border_Color",
                label: "Border Color",
                changeProp: true,
              },
              // {
              //     type: 'checkbox',
              //     name: 'Fill',
              //     label: 'Fill Area',
              //     changeProp: true,
              // },
            ],

            changeProp: true,

            "script-props": [
              "Graph_API",
              "Username",
              "Password",
              "API_Key",
              "More_Headers",
              "Animation",
              "Abscissa",
              "Ordinate",
              "Bar_Colors",
              "Border_Width",
              "Border_Color",
            ],
          },
        },
        isComponent: (el) => {
          if (
            el.getAttribute &&
            el.getAttribute("data-gjs-type") == "doughnutChart"
          ) {
            return "doughnutChart";
          }
        },
        view: defaultView.extend({
          init({ model }) {},
        }),
      });

      editor.DomComponents.addType("pieChart", {
        model: {
          defaults: {
            script: function (props) {
              const initLib = async function () {
                // this helper function recursively scans an object and its nests until it finds the key and returns its value
                function findKeyInNestedObject(response, key) {
                  let values = [];

                  function traverseObject(obj) {
                    for (let prop in obj) {
                      if (typeof obj[prop] === "object") {
                        traverseObject(obj[prop]);
                      } else if (Array.isArray(obj[prop])) {
                        for (let item of obj[prop]) {
                          if (typeof item === "object") {
                            traverseObject(item);
                          }
                        }
                      } else if (prop === key) {
                        values.push(Number(obj[prop]));
                      }
                    }
                  }

                  traverseObject(response);

                  return values;
                }

                // this helper function checks if an object has multiple levels of nesting
                function isNestedObject(response) {
                  if (typeof response !== "object") {
                    return false; // Not an object
                  }

                  for (let prop in response) {
                    if (typeof response[prop] === "object") {
                      return true; // Found nested object
                    }
                  }

                  return false; // No nested object found
                }

                // this helper function checks if there is an array of objects in a response object
                function hasArrayofObjects(obj) {
                  for (let prop in obj) {
                    if (
                      Array.isArray(obj[prop]) &&
                      obj[prop].length > 0 &&
                      typeof obj[prop][0] === "object"
                    ) {
                      return true; // Array of objects found
                    }
                  }
                  return false; // Array of objects not found
                }

                let username = props.Username;
                let password = props.Password;
                let apiKey = props.API_key;
                let moreHeaders = props.More_Headers;

                let xAxis = [];
                let yAxis = [];

                console.log(
                  "Graph props:",
                  props,
                  "\n\nusername:",
                  username,
                  "\npassword:",
                  password,
                  "\napiKey:",
                  apiKey,
                  "\nmoreHeaders:",
                  moreHeaders
                );

                if (props.Graph_API) {
                  try {
                    // By Invoice URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

                    // By Date URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

                    // By Customer URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

                    // By Coin URL
                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

                    // By Month URL
                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

                    // when api, username and password is provided but not api key
                    if (username && password && apiKey === undefined) {
                      let apiData;
                      let config = {
                        headers: {
                          Authorization:
                            "Basic " + btoa(username + ":" + password),
                        },
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait, if provided
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      const response = await fetch(
                        `${props.Graph_API}`,
                        config
                      );

                      const responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        responseData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        responseData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    // when api and api key is provided but not username and password
                    else if (!username && !password && apiKey !== undefined) {
                      let apiData;
                      let config = {
                        headers: {
                          "X-API-KEY": `${apiKey}`,
                        },
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      let response = await fetch(`${props.Graph_API}`, config);

                      let responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        responseData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        responseData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    // when everything is provided
                    else if (username && password && apiKey !== undefined) {
                      let apiData;
                      let config = {
                        headers: {
                          Authorization:
                            "Basic " + btoa(username + ":" + password),
                          "X-API-KEY": `${apiKey}`,
                        },
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      let response = await fetch(`${props.Graph_API}`, config);

                      let responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        responseData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        responseData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    // when api is provided but nothing else is provided
                    else if (!username && !password && apiKey === undefined) {
                      console.log(
                        "inside else if block - when nothing is provided except api"
                      );
                      let apiData;
                      // to hadd multiple header attributes
                      let config = {
                        headers: {},
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          config.headers[key] = val;

                          console.log("[key, val]:\n", key, val);
                        });
                      }

                      console.log("config:", config);

                      let response = await fetch(`${props.Graph_API}`, config);

                      let responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        apiData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        apiData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

                    // const labels = [
                    //   "January",
                    //   "February",
                    //   "March",
                    //   "April",
                    //   "May",
                    //   "June",
                    // ];

                    // animations
                    let animate;
                    let transition;
                    let delayed;

                    if (props.Animation === "delay") {
                      animate = {
                        onComplete: () => {
                          delayed = true;
                        },

                        delay: (context) => {
                          let delay = 0;
                          if (
                            context.type === "data" &&
                            context.mode === "default" &&
                            !delayed
                          ) {
                            delay =
                              context.dataIndex * 300 +
                              context.datasetIndex * 100;
                          }
                          return delay;
                        },
                      };
                    } else if (props.Animation === "hideAndShow") {
                      animate = {};
                      transition = {
                        show: {
                          animations: {
                            x: {
                              from: 0,
                            },
                            y: {
                              from: 0,
                            },
                          },
                        },

                        hide: {
                          animations: {
                            x: {
                              to: 0,
                            },
                            y: {
                              to: 0,
                            },
                          },
                        },
                      };
                    }

                    const data = {
                      datasets: [
                        {
                          backgroundColor: !props.Bar_Colors
                            ? ["red", "green", "blue"]
                            : props.Bar_Colors.split(","),
                          borderColor: !props.Border_Color
                            ? "rgb(255, 99, 132)"
                            : props.Border_Color,
                          borderWidth: !props.Border_Width
                            ? 2
                            : props.Border_Width,
                          hoverOffset: 4,
                          // data: [10, 20, 30]
                          data: yAxis,
                        },
                      ],

                      labels: xAxis,
                    };

                    const config = {
                      type: "pie",
                      data: data,
                      options: {
                        animation: animate,
                        transitions: transition,
                        responsive: true,
                      },
                    };

                    const ctx = document
                      .getElementById("pieChart")
                      .getContext("2d");
                    const myChart = new Chart(ctx, config);
                  } catch (e) {
                    console.log(e);
                  }
                }
              };

              if (typeof Chart == "undefined") {
                const script = document.createElement("script");
                script.onload = initLib;
                script.src = "https://cdn.jsdelivr.net/npm/chart.js";
                document.body.appendChild(script);
              } else {
                console.log("InitLib");
                initLib();
              }
            },

            Graph_API: "",
            Username: "",
            Password: "",
            API_Key: "",
            More_Headers: "", // input should be like: a:b,c:d,e:f

            Animation: "",
            Abscissa: "",
            Ordinate: "",
            Bar_Colors: "",
            Border_Width: "",
            Border_Color: "",
            // Fill: "",

            traits: [
              {
                type: "text",
                name: "Graph_API",
                label: "Graph API",
                changeProp: true,
              },
              {
                type: "text",
                name: "Username",
                label: "Username",
                changeProp: true,
              },
              {
                type: "text",
                name: "Password",
                label: "Password",
                changeProp: true,
              },
              {
                type: "text",
                name: "API_Key",
                label: "API Key",
                changeProp: true,
              },
              {
                type: "text",
                name: "More_Headers",
                label: "More Headers",
                changeProp: true,
              },
              {
                type: "select",
                name: "Animation",
                label: "Pre-defined Graph Animations",
                options: [
                  { id: "delay", name: "Delay" },
                  { id: "hideAndShow", name: "Hide And Show" },
                ],
                changeProp: true,
              },
              {
                type: "text",
                name: "Abscissa",
                label: "Abscissa",
                changeProp: true,
              },
              {
                type: "text",
                name: "Ordinate",
                label: "Ordinates",
                changeProp: true,
              },
              {
                type: "text",
                name: "Bar_Colors",
                label: "Datapoint Colors",
                changeProp: true,
              },
              {
                type: "range",
                min: "0",
                max: "20",
                name: "Border_Width",
                label: "Border Width [0px to 20px]",
                changeProp: true,
              },
              {
                type: "text",
                name: "Border_Color",
                label: "Border Color",
                changeProp: true,
              },
              // {
              //     type: 'checkbox',
              //     name: 'Fill',
              //     label: 'Fill Area',
              //     changeProp: true,
              // },
            ],

            changeProp: true,

            "script-props": [
              "Graph_API",
              "Username",
              "Password",
              "API_Key",
              "More_Headers",
              "Animation",
              "Abscissa",
              "Ordinate",
              "Bar_Colors",
              "Border_Width",
              "Border_Color",
            ],
          },
        },
        isComponent: (el) => {
          if (
            el.getAttribute &&
            el.getAttribute("data-gjs-type") == "pieChart"
          ) {
            return "pieChart";
          }
        },
        view: defaultView.extend({
          init({ model }) {},
        }),
      });

      editor.DomComponents.addType("polarAreaChart", {
        model: {
          defaults: {
            script: function (props) {
              const initLib = async function () {
                // this helper function recursively scans an object and its nests until it finds the key and returns its value
                function findKeyInNestedObject(response, key) {
                  let values = [];

                  function traverseObject(obj) {
                    for (let prop in obj) {
                      if (typeof obj[prop] === "object") {
                        traverseObject(obj[prop]);
                      } else if (Array.isArray(obj[prop])) {
                        for (let item of obj[prop]) {
                          if (typeof item === "object") {
                            traverseObject(item);
                          }
                        }
                      } else if (prop === key) {
                        values.push(Number(obj[prop]));
                      }
                    }
                  }

                  traverseObject(response);

                  return values;
                }

                // this helper function checks if an object has multiple levels of nesting
                function isNestedObject(response) {
                  if (typeof response !== "object") {
                    return false; // Not an object
                  }

                  for (let prop in response) {
                    if (typeof response[prop] === "object") {
                      return true; // Found nested object
                    }
                  }

                  return false; // No nested object found
                }

                // this helper function checks if there is an array of objects in a response object
                function hasArrayofObjects(obj) {
                  for (let prop in obj) {
                    if (
                      Array.isArray(obj[prop]) &&
                      obj[prop].length > 0 &&
                      typeof obj[prop][0] === "object"
                    ) {
                      return true; // Array of objects found
                    }
                  }
                  return false; // Array of objects not found
                }

                let username = props.Username;
                let password = props.Password;
                let apiKey = props.API_key;
                let moreHeaders = props.More_Headers;

                let xAxis = [];
                let yAxis = [];

                console.log(
                  "Graph props:",
                  props,
                  "\n\nusername:",
                  username,
                  "\npassword:",
                  password,
                  "\napiKey:",
                  apiKey,
                  "\nmoreHeaders:",
                  moreHeaders
                );

                if (props.Graph_API) {
                  try {
                    // By Invoice URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

                    // By Date URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

                    // By Customer URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

                    // By Coin URL
                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

                    // By Month URL
                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

                    // when api, username and password is provided but not api key
                    if (username && password && apiKey === undefined) {
                      let apiData;
                      let config = {
                        headers: {
                          Authorization:
                            "Basic " + btoa(username + ":" + password),
                        },
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait, if provided
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      const response = await fetch(
                        `${props.Graph_API}`,
                        config
                      );

                      const responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        responseData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        responseData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    // when api and api key is provided but not username and password
                    else if (!username && !password && apiKey !== undefined) {
                      let apiData;
                      let config = {
                        headers: {
                          "X-API-KEY": `${apiKey}`,
                        },
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      let response = await fetch(`${props.Graph_API}`, config);

                      let responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        responseData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        responseData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    // when everything is provided
                    else if (username && password && apiKey !== undefined) {
                      let apiData;
                      let config = {
                        headers: {
                          Authorization:
                            "Basic " + btoa(username + ":" + password),
                          "X-API-KEY": `${apiKey}`,
                        },
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      let response = await fetch(`${props.Graph_API}`, config);

                      let responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        responseData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        responseData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    // when api is provided but nothing else is provided
                    else if (!username && !password && apiKey === undefined) {
                      let apiData;
                      let config = {
                        headers: {},
                      };
                      // ['a:b', "c:d"]
                      // extracting headers from More_Headers trait
                      if (moreHeaders) {
                        moreHeaders.split(",").forEach((header) => {
                          let key, val;
                          [key, val] = header.split(":");
                          console.log("[key, val]:\n", key, val);

                          config.headers[key] = val;
                        });
                      }

                      console.log("config:", config);

                      let response = await fetch(`${props.Graph_API}`, config);

                      let responseData = await response.json();
                      apiData = responseData;
                      console.log(
                        "responseData:",
                        responseData,
                        "\napiData:",
                        apiData
                      );

                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
                      let abscissaIsNested = isNestedObject(
                        apiData[props.Abscissa]
                      );
                      let ordinateIsNested = isNestedObject(
                        apiData[props.Ordinate]
                      );

                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
                      if (
                        Array.isArray(apiData) &&
                        apiData.length > 0 &&
                        typeof apiData[0] === "object"
                      ) {
                        for (let objX of apiData) {
                          xAxis.push(
                            objX[!props.Abscissa ? "" : props.Abscissa]
                          );
                        }

                        for (let objY of apiData) {
                          yAxis.push(
                            objY[!props.Ordinate ? "" : props.Ordinate]
                          );
                        }
                      }

                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
                      else if (
                        typeof apiData === "object" &&
                        !Array.isArray(apiData)
                      ) {
                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
                        if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          Array.isArray(apiData[props.Abscissa]) &&
                          props.Ordinate &&
                          Array.isArray(apiData[props.Ordinate])
                        ) {
                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
                          let xContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          xAxis = !xContainsString
                            ? apiData[props.Abscissa]
                            : [];

                          let yContainsString = apiData[props.Abscissa].some(
                            (element) => typeof element === "string"
                          );
                          yAxis = !yContainsString
                            ? apiData[props.Ordinate]
                            : [];
                        }

                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
                        else if (
                          (!hasNestedArrayOfObjects &&
                            props.Abscissa &&
                            typeof apiData[props.Abscissa] !== "object") ||
                          (apiData[props.Abscissa] === null &&
                            props.Ordinate &&
                            typeof responseData[props.Ordinate] !== "object") ||
                          responseData[props.Ordinate] === null
                        ) {
                          xAxis.push(apiData[props.Abscissa]);
                          yAxis.push(apiData[props.Ordinate]);
                        }

                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
                        else if (
                          !hasNestedArrayOfObjects &&
                          props.Abscissa &&
                          abscissaIsNested &&
                          props.Ordinate &&
                          ordinateIsNested
                        ) {
                          console.log("inside 1");
                          let xValue = findKeyInNestedObject(
                            apiData[props.Abscissa],
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData[props.Ordinate],
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          else if (
                            (xValue &&
                              yValue &&
                              !Array.isArray(xValue) &&
                              !Array.isArray(yValue) &&
                              typeof xValue !== "object") ||
                            (xValue === null && typeof yValue !== "object") ||
                            yValue === null
                          ) {
                            xAxis.push(xValue);
                            yAxis.push(yValue);
                          }
                        }

                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
                        else if (
                          props.Abscissa &&
                          props.Ordinate &&
                          hasNestedArrayOfObjects
                        ) {
                          console.log("inside 2");
                          let xValue = findKeyInNestedObject(
                            apiData,
                            props.Abscissa
                          );
                          let yValue = findKeyInNestedObject(
                            apiData,
                            props.Ordinate
                          );

                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
                          if (
                            xValue &&
                            yValue &&
                            Array.isArray(xValue) &&
                            Array.isArray(yValue)
                          ) {
                            xAxis = xValue;
                            yAxis = yValue;
                          }

                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
                          else if (
                            typeof Number(xValue) === "number" &&
                            typeof Number(yValue) === "number"
                          ) {
                            xAxis.push(Number(xValue));
                            yAxis.push(Number(yValue));
                          }
                        }
                      }
                    }

                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

                    // const labels = [
                    //   "January",
                    //   "February",
                    //   "March",
                    //   "April",
                    //   "May",
                    //   "June",
                    // ];

                    // animations
                    let animate;
                    let transition;
                    let delayed;

                    if (props.Animation === "delay") {
                      animate = {
                        onComplete: () => {
                          delayed = true;
                        },

                        delay: (context) => {
                          let delay = 0;
                          if (
                            context.type === "data" &&
                            context.mode === "default" &&
                            !delayed
                          ) {
                            delay =
                              context.dataIndex * 300 +
                              context.datasetIndex * 100;
                          }
                          return delay;
                        },
                      };
                    } else if (props.Animation === "hideAndShow") {
                      animate = {};
                      transition = {
                        show: {
                          animations: {
                            x: {
                              from: 0,
                            },
                            y: {
                              from: 0,
                            },
                          },
                        },

                        hide: {
                          animations: {
                            x: {
                              to: 0,
                            },
                            y: {
                              to: 0,
                            },
                          },
                        },
                      };
                    }

                    const data = {
                      // x-axis
                      labels: xAxis,
                      datasets: [
                        {
                          label: props.Abscissa,
                          // backgroundColor: ['red', 'green', 'blue'],
                          backgroundColor: !props.Bar_Colors
                            ? ["red", "green", "blue"]
                            : props.Bar_Colors.split(","),
                          borderColor: !props.Border_Color
                            ? "rgb(255, 99, 132)"
                            : props.Border_Color,
                          borderWidth: !props.Border_Width
                            ? 2
                            : props.Border_Width,
                          // y-axis
                          data: yAxis,
                          // color: ['red', 'green', 'blue'],
                        },
                      ],
                    };

                    const config = {
                      type: "polarArea",
                      data: data,
                      options: {
                        animation: animate,
                        transitions: transition,
                        stacked: false,
                        responsive: true,
                      },
                    };

                    const ctx = document
                      .getElementById("polarAreaChart")
                      .getContext("2d");
                    const myChart = new Chart(ctx, config);
                  } catch (e) {
                    console.log(e);
                  }
                }
              };

              if (typeof Chart == "undefined") {
                const script = document.createElement("script");
                script.onload = initLib;
                script.src = "https://cdn.jsdelivr.net/npm/chart.js";
                document.body.appendChild(script);
              } else {
                console.log("InitLib");
                initLib();
              }
            },

            Graph_API: "",
            Username: "",
            Password: "",
            API_Key: "",
            More_Headers: "", // input should be like: a:b,c:d,e:f

            Animation: "",
            Abscissa: "",
            Ordinate: "",
            Bar_Colors: "",
            Border_Width: "",
            Border_Color: "",
            // Fill: "",

            traits: [
              {
                type: "text",
                name: "Graph_API",
                label: "Graph API",
                changeProp: true,
              },
              {
                type: "text",
                name: "Username",
                label: "Username",
                changeProp: true,
              },
              {
                type: "text",
                name: "Password",
                label: "Password",
                changeProp: true,
              },
              {
                type: "text",
                name: "API_Key",
                label: "API Key",
                changeProp: true,
              },
              {
                type: "text",
                name: "More_Headers",
                label: "More Headers",
                changeProp: true,
              },
              {
                type: "select",
                name: "Animation",
                label: "Pre-defined Graph Animations",
                options: [
                  { id: "delay", name: "Delay" },
                  { id: "hideAndShow", name: "Hide And Show" },
                ],
                changeProp: true,
              },
              {
                type: "text",
                name: "Abscissa",
                label: "Abscissa",
                changeProp: true,
              },
              {
                type: "text",
                name: "Ordinate",
                label: "Ordinates",
                changeProp: true,
              },
              {
                type: "text",
                name: "Bar_Colors",
                label: "Datapoint Colors",
                changeProp: true,
              },
              {
                type: "range",
                min: "0",
                max: "20",
                name: "Border_Width",
                label: "Border Width [0px to 20px]",
                changeProp: true,
              },
              {
                type: "text",
                name: "Border_Color",
                label: "Border Color",
                changeProp: true,
              },
              // {
              //     type: 'checkbox',
              //     name: 'Fill',
              //     label: 'Fill Area',
              //     changeProp: true,
              // },
            ],

            changeProp: true,

            "script-props": [
              "Graph_API",
              "Username",
              "Password",
              "API_Key",
              "More_Headers",
              "Animation",
              "Abscissa",
              "Ordinate",
              "Bar_Colors",
              "Border_Width",
              "Border_Color",
            ],
          },
        },
        isComponent: (el) => {
          if (
            el.getAttribute &&
            el.getAttribute("data-gjs-type") == "polarAreaChart"
          ) {
            return "polarAreaChart";
          }
        },
        view: defaultView.extend({
          init({ model }) {},
        }),
      });

      editor.DomComponents.addType("lineBarBubbleMixChart", {
        model: {
          defaults: {
            script: function (props) {
              const initLib = async function () {
                let username = "SLTECH1";
                let password = "Welcome@123";

                let xAxis = []; // data for X axis
                let yAxisLine = []; // data for Y axis line graph
                let yAxisBar = []; // data for Y axis bar graph
                let yAxisBubble = []; // data for Y axis bubble graph

                console.log("Graph props:", props);

                if (props.Graph_API) {
                  try {
                    // By Invoice URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

                    // By Date URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

                    // By Customer URL
                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

                    // By Coin URL
                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

                    // By Month URL
                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR
                    let response = await fetch(`${props.Graph_API}`, {
                      headers: {
                        Authorization:
                          "Basic " + btoa(username + ":" + password),
                      },
                    });
                    let responseData = await response.json();
                    console.log("responseData:", responseData);

                    for (let objX of responseData) {
                      xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa]);
                    }

                    for (let objYLine of responseData) {
                      yAxisLine.push(
                        objYLine[
                          !props.LineGraphOrdinate
                            ? ""
                            : props.LineGraphOrdinate
                        ]
                      );
                    }

                    for (let objYBar of responseData) {
                      yAxisBar.push(
                        objYBar[
                          !props.BarGraphOrdinate ? "" : props.BarGraphOrdinate
                        ]
                      );
                    }

                    for (let objYBubble of responseData) {
                      yAxisBubble.push(
                        objYBubble[
                          !props.BubbleGraphOrdinate
                            ? ""
                            : props.BubbleGraphOrdinate
                        ]
                      );
                    }

                    // const labels = [
                    //   "January",
                    //   "February",
                    //   "March",
                    //   "April",
                    //   "May",
                    //   "June",
                    // ];

                    // animations
                    let animate;
                    let transition;
                    let delayed;

                    if (props.Animation === "delay") {
                      animate = {
                        onComplete: () => {
                          delayed = true;
                        },

                        delay: (context) => {
                          let delay = 0;
                          if (
                            context.type === "data" &&
                            context.mode === "default" &&
                            !delayed
                          ) {
                            delay =
                              context.dataIndex * 300 +
                              context.datasetIndex * 100;
                          }
                          return delay;
                        },
                      };
                    } else if (props.Animation === "hideAndShow") {
                      animate = {};
                      transition = {
                        show: {
                          animations: {
                            x: {
                              from: 0,
                            },
                            y: {
                              from: 0,
                            },
                          },
                        },

                        hide: {
                          animations: {
                            x: {
                              to: 0,
                            },
                            y: {
                              to: 0,
                            },
                          },
                        },
                      };
                    }

                    // const data = {
                    //     // x-axis
                    //     labels: xAxis,
                    //     datasets: [
                    //         {
                    //             label: props.Abscissa,
                    //             // backgroundColor: ['red', 'green', 'blue'],
                    //             backgroundColor: !props.Bar_Colors ? ['red', 'green', 'blue'] : props.Bar_Colors.split(','),
                    //             borderColor: "rgb(255, 99, 132)",
                    //             // y-axis
                    //             data: yAxis,
                    //             // color: ['red', 'green', 'blue'],
                    //         },
                    //     ],
                    // };

                    const data = {
                      labels: xAxis,

                      // datasets: an array of objects [ { }, { }, ]
                      datasets: [
                        // if BarGraphOrdinate === 'true' in traits, then plot bar graph, else pass an empty array
                        props.MixInBarChartType
                          ? {
                              label: !props.BarLabel
                                ? "Bar Dataset"
                                : props.BarLabel,
                              data: yAxisBar,
                              backgroundColor: !props.Bar_Colors
                                ? ["red", "green", "blue"]
                                : props.Bar_Colors.split(","),
                              borderColor: !props.Bar_Border_Color
                                ? "rgb(255, 99, 132)"
                                : props.Bar_Border_Color,
                              borderWidth: !props.Bar_Border_Width
                                ? 2
                                : props.Bar_Border_Width,
                              // this dataset is drawn below
                              order: !props.BarOrder ? 2 : props.BarOrder,
                            }
                          : {},

                        props.MixInLineChartType
                          ? {
                              label: !props.LineLabel
                                ? "Line Dataset"
                                : props.LineLabel,
                              data: yAxisLine,
                              type: "line",
                              backgroundColor: !props.Line_Colors
                                ? ["cyan", "magenta", "yellow"]
                                : props.Line_Colors.split(","),
                              borderColor: !props.Line_Border_Color
                                ? "rgb(255, 99, 132)"
                                : props.Line_Border_Color,
                              borderWidth: !props.Line_Border_Width
                                ? 2
                                : props.Line_Border_Width,
                              // this dataset is drawn on top
                              order: !props.LineOrder ? 1 : props.LineOrder,
                            }
                          : {},

                        props.MixInBubbleChartType
                          ? {
                              label: !props.BubbleLabel
                                ? "Bubble Dataset"
                                : props.BubbleLabel,
                              data: yAxisBubble,
                              type: "bubble",
                              backgroundColor: !props.Bubble_Colors
                                ? ["black", "gray", "purple"]
                                : props.Bubble_Colors.split(","),
                              borderColor: !props.Bubble_Border_Color
                                ? "rgb(255, 99, 132)"
                                : props.Bubble_Border_Color,
                              borderWidth: !props.Bubble_Border_Width
                                ? 2
                                : props.Bubble_Border_Width,
                              // this dataset is drawn on top
                              order: !props.BubbleOrder ? 1 : props.BubbleOrder,
                            }
                          : {},
                      ],
                    };

                    const config = {
                      type: "bar",
                      data: data,
                      options: {
                        animation: animate,
                        transitions: transition,
                      },
                    };

                    const ctx = document
                      .getElementById("lineBarBubbleMixChart")
                      .getContext("2d");
                    const myChart = new Chart(ctx, config);
                  } catch (e) {
                    console.log(e);
                  }
                }
              };

              if (typeof Chart == "undefined") {
                const script = document.createElement("script");
                script.onload = initLib;
                script.src = "https://cdn.jsdelivr.net/npm/chart.js";
                document.body.appendChild(script);
              } else {
                console.log("InitLib");
                initLib();
              }
            },

            Graph_API: "",

            MixInLineChartType: "",
            MixInBarChartType: "",
            MixInBubbleChartType: "",

            Animation: "",

            BarLabel: "",
            LineLabel: "",
            BubbleLabel: "",

            Abscissa: "",
            LineGraphOrdinate: "",
            BarGraphOrdinate: "",
            BubbleGraphOrdinate: "",

            Bar_Colors: "",
            Line_Colors: "",
            Bubble_Colors: "",

            Bar_Border_Color: "",
            Line_Border_Color: "",
            Bubble_Border_Color: "",

            Bar_Border_Width: "",
            Line_Border_Width: "",
            Bubble_Border_Width: "",

            BarOrder: "",
            LineOrder: "",
            BubbleOrder: "",

            traits: [
              {
                type: "text",
                name: "Graph_API",
                label: "Graph API",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "MixInLineChartType",
                label: "Mix In Line Chart",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "MixInBarChartType",
                label: "Mix In Bar Chart",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "MixInBubbleChartType",
                label: "Mix In Bubble Chart",
                changeProp: true,
              },
              {
                type: "select",
                name: "Animation",
                label: "Pre-defined Graph Animations",
                options: [
                  { id: "delay", name: "Delay" },
                  { id: "hideAndShow", name: "Hide And Show" },
                ],
                changeProp: true,
              },
              {
                type: "text",
                name: "BarLabel",
                label: "Bar Label",
                changeProp: true,
              },
              {
                type: "text",
                name: "LineLabel",
                label: "Line Label",
                changeProp: true,
              },
              {
                type: "text",
                name: "BubbleLabel",
                label: "Bubble Label",
                changeProp: true,
              },
              {
                type: "text",
                name: "Abscissa",
                label: "Abscissa",
                changeProp: true,
              },
              {
                type: "text",
                name: "LineGraphOrdinate",
                label: "Line Graph Ordinate",
                changeProp: true,
              },
              {
                type: "text",
                name: "BarGraphOrdinate",
                label: "Bar Graph Ordinate",
                changeProp: true,
              },
              {
                type: "text",
                name: "BubbleGraphOrdinate",
                label: "Bubble Graph Ordinate",
                changeProp: true,
              },
              {
                type: "text",
                name: "Bar_Colors",
                label: "Bar Colors",
                changeProp: true,
              },
              {
                type: "text",
                name: "Line_Colors",
                label: "Line Colors",
                changeProp: true,
              },
              {
                type: "text",
                name: "Bubble_Colors",
                label: "Bubble Colors",
                changeProp: true,
              },
              {
                type: "range",
                min: "0",
                max: "20",
                name: "Bar_Border_Width",
                label: "Bar Border Width [0px to 20px]",
                changeProp: true,
              },
              {
                type: "range",
                min: "0",
                max: "20",
                name: "Line_Border_Width",
                label: "Line Border Width [0px to 20px]",
                changeProp: true,
              },
              {
                type: "range",
                min: "0",
                max: "20",
                name: "Bubble_Border_Width",
                label: "Bubble Border Width [0px to 20px]",
                changeProp: true,
              },
              {
                type: "text",
                name: "Bar_Border_Color",
                label: "Bar Border Colors",
                changeProp: true,
              },
              {
                type: "text",
                name: "Line_Border_Color",
                label: "Line Border Colors",
                changeProp: true,
              },
              {
                type: "text",
                name: "Bubble_Border_Color",
                label: "Bubble Border Colors",
                changeProp: true,
              },
              {
                type: "number",
                name: "LineOrder",
                label: "Line Chart Order",
                changeProp: true,
              },
              {
                type: "number",
                name: "BarOrder",
                label: "Bar Chart Order",
                changeProp: true,
              },
              {
                type: "number",
                name: "BubbleOrder",
                label: "Bubble Chart Order",
                changeProp: true,
              },
            ],

            changeProp: true,

            "script-props": [
              "Graph_API",
              "MixInLineChartType",
              "MixInBarChartType",
              "MixInBubbleChartType",
              "BarLabel",
              "LineLabel",
              "BubbleLabel",
              "Animation",
              "Abscissa",
              "LineGraphOrdinate",
              "BarGraphOrdinate",
              "BubbleGraphOrdinate",
              "Bar_Colors",
              "Line_Colors",
              "Bubble_Colors",
              "LineOrder",
              "BarOrder",
              "BubbleOrder",
              "Bar_Border_Width",
              "Line_Border_Width",
              "Bubble_Border_Width",
              "Bar_Border_Color",
              "Line_Border_Color",
              "Bubble_Border_Color",
            ],
          },
        },
        isComponent: (el) => {
          if (
            el.getAttribute &&
            el.getAttribute("data-gjs-type") == "lineBarBubbleMixChart"
          ) {
            return "lineBarBubbleMixChart";
          }
        },
        view: defaultView.extend({
          init({ model }) {},
        }),
      });

      editor.Components.addType("radio-regular-form", {
        model: {
          defaults: {
            tagName: "div",
            attributes: { id: "radio-regular" },

            styles: `
                            #radio-regular {
                                display: flex;
                                 column-gap: 0.5em;
                            }
                        `,

            components: [
              {
                type: "text",
                content: `<div>
                    <input contenteditable="true" type="radio" id="option" name="option" value="option1" style="margin-right: 0.1em;">
                    <label contenteditable="true" for="option">option1</label>
                    <input contenteditable="true" type="radio" id="option" name="option" value="option2" style="margin-right: 0.1em;">
                    <label contenteditable="true" for="option">option2</label>
                </div>`,
              },
            ],

            // traits
            TempVar: "",

            traits: [
              {
                type: "select",
                name: "TempVar",
                label: "TempVar",
                changeProp: true,
                options:
                  tempVarList && tempVarList.current !== null
                    ? [
                        ...tempVarList.current.map((x) => ({
                          value: x._id,
                          name: x.name,
                        })),
                        { value: "none", name: "None" },
                      ]
                    : "",
              },
            ],

            "script-props": ["TempVar"],
          },
        },

        view: {
          events: {
            click: function (event) {
              var selectedFunction = this.model.get("TempVar");
              console.log("selectedFunction", selectedFunction);
            },
          },
        },
      });

      editor.Components.addType("smiley-ratings-slider", {
        model: {
          defaults: {
            tagName: "div",
            //attributes: { id: "radio-regular" },

            styles: `
                  #rating-container {
                    width: 100%;
                    //margin: 20px auto;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }
        
                #rating-slider-container {
                    width: 100%;
                    position: relative;
                }
        
                #rating-slider {
                    width: 100%;
                }
        
                #smiley {
                    font-size: 24px;
                    position: absolute;
                    top: -30px;
                    left: 0;
                    transform: translateX(-50%);
                }
        
                #rating-scale {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    font-size: 18px;
                    flex-direction: row;
                }
                        `,
            script: ratingSliderScript,
            // components: [
            //   {
            //     type: "text",
            //     content: `
            //     <div id="rating-container">
            //     <div id="rating-slider-container">
            //         <div id="smiley">😄</div>
            //         <input type="range" id="rating-slider" name="rating" min="1" max="10" value="5" contenteditable="true">
            //     </div>
            //     <div id="rating-scale">
            //         <span>1</span>
            //         <span>2</span>
            //         <span>3</span>
            //         <span>4</span>
            //         <span>5</span>
            //         <span>6</span>
            //         <span>7</span>
            //         <span>8</span>
            //         <span>9</span>
            //         <span>10</span>
            //     </div>
            //     <input type="hidden" id="hidden-rating" name="hidden-rating" value="5">
            //     </div>`,
            //   },
            // ],
            attributes: { class: "rating-container" },
            components: [
              {
                type: "text",
                content: "😄",
                tagName: "div",
                attributes: { id: "smiley" },
              },
              {
                type: "input",
                tagName: "input",
                attributes: {
                  type: "range",
                  id: "rating-slider",
                  name: "rating",
                  min: "1",
                  max: "10",
                  value: "5",
                  contenteditable: "true",
                  style: "width: -webkit-fill-available",
                },
              },
              {
                type: "text",
                tagName: "div",
                attributes: { id: "rating-scale" },
                style: {
                  width: "-webkit-fill-available",
                  display: "flex",
                  "justify-content": "space-between",
                  "font-size": "18px",
                  "flex-direction": "row",
                },
                components: [
                  { content: "1" },
                  { content: "2" },
                  { content: "3" },
                  { content: "4" },
                  { content: "5" },
                  { content: "6" },
                  { content: "7" },
                  { content: "8" },
                  { content: "9" },
                  { content: "10" },
                ],
              },
              {
                type: "input",
                tagName: "input",
                attributes: {
                  type: "hidden",
                  id: "hidden-rating",
                  name: "hidden-rating",
                  value: "5",
                },
              },
            ],

            // traits
            TempVar: "",

            traits: [
              "name",
              "id",
              {
                type: "select",
                name: "TempVar",
                label: "TempVar",
                changeProp: true,
                options:
                  tempVarList && tempVarList.current !== null
                    ? [
                        ...tempVarList.current.map((x) => ({
                          value: x._id,
                          name: x.name,
                        })),
                        { value: "none", name: "None" },
                      ]
                    : "",
              },
            ],
          },
        },

        view: {
          events: {
            click: function (event) {
              var selectedFunction = this.model.get("TempVar");
              console.log("selectedFunction", selectedFunction);
            },
          },
        },
      });

      editor.Components.addType("colorPalette-regular-form", {
        model: {
          defaults: {
            tagName: "span",
            attributes: {
              id: "colorPalette-regular-form",
              class: "colorPalette-regular-form",
            },
            content:
              '<input type="color" id="color" name="color" value="ff0000" placeholder="Type your name, here" contenteditable="true">',

            // traits
            TempVar: "",

            traits: [
              "name",
              "placeholder",
              "id",
              "value",
              {
                type: "select",
                name: "TempVar",
                label: "TempVar",
                changeProp: true,
                options:
                  tempVarList && tempVarList.current !== null
                    ? [
                        ...tempVarList.current.map((x) => ({
                          value: x._id,
                          name: x.name,
                        })),
                        { value: "none", name: "None" },
                      ]
                    : "",
              },
            ],

            changeProp: true,

            "script-props": ["TempVar"],
          },
        },

        view: {
          events: {
            click: function (event) {
              var selectedFunction = this.model.get("TempVar");
              console.log("selectedFunction", selectedFunction);
            },
          },
        },
      });

      editor.Components.addType("week-regular-form", {
        model: {
          defaults: {
            tagName: "span",
            attributes: {
              id: "week-regular-form",
              class: "week-regular-form",
            },
            content:
              '<input type="week" id="week" name="week" contenteditable="true">',

            // traits
            TempVar: "",

            traits: [
              "name",
              "placeholder",
              "id",
              {
                type: "select",
                name: "TempVar",
                label: "TempVar",
                changeProp: true,
                options:
                  tempVarList && tempVarList.current !== null
                    ? [
                        ...tempVarList.current.map((x) => ({
                          value: x._id,
                          name: x.name,
                        })),
                        { value: "none", name: "None" },
                      ]
                    : "",
              },
            ],

            changeProp: true,

            "script-props": ["TempVar"],
          },
        },

        view: {
          events: {
            click: function (event) {
              var selectedFunction = this.model.get("TempVar");
              console.log("selectedFunction", selectedFunction);
            },
          },
        },
      });

      editor.Components.addType("monthYear-regular-form", {
        model: {
          defaults: {
            tagName: "span",
            attributes: {
              id: "monthYear-regular-form",
              class: "monthYear-regular-form",
            },
            content:
              '<input type="month" id="month" name="month" contenteditable="true">',

            // traits
            TempVar: "",

            traits: [
              "name",
              "placeholder",
              "id",
              {
                type: "select",
                name: "TempVar",
                label: "TempVar",
                changeProp: true,
                options:
                  tempVarList && tempVarList.current !== null
                    ? [
                        ...tempVarList.current.map((x) => ({
                          value: x._id,
                          name: x.name,
                        })),
                        { value: "none", name: "None" },
                      ]
                    : "",
              },
            ],

            changeProp: true,

            "script-props": ["TempVar"],
          },
        },

        view: {
          events: {
            click: function (event) {
              var selectedFunction = this.model.get("TempVar");
              console.log("selectedFunction", selectedFunction);
            },
          },
        },
      });

      editor.Components.addType("time-regular-form", {
        model: {
          defaults: {
            tagName: "span",
            attributes: {
              id: "time-regular-form",
              class: "time-regular-form",
            },
            content:
              '<input type="time" id="time" name="time" contenteditable="true">',

            // traits
            TempVar: "",

            traits: [
              "name",
              "placeholder",
              "id",
              {
                type: "select",
                name: "TempVar",
                label: "TempVar",
                changeProp: true,
                options:
                  tempVarList && tempVarList.current !== null
                    ? [
                        ...tempVarList.current.map((x) => ({
                          value: x._id,
                          name: x.name,
                        })),
                        { value: "none", name: "None" },
                      ]
                    : "",
              },
            ],

            changeProp: true,

            "script-props": ["TempVar"],
          },
        },

        view: {
          events: {
            click: function (event) {
              var selectedFunction = this.model.get("TempVar");
              console.log("selectedFunction", selectedFunction);
            },
          },
        },
      });

      editor.Components.addType("file-regular-form", {
        model: {
          defaults: {
            tagName: "span",
            attributes: {
              id: "file-regular-form",
              class: "file-regular-form",
            },
            content:
              '<input type="file" id="file" name="file" contenteditable="true">',

            // traits
            TempVar: "",

            traits: [
              "name",
              "placeholder",
              "id",
              "accept",
              "capture",
              {
                type: "checkbox",
                name: "multiple",
                label: "Multiple",
                changeProp: true,
              },
              {
                type: "select",
                name: "TempVar",
                label: "TempVar",
                changeProp: true,
                options:
                  tempVarList && tempVarList.current !== null
                    ? [
                        ...tempVarList.current.map((x) => ({
                          value: x._id,
                          name: x.name,
                        })),
                        { value: "none", name: "None" },
                      ]
                    : "",
              },
            ],

            changeProp: true,

            "script-props": ["TempVar"],
          },
        },

        view: {
          events: {
            click: function (event) {
              var selectedFunction = this.model.get("TempVar");
              console.log("selectedFunction", selectedFunction);
            },
          },
        },
      });

      editor.Components.addType("number-regular-form", {
        model: {
          defaults: {
            tagName: "span",
            attributes: {
              id: "number-regular-form",
              class: "number-regular-form",
            },
            content:
              '<input type="number" id="number" name="number" placeholder="Type your name, here" contenteditable="true">',

            // traits
            TempVar: "",

            traits: [
              "name",
              "placeholder",
              "id",
              "min",
              "max",
              {
                type: "select",
                name: "TempVar",
                label: "TempVar",
                changeProp: true,
                options:
                  tempVarList && tempVarList.current !== null
                    ? [
                        ...tempVarList.current.map((x) => ({
                          value: x._id,
                          name: x.name,
                        })),
                        { value: "none", name: "None" },
                      ]
                    : "",
              },
            ],

            changeProp: true,

            "script-props": ["TempVar"],
          },
        },

        view: {
          onRender({ el, model }) {
            if (el.id === "number") {
              console.log("el before:", el);
              console.log(
                "changing the name trait of the element to:",
                this.model.get("name")
              );

              el.setAttribute("name", `${this.model.get("name")}`);

              console.log("el after:", el);
            }
          },
          events: {
            click: function (event) {
              event.preventDefault();
              var selectedFunction = this.model.get("TempVar");
              console.log("selectedFunction", selectedFunction);
            },
          },
        },
      });

      editor.Components.addType("range-regular-form-old", {
        model: {
          defaults: {
            tagName: "span",
            attributes: {
              id: "range-regular-form",
              class: "range-regular-form",
            },
            content:
              '<input type="range" id="range" name="range" contenteditable="true">',

            // traits
            TempVar: "",

            traits: [
              "name",
              "placeholder",
              "id",
              "min",
              "max",
              {
                type: "select",
                name: "TempVar",
                label: "TempVar",
                changeProp: true,
                options:
                  tempVarList && tempVarList.current !== null
                    ? [
                        ...tempVarList.current.map((x) => ({
                          value: x._id,
                          name: x.name,
                        })),
                        { value: "none", name: "None" },
                      ]
                    : "",
              },
            ],

            changeProp: true,

            "script-props": ["TempVar"],
          },
        },

        view: {
          events: {
            click: function (event) {
              var selectedFunction = this.model.get("TempVar");
              console.log("selectedFunction", selectedFunction);
            },
          },
        },
      });

      const sliderScript = function (props) {
        console.log(props);

        if (props.min) {
          this.getElementsByClassName(
            "range-regular-form-slider"
          )[0].setAttribute("min", `${props.min}`);
        }
        if (props.max) {
          this.getElementsByClassName(
            "range-regular-form-slider"
          )[0].setAttribute("max", `${props.max}`);
        }

        let slider = this.getElementsByClassName(
          "range-regular-form-slider"
        )[0];
        let sliderTooltip = this.getElementsByClassName(
          "range-regular-form-slider-tooltip"
        )[0];

        // make the tooptip appear on hovering on the slider
        slider.addEventListener("mouseover", function (event) {
          sliderTooltip.style.visibility = "visible";
          sliderTooltip.style.opacity = "1";
        });
        // make the tooptip disappear on stopping hovering on the slider
        slider.addEventListener("mouseout", function (event) {
          sliderTooltip.style.visibility = "hidden";
          sliderTooltip.style.opacity = "0";
        });

        slider.addEventListener("change", function (event) {
          sliderTooltip.innerHTML = this.value;

          // const toolTipLeft = ((this.value / 100) * 10) + 50;
          const toolTipLeft = (this.value / props.max) * 100;
          console.log("toolTipLeft", toolTipLeft);
          sliderTooltip.style.left = `${toolTipLeft}%`;
        });

        // // to keep the tooltip visible
        // if (props.show) {
        //   sliderTooltip.style.visibility = 'visible';
        //   sliderTooltip.style.opacity = '1';
        // }
        // // to hide the tooltip
        // if (!props.show) {
        //   sliderTooltip.style.visibility = 'hidden';
        //   sliderTooltip.style.opacity = '0';
        // }
      };

      editor.Components.addType("range-regular-form", {
        model: {
          defaults: {
            tagName: "span",
            type: "range-regular-form",
            script: sliderScript,
            attributes: {
              // id: "range-regular-form",
              class: "range-regular-form",
            },

            "style-default": {
              position: "relative",
              width: "40vw",
            },
            style: {
              position: "relative",
              width: "40vw",
            },

            components: [
              {
                tagName: "input",
                type: "default",
                attributes: {
                  type: "range",
                  value: "1",
                  // id: "range-regular-form-slider",
                  class: "range-regular-form-slider",
                  name: "range-regular-form-slider",
                },
              },
              {
                tagName: "span",
                type: "range-regular-form-slider-tooltip",
                attributes: {
                  class: "range-regular-form-slider-tooltip",
                },
                content: "1",

                "style-default": {
                  visibility: "hidden",
                  width: "max-content",
                  "background-color": "transparent",
                  color: "black",
                  "text-align": "center",
                  "border-radius": "6px",
                  border: "1px solid gray",
                  padding: "0.3em",
                  "z-index": "1",
                  position: "absolute",
                  bottom: "105%",
                  left: "5px",
                  "margin-left": "-20px",
                  opacity: "0",
                  transition: "all 0.3s",
                },

                style: {
                  visibility: "hidden",
                  width: "max-content",
                  "background-color": "transparent",
                  color: "black",
                  "text-align": "center",
                  "border-radius": "6px",
                  border: "1px solid gray",
                  padding: "0.3em",
                  "z-index": "1",
                  position: "absolute",
                  bottom: "105%",
                  left: "5px",
                  "margin-left": "-20px",
                  opacity: "0",
                  transition: "all 0.3s",
                },
              },
            ],

            // traits
            min: "0",
            max: "100",
            // show: false,

            traits: [
              "name",
              // "id",
              {
                type: "number",
                name: "min",
                label: "Minimum value",
                placeholder: "0",
                changeProp: true,
              },
              {
                type: "number",
                name: "max",
                label: "Maximum value",
                placeholder: "100",
                changeProp: true,
              },
              // {
              //   type: 'checkbox',
              //   name: "show",
              //   label: 'Show',
              //   changeProp: true,
              // },
            ],

            "script-props": ["min", "max"],
            changeProp: true,
          },
        },
      });

      editor.Components.addType("reset-regular-form", {
        model: {
          defaults: {
            tagName: "span",
            attributes: {
              id: "reset-regular-form",
              class: "reset-regular-form",
            },
            content:
              '<input type="reset" id="reset" name="reset"contenteditable="true">',

            // traits
            TempVar: "",

            traits: [
              "name",
              "placeholder",
              "id",
              {
                type: "select",
                name: "TempVar",
                label: "TempVar",
                changeProp: true,
                options:
                  tempVarList && tempVarList.current !== null
                    ? [
                        ...tempVarList.current.map((x) => ({
                          value: x._id,
                          name: x.name,
                        })),
                        { value: "none", name: "None" },
                      ]
                    : "",
              },
            ],

            changeProp: true,

            "script-props": ["TempVar"],
          },
        },

        view: {
          events: {
            click: function (event) {
              var selectedFunction = this.model.get("TempVar");
              console.log("selectedFunction", selectedFunction);
            },
          },
        },
      });

      editor.Components.addType("submit-regular-form", {
        model: {
          defaults: {
            tagName: "span",
            attributes: {
              id: "submit-regular-form",
              class: "submit-regular-form",
            },
            content:
              '<input type="submit" id="submit" name="submit" contenteditable="true">',

            // traits
            TempVar: "",

            traits: [
              "name",
              "placeholder",
              "id",
              {
                type: "select",
                name: "TempVar",
                label: "TempVar",
                changeProp: true,
                options:
                  tempVarList && tempVarList.current !== null
                    ? [
                        ...tempVarList.current.map((x) => ({
                          value: x._id,
                          name: x.name,
                        })),
                        { value: "none", name: "None" },
                      ]
                    : "",
              },
            ],

            changeProp: true,

            "script-props": ["TempVar"],
          },
        },

        // view: {
        //     events: {
        //         click: function (event) {
        //             var selectedFunction = this.model.get('TempVar');
        //             console.log("selectedFunction", selectedFunction);

        //         }
        //     },
        // },
      });

      // feature - if a user gives it an id or class with a hyphen it will automatically change them to underscrores
      editor.Components.addType("normal_text_area_regular_form", {
        model: {
          defaults: {
            tagName: "div",
            // type: "normal_text_area_regular_form",
            attributes: {
              name: "normal_text_area_regular_form",
              class: "normal_text_area_regular_form",
            },

            components: [
              {
                tagName: "textarea",
                type: "default",
                attributes: {
                  name: "normal_text_area",
                  class: "normal_text_area",
                  rows: 5,
                  cols: 50,
                  placeholder: "Form text area",
                },

                traits: ["id"],
              },
            ],

            // traits
            Autofocus: false,
            Cols: 50,
            Disabled: false,
            FormId: "",
            MaxLength: "",
            Name: "",
            Placeholder: "",
            ReadOnly: "",
            Required: false,
            Rows: 5,
            Wrap: "",

            traits: [
              {
                type: "checkbox",
                name: "Autofocus",
                label: "Autofocus",
                changeProp: true,
              },
              {
                type: "number",
                name: "Cols",
                label: "Cols",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "Disabled",
                label: "Disabled",
                changeProp: true,
              },
              {
                type: "text",
                name: "FormId",
                label: "FormId",
                placeholder: "ID of the form this belongs to",
                changeProp: true,
              },
              {
                type: "number",
                name: "MaxLength",
                label: "MaxLength",
                placeholder:
                  "maximum number of characters allowed in the text area",
                changeProp: true,
              },
              {
                type: "text",
                name: "Name",
                label: "Name",
                changeProp: true,
              },
              {
                type: "text",
                name: "Placeholder",
                label: "Placeholder",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "ReadOnly",
                label: "ReadOnly",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "Required",
                label: "Required",
                changeProp: true,
              },
              {
                type: "number",
                name: "Rows",
                label: "Rows",
                changeProp: true,
              },
              {
                type: "select",
                name: "Wrap",
                label: "Wrap",
                options: [
                  { id: "soft", name: "Soft" },
                  { id: "hard", name: "Hard" },
                ],
                changeProp: true,
              },
              "id",
            ],

            changeProp: true,
            "script-props": [
              "Autofocus",
              "Cols",
              "Disabled",
              "FormId",
              "MaxLength",
              "Name",
              "Placeholder",
              "ReadOnly",
              "Required",
              "Rows",
              "Wrap",
            ],
          },

          init() {
            this.on("change:Autofocus", this.handleTextAreaPropChange);
            this.on("change:Cols", this.handleTextAreaPropChange);
            this.on("change:Disabled", this.handleTextAreaPropChange);
            this.on("change:FormId", this.handleTextAreaPropChange);
            this.on("change:MaxLength", this.handleTextAreaPropChange);
            this.on("change:Name", this.handleTextAreaPropChange);
            this.on("change:Placeholder", this.handleTextAreaPropChange);
            this.on("change:ReadOnly", this.handleTextAreaPropChange);
            this.on("change:Required", this.handleTextAreaPropChange);
            this.on("change:Rows", this.handleTextAreaPropChange);
            this.on("change:Wrap", this.handleTextAreaPropChange);
          },

          handleTextAreaPropChange() {
            let {
              Autofocus,
              Cols,
              Row,
              Disabled,
              FormId,
              MaxLength,
              Name,
              Placeholder,
              ReadOnly,
              Required,
              Rows,
              Wrap,
            } = this.props();

            const container = this;
            console.log("container", container);

            const textArea = container.find("textarea.normal_text_area")[0];
            console.log("textArea", textArea);

            if (Autofocus) {
              if (textArea) {
                textArea.addAttributes({ autofocus: "autofocus" });
              }
            } else {
              if (textArea) {
                textArea.removeAttributes("autofocus");
              }
            }

            if (Cols) {
              if (textArea) {
                textArea.addAttributes({ cols: Cols });
              }
            } else {
              if (textArea) {
                textArea.removeAttributes("cols");
              }
            }

            if (Disabled) {
              if (textArea) {
                textArea.addAttributes({ disabled: "disabled" });
              }
            } else {
              if (textArea) {
                textArea.removeAttributes("disabled");
              }
            }

            if (FormId) {
              if (textArea) {
                textArea.addAttributes({ form: FormId });
              }
            } else {
              if (textArea) {
                textArea.removeAttributes("form");
              }
            }

            if (MaxLength) {
              if (textArea) {
                textArea.addAttributes({ maxlength: MaxLength });
              }
            } else {
              if (textArea) {
                textArea.removeAttributes("maxlength");
              }
            }

            if (Name) {
              if (textArea) {
                textArea.addAttributes({ name: Name });
              }
            } else {
              if (textArea) {
                textArea.removeAttributes("name");
              }
            }

            if (Placeholder) {
              if (textArea) {
                textArea.addAttributes({ placeholder: Placeholder });
              }
            } else {
              if (textArea) {
                textArea.removeAttributes("placeholder");
              }
            }

            if (ReadOnly) {
              if (textArea) {
                textArea.addAttributes({ readonly: "readonly" });
              }
            } else {
              if (textArea) {
                textArea.removeAttributes("readonly");
              }
            }

            if (Required) {
              if (textArea) {
                textArea.addAttributes({ required: "required" });
              }
            } else {
              if (textArea) {
                textArea.removeAttributes("required");
              }
            }

            if (Rows) {
              if (textArea) {
                textArea.addAttributes({ rows: Rows });
              }
            } else {
              if (textArea) {
                textArea.removeAttributes("rows");
              }
            }

            if (Wrap) {
              if (textArea) {
                textArea.addAttributes({ wrap: Wrap });
              }
            } else {
              if (textArea) {
                textArea.removeAttributes("wrap");
              }
            }
          },

          updated(property, value, prevValue) {
            console.log(
              "+++ property",
              property,
              "value",
              value,
              "prevValue",
              prevValue
            );
            console.log("this from updated()", this.getEl());

            const container = this;
            console.log("container", container);

            const textArea = container.find("textarea.normal_text_area")[0];
            console.log("textArea", textArea);

            // if the container ID includes '-', replace it with '_'
            if (
              "id" in container.getAttributes() &&
              container.getAttributes()["id"].includes("-")
            ) {
              let containerId = container
                .getAttributes()
                ["id"].replace(/-/g, "_");
              container.setAttributes({ id: containerId });
            }

            if (
              "id" in textArea.getAttributes() &&
              textArea.getAttributes()["id"].includes("-")
            ) {
              let textAreaId = textArea
                .getAttributes()
                ["id"].replace(/-/g, "_");
              textArea.setAttributes({ id: textAreaId });
            }

            console.log("container, textArea", container, textArea);
          },
        },
      });

      editor.DomComponents.addType("basicButton", {
        model: {
          defaults: {
            tagName: "basicButton",
            // script,
            // Define default values for your custom properties
            // Define traits, in order to change your properties
            Page: "",
            PassToNextPage: "",
            traits: [
              {
                type: "select",
                name: "Page",
                changeProp: true,
                options: pageByProjectData
                  ? pageByProjectData?.map((x) => {
                      const arr = {
                        value: x._id,
                        name: x.name,
                      };
                      return arr;
                    })
                  : "",
              },
              {
                type: "select",
                name: "PassToNextPage",
                label: "Pass Over Next Page",
                changeProp: true,
                options: [
                  { id: "true", value: true },
                  { id: "false", value: false },
                ],
              },
            ],
            "script-props": ["Page", "PassToNextPage"],
            // Add some style, just to make the component visible
            style: {
              width: "100px",
              height: "30px",
              display: "flex",
              "justify-content": "center",
              "align-items": "center",
            },
            // content: {
            components: `
                                        <button onclick='pageRedirect'>
                                            <p style="margin: auto;">Submit</p>
                                        </button>
                                    `,
            // }
          },
        },
        view: {
          events: {
            click: function (event) {
              var link = this.model.get("Page");
              var willDataPass = this.model.get("PassToNextPage");
              console.log("willDataPass", willDataPass);

              const project_id = window.location.search.split("=")[1];

              let dataOnLocalCheck = JSON.parse(
                localStorage.getItem("dynoApi")
              );
              console.log("dataOnLocalCheck", dataOnLocalCheck);
              let valueCheck = false;

              // check if the local storage data contains empty values:
              if (link && willDataPass === true) {
                window.location.href =
                  origin +
                  `/editor/` +
                  `${link}` +
                  "?projectId=" +
                  `${project_id}`;
                // if (dataOnLocalCheck) {
                //     console.log('dataOnLocalCheck')
                //     if (Object?.keys(dataOnLocalCheck)?.length === 0) {
                //         localStorage.removeItem('dynoApi');
                //     } else {
                //         for (let key in dataOnLocalCheck) {
                //             if (dataOnLocalCheck.hasOwnProperty(key) && !dataOnLocalCheck[key]) {
                //                 localStorage.removeItem('dynoApi');
                //             }
                //         }
                //     }

                //     const components = editor.DomComponents.getComponents();
                //     console.log(components.get('components'));
                //     console.log('components', components)
                //     var editor = grapesjs.Editor;

                //     // Get the canvas element
                //     // var canvas = editor.Canvas.getCanvas();

                //     // console.log('canvas', canvas)
                //     // console.log('editor', editor)

                //     // Filter the components that have an input tag
                //     // components.filter(component => {
                //     //     console.log('component', components.component)
                //     //     console.log('component.attributes', component.attributes)
                //     //     console.log('component.attributes.type', component.attributes.type);

                //     //     if (component.attributes.attributes.type === 'div') {
                //     //         component.filter((sub_comp) => {
                //     //             if (sub_comp.attributes.attributes.id === 'email-regular-form') {
                //     //                 const emailDiv = editor.DomComponents.getWrapper().find('#email');
                //     //                 if (emailDiv) {
                //     //                     dataOnLocalCheck[`${emailDiv[0].view.el.name}`] = emailDiv[0].view.el.value;
                //     //                 }

                //     //             }

                //     //             // password input
                //     //             if (sub_comp.attributes.attributes.id === 'pwd-regular-form') {
                //     //                 const passDiv = editor.DomComponents.getWrapper().find('#password');
                //     //                 if (passDiv) {
                //     //                     dataOnLocalCheck[`${passDiv[0].view.el.name}`] = passDiv[0].view.el.value;
                //     //                 }

                //     //             }

                //     //             // number input
                //     //             if (sub_comp.attributes.attributes.id === 'tele-regular-form') {
                //     //                 const passDiv = editor.DomComponents.getWrapper().find('#phone');
                //     //                 if (passDiv) {
                //     //                     dataOnLocalCheck[`${passDiv[0].view.el.name}`] = passDiv[0].view.el.value;
                //     //                 }

                //     //             }

                //     //             // text input
                //     //             if (sub_comp.attributes.attributes.name === 'text') {
                //     //                 const el = sub_comp.view.el.childNodes[1];
                //     //                 dataOnLocalCheck[`${el.name}`] = el.value;
                //     //             }

                //     //             // checkbox input

                //     //             if (sub_comp.attributes.type === 'basicCheckBox') {
                //     //                 const elementValue = sub_comp.attributes.isChecked;
                //     //                 const elementKey = sub_comp.attributes.nameToCheck
                //     //                 if (elementValue && elementKey) {
                //     //                     dataOnLocalCheck[`${elementKey}`] = elementValue;
                //     //                 }
                //     //             }

                //     //             // calender Input

                //     //             if (sub_comp.attributes.type === 'basicDateTime') {
                //     //                 const elementKey = editor.DomComponents.getWrapper().find('#compLabel')[0].view.el.innerText;

                //     //                 const elementValue = editor.DomComponents.getWrapper().find('#compId')[0].view.el.textContent;

                //     //                 if (elementKey && elementValue) {
                //     //                     dataOnLocalCheck[`${elementKey}`] = elementValue;
                //     //                 }

                //     //             }

                //     //             // select dropdown Input
                //     //             if (sub_comp.attributes.type === 'input-select') {
                //     //                 const inputVal = sub_comp.view.el.childNodes[1].childNodes[1].value;
                //     //                 const inputKey = sub_comp.attributes.Name;

                //     //                 if (inputVal && inputKey) {
                //     //                     dataOnLocalCheck[`${inputKey}`] = inputVal;
                //     //                 }

                //     //             }

                //     //             // input type file
                //     //             if (sub_comp.attributes.attributes.id === 'upload-file') {

                //     //                 const elementKey = editor.DomComponents.getWrapper().find('#apiLabel')[0].view.el.innerHTML;
                //     //                 const elementKey1 = sub_comp.view.el.childNodes[0].childNodes[1].attributes[7].nodeValue;
                //     //                 if (elementKey && elementKey1) {
                //     //                     dataOnLocalCheck[`${elementKey}`] = elementKey1;
                //     //                 }

                //     //             }

                //     //             // number input:
                //     //             if (sub_comp.attributes.attributes.id === 'number-regular-form') {
                //     //                 const elementKey = sub_comp.view.el.childNodes[1].name;
                //     //                 const elementKey1 = sub_comp.view.el.childNodes[1].value;
                //     //                 if (elementKey && elementKey1) {
                //     //                     dataOnLocalCheck[`${elementKey}`] = elementKey1;
                //     //                 }
                //     //             }
                //     //         })
                //     //     }

                //     // });

                //     allComponents.map((component) => {
                //         // console.log(component)
                //         // console.log(component.collection.domc.componentsById);
                //         // if(component.attributes.attributes.id === "formId") {

                //         var allNestedComponents = getAllNestedComponents(components);

                //         console.log('component', component)
                //         // console.log('component.attributes.type', component.attributes.type)
                //         // console.log('#selection', editor.DomComponents.getWrapper().find('#selection'))

                //         // email input (done)
                //         if (component.attributes.attributes.type === 'email') {
                //             if (component.attributes.attributes.id && component.view.el.value) {
                //                 dataOnLocalCheck[`${component.attributes.attributes.id}`] = component.view.el.value
                //             }
                //         }

                //         // password input (done)
                //         if (component.attributes.attributes.id === 'password') {
                //             if (component.attributes.attributes.id && component.view.el.value) {
                //                 dataOnLocalCheck[`${component.attributes.attributes.id}`] = component.view.el.value
                //             }
                //         }

                //         // tele input (done)
                //         if (component.attributes.attributes.type === 'tel') {
                //             if (component.attributes.attributes.id && component.view.el.value) {
                //                 dataOnLocalCheck[`${component.attributes.attributes.id}`] = component.view.el.value
                //             }

                //         }

                //         // text input(done)
                //         if (component.attributes.attributes.id === 'text') {
                //             if (component.attributes.attributes.id && component.view.el.value) {
                //                 dataOnLocalCheck[`${component.attributes.attributes.id}`] = component.view.el.value
                //             }
                //         }

                //         // checkbox input(done)
                //         if (component.attributes.type === 'basicCheckBox') {
                //             const elementValue = component.attributes.isChecked;
                //             const elementKey = component.attributes.nameToCheck
                //             if (elementKey && elementValue) {
                //                 dataOnLocalCheck[`${elementKey}`] = elementValue;
                //             }

                //         }

                //         // calender Input(done)
                //         if (component.attributes.type === 'basicDateTime') {

                //             if (component.view.el.childNodes[0].innerText && component.view.el.childNodes[1].outerText) {
                //                 dataOnLocalCheck[`${component.view.el.childNodes[0].innerText}`] = component.view.el.childNodes[1].outerText;
                //             }

                //         }

                //         // select dropdown Input(done)
                //         if (component.attributes.type === 'input-select') {

                //             const inputVal = component.view.el.firstElementChild.value;

                //             if (inputVal && component.attributes.attributes.id) {
                //                 dataOnLocalCheck[`${component.attributes.attributes.id}`] = inputVal;
                //             }

                //         }

                //         // input type file (done)
                //         if (component.attributes.attributes.id === 'upload-file') {
                //             const elementKey = editor.DomComponents.getWrapper().find('#apiLabel')[0].view.el.innerHTML;
                //             const elementKey1 = component.view.el.childNodes[0].childNodes[1].attributes[7].nodeValue;
                //             if (elementKey && elementKey1) {
                //                 dataOnLocalCheck[`${elementKey}`] = elementKey1;
                //             }

                //         }

                //         // number input:(done)
                //         if (component.attributes.attributes.id === 'number') {
                //             if (component.attributes.attributes.id && component.view.el.value) {
                //                 dataOnLocalCheck[`${component.attributes.attributes.id}`] = component.view.el.value;
                //             }
                //         }
                //     });

                //     localStorage.removeItem('dynoApi')
                //     localStorage.setItem(`dynoApi`, JSON.stringify(dataOnLocalCheck))
                //     const origin = window.location.origin;
                //     window.location.href = origin + `/editor/` + `${link}` + '?projectId=' + `${project_id}`
                // } else {
                //     // console.log('!!!!dataOnLocalCheck')
                //     // const components = editor.DomComponents.getComponents();
                //     // let dataToBePassed = {}
                //     // // Filter the components that have an input tag
                //     // components.filter(component => {
                //     //     console.log('component', component)
                //     //     console.log('component.attributes.type', component.attributes.type)
                //     //     console.log('#selection', editor.DomComponents.getWrapper().find('#selection'))

                //     //     if (component.attributes.attributes.type === 'div') {
                //     //         component.filter((sub_comp) => {
                //     //             if (sub_comp.attributes.attributes.id === 'email-regular-form') {
                //     //                 const emailDiv = editor.DomComponents.getWrapper().find('#email');
                //     //                 if (emailDiv) {
                //     //                     dataToBePassed[`${emailDiv[0].view.el.name}`] = emailDiv[0].view.el.value;
                //     //                 }

                //     //             }

                //     //             // password input
                //     //             if (sub_comp.attributes.attributes.id === 'pwd-regular-form') {
                //     //                 const passDiv = editor.DomComponents.getWrapper().find('#password');
                //     //                 if (passDiv) {
                //     //                     dataToBePassed[`${passDiv[0].view.el.name}`] = passDiv[0].view.el.value;
                //     //                 }

                //     //             }

                //     //             // number input
                //     //             if (sub_comp.attributes.attributes.id === 'tele-regular-form') {
                //     //                 const passDiv = editor.DomComponents.getWrapper().find('#phone');
                //     //                 if (passDiv) {
                //     //                     dataToBePassed[`${passDiv[0].view.el.name}`] = passDiv[0].view.el.value;
                //     //                 }

                //     //             }

                //     //             // text input
                //     //             if (sub_comp.attributes.attributes.name === 'text') {
                //     //                 const el = sub_comp.view.el.childNodes[1];
                //     //                 dataToBePassed[`${el.name}`] = el.value;
                //     //             }

                //     //             // checkbox input

                //     //             if (sub_comp.attributes.type === 'basicCheckBox') {
                //     //                 const elementValue = sub_comp.attributes.isChecked;
                //     //                 const elementKey = sub_comp.attributes.nameToCheck
                //     //                 if (elementValue && elementKey) {
                //     //                     dataToBePassed[`${elementKey}`] = elementValue;
                //     //                 }
                //     //             }

                //     //             // calender Input

                //     //             if (sub_comp.attributes.type === 'basicDateTime') {
                //     //                 const elementKey = editor.DomComponents.getWrapper().find('#compLabel')[0].view.el.innerText;

                //     //                 const elementValue = editor.DomComponents.getWrapper().find('#compId')[0].view.el.textContent;

                //     //                 if (elementKey && elementValue) {
                //     //                     dataToBePassed[`${elementKey}`] = elementValue;
                //     //                 }

                //     //             }

                //     //             // select dropdown Input
                //     //             if (sub_comp.attributes.type === 'input-select') {
                //     //                 const inputVal = sub_comp.view.el.childNodes[1].childNodes[1].value;
                //     //                 const inputKey = sub_comp.attributes.Name;

                //     //                 if (inputVal && inputKey) {
                //     //                     dataToBePassed[`${inputKey}`] = inputVal;
                //     //                 }

                //     //             }

                //     //             // input type file
                //     //             if (sub_comp.attributes.attributes.id === 'upload-file') {

                //     //                 const elementKey = editor.DomComponents.getWrapper().find('#apiLabel')[0].view.el.innerHTML;
                //     //                 const elementKey1 = sub_comp.view.el.childNodes[0].childNodes[1].attributes[7].nodeValue;
                //     //                 if (elementKey && elementKey1) {
                //     //                     dataToBePassed[`${elementKey}`] = elementKey1;
                //     //                 }

                //     //             }

                //     //             // number input:
                //     //             if (sub_comp.attributes.attributes.id === 'number-regular-form') {
                //     //                 const elementKey = sub_comp.view.el.childNodes[1].name;
                //     //                 const elementKey1 = sub_comp.view.el.childNodes[1].value;
                //     //                 if (elementKey && elementKey1) {
                //     //                     dataToBePassed[`${elementKey}`] = elementKey1;
                //     //                 }
                //     //             }
                //     //         })
                //     //     }

                //     // });

                //     // console.log('dataToBePassed', dataToBePassed)

                //     // if (Object?.keys(dataToBePassed)?.length !== 0) {
                //     //     for (let key in dataToBePassed) {
                //     //         console.log('valueCheck11111', valueCheck)
                //     //         if (dataToBePassed.hasOwnProperty(key) && !dataToBePassed[key]) {
                //     //             valueCheck = true
                //     //         }
                //     //     }
                //     //     if (valueCheck === false) {
                //     //         localStorage.removeItem(`dynoApi`)
                //     //         localStorage.setItem(`dynoApi`, JSON.stringify(dataToBePassed));
                //     //         const origin = window.location.origin;
                //     //         window.location.href = origin + `/editor/` + `${link}` + '?projectId=' + `${project_id}`
                //     //     }
                //     // }

                //     console.log('!!!!dataOnLocalCheck')
                //     console.log('editor11111', editor)
                //     const components = editor.DomComponents.getComponents();
                //     console.log("ALLL components----- ", components)

                //     var allComponents = getAllComponents(editor);

                //     console.log("ALLL COOMPONENNNN----- ", allComponents)

                //     let dataToBePassed = {}
                //     // Filter the components that have an input tag
                //     allComponents.map((component) => {
                //         // console.log(component)
                //         // console.log(component.collection.domc.componentsById);
                //         // if(component.attributes.attributes.id === "formId") {
                //         var allNestedComponents = getAllNestedComponents(components);
                //         console.log("NESTEd components 2", allNestedComponents)

                //         console.log('component', component)
                //         // console.log('component.attributes.type', component.attributes.type)
                //         // console.log('#selection', editor.DomComponents.getWrapper().find('#selection'))

                //         // email input
                //         if (component.attributes.attributes.type === 'email') {
                //             console.log("IN EMAILLLLLL")
                //             console.log(component.view.el.value)

                //             dataToBePassed[`${component.attributes.attributes.id}`] = component.view.el.value

                //         }

                //         // password input
                //         if (component.attributes.attributes.type === 'password') {

                //             dataToBePassed[`${component.attributes.attributes.id}`] = component.view.el.value

                //         }

                //         // tele input
                //         if (component.attributes.attributes.type === 'tel') {

                //             dataToBePassed[`${component.attributes.attributes.id}`] = component.view.el.value

                //         }

                //         // text input
                //         if (component.attributes.attributes.name === 'text') {
                //             const el = component.view.el.childNodes[1];
                //             dataToBePassed[`${el.id}`] = el.value;
                //         }

                //         // checkbox input

                //         if (component.attributes.type === 'basicCheckBox') {
                //             const elementValue = component.attributes.isChecked;
                //             const elementKey = component.attributes.nameToCheck
                //             dataToBePassed[`${elementKey}`] = elementValue;
                //         }

                //         // calender Input

                //         if (component.attributes.type === 'basicDateTime') {
                //             const elementKey = editor.DomComponents.getWrapper().find('#compLabel')[0].view.el.innerText;

                //             const elementValue = editor.DomComponents.getWrapper().find('#compId')[0].view.el.textContent;

                //             if (elementKey && elementValue) {
                //                 dataToBePassed[`${elementKey}`] = elementValue;
                //             }

                //         }

                //         // select dropdown Input
                //         if (component.attributes.type === 'input-select') {
                //             const inputVal = component.view.el.childNodes[1].childNodes[1].value;
                //             const inputKey = component.attributes.Name;

                //             if (inputVal && inputKey) {
                //                 dataToBePassed[`${inputKey}`] = inputVal;
                //             }

                //         }

                //         // input type file
                //         if (component.attributes.attributes.id === 'upload-file') {

                //             const elementKey = editor.DomComponents.getWrapper().find('#apiLabel')[0].view.el.innerHTML;
                //             const elementKey1 = component.view.el.childNodes[0].childNodes[1].attributes[7].nodeValue;
                //             if (elementKey && elementKey1) {
                //                 dataToBePassed[`${elementKey}`] = elementKey1;
                //             }

                //         }

                //         // number input:
                //         if (component.attributes.attributes.id === 'number-regular-form') {
                //             const elementKey = component.view.el.childNodes[1].name;
                //             const elementKey1 = component.view.el.childNodes[1].value;
                //             if (elementKey && elementKey1) {
                //                 dataToBePassed[`${elementKey}`] = elementKey1;
                //             }
                //         }

                //         // }

                //     });

                //     console.log('dataToBePassed', dataToBePassed)

                //     if (Object?.keys(dataToBePassed)?.length !== 0) {
                //         for (let key in dataToBePassed) {
                //             console.log('valueCheck11111', valueCheck)
                //             if (dataToBePassed.hasOwnProperty(key) && !dataToBePassed[key]) {
                //                 valueCheck = true
                //             }
                //         }
                //         if (valueCheck === false) {
                //             localStorage.removeItem(`dynoApi`)
                //             localStorage.setItem(`dynoApi`, JSON.stringify(dataToBePassed));
                //             // const origin = window.location.origin;
                //             // window.location.href = origin + `/editor/` + `${link}` + '?projectId=' + `${project_id}`
                //         }
                //     }
                // }
              }
              // else if (link.length > 0 && willDataPass === false) {
              //     const origin = window.location.origin;
              //     window.location.href = origin + `/editor/` + `${link}` + '?projectId=' + `${project_id}`
              // }
            },
          },
        },
      });

      const dateTimeScript = function (props) {
        console.log("dateTimeiD", this.id);
        console.log("dateTime", this);
        const inp1 = document
          .querySelector(`#${this.id}`)
          .getElementsByTagName("ion-datetime");
        console.log("inp1", inp1);
        inp1[0].addEventListener("ionChange", (event) => {
          console.log("here");
          const selectedDate = event.detail.value;
          const newUtc = new Date(selectedDate);
          var date = new Date(newUtc),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
          const finalDate = [date.getFullYear(), mnth, day].join("-");
          console.log("finalDate", finalDate);
          const labelTag = document.querySelector(`#calenderInputId`);
          console.log("labelTag", labelTag);
          labelTag.innerText = `${finalDate}`;
          labelTag.value = `${finalDate}`;
        });
      };

      // date-time comp new
      editor.DomComponents.addType("basicDateTime", {
        model: {
          defaults: {
            script: dateTimeScript,
            tagName: "basicDateTime",
            date: "",
            traits: [
              {
                name: "date",
                type: "text",
                changeProp: true,
              },
            ],
            "script-props": ["date"],
            // Add some style, just to make the component visible
            components: `
                                <div id="${calenderId}" >
                                <p >
                                <label id="${calenderLabelId}">Date<label>
                                </p>
            
                                <p>
                                <ion-item id="${calenderItemId}">
                                <ion-input
                                  id="calenderInputId"
                                  name=""
                                ></ion-input>
                                <ion-popover trigger="${calenderInputId}" size="contain" >
                                    <ion-datetime id="${calenderDateId}"
                                    ></ion-datetime>
                                </ion-popover>
                                </ion-item>
                                </p>
            
                                </div>
            
                                <style>
            
                                </style>
            
                                `,
          },
        },
      });

      editor.DomComponents.addType("center-aligned-element-container", {
        model: {
          defaults: {
            tagName: "div",
            attributes: {
              id: "center-aligned-element-container",
              class: "center-aligned-element-container",
            },
            styles: `
                                    .center-aligned-element-container {
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        padding: 0.5em;
                                        width: 100%;
                                        min-height: 3em;
                                    }
                                `,
          },
        },
      });

      editor.DomComponents.addType("test-multiple", {
        model: {
          defaults: {
            items: ["Item 1", "Item 2", "Item 3"],
            traits: [
              {
                type: "checkbox",
                name: "items",
                changeProp: true,
                value: "Item1",
              },
              {
                type: "checkbox",
                name: "items",
                changeProp: true,
                value: "Item2",
              },
              {
                type: "checkbox",
                name: "items",
                changeProp: true,
                value: "Item3",
              },
            ],
          },
        },
        view: {
          render: function () {
            console.log("EHRJKWEHKJRHE");
            var items = this.model.get("items");
            console.log("ITEMS ---- ", items);
            var html = "<ul>";
            for (var i = 0; i < items.length; i++) {
              html += "<li>" + items[i] + "</li>";
            }
            html += "</ul>";
            this.$el.html(html);
            console.log("HTML _______ ", html);
            return this;
          },
        },
      });

      editor.DomComponents.addType("test-multiple-2", {
        model: {
          defaults: {
            count: 1,
            text: "Hello, world!",
            REST_API_URL: "",
            Response_Key_To_Be_Captured: "",
            Captured_Response_Key_Datatype: "",
            Dependent_On: "",
            Property_Name1: "",
            Property_Name2: "",
            Property_Name3: "",
            Property_Name4: "",
            Image_URL1: "",
            Image_URL2: "",
            Property_Id: "",
            traits: [
              {
                type: "number",
                name: "count",
                changeProp: true,
              },
              {
                type: "text",
                name: "text",
                changeProp: true,
              },
              {
                type: "text",
                name: "REST_API_URL",
                changeProp: true,
              },
              {
                type: "text",
                name: "Response_Key_To_Be_Captured",
                changeProp: true,
              },
              {
                type: "text",
                name: "Captured_Response_Key_Datatype",
                changeProp: true,
              },
              {
                type: "text",
                name: "Property_Name1",
                changeProp: true,
              },
              {
                type: "text",
                name: "Property_Name2",
                changeProp: true,
              },
              {
                type: "text",
                name: "Property_Name3",
                changeProp: true,
              },
              {
                type: "text",
                name: "Property_Name4",
                changeProp: true,
              },
              {
                type: "text",
                name: "Image_URL1",
                changeProp: true,
              },
              {
                type: "text",
                name: "Image_URL2",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "resizable",
                label: "Resizable",
                changeProp: true,
              },
              {
                type: "text",
                name: "Header1Key",
                changeProp: true,
                label: "Header 1 key",
              },
              {
                type: "text",
                name: "Header1Value",
                changeProp: true,
                label: "Header 1 Value",
              },
              {
                type: "text",
                name: "Header2Key",
                changeProp: true,
                label: "Header 2 Key",
              },
              {
                type: "text",
                name: "Header2Value",
                changeProp: true,
                label: "Header 2 Value",
              },
            ],
            stylable: true,
            styles: `
                    .items {
                        display: flex;
                        background-color: yellow;
                    }
                `,
          },
        },
        view: {
          tagName: "div",
          attributes: {
            contenteditable: true, // add contenteditable attribute
          },

          editable() {
            return true;
          },

          init() {
            console.log("INITTTTT ----");
            // this.listenTo(this.model, 'change:styles.typography', this.handleTypographyChange);
            // this.listenTo(this.model, 'change:styles', this.handleTypographyChange);
            // this.listenTo(this.model.get('attributes'), 'change',  this.handleTypographyChange);
            this.listenTo(this.model, "change:count", this.render);
            this.listenTo(this.model, "change:REST_API_URL", this.render);
            this.listenTo(
              this.model,
              "change:Response_Key_To_Be_Captured",
              this.render
            );
            this.listenTo(
              this.model,
              "change:Captured_Response_Key_Datatype",
              this.render
            );
            this.listenTo(this.model, "change:Property_Name1", this.render);
            this.listenTo(this.model, "change:Property_Name2", this.render);
            this.listenTo(this.model, "change:Property_Name3", this.render);
            this.listenTo(this.model, "change:Property_Name4", this.render);
            this.listenTo(this.model, "change:Image_URL1", this.render);
            this.listenTo(this.model, "change:Image_URL2", this.render);
            this.listenTo(this.model, "change:resizable", this.handleResize);
            // this.listenTo(this.model, 'change:headers', this.render)
            this.listenTo(this.model, "change:Header1Key", this.render);
            this.listenTo(this.model, "change:Header1Value", this.render);
            this.listenTo(this.model, "change:Header2Key", this.render);
            this.listenTo(this.model, "change:Header2Value", this.render);
          },

          handleResize() {
            this.el.style.resize = this.model.get("resizable")
              ? "both"
              : "none";
          },
          //   handleTypographyChange() {
          //     console.log("DSFLKSDJGLKHDSLKGHKLDSGHLKGHKLDH__________")
          //     const typographyStyles = this.model.get('styles.style');
          //     const styleString = Object.keys(typographyStyles)
          //       .map((prop) => `${prop}: ${typographyStyles[prop]};`)
          //       .join(' ');
          //     this.el.style.cssText += ` ${styleString}`; // add typography styles to element's style attribute
          //     this.render();
          //   },
          onRender() {
            var count = this.model.get("count");

            var rest_api_url = this.model.get("REST_API_URL");
            var response_key = this.model.get("Response_Key_To_Be_Captured");
            var captured_type = this.model.get(
              "Captured_Response_Key_Datatype"
            );
            var property_name1 = this.model.get("Property_Name1");
            var property_name2 = this.model.get("Property_Name2");
            var property_name3 = this.model.get("Property_Name3");
            var property_name4 = this.model.get("Property_Name4");

            var Image_URL1 = this.model.get("Image_URL1");
            var Image_URL2 = this.model.get("Image_URL2");
            var header1Key = this.model.get("Header1Key");
            var header1Value = this.model.get("Header1Value");
            var header2Key = this.model.get("Header2Key");
            var header2Value = this.model.get("Header2Value");
            console.log(rest_api_url);
            console.log(response_key);
            console.log(captured_type);
            console.log(property_name1);

            if (
              rest_api_url &&
              response_key &&
              captured_type &&
              property_name1
            ) {
              console.log(rest_api_url);
              console.log(response_key);
              console.log(captured_type);
              console.log(property_name1);

              var html = '<div class="test-editable2">';
              var options = {
                method: "GET",
                headers: {
                  [header1Key]: header1Value,
                  [header2Key]: header2Value,
                },
              };
              // let html2 = document.querySelector('.test-editable2');
              // let html2 = document.createElement('div')
              let html2 = `<div> `;
              console.log("HENTELA-----", html2);
              let i = 0;
              fetch(`${rest_api_url}`, options).then((res) => {
                res.json().then((data) => {
                  // if(i < 4) {
                  if (response_key) {
                    // let obj2 = Object.keys(data[`${response_key}`]).find(`${property_name}`)
                    // console.log("ob2323 ", obj2)
                    if (property_name1) {
                      html2 += '<div style="display: flex">';
                      // displayObject(data[`${response_key}`], html2, property_name)
                      data[`${response_key}`].map((obj) => {
                        if (i < 4) {
                          html2 +=
                            "<div class='items' style='display: flex; flex-direction: column';>";
                          console.log("IN MAP");
                          if (obj.hasOwnProperty(`${Image_URL1}`)) {
                            console.log("HASDD PROPERTY");
                            html2 += `<img contentEditable="true" src="${
                              obj[`${Image_URL1}`]
                            }" style='width: 400px; height: 300px' />`;

                            if (obj.hasOwnProperty(`${property_name1}`)) {
                              html2 += `<h3 contentEditable="true"> ${
                                obj[`${property_name1}`]
                              } </h3>`;
                            }
                          }
                        }
                      });
                    }
                  }
                });
              });
            }
          },
        },
      });

      editor.DomComponents.addType("dateTimeInputNew", {
        model: {
          defaults: {
            tagName: "div",
            // Add some style, just to make the component visible
            components: [
              {
                tagName: "input",
                type: "default",
                attributes: {
                  type: "date",
                  id: `dateTime${uniqid()}`,
                },
                styles: {
                  width: "100%",
                  padding: "0.5rem",
                },
              },
            ],
          },
        },
      });

      const rest_api_displayScript = async function (props) {
        console.log("SCCDSDS ", props);

        let API_RESPONSE;

        if (props.REST_API_URL) {
          let response = await fetch(`${props.REST_API_URL}`);

          let data = await response.json();

          // setValuesForAPI(data)

          API_RESPONSE = data;

          console.log("REST_API_URL response-1 data:", data);

          console.log("REST_API_URL response-1 data:", API_RESPONSE);
        } else if (props.Property_Name) {
          const el = this;

          el.setAttribute("name", props.Property_Name);
        }

        function setValuesForAPI(data) {
          if (props.Property_Name) {
            let htmlEl = document.querySelector(
              `[name="${props.Property_Name}"]`
            );

            htmlEl.innerHTML = data[`${props.Property_Name}`];
          }
        }
      };

      editor.DomComponents.addType("rest-api-display", {
        model: {
          defaults: {
            script: rest_api_displayScript,
            tagName: "rest-api-display",
            REST_API_URL: "",
            Number_of_items: 0,
            Name: "",

            traits: [
              {
                type: "text",
                name: "REST_API_URL",
                changeProp: true,
              },
              {
                type: "number",
                name: "Number_of_items",
                changeProp: true,
              },
              {
                type: "text",
                name: "Name",
                changeProp: true,
              },
            ],
            "script-props": ["REST_API_URL", "Number_of_items", "Name"],
            // tagName: 'div',
            attributes: { title: "Hello" },
            // Can be a string
            components: `
                                    <p>Paragraph test</p>
                                `,
          },
        },
      });

      editor.DomComponents.addType("test-multiple", {
        model: {
          defaults: {
            items: ["Item 1", "Item 2", "Item 3"],
            traits: [
              {
                type: "checkbox",
                name: "items",
                changeProp: true,
                value: "Item1",
              },
              {
                type: "checkbox",
                name: "items",
                changeProp: true,
                value: "Item2",
              },
              {
                type: "checkbox",
                name: "items",
                changeProp: true,
                value: "Item3",
              },
            ],
          },
        },
        view: {
          render: function () {
            console.log("EHRJKWEHKJRHE");
            var items = this.model.get("items");
            console.log("ITEMS ---- ", items);
            var html = "<ul>";
            for (var i = 0; i < items.length; i++) {
              html += "<li>" + items[i] + "</li>";
            }
            html += "</ul>";
            this.$el.html(html);
            console.log("HTML _______ ", html);
            return this;
          },
        },
      });

      editor.DomComponents.addType("test-multiple-2", {
        model: {
          defaults: {
            count: 1,
            text: "Hello, world!",
            REST_API_URL: "",
            Response_Key_To_Be_Captured: "",
            Captured_Response_Key_Datatype: "",
            Dependent_On: "",
            Property_Name1: "",
            Property_Name2: "",
            Property_Name3: "",
            Property_Name4: "",
            Image_URL1: "",
            Image_URL2: "",
            Property_Id: "",
            traits: [
              {
                type: "number",
                name: "count",
                changeProp: true,
              },
              {
                type: "text",
                name: "text",
                changeProp: true,
              },
              {
                type: "text",
                name: "REST_API_URL",
                changeProp: true,
              },
              {
                type: "text",
                name: "Response_Key_To_Be_Captured",
                changeProp: true,
              },
              {
                type: "text",
                name: "Captured_Response_Key_Datatype",
                changeProp: true,
              },
              {
                type: "text",
                name: "Property_Name1",
                changeProp: true,
              },
              {
                type: "text",
                name: "Property_Name2",
                changeProp: true,
              },
              {
                type: "text",
                name: "Property_Name3",
                changeProp: true,
              },
              {
                type: "text",
                name: "Property_Name4",
                changeProp: true,
              },
              {
                type: "text",
                name: "Image_URL1",
                changeProp: true,
              },
              {
                type: "text",
                name: "Image_URL2",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "resizable",
                label: "Resizable",
                changeProp: true,
              },
              {
                type: "text",
                name: "Header1Key",
                changeProp: true,
                label: "Header 1 key",
              },
              {
                type: "text",
                name: "Header1Value",
                changeProp: true,
                label: "Header 1 Value",
              },
              {
                type: "text",
                name: "Header2Key",
                changeProp: true,
                label: "Header 2 Key",
              },
              {
                type: "text",
                name: "Header2Value",
                changeProp: true,
                label: "Header 2 Value",
              },
            ],
            stylable: true,
            styles: `
                                .items {
                                    display: flex;
                                    background-color: yellow;
                                }
                            `,
          },
        },
        view: {
          tagName: "div",
          attributes: {
            contenteditable: true, // add contenteditable attribute
          },

          editable() {
            return true;
          },

          init() {
            console.log("INITTTTT ----");
            // this.listenTo(this.model, 'change:styles.typography', this.handleTypographyChange);
            // this.listenTo(this.model, 'change:styles', this.handleTypographyChange);
            // this.listenTo(this.model.get('attributes'), 'change',  this.handleTypographyChange);
            this.listenTo(this.model, "change:count", this.render);
            this.listenTo(this.model, "change:REST_API_URL", this.render);
            this.listenTo(
              this.model,
              "change:Response_Key_To_Be_Captured",
              this.render
            );
            this.listenTo(
              this.model,
              "change:Captured_Response_Key_Datatype",
              this.render
            );
            this.listenTo(this.model, "change:Property_Name1", this.render);
            this.listenTo(this.model, "change:Property_Name2", this.render);
            this.listenTo(this.model, "change:Property_Name3", this.render);
            this.listenTo(this.model, "change:Property_Name4", this.render);
            this.listenTo(this.model, "change:Image_URL1", this.render);
            this.listenTo(this.model, "change:Image_URL2", this.render);
            this.listenTo(this.model, "change:resizable", this.handleResize);
            // this.listenTo(this.model, 'change:headers', this.render)
            this.listenTo(this.model, "change:Header1Key", this.render);
            this.listenTo(this.model, "change:Header1Value", this.render);
            this.listenTo(this.model, "change:Header2Key", this.render);
            this.listenTo(this.model, "change:Header2Value", this.render);
          },

          handleResize() {
            this.el.style.resize = this.model.get("resizable")
              ? "both"
              : "none";
          },
          //   handleTypographyChange() {
          //     console.log("DSFLKSDJGLKHDSLKGHKLDSGHLKGHKLDH__________")
          //     const typographyStyles = this.model.get('styles.style');
          //     const styleString = Object.keys(typographyStyles)
          //       .map((prop) => `${prop}: ${typographyStyles[prop]};`)
          //       .join(' ');
          //     this.el.style.cssText += ` ${styleString}`; // add typography styles to element's style attribute
          //     this.render();
          //   },
          onRender() {
            var count = this.model.get("count");

            var rest_api_url = this.model.get("REST_API_URL");
            var response_key = this.model.get("Response_Key_To_Be_Captured");
            var captured_type = this.model.get(
              "Captured_Response_Key_Datatype"
            );
            var property_name1 = this.model.get("Property_Name1");
            var property_name2 = this.model.get("Property_Name2");
            var property_name3 = this.model.get("Property_Name3");
            var property_name4 = this.model.get("Property_Name4");

            var Image_URL1 = this.model.get("Image_URL1");
            var Image_URL2 = this.model.get("Image_URL2");
            var header1Key = this.model.get("Header1Key");
            var header1Value = this.model.get("Header1Value");
            var header2Key = this.model.get("Header2Key");
            var header2Value = this.model.get("Header2Value");
            console.log(rest_api_url);
            console.log(response_key);
            console.log(captured_type);
            console.log(property_name1);

            if (
              rest_api_url &&
              response_key &&
              captured_type &&
              property_name1
            ) {
              console.log(rest_api_url);
              console.log(response_key);
              console.log(captured_type);
              console.log(property_name1);

              var html = '<div class="test-editable2">';
              var options = {
                method: "GET",
                headers: {
                  [header1Key]: header1Value,
                  [header2Key]: header2Value,
                },
              };
              // let html2 = document.querySelector('.test-editable2');
              // let html2 = document.createElement('div')
              let html2 = `<div> `;
              console.log("HENTELA-----", html2);
              let i = 0;
              fetch(`${rest_api_url}`, options).then((res) => {
                res.json().then((data) => {
                  // if(i < 4) {
                  if (response_key) {
                    // let obj2 = Object.keys(data[`${response_key}`]).find(`${property_name}`)
                    // console.log("ob2323 ", obj2)
                    if (property_name1) {
                      html2 += '<div style="display: flex">';
                      // displayObject(data[`${response_key}`], html2, property_name)
                      data[`${response_key}`].map((obj) => {
                        if (i < 4) {
                          html2 +=
                            "<div class='items' style='display: flex; flex-direction: column';>";
                          console.log("IN MAP");
                          if (obj.hasOwnProperty(`${Image_URL1}`)) {
                            console.log("HASDD PROPERTY");
                            html2 += `<img contentEditable="true" src="${
                              obj[`${Image_URL1}`]
                            }" style='width: 400px; height: 300px' />`;

                            if (obj.hasOwnProperty(`${property_name1}`)) {
                              html2 += `<h3 contentEditable="true"> ${
                                obj[`${property_name1}`]
                              } </h3>`;
                            }

                            if (obj.hasOwnProperty(`${property_name2}`)) {
                              html2 += `<p contentEditable="true">  ${
                                obj[`${property_name2}`]
                              } </p>`;
                            }
                          }
                          html2 += "</div>";
                          i++;
                        }
                      });
                    }
                    // i++;
                  }

                  // }
                  // displayObject(data, html2)
                  console.log("htetetete", html2);
                  html2 += "</div>";
                  this.$el.html(html2);
                  // this.el.innerHTML = html2.innerHTML;

                  return this;
                });
              });

              // html2 += "</div>"
            } else {
              // Response_Key_To_Be_Captured: "",
              // Captured_Response_Key_Datatype: "",
              // Dependent_On: "",
              // Property_Name: "",
              // Property_Id: "",
              var html = '<div class="test-editable2">';
              for (var i = 0; i < count; i++) {
                console.log("IN FOR LOOOOOPPPPP");
                html += '<p contenteditable="true">' + "Insert API" + "</p>";
              }
              html += "</div>";
              this.$el.html(html);
              // this.renderChildren();
              return this;
            }

            // var html3 = '<div class="test-editable3"> </div>'
            // html3+= "</div>"
            // this.$el.html(html3)
            // return this;
          },
        },
      });

      editor.StyleManager.addType("test-multiple-2", {
        name: "Test Multiple 2",
        properties: [
          {
            name: "Count",
            property: "count",
            type: "integer",
          },
          {
            name: "Text",
            property: "text",
          },
        ],
      });

      const listCard = async function (props) {
        console.log("props:", props);
      };

      editor.DomComponents.addType("g-translate-old", {
        model: {
          defaults: {
            // script: googleTranslateElementInit,

            tagName: "section",
            components: [
              {
                tagName: "h1",
                content: "hello world",
              },
              {
                tagName: "div",
                attributes: { id: "google_translate_element" },
              },
              {
                tagName: "script",
                attributes: { type: "text/javascript" },
                components: [
                  {
                    type: "textnode",
                    content: `
                        function googleTranslateElementInit() {
                            new google.translate.TranslateElement({pageLanguage: 'en'}, 'google_translate_element');
                        }
                    `,
                  },
                ],
              },
              {
                tagName: "script",
                attributes: {
                  type: "text/javascript",
                  src: "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit",
                },
              },
            ],
          },
        },
      });

      const gTranslateScript = function (props) {
        const includedLanguages = props.includedLanguages || "";

        const script1 = document.createElement("script");
        script1.setAttribute("type", "text/javascript");
        // script1.innerHTML = `
        //   function googleTranslateElementInit() {
        //     new google.translate.TranslateElement({pageLanguage: 'en',includedLanguages: ${includedLanguages}}, 'google_translate_element');
        //   }
        // `;
        // this.appendChild(script1);

         script1.innerHTML = `
          function googleTranslateElementInit() {
            new google.translate.TranslateElement({
              pageLanguage: 'en',
              includedLanguages: '${includedLanguages}'
            }, 'google_translate_element');
          }
        `;
        document.head.appendChild(script1);

        const script2 = document.createElement("script");
        script2.setAttribute("type", "text/javascript");
        script2.setAttribute(
          "src",
          "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
        );
        this.appendChild(script2);

        // this.innerHTML += `
        //   <script type="text/javascript">
        //     function googleTranslateElementInit() {
        //       new google.translate.TranslateElement({pageLanguage: 'en'}, 'google_translate_element');
        //     }
        //   </script>

        //   <script type="text/javascript" src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"></script>
        // `;
      };

      editor.DomComponents.addType("g-translate-container", {
        model: {
          defaults: {
            tagName: "div",
            script: gTranslateScript,
            type: "g-translate-container",
            attributes: {
              class: "g-translate-container",
            },
            includedLanguages: "",
            traits: [
              {
                type: "text",
                name: "includedLanguages",
                label: "Target Languages (comma-separated)",
                placeholder: "e.g. en,hi,bn,es,fr",
                changeProp: 1,
              },
            ],
            'script-props':["includedLanguages"],
            components: [
              {
                tagName: "div",
                type: "g-translate",
                attributes: {
                  id: "google_translate_element",
                  class: "google_translate_element",
                },

                // content: `
                //   <script type="text/javascript">
                //     function googleTranslateElementInit() {
                //       new google.translate.TranslateElement({pageLanguage: 'en'}, 'google_translate_element');
                //     }
                //   </script>

                //   <script type="text/javascript" src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"></script>
                // `,
              },
            ],
          },

          // init() {
          //   this.initGoogleTranslateElement();
          // },

          // initGoogleTranslateElement() {
          //   let script1 = {
          //     tagName: "script",
          //     attributes: {
          //       type: "text/javascript",
          //     },
          //     content: `
          //       function googleTranslateElementInit() {
          //         new google.translate.TranslateElement({pageLanguage: 'en'}, 'google_translate_element');
          //       }
          //     `,
          //   };

          //   let script2 = {
          //     tagName: "script",
          //     attributes: {
          //       type: "text/javascript",
          //       src: "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit",
          //     },
          //   };

          //   this.find('.google_translate_element')[0].append(script1);
          //   this.find('.google_translate_element')[0].append(script2);
          // },
        },
      });

      // login form template 1
      function createLoginFormTemplate1() {}

      // LOGIN FORM
      editor.DomComponents.addType("login-form-temp1", {
        model: {
          defaults: {
            // script: createLoginFormTemplate1,

            tagName: "section",
            attributes: { class: "login-form-temp1" },

            styles: `
              .login-form-temp1 {
                width: 50%;
                padding: 0.5em;
              }
            `,

            components: [
              {
                tagName: "form",
                attributes: { class: "login-form-temp1-container" },

                styles: `
                                        .login-form-container {
                                            position: relative;
                                            max-width: 100%;
                                            background-color: white;
                                            border-radius: 20px;
                                            padding: 0.5em 0.5em 3em 0.5em;
                                            margin: auto;
                                            border: 1px solid black;
                                        }
                                    `,

                components: [
                  {
                    tagName: "h2",
                    attributes: { class: "login-form-temp1-header" },
                    content: "Login Form",

                    styles: `
                                                .login-form-header {
                                                    text-align: center;
                                                }
                                            `,
                  },
                  {
                    tagName: "input",
                    attributes: {
                      class: "login-form-temp1-email-input",
                      type: "email",
                      placeholder: "Enter email",
                    },

                    styles: `
                                                .login-form-temp1-email-input {
                                                    display: block;
                                                    width: 90%;
                                                    border-radius: 25px;
                                                    boder: none;
                                                    padding: 0.5em;
                                                    background-color: #d9d6ce;
                                                    margin-right: auto;
                                                    margin-left: auto;
                                                    margin-top: 5%;
                                                    color: black;
                                                }
                                            `,
                  },
                  {
                    tagName: "input",
                    attributes: {
                      class: "login-form-temp1-username-input",
                      type: "text",
                      placeholder: "Enter username",
                    },

                    styles: `
                                                .login-form-temp1-username-input {
                                                    display: block;
                                                    width: 90%;
                                                    border-radius: 25px;
                                                    boder: none;
                                                    padding: 0.5em;
                                                    background-color: #d9d6ce;
                                                    margin-right: auto;
                                                    margin-left: auto;
                                                    margin-top: 5%;
                                                    color: black;
                                                }
                                            `,
                  },
                  {
                    tagName: "input",
                    attributes: {
                      class: "login-form-temp1-password-input",
                      type: "password",
                      placeholder: "Enter password",
                    },

                    styles: `
                                                .login-form-temp1-password-input {
                                                    display: block;
                                                    width: 90%;
                                                    border-radius: 25px;
                                                    boder: none;
                                                    padding: 0.5em;
                                                    background-color: #d9d6ce;
                                                    margin-right: auto;
                                                    margin-left: auto;
                                                    margin-top: 5%;
                                                    color: black;
                                                }
                                            `,
                  },
                  {
                    tagName: "button",
                    attributes: {
                      class: "login-form-temp1-submit-button",
                    },
                    content: "Submit",

                    styles: `
                                                .login-form-temp1-submit-button {
                                                    display: block;
                                                    width: 90%;
                                                    border-radius: 25px;
                                                    boder: none;
                                                    padding: 0.6em;
                                                    background-color: #2979FF;
                                                    margin-right: auto;
                                                    margin-left: auto;
                                                    margin-top: 5%;
                                                    color: white;
                                                }
                                            `,
                  },
                  {
                    tagName: "div",
                    attributes: {
                      class: "social-media-container",
                    },

                    styles: `
                                                .social-media-container {
                                                    display: flex;
                                                    align-items: center;
                                                    justify-content: space-between;
                                                    width: 40%;
                                                    
                                                    position: absolute;
                                                    left: 30%;
                                                    right: auto;
                                                    bottom: -5%;
                                                }
                                            `,
                    components: [
                      {
                        tagName: "span",
                        attributes: {
                          class: "form-facebook-icon",
                        },
                        content: '<i class="fa-brands fa-facebook"></i>',

                        styles: `
                                                        .form-facebook-icon {
                                                            padding: 0.5em;
                                                            border-radius: 50%;
                                                            background-color: #2979FF,
                                                            color: white;
                                                        }
                                                    `,
                      },
                      {
                        tagName: "span",
                        attributes: {
                          class: "form-google-icon",
                        },
                        content: '<i class="fa-brands fa-google"></i>',

                        styles: `
                                                        .form-google-icon {
                                                            padding: 0.5em;
                                                            border-radius: 50%;
                                                            background-color: red,
                                                            color: white;
                                                        }
                                                    `,
                      },
                      {
                        tagName: "span",
                        attributes: {
                          class: "form-twitter-icon",
                        },
                        content: '<i class="fa-brands fa-twitter"></i>',

                        styles: `
                                                        .form-twitter-icon {
                                                            padding: 0.5em;
                                                            border-radius: 50%;
                                                            background-color: green,
                                                            color: white;
                                                        }
                                                    `,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        },
      });

      editor.DomComponents.addType("login-form-temp2", {
        model: {
          defaults: {
            // script:,
            tagName: "section",
            attributes: { class: "login-form-temp2" },

            styles: `
                                    .login-form-temp2 {
                                        width: 60%;
                                        padding: 0.5em;
                                    }
                                `,

            components: [
              {
                tagName: "div",
                attributes: { class: "login-form-temp2-container" },

                styles: `
                                        .login-form-container {
                                            display: flex;
                                            align-items: center;
                                            max-width: 100%;
                                            height: 30em;
                                            background-color: white;
                                            border-radius: 20px;
                                            margin: auto;
                                            border: 1px solid black;
                                        }
                                    `,

                components: [
                  {
                    tagName: "div",
                    attributes: { class: "login-form-temp2-left-container" },

                    styles: `
                                                .login-form-temp2-left-container {
                                                    width: 50%;
                                                    height: 100%;
                                                    
                                                    display: flex;
                                                    justify-content: center;
                                                    align-items: center;
                                                }
                                            `,

                    components: [
                      {
                        tagName: "div",
                        attributes: {
                          class: "login-form-temp2-left-container-image-holder",
                        },

                        styles: `
                                                        .login-form-temp2-left-container-image-holder {
                                                            padding: 0.5em;
                                                            width: 50%;
                                                            height: 40%;
                                                            border-radius: 50%;
                                                            background-color: #f0eee9;
                                                            
                                                            display: flex;
                                                            justify-content: center;
                                                            align-items: center;
                                                        }
                                                    `,

                        components: [
                          {
                            tagName: "img",
                            attributes: {
                              class:
                                "login-form-temp2-left-container-image-holder-image",
                              src: "https://png.pngtree.com/element_our/20190602/ourmid/pngtree-cartoon-laptop-free-illustration-image_1377333.jpg",
                            },

                            styles: `
                                                            .login-form-temp2-left-container-image-holder-image {
                                                                width: 80%;
                                                            }
                                                        `,
                          },
                        ],
                      },
                    ],
                  },
                  {
                    tagName: "form",
                    attributes: { class: "login-form-temp2-right-container" },

                    styles: `
                                                .login-form-temp2-right-container {
                                                    width: 50%;
                                                    height: 100%;
                                                    
                                                    display: flex;
                                                    flex-direction: column;
                                                    justify-content: center;
                                                    align-items: center;
                                                    row-gap: 2em;
                                                }
                                            `,

                    components: [
                      {
                        tagName: "h2",
                        attributes: {
                          class: "login-form-temp2-right-container-header",
                        },
                        content: "Member Login",

                        styles: `
                                                        .login-form-temp2-right-container-header {
                                                            text-align: center;
                                                        }
                                                    `,
                      },
                      {
                        tagName: "div",
                        attributes: {
                          class:
                            "login-form-temp2-right-container-email-input-container",
                        },

                        styles: `
                                                        .login-form-temp2-right-container-email-input-container {
                                                            position: relative;
                                                            margin-left: auto;
                                                            margin-right: auto;
                                                            width: 90%;
                                                        }
                                                    `,

                        components: [
                          {
                            tagName: "i",
                            attributes: {
                              class:
                                "fa-solid fa-envelope login-form-temp2-right-container-email-input-icon",
                            },

                            styles: `
                                                                .login-form-temp2-right-container-email-input-icon {
                                                                    color: 'gray';
                                                                    font-size: 90%;
                                                                    z-index: 1;
            
                                                                    position: absolute;
                                                                    top: 35%;
                                                                    left: 4%;
                                                                }
                                                            `,
                          },
                          {
                            tagName: "input",
                            attributes: {
                              class:
                                "login-form-temp2-right-container-email-input",
                              type: "email",
                              placeholder: "Email",
                            },

                            styles: `
                                                                .login-form-temp2-right-container-email-input {
                                                                    width: 100%;
                                                                    border-radius: 25px;
                                                                    boder: none;
                                                                    padding: 0.5em 0.5em 0.5em 3em;
                                                                    background-color: #d9d6ce;
                                                                    color: black;
                                                                }
                                                            `,
                          },
                        ],
                      },
                      {
                        tagName: "div",
                        attributes: {
                          class:
                            "login-form-temp2-right-container-username-input-container",
                        },

                        styles: `
                                                        .login-form-temp2-right-container-username-input-container {
                                                            position: relative;
                                                            margin-left: auto;
                                                            margin-right: auto;
                                                            width: 90%;
                                                        }
                                                    `,

                        components: [
                          {
                            tagName: "i",
                            attributes: {
                              class:
                                "fa-solid fa-envelope login-form-temp2-right-container-username-input-icon",
                            },

                            styles: `
                                                                .login-form-temp2-right-container-username-input-icon {
                                                                    color: 'gray';
                                                                    font-size: 90%;
                                                                    z-index: 1;
            
                                                                    position: absolute;
                                                                    top: 35%;
                                                                    left: 4%;
                                                                }
                                                            `,
                          },
                          {
                            tagName: "input",
                            attributes: {
                              class:
                                "login-form-temp2-right-container-username-input",
                              type: "text",
                              placeholder: "Username",
                            },

                            styles: `
                                                                .login-form-temp2-right-container-username-input {
                                                                    width: 100%;
                                                                    border-radius: 25px;
                                                                    boder: none;
                                                                    padding: 0.5em 0.5em 0.5em 3em;
                                                                    background-color: #d9d6ce;
                                                                    color: black;
                                                                }
                                                            `,
                          },
                        ],
                      },
                      {
                        tagName: "div",
                        attributes: {
                          class:
                            "login-form-temp2-right-container-password-input-container",
                        },

                        styles: `
                                                        .login-form-temp2-right-container-password-input-container {
                                                            position: relative;
                                                            margin-left: auto;
                                                            margin-right: auto;
                                                            width: 90%;
                                                        }
                                                    `,

                        components: [
                          {
                            tagName: "i",
                            attributes: {
                              class:
                                "fa-solid fa-lock login-form-temp2-right-container-password-input-icon",
                            },

                            styles: `
                                                                .login-form-temp2-right-container-password-input-icon {
                                                                    color: 'gray';
                                                                    font-size: 90%;
                                                                    z-index: 1;
            
                                                                    position: absolute;
                                                                    top: 35%;
                                                                    left: 4%;
                                                                }
                                                            `,
                          },
                          {
                            tagName: "input",
                            attributes: {
                              class:
                                "login-form-temp2-right-container-password-input",
                              type: "password",
                              placeholder: "Password",
                            },

                            styles: `
                                                                .login-form-temp2-right-container-password-input {
                                                                    width: 100%;
                                                                    border-radius: 25px;
                                                                    boder: none;
                                                                    padding: 0.5em 0.5em 0.5em 3em;
                                                                    background-color: #d9d6ce;
                                                                    color: black;
                                                                }
                                                            `,
                          },
                        ],
                      },
                      {
                        tagName: "button",
                        attributes: {
                          class:
                            "login-form-temp2-right-container-login-button",
                        },
                        content: "LOGIN",

                        styles: `
                                                        width: 90%;
                                                        background-color: green;
                                                        border-radius: 25px;
                                                        padding: 0.8em;
                                                        cursor: pointer;
                                                        color: white;
                                                    `,
                      },
                      {
                        tagName: "p",
                        attributes: {
                          class:
                            "login-form-temp2-right-container-forget-credentials",
                        },

                        components: [
                          {
                            type: "textnode",
                            content: "Forget ",
                          },
                          {
                            tagName: "span",
                            attributes: {
                              class:
                                "login-form-temp2-right-container-forget-credentials-container",
                            },

                            components: {
                              tagName: "a",
                              attributes: {
                                class:
                                  "login-form-temp2-right-container-forget-credentials-link",
                                href: "#",
                              },
                              content: "Username/Password?",

                              styles: `
                                                                    .login-form-temp2-right-container-forget-credentials-link {
                                                                        color: green;
                                                                        text-decoration: none;
                                                                        cursor: pointer;
                                                                    }
                                                                `,
                            },
                          },
                        ],
                      },
                      {
                        tagName: "a",
                        attributes: {
                          class:
                            "login-form-temp2-right-container-create-credentials-link",
                          href: "#",
                        },

                        styles: `
                                                        .login-form-temp2-right-container-create-credentials-link {
                                                            color: green;
                                                            text-decoration: none;
                                                            cursor: pointer;
                                                        }
                                                    `,

                        components: [
                          {
                            type: "textnode",
                            content: "Create your account ",
                          },
                          {
                            tagName: "i",
                            attributes: {
                              class:
                                "fa-solid fa-arrow-right login-form-temp2-right-container-create-credentials-arrow",
                            },

                            styles: `
                                                                .login-form-temp2-right-container-create-credentials-arrow {
                                                                    color: green;
                                                                }
                                                            `,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        },
      });

      // function koreChatScript() {

      //   (function ($) {
      //     $(document).ready(function () {
      //       let koreBot;
      //       let chatConfig = {};
      //       function assertion(options, callback) {
      //         var jsonData = {
      //           clientId: options.clientId,
      //           clientSecret: options.clientSecret,
      //           identity: options.userIdentity,
      //           aud: "",
      //           isAnonymous: false,
      //         };
      //         $.ajax({
      //           url: options.JWTUrl,
      //           type: "post",
      //           data: jsonData,
      //           dataType: "json",
      //           success: function (data) {
      //             options.assertion = data.jwt;
      //             options.handleError = koreBot.showError;
      //             options.chatHistory = koreBot.chatHistory;
      //             options.botDetails = koreBot.botDetails;
      //             callback(null, options);
      //             setTimeout(function () {
      //               if (koreBot && koreBot.initToken) {
      //                 koreBot.initToken(options);
      //               }
      //             }, 2000);
      //           },
      //           error: function (err) {
      //             koreBot.showError(err.responseText);
      //           },
      //         });
      //       }
      //       function getBrandingInformation(options) {
      //         if (chatConfig.botOptions && chatConfig.botOptions.enableThemes) {
      //           var brandingAPIUrl = (
      //             chatConfig.botOptions.brandingAPIUrl || ""
      //           ).replace(":appId", chatConfig.botOptions.botInfo._id);
      //           $.ajax({
      //             url: brandingAPIUrl,
      //             headers: {
      //               Authorization:
      //                 "bearer " + options.authorization.accessToken,
      //             },
      //             type: "get",
      //             dataType: "json",
      //             success: function (data) {
      //               if (koreBot && koreBot.applySDKBranding) {
      //                 koreBot.applySDKBranding(data);
      //               }
      //               if (koreBot && koreBot.initToken) {
      //                 koreBot.initToken(options);
      //               }
      //             },
      //             error: function (err) {
      //               console.log(err);
      //             },
      //           });
      //         }
      //       }
      //       function onJWTGrantSuccess(options) {
      //         getBrandingInformation(options);
      //       }
      //       async function fetchBotOptions() {
      //         // Project id needs to be replaced
      //         const response = await fetch(
      //           "http://localhost:8085/chatbots/api/chatbots/64e6f9066557ff884a1cc8b2"
      //         ); // Replace YOUR_API_ENDPOINT with your actual API endpoint
      //         const apiResult = await response.json();
      //         let botOptions = {};
      //         console.log("Api result -- ", apiResult[0]);
      //         botOptions.apiResult = apiResult;

      //         botOptions.logLevel = "debug";
      //         botOptions.koreAPIUrl = "https://bots.kore.ai/api/";
      //         botOptions.koreSpeechAPIUrl = ""; //deprecated
      //         //botOptions.bearer = "bearer xyz-------------------";
      //         //botOptions.ttsSocketUrl = '';//deprecated
      //         botOptions.koreAnonymousFn = koreAnonymousFn;
      //         botOptions.recorderWorkerPath =
      //           "korebotComponents/sdk/libs/recorderWorker.js";
      //         //botOptions.name = apiResult[0].koreAPIUrlbotInfoName;
      //         botOptions.JWTUrl = apiResult[0].JWTUrl;
      //         botOptions.userIdentity = apiResult[0].userIdentity; // Provide users email id here
      //         botOptions.botInfo = {
      //           name: apiResult[0].koreAPIUrlbotInfoName,
      //           _id: apiResult[0].botInfoId,
      //         }; // bot name is case sensitive

      //         /*
      //               Important Note: These keys are provided here for quick demos to generate JWT token at client side but not for Production environment.
      //               Refer below document for JWT token generation at server side. Client Id and Client secret should maintained at server end.
      //               https://developer.kore.ai/docs/bots/sdks/user-authorization-and-assertion/
      //               **/
      //         botOptions.clientId = apiResult[0].clientId;
      //         botOptions.clientSecret = apiResult[0].clientSecret;
      //         botOptions.brandingAPIUrl =
      //           botOptions.koreAPIUrl +
      //           "websdkthemes/" +
      //           botOptions.botInfo._id +
      //           "/activetheme";
      //         botOptions.enableThemes = true;
      //         return botOptions;
      //       }
      //       async function initializeChat() {
      //         const botOptions = await fetchBotOptions();
      //         botOptions.logLevel = "debug";
      //         botOptions.koreAPIUrl = "https://bots.kore.ai/api/";
      //         botOptions.koreSpeechAPIUrl = "";
      //         botOptions.recorderWorkerPath = "../libs/recorderWorker.js";
      //         botOptions.enableThemes = true;

      //         chatConfig = {
      //           botOptions: botOptions,
      //           allowIframe: false, // set true, opens authentication links in popup window, default value is "false"
      //           isSendButton: false, // set true, to show send button below the compose bar
      //           isTTSEnabled: true, // set true, to hide speaker icon
      //           ttsInterface: "webapi", // webapi or awspolly , where default is webapi
      //           isSpeechEnabled: true, // set true, to hide mic icon
      //           stt: {
      //             vendor: "webapi", //'webapi'|'azure'|'google' //uses respective settings from the following keys and uncomments respective files in index.html
      //             azure: {
      //               subscriptionKey: "",
      //               recognitionLanguage: "en-US",
      //               recognitionMode: "Interactive", //Interactive/Dictation/Conversation/Interactive
      //             },
      //             google: {
      //               apiKey: "",
      //               recognitionLanguage: "en-US",
      //             },
      //             webapi: {
      //               recognitionLanguage: "en-US",
      //             },
      //           },
      //           allowLocation: true, // set false, to deny sending location to server
      //           loadHistory: true, // set true to load recent chat history
      //           messageHistoryLimit: 10, // set limit to load recent chat history
      //           autoEnableSpeechAndTTS: false, // set true, to use talkType voice keyboard.
      //           graphLib: "d3", // set google, to render google charts.This feature requires loader.js file which is available in google charts documentation.
      //           googleMapsAPIKey: "",
      //           minimizeMode: true, // set true, to show chatwindow in minimized mode, If false is set remove #chatContainer style in chatwindow.css
      //           multiPageApp: {
      //             enable: false, //set true for non SPA(Single page applications)
      //             userIdentityStore: "localStorage", //'localStorage || sessionStorage'
      //             chatWindowStateStore: "localStorage", //'localStorage || sessionStorage'
      //           },
      //           supportDelayedMessages: true, // enable to add support for renderDelay in message nodes which will help to render messages with delay from UI
      //           maxTypingIndicatorTime: 10000, //time in milliseconds,typing indicator will be stopped after this time limit,even bot doesn't respond
      //           pickersConfig: {
      //             showDatePickerIcon: false, //set true to show datePicker icon
      //             showDateRangePickerIcon: false, //set true to show dateRangePicker icon
      //             showClockPickerIcon: false, //set true to show clockPicker icon
      //             showTaskMenuPickerIcon: false, //set true to show TaskMenu Template icon
      //             showradioOptionMenuPickerIcon: false, //set true to show Radio Option Template icon
      //           },
      //           sendFailedMessage: {
      //             MAX_RETRIES: 3,
      //           },
      //         };

      //         botOptions.assertionFn = assertion;
      //         botOptions.jwtgrantSuccessCB = onJWTGrantSuccess;

      //         koreBot = koreBotChat();
      //         koreBot.show(chatConfig);

      //         $(".openChatWindow").click(function () {
      //           koreBot.show(chatConfig);
      //         });
      //       }
      //       initializeChat();
      //     });
      //   })(
      //     jQuery ||
      //       (window.KoreSDK &&
      //         window.KoreSDK.dependencies &&
      //         window.KoreSDK.dependencies.jQuery)
      //   );
      // }

      function ratingSliderScript() {
        const ratingSlider = document.getElementById("rating-slider");
        const smiley = document.getElementById("smiley");
        const displayRating = document.getElementById("display-rating");
        const hiddenRatingInput = document.getElementById("hidden-rating");
        //const ratingForm = document.getElementById('rating-form');

        ratingSlider.addEventListener("input", () => {
          alert(hiddenRatingInput.value);
          const rating = ratingSlider.value;

          // Update smiley position
          const sliderWidth = ratingSlider.clientWidth;
          const smileyPosition = (rating / 10) * sliderWidth;
          smiley.style.left = `${smileyPosition}px`;

          // Update smiley icon based on rating
          if (rating >= 7) {
            smiley.textContent = "😄"; // Happy face
          } else if (rating >= 4) {
            smiley.textContent = "😐"; // Neutral face
          } else {
            smiley.textContent = "😞"; // Sad face
          }

          // Update displayed rating
          displayRating.textContent = rating;

          // Update hidden input value
          hiddenRatingInput.value = rating;
        });

        // Initialize with default value
        ratingSlider.dispatchEvent(new Event("input"));

        // // Handle form submission
        // ratingForm.addEventListener('submit', (e) => {
        //     e.preventDefault();
        //     const selectedRating = hiddenRatingInput.value;
        //     alert(`You submitted a rating of ${selectedRating}/10`);
        // });
      }

      function calendyScript({
        url,
        widgettype,
        badgetext,
        bgcolor,
        textcolor,
        buttonlink,
        hidedetail,
        branding,
      }) {
        var el = this;
        function init() {
          var btn = el.querySelector(".gpd-calendly-btn"),
            config = [
              !!hidedetail ? "hide_event_type_details=1" : "",
              "background_color=".concat(bgcolor),
              "text_color=".concat(textcolor),
              "primary_color=".concat(buttonlink),
            ]
              .filter(function (option) {
                return option;
              })
              .join("&");
          if (widgettype === "popup") {
            btn &&
              btn.addEventListener("click", function () {
                return window.Calendly.initPopupWidget({
                  url: "".concat(url, "?").concat(config),
                  branding: !!branding,
                });
              });
          } else {
            btn && (btn.style.display = "none");
            if (widgettype === "inline") {
              window.Calendly.initInlineWidget({
                url: "".concat(url, "?").concat(config),
                parentElement: el,
                branding: !!branding,
              });
            } else {
              window.Calendly.initBadgeWidget({
                url: "".concat(url, "?").concat(config),
                text: badgetext || "Schedule meeting",
                textColor: textcolor,
                color: bgcolor,
                branding: !!branding,
              });
            }
          }
        }
        if (window.Calendly) init();
        else {
          var link = document.createElement("link");
          link.href = "https://assets.calendly.com/assets/external/widget.css";
          link.rel = "stylesheet";
          document.head.appendChild(link);
          var script = document.createElement("script");
          script.src = "https://assets.calendly.com/assets/external/widget.js";
          script.onload = init;
          document.head.appendChild(script);
        }
      }

      function launchMobileNav() {
        const homeNav = document.querySelector("#home-nav");
        const homePage = document.querySelector("#home-page");
        homeNav.root = homePage;

        const radioNav = document.querySelector("#radio-nav");
        const radioPage = document.querySelector("#radio-page");
        radioNav.root = radioPage;

        const libraryNav = document.querySelector("#library-nav");
        const libraryPage = document.querySelector("#library-page");
        libraryNav.root = libraryPage;

        const searchNav = document.querySelector("#search-nav");
        const searchPage = document.querySelector("#search-page");
        searchNav.root = searchPage;
      }

      function launch3dAnimation({ url }) {
        var el = this;
        function init() {
          var btn = el.querySelector(".gpd-calendly-admin-btn");
          btn &&
            btn.addEventListener("click", function () {
              window.open(url);
            });
        }
        init();
      }

      function calendyAdminScript({
        url,
        clientid,
        clientsecret,
        redirecturi,
      }) {
        var el = this;
        //CalendyScreen(editorRef.current);
        calendyClientSecret = clientsecret;
        calendyClientID = clientid;
        var accesstokenurl = "https://auth.calendly.com/oauth/token";
        var calendyTokenUrl = accesstokenurl;
        function init() {
          var btn = el.querySelector(".gpd-calendly-admin-btn"),
            config = [
              "response_type=code&client_id=".concat(clientid),
              "redirect_uri=".concat(redirecturi),
            ]
              .filter(function (option) {
                return option;
              })
              .join("&");
          btn &&
            btn.addEventListener("click", function () {
              window.open("".concat(url, "?").concat(config));
              function fetchCode() {}
              window.setTimeout(fetchCode, 20000);

              let code = localStorage.getItem("authorizationCode");
              const credentials = `${clientid}:${clientsecret}`;
              const encodedCredentials = btoa(credentials);

              const headers = new Headers();
              headers.append("Authorization", `Basic ${encodedCredentials}`);
              headers.append("Content-Type", "application/json");

              const requestBody = {
                code: code,
                redirect_uri: redirecturi,
                grant_type: "authorization_code",
              };

              const requestOptions = {
                method: "POST",
                headers: headers,
                body: JSON.stringify(requestBody),
              };

              fetch(accesstokenurl, requestOptions)
                .then((response) => {
                  let responseCode = response.status;
                  return response.json();
                })
                .then((data) => {
                  const accessToken = data.access_token;
                  const endpoint = "https://api.calendly.com/users/me";
                  const headers = new Headers();
                  headers.append("Authorization", `Bearer ${accessToken}`);
                  headers.append("Content-Type", "application/json");

                  const requestOptions = {
                    method: "GET",
                    headers: headers,
                  };

                  fetch(endpoint, requestOptions)
                    .then((response) => response.json())
                    .then((data) => {
                      let uri12 = data.resource.uri;
                      //alert(uri12);
                      console.log(uri12);
                      //alert(accessToken);
                      const endpoint =
                        "https://api.calendly.com/scheduled_events?user=" +
                        uri12;
                      const headers = new Headers();
                      headers.append("Authorization", `Bearer ${accessToken}`);
                      headers.append("Content-Type", "application/json");

                      const requestOptions = {
                        method: "GET",
                        headers: headers,
                      };
                      fetch(endpoint, requestOptions)
                        .then((response) => {
                          //alert("check2");
                          //alert(response.status);
                          return response.json();
                        })
                        .then((data) => {
                          const container = document.querySelector(
                            ".gpd-calendly-admin-btn"
                          );
                          container.innerHTML = "";
                          data.collection.forEach((item) => {
                            //alert(item.uri);
                            const card = document.createElement("div");
                            card.classList.add("card");
                            card.style.backgroundColor = "#f4f4f4";

                            const uri = document.createElement("p");
                            uri.textContent = `URI: ${item.uri}`;

                            const name = document.createElement("p");
                            name.textContent = `Name: ${item.name}`;

                            const status = document.createElement("p");
                            status.textContent = `Status: ${item.status}`;

                            const start = document.createElement("p");
                            start.textContent = `Start time: ${item.start_time}`;

                            const end = document.createElement("p");
                            end.textContent = `End Time: ${item.end_time}`;

                            card.appendChild(uri);
                            card.appendChild(name);
                            card.appendChild(status);
                            card.appendChild(start);
                            card.appendChild(end);
                            container.appendChild(card);
                          });
                        })
                        .catch((error) => {
                          alert(error);
                        });
                    })
                    .catch((error) => {
                      console.error("Error:", error);
                    });
                })
                .catch((error) => {
                  console.error("Error:", error);
                });
            });
        }
        if (window.Calendly) init();
        else {
          var link = document.createElement("link");
          link.href = "https://assets.calendly.com/assets/external/widget.css";
          link.rel = "stylesheet";
          document.head.appendChild(link);
          var script = document.createElement("script");
          script.src = "https://assets.calendly.com/assets/external/widget.js";
          script.onload = init;
          document.head.appendChild(script);
        }
      }

      editor.DomComponents.addType("calendy-admin", {
        model: {
          defaults: {
            name: "calendly-admin",
            icon: '<svg viewBox="0 0 24 24"><path d="M14 14H7v2h7m5 3H5V8h14m0-5h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-2 7H7v2h10v-2z"></path></svg>',
            droppable: false,
            resizable: false,
            script: calendyAdminScript,
            content: `<div style = "padding:10px 0;" data-gjs-type="calendly-admin">
      <div class= "gpd-calendly-admin-btn gpd-calendly-admin-btn-st" data-gjs-type="calendly-admin-btn">View Meetings</div>
    </div>`,
            attributes: {
              style: "font-family: Helvetica",
            },
            url: "https://calendly.com/oauth/authorize",
            widgettype: "popup",
            badgetext: "Schedule time with me",
            bgcolor: "#ffffff",
            textcolor: "#4d5055",
            buttonlink: "#00a2ff",
            branding: false,
            hidedetail: false,
            traits: [
              {
                name: "url",
                label: "Calendly Authorize URL",
                placeholder: "https://calendly.com/oauth/authorize",
                default: "https://calendly.com/oauth/authorize",
                changeProp: true,
              },
              {
                name: "clientid",
                label: "Client ID",
                placeholder: "Enter Client ID",
                default: "Enter Client ID",
                changeProp: true,
              },
              {
                name: "clientsecret",
                label: "Client Secret",
                placeholder: "Enter Client Secret",
                default: "Enter Client Secret",
                changeProp: true,
              },
              {
                name: "redirecturi",
                label: "Redirect URI",
                placeholder: "Enter Redirect URI",
                default: "Enter Redirect URI",
                changeProp: true,
              },
            ],
            "script-props": ["url", "clientid", "clientsecret", "redirecturi"],
          },
        },
      });

      editor.DomComponents.addType("3d-urdf", {
        model: {
          defaults: {
            name: "3d-urdf",
            icon: '<svg viewBox="0 0 24 24"><path d="M12 10.2308L3.08495 7.02346M12 10.2308L20.9178 7.03406M12 10.2308V20.8791M5.13498 18.5771L10.935 20.6242C11.3297 20.7635 11.527 20.8331 11.7294 20.8608C11.909 20.8853 12.091 20.8853 12.2706 20.8608C12.473 20.8331 12.6703 20.7635 13.065 20.6242L18.865 18.5771C19.6337 18.3058 20.018 18.1702 20.3018 17.9269C20.5523 17.7121 20.7459 17.4386 20.8651 17.1308C21 16.7823 21 16.3747 21 15.5595V8.44058C21 7.62542 21 7.21785 20.8651 6.86935C20.7459 6.56155 20.5523 6.28804 20.3018 6.0732C20.018 5.82996 19.6337 5.69431 18.865 5.42301L13.065 3.37595C12.6703 3.23665 12.473 3.167 12.2706 3.13936C12.091 3.11484 11.909 3.11484 11.7294 3.13936C11.527 3.167 11.3297 3.23665 10.935 3.37595L5.13498 5.42301C4.36629 5.69431 3.98195 5.82996 3.69824 6.0732C3.44766 6.28804 3.25414 6.56155 3.13495 6.86935C3 7.21785 3 7.62542 3 8.44058V15.5595C3 16.3747 3 16.7823 3.13495 17.1308C3.25414 17.4386 3.44766 17.7121 3.69824 17.9269C3.98195 18.1702 4.36629 18.3058 5.13498 18.5771Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
            droppable: false,
            resizable: false,
            script: launch3dAnimation,
            content: `<div style = "padding:10px 0;" data-gjs-type="calendly-admin">
      <div class= "gpd-calendly-admin-btn gpd-calendly-admin-btn-st" data-gjs-type="calendly-admin-btn">Open 3D Simulation</div>
    </div>`,
            attributes: {
              style: "font-family: Helvetica",
            },
            //url: `http://localhost:9080/js/3D/urdf/`,
            url: `${window.location.origin.split(":3000")[0]}:9080/js/3D/urdf/`,
            "script-props": ["url"],
          },
        },
      });

      // editor.DomComponents.addType("mobile-nav-new", {
      //   model: {
      //     defaults: {
      //       name: "mobile-nav-new",
      //       icon: '',
      //       script: launchMobileNav,
      //       editable: true,
      //       contenteditable:true,
      //       attributes:{'contenteditable':'true'},
      //   //     content: ` <style>
      //   //     .example-content {
      //   //         display: flex;
      //   //         align-items: center;
      //   //         justify-content: center;
      //   //         height: 100%;
      //   //     }
      //   // </style>`,
      //       content: `
      //       <ion-tabs class="tab-container">
      //       <ion-tab tab="home">
      //       <ion-nav id="home-nav">
      //           <div class="example-content" contenteditable="true">Listen now content</div>
      //       </ion-nav>
      //       <div id="home-page">
      //         <ion-header style="padding: 0.5em;">
      //           <ion-toolbar>
      //             <ion-title contenteditable="true">Listen now</ion-title>
      //           </ion-toolbar>
      //         </ion-header>
      //       </div>
      //   </ion-tab>

      //   <ion-tab tab="radio">
      //       <ion-nav id="radio-nav">
      //           <div class="example-content" contenteditable="true">Radio content</div>
      //       </ion-nav>
      //       <div id="radio-page">
      //         <ion-header style="padding: 0.5em;">
      //           <ion-toolbar>
      //             <ion-title contenteditable="true">Radio</ion-title>
      //           </ion-toolbar>
      //         </ion-header>
      //       </div>
      //   </ion-tab>

      //   <ion-tab tab="library">
      //       <ion-nav id="library-nav">
      //           <div class="example-content" contenteditable="true">Library content</div>
      //       </ion-nav>
      //       <div id="library-page">
      //         <ion-header style="padding: 0.5em;">
      //           <ion-toolbar>
      //             <ion-title contenteditable="true">Library</ion-title>
      //           </ion-toolbar>
      //         </ion-header>
      //       </div>
      //   </ion-tab>

      //   <ion-tab tab="search">
      //       <ion-nav id="search-nav">
      //           <div class="example-content" contenteditable="true"><p>Search content</p></div>
      //       </ion-nav>
      //       <div id="search-page">
      //         <ion-header style="padding: 0.5em;">
      //           <ion-toolbar>
      //             <ion-title contenteditable="true"><p>Search</p></ion-title>
      //           </ion-toolbar>
      //         </ion-header>
      //       </div>
      //   </ion-tab>

      //   <ion-tab-bar slot="bottom">
      //       <ion-tab-button tab="home">
      //           <p style="margin: 0; display: flex; flex-direction: column; align-items: center;" contenteditable="true">
      //             <ion-icon name="play-circle"></ion-icon>
      //             Listen Now
      //           </p>
      //       </ion-tab-button>
      //       <ion-tab-button tab="radio">
      //           <p style="margin: 0; display: flex; flex-direction: column; align-items: center;" contenteditable="true">
      //             <ion-icon name="radio"></ion-icon>
      //             Radio
      //           </p>
      //       </ion-tab-button>
      //       <ion-tab-button tab="library">
      //           <p style="margin: 0; display: flex; flex-direction: column; align-items: center;" contenteditable="true">
      //             <ion-icon name="library"></ion-icon>
      //             Library
      //           </p>
      //       </ion-tab-button>
      //       <ion-tab-button tab="search">
      //           <p style="margin: 0; display: flex; flex-direction: column; align-items: center;" contenteditable="true">
      //             <ion-icon name="search"></ion-icon>
      //             Search
      //           </p>
      //       </ion-tab-button>
      //   </ion-tab-bar>
      //   </ion-tabs>
      //   <style>
      //       .example-content {
      //           display: flex;
      //           align-items: center;
      //           justify-content: center;
      //           height: 100%;
      //       }
      //   </style>
      //       `,
      //   // components: [
      //   //   {
      //   //     type: "ion-tabs",
      //   //     classes: ["tab-container"],
      //   //     components: [
      //   //       {
      //   //         type: "ion-tab",
      //   //         tab: "home",
      //   //         components: [
      //   //           {
      //   //             type: "ion-nav",
      //   //             id: "home-nav",
      //   //             components: [
      //   //               {
      //   //                 type: "div",
      //   //                 classes: ["example-content"],
      //   //                 content: "Listen now content",
      //   //               },
      //   //             ],
      //   //           },
      //   //           {
      //   //             type: "div",
      //   //             id: "home-page",
      //   //             components: [
      //   //               {
      //   //                 type: "ion-header",
      //   //                 style: "padding: 0.5em;",
      //   //                 components: [
      //   //                   {
      //   //                     type: "ion-toolbar",
      //   //                     components: [
      //   //                       {
      //   //                         type: "ion-title",
      //   //                         content: "Listen now",
      //   //                       },
      //   //                     ],
      //   //                   },
      //   //                 ],
      //   //               },
      //   //             ],
      //   //           },
      //   //         ],
      //   //       },
      //   //       {
      //   //         type: "ion-tab",
      //   //         tab: "radio",
      //   //         components: [
      //   //           {
      //   //             type: "ion-nav",
      //   //             id: "radio-nav",
      //   //             components: [
      //   //               {
      //   //                 type: "div",
      //   //                 classes: ["example-content"],
      //   //                 content: "Radio content",
      //   //               },
      //   //             ],
      //   //           },
      //   //           {
      //   //             type: "div",
      //   //             id: "radio-page",
      //   //             components: [
      //   //               {
      //   //                 type: "ion-header",
      //   //                 style: "padding: 0.5em;",
      //   //                 components: [
      //   //                   {
      //   //                     type: "ion-toolbar",
      //   //                     components: [
      //   //                       {
      //   //                         type: "ion-title",
      //   //                         content: "Radio",
      //   //                       },
      //   //                     ],
      //   //                   },
      //   //                 ],
      //   //               },
      //   //             ],
      //   //           },
      //   //         ],
      //   //       },
      //   //       {
      //   //         type: "ion-tab",
      //   //         tab: "library",
      //   //         components: [
      //   //           {
      //   //             type: "ion-nav",
      //   //             id: "library-nav",
      //   //             components: [
      //   //               {
      //   //                 type: "div",
      //   //                 classes: ["example-content"],
      //   //                 content: "Library content",
      //   //               },
      //   //             ],
      //   //           },
      //   //           {
      //   //             type: "div",
      //   //             id: "library-page",
      //   //             components: [
      //   //               {
      //   //                 type: "ion-header",
      //   //                 style: "padding: 0.5em;",
      //   //                 components: [
      //   //                   {
      //   //                     type: "ion-toolbar",
      //   //                     components: [
      //   //                       {
      //   //                         type: "ion-title",
      //   //                         content: "Library",
      //   //                       },
      //   //                     ],
      //   //                   },
      //   //                 ],
      //   //               },
      //   //             ],
      //   //           },
      //   //         ],
      //   //       },
      //   //       {
      //   //         type: "ion-tab",
      //   //         tab: "search",
      //   //         components: [
      //   //           {
      //   //             type: "ion-nav",
      //   //             id: "search-nav",
      //   //             components: [
      //   //               {
      //   //                 type: "div",
      //   //                 classes: ["example-content"],
      //   //                 content: "Search content",
      //   //               },
      //   //             ],
      //   //           },
      //   //           {
      //   //             type: "div",
      //   //             id: "search-page",
      //   //             components: [
      //   //               {
      //   //                 type: "ion-header",
      //   //                 style: "padding: 0.5em;",
      //   //                 components: [
      //   //                   {
      //   //                     type: "ion-toolbar",
      //   //                     components: [
      //   //                       {
      //   //                         type: "ion-title",
      //   //                         content: "Search",
      //   //                       },
      //   //                     ],
      //   //                   },
      //   //                 ],
      //   //               },
      //   //             ],
      //   //           },
      //   //         ],
      //   //       },
      //   //       {
      //   //         type: "ion-tab-bar",
      //   //         slot: "bottom",
      //   //         components: [
      //   //           {
      //   //             type: "ion-tab-button",
      //   //             components: [
      //   //               {
      //   //                 type: "p",
      //   //                 style: "margin: 0; display: flex; flex-direction: column; align-items: center;",
      //   //                 components: [
      //   //                   {
      //   //                     type: "ion-icon",
      //   //                     name: "play-circle",
      //   //                   },
      //   //                   {
      //   //                     type: "span",
      //   //                     text: "Listen Now",
      //   //                   },
      //   //                 ],
      //   //               },
      //   //             ],
      //   //           },
      //   //           {
      //   //             type: "ion-tab-button",
      //   //             components: [
      //   //               {
      //   //                 type: "p",
      //   //                 style: "margin: 0; display: flex; flex-direction: column; align-items: center;",
      //   //                 components: [
      //   //                   {
      //   //                     type: "ion-icon",
      //   //                     name: "radio",
      //   //                   },
      //   //                   {
      //   //                     type: "span",
      //   //                     text: "Radio",
      //   //                   },
      //   //                 ],
      //   //               },
      //   //             ],
      //   //           },
      //   //           {
      //   //             type: "ion-tab-button",
      //   //             components: [
      //   //               {
      //   //                 type: "p",
      //   //                 style: "margin: 0; display: flex; flex-direction: column; align-items: center;",
      //   //                 components: [
      //   //                   {
      //   //                     type: "ion-icon",
      //   //                     name: "library",
      //   //                   },
      //   //                   {
      //   //                     type: "span",
      //   //                     text: "Library",
      //   //                   },
      //   //                 ],
      //   //               },
      //   //             ],
      //   //           },
      //   //           {
      //   //             type: "ion-tab-button",
      //   //             components: [
      //   //               {
      //   //                 type: "p",
      //   //                 style: "margin: 0; display: flex; flex-direction: column; align-items: center;",
      //   //                 components: [
      //   //                   {
      //   //                     type: "ion-icon",
      //   //                     name: "search",
      //   //                   },
      //   //                   {
      //   //                     type: "span",
      //   //                     text: "Search",
      //   //                   },
      //   //                 ],
      //   //               },
      //   //             ],
      //   //           },
      //   //         ],

      //   //       }
      //   //       // Add similar components for other tabs here
      //   //     ],
      //   //   },
      //   //   // {
      //   //   //   type: "style",
      //   //   //   content: `
      //   //   //     .example-content {
      //   //   //         display: flex;
      //   //   //         align-items: center;
      //   //   //         justify-content: center;
      //   //   //         height: 100%;
      //   //   //     }
      //   //   //   `,
      //   //   // },
      //   // ],
      //     },
      //   },
      // });

      //       .tab-button {
      //           flex-grow: 1;
      //           text-align: center;
      //           color: white;
      //           padding: 15px 0;
      //           cursor: pointer;
      //           font-size: 16px;
      //           transition: background-color 0.3s ease-in-out;
      //       }

      //       .tab-button.active {
      //           background-color: #4CAF50;
      //       }

      //       .content {
      //           padding: 20px;
      //       }

      //       .example-content {
      //           display: flex;
      //           align-items: center;
      //           justify-content: center;
      //           height: 300px;
      //           background-color: #f0f0f0;
      //           display: none;
      //       }

      //       .active-content {
      //           display: block;
      //       }

      // </style>`,

      //           },
      //         },
      //       });

      // editor.DomComponents.addType("korebot-client", {
      //   model: {
      //     defaults: {
      //       name: "korebot-client",
      //       icon: '<svg viewBox="0 0 24 24"><path d="M14 14H7v2h7m5 3H5V8h14m0-5h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-2 7H7v2h10v-2z"></path></svg>',
      //       droppable: false,
      //       resizable: false,
      //       //script: koreChatScript,
      //       content: `
      //       <div>

      //       </div>
      //       `,
      //       view: {
      //         onRender() {
      //           (function ($) {
      //             $(document).ready(function () {
      //               let koreBot;
      //               let chatConfig = {};
      //               function assertion(options, callback) {
      //                 var jsonData = {
      //                   clientId: options.clientId,
      //                   clientSecret: options.clientSecret,
      //                   identity: options.userIdentity,
      //                   aud: "",
      //                   isAnonymous: false,
      //                 };
      //                 $.ajax({
      //                   url: options.JWTUrl,
      //                   type: "post",
      //                   data: jsonData,
      //                   dataType: "json",
      //                   success: function (data) {
      //                     options.assertion = data.jwt;
      //                     options.handleError = koreBot.showError;
      //                     options.chatHistory = koreBot.chatHistory;
      //                     options.botDetails = koreBot.botDetails;
      //                     callback(null, options);
      //                     setTimeout(function () {
      //                       if (koreBot && koreBot.initToken) {
      //                         koreBot.initToken(options);
      //                       }
      //                     }, 2000);
      //                   },
      //                   error: function (err) {
      //                     koreBot.showError(err.responseText);
      //                   },
      //                 });
      //               }
      //               function getBrandingInformation(options) {
      //                 if (
      //                   chatConfig.botOptions &&
      //                   chatConfig.botOptions.enableThemes
      //                 ) {
      //                   var brandingAPIUrl = (
      //                     chatConfig.botOptions.brandingAPIUrl || ""
      //                   ).replace(":appId", chatConfig.botOptions.botInfo._id);
      //                   $.ajax({
      //                     url: brandingAPIUrl,
      //                     headers: {
      //                       Authorization:
      //                         "bearer " + options.authorization.accessToken,
      //                     },
      //                     type: "get",
      //                     dataType: "json",
      //                     success: function (data) {
      //                       if (koreBot && koreBot.applySDKBranding) {
      //                         koreBot.applySDKBranding(data);
      //                       }
      //                       if (koreBot && koreBot.initToken) {
      //                         koreBot.initToken(options);
      //                       }
      //                     },
      //                     error: function (err) {
      //                       console.log(err);
      //                     },
      //                   });
      //                 }
      //               }
      //               function onJWTGrantSuccess(options) {
      //                 getBrandingInformation(options);
      //               }
      //               async function fetchBotOptions() {
      //                 // Project id needs to be replaced
      //                 const response = await fetch(
      //                   "http://localhost:8085/chatbots/api/chatbots/64e6f9066557ff884a1cc8b2"
      //                 ); // Replace YOUR_API_ENDPOINT with your actual API endpoint
      //                 const apiResult = await response.json();
      //                 let botOptions = {};
      //                 console.log("Api result -- ", apiResult[0]);
      //                 botOptions.apiResult = apiResult;

      //                 botOptions.logLevel = "debug";
      //                 botOptions.koreAPIUrl = "https://bots.kore.ai/api/";
      //                 botOptions.koreSpeechAPIUrl = ""; //deprecated
      //                 //botOptions.bearer = "bearer xyz-------------------";
      //                 //botOptions.ttsSocketUrl = '';//deprecated
      //                 botOptions.koreAnonymousFn = koreAnonymousFn;
      //                 botOptions.recorderWorkerPath =
      //                   "korebotComponents/sdk/libs/recorderWorker.js";
      //                 //botOptions.name = apiResult[0].koreAPIUrlbotInfoName;
      //                 botOptions.JWTUrl = apiResult[0].JWTUrl;
      //                 botOptions.userIdentity = apiResult[0].userIdentity; // Provide users email id here
      //                 botOptions.botInfo = {
      //                   name: apiResult[0].koreAPIUrlbotInfoName,
      //                   _id: apiResult[0].botInfoId,
      //                 }; // bot name is case sensitive

      //                 /*
      //                       Important Note: These keys are provided here for quick demos to generate JWT token at client side but not for Production environment.
      //                       Refer below document for JWT token generation at server side. Client Id and Client secret should maintained at server end.
      //                       https://developer.kore.ai/docs/bots/sdks/user-authorization-and-assertion/
      //                       **/
      //                 botOptions.clientId = apiResult[0].clientId;
      //                 botOptions.clientSecret = apiResult[0].clientSecret;
      //                 botOptions.brandingAPIUrl =
      //                   botOptions.koreAPIUrl +
      //                   "websdkthemes/" +
      //                   botOptions.botInfo._id +
      //                   "/activetheme";
      //                 botOptions.enableThemes = true;
      //                 return botOptions;
      //               }
      //               async function initializeChat() {
      //                 const botOptions = await fetchBotOptions();
      //                 botOptions.logLevel = "debug";
      //                 botOptions.koreAPIUrl = "https://bots.kore.ai/api/";
      //                 botOptions.koreSpeechAPIUrl = "";
      //                 botOptions.recorderWorkerPath =
      //                   "../libs/recorderWorker.js";
      //                 botOptions.enableThemes = true;

      //                 chatConfig = {
      //                   botOptions: botOptions,
      //                   allowIframe: false, // set true, opens authentication links in popup window, default value is "false"
      //                   isSendButton: false, // set true, to show send button below the compose bar
      //                   isTTSEnabled: true, // set true, to hide speaker icon
      //                   ttsInterface: "webapi", // webapi or awspolly , where default is webapi
      //                   isSpeechEnabled: true, // set true, to hide mic icon
      //                   stt: {
      //                     vendor: "webapi", //'webapi'|'azure'|'google' //uses respective settings from the following keys and uncomments respective files in index.html
      //                     azure: {
      //                       subscriptionKey: "",
      //                       recognitionLanguage: "en-US",
      //                       recognitionMode: "Interactive", //Interactive/Dictation/Conversation/Interactive
      //                     },
      //                     google: {
      //                       apiKey: "",
      //                       recognitionLanguage: "en-US",
      //                     },
      //                     webapi: {
      //                       recognitionLanguage: "en-US",
      //                     },
      //                   },
      //                   allowLocation: true, // set false, to deny sending location to server
      //                   loadHistory: true, // set true to load recent chat history
      //                   messageHistoryLimit: 10, // set limit to load recent chat history
      //                   autoEnableSpeechAndTTS: false, // set true, to use talkType voice keyboard.
      //                   graphLib: "d3", // set google, to render google charts.This feature requires loader.js file which is available in google charts documentation.
      //                   googleMapsAPIKey: "",
      //                   minimizeMode: true, // set true, to show chatwindow in minimized mode, If false is set remove #chatContainer style in chatwindow.css
      //                   multiPageApp: {
      //                     enable: false, //set true for non SPA(Single page applications)
      //                     userIdentityStore: "localStorage", //'localStorage || sessionStorage'
      //                     chatWindowStateStore: "localStorage", //'localStorage || sessionStorage'
      //                   },
      //                   supportDelayedMessages: true, // enable to add support for renderDelay in message nodes which will help to render messages with delay from UI
      //                   maxTypingIndicatorTime: 10000, //time in milliseconds,typing indicator will be stopped after this time limit,even bot doesn't respond
      //                   pickersConfig: {
      //                     showDatePickerIcon: false, //set true to show datePicker icon
      //                     showDateRangePickerIcon: false, //set true to show dateRangePicker icon
      //                     showClockPickerIcon: false, //set true to show clockPicker icon
      //                     showTaskMenuPickerIcon: false, //set true to show TaskMenu Template icon
      //                     showradioOptionMenuPickerIcon: false, //set true to show Radio Option Template icon
      //                   },
      //                   sendFailedMessage: {
      //                     MAX_RETRIES: 3,
      //                   },
      //                 };

      //                 botOptions.assertionFn = assertion;
      //                 botOptions.jwtgrantSuccessCB = onJWTGrantSuccess;

      //                 koreBot = koreBotChat();
      //                 koreBot.show(chatConfig);

      //                 $(".openChatWindow").click(function () {
      //                   koreBot.show(chatConfig);
      //                 });
      //               }
      //               initializeChat();
      //             });
      //           })(
      //             jQuery ||
      //               (window.KoreSDK &&
      //                 window.KoreSDK.dependencies &&
      //                 window.KoreSDK.dependencies.jQuery)
      //           );
      //         },
      //       },
      //     },
      //   },
      // });

      editor.DomComponents.addType("calendy", {
        model: {
          defaults: {
            name: "calendly",
            icon: '<svg viewBox="0 0 24 24"><path d="M14 14H7v2h7m5 3H5V8h14m0-5h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-2 7H7v2h10v-2z"></path></svg>',
            droppable: false,
            resizable: false,
            script: calendyScript,
            content: `<div style = "padding:10px 0;" data-gjs-type="calendly">
      <div class= "gpd-calendly-btn gpd-calendly-btn-st" data-gjs-type="calendly-btn">Schedule Now!</div>
    </div>`,
            attributes: {
              style: "font-family: Helvetica",
            },
            url: "https://calendly.com/redslingtest",
            widgettype: "popup",
            badgetext: "Schedule time with me",
            bgcolor: "#ffffff",
            textcolor: "#4d5055",
            buttonlink: "#00a2ff",
            branding: true,
            hidedetail: false,
            traits: [
              {
                name: "url",
                label: "Calendly URL",
                placeholder: "",
                default: "",
                changeProp: true,
              },
              {
                name: "widgettype",
                label: "Type",
                type: "select",
                options: [
                  { value: "inline" },
                  { value: "popup" },
                  { value: "popup-text" },
                ],
                default: "popup",
                changeProp: true,
              },
              {
                name: "badgetext",
                label: "Badge Text",
                placeholder: "Schedule time with me",
                default: "Schedule time with me",
                changeProp: true,
              },
              {
                name: "branding",
                label: "Badge Branding",
                type: "checkbox",
                changeProp: false,
              },
              {
                name: "bgcolor",
                label: "Color background",
                type: "color",
                default: "#ffffff",
                changeProp: true,
              },
              {
                name: "textcolor",
                label: "Color text",
                type: "color",
                default: "#4d5055",
                changeProp: true,
              },
              {
                name: "buttonlink",
                label: "Button & Links",
                type: "color",
                default: "#00a2ff",
                changeProp: true,
              },
              {
                name: "hidedetail",
                label: "Hide Details",
                type: "checkbox",
                changeProp: true,
              },
            ],
            "script-props": [
              "url",
              "widgettype",
              "badgetext",
              "bgcolor",
              "textcolor",
              "buttonlink",
              "hidedetail",
              "branding",
            ],
          },
        },
      });

      editor.DomComponents.addType("calendly-btn", {
        model: {
          defaults: {
            name: "calendly",
            icons: '<i className="fa fa-link"></i>',
            droppable: false,
            highlightable: false,
            resizable: false,
            removable: false,
            copyable: false,
          },
        },
        extend: "link",
        isComponent(el) {
          if (el.tagName === "calendly-btn") return { type: "calendly-btn" };
        },
      });

      editor.DomComponents.addType("stellar-button-old", {
        model: {
          defaults: {
            tagName: "button",
            attributes: { class: "stellar-btn" },
            editable: true,

            // EXPLANATION - why do we need to define css in both 'style-default' and style keys along with the same css in geditor_utils.js file?

            // using 'style-default', we make it so it doesn't delete other componenets' css when this button is deleted but if there is no other component already present

            // in the canvas and this is the first to be dropped then its css won't initialize with it and that's why we define css in 'style' key also.

            // But if we define css only in 'style' key then the user won't be able to customize this component even from the styles manager and if we define css

            // using 'styles' key then if the user deletes this component then other components will lose their css also thats why both 'style-default' and 'style' key are needed for the css definition.

            "style-default": {
              width: "max-content",

              padding: "0.5em",

              "border-radius": "10px",

              "background-color": "blue",

              border: "none",

              color: "white",

              cursor: "pointer",
            },

            style: {
              width: "max-content",

              padding: "0.5em",

              "border-radius": "10px",

              "background-color": "blue",

              border: "none",

              color: "white",

              cursor: "pointer",
            },

            components: {
              tagName: "p",

              type: "text",

              editable: true,

              components: {
                type: "textnode",

                content: "Click",
              },

              "style-default": {
                margin: "auto",

                "text-align": "center",
              },

              style: {
                margin: "auto",

                "text-align": "center",
              },
            },

            // styles: `

            //     .stellar-btn {

            //         width: max-content;

            //         padding: 0.5em;

            //         border-radius: 10px;

            //         background-color: blue;

            //         border: none;

            //         color: white;

            //         cursor: pointer;

            //     }

            //     .stellar-btn > p {

            //         margin: auto;

            //         text-align: center;

            //     }

            // `,

            // traits

            Navigate: "",
            InternalTarget: "",
            ExternalTarget: "",

            // Independent Button API traits
            API_URL: "",
            Method: "",
            Body: "",
            Content_Type: "",
            Username: "",
            Password: "",
            API_Key: "",
            Response_Status_200: "",
            Response_Status_201: "",
            Response_Status_204: "",
            Response_Status_400: "",
            Response_Status_404: "",
            Response_Status_500: "",

            // Within Form API traits
            Form_API_URL: "",
            Form_Method: "",
            Form_Content_Type: "",

            traits: [
              // {

              //     type: 'text',

              //     name: 'Button_label',

              //     label: 'Button label',

              //     changeProp: true,

              // },

              {
                type: "select",
                name: "Navigate",
                label: "Navigate",
                changeProp: true,
                options: [
                  { id: "true", value: true, name: "True" },
                  { id: "false", value: false, name: "False" },
                ],
              },
              {
                type: "select",
                name: "InternalTarget",
                label: "Internal Target",
                changeProp: true,
                options: pageByProjectData
                  ? pageByProjectData?.map((x) => {
                      const arr = {
                        value: x._id,
                        name: x.name,
                      };
                      return arr;
                    })
                  : "",
              },
              {
                type: "url",
                name: "ExternalTarget",
                label: "External Target",
                changeProp: true,
              },
              {
                type: "url",
                name: "API_URL",
                label: "API URL",
                changeProp: true,
              },
              {
                type: "select",
                name: "Method",
                label: "Method",
                changeProp: true,
                options: [
                  { id: "GET", name: "GET" },
                  { id: "POST", name: "POST" },
                ],
              },
              {
                type: "text",
                name: "Body",
                label: "Body",
                changeProp: true,
              },
              {
                type: "select",
                name: "Content_Type",
                label: "Content-Type",
                changeProp: true,
                options: [
                  {
                    id: "application/java-archive",
                    name: "application/java-archive",
                  },
                  { id: "application/json", name: "application/json" },
                  { id: "application/xml", name: "application/xml" },
                  { id: "application/xml", name: "application/xml" },
                  { id: "text/css", name: "text/css" },
                  { id: "text/csv", name: "text/csv" },
                  { id: "text/html", name: "text/html" },
                  { id: "text/plain", name: "text/plain" },
                ],
              },
              {
                type: "text",
                name: "Username",
                label: "Username",
                changeProp: true,
              },
              {
                type: "text",
                name: "Password",
                label: "Password",
                changeProp: true,
              },
              {
                type: "text",
                name: "API_Key",
                label: "API Key",
                changeProp: true,
              },
              {
                type: "select",
                name: "Response_Status_200",
                label: "Response Status 200 Target",
                changeProp: true,
                options: pageByProjectData
                  ? pageByProjectData?.map((x) => {
                      const arr = {
                        value: x._id,
                        name: x.name,
                      };
                      return arr;
                    })
                  : "",
              },
              {
                type: "select",
                name: "Response_Status_201",
                label: "Response Status 201 Target",
                changeProp: true,
                options: pageByProjectData
                  ? pageByProjectData?.map((x) => {
                      const arr = {
                        value: x._id,
                        name: x.name,
                      };
                      return arr;
                    })
                  : "",
              },
              {
                type: "select",
                name: "Response_Status_204",
                label: "Response Status 204 Target",
                changeProp: true,
                options: pageByProjectData
                  ? pageByProjectData?.map((x) => {
                      const arr = {
                        value: x._id,
                        name: x.name,
                      };
                      return arr;
                    })
                  : "",
              },
              {
                type: "select",
                name: "Response_Status_400",
                label: "Response Status 400 Target",
                changeProp: true,
                options: pageByProjectData
                  ? pageByProjectData?.map((x) => {
                      const arr = {
                        value: x._id,
                        name: x.name,
                      };
                      return arr;
                    })
                  : "",
              },
              {
                type: "select",
                name: "Response_Status_404",
                label: "Response Status 404 Target",
                changeProp: true,
                options: pageByProjectData
                  ? pageByProjectData?.map((x) => {
                      const arr = {
                        value: x._id,
                        name: x.name,
                      };
                      return arr;
                    })
                  : "",
              },
              {
                type: "select",
                name: "Response_Status_500",
                label: "Response Status 500 Target",
                changeProp: true,
                options: pageByProjectData
                  ? pageByProjectData?.map((x) => {
                      const arr = {
                        value: x._id,
                        name: x.name,
                      };
                      return arr;
                    })
                  : "",
              },
              {
                type: "url",
                name: "Form_API_URL",
                label: "Form API URL",
                changeProp: true,
              },
              {
                type: "select",
                name: "Form_Method",
                label: "Form Method",
                changeProp: true,
                options: [
                  { id: "GET", name: "GET" },
                  { id: "POST", name: "POST" },
                ],
              },
              {
                type: "select",
                name: "Form_Content_Type",
                label: "Form Content-Type",
                changeProp: true,
                options: [
                  {
                    id: "application/java-archive",
                    name: "application/java-archive",
                  },
                  { id: "application/json", name: "application/json" },
                  { id: "application/xml", name: "application/xml" },
                  { id: "application/xml", name: "application/xml" },
                  { id: "text/css", name: "text/css" },
                  { id: "text/csv", name: "text/csv" },
                  { id: "text/html", name: "text/html" },
                  { id: "text/plain", name: "text/plain" },
                ],
              },
            ],

            changeProp: true,
            "script-props": [
              "Navigate",
              "InternalTarget",
              "ExternalTarget",
              "API_URL",
              "Method",
              "Body",
              "Content_Type",
              "Username",
              "Password",
              "API_Key",
              "Response_Status_200",
              "Response_Status_201",
              "Response_Status_204",
              "Response_Status_400",
              "Response_Status_404",
              "Response_Status_500",
              "Form_API_URL",
              "Form_Method",
              "Form_Content_Type",
            ],
          },

          init() {
            // this.on('change:Navigate', this.handlePropChange);
            // this.on('change:InternalTarget', this.handlePropChange);
            // this.on('change:ExternalTarget', this.handlePropChange);
            // this.on('change:API_URL', this.handlePropChange);
            // this.on('change:Method', this.handlePropChange);
            // this.on('change:Body', this.handlePropChange);
            // this.on('change:Content_Type', this.handlePropChange);
            // this.on('change:Username', this.handlePropChange);
            // this.on('change:Password', this.handlePropChange);
            // this.on('change:API_Key', this.handlePropChange);
            // this.on('change:Response_Status_200', this.handlePropChange);
            // this.on('change:Response_Status_201', this.handlePropChange);
            // this.on('change:Response_Status_204', this.handlePropChange);
            // this.on('change:Response_Status_400', this.handlePropChange);
            // this.on('change:Response_Status_404', this.handlePropChange);
            // this.on('change:Response_Status_500', this.handlePropChange);
            // this.on('change:Form_API_URL', this.handlePropChange);
            // this.on('change:Form_Method', this.handlePropChange);
            // this.on('change:Form_Content_Type', this.handlePropChange);
            // console.log('this', this);
            // if (this.attributes.tagName === 'div' && this.attributes.type === 'stellar-button') {
            //   this.setAttributes({tagName: "button"});
            // }
            // console.log('this', this);
          },

          // async handlePropChange() {
          //   const { Navigate, InternalTarget, ExternalTarget, API_URL, Method, Body, Content_Type, Username, Password, API_Key, Response_Status_200, Response_Status_201, Response_Status_204, Response_Status_400, Response_Status_404, Response_Status_500, Form_API_URL, Form_Method, Form_Content_Type } = this.props();
          //   let project_id = window.location.search.split("=")[1];
          //   let parentComponent = this.model.parent();

          //   console.log('this, project_id, parentComponent, Navigate, InternalTarget, ExternalTarget, API_URL, Method, Body, Content_Type, Username, Password, API_Key, Response_Status_200, Response_Status_201, Response_Status_204, Response_Status_400, Response_Status_404, Response_Status_500, Form_API_URL, Form_Method, Form_Content_Type', this, this.getEl(), project_id, parentComponent, Navigate, InternalTarget, ExternalTarget, API_URL, Method, Body, Content_Type, Username, Password, API_Key, Response_Status_200, Response_Status_201, Response_Status_204, Response_Status_400, Response_Status_404, Response_Status_500, Form_API_URL, Form_Method, Form_Content_Type);

          //   if (Navigate && InternalTarget && !ExternalTarget) {
          //     this.getEl().addEventListener('click', function(event) {
          //       console.log("InternalTarget", InternalTarget);

          //       const origin = window.location.origin;
          //       window.location.href = origin + `/editor/` + `${InternalTarget}` + "?projectId=" + `${project_id}`;
          //     });
          //   } else if (Navigate && ExternalTarget && !InternalTarget) {
          //     this.getEl().addEventListener('click', function(event) {
          //       console.log("ExternalTarget", ExternalTarget);

          //       let origin = "https://";
          //       let modifiedUrl = ExternalTarget.includes("http://") || ExternalTarget.includes("https://") ? ExternalTarget : origin + `${ExternalTarget}`;
          //       console.log("modifiedUrl:", modifiedUrl);
          //       let win = window.open(modifiedUrl, "_blank");
          //       win.focus();
          //     });
          //   }

          //   if (parentComponent.attributes.tagName !== "form") {
          //     console.log("this button is NOT inside a FORM; using API traits" );

          //     // GET API call
          //     if (Method === "GET") {
          //       console.log("stellar-button GET request");

          //       // if there is no api key, username or password
          //       if (Username === "" && Password === "" && API_Key === "") {
          //         console.log("No username, password & api key for stellar button POST request" );

          //         // making the fetch API GET request
          //         fetch(`${API_URL}`, {
          //           method: method,
          //           // headers: config,
          //         })
          //         .then((response) => response.json())
          //         .then((data) => {
          //           // can display the data here in a table format
          //           if (Response_Status_200) {
          //             this.getEl().addEventListener('click', function(event) {
          //               const origin = window.location.origin;
          //               window.location.href = origin + `/editor/` + `${Response_Status_200}` + "?projectId=" + `${project_id}`;
          //             });
          //           }
          //           console.log("stellar-button GET request Data:", data);
          //           toast.info("Data is received successfully in the console.", successTheme );
          //         })
          //         .catch((error) => {
          //           console.log("stellar-button GET request error:", error);
          //         });
          //       }

          //       // if there is an api key, but no username or password
          //       else if (API_Key !== "") {
          //         console.log("Api key provided for stellar button GET request" );

          //         // making the fetch API GET request
          //         fetch(`${API_URL}`, {
          //           method: Method,
          //           headers: {
          //             "Content-Type": `${Content_Type}`,
          //             Authorization: `Bearer ${API_Key}`,
          //           },
          //         })
          //         .then((response) => response.json())
          //         .then((data) => {
          //           // can display the data here in a table format
          //           if (Response_Status_200) {
          //             this.getEl().addEventListener('click', function(event) {
          //               const origin = window.location.origin;
          //               window.location.href = origin + `/editor/` + `${Response_Status_200}` + "?projectId=" + `${project_id}`;
          //             });
          //           }
          //           console.log("stellar-button GET request Data:", data);
          //           toast.info("Data is received successfully in the console.", successTheme );
          //         })
          //         .catch((error) => {
          //           console.log("stellar-button GET request error:", error);
          //         });
          //       }

          //       // if there is no api key, but username or password or token
          //       if (Username !== "" && Password !== "") {
          //         console.log(
          //           "Username & Password provided for stellar button GET request"
          //         );

          //         // creating a token using this method from creatorFunctions.js file

          //         let token = authenticateUser(Username, Password);

          //         console.log("stellar-button GET request token:", token);

          //         // making the fetch API GET request
          //         fetch(`${API_URL}`, {
          //           method: Method,

          //           headers: {
          //             "Content-Type": `${Content_Type}`,
          //             Authorization: `${token}`,
          //           },
          //         })
          //         .then((response) => response.json())
          //         .then((data) => {
          //           // can display the data here in a table format
          //           if (Response_Status_200) {
          //             this.getEl().addEventListener('click', function(event) {
          //               const origin = window.location.origin;
          //               window.location.href = origin + `/editor/` + `${Response_Status_200}` + "?projectId=" + `${project_id}`;
          //             });
          //           }
          //           console.log("stellar-button GET request Data:", data);

          //           toast.info("Data is received successfully in the console.", successTheme );
          //         })
          //         .catch((error) => {
          //           console.log("stellar-button GET request error:", error);
          //         });
          //       }
          //     }

          //     // POST API call
          //     else if (Method === "POST") {
          //       console.log("stellar-button POST request");

          //       // if there is no api key, username or password
          //       if (Username === "" && Password === "" && API_Key === "") {
          //         console.log("No username, password & api key for stellar button POST request" );

          //         // making the fetch API POST request
          //         fetch(`${API_URL}`, {
          //           method: Method,
          //           headers: {
          //             "Content-Type": `${Content_Type}`,
          //           },
          //           body: Body,
          //         })
          //         .then((response) => response.json())
          //         .then((data) => {
          //           if (Response_Status_200) {
          //             this.getEl().addEventListener('click', function(event) {
          //               const origin = window.location.origin;
          //               window.location.href = origin + `/editor/` + `${Response_Status_200}` + "?projectId=" + `${project_id}`;
          //             });
          //           }
          //           // can display the data here in a table format
          //           console.log("stellar-button POST request Data:", data);

          //           toast.info("Data is received successfully in the console.", successTheme );
          //         })
          //         .catch((error) => {
          //           console.log("stellar-button POST request error:", error );
          //         });
          //       }

          //       // if there is an api key, but no username or password
          //       else if (API_Key !== "") {
          //         console.log("Api key provided for stellar button POST request" );

          //         // making the fetch API POST request
          //         fetch(`${API_URL}`, {
          //           method: Method,
          //           headers: {
          //             "Content-Type": `${Content_Type}`,
          //             Authorization: `Bearer ${API_Key}`,
          //           },
          //           body: Body,
          //         })
          //         .then((response) => response.json())
          //         .then((data) => {
          //           // can display the data here in a table format

          //           console.log("stellar-button POST request Data:", data);
          //           if (Response_Status_200) {
          //             this.getEl().addEventListener('click', function(event) {
          //               const origin = window.location.origin;
          //               window.location.href = origin + `/editor/` + `${Response_Status_200}` + "?projectId=" + `${project_id}`;
          //             });
          //           }

          //           toast.info("Data is received successfully in the console.", successTheme );
          //         })
          //         .catch((error) => {
          //           console.log("stellar-button POST request error:", error );
          //         });
          //       }

          //       // if there is no api key, but username or password or token
          //       else if (Username !== "" && Password !== "") {
          //         console.log("Username & Password provided for stellar button POST request" );

          //         // creating a token using this method from creatorFunctions.js file
          //         let token = authenticateUser(Username, Password);

          //         console.log("stellar-button POST request token:", token);

          //         // making the fetch API POST request
          //         fetch(`${API_URL}`, {
          //           method: Method,
          //           headers: {
          //             "Content-Type": `${Content_Type}`,
          //             Authorization: `${token}`,
          //           },
          //           body: Body,
          //         })
          //         .then((response) => response.json())
          //         .then((data) => {
          //           if (Response_Status_200) {
          //             this.getEl().addEventListener('click', function(event) {
          //               const origin = window.location.origin;
          //               window.location.href = origin + `/editor/` + `${Response_Status_200}` + "?projectId=" + `${project_id}`;
          //             });
          //           }
          //           // can display the data here in a table format

          //           console.log("stellar-button POST request Data:", data);

          //           toast.info("Data is received successfully in the console.", successTheme );
          //         })
          //         .catch((error) => {
          //           console.log("stellar-button POST request error:", error );
          //         });
          //       }
          //     }
          //   }

          //   // if the parent component of this button is a form, then use the data from the form
          //   if (parentComponent.attributes.tagName === "form") {
          //     // the form should have only 1 username and password field
          //     // find all the inputs in the form container and see their field types and do something based on them
          //     parentComponent.find("input").forEach((child) => {
          //         // if (child.attributes.tagName === 'input') {

          //         console.log("child:", child, "\ninput value:", child.view.el.value );

          //         // CONFIGURED only for inputs-types: email, text, text-node, password
          //         // checking if element is email or username or password and then extracting their value and trait Name

          //         if (child.attributes.attributes.type === "email") {
          //           formEmail = child.view.el.value;

          //           formEmailTraitName = child.attributes.attributes.name;
          //         }

          //         if (child.attributes.attributes.type === "text") {
          //           formUsername = child.view.el.value;

          //           formUsernameTraitName = child.attributes.attributes.name;
          //         }

          //         if (child.attributes.attributes.type === "password") {
          //           formPassword = child.view.el.value;

          //           formPasswordTraitName = child.attributes.attributes.name;
          //         }

          //         // preparing formBody (payload) depending of whether the Name traits are provided or not

          //         if (formEmailTraitName)
          //           formBody[formEmailTraitName] = formEmail;

          //         if (formUsernameTraitName)
          //           formBClickody[formUsernameTraitName] = formUsername;

          //         if (formPasswordTraitName)
          //           formBody[formPasswordTraitName] = formPassword;
          //       }

          //       // }
          //     );
          //   }
          // },
        },

        view: {
          // init({ model }) {

          //     // giving unique class to every stellar-button so that they don't affect others on getting styled

          //     const uniqueId = uniqid('stellar-button-');

          //     console.log('stellar-button ID for class:', uniqueId);

          //     // to give unique class so that one button does not affect the other

          //     // let modelAttributes = this.model.getAttributes();

          //     // console.log('modelAttributes:', modelAttributes);

          //     // modelAttributes.class += ` ${uniqueId}`;

          //     this.model.setAttributes({ class: `stellar-btn ${uniqueId}` });

          //     // console.log('modelAttributes:', modelAttributes);

          // this.listenTo(model, 'change:style', this.handlePropChange);

          // },

          onRender({ el, model }) {
            // el.classList.add(`${uniqueId}`);
            // let customStyle = this.model.get('styles');
            // console.log('customStyle:', customStyle);
            // if (customStyle) {
            //     el.setAttribute('styles', customStyle);
            // }
            // getting the current value of this trait
            // let buttonLabel = this.model.get('Button_label');
            // console.log('buttonLabel:', buttonLabel, 'el:', el);
            // // to let the button inner text be edited without opening the modal because the button is connected to the modal, so you cannot click ont he button to edit the inner text of it
            // if (buttonLabel) {
            //     el.innerHTML = buttonLabel;
            // }
            // // Listen for changes to the button style
            // el.addEventListener('change', () => {
            //     const updatedStyle = el.getAttribute('styles');
            //     console.log('updatedStyle:', updatedStyle);
            //     // Store the updated style in the model based on the unique ID
            //     this.model.set('styles', updatedStyle);
            // });
            // el.style.width = 'max-content';
            // el.style.padding = '0.5em';
            // el.style.borderRadius = '10px';
            // el.style.backgroundColor = 'blue';
            // el.style.border = 'none';
            // el.style.color = 'white';
            // el.style.cursor = 'pointer';
            // let innerPTag = el.querySelector('p');
            // innerPTag.style.margin = 'auto';
            // innerPTag.style.textAlign = 'center';
            // console.log('model', model);
            // if (model.attributes.type === 'stellar-button') {
            //   model.attributes.tagName = 'button';
            //   console.log('el, model', el, model);
            // }
          },

          events: {
            click: function (event) {
              var internalTarget = this.model.get("InternalTarget");

              var navigate = this.model.get("Navigate");

              var externalTarget = this.model.get("ExternalTarget");

              console.log(
                "Navigating:",
                navigate,
                "\nInternal Target:",
                internalTarget,
                "\nExternal Target:",
                externalTarget
              );

              const project_id = window.location.search.split("=")[1];

              if (navigate && internalTarget && !externalTarget) {
                console.log("internalTarget", internalTarget);

                const origin = window.location.origin;

                window.location.href =
                  origin +
                  `/editor/` +
                  `${internalTarget}` +
                  "?projectId=" +
                  `${project_id}`;
              }

              if (navigate && externalTarget && !internalTarget) {
                console.log("externalTarget", externalTarget);

                let origin = "https://";

                let modifiedUrl =
                  externalTarget.includes("http://") ||
                  externalTarget.includes("https://")
                    ? externalTarget
                    : origin + `${externalTarget}`;

                console.log("modifiedUrl:", modifiedUrl);

                let win = window.open(modifiedUrl, "_blank");

                win.focus();
              }

              // Button API functionality

              let parentComponent = this.model.parent();

              console.log("parent of stellar-button:", parentComponent);

              // if the parent component of this button is not a form, then use button's API traits

              if (parentComponent.attributes.tagName !== "form") {
                console.log(
                  "this button is NOT inside a FORM; using API traits"
                );

                var apiUrl = this.model.get("API_URL");

                var method = this.model.get("Method");

                var body = this.model.get("Body");

                var contentType = this.model.get("Content_Type");

                var username = this.model.get("Username");

                var password = this.model.get("Password");

                var apiKey = this.model.get("API_Key");

                var responseStatus200 = this.model.get("Response_Status_200");

                var responseStatus201 = this.model.get("Response_Status_201");

                var responseStatus204 = this.model.get("Response_Status_204");

                var responseStatus400 = this.model.get("Response_Status_400");

                var responseStatus404 = this.model.get("Response_Status_404");

                var responseStatus500 = this.model.get("Response_Status_500");

                console.log(
                  "apiUrl:",
                  apiUrl,
                  "\nmethod:",
                  method,
                  "\nbody:",
                  body,
                  "\ncontentType:",
                  contentType,
                  "\nUsername:",
                  username,
                  "\nPassword:",
                  password,
                  "\napiKey:",
                  apiKey,
                  "\nresponseStatus200:",
                  responseStatus200,
                  "\nresponseStatus201:",
                  responseStatus201,
                  "\nresponseStatus204:",
                  responseStatus204,
                  "\nresponseStatus400:",
                  responseStatus400,
                  "\nresponseStatus404:",
                  responseStatus404,
                  "\nresponseStatus500:",
                  responseStatus500
                );

                // GET API call

                if (method === "GET") {
                  console.log("stellar-button GET request");

                  // creating a token using this method from creatorFunctions.js file

                  // let token = authenticateUser(username, password);

                  // console.log('stellar-button GET request token:', token);

                  // let config = {

                  //     "Authorization": `${token}`,

                  // };

                  // if there is no api key, username or password

                  if (username === "" && password === "" && apiKey === "") {
                    console.log(
                      "No username, password & api key for stellar button POST request"
                    );

                    // making the fetch API GET request

                    fetch(`${apiUrl}`, {
                      method: method,

                      // headers: config,
                    })
                      .then((response) => response.json())

                      .then((data) => {
                        // can display the data here in a table format
                        if (responseStatus200) {
                          const origin = window.location.origin;

                          window.location.href =
                            origin +
                            `/editor/` +
                            `${responseStatus200}` +
                            "?projectId=" +
                            `${project_id}`;
                        }
                        console.log("stellar-button GET request Data:", data);

                        toast.info(
                          "Data is received successfully in the console.",
                          successTheme
                        );
                      })

                      .catch((error) => {
                        console.log("stellar-button GET request error:", error);
                      });
                  }

                  // if there is an api key, but no username or password

                  if (apiKey !== "") {
                    console.log(
                      "Api key provided for stellar button GET request"
                    );

                    // making the fetch API GET request

                    fetch(`${apiUrl}`, {
                      method: method,

                      headers: {
                        "Content-Type": `${contentType}`,

                        Authorization: `Bearer ${apiKey}`,
                      },
                    })
                      .then((response) => response.json())

                      .then((data) => {
                        // can display the data here in a table format
                        if (responseStatus200) {
                          const origin = window.location.origin;

                          window.location.href =
                            origin +
                            `/editor/` +
                            `${responseStatus200}` +
                            "?projectId=" +
                            `${project_id}`;
                        }
                        console.log("stellar-button GET request Data:", data);

                        toast.info(
                          "Data is received successfully in the console.",
                          successTheme
                        );
                      })

                      .catch((error) => {
                        console.log("stellar-button GET request error:", error);
                      });
                  }

                  // if there is no api key, but username or password or token

                  if (username !== "" && password !== "") {
                    console.log(
                      "Username & Password provided for stellar button GET request"
                    );

                    // creating a token using this method from creatorFunctions.js file

                    let token = authenticateUser(username, password);

                    console.log("stellar-button GET request token:", token);

                    // making the fetch API GET request

                    fetch(`${apiUrl}`, {
                      method: method,

                      headers: {
                        "Content-Type": `${contentType}`,

                        Authorization: `${token}`,
                      },
                    })
                      .then((response) => response.json())

                      .then((data) => {
                        // can display the data here in a table format
                        if (responseStatus200) {
                          const origin = window.location.origin;

                          window.location.href =
                            origin +
                            `/editor/` +
                            `${responseStatus200}` +
                            "?projectId=" +
                            `${project_id}`;
                        }
                        console.log("stellar-button GET request Data:", data);

                        toast.info(
                          "Data is received successfully in the console.",
                          successTheme
                        );
                      })

                      .catch((error) => {
                        console.log("stellar-button GET request error:", error);
                      });
                  }
                }

                // GET API call
                else if (method === "POST") {
                  console.log("stellar-button POST request");

                  // if there is no api key, username or password

                  if (username === "" && password === "" && apiKey === "") {
                    console.log(
                      "No username, password & api key for stellar button POST request"
                    );

                    // making the fetch API POST request

                    fetch(`${apiUrl}`, {
                      method: method,

                      headers: {
                        "Content-Type": `${contentType}`,
                      },

                      body: body,
                    })
                      .then((response) => response.json())

                      .then((data) => {
                        if (responseStatus200) {
                          const origin = window.location.origin;

                          window.location.href =
                            origin +
                            `/editor/` +
                            `${responseStatus200}` +
                            "?projectId=" +
                            `${project_id}`;
                        }
                        // can display the data here in a table format

                        console.log("stellar-button POST request Data:", data);

                        toast.info(
                          "Data is received successfully in the console.",
                          successTheme
                        );
                      })

                      .catch((error) => {
                        console.log(
                          "stellar-button POST request error:",
                          error
                        );
                      });
                  }

                  // if there is an api key, but no username or password

                  if (apiKey !== "") {
                    console.log(
                      "Api key provided for stellar button POST request"
                    );

                    // making the fetch API POST request

                    fetch(`${apiUrl}`, {
                      method: method,

                      headers: {
                        "Content-Type": `${contentType}`,

                        Authorization: `Bearer ${apiKey}`,
                      },

                      body: body,
                    })
                      .then((response) => response.json())

                      .then((data) => {
                        // can display the data here in a table format

                        console.log("stellar-button POST request Data:", data);
                        if (responseStatus200) {
                          const origin = window.location.origin;

                          window.location.href =
                            origin +
                            `/editor/` +
                            `${responseStatus200}` +
                            "?projectId=" +
                            `${project_id}`;
                        }

                        toast.info(
                          "Data is received successfully in the console.",
                          successTheme
                        );
                      })

                      .catch((error) => {
                        console.log(
                          "stellar-button POST request error:",
                          error
                        );
                      });
                  }

                  // if there is no api key, but username or password or token

                  if (username !== "" && password !== "") {
                    console.log(
                      "Username & Password provided for stellar button POST request"
                    );

                    // creating a token using this method from creatorFunctions.js file

                    let token = authenticateUser(username, password);

                    console.log("stellar-button POST request token:", token);

                    // making the fetch API POST request

                    fetch(`${apiUrl}`, {
                      method: method,

                      headers: {
                        "Content-Type": `${contentType}`,

                        Authorization: `${token}`,
                      },

                      body: body,
                    })
                      .then((response) => response.json())

                      .then((data) => {
                        if (responseStatus200) {
                          const origin = window.location.origin;

                          window.location.href =
                            origin +
                            `/editor/` +
                            `${responseStatus200}` +
                            "?projectId=" +
                            `${project_id}`;
                        }
                        // can display the data here in a table format

                        console.log("stellar-button POST request Data:", data);

                        toast.info(
                          "Data is received successfully in the console.",
                          successTheme
                        );
                      })

                      .catch((error) => {
                        console.log(
                          "stellar-button POST request error:",
                          error
                        );
                      });
                  }
                }
              }

              // if the parent component of this button is a form, then use the data from the form

              if (parentComponent.attributes.tagName === "form") {
                var formApiUrl = this.model.get("Form_API_URL");

                var formMethod = this.model.get("Form_Method");

                var formContentType = this.model.get("Form_Content_Type");

                let formEmail;

                let formEmailTraitName; // using this variable to store the 'Name' trait value of its input field and passing it in form 'body' fetch API request

                let formUsername;

                let formUsernameTraitName; // using this variable to store the 'Name' trait value of its input field and passing it in form 'body' fetch API request

                let formPassword;

                let formPasswordTraitName; // using this variable to store the 'Name' trait value of its input field and passing it in form 'body' fetch API request

                let formBody = {}; // creating payload for 'Body' key

                // the form should have only 1 username and password field

                // find all the inputs in the form container and see their field types and do something based on them

                parentComponent.find("input").forEach(
                  (child) => {
                    // if (child.attributes.tagName === 'input') {

                    console.log(
                      "child:",
                      child,
                      "\ninput value:",
                      child.view.el.value
                    );

                    // CONFIGURED only for inputs-types: email, text, text-node, password

                    // checking if element is email or username or password and then extracting their value and trait Name

                    if (child.attributes.attributes.type === "email") {
                      formEmail = child.view.el.value;

                      formEmailTraitName = child.attributes.attributes.name;
                    }

                    if (child.attributes.attributes.type === "text") {
                      formUsername = child.view.el.value;

                      formUsernameTraitName = child.attributes.attributes.name;
                    }

                    if (child.attributes.attributes.type === "password") {
                      formPassword = child.view.el.value;

                      formPasswordTraitName = child.attributes.attributes.name;
                    }

                    // preparing formBody (payload) depending of whether the Name traits are provided or not

                    if (formEmailTraitName)
                      formBody[formEmailTraitName] = formEmail;

                    if (formUsernameTraitName)
                      formBody[formUsernameTraitName] = formUsername;

                    if (formPasswordTraitName)
                      formBody[formPasswordTraitName] = formPassword;
                  }

                  // }
                );

                // let allInputs = parentComponent.find('input');

                // console.log('allInputs:', allInputs);

                console.log(
                  "formApiUrl:",
                  formApiUrl,
                  "\nformMethod:",
                  formMethod,
                  "\nformContentType:",
                  formContentType,
                  "\nformEmail:",
                  formEmail,
                  "\nformUsername:",
                  formUsername,
                  "\nformPassword:",
                  formPassword,
                  "\nformBody (payload):",
                  formBody
                );

                // making a GET request

                if (formMethod === "GET") {
                  // if there is no api key, but formUsername or formPassword or token

                  if (formUsername !== "" && formPassword !== "") {
                    console.log(
                      "Username & Password provided for stellar button GET request"
                    );

                    // creating a token using this method from creatorFunctions.js file

                    let token = authenticateUser(formUsername, formPassword);

                    console.log(
                      "stellar-button inside form GET request token:",
                      token
                    );

                    // making the fetch API GET request

                    fetch(`${formApiUrl}`, {
                      method: formMethod,

                      headers: {
                        "Content-Type": `${formContentType}`,

                        Authorization: `${token}`,
                      },
                    })
                      .then((response) => response.json())

                      .then((data) => {
                        if (responseStatus200) {
                          const origin = window.location.origin;

                          window.location.href =
                            origin +
                            `/editor/` +
                            `${responseStatus200}` +
                            "?projectId=" +
                            `${project_id}`;
                        }
                        // can display the data here in a table format

                        console.log(
                          "stellar-button form GET request Data:",
                          data
                        );

                        toast.info(
                          "Data is received successfully in the console.",
                          successTheme
                        );
                      })

                      .catch((error) => {
                        console.log(
                          "stellar-button form GET request error:",
                          error
                        );
                      });
                  }
                }

                // making a POST request

                if (formMethod === "POST") {
                  // if there is no api key, but formUsername or formPassword or token

                  if (
                    formUsername !== undefined &&
                    formPassword !== undefined
                  ) {
                    console.log(
                      "Username & Password provided for stellar button POST request"
                    );

                    // creating a token using this method from creatorFunctions.js file

                    let token = authenticateUser(formUsername, formPassword);

                    console.log(
                      "stellar-button inside form, POST request token:",
                      token
                    );

                    // making the fetch API POST request

                    fetch(`${formApiUrl}`, {
                      method: formMethod,

                      headers: {
                        "Content-Type": `${formContentType}`,

                        Authorization: `${token}`,
                      },

                      body:
                        formContentType === "application/json"
                          ? JSON.stringify(formBody)
                          : formBody,
                    })
                      .then((response) => response.json())

                      .then((data) => {
                        // can display the data here in a table format
                        if (responseStatus200) {
                          const origin = window.location.origin;

                          window.location.href =
                            origin +
                            `/editor/` +
                            `${responseStatus200}` +
                            "?projectId=" +
                            `${project_id}`;
                        }
                        console.log(
                          "stellar-button form POST request Data:",
                          data
                        );

                        toast.info(
                          "Data is received successfully in the console.",
                          successTheme
                        );
                      })

                      .catch((error) => {
                        console.log(
                          "stellar-button form POST request error:",
                          error
                        );
                      });
                  }

                  // if there is no api key, but formEmail or formPassword or token

                  if (formEmail !== undefined && formPassword !== undefined) {
                    console.log(
                      "Username & Password provided for stellar button POST request"
                    );

                    // creating a token using this method from creatorFunctions.js file

                    let token = authenticateUser(formEmail, formPassword);

                    console.log(
                      "stellar-button inside form, POST request token:",
                      token
                    );

                    // making the fetch API POST request

                    fetch(`${formApiUrl}`, {
                      method: formMethod,

                      headers: {
                        "Content-Type": `${formContentType}`,

                        Authorization: `${token}`,
                      },

                      body:
                        formContentType === "application/json"
                          ? JSON.stringify(formBody)
                          : formBody,
                    })
                      .then((response) => response.json())

                      .then((data) => {
                        if (responseStatus200) {
                          const origin = window.location.origin;

                          window.location.href =
                            origin +
                            `/editor/` +
                            `${responseStatus200}` +
                            "?projectId=" +
                            `${project_id}`;
                        }

                        console.log(
                          "stellar-button form POST request Data:",
                          data
                        );

                        toast.info(
                          "Data is received successfully in the console.",
                          successTheme
                        );
                      })

                      .catch((error) => {
                        console.log(
                          "stellar-button form POST request error:",
                          error
                        );
                      });
                  }
                }
              }
            },
          },
        },
      });

      const stellarScript = function (props) {
        console.log("updated props", `${this.id}`, props);

        // For LB download manipulation
        // checking if the url or script is not running in the redsling editor, only then run the script to plot checkboxes
        let idEl = this.id;
        const urlDownload = window.top.location.href;
        const isSubstringPresent =
          (urlDownload.indexOf("/editor/") !== -1 &&
            urlDownload.indexOf("?projectId=") !== -1) ||
          urlDownload.indexOf("/large_preview/") !== -1 ||
          urlDownload.indexOf("/tab_preview/") !== -1 ||
          urlDownload.indexOf("/mobile_preview/") !== -1 ||
          urlDownload.indexOf("/fragment_editor/") !== -1;
        if (!isSubstringPresent) {
          setInterval(function () {
            Object.keys(props).forEach(function (key) {
              if (window[`${key}${idEl}`]) {
                props[key] = window[`${key}${idEl}`];
              }
            });
          }, 500);
        }

        let project_id = props.projectId;
        let parentComponent = this.parentElement.nodeName;

        console.log(
          "this, parentComponent, props:",
          this,
          parentComponent,
          props
        );
        // console.log("props.pageByProjectData", props.pageByProjectData);

        if (this.tagName === "DIV") {
          if (props.Navigate && props.InternalTarget && !props.ExternalTarget) {
            this.getElementsByClassName("stellar-btn")[0].onclick = function (
              event
            ) {
              console.log("props.InternalTarget", props.InternalTarget);

              const origin = window.location.origin;
              if (window.location.href.includes("/large_preview")) {
                window.top.location.href =
                  origin + "/large_preview/" + `${props.InternalTarget}`;
              } else if (window.top.location.href.includes("/editor")) {
                window.top.location.href =
                  origin +
                  `/editor/` +
                  `${props.InternalTarget}` +
                  "?projectId=" +
                  `${project_id}`;
              } else {
                window.top.location.href = `{{HOST_URL}}/${props.InternalTarget}.html`;
              }
            };
          } else if (
            props.Navigate &&
            props.ExternalTarget &&
            !props.InternalTarget
          ) {
            this.getElementsByClassName("stellar-btn")[0].onclick = function (
              event
            ) {
              console.log("props.ExternalTarget", props.ExternalTarget);

              let origin = "https://";
              let modifiedUrl =
                props.ExternalTarget.includes("http://") ||
                props.ExternalTarget.includes("https://")
                  ? props.ExternalTarget
                  : origin + `${props.ExternalTarget}`;
              console.log("modifiedUrl:", modifiedUrl);
              let win = window.open(modifiedUrl, "_blank");
              if (win) {
                win.focus();
              }
            };
          }

          // if the parent component of this button is not a form, then use button's API traits
          if (parentComponent !== "FORM") {
            console.log("this button is NOT inside a FORM; using API traits");

            // GET API call
            if (props.Method === "GET") {
              console.log("stellar-button GET request");

              // creating a token using this method from creatorFunctions.js file

              // let token = authenticateUser(username, password);

              // console.log('stellar-button GET request token:', token);

              // let config = {

              //     "Authorization": `${token}`,

              // };

              // if there is no api key, username or password
              if (
                props.Username === "" &&
                props.Password === "" &&
                props.API_Key === ""
              ) {
                console.log(
                  "No username, password & api key for stellar button POST request"
                );

                // making the fetch API GET request

                fetch(`${props.API_URL}`, {
                  method: props.Method,
                  // headers: config,
                })
                  .then((response) => response.json())
                  .then((data) => {
                    // can display the data here in a table format
                    if (props.Response_Status_200) {
                      this.getElementsByTagName("button")[0].addEventListener(
                        "click",
                        function (e) {
                          const origin = window.location.origin;
                          window.top.location.href =
                            origin +
                            `/editor/` +
                            `${props.Response_Status_200}` +
                            "?projectId=" +
                            `${project_id}`;
                        }
                      );
                    }
                    console.log("stellar-button GET request Data:", data);
                  })
                  .catch((error) => {
                    console.log("stellar-button GET request error:", error);
                  });
              }

              // if there is an api key, but no username or password

              if (props.API_Key !== "") {
                console.log("Api key provided for stellar button GET request");

                // making the fetch API GET request

                fetch(`${props.API_URL}`, {
                  method: props.Method,

                  headers: {
                    "Content-Type": `${props.Content_Type}`,

                    Authorization: `Bearer ${props.API_Key}`,
                  },
                })
                  .then((response) => response.json())

                  .then((data) => {
                    // can display the data here in a table format
                    if (props.Response_Status_200) {
                      this.getElementsByTagName("button")[0].addEventListener(
                        "click",
                        function (e) {
                          const origin = window.location.origin;
                          window.top.location.href =
                            origin +
                            `/editor/` +
                            `${props.Response_Status_200}` +
                            "?projectId=" +
                            `${project_id}`;
                        }
                      );
                    }
                    console.log("stellar-button GET request Data:", data);
                  })
                  .catch((error) => {
                    console.log("stellar-button GET request error:", error);
                  });
              }

              // if there is no api key, but username or password or token

              if (props.Username !== "" && props.Password !== "") {
                console.log(
                  "Username & Password provided for stellar button GET request"
                );

                // creating a token using this method from creatorFunctions.js file

                let token = authenticateUser(props.Username, props.Password);

                console.log("stellar-button GET request token:", token);

                // making the fetch API GET request

                fetch(`${props.API_URL}`, {
                  method: props.Method,

                  headers: {
                    "Content-Type": `${props.Content_Type}`,

                    Authorization: `${token}`,
                  },
                })
                  .then((response) => response.json())

                  .then((data) => {
                    // can display the data here in a table format
                    if (props.Response_Status_200) {
                      this.getElementsByTagName("button")[0].addEventListener(
                        "click",
                        function (e) {
                          const origin = window.location.origin;
                          window.top.location.href =
                            origin +
                            `/editor/` +
                            `${props.Response_Status_200}` +
                            "?projectId=" +
                            `${project_id}`;
                        }
                      );
                    }
                    console.log("stellar-button GET request Data:", data);
                  })

                  .catch((error) => {
                    console.log("stellar-button GET request error:", error);
                  });
              }
            }

            // GET API call
            else if (props.Method === "POST") {
              console.log("stellar-button POST request");

              // if there is no api key, username or password

              if (
                props.Username === "" &&
                props.Password === "" &&
                props.API_Key === ""
              ) {
                console.log(
                  "No username, password & api key for stellar button POST request"
                );

                // making the fetch API POST request

                fetch(`${props.API_URL}`, {
                  method: props.Method,

                  headers: {
                    "Content-Type": `${props.Content_Type}`,
                  },

                  body: props.Body,
                })
                  .then((response) => response.json())

                  .then((data) => {
                    if (props.Response_Status_200) {
                      this.getElementsByTagName("button")[0].addEventListener(
                        "click",
                        function (e) {
                          const origin = window.location.origin;
                          window.top.location.href =
                            origin +
                            `/editor/` +
                            `${props.Response_Status_200}` +
                            "?projectId=" +
                            `${project_id}`;
                        }
                      );
                    }
                    // can display the data here in a table format

                    console.log("stellar-button POST request Data:", data);
                  })

                  .catch((error) => {
                    console.log("stellar-button POST request error:", error);
                  });
              }

              // if there is an api key, but no username or password

              if (props.API_Key !== "") {
                console.log("Api key provided for stellar button POST request");

                // making the fetch API POST request

                fetch(`${props.API_URL}`, {
                  method: props.Method,

                  headers: {
                    "Content-Type": `${props.Content_Type}`,

                    Authorization: `Bearer ${props.API_Key}`,
                  },

                  body: props.Body,
                })
                  .then((response) => response.json())

                  .then((data) => {
                    // can display the data here in a table format

                    console.log("stellar-button POST request Data:", data);
                    if (props.Response_Status_200) {
                      this.getElementsByTagName("button")[0].addEventListener(
                        "click",
                        function (e) {
                          const origin = window.location.origin;
                          window.top.location.href =
                            origin +
                            `/editor/` +
                            `${props.Response_Status_200}` +
                            "?projectId=" +
                            `${project_id}`;
                        }
                      );
                    }
                  })

                  .catch((error) => {
                    console.log("stellar-button POST request error:", error);
                  });
              }

              // if there is no api key, but username or password or token

              if (props.Username !== "" && props.Password !== "") {
                console.log(
                  "Username & Password provided for stellar button POST request"
                );

                // creating a token using this method from creatorFunctions.js file

                let token = authenticateUser(props.Username, props.Password);

                console.log("stellar-button POST request token:", token);

                // making the fetch API POST request

                fetch(`${props.API_URL}`, {
                  method: props.Method,

                  headers: {
                    "Content-Type": `${props.Content_Type}`,

                    Authorization: `${token}`,
                  },

                  body: props.Body,
                })
                  .then((response) => response.json())

                  .then((data) => {
                    if (props.Response_Status_200) {
                      this.getElementsByTagName("button")[0].addEventListener(
                        "click",
                        function (e) {
                          const origin = window.location.origin;
                          window.top.location.href =
                            origin +
                            `/editor/` +
                            `${props.Response_Status_200}` +
                            "?projectId=" +
                            `${project_id}`;
                        }
                      );
                    }
                    // can display the data here in a table format

                    console.log("stellar-button POST request Data:", data);
                  })

                  .catch((error) => {
                    console.log("stellar-button POST request error:", error);
                  });
              }
            }
          }

          // if the parent component of this button is a form, then use the data from the form
          // if (parentComponent === "FORM") {
          //   var formApiUrl = this.model.get("Form_API_URL");

          //   var formMethod = this.model.get("Form_Method");

          //   var formContentType = this.model.get("Form_Content_Type");

          //   let formEmail;

          //   let formEmailTraitName; // using this variable to store the 'Name' trait value of its input field and passing it in form 'body' fetch API request

          //   let formUsername;

          //   let formUsernameTraitName; // using this variable to store the 'Name' trait value of its input field and passing it in form 'body' fetch API request

          //   let formPassword;

          //   let formPasswordTraitName; // using this variable to store the 'Name' trait value of its input field and passing it in form 'body' fetch API request

          //   let formBody = {}; // creating payload for 'Body' key

          //   // the form should have only 1 username and password field

          //   // find all the inputs in the form container and see their field types and do something based on them

          //   parentComponent.find("input").forEach(
          //     (child) => {
          //       // if (child.attributes.tagName === 'input') {

          //       console.log(
          //         "child:",
          //         child,
          //         "\ninput value:",
          //         child.view.el.value
          //       );

          //       // CONFIGURED only for inputs-types: email, text, text-node, password

          //       // checking if element is email or username or password and then extracting their value and trait Name

          //       if (child.attributes.attributes.type === "email") {
          //         formEmail = child.view.el.value;

          //         formEmailTraitName = child.attributes.attributes.name;
          //       }

          //       if (child.attributes.attributes.type === "text") {
          //         formUsername = child.view.el.value;

          //         formUsernameTraitName = child.attributes.attributes.name;
          //       }

          //       if (child.attributes.attributes.type === "password") {
          //         formPassword = child.view.el.value;

          //         formPasswordTraitName = child.attributes.attributes.name;
          //       }

          //       // preparing formBody (payload) depending of whether the Name traits are provided or not

          //       if (formEmailTraitName)
          //         formBody[formEmailTraitName] = formEmail;

          //       if (formUsernameTraitName)
          //         formBody[formUsernameTraitName] = formUsername;

          //       if (formPasswordTraitName)
          //         formBody[formPasswordTraitName] = formPassword;
          //     }

          //     // }
          //   );

          //   // let allInputs = parentComponent.find('input');

          //   // console.log('allInputs:', allInputs);

          //   console.log(
          //     "formApiUrl:",
          //     formApiUrl,
          //     "\nformMethod:",
          //     formMethod,
          //     "\nformContentType:",
          //     formContentType,
          //     "\nformEmail:",
          //     formEmail,
          //     "\nformUsername:",
          //     formUsername,
          //     "\nformPassword:",
          //     formPassword,
          //     "\nformBody (payload):",
          //     formBody
          //   );

          //   // making a GET request

          //   if (formMethod === "GET") {
          //     // if there is no api key, but formUsername or formPassword or token

          //     if (formUsername !== "" && formPassword !== "") {
          //       console.log(
          //         "Username & Password provided for stellar button GET request"
          //       );

          //       // creating a token using this method from creatorFunctions.js file

          //       let token = authenticateUser(formUsername, formPassword);

          //       console.log(
          //         "stellar-button inside form GET request token:",
          //         token
          //       );

          //       // making the fetch API GET request

          //       fetch(`${formApiUrl}`, {
          //         method: formMethod,

          //         headers: {
          //           "Content-Type": `${formContentType}`,

          //           Authorization: `${token}`,
          //         },
          //       })
          //         .then((response) => response.json())

          //         .then((data) => {
          //           if (responseStatus200) {
          //             const origin = window.location.origin;

          //             window.location.href =
          //               origin +
          //               `/editor/` +
          //               `${responseStatus200}` +
          //               "?projectId=" +
          //               `${project_id}`;
          //           }
          //           // can display the data here in a table format

          //           console.log(
          //             "stellar-button form GET request Data:",
          //             data
          //           );

          //           toast.info(
          //             "Data is received successfully in the console.",
          //             successTheme
          //           );
          //         })

          //         .catch((error) => {
          //           console.log(
          //             "stellar-button form GET request error:",
          //             error
          //           );
          //         });
          //     }
          //   }

          //   // making a POST request

          //   if (formMethod === "POST") {
          //     // if there is no api key, but formUsername or formPassword or token

          //     if (
          //       formUsername !== undefined &&
          //       formPassword !== undefined
          //     ) {
          //       console.log(
          //         "Username & Password provided for stellar button POST request"
          //       );

          //       // creating a token using this method from creatorFunctions.js file

          //       let token = authenticateUser(formUsername, formPassword);

          //       console.log(
          //         "stellar-button inside form, POST request token:",
          //         token
          //       );

          //       // making the fetch API POST request

          //       fetch(`${formApiUrl}`, {
          //         method: formMethod,

          //         headers: {
          //           "Content-Type": `${formContentType}`,

          //           Authorization: `${token}`,
          //         },

          //         body:
          //           formContentType === "application/json"
          //             ? JSON.stringify(formBody)
          //             : formBody,
          //       })
          //         .then((response) => response.json())

          //         .then((data) => {
          //           // can display the data here in a table format
          //           if (responseStatus200) {
          //             const origin = window.location.origin;

          //             window.location.href =
          //               origin +
          //               `/editor/` +
          //               `${responseStatus200}` +
          //               "?projectId=" +
          //               `${project_id}`;
          //           }
          //           console.log(
          //             "stellar-button form POST request Data:",
          //             data
          //           );

          //           toast.info(
          //             "Data is received successfully in the console.",
          //             successTheme
          //           );
          //         })

          //         .catch((error) => {
          //           console.log(
          //             "stellar-button form POST request error:",
          //             error
          //           );
          //         });
          //     }

          //     // if there is no api key, but formEmail or formPassword or token

          //     if (formEmail !== undefined && formPassword !== undefined) {
          //       console.log(
          //         "Username & Password provided for stellar button POST request"
          //       );

          //       // creating a token using this method from creatorFunctions.js file

          //       let token = authenticateUser(formEmail, formPassword);

          //       console.log(
          //         "stellar-button inside form, POST request token:",
          //         token
          //       );

          //       // making the fetch API POST request

          //       fetch(`${formApiUrl}`, {
          //         method: formMethod,

          //         headers: {
          //           "Content-Type": `${formContentType}`,

          //           Authorization: `${token}`,
          //         },

          //         body:
          //           formContentType === "application/json"
          //             ? JSON.stringify(formBody)
          //             : formBody,
          //       })
          //         .then((response) => response.json())

          //         .then((data) => {
          //           if (responseStatus200) {
          //             const origin = window.location.origin;

          //             window.location.href =
          //               origin +
          //               `/editor/` +
          //               `${responseStatus200}` +
          //               "?projectId=" +
          //               `${project_id}`;
          //           }

          //           console.log(
          //             "stellar-button form POST request Data:",
          //             data
          //           );

          //           toast.info(
          //             "Data is received successfully in the console.",
          //             successTheme
          //           );
          //         })

          //         .catch((error) => {
          //           console.log(
          //             "stellar-button form POST request error:",
          //             error
          //           );
          //         });
          //     }
          //   }
          // }
        }
      };

      editor.DomComponents.addType("stellar-button", {
        model: {
          defaults: {
            tagName: "div",
            type: "stellar-button-container",
            script: stellarScript,
            attributes: {
              class: "stellar-button-container",
            },

            components: [
              {
                tagName: "button",
                type: "stellar-btn",
                attributes: { class: "stellar-btn" },
                editable: true,

                // EXPLANATION - why do we need to define css in both 'style-default' and style keys along with the same css in geditor_utils.js file?

                // using 'style-default', we make it so it doesn't delete other componenets' css when this button is deleted but if there is no other component already present

                // in the canvas and this is the first to be dropped then its css won't initialize with it and that's why we define css in 'style' key also.

                // But if we define css only in 'style' key then the user won't be able to customize this component even from the styles manager and if we define css

                // using 'styles' key then if the user deletes this component then other components will lose their css also thats why both 'style-default' and 'style' key are needed for the css definition.

                "style-default": {
                  width: "max-content",

                  padding: "0.5em",

                  "border-radius": "10px",

                  "background-color": "blue",

                  border: "none",

                  color: "white",

                  cursor: "pointer",

                  "pointer-events": "auto",
                },

                style: {
                  width: "max-content",

                  padding: "0.5em",

                  "border-radius": "10px",

                  "background-color": "blue",

                  border: "none",

                  color: "white",

                  cursor: "pointer",

                  "pointer-events": "auto",
                },

                components: {
                  tagName: "p",

                  type: "text",

                  editable: true,

                  components: {
                    type: "textnode",

                    content: "Click",
                  },

                  "style-default": {
                    margin: "auto",

                    "text-align": "center",
                  },

                  style: {
                    margin: "auto",

                    "text-align": "center",
                  },
                },

                // styles: `

                //     .stellar-btn {

                //         width: max-content;

                //         padding: 0.5em;

                //         border-radius: 10px;

                //         background-color: blue;

                //         border: none;

                //         color: white;

                //         cursor: pointer;

                //     }

                //     .stellar-btn > p {

                //         margin: auto;

                //         text-align: center;

                //     }

                // `,
              },
            ],

            // traits
            Navigate: false,
            InternalTarget: "",
            ExternalTarget: "",
            // pageByProjectData: pageByProjectData ? pageByProjectData : "",
            projectId: localStorage.getItem("project_id")
              ? localStorage.getItem("project_id")
              : "",

            // Independent Button API traits
            API_URL: "",
            Method: "",
            Body: "",
            Content_Type: "",
            Username: "",
            Password: "",
            API_Key: "",
            Response_Status_200: "",
            Response_Status_201: "",
            Response_Status_204: "",
            Response_Status_400: "",
            Response_Status_404: "",
            Response_Status_500: "",

            // Within Form API traits
            Form_API_URL: "",
            Form_Method: "",
            Form_Content_Type: "",

            traits: [
              // {

              //     type: 'text',

              //     name: 'Button_label',

              //     label: 'Button label',

              //     changeProp: true,

              // },

              {
                type: "select",
                name: "Navigate",
                label: "Navigate",
                changeProp: true,
                options: [
                  { id: "true", value: true, name: "True" },
                  { id: "false", value: false, name: "False" },
                ],
              },
              {
                type: "select",
                name: "InternalTarget",
                label: "Internal Target",
                changeProp: true,
                options: pageByProjectData
                  ? pageByProjectData?.map((x) => {
                      const arr = {
                        value: x._id,
                        name: x.name,
                      };
                      return arr;
                    })
                  : "",
              },
              {
                type: "url",
                name: "ExternalTarget",
                label: "External Target",
                changeProp: true,
              },
              {
                type: "url",
                name: "API_URL",
                label: "API URL",
                changeProp: true,
              },
              {
                type: "select",
                name: "Method",
                label: "Method",
                changeProp: true,
                options: [
                  { id: "GET", name: "GET" },
                  { id: "POST", name: "POST" },
                ],
              },
              {
                type: "text",
                name: "Body",
                label: "Body",
                changeProp: true,
              },
              {
                type: "select",
                name: "Content_Type",
                label: "Content-Type",
                changeProp: true,
                options: [
                  {
                    id: "application/java-archive",
                    name: "application/java-archive",
                  },
                  { id: "application/json", name: "application/json" },
                  { id: "application/xml", name: "application/xml" },
                  { id: "application/xml", name: "application/xml" },
                  { id: "text/css", name: "text/css" },
                  { id: "text/csv", name: "text/csv" },
                  { id: "text/html", name: "text/html" },
                  { id: "text/plain", name: "text/plain" },
                ],
              },
              {
                type: "text",
                name: "Username",
                label: "Username",
                changeProp: true,
              },
              {
                type: "text",
                name: "Password",
                label: "Password",
                changeProp: true,
              },
              {
                type: "text",
                name: "API_Key",
                label: "Bearer Token",
                placeholder: "Bearer",
                changeProp: true,
              },
              {
                type: "select",
                name: "Response_Status_200",
                label: "Response Status 200 Target",
                changeProp: true,
                options: pageByProjectData
                  ? pageByProjectData?.map((x) => {
                      const arr = {
                        value: x._id,
                        name: x.name,
                      };
                      return arr;
                    })
                  : "",
              },
              {
                type: "select",
                name: "Response_Status_201",
                label: "Response Status 201 Target",
                changeProp: true,
                options: pageByProjectData
                  ? pageByProjectData?.map((x) => {
                      const arr = {
                        value: x._id,
                        name: x.name,
                      };
                      return arr;
                    })
                  : "",
              },
              {
                type: "select",
                name: "Response_Status_204",
                label: "Response Status 204 Target",
                changeProp: true,
                options: pageByProjectData
                  ? pageByProjectData?.map((x) => {
                      const arr = {
                        value: x._id,
                        name: x.name,
                      };
                      return arr;
                    })
                  : "",
              },
              {
                type: "select",
                name: "Response_Status_400",
                label: "Response Status 400 Target",
                changeProp: true,
                options: pageByProjectData
                  ? pageByProjectData?.map((x) => {
                      const arr = {
                        value: x._id,
                        name: x.name,
                      };
                      return arr;
                    })
                  : "",
              },
              {
                type: "select",
                name: "Response_Status_404",
                label: "Response Status 404 Target",
                changeProp: true,
                options: pageByProjectData
                  ? pageByProjectData?.map((x) => {
                      const arr = {
                        value: x._id,
                        name: x.name,
                      };
                      return arr;
                    })
                  : "",
              },
              {
                type: "select",
                name: "Response_Status_500",
                label: "Response Status 500 Target",
                changeProp: true,
                options: pageByProjectData
                  ? pageByProjectData?.map((x) => {
                      const arr = {
                        value: x._id,
                        name: x.name,
                      };
                      return arr;
                    })
                  : "",
              },
              {
                type: "url",
                name: "Form_API_URL",
                label: "Form API URL",
                changeProp: true,
              },
              {
                type: "select",
                name: "Form_Method",
                label: "Form Method",
                changeProp: true,
                options: [
                  { id: "GET", name: "GET" },
                  { id: "POST", name: "POST" },
                ],
              },
              {
                type: "select",
                name: "Form_Content_Type",
                label: "Form Content-Type",
                changeProp: true,
                options: [
                  {
                    id: "application/java-archive",
                    name: "application/java-archive",
                  },
                  { id: "application/json", name: "application/json" },
                  { id: "application/xml", name: "application/xml" },
                  { id: "application/xml", name: "application/xml" },
                  { id: "text/css", name: "text/css" },
                  { id: "text/csv", name: "text/csv" },
                  { id: "text/html", name: "text/html" },
                  { id: "text/plain", name: "text/plain" },
                ],
              },
            ],

            changeProp: true,
            "script-props": [
              "Navigate",
              "InternalTarget",
              "ExternalTarget",
              "projectId",
              "API_URL",
              "Method",
              "Body",
              "Content_Type",
              "Username",
              "Password",
              "API_Key",
              "Response_Status_200",
              "Response_Status_201",
              "Response_Status_204",
              "Response_Status_400",
              "Response_Status_404",
              "Response_Status_500",
              "Form_API_URL",
              "Form_Method",
              "Form_Content_Type",
            ],
          },

          init() {
            // this.on('change:Navigate', this.handlePropChange);
            // this.on('change:InternalTarget', this.handlePropChange);
            // this.on('change:ExternalTarget', this.handlePropChange);
            // this.on('change:API_URL', this.handlePropChange);
            // this.on('change:Method', this.handlePropChange);
            // this.on('change:Body', this.handlePropChange);
            // this.on('change:Content_Type', this.handlePropChange);
            // this.on('change:Username', this.handlePropChange);
            // this.on('change:Password', this.handlePropChange);
            // this.on('change:API_Key', this.handlePropChange);
            // this.on('change:Response_Status_200', this.handlePropChange);
            // this.on('change:Response_Status_201', this.handlePropChange);
            // this.on('change:Response_Status_204', this.handlePropChange);
            // this.on('change:Response_Status_400', this.handlePropChange);
            // this.on('change:Response_Status_404', this.handlePropChange);
            // this.on('change:Response_Status_500', this.handlePropChange);
            // this.on('change:Form_API_URL', this.handlePropChange);
            // this.on('change:Form_Method', this.handlePropChange);
            // this.on('change:Form_Content_Type', this.handlePropChange);
            // console.log('this', this);
            // if (this.attributes.tagName === 'div' && this.attributes.type === 'stellar-button') {
            //   this.setAttributes({tagName: "button"});
            // }
            // console.log('this', this);
          },

          async handlePropChange() {
            const {
              Navigate,
              InternalTarget,
              ExternalTarget,
              API_URL,
              Method,
              Body,
              Content_Type,
              Username,
              Password,
              API_Key,
              Response_Status_200,
              Response_Status_201,
              Response_Status_204,
              Response_Status_400,
              Response_Status_404,
              Response_Status_500,
              Form_API_URL,
              Form_Method,
              Form_Content_Type,
            } = this.props();
            let project_id = window.location.search.split("=")[1];
            // let parentComponent = this.model.parent();

            console.log(
              "this, project_id, Navigate, InternalTarget, ExternalTarget, API_URL, Method, Body, Content_Type, Username, Password, API_Key, Response_Status_200, Response_Status_201, Response_Status_204, Response_Status_400, Response_Status_404, Response_Status_500, Form_API_URL, Form_Method, Form_Content_Type",
              this,
              this.getEl(),
              project_id,
              Navigate,
              InternalTarget,
              ExternalTarget,
              API_URL,
              Method,
              Body,
              Content_Type,
              Username,
              Password,
              API_Key,
              Response_Status_200,
              Response_Status_201,
              Response_Status_204,
              Response_Status_400,
              Response_Status_404,
              Response_Status_500,
              Form_API_URL,
              Form_Method,
              Form_Content_Type
            );

            if (Navigate && InternalTarget && !ExternalTarget) {
              this.getEl().addEventListener("click", function (event) {
                console.log("InternalTarget", InternalTarget);

                const origin = window.location.origin;
                window.location.href =
                  origin +
                  `/editor/` +
                  `${InternalTarget}` +
                  "?projectId=" +
                  `${project_id}`;
              });
            } else if (Navigate && ExternalTarget && !InternalTarget) {
              this.getEl().addEventListener("click", function (event) {
                console.log("ExternalTarget", ExternalTarget);

                let origin = "https://";
                let modifiedUrl =
                  ExternalTarget.includes("http://") ||
                  ExternalTarget.includes("https://")
                    ? ExternalTarget
                    : origin + `${ExternalTarget}`;
                console.log("modifiedUrl:", modifiedUrl);
                let win = window.open(modifiedUrl, "_blank");
                if (win) {
                  win.focus();
                }
              });
            }

            // if (parentComponent.attributes.tagName !== "form") {
            //   console.log("this button is NOT inside a FORM; using API traits" );

            //   // GET API call
            //   if (Method === "GET") {
            //     console.log("stellar-button GET request");

            //     // if there is no api key, username or password
            //     if (Username === "" && Password === "" && API_Key === "") {
            //       console.log("No username, password & api key for stellar button POST request" );

            //       // making the fetch API GET request
            //       fetch(`${API_URL}`, {
            //         method: Method,
            //         // headers: config,
            //       })
            //       .then((response) => response.json())
            //       .then((data) => {
            //         // can display the data here in a table format
            //         if (Response_Status_200) {
            //           this.getEl().addEventListener('click', function(event) {
            //             const origin = window.location.origin;
            //             window.location.href = origin + `/editor/` + `${Response_Status_200}` + "?projectId=" + `${project_id}`;
            //           });
            //         }
            //         console.log("stellar-button GET request Data:", data);
            //         toast.info("Data is received successfully in the console.", successTheme );
            //       })
            //       .catch((error) => {
            //         console.log("stellar-button GET request error:", error);
            //       });
            //     }

            //     // if there is an api key, but no username or password
            //     else if (API_Key !== "") {
            //       console.log("Api key provided for stellar button GET request" );

            //       // making the fetch API GET request
            //       fetch(`${API_URL}`, {
            //         method: Method,
            //         headers: {
            //           "Content-Type": `${Content_Type}`,
            //           Authorization: `Bearer ${API_Key}`,
            //         },
            //       })
            //       .then((response) => response.json())
            //       .then((data) => {
            //         // can display the data here in a table format
            //         if (Response_Status_200) {
            //           this.getEl().addEventListener('click', function(event) {
            //             const origin = window.location.origin;
            //             window.location.href = origin + `/editor/` + `${Response_Status_200}` + "?projectId=" + `${project_id}`;
            //           });
            //         }
            //         console.log("stellar-button GET request Data:", data);
            //         toast.info("Data is received successfully in the console.", successTheme );
            //       })
            //       .catch((error) => {
            //         console.log("stellar-button GET request error:", error);
            //       });
            //     }

            //     // if there is no api key, but username or password or token
            //     if (Username !== "" && Password !== "") {
            //       console.log(
            //         "Username & Password provided for stellar button GET request"
            //       );

            //       // creating a token using this method from creatorFunctions.js file

            //       let token = authenticateUser(Username, Password);

            //       console.log("stellar-button GET request token:", token);

            //       // making the fetch API GET request
            //       fetch(`${API_URL}`, {
            //         method: Method,

            //         headers: {
            //           "Content-Type": `${Content_Type}`,
            //           Authorization: `${token}`,
            //         },
            //       })
            //       .then((response) => response.json())
            //       .then((data) => {
            //         // can display the data here in a table format
            //         if (Response_Status_200) {
            //           this.getEl().addEventListener('click', function(event) {
            //             const origin = window.location.origin;
            //             window.location.href = origin + `/editor/` + `${Response_Status_200}` + "?projectId=" + `${project_id}`;
            //           });
            //         }
            //         console.log("stellar-button GET request Data:", data);

            //         toast.info("Data is received successfully in the console.", successTheme );
            //       })
            //       .catch((error) => {
            //         console.log("stellar-button GET request error:", error);
            //       });
            //     }
            //   }

            //   // POST API call
            //   else if (Method === "POST") {
            //     console.log("stellar-button POST request");

            //     // if there is no api key, username or password
            //     if (Username === "" && Password === "" && API_Key === "") {
            //       console.log("No username, password & api key for stellar button POST request" );

            //       // making the fetch API POST request
            //       fetch(`${API_URL}`, {
            //         method: Method,
            //         headers: {
            //           "Content-Type": `${Content_Type}`,
            //         },
            //         body: Body,
            //       })
            //       .then((response) => response.json())
            //       .then((data) => {
            //         if (Response_Status_200) {
            //           this.getEl().addEventListener('click', function(event) {
            //             const origin = window.location.origin;
            //             window.location.href = origin + `/editor/` + `${Response_Status_200}` + "?projectId=" + `${project_id}`;
            //           });
            //         }
            //         // can display the data here in a table format
            //         console.log("stellar-button POST request Data:", data);

            //         toast.info("Data is received successfully in the console.", successTheme );
            //       })
            //       .catch((error) => {
            //         console.log("stellar-button POST request error:", error );
            //       });
            //     }

            //     // if there is an api key, but no username or password
            //     else if (API_Key !== "") {
            //       console.log("Api key provided for stellar button POST request" );

            //       // making the fetch API POST request
            //       fetch(`${API_URL}`, {
            //         method: Method,
            //         headers: {
            //           "Content-Type": `${Content_Type}`,
            //           Authorization: `Bearer ${API_Key}`,
            //         },
            //         body: Body,
            //       })
            //       .then((response) => response.json())
            //       .then((data) => {
            //         // can display the data here in a table format

            //         console.log("stellar-button POST request Data:", data);
            //         if (Response_Status_200) {
            //           this.getEl().addEventListener('click', function(event) {
            //             const origin = window.location.origin;
            //             window.location.href = origin + `/editor/` + `${Response_Status_200}` + "?projectId=" + `${project_id}`;
            //           });
            //         }

            //         toast.info("Data is received successfully in the console.", successTheme );
            //       })
            //       .catch((error) => {
            //         console.log("stellar-button POST request error:", error );
            //       });
            //     }

            //     // if there is no api key, but username or password or token
            //     else if (Username !== "" && Password !== "") {
            //       console.log("Username & Password provided for stellar button POST request" );

            //       // creating a token using this method from creatorFunctions.js file
            //       let token = authenticateUser(Username, Password);

            //       console.log("stellar-button POST request token:", token);

            //       // making the fetch API POST request
            //       fetch(`${API_URL}`, {
            //         method: Method,
            //         headers: {
            //           "Content-Type": `${Content_Type}`,
            //           Authorization: `${token}`,
            //         },
            //         body: Body,
            //       })
            //       .then((response) => response.json())
            //       .then((data) => {
            //         if (Response_Status_200) {
            //           this.getEl().addEventListener('click', function(event) {
            //             const origin = window.location.origin;
            //             window.location.href = origin + `/editor/` + `${Response_Status_200}` + "?projectId=" + `${project_id}`;
            //           });
            //         }
            //         // can display the data here in a table format

            //         console.log("stellar-button POST request Data:", data);

            //         toast.info("Data is received successfully in the console.", successTheme );
            //       })
            //       .catch((error) => {
            //         console.log("stellar-button POST request error:", error );
            //       });
            //     }
            //   }
            // }

            // if the parent component of this button is a form, then use the data from the form
            // if (parentComponent.attributes.tagName === "form") {
            //   // the form should have only 1 username and password field
            //   // find all the inputs in the form container and see their field types and do something based on them
            //   parentComponent.find("input").forEach((child) => {
            //       // if (child.attributes.tagName === 'input') {

            //       console.log("child:", child, "\ninput value:", child.view.el.value );

            //       // CONFIGURED only for inputs-types: email, text, text-node, password
            //       // checking if element is email or username or password and then extracting their value and trait Name

            //       if (child.attributes.attributes.type === "email") {
            //         formEmail = child.view.el.value;

            //         formEmailTraitName = child.attributes.attributes.name;
            //       }

            //       if (child.attributes.attributes.type === "text") {
            //         formUsername = child.view.el.value;

            //         formUsernameTraitName = child.attributes.attributes.name;
            //       }

            //       if (child.attributes.attributes.type === "password") {
            //         formPassword = child.view.el.value;

            //         formPasswordTraitName = child.attributes.attributes.name;
            //       }

            //       // preparing formBody (payload) depending of whether the Name traits are provided or not

            //       if (formEmailTraitName)
            //         formBody[formEmailTraitName] = formEmail;

            //       if (formUsernameTraitName)
            //         formBody[formUsernameTraitName] = formUsername;

            //       if (formPasswordTraitName)
            //         formBody[formPasswordTraitName] = formPassword;
            //     }

            //     // }
            //   );
            // }
          },
        },

        view: {
          // init({ model }) {

          //     // giving unique class to every stellar-button so that they don't affect others on getting styled

          //     const uniqueId = uniqid('stellar-button-');

          //     console.log('stellar-button ID for class:', uniqueId);

          //     // to give unique class so that one button does not affect the other

          //     // let modelAttributes = this.model.getAttributes();

          //     // console.log('modelAttributes:', modelAttributes);

          //     // modelAttributes.class += ` ${uniqueId}`;

          //     this.model.setAttributes({ class: `stellar-btn ${uniqueId}` });

          //     // console.log('modelAttributes:', modelAttributes);

          // this.listenTo(model, 'change:style', this.handlePropChange);

          // },

          onRender({ el, model }) {
            // el.classList.add(`${uniqueId}`);
            // let customStyle = this.model.get('styles');
            // console.log('customStyle:', customStyle);
            // if (customStyle) {
            //     el.setAttribute('styles', customStyle);
            // }
            // getting the current value of this trait
            // let buttonLabel = this.model.get('Button_label');
            // console.log('buttonLabel:', buttonLabel, 'el:', el);
            // // to let the button inner text be edited without opening the modal because the button is connected to the modal, so you cannot click ont he button to edit the inner text of it
            // if (buttonLabel) {
            //     el.innerHTML = buttonLabel;
            // }
            // // Listen for changes to the button style
            // el.addEventListener('change', () => {
            //     const updatedStyle = el.getAttribute('styles');
            //     console.log('updatedStyle:', updatedStyle);
            //     // Store the updated style in the model based on the unique ID
            //     this.model.set('styles', updatedStyle);
            // });
            // el.style.width = 'max-content';
            // el.style.padding = '0.5em';
            // el.style.borderRadius = '10px';
            // el.style.backgroundColor = 'blue';
            // el.style.border = 'none';
            // el.style.color = 'white';
            // el.style.cursor = 'pointer';
            // let innerPTag = el.querySelector('p');
            // innerPTag.style.margin = 'auto';
            // innerPTag.style.textAlign = 'center';
            // console.log('model', model);
            // if (model.attributes.type === 'stellar-button') {
            //   model.attributes.tagName = 'button';
            //   console.log('el, model', el, model);
            // }
          },

          // events: {
          //   click: function (event) {
          //     var internalTarget = this.model.get("InternalTarget");

          //     var navigate = this.model.get("Navigate");

          //     var externalTarget = this.model.get("ExternalTarget");

          //     console.log(
          //       "Navigating:",
          //       navigate,
          //       "\nInternal Target:",
          //       internalTarget,
          //       "\nExternal Target:",
          //       externalTarget
          //     );

          //     const project_id = window.location.search.split("=")[1];

          //     if (navigate && internalTarget && !externalTarget) {
          //       console.log("internalTarget", internalTarget);

          //       const origin = window.location.origin;

          //       window.location.href =
          //         origin +
          //         `/editor/` +
          //         `${internalTarget}` +
          //         "?projectId=" +
          //         `${project_id}`;
          //     }

          //     if (navigate && externalTarget && !internalTarget) {
          //       console.log("externalTarget", externalTarget);

          //       let origin = "https://";

          //       let modifiedUrl =
          //         externalTarget.includes("http://") ||
          //         externalTarget.includes("https://")
          //           ? externalTarget
          //           : origin + `${externalTarget}`;

          //       console.log("modifiedUrl:", modifiedUrl);

          //       let win = window.open(modifiedUrl, "_blank");

          //       win.focus();
          //     }

          //     // Button API functionality

          //     let parentComponent = this.model.parent();

          //     console.log("parent of stellar-button:", parentComponent);

          //     // if the parent component of this button is not a form, then use button's API traits

          //     if (parentComponent.attributes.tagName !== "form") {
          //       console.log(
          //         "this button is NOT inside a FORM; using API traits"
          //       );

          //       var apiUrl = this.model.get("API_URL");

          //       var method = this.model.get("Method");

          //       var body = this.model.get("Body");

          //       var contentType = this.model.get("Content_Type");

          //       var username = this.model.get("Username");

          //       var password = this.model.get("Password");

          //       var apiKey = this.model.get("API_Key");

          //       var responseStatus200 = this.model.get("Response_Status_200");

          //       var responseStatus201 = this.model.get("Response_Status_201");

          //       var responseStatus204 = this.model.get("Response_Status_204");

          //       var responseStatus400 = this.model.get("Response_Status_400");

          //       var responseStatus404 = this.model.get("Response_Status_404");

          //       var responseStatus500 = this.model.get("Response_Status_500");

          //       console.log("apiUrl:", apiUrl, "\nmethod:", method, "\nbody:", body, "\ncontentType:", contentType, "\nUsername:", username, "\nPassword:", password, "\napiKey:", apiKey, "\nresponseStatus200:", responseStatus200, "\nresponseStatus201:", responseStatus201, "\nresponseStatus204:", responseStatus204, "\nresponseStatus400:", responseStatus400, "\nresponseStatus404:", responseStatus404, "\nresponseStatus500:", responseStatus500 );

          //       // GET API call

          //       if (method === "GET") {
          //         console.log("stellar-button GET request");

          //         // creating a token using this method from creatorFunctions.js file

          //         // let token = authenticateUser(username, password);

          //         // console.log('stellar-button GET request token:', token);

          //         // let config = {

          //         //     "Authorization": `${token}`,

          //         // };

          //         // if there is no api key, username or password

          //         if (username === "" && password === "" && apiKey === "") {
          //           console.log(
          //             "No username, password & api key for stellar button POST request"
          //           );

          //           // making the fetch API GET request

          //           fetch(`${apiUrl}`, {
          //             method: method,

          //             // headers: config,
          //           })
          //             .then((response) => response.json())

          //             .then((data) => {
          //               // can display the data here in a table format
          //               if (responseStatus200) {
          //                 const origin = window.location.origin;

          //                 window.location.href =
          //                   origin +
          //                   `/editor/` +
          //                   `${responseStatus200}` +
          //                   "?projectId=" +
          //                   `${project_id}`;
          //               }
          //               console.log("stellar-button GET request Data:", data);

          //               toast.info(
          //                 "Data is received successfully in the console.",
          //                 successTheme
          //               );
          //             })

          //             .catch((error) => {
          //               console.log("stellar-button GET request error:", error);
          //             });
          //         }

          //         // if there is an api key, but no username or password

          //         if (apiKey !== "") {
          //           console.log(
          //             "Api key provided for stellar button GET request"
          //           );

          //           // making the fetch API GET request

          //           fetch(`${apiUrl}`, {
          //             method: method,

          //             headers: {
          //               "Content-Type": `${contentType}`,

          //               Authorization: `Bearer ${apiKey}`,
          //             },
          //           })
          //             .then((response) => response.json())

          //             .then((data) => {
          //               // can display the data here in a table format
          //               if (responseStatus200) {
          //                 const origin = window.location.origin;

          //                 window.location.href =
          //                   origin +
          //                   `/editor/` +
          //                   `${responseStatus200}` +
          //                   "?projectId=" +
          //                   `${project_id}`;
          //               }
          //               console.log("stellar-button GET request Data:", data);

          //               toast.info(
          //                 "Data is received successfully in the console.",
          //                 successTheme
          //               );
          //             })

          //             .catch((error) => {
          //               console.log("stellar-button GET request error:", error);
          //             });
          //         }

          //         // if there is no api key, but username or password or token

          //         if (username !== "" && password !== "") {
          //           console.log(
          //             "Username & Password provided for stellar button GET request"
          //           );

          //           // creating a token using this method from creatorFunctions.js file

          //           let token = authenticateUser(username, password);

          //           console.log("stellar-button GET request token:", token);

          //           // making the fetch API GET request

          //           fetch(`${apiUrl}`, {
          //             method: method,

          //             headers: {
          //               "Content-Type": `${contentType}`,

          //               Authorization: `${token}`,
          //             },
          //           })
          //             .then((response) => response.json())

          //             .then((data) => {
          //               // can display the data here in a table format
          //               if (responseStatus200) {
          //                 const origin = window.location.origin;

          //                 window.location.href =
          //                   origin +
          //                   `/editor/` +
          //                   `${responseStatus200}` +
          //                   "?projectId=" +
          //                   `${project_id}`;
          //               }
          //               console.log("stellar-button GET request Data:", data);

          //               toast.info(
          //                 "Data is received successfully in the console.",
          //                 successTheme
          //               );
          //             })

          //             .catch((error) => {
          //               console.log("stellar-button GET request error:", error);
          //             });
          //         }
          //       }

          //       // GET API call
          //       else if (method === "POST") {
          //         console.log("stellar-button POST request");

          //         // if there is no api key, username or password

          //         if (username === "" && password === "" && apiKey === "") {
          //           console.log(
          //             "No username, password & api key for stellar button POST request"
          //           );

          //           // making the fetch API POST request

          //           fetch(`${apiUrl}`, {
          //             method: method,

          //             headers: {
          //               "Content-Type": `${contentType}`,
          //             },

          //             body: body,
          //           })
          //             .then((response) => response.json())

          //             .then((data) => {
          //               if (responseStatus200) {
          //                 const origin = window.location.origin;

          //                 window.location.href =
          //                   origin +
          //                   `/editor/` +
          //                   `${responseStatus200}` +
          //                   "?projectId=" +
          //                   `${project_id}`;
          //               }
          //               // can display the data here in a table format

          //               console.log("stellar-button POST request Data:", data);

          //               toast.info(
          //                 "Data is received successfully in the console.",
          //                 successTheme
          //               );
          //             })

          //             .catch((error) => {
          //               console.log(
          //                 "stellar-button POST request error:",
          //                 error
          //               );
          //             });
          //         }

          //         // if there is an api key, but no username or password

          //         if (apiKey !== "") {
          //           console.log(
          //             "Api key provided for stellar button POST request"
          //           );

          //           // making the fetch API POST request

          //           fetch(`${apiUrl}`, {
          //             method: method,

          //             headers: {
          //               "Content-Type": `${contentType}`,

          //               Authorization: `Bearer ${apiKey}`,
          //             },

          //             body: body,
          //           })
          //             .then((response) => response.json())

          //             .then((data) => {
          //               // can display the data here in a table format

          //               console.log("stellar-button POST request Data:", data);
          //               if (responseStatus200) {
          //                 const origin = window.location.origin;

          //                 window.location.href =
          //                   origin +
          //                   `/editor/` +
          //                   `${responseStatus200}` +
          //                   "?projectId=" +
          //                   `${project_id}`;
          //               }

          //               toast.info(
          //                 "Data is received successfully in the console.",
          //                 successTheme
          //               );
          //             })

          //             .catch((error) => {
          //               console.log(
          //                 "stellar-button POST request error:",
          //                 error
          //               );
          //             });
          //         }

          //         // if there is no api key, but username or password or token

          //         if (username !== "" && password !== "") {
          //           console.log(
          //             "Username & Password provided for stellar button POST request"
          //           );

          //           // creating a token using this method from creatorFunctions.js file

          //           let token = authenticateUser(username, password);

          //           console.log("stellar-button POST request token:", token);

          //           // making the fetch API POST request

          //           fetch(`${apiUrl}`, {
          //             method: method,

          //             headers: {
          //               "Content-Type": `${contentType}`,

          //               Authorization: `${token}`,
          //             },

          //             body: body,
          //           })
          //             .then((response) => response.json())

          //             .then((data) => {
          //               if (responseStatus200) {
          //                 const origin = window.location.origin;

          //                 window.location.href =
          //                   origin +
          //                   `/editor/` +
          //                   `${responseStatus200}` +
          //                   "?projectId=" +
          //                   `${project_id}`;
          //               }
          //               // can display the data here in a table format

          //               console.log("stellar-button POST request Data:", data);

          //               toast.info(
          //                 "Data is received successfully in the console.",
          //                 successTheme
          //               );
          //             })

          //             .catch((error) => {
          //               console.log(
          //                 "stellar-button POST request error:",
          //                 error
          //               );
          //             });
          //         }
          //       }
          //     }

          //     // if the parent component of this button is a form, then use the data from the form

          //     if (parentComponent.attributes.tagName === "form") {
          //       var formApiUrl = this.model.get("Form_API_URL");

          //       var formMethod = this.model.get("Form_Method");

          //       var formContentType = this.model.get("Form_Content_Type");

          //       let formEmail;

          //       let formEmailTraitName; // using this variable to store the 'Name' trait value of its input field and passing it in form 'body' fetch API request

          //       let formUsername;

          //       let formUsernameTraitName; // using this variable to store the 'Name' trait value of its input field and passing it in form 'body' fetch API request

          //       let formPassword;

          //       let formPasswordTraitName; // using this variable to store the 'Name' trait value of its input field and passing it in form 'body' fetch API request

          //       let formBody = {}; // creating payload for 'Body' key

          //       // the form should have only 1 username and password field

          //       // find all the inputs in the form container and see their field types and do something based on them

          //       parentComponent.find("input").forEach(
          //         (child) => {
          //           // if (child.attributes.tagName === 'input') {

          //           console.log(
          //             "child:",
          //             child,
          //             "\ninput value:",
          //             child.view.el.value
          //           );

          //           // CONFIGURED only for inputs-types: email, text, text-node, password

          //           // checking if element is email or username or password and then extracting their value and trait Name

          //           if (child.attributes.attributes.type === "email") {
          //             formEmail = child.view.el.value;

          //             formEmailTraitName = child.attributes.attributes.name;
          //           }

          //           if (child.attributes.attributes.type === "text") {
          //             formUsername = child.view.el.value;

          //             formUsernameTraitName = child.attributes.attributes.name;
          //           }

          //           if (child.attributes.attributes.type === "password") {
          //             formPassword = child.view.el.value;

          //             formPasswordTraitName = child.attributes.attributes.name;
          //           }

          //           // preparing formBody (payload) depending of whether the Name traits are provided or not

          //           if (formEmailTraitName)
          //             formBody[formEmailTraitName] = formEmail;

          //           if (formUsernameTraitName)
          //             formBody[formUsernameTraitName] = formUsername;

          //           if (formPasswordTraitName)
          //             formBody[formPasswordTraitName] = formPassword;
          //         }

          //         // }
          //       );

          //       // let allInputs = parentComponent.find('input');

          //       // console.log('allInputs:', allInputs);

          //       console.log(
          //         "formApiUrl:",
          //         formApiUrl,
          //         "\nformMethod:",
          //         formMethod,
          //         "\nformContentType:",
          //         formContentType,
          //         "\nformEmail:",
          //         formEmail,
          //         "\nformUsername:",
          //         formUsername,
          //         "\nformPassword:",
          //         formPassword,
          //         "\nformBody (payload):",
          //         formBody
          //       );

          //       // making a GET request

          //       if (formMethod === "GET") {
          //         // if there is no api key, but formUsername or formPassword or token

          //         if (formUsername !== "" && formPassword !== "") {
          //           console.log(
          //             "Username & Password provided for stellar button GET request"
          //           );

          //           // creating a token using this method from creatorFunctions.js file

          //           let token = authenticateUser(formUsername, formPassword);

          //           console.log(
          //             "stellar-button inside form GET request token:",
          //             token
          //           );

          //           // making the fetch API GET request

          //           fetch(`${formApiUrl}`, {
          //             method: formMethod,

          //             headers: {
          //               "Content-Type": `${formContentType}`,

          //               Authorization: `${token}`,
          //             },
          //           })
          //             .then((response) => response.json())

          //             .then((data) => {
          //               if (responseStatus200) {
          //                 const origin = window.location.origin;

          //                 window.location.href =
          //                   origin +
          //                   `/editor/` +
          //                   `${responseStatus200}` +
          //                   "?projectId=" +
          //                   `${project_id}`;
          //               }
          //               // can display the data here in a table format

          //               console.log(
          //                 "stellar-button form GET request Data:",
          //                 data
          //               );

          //               toast.info(
          //                 "Data is received successfully in the console.",
          //                 successTheme
          //               );
          //             })

          //             .catch((error) => {
          //               console.log(
          //                 "stellar-button form GET request error:",
          //                 error
          //               );
          //             });
          //         }
          //       }

          //       // making a POST request

          //       if (formMethod === "POST") {
          //         // if there is no api key, but formUsername or formPassword or token

          //         if (
          //           formUsername !== undefined &&
          //           formPassword !== undefined
          //         ) {
          //           console.log(
          //             "Username & Password provided for stellar button POST request"
          //           );

          //           // creating a token using this method from creatorFunctions.js file

          //           let token = authenticateUser(formUsername, formPassword);

          //           console.log(
          //             "stellar-button inside form, POST request token:",
          //             token
          //           );

          //           // making the fetch API POST request

          //           fetch(`${formApiUrl}`, {
          //             method: formMethod,

          //             headers: {
          //               "Content-Type": `${formContentType}`,

          //               Authorization: `${token}`,
          //             },

          //             body:
          //               formContentType === "application/json"
          //                 ? JSON.stringify(formBody)
          //                 : formBody,
          //           })
          //             .then((response) => response.json())

          //             .then((data) => {
          //               // can display the data here in a table format
          //               if (responseStatus200) {
          //                 const origin = window.location.origin;

          //                 window.location.href =
          //                   origin +
          //                   `/editor/` +
          //                   `${responseStatus200}` +
          //                   "?projectId=" +
          //                   `${project_id}`;
          //               }
          //               console.log(
          //                 "stellar-button form POST request Data:",
          //                 data
          //               );

          //               toast.info(
          //                 "Data is received successfully in the console.",
          //                 successTheme
          //               );
          //             })

          //             .catch((error) => {
          //               console.log(
          //                 "stellar-button form POST request error:",
          //                 error
          //               );
          //             });
          //         }

          //         // if there is no api key, but formEmail or formPassword or token

          //         if (formEmail !== undefined && formPassword !== undefined) {
          //           console.log(
          //             "Username & Password provided for stellar button POST request"
          //           );

          //           // creating a token using this method from creatorFunctions.js file

          //           let token = authenticateUser(formEmail, formPassword);

          //           console.log(
          //             "stellar-button inside form, POST request token:",
          //             token
          //           );

          //           // making the fetch API POST request

          //           fetch(`${formApiUrl}`, {
          //             method: formMethod,

          //             headers: {
          //               "Content-Type": `${formContentType}`,

          //               Authorization: `${token}`,
          //             },

          //             body:
          //               formContentType === "application/json"
          //                 ? JSON.stringify(formBody)
          //                 : formBody,
          //           })
          //             .then((response) => response.json())

          //             .then((data) => {
          //               if (responseStatus200) {
          //                 const origin = window.location.origin;

          //                 window.location.href =
          //                   origin +
          //                   `/editor/` +
          //                   `${responseStatus200}` +
          //                   "?projectId=" +
          //                   `${project_id}`;
          //               }

          //               console.log(
          //                 "stellar-button form POST request Data:",
          //                 data
          //               );

          //               toast.info(
          //                 "Data is received successfully in the console.",
          //                 successTheme
          //               );
          //             })

          //             .catch((error) => {
          //               console.log(
          //                 "stellar-button form POST request error:",
          //                 error
          //               );
          //             });
          //         }
          //       }
          //     }
          //   },
          // },
        },
      });

      // dispatch emails with this button. The body, to and from email addresses will be set fixed by the user of the editor and then exported
      editor.DomComponents.addType("predefined-email-dispatch", {
        model: {
          defaults: {
            tagName: "button",
            attributes: {
              id: "predefined-email-dispatch",
              class: "predefined-email-dispatch",
            },
            editable: true,

            // EXPLANATION - why do we need to define css in both 'style-default' and style keys along with the same css in geditor_utils.js file?
            // using 'style-default', we make it so it doesn't delete other componenets' css when this button is deleted but if there is no other component already present
            // in the canvas and this is the first to be dropped then its css won't initialize with it and that's why we define css in 'style' key also.
            // But if we define css only in 'style' key then the user won't be able to customize this component even from the styles manager and if we define css
            // using 'styles' key then if the user deletes this component then other components will lose their css also thats why both 'style-default' and 'style' key are needed for the css definition.
            "style-default": {
              width: "max-content",
              padding: "0.5em",
              "border-radius": "10px",
              "background-color": "blue",
              border: "none",
              color: "white",
              cursor: "pointer",
            },

            style: {
              width: "max-content",
              padding: "0.5em",
              "border-radius": "10px",
              "background-color": "blue",
              border: "none",
              color: "white",
              cursor: "pointer",
            },

            components: {
              tagName: "p",
              type: "text",
              editable: true,
              components: {
                type: "textnode",
                content: "Dispatch Email",
              },

              "style-default": {
                margin: "auto",
                "text-align": "center",
              },

              style: {
                margin: "auto",
                "text-align": "center",
              },
            },

            // styles: `
            //     .predefined-email-dispatch {
            //         width: max-content;
            //         padding: 0.5em;
            //         border-radius: 10px;
            //         text-align: center;
            //         background-color: blue;
            //         color: white;
            //         border: none;
            //         cursor: pointer;
            //     }

            //     .predefined-email-dispatch > p {
            //         margin: auto;
            //         text-align: center;
            //     }
            // `,

            // traits
            // Button_label: "",

            // Email traits
            Email_To: "",
            Email_Subject: "",
            Email_Body: "",
            File_Attachment: "",

            traits: [
              // {
              //     type: 'text',
              //     name: 'Button_label',
              //     label: 'Button label',
              //     changeProp: true,
              // },
              {
                type: "text",
                name: "Email_To",
                label: "Email To",
                changeProp: true,
              },
              {
                type: "text",
                name: "Email_Subject",
                label: "Email Subject",
                changeProp: true,
              },
              {
                type: "text",
                name: "Email_Body",
                label: "Email Body",
                changeProp: true,
              },
              {
                type: "file",
                name: "File_Attachment",
                label: "Attach File",
                changeProp: true,
              },
            ],

            "script-props": [
              "Email_To",
              "Email_Subject",
              "Email_Body",
              "File_Attachment",
            ],
          },
        },

        view: {
          onRender({ el }) {
            // let buttonLabel = this.model.get('Button_label');
            // let emailUsername = this.model.get('Email_Username');
            // let emailPassword = this.model.get('Email_Password');
            // let emailTo = this.model.get('Email_To');
            // let emailFrom = this.model.get('Email_From');
            // let emailSubject = this.model.get('Email_Subject');
            // let emailBody = this.model.get('Email_Body');

            const uniqueId = uniqid("predefined-email-dispatch-");
            console.log("predefined-email-dispatch ID for class:", uniqueId);

            if (el.id === "predefined-email-dispatch") {
              this.model.setAttributes({
                class: `predefined-email-dispatch ${uniqueId}`,
              });
            }

            // to let the button inner text become editable
            // if (buttonLabel) {
            //     el.innerHTML = buttonLabel;
            // }
          },

          events: {
            click: async function (event) {
              let emailTo = this.model.get("Email_To");
              // let emailFrom = this.model.get('Email_From');
              let emailSubject = this.model.get("Email_Subject");
              let emailBody = this.model.get("Email_Body");
              let fileAttachment = this.model.get("File_Attachment");

              console.log(
                "emailTo:",
                emailTo,
                "\nemailSubject:",
                emailSubject,
                "\nemailBody:",
                emailBody
              );
              console.log("fileAttachment:", fileAttachment);

              try {
                // Send a POST request to your server endpoint
                let response = await fetch(`${API_HOST}user/custom_email`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    to: emailTo.split(","), // pass [comma] separated emails (not [comma-space]) (e.g., abc@gmail.com,xyz@gmail.com)
                    // from: emailFrom,
                    from: "",
                    subject: emailSubject,
                    body: emailBody,
                    fileAttachment: fileAttachment ? fileAttachment : null,
                  }),
                });

                let responseData = await response.json();

                console.log("Email sent successfully:", responseData);
              } catch (error) {
                console.error("Failed to send email:", error);
              }
            },
          },
        },
      });

      editor.DomComponents.addType("customize-receiver-email-dispatch", {
        model: {
          defaults: {
            // tagName: 'button',

            // attributes: { id: 'customize-receiver-email-dispatch', class: 'customize-receiver-email-dispatch' },

            // content: 'Dispatch Email',

            // styles: `

            //     .predefined-email-dispatch {

            //         width: 10em;

            //         padding: 0.5em;

            //         border-radius: 10px;

            //         text-align: center;

            //         cursor: pointer;

            //     }

            // `,

            tagName: "span",

            attributes: {
              class: "contain-customize-receiver-email-dispatch",
            },

            // styles: `

            //     .contain-customize-receiver-email-dispatch {

            //         width: max-content;

            //         padding: 0.5em;

            //     }

            // `,

            "style-default": {
              width: "max-content",

              padding: "0.5em",
            },

            style: {
              width: "max-content",

              padding: "0.5em",
            },

            components: [
              {
                tagName: "button",

                attributes: {
                  type: "button",

                  class: "btn customize-receiver-email-dispatch",

                  id: "customize-receiver-email-dispatch",

                  "data-bs-toggle": "modal",

                  "data-bs-target": "#exampleModal",
                },

                editable: true,

                // EXPLANATION - why do we need to define css in both 'style-default' and style keys along with the same css in geditor_utils.js file?

                // using 'style-default', we make it so it doesn't delete other componenets' css when this button is deleted but if there is no other component already present

                // in the canvas and this is the first to be dropped then its css won't initialize with it and that's why we define css in 'style' key also.

                // But if we define css only in 'style' key then the user won't be able to customize this component even from the styles manager and if we define css

                // using 'stylespopup-button' key then if the user deletes this component then other components will lose their css also thats why both 'style-default' and 'style' key are needed for the css definition.

                "style-default": {
                  width: "max-content",

                  padding: "0.5em",

                  "border-radius": "10px",

                  "text-align": "center",

                  "background-color": "blue",

                  border: "none",

                  color: "white",

                  cursor: "pointer",
                },

                style: {
                  width: "max-content",

                  padding: "0.5em",

                  "border-radius": "10px",

                  "text-align": "center",

                  "background-color": "blue",

                  border: "none",

                  color: "white",

                  cursor: "pointer",
                },

                // styles: `

                //     .customize-receiver-email-dispatch {

                //         background-color: blue;

                //         color: white;

                //         border: none;

                //         width: max-content;

                //         padding: 0.5em;

                //         border-radius: 10px;

                //         text-align: center;

                //         cursor: pointer;

                //     }

                //     .customize-receiver-email-dispatch > p {

                //         margin: auto;

                //         text-align: center;

                //     }

                // `,

                components: {
                  tagName: "p",

                  type: "text",

                  editable: true,

                  components: {
                    type: "textnode",

                    content: "Dispatch Email",
                  },

                  "style-default": {
                    margin: "auto",

                    "text-align": "center",
                  },

                  style: {
                    margin: "auto",

                    "text-align": "center",
                  },
                },
              },
              {
                tagName: "div",

                attributes: {
                  class: "modal fade popup-button-modal",

                  id: "exampleModal",

                  tabindex: "-1",

                  "aria-labelledby": "exampleModalLabel",

                  "aria-hidden": "true",
                },

                // styles: `

                //     .customize-receiver-email-dispatch-modal {

                //         position: absolute !important;

                //         width: 100% !important;

                //         border: none !important;

                //         padding: 0.5em !important;

                //         top: auto !important;

                //         bottom: auto !important;

                //         left: auto !important;

                //         right: auto !important;

                //     }

                // `,

                "style-default": {
                  position: "absolute !important",

                  width: "100% !important",

                  border: "none !important",

                  padding: "0.5em !important",

                  top: "auto !important",

                  bottom: "auto !important",

                  left: "auto !important",

                  right: "auto !important",
                },

                style: {
                  position: "absolute !important",

                  width: "100% !important",

                  border: "none !important",

                  padding: "0.5em !important",

                  top: "auto !important",

                  bottom: "auto !important",

                  left: "auto !important",

                  right: "auto !important",
                },

                components: {
                  tagName: "div",

                  attributes: { class: "modal-dialog" },

                  components: {
                    tagName: "div",

                    attributes: { class: "modal-content" },

                    // styles: `

                    //     .modal-content {

                    //         padding: 0.5em;

                    //     }

                    // `,

                    "style-default": {
                      padding: "0.5em !important",
                    },

                    style: {
                      padding: "0.5em !important",
                    },

                    components: [
                      {
                        tagName: "div",

                        attributes: { class: "modal-header" },

                        components: [
                          {
                            tagName: "button",

                            attributes: {
                              class: "btn-close",

                              "data-bs-dismiss": "modal",

                              "aria-label": "Close",
                            },
                          },
                        ],
                      },
                      {
                        tagName: "div",

                        attributes: { class: "modal-body" },

                        components: {
                          tagName: "input",

                          attributes: {
                            type: "email",

                            id: "customize-receiver-email-dispatch-email-input",

                            class:
                              "customize-receiver-email-dispatch-email-input",

                            placeholder: "Enter receiving email addresses",
                          },
                        },
                      },
                      {
                        tagName: "div",

                        attributes: { class: "modal-footer" },

                        components: [
                          {
                            tagName: "button",

                            attributes: {
                              type: "button",

                              class:
                                "btn customize-receiver-email-dispatch-btn",

                              "data-bs-dismiss": "modal",
                            },

                            content: "Dispatch Email",
                          },
                        ],
                      },
                    ],
                  },
                },
              },
            ],

            // traits

            Button_label: "",

            // Email traits

            Email_Subject: "",

            Email_Body: "",

            File_Attachment: "",

            traits: [
              {
                type: "text",

                name: "Button_label",

                label: "Button label",

                changeProp: true,
              },
              {
                type: "text",

                name: "Email_Subject",

                label: "Email Subject",

                changeProp: true,
              },
              {
                type: "text",

                name: "Email_Body",

                label: "Email Body",

                changeProp: true,
              },
              {
                type: "file",

                name: "File_Attachment",

                label: "Attach File",

                changeProp: true,
              },
            ],

            "script-props": [
              "Button_label",
              "Email_Subject",
              "Email_Body",
              "File_Attachment",
            ],
          },
        },

        view: {
          onRender({ el }) {
            let buttonLabel = this.model.get("Button_label");

            // let emailUsername = this.model.get('Email_Username');

            // let emailPassword = this.model.get('Email_Password');

            // let emailTo = this.model.get('Email_To');

            // let emailFrom = this.model.get('Email_From');

            let emailSubject = this.model.get("Email_Subject");

            let emailBody = this.model.get("Email_Body");

            let fileAttachment = this.model.get("File_Attachment");

            console.log("el:", el);

            console.log("fileAttachment:", fileAttachment);

            // to let the button inner text become editable

            // if (el.className === 'customize-receiver-email-dispatch') {

            //     console.log('el 2:', el);

            if (buttonLabel) {
              console.log("buttonLabel:", buttonLabel);

              el.getElementsByTagName("p")[0].innerHTML = buttonLabel;
            }

            // }

            // const uniqueId = uniqid('customize-receiver-email-dispatch-');

            // console.log('customize-receiver-email-dispatch ID for class:', uniqueId);

            // if (el.id === 'customize-receiver-email-dispatch') {

            //     this.model.setAttributes({ class: `btn customize-receiver-email-dispatch ${uniqueId}` });

            // }

            // grabbing values to send email through modal send button

            let emailInputValue;

            // let emailInput;

            let emailInput = el.getElementsByClassName(
              "customize-receiver-email-dispatch-email-input"
            )[0];

            let dispatchEmailBtn = el.getElementsByClassName(
              "customize-receiver-email-dispatch-btn"
            )[0];

            if (dispatchEmailBtn) {
              dispatchEmailBtn.addEventListener(
                "click",
                async function (event) {
                  if (emailInput) emailInputValue = emailInput.value;

                  console.log(
                    "emailInput:",
                    emailInput,
                    "\nemailInputValue:",
                    emailInputValue,
                    "\nemailSubject:",
                    emailSubject,
                    "\nemailBody:",
                    emailBody
                  );

                  // sending actual email

                  // and sending only once other wise it will send email as many times as onRender function runs which is as many components there are in this definition

                  if (
                    el.className ===
                      "contain-customize-receiver-email-dispatch" &&
                    (emailInputValue !== "" ||
                      emailInputValue !== null ||
                      emailInputValue !== undefined) &&
                    (emailSubject !== "" ||
                      emailSubject !== null ||
                      emailSubject !== undefined) &&
                    (emailBody !== "" ||
                      emailBody !== null ||
                      emailBody !== undefined)
                  ) {
                    try {
                      console.log("heyyyyyyy");

                      // Send a POST request to your server endpoint

                      let response = await fetch(
                        `${API_HOST}user/custom_email`,
                        {
                          method: "POST",

                          headers: {
                            "Content-Type": "application/json",
                          },

                          body: JSON.stringify({
                            to: emailInputValue.split(","), // pass [comma] separated emails (not [comma-space]) (e.g., abc@gmail.com,xyz@gmail.com)

                            // from: emailFrom,

                            from: "",

                            subject: emailSubject,

                            body: emailBody,

                            fileAttachment: fileAttachment
                              ? fileAttachment
                              : null,
                          }),
                        }
                      );

                      let responseData = await response.json();

                      console.log("Email sent successfully:", responseData);
                    } catch (error) {
                      console.error("Failed to send email:", error);
                    }
                  }
                }
              );
            }

            console.log("email button clicked");
          },

          // events: {

          //     click: async function (event) {

          //         let emailSubject = this.model.get('Email_Subject');

          //         let emailBody = this.model.get('Email_Body');

          //         console.log('emailSubject:', emailSubject, '\nemailBody:', emailBody)

          //         // try {

          //         //     // Send a POST request to your server endpoint

          //         //     let response = await fetch(`${API_HOST}user/custom_email`, {

          //         //         method: 'POST',

          //         //         headers: {

          //         //             'Content-Type': 'application/json',

          //         //         },

          //         //         body: JSON.stringify({

          //         //             to: emailTo.split(','), // pass [comma] separated emails (not [comma-space]) (e.g., abc@gmail.com,xyz@gmail.com)

          //         //             // from: emailFrom,

          //         //             from: '',

          //         //             subject: emailSubject,

          //         //             body: emailBody,

          //         //         }),

          //         //     });

          //         //     let responseData = await response.json();

          //         //     console.log('Email sent successfully:', responseData);

          //         // } catch (error) {

          //         //     console.error('Failed to send email:', error);

          //         // }

          //     },

          //     // 'click .customize-receiver-email-dispatch-btn': function(event) {

          //     //     let modal = document.getElementById('grapesjs-iframe-body').getElementsByClassName('customize-receiver-email-dispatch')[0].getElementsByClassName('modal')[0];

          //     //     // if (modal) {

          //     //     let emailInputValue;

          //     //     // let emailInput = modal[0].getElementsByTagName('input');

          //     //     // if (emailInput) {

          //     //     //     emailInputValue = emailInput.value;

          //     //     // }

          //     //     console.log('modal:', modal, '\nemailInputValue:', emailInputValue);

          //     //     // }

          //     //     console.log('email button clicked');

          //     // },

          // },
        },
      });

      editor.DomComponents.addType("popup-button", {
        model: {
          defaults: {
            tagName: "span",

            attributes: {
              class: "contain-popup-button",
            },

            // styles: `

            //     .contain-popup-button {

            //         width: max-content;

            //         padding: 0.5em;

            //     }

            // `,

            components: [
              {
                // tagName: "button",

                // attributes: {
                //   type: "button",

                //   class: "btn popup-button",

                //   id: "popup-button",

                //   "data-bs-toggle": "modal",

                //   "data-bs-target": "#exampleModal",
                // },

                // editable: true,
                tagName: "popup-button-btn",
                type: "default",
                editable: true,
                contenteditable: "true",
                // components: `<button class="btn popup-button" id="popup-button" data-bs-toggle= "modal" data-bs-target= "#exampleModal">Open</button> `,
                components: [
                  {
                    tagName: "button",
                    attributes: {
                      class: "btn popup-button",
                      id: "popup-button",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#exampleModal",
                      // 'data-bs-target': '',
                    },

                    components: {
                      tagName: "p",
                      type: "text",
                      editable: true,

                      components: {
                        type: "textnode",
                        content: "Open",
                      },
                    },
                  },
                ],

                // EXPLANATION - why do we need to define css in both 'style-default' and style keys along with the same css in geditor_utils.js file?

                // using 'style-default', we make it so it doesn't delete other componenets' css when this button is deleted but if there is no other component already present

                // in the canvas and this is the first to be dropped then its css won't initialize with it and that's why we define css in 'style' key also.

                // But if we define css only in 'style' key then the user won't be able to customize this component even from the styles manager and if we define css

                // using 'styles' key then if the user deletes this component then other components will lose their css also thats why both 'style-default' and 'style' key are needed for the css definition.

                "style-default": {
                  width: "max-content",

                  padding: "0.5em",

                  "border-radius": "10px",

                  "background-color": "blue",

                  border: "none",

                  color: "white",

                  cursor: "pointer",
                },

                style: {
                  width: "max-content",

                  padding: "0.5em",

                  "border-radius": "10px",

                  "background-color": "blue",

                  border: "none",

                  color: "white",

                  cursor: "pointer",
                },

                // components: {
                //   tagName: "p",

                //   type: "text",

                //   editable: true,

                //   components: {
                //     type: "textnode",

                //     content: "Open",
                //   },

                //   "style-default": {
                //     margin: "auto",

                //     "text-align": "center",
                //   },

                //   style: {
                //     margin: "auto",

                //     "text-align": "center",
                //   },
                // },

                // styles: `

                //     .popup-button {

                //         background-color: blue;

                //         color: white;

                //         border: none;

                //     }

                //     .popup-button > p {

                //         margin: auto;

                //         text-align: center;

                //     }

                // `,
              },
              {
                tagName: "div",
                type: "default",
                attributes: {
                  class: "modal fade popup-button-modal",

                  id: "exampleModal",

                  tabindex: "-1",

                  "aria-labelledby": "exampleModalLabel",

                  "aria-hidden": "true",
                },

                // styles: `

                //     .popup-button-modal {

                //         position: absolute !important;

                //         width: 100% !important;

                //         border: none !important;

                //         padding: 0.5em !important;

                //         top: auto !important;

                //         bottom: auto !important;

                //         left: auto !important;

                //         right: auto !important;

                //     }

                // `,

                "style-default": {
                  position: "absolute !important",

                  width: "100% !important",

                  height: "100% !important",

                  padding: "0.5em !important",

                  border: "none !important",

                  top: "0 !important",

                  bottom: "0 !important",

                  left: "0 !important",

                  right: "0 !important",
                },

                style: {
                  position: "absolute !important",

                  width: "100% !important",

                  height: "100% !important",

                  padding: "0.5em !important",

                  border: "none !important",

                  top: "0 !important",

                  bottom: "0 !important",

                  left: "0 !important",

                  right: "0 !important",
                },

                components: {
                  tagName: "div",
                  type: "default",
                  attributes: { class: "modal-dialog" },

                  components: {
                    tagName: "div",
                    type: "default",
                    attributes: { class: "modal-content" },

                    // styles: `

                    //     .modal-content {

                    //         padding: 0.5em;

                    //     }

                    // `,

                    "style-default": {
                      padding: "0.5em !important",
                    },

                    style: {
                      padding: "0.5em !important",
                    },

                    components: [
                      {
                        tagName: "div",
                        type: "default",
                        attributes: { class: "modal-header" },

                        components: [
                          {
                            tagName: "button",
                            type: "default",
                            attributes: {
                              class: "btn-close",

                              "data-bs-dismiss": "modal",

                              "aria-label": "Close",
                            },

                            traits: ["data-bs-dismiss"],
                          },
                        ],
                      },
                      {
                        tagName: "div",
                        type: "default",
                        attributes: { class: "modal-body" },
                      },
                      {
                        tagName: "div",
                        type: "default",
                        attributes: { class: "modal-footer" },

                        // components: [

                        //     {

                        //         tagName: 'button',

                        //         attributes: {

                        //             type: 'button',

                        //             class: 'btn btn-secondary',

                        //             'data-bs-dismiss': 'modal',

                        //         },

                        //         content: 'Close',

                        //     }

                        // ],
                      },
                    ],
                  },
                },
              },
            ],

            // Button_label: "",
            Block_Modal: true,

            traits: [
              // {
              //   type: "text",

              //   name: "Button_label",

              //   label: "Button label",

              //   changeProp: true,
              // },

              {
                type: "checkbox",

                name: "Block_Modal",

                label: "Block Modal",

                changeProp: true,
              },
            ],

            "script-props": ["Block_Modal"],
          },
        },

        view: {
          init({ model }) {
            // to attach event listener on initialization
            this.listenTo(
              model,
              "change:Block_Modal",
              this.handleBlockModalTrait
            );
          },

          handleBlockModalTrait() {
            const blockModal = this.model.get("Block_Modal");
            console.log("blockModal:", blockModal);

            // let parentComponent = this.model.parent().getEl();
            let model = this.model;
            let modal = model.find(".popup-button-modal")[0];

            if (!blockModal) {
              modal.getEl().setAttribute("id", "");
            } else {
              modal.getEl().setAttribute("id", "exampleModal");
            }

            console.log("###", modal.getEl());
          },

          onRender({ el }) {
            // let buttonLabel = this.model.get("Button_label");

            // console.log("buttonLabel:", buttonLabel);

            let modalTitle = this.model.get("Modal_Title");

            console.log("modalTitle:", modalTitle);

            // const uniqueId = uniqid('popup-button-');

            // console.log('popup-button ID for class:', uniqueId);

            // if (el.id === 'popup-button') {

            //     this.model.setAttributes({ class: `btn popup-button ${uniqueId}` });

            // }

            // to let the button inner text be edited without opening the modal because the button is connected to the modal, so you cannot click ont he button to edit the inner text of it

            // if (buttonLabel) {
            //   el.getElementsByTagName("p")[0].innerHTML = buttonLabel;
            // }

            if (modalTitle) {
              document.querySelector(".modal-title").innerHTML = modalTitle;
            }
          },
        },
      });

      // helper function to extract styles from css string
      function extractSelectorsAndStyles(cssCode) {
        const selectorRegex = /([^{]+)\s*\{([^}]+)\}/g;
        const selectorsAndStyles = [];

        let match;
        while ((match = selectorRegex.exec(cssCode)) !== null) {
          const selector = match[1].trim();
          const styles = match[2].trim();

          selectorsAndStyles.push({ selector, styles });
        }

        return selectorsAndStyles;
      }

      // page popup where a page from the project appears
      editor.DomComponents.addType("page-popup-old", {
        model: {
          defaults: {
            tagName: "span",

            attributes: {
              class: "contain-page-popup",
            },

            // styles: `

            //     .contain-page-popup {

            //         width: max-content;

            //         padding: 0.5em;

            //     }

            // `,

            components: [
              {
                tagName: "button",

                attributes: {
                  type: "button",

                  class: "btn page-popup",

                  id: "page-popup",

                  "data-bs-toggle": "modal",

                  "data-bs-target": "#staticBackdrop",
                },

                editable: true,

                // EXPLANATION - why do we need to define css in both 'style-default' and style keys along with the same css in geditor_utils.js file?

                // using 'style-default', we make it so it doesn't delete other componenets' css when this button is deleted but if there is no other component already present

                // in the canvas and this is the first to be dropped then its css won't initialize with it and that's why we define css in 'style' key also.

                // But if we define css only in 'style' key then the user won't be able to customize this component even from the styles manager and if we define css

                // using 'styles' key then if the user deletes this component then other components will lose their css also thats why both 'style-default' and 'style' key are needed for the css definition.

                "style-default": {
                  width: "max-content",

                  padding: "0.5em",

                  "border-radius": "10px",

                  "background-color": "blue",

                  border: "none",

                  color: "white",

                  cursor: "pointer",
                },

                style: {
                  width: "max-content",

                  padding: "0.5em",

                  "border-radius": "10px",

                  "background-color": "blue",

                  border: "none",

                  color: "white",

                  cursor: "pointer",
                },

                // styles: `

                //     .page-popup {

                //         background-color: blue;

                //         color: white;

                //         border: none;

                //     }

                //     .page-popup > p {

                //         margin: auto;

                //         text-align: center;

                //     }

                // `,

                components: {
                  tagName: "p",

                  type: "text",

                  editable: true,

                  components: {
                    type: "textnode",

                    content: "Open",
                  },

                  "style-default": {
                    margin: "auto",

                    "text-align": "center",
                  },

                  style: {
                    margin: "auto",

                    "text-align": "center",
                  },
                },
              },
              {
                tagName: "div",

                attributes: {
                  class: "modal fade page-popup-modal",

                  id: "staticBackdrop",

                  tabindex: "-1",

                  "aria-labelledby": "staticBackdropLabel",

                  "aria-hidden": "true",
                },

                // styles: `

                //     .page-popup-modal {

                //         width: 90em !important;

                //         height: max-content;

                //         border: none !important;

                //         padding: 0.5em !important;

                //         position: relative !important;

                //     }

                // `,

                "style-default": {
                  position: "relative !important",

                  width: "90em !important",

                  height: "80vh !important",

                  padding: "0.5em !important",

                  border: "none !important",
                },

                style: {
                  position: "relative !important",

                  width: "90em !important",

                  height: "80vh !important",

                  padding: "0.5em !important",

                  border: "none !important",
                },

                components: {
                  tagName: "div",

                  attributes: { class: "modal-dialog" },

                  // styles: `

                  //     .modal-dialog {

                  //         padding: 1em;

                  //     }

                  // `,

                  "style-default": {
                    padding: "1em",
                  },

                  style: {
                    padding: "1em",
                  },

                  components: {
                    tagName: "div",

                    attributes: { class: "modal-content" },

                    // styles: `

                    //     .modal-content {

                    //         padding: 0.5em;

                    //         width: max-content;

                    //         height: max-content;

                    //         position: absolute !important;

                    //         left: -80%;

                    //     }

                    // `,

                    "style-default": {
                      width: "max-content",

                      height: "max-content",

                      padding: "0.5em !important",

                      position: "absolute !important",

                      left: "-80% !important",
                    },

                    style: {
                      width: "max-content",

                      height: "max-content",

                      padding: "0.5em !important",

                      position: "absolute !important",

                      left: "-80% !important",
                    },

                    components: [
                      // {

                      //     tagName: 'div',

                      //     attributes: { class: 'modal-header' },

                      //     components: [

                      //         {

                      //             tagName: 'button',

                      //             attributes: {

                      //                 class: 'btn-close',

                      //                 'data-bs-dismiss': 'modal',

                      //                 'aria-label': 'Close',

                      //             },

                      //         },

                      //     ],

                      // },

                      {
                        tagName: "div",

                        attributes: { class: "modal-body" },

                        components: [
                          {
                            tagName: "button",

                            attributes: {
                              class: "btn-close",

                              "data-bs-dismiss": "modal",

                              "aria-label": "Close",
                            },
                          },
                        ],
                      },

                      // {

                      //     tagName: 'div',

                      //     attributes: { class: 'modal-footer' },

                      //     components: [

                      //         {

                      //             tagName: 'button',

                      //             attributes: {

                      //                 type: 'button',

                      //                 class: 'btn btn-secondary',

                      //                 'data-bs-dismiss': 'modal',

                      //             },

                      //             content: 'Close',

                      //         }

                      //     ],

                      // },
                    ],
                  },
                },
              },
            ],

            Button_label: "",

            Pages: "",

            traits: [
              {
                type: "text",

                name: "Button_label",

                label: "Button label",

                changeProp: true,
              },
              {
                type: "select",

                name: "Page",

                label: "Page",

                changeProp: true,

                options: pageByProjectData
                  ? pageByProjectData?.map((x) => {
                      const arr = {
                        value: x._id,

                        name: x.name,
                      };

                      return arr;
                    })
                  : "",
              },
            ],

            "script-props": ["Button_label", "Page"],
          },
        },

        view: {
          async onRender({ el, model }) {
            let buttonLabel = this.model.get("Button_label");

            let selectedPage = this.model.get("Page");

            console.log("selectedPage:", selectedPage);

            // to let the button inner text be edited without opening the modal because the button is connected to the modal, so you cannot click ont he button to edit the inner text of it

            if (buttonLabel) {
              el.getElementsByTagName("p")[0].innerHTML = buttonLabel;
            }

            let pageData;

            if (selectedPage) {
              try {
                console.log("fetching page data...");

                let response = await fetch(
                  `${API_HOST}pages/${selectedPage}/content`,
                  {
                    headers: {
                      "Content-Type": "application/json",

                      // "Authorization": `Bearer ${userInfo.token}`,
                    },
                  }
                );

                let responseData = await response.json();

                pageData = responseData;

                console.log(
                  "responseData:",
                  responseData,
                  "\npageData:",
                  pageData
                );
              } catch (e) {
                toast.info(
                  "Could not fetch this page's data. Please try another page.",
                  successTheme
                );
              }
            }

            // const uniqueId = uniqid('page-popup-');

            // console.log('page-popup ID for class:', uniqueId);

            // if (el.id === 'page-popup') {

            //     this.model.setAttributes({ class: `btn page-popup ${uniqueId}` });

            // }

            // do things when its modal-body

            if (pageData) {
              // if (selectedPage) {

              console.log(
                "inside modal body\n",
                pageData["my-html"],
                pageData["my-css"],
                "\nmodel:",
                model
              );

              // const selectorsAndStyles = extractSelectorsAndStyles(pageData['my-css']);

              // console.log('selectorsAndStyles:', selectorsAndStyles);

              // selectorsAndStyles.forEach(({ selector, styles }) => {

              //     const rule = model.find('.modal-body')[0].add([{ selectors: [selector], style: styles }]);

              //     const classNames = rule.get('selectors').map((s) => s.split('.')[1]).join(' ');

              //     model.find('.modal-body')[0].addAttributes({ class: classNames });

              // });

              // appending the whole page HTML & css content into the modal

              // model.find('.modal-body')[0].append(`${pageData['my-html']}`);

              // console.log('model.find(.modal-body)[0]:', model.find('.modal-body')[0]);

              // let css = editor.Css;

              // let addedRules = css.addRules(pageData['my-styles']);

              // console.log('added rule:', addedRules.map(rule => rule.toCSS()));

              model.find(".modal-body")[0].append({
                tagName: "div",

                editable: false,

                content: `${pageData["my-html"]}\n<style>${pageData["my-css"]}</style>`,

                // styles: pageData['my-styles'],
              });

              // selectorsAndStyles.forEach((css) => {

              //     parserCss(css, editor);

              // });

              // model.find('.modal-body')[0].append([

              //     {

              //         type: 'helper-editor',

              //         // Add any necessary attributes or content

              //         attributes: {

              //           selectedPage: selectedPage,

              //         },

              //     },

              // ]);

              // model.find('.modal-body')[0].append(`

              //     <style>${pageData['my-css']}</style>

              // `);

              // const css = editor.Css;

              // let addedRules = css.addRules(pageData['my-css']);

              // console.log(addedRules.map(rule => rule.toCSS()));

              // const cssComponent = editor.CssComposer;

              // selectorsAndStyles.forEach(({ selector, styles }) => {

              //     const rule = cssComponent.addRules({ selectors: [selector], style: styles });

              //     model.find('.modal-body')[0].get('classes').add(rule.selectors);

              // });
            }
          },
        },
      });

      editor.DomComponents.addType("page-popup", {
        model: {
          defaults: {
            tagname: "span",
            attributes: {
              class: "contain-page-popup",
            },

            components: [
              {
                tagName: "button",
                attributes: {
                  type: "button",
                  class: "btn page-popup",
                  id: "page-popup",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#staticBackdrop",
                },

                components: [
                  {
                    tagName: "p",
                    type: "text",
                    editable: true,
                    content: "Open",
                  },
                ],

                traits: ["id", "data-bs-toggle", "data-bs-target"],
              },
              {
                tagName: "div",
                attributes: {
                  class: "modal fade page-popup-modal",
                  id: "staticBackdrop",
                  "data-bs-backdrop": "static",
                  tabindex: "-1",
                  "aria-labelledby": "staticBackdropLabel",
                  "aria-hidden": "true",
                },

                "style-default": {
                  position: "absolute !important",

                  width: "100% !important",

                  height: "100% !important",

                  padding: "0.5em !important",

                  border: "none !important",

                  top: "0 !important",

                  bottom: "0 !important",

                  left: "0 !important",

                  right: "0 !important",
                },

                style: {
                  position: "absolute !important",

                  width: "100% !important",

                  height: "100% !important",

                  padding: "0.5em !important",

                  border: "none !important",

                  top: "0 !important",

                  bottom: "0 !important",

                  left: "0 !important",

                  right: "0 !important",
                },

                components: [
                  {
                    tagName: "div",
                    type: "default",
                    attributes: {
                      class: "modal-dialog",
                    },

                    components: [
                      {
                        tagName: "div",
                        type: "default",
                        attributes: {
                          class: "modal-content",
                        },

                        "style-default": {
                          padding: "0.5em !important",
                        },

                        style: {
                          padding: "0.5em !important",
                        },

                        components: [
                          {
                            tagName: "div",
                            type: "default",
                            attributes: { class: "modal-header" },

                            components: [
                              {
                                tagName: "button",
                                type: "default",
                                attributes: {
                                  class: "btn-close",
                                  "data-bs-dismiss": "modal",
                                  "aria-label": "Close",
                                },

                                traits: ["data-bs-dismiss"],
                              },
                            ],
                          },
                          {
                            tagName: "div",
                            type: "default",
                            attributes: {
                              class: "modal-body",
                            },

                            // "style-default": {
                            //   maxWidth: "90%",
                            // },

                            // style: {
                            //   maxWidth: "90%",
                            // },
                          },
                        ],
                      },
                    ],
                  },
                ],

                traits: ["id", "class", "aria-labelledby"],
              },
            ],

            Page: "",

            traits: [
              {
                type: "select",
                name: "Page",
                label: "Page",
                changeProp: true,

                options: pageByProjectData
                  ? pageByProjectData?.map((x) => {
                      const arr = {
                        value: x._id,

                        name: x.name,
                      };

                      return arr;
                    })
                  : "",
              },
            ],

            changeProp: true,

            "script-props": ["Page"],
          },

          init() {
            this.on("change:Page", this.handlePropChange);
          },

          async handlePropChange() {
            const { Page } = this.props();
            let pageData;

            if (Page) {
              try {
                console.log("fetching page data...");

                let response = await fetch(`${API_HOST}pages/${Page}/content`, {
                  headers: {
                    "Content-Type": "application/json",
                    // "Authorization": `Bearer ${userInfo.token}`,
                  },
                });

                let responseData = await response.json();

                pageData = responseData;

                console.log(
                  "responseData:",
                  responseData,
                  "\npageData:",
                  pageData
                );
              } catch (e) {
                toast.info(
                  "Could not fetch this page's data. Please try another page.",
                  successTheme
                );
              }
            }

            if (pageData) {
              console.log(
                this.find(".modal-body")[0],
                "inside modal body\n",
                pageData["my-html"],
                pageData["my-css"],
                "\nthis:",
                this
              );

              this.getEl().getElementsByClassName("modal-body")[0].innerHTML =
                "";

              this.find(".modal-body")[0].append({
                tagName: "div",
                editable: true,
                content: `${pageData["my-html"]}\n<style>${pageData["my-css"]}</style>`,
              });
            }
          },
        },
      });

      editor.DomComponents.addType("live-alert", {
        model: {
          defaults: {
            tagName: "div",
            attributes: {
              class: "alert alert-primary alert-dismissible fade show",
              role: "alert",
            },

            components: [
              {
                tagName: "p",
                type: "text",
                editable: true,

                components: {
                  type: "textnode",
                  content:
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris facilisis egestas neque id viverra. Morbi et hendrerit eros.",
                },
              },
              {
                tagName: "button",
                attributes: {
                  type: "button",
                  class: "btn-close",
                  "data-bs-dismiss": "alert",
                  "aria-label": "Close",
                },
              },
            ],
          },
        },
      });

      // HELPER function, to check whether a variable is an array of objects or not
      function isArrayOfObjects(variable) {
        if (Array.isArray(variable)) {
          for (let i = 0; i < variable.length; i++) {
            if (
              typeof variable[i] !== "object" ||
              variable[i] === null ||
              Array.isArray(variable[i])
            ) {
              return false;
            }
          }

          return true;
        }

        return false;
      }

      const individualCheckboxScript = function (props) {
        console.log("this element:", this, props);

        let container = this.getElementsByTagName("input")[0];

        if (props.Autofocus) {
          container.setAttribute("autofocus", true);
        }

        if (props.Disabled) {
          container.setAttribute("disabled", true);
        }

        if (props.Required) {
          container.setAttribute("required", true);
        }

        if (props.Checked) {
          container.setAttribute("checked", true);
        }

        if (props.Value) {
          container.setAttribute("value", props.Value);
        }

        container.addEventListener("change", function () {
          console.log(
            "wrapper:::::11111",
            this.parentNode.parentNode.parentNode
          );
          let wrapper = this.parentNode.parentNode.parentNode;
          if (wrapper) {
            // Find all input elements under the div
            const inputElements = wrapper.querySelectorAll("input");

            // Filter out the checked input elements and retrieve their value attributes
            const checkedValues = Array.from(inputElements)
              .filter((input) => input.checked)
              .map((input) => input.value);

            const dbIds = Array.from(inputElements)
              .filter((input) => input.checked)
              .map((input) => input.getAttribute("data_db_id"));

            console.log("checkedValues:::::::::", checkedValues);
            console.log("dbIds", dbIds);

            wrapper.setAttribute("value", checkedValues.join(", "));
            wrapper.setAttribute("data_db_id", dbIds.join(", "));
          } else {
            console.log('Div element with id "iy1ck" not found.');
          }
        });
      };

      editor.DomComponents.addType("checkbox_input", {
        model: {
          defaults: {
            tagName: "span",
            type: "checkbox_input",
            script: individualCheckboxScript,

            attributes: {
              class: "checkbox_input",
            },

            components: [
              {
                tagName: "input",
                type: "default",
                attributes: {
                  type: "checkbox",
                  id: `checkbox_1_${uniqid()}`,
                  name: "checkbox_1",
                  value: "checkbox_1",
                },
              },
            ],

            Autofocus: false,
            Disabled: false,
            Required: false,
            Checked: false,

            traits: [
              "id",
              "name",
              "value",
              {
                type: "checkbox",
                name: "Autofocus",
                label: "Autofocus",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "Disabled",
                label: "Disabled",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "Required",
                label: "Required",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "Checked",
                label: "Checked",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "Checked",
                label: "Checked",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "Checked",
                label: "Checked",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "Checked",
                label: "Checked",
                changeProp: true,
              },
            ],

            changeProp: true,
            "script-props": ["Autofocus", "Disabled", "Required", "Checked"],
          },
        },
      });

      editor.DomComponents.addType("checkbox_label", {
        model: {
          defaults: {
            tagName: "label",
            type: "checkbox_label",
            attributes: {
              for: "",
            },

            components: [
              {
                tagName: "p",
                type: "text",
                editable: true,

                components: {
                  type: "textnode",
                  content: "checkbox_1",
                },
              },
            ],

            traits: ["id", "for"],
            changeProp: true,
          },
        },
      });

      editor.DomComponents.addType("checkbox_regular_form", {
        model: {
          defaults: {
            tagName: "span",
            type: "checkbox_regular_form",

            attributes: {
              // id: "checkbox_regular_form",
              class: "checkbox_regular_form",
            },

            components: [
              {
                tagName: "span",
                type: "default",
                attributes: {
                  class: "group_checbox_label",
                },

                "style-default": {
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                },

                style: {
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                },

                components: [
                  {
                    type: "checkbox_input",
                  },
                  {
                    type: "checkbox_label",
                  },
                ],
              },
              {
                tagName: "span",
                type: "default",
                attributes: {
                  class: "group_checbox_label",
                },

                "style-default": {
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                },

                style: {
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                },

                components: [
                  {
                    type: "checkbox_input",
                  },
                  {
                    type: "checkbox_label",
                  },
                ],
              },
            ],

            // traits
            CustomUrl: "",
            BaseUrl: "",
            APIPath: "",
            BearerToken: "",
            Username: "",
            Password: "",
            MoreHeaders: "",
            ArrOfObjKyename: "",
            NestedKeyname: "",

            traits: [
              "id",
              {
                type: "text",
                name: "CustomUrl",
                label: "Custom URL",
                changeProp: true,
              },
              {
                type: "select",
                name: "BaseUrl",
                label: "Base URL",
                options: [
                  { id: "baseUrl1", name: "Base URL #1" },
                  { id: "baseUrl2", name: "Base URL #2" },
                  { id: "baseUrl3", name: "Base URL #3" },
                  { id: "baseUrl4", name: "Base URL #4" },
                  { id: "baseUrl5", name: "Base URL #5" },
                  { id: "null", name: "No Base URL" },
                ],
                changeProp: true,
              },
              {
                type: "text",
                name: "APIPath",
                label: "API Path",
                placeholder: "Don't start with '/'",
                changeProp: true,
              },
              {
                type: "text",
                name: "BearerToken",
                label: "Bearer Token",
                placeholder: "No bearer token provided",
                changeProp: true,
              },
              {
                type: "text",
                name: "Username",
                label: "Username",
                changeProp: true,
              },
              {
                type: "text",
                name: "Password",
                label: "Password",
                changeProp: true,
              },
              {
                type: "text",
                name: "MoreHeaders",
                label: "More Headers",
                placeholder: "k1:v1,k2:v2,k3:v3,...",
                changeProp: true,
              },
              {
                type: "text",
                name: "ArrOfObjKyename",
                label: "Keyname From Array Of Object",
                placeholder: "[ {k1:v1}, {k1:v2} ]",
                changeProp: true,
              },
              {
                type: "text",
                name: "NestedKeyname",
                label: "Keyname For Nested Structure",
                placeholder: "{ k1: [{...}, {...}] }",
                changeProp: true,
              },
            ],

            changeProp: true,
            "script-props": [
              "CustomUrl",
              "BaseUrl",
              "APIPath",
              "BearerToken",
              "Username",
              "Password",
              "MoreHeaders",
              "ArrOfObjKyename",
              "NestedKeyname",
            ],
          },

          init() {
            this.listenTo(this, "change:CustomUrl", this.handlePropChange);
            this.listenTo(this, "change:BaseUrl", this.handlePropChange);
            this.listenTo(this, "change:APIPath", this.handlePropChange);
            this.listenTo(this, "change:BearerToken", this.handlePropChange);
            this.listenTo(this, "change:Username", this.handlePropChange);
            this.listenTo(this, "change:Password", this.handlePropChange);
            this.listenTo(this, "change:MoreHeaders", this.handlePropChange);
            this.listenTo(
              this,
              "change:ArrOfObjKyename",
              this.handlePropChange
            );
            this.listenTo(this, "change:NestedKeyname", this.handlePropChange);
          },

          async handlePropChange() {
            const {
              CustomUrl,
              BaseUrl,
              APIPath,
              BearerToken,
              Username,
              Password,
              MoreHeaders,
              ArrOfObjKyename,
              NestedKeyname,
            } = this.props();

            // to rename a variable because API var is getting used in many places in this block scope
            let API;
            if (APIPath) {
              API = APIPath;
            }

            let container = this;
            console.log("container:", container);

            // helper function to check if a variable is an array-of-objects or not
            function isArrayofObjects(variable) {
              // Check if the variable is an array
              if (!Array.isArray(variable)) {
                return false;
              }

              // Check if all elements in the array are objects
              for (const element of variable) {
                if (
                  typeof element !== "object" ||
                  Array.isArray(element) ||
                  element === null
                ) {
                  return false;
                }
              }
              return true;
            }

            // helper function to get value of a key in nested object
            function findKeyValue(obj, key) {
              if (obj.hasOwnProperty(key)) {
                // If the current object has the key, return its value
                return obj[key];
              }

              for (var prop in obj) {
                if (obj.hasOwnProperty(prop) && typeof obj[prop] === "object") {
                  // If the current property is an object, recursively search within it
                  var result = findKeyValue(obj[prop], key);
                  if (result !== undefined) {
                    return result;
                  }
                }
              }
              // Key not found in the object
              return undefined;
            }

            let apiData;

            // -------- Getting API Data
            // if CustomUrl is provided, use only that
            if (CustomUrl && (!BaseUrl || BaseUrl === "null")) {
              // if nothing is provided for auth
              if (!BearerToken && !Username && !Password) {
                // add extra headers, if needed
                let config = {
                  headers: {},
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${CustomUrl}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token is provided but not api_key or usr+pwd
              else if (BearerToken && !Username && !Password) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${BearerToken}`,
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${CustomUrl}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token and api_key not provided but usr+pwd are provided
              else if (!BearerToken && Username && Password) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    Authorization: "Basic " + btoa(Username + ":" + Password),
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${CustomUrl}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }
            }

            // if base url is the choice and provided
            else if (BaseUrl && API && !CustomUrl) {
              // concatenating base url and its remaining part
              let url, baseUrlBearerToken;
              if (BaseUrl === "baseUrl1") {
                url = baseUrl1 + API;
                baseUrlBearerToken = baseUrl1BearerToken;
              } else if (BaseUrl === "baseUrl2") {
                url = baseUrl2 + API;
                baseUrlBearerToken = baseUrl2BearerToken;
              } else if (BaseUrl === "baseUrl3") {
                url = baseUrl3 + API;
                baseUrlBearerToken = baseUrl3BearerToken;
              } else if (BaseUrl === "baseUrl4") {
                url = baseUrl4 + API;
                baseUrlBearerToken = baseUrl4BearerToken;
              } else if (BaseUrl === "baseUrl5") {
                url = baseUrl5 + API;
                baseUrlBearerToken = baseUrl5BearerToken;
              }
              console.log("url, baseUrlBearerToken", url, baseUrlBearerToken);

              // if nothing is provided for auth
              if (
                !BearerToken &&
                !baseUrlBearerToken &&
                !Username &&
                !Password
              ) {
                // add extra headers, if needed
                let config = {
                  headers: {},
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token is provided but not usr+pwd
              else if (BearerToken && !Username && !Password) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${BearerToken}`,
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a baseUrlBearerToken is provided but not Custom Bearer Token and usr+pwd
              else if (
                baseUrlBearerToken &&
                !BearerToken &&
                !Username &&
                !Password
              ) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${baseUrlBearerToken}`,
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config@:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token is not provided but usr+pwd are provided
              else if (!BearerToken && Username && Password) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    Authorization: "Basic " + btoa(Username + ":" + Password),
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }
            }

            console.log("apiData:", apiData);

            // -------- Populating API Data, into the dropdown list
            if (apiData !== undefined) {
              console.log("#");
              // if API response is directly an array-of-objects
              if (isArrayofObjects(apiData)) {
                if (ArrOfObjKyename) {
                  console.log("##");
                  // container.getEl().innerHTML = "";
                  container.components("");

                  apiData.forEach((opt) => {
                    let groupEle = {
                      tagName: "span",
                      type: "default",
                      attributes: {
                        class: "group_checbox_label",
                      },

                      components: [
                        {
                          tagName: "span",
                          type: "checkbox_input",
                          script: individualCheckboxScript,

                          attributes: {
                            class: "checkbox_input",
                          },

                          components: [
                            {
                              tagName: "input",
                              type: "default",
                              attributes: {
                                type: "checkbox",
                                id: `checkbox_1_${uniqid()}`,
                                name: `${opt[`${ArrOfObjKyename}`]}`,
                                value: `${opt[`${ArrOfObjKyename}`]}`,
                                data_db_id: `${opt[`_id`]}`
                                  ? `${opt[`_id`]}`
                                  : `${opt[`${ArrOfObjKyename}`]}`,
                              },
                            },
                          ],

                          Autofocus: false,
                          Disabled: false,
                          Required: false,
                          Checked: false,

                          traits: [
                            "id",
                            "name",
                            "value",
                            {
                              type: "checkbox",
                              name: "Autofocus",
                              label: "Autofocus",
                              changeProp: true,
                            },
                            {
                              type: "checkbox",
                              name: "Disabled",
                              label: "Disabled",
                              changeProp: true,
                            },
                            {
                              type: "checkbox",
                              name: "Required",
                              label: "Required",
                              changeProp: true,
                            },
                            {
                              type: "checkbox",
                              name: "Checked",
                              label: "Checked",
                              changeProp: true,
                            },
                          ],

                          changeProp: true,
                          "script-props": [
                            "Autofocus",
                            "Disabled",
                            "Required",
                            "Checked",
                          ],
                        },
                        {
                          tagName: "label",
                          type: "checkbox_label",
                          attributes: {
                            for: ``,
                          },

                          components: [
                            {
                              tagName: "p",
                              type: "text",
                              editable: true,

                              components: {
                                type: "textnode",
                                content: `${opt[`${ArrOfObjKyename}`]}`,
                              },
                            },
                          ],

                          traits: ["id", "for"],
                          changeProp: true,
                        },
                      ],
                    };

                    // let inputEle = {
                    //   tagName: "input",
                    //   type: "default", // so that the input component doesn't throw error of 'undefined'

                    //   script: individualCheckboxScript,

                    //   attributes: {
                    //     type: "checkbox",
                    //     // id: `${opt[`${ArrOfObjKyename}`]}`,
                    //     name: `${opt[`${ArrOfObjKyename}`]}`,
                    //     value: `${opt[`${ArrOfObjKyename}`]}`,
                    //   },

                    //   Autofocus: false,
                    //   Disabled: false,
                    //   Required: false,
                    //   Checked: false,

                    //   traits: [
                    //     "id",
                    //     "name",
                    //     "value",
                    //     {
                    //       type: "checkbox",
                    //       name: "Autofocus",
                    //       label: "Autofocus",
                    //       changeProp: true,
                    //     },
                    //     {
                    //       type: "checkbox",
                    //       name: "Disabled",
                    //       label: "Disabled",
                    //       changeProp: true,
                    //     },
                    //     {
                    //       type: "checkbox",
                    //       name: "Required",
                    //       label: "Required",
                    //       changeProp: true,
                    //     },
                    //     {
                    //       type: "checkbox",
                    //       name: "Checked",
                    //       label: "Checked",
                    //       changeProp: true,
                    //     },
                    //   ],

                    //   changeProp: true,
                    //   "script-props": [
                    //     "Autofocus",
                    //     "Disabled",
                    //     "Required",
                    //     "Checked",
                    //   ],
                    // };

                    // let labelEle = {
                    //   tagName: "label",
                    //   attributes: {
                    //     for: ``,
                    //   },

                    //   components: [
                    //     {
                    //       tagName: "p",
                    //       type: "text",
                    //       editable: true,

                    //       components: {
                    //         type: "textnode",
                    //         content: `${opt[`${ArrOfObjKyename}`]}`,
                    //       },
                    //     },
                    //   ],

                    //   traits: ["id", "for"],
                    // };

                    // container.append(inputEle);
                    // container.append(labelEle);
                    container.append(groupEle);
                  });
                }
              }

              // if API response is a plain array of single elements
              else if (Array.isArray(apiData) && !isArrayofObjects(apiData)) {
                console.log("###");
                container.components("");
                apiData.forEach((opt) => {
                  let groupEle = {
                    tagName: "span",
                    type: "default",
                    attributes: {
                      class: "group_checbox_label",
                    },

                    components: [
                      {
                        tagName: "span",
                        type: "checkbox_input",
                        script: individualCheckboxScript,

                        attributes: {
                          class: "checkbox_input",
                        },

                        components: [
                          {
                            tagName: "input",
                            type: "default",
                            attributes: {
                              type: "checkbox",
                              id: `checkbox_1_${uniqid()}`,
                              name: `ch-${opt}`,
                              value: `${opt}`,
                            },
                          },
                        ],

                        Autofocus: false,
                        Disabled: false,
                        Required: false,
                        Checked: false,

                        traits: [
                          "id",
                          "name",
                          "value",
                          {
                            type: "checkbox",
                            name: "Autofocus",
                            label: "Autofocus",
                            changeProp: true,
                          },
                          {
                            type: "checkbox",
                            name: "Disabled",
                            label: "Disabled",
                            changeProp: true,
                          },
                          {
                            type: "checkbox",
                            name: "Required",
                            label: "Required",
                            changeProp: true,
                          },
                          {
                            type: "checkbox",
                            name: "Checked",
                            label: "Checked",
                            changeProp: true,
                          },
                        ],

                        changeProp: true,
                        "script-props": [
                          "Autofocus",
                          "Disabled",
                          "Required",
                          "Checked",
                        ],
                      },
                      {
                        tagName: "label",
                        attributes: {
                          for: ``,
                        },

                        components: [
                          {
                            tagName: "p",
                            type: "text",
                            editable: true,

                            components: {
                              type: "textnode",
                              content: `${opt}`,
                            },
                          },
                        ],

                        traits: ["id", "for"],
                      },
                    ],
                  };

                  // let inputEle = {
                  //   tagName: "input",
                  //   type: "default", // so that the input component doesn't throw error of 'undefined'

                  //   script: individualCheckboxScript,

                  //   attributes: {
                  //     type: "checkbox",
                  //     // id: `ch-${opt}`,
                  //     name: `ch-${opt}`,
                  //     value: `${opt}`,
                  //   },

                  //   Autofocus: false,
                  //   Disabled: false,
                  //   Required: false,
                  //   Checked: false,

                  //   traits: [
                  //     "id",
                  //     "name",
                  //     "value",
                  //     {
                  //       type: "checkbox",
                  //       name: "Autofocus",
                  //       label: "Autofocus",
                  //       changeProp: true,
                  //     },
                  //     {
                  //       type: "checkbox",
                  //       name: "Disabled",
                  //       label: "Disabled",
                  //       changeProp: true,
                  //     },
                  //     {
                  //       type: "checkbox",
                  //       name: "Required",
                  //       label: "Required",
                  //       changeProp: true,
                  //     },
                  //     {
                  //       type: "checkbox",
                  //       name: "Checked",
                  //       label: "Checked",
                  //       changeProp: true,
                  //     },
                  //   ],

                  //   changeProp: true,
                  //   "script-props": [
                  //     "Autofocus",
                  //     "Disabled",
                  //     "Required",
                  //     "Checked",
                  //   ],
                  // };

                  // let labelEle = {
                  //   tagName: "label",
                  //   attributes: {
                  //     for: ``,
                  //   },

                  //   components: [
                  //     {
                  //       tagName: "p",
                  //       type: "text",
                  //       editable: true,

                  //       components: {
                  //         type: "textnode",
                  //         content: `${opt}`,
                  //       },
                  //     },
                  //   ],

                  //   traits: ["id", "for"],
                  // };

                  // container.append(inputEle);
                  // container.append(labelEle);
                  container.append(groupEle);
                });
              }

              // if API response is an object
              else if (
                !isArrayofObjects(apiData) &&
                typeof apiData === "object"
              ) {
                // if API response to plot is a nested array-of-objects inside the main response object
                if (NestedKeyname && ArrOfObjKyename) {
                  console.log("####");
                  container.components("");

                  // find the array-of-objects value
                  let data = findKeyValue(apiData, NestedKeyname);

                  if (isArrayofObjects(data)) {
                    data.forEach((opt) => {
                      let groupEle = {
                        tagName: "span",
                        type: "default",
                        attributes: {
                          class: "group_checbox_label",
                        },

                        components: [
                          {
                            tagName: "span",
                            type: "checkbox_input",
                            script: individualCheckboxScript,

                            attributes: {
                              class: "checkbox_input",
                            },

                            components: [
                              {
                                tagName: "input",
                                type: "default",
                                attributes: {
                                  type: "checkbox",
                                  id: `checkbox_1_${uniqid()}`,
                                  name: `${opt[`${ArrOfObjKyename}`]}`,
                                  value: `${opt[`${ArrOfObjKyename}`]}`,
                                },
                              },
                            ],

                            Autofocus: false,
                            Disabled: false,
                            Required: false,
                            Checked: false,

                            traits: [
                              "id",
                              "name",
                              "value",
                              {
                                type: "checkbox",
                                name: "Autofocus",
                                label: "Autofocus",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Disabled",
                                label: "Disabled",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Required",
                                label: "Required",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Checked",
                                label: "Checked",
                                changeProp: true,
                              },
                            ],

                            changeProp: true,
                            "script-props": [
                              "Autofocus",
                              "Disabled",
                              "Required",
                              "Checked",
                            ],
                          },
                          {
                            tagName: "label",
                            attributes: {
                              for: ``,
                            },

                            components: [
                              {
                                tagName: "p",
                                type: "text",
                                editable: true,

                                components: {
                                  type: "textnode",
                                  content: `${opt[`${ArrOfObjKyename}`]}`,
                                },
                              },
                            ],

                            traits: ["id", "for"],
                          },
                        ],
                      };

                      // let inputEle = {
                      //   tagName: "input",
                      //   type: "default", // so that the input component doesn't throw error of 'undefined'

                      //   script: individualCheckboxScript,

                      //   attributes: {
                      //     type: "checkbox",
                      //     // id: `${opt[`${ArrOfObjKyename}`]}`,
                      //     name: `${opt[`${ArrOfObjKyename}`]}`,
                      //     value: `${opt[`${ArrOfObjKyename}`]}`,
                      //   },

                      //   Autofocus: false,
                      //   Disabled: false,
                      //   Required: false,
                      //   Checked: false,

                      //   traits: [
                      //     "id",
                      //     "name",
                      //     "value",
                      //     {
                      //       type: "checkbox",
                      //       name: "Autofocus",
                      //       label: "Autofocus",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Disabled",
                      //       label: "Disabled",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Required",
                      //       label: "Required",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Checked",
                      //       label: "Checked",
                      //       changeProp: true,
                      //     },
                      //   ],

                      //   changeProp: true,
                      //   "script-props": [
                      //     "Autofocus",
                      //     "Disabled",
                      //     "Required",
                      //     "Checked",
                      //   ],
                      // };

                      // let labelEle = {
                      //   tagName: "label",
                      //   attributes: {
                      //     for: ``,
                      //   },

                      //   components: [
                      //     {
                      //       tagName: "p",
                      //       type: "text",
                      //       editable: true,

                      //       components: {
                      //         type: "textnode",
                      //         content: `${opt[`${ArrOfObjKyename}`]}`,
                      //       },
                      //     },
                      //   ],

                      //   traits: ["id", "for"],
                      // };

                      // container.append(inputEle);
                      // container.append(labelEle);
                      container.append(groupEle);
                    });
                  }
                } else if (NestedKeyname && !ArrOfObjKyename) {
                  container.components("");

                  // find the array value
                  let data = findKeyValue(apiData, NestedKeyname);

                  // if API response to plot is a nested plain array of single elements inside the main response object
                  if (Array.isArray(data) && !isArrayofObjects(data)) {
                    console.log("#####");
                    data.forEach((opt) => {
                      let groupEle = {
                        tagName: "span",
                        type: "default",
                        attributes: {
                          class: "group_checbox_label",
                        },

                        components: [
                          {
                            tagName: "span",
                            type: "checkbox_input",
                            script: individualCheckboxScript,

                            attributes: {
                              class: "checkbox_input",
                            },

                            components: [
                              {
                                tagName: "input",
                                type: "default",
                                attributes: {
                                  type: "checkbox",
                                  id: `checkbox_1_${uniqid()}`,
                                  name: `ch-${opt}`,
                                  value: `${opt}`,
                                },
                              },
                            ],

                            Autofocus: false,
                            Disabled: false,
                            Required: false,
                            Checked: false,

                            traits: [
                              "id",
                              "name",
                              "value",
                              {
                                type: "checkbox",
                                name: "Autofocus",
                                label: "Autofocus",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Disabled",
                                label: "Disabled",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Required",
                                label: "Required",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Checked",
                                label: "Checked",
                                changeProp: true,
                              },
                            ],

                            changeProp: true,
                            "script-props": [
                              "Autofocus",
                              "Disabled",
                              "Required",
                              "Checked",
                            ],
                          },
                          {
                            tagName: "label",
                            attributes: {
                              for: ``,
                            },

                            components: [
                              {
                                tagName: "p",
                                type: "text",
                                editable: true,

                                components: {
                                  type: "textnode",
                                  content: `${opt}`,
                                },
                              },
                            ],

                            traits: ["id", "for"],
                          },
                        ],
                      };

                      // let inputEle = {
                      //   tagName: "input",
                      //   type: "default", // so that the input component doesn't throw error of 'undefined'

                      //   script: individualCheckboxScript,

                      //   attributes: {
                      //     type: "checkbox",
                      //     // id: `ch-${opt}`,
                      //     name: `ch-${opt}`,
                      //     value: `${opt}`,
                      //   },

                      //   Autofocus: false,
                      //   Disabled: false,
                      //   Required: false,
                      //   Checked: false,

                      //   traits: [
                      //     "id",
                      //     "name",
                      //     "value",
                      //     {
                      //       type: "checkbox",
                      //       name: "Autofocus",
                      //       label: "Autofocus",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Disabled",
                      //       label: "Disabled",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Required",
                      //       label: "Required",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Checked",
                      //       label: "Checked",
                      //       changeProp: true,
                      //     },
                      //   ],

                      //   changeProp: true,
                      //   "script-props": [
                      //     "Autofocus",
                      //     "Disabled",
                      //     "Required",
                      //     "Checked",
                      //   ],
                      // };

                      // let labelEle = {
                      //   tagName: "label",
                      //   attributes: {
                      //     for: ``,
                      //   },

                      //   components: [
                      //     {
                      //       tagName: "p",
                      //       type: "text",
                      //       editable: true,

                      //       components: {
                      //         type: "textnode",
                      //         content: `${opt}`,
                      //       },
                      //     },
                      //   ],

                      //   traits: ["id", "for"],
                      // };

                      // container.append(inputEle);
                      // container.append(labelEle);
                      container.append(groupEle);
                    });
                  }

                  // if API response to plot are all key:value pairs of a plain object inside main object
                  else if (
                    !Array.isArray(data) &&
                    !isArrayofObjects(data) &&
                    typeof data === "object"
                  ) {
                    console.log("######");
                    Object.keys(data).forEach((key) => {
                      if (
                        !Array.isArray(data[`${key}`]) &&
                        typeof data[`${key}`] !== "object"
                      ) {
                        let groupEle = {
                          tagName: "span",
                          type: "default",
                          attributes: {
                            class: "group_checbox_label",
                          },

                          components: [
                            {
                              tagName: "span",
                              type: "checkbox_input",
                              script: individualCheckboxScript,

                              attributes: {
                                class: "checkbox_input",
                              },

                              components: [
                                {
                                  tagName: "input",
                                  type: "default",
                                  attributes: {
                                    type: "checkbox",
                                    id: `checkbox_1_${uniqid()}`,
                                    name: `${data[`${key}`]}`,
                                    value: `${data[`${key}`]}`,
                                  },
                                },
                              ],

                              Autofocus: false,
                              Disabled: false,
                              Required: false,
                              Checked: false,

                              traits: [
                                "id",
                                "name",
                                "value",
                                {
                                  type: "checkbox",
                                  name: "Autofocus",
                                  label: "Autofocus",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Disabled",
                                  label: "Disabled",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Required",
                                  label: "Required",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Checked",
                                  label: "Checked",
                                  changeProp: true,
                                },
                              ],

                              changeProp: true,
                              "script-props": [
                                "Autofocus",
                                "Disabled",
                                "Required",
                                "Checked",
                              ],
                            },
                            {
                              tagName: "label",
                              attributes: {
                                for: ``,
                              },

                              components: [
                                {
                                  tagName: "p",
                                  type: "text",
                                  editable: true,

                                  components: {
                                    type: "textnode",
                                    content: `${key}`,
                                  },
                                },
                              ],

                              traits: ["id", "for"],
                            },
                          ],
                        };

                        // let inputEle = {
                        //   tagName: "input",
                        //   type: "default", // so that the input component doesn't throw error of 'undefined'

                        //   script: individualCheckboxScript,

                        //   attributes: {
                        //     type: "checkbox",
                        //     // id: `${data[`${key}`]}`,
                        //     name: `${data[`${key}`]}`,
                        //     value: `${data[`${key}`]}`,
                        //   },

                        //   Autofocus: false,
                        //   Disabled: false,
                        //   Required: false,
                        //   Checked: false,

                        //   traits: [
                        //     "id",
                        //     "name",
                        //     "value",
                        //     {
                        //       type: "checkbox",
                        //       name: "Autofocus",
                        //       label: "Autofocus",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Disabled",
                        //       label: "Disabled",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Required",
                        //       label: "Required",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Checked",
                        //       label: "Checked",
                        //       changeProp: true,
                        //     },
                        //   ],

                        //   changeProp: true,
                        //   "script-props": [
                        //     "Autofocus",
                        //     "Disabled",
                        //     "Required",
                        //     "Checked",
                        //   ],
                        // };

                        // let labelEle = {
                        //   tagName: "label",
                        //   attributes: {
                        //     for: ``,
                        //   },

                        //   components: [
                        //     {
                        //       tagName: "p",
                        //       type: "text",
                        //       editable: true,

                        //       components: {
                        //         type: "textnode",
                        //         content: `${key}`,
                        //       },
                        //     },
                        //   ],

                        //   traits: ["id", "for"],
                        // };

                        // container.append(inputEle);
                        // container.append(labelEle);
                        container.append(groupEle);
                      }
                    });
                  }
                }

                // if API response to plot are all key:value pairs of the plain object
                else if (!NestedKeyname && !ArrOfObjKyename) {
                  console.log("#######");
                  container.components("");

                  Object.keys(apiData).forEach((key) => {
                    if (
                      !Array.isArray(apiData[`${key}`]) &&
                      typeof apiData[`${key}`] !== "object"
                    ) {
                      let groupEle = {
                        tagName: "span",
                        type: "default",
                        attributes: {
                          class: "group_checbox_label",
                        },

                        components: [
                          {
                            tagName: "span",
                            type: "checkbox_input",
                            script: individualCheckboxScript,

                            attributes: {
                              class: "checkbox_input",
                            },

                            components: [
                              {
                                tagName: "input",
                                type: "default",
                                attributes: {
                                  type: "checkbox",
                                  id: `checkbox_1_${uniqid()}`,
                                  name: `${apiData[`${key}`]}`,
                                  value: `${apiData[`${key}`]}`,
                                },
                              },
                            ],

                            Autofocus: false,
                            Disabled: false,
                            Required: false,
                            Checked: false,

                            traits: [
                              "id",
                              "name",
                              "value",
                              {
                                type: "checkbox",
                                name: "Autofocus",
                                label: "Autofocus",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Disabled",
                                label: "Disabled",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Required",
                                label: "Required",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Checked",
                                label: "Checked",
                                changeProp: true,
                              },
                            ],

                            changeProp: true,
                            "script-props": [
                              "Autofocus",
                              "Disabled",
                              "Required",
                              "Checked",
                            ],
                          },
                          {
                            tagName: "label",
                            attributes: {
                              for: ``,
                            },

                            components: [
                              {
                                tagName: "p",
                                type: "text",
                                editable: true,

                                components: {
                                  type: "textnode",
                                  content: `${key}`,
                                },
                              },
                            ],

                            traits: ["id", "for"],
                          },
                        ],
                      };

                      // let inputEle = {
                      //   tagName: "input",
                      //   type: "default", // so that the input component doesn't throw error of 'undefined'

                      //   script: individualCheckboxScript,

                      //   attributes: {
                      //     type: "checkbox",
                      //     // id: `${apiData[`${key}`]}`,
                      //     name: `${apiData[`${key}`]}`,
                      //     value: `${apiData[`${key}`]}`,
                      //   },

                      //   Autofocus: false,
                      //   Disabled: false,
                      //   Required: false,
                      //   Checked: false,

                      //   traits: [
                      //     "id",
                      //     "name",
                      //     "value",
                      //     {
                      //       type: "checkbox",
                      //       name: "Autofocus",
                      //       label: "Autofocus",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Disabled",
                      //       label: "Disabled",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Required",
                      //       label: "Required",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Checked",
                      //       label: "Checked",
                      //       changeProp: true,
                      //     },
                      //   ],

                      //   changeProp: true,
                      //   "script-props": [
                      //     "Autofocus",
                      //     "Disabled",
                      //     "Required",
                      //     "Checked",
                      //   ],
                      // };

                      // let labelEle = {
                      //   tagName: "label",
                      //   attributes: {
                      //     for: ``,
                      //   },

                      //   components: [
                      //     {
                      //       tagName: "p",
                      //       type: "text",
                      //       editable: true,

                      //       components: {
                      //         type: "textnode",
                      //         content: `${key}`,
                      //       },
                      //     },
                      //   ],

                      //   traits: ["id", "for"],
                      // };

                      // container.append(inputEle);
                      // container.append(labelEle);
                      container.append(groupEle);
                    }
                  });
                }
              }
            }
          },
        },

        view: {
          onRender({ el, model }) {
            if (el.getAttribute("data-gjs-type") === "checkbox_regular_form") {
              console.log("rendering", el);
              model.handlePropChange();
            }
          },
        },
      });

      // checkbox v2
      const individualCheckboxScriptNew = function (props) {
        console.log("this element:", this, props);

        let container = this.getElementsByTagName("input")[0];

        if (props.Autofocus) {
          container.setAttribute("autofocus", true);
        }

        if (props.Disabled) {
          container.setAttribute("disabled", true);
        }

        if (props.Required) {
          container.setAttribute("required", true);
        }

        if (props.Checked) {
          container.setAttribute("checked", true);
        }

        if (props.Value) {
          container.setAttribute("value", props.Value);
        }

        // if (props.Name) {
        //   container.setAttribute("name", props.Name);
        // }

        // if (props.Id) {
        //   container.setAttribute("id", props.Id);
        // }

        // Event delegation: Attach the event listener to a common parent
        const parentElement = this.parentNode.parentNode; // The parent container for all checkboxes

        if (parentElement) {
          parentElement.addEventListener("change", function (event) {
            // Check if the event target is a checkbox
            if (event.target && event.target.type === "checkbox") {
              console.log("Checkbox changed:", event.target);

              // Find all input elements under the div
              const inputElements = parentElement.querySelectorAll(
                "input[type='checkbox']"
              );

              // Filter out the checked input elements and retrieve their value attributes
              const checkedValues = Array.from(inputElements)
                .filter((input) => input.checked)
                .map((input) => input.value);

              const dbIds = Array.from(inputElements)
                .filter((input) => input.checked)
                .map((input) => input.getAttribute("data_db_id"));

              console.log("@checkedValues:::::::::", checkedValues);
              console.log("@dbIds", dbIds);

              parentElement.setAttribute("value", checkedValues.join("‰"));
              parentElement.setAttribute("data_db_id", dbIds.join("‰"));
            }
          });
        }
      };

      editor.DomComponents.addType("checkbox_input_new", {
        model: {
          defaults: {
            tagName: "span",
            type: "checkbox_input_new",
            script: individualCheckboxScriptNew,

            attributes: {
              class: "checkbox_input_new",
            },

            style: {
              "margin-right": "5%",
            },

            "style-default": {
              "margin-right": "5%",
            },

            components: [
              {
                tagName: "input",
                type: "default",
                attributes: {
                  type: "checkbox",
                  // id: `checkbox_1_${uniqid()}`,
                  name: `checkbox_1_${uniqid()}`,
                  value: "checkbox_1",
                },
              },
            ],

            Autofocus: false,
            Disabled: false,
            Required: false,
            Checked: false,
            Value: "",

            traits: [
              "id",
              "name",
              {
                type: "checkbox",
                name: "Autofocus",
                label: "Autofocus",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "Disabled",
                label: "Disabled",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "Required",
                label: "Required",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "Checked",
                label: "Checked",
                changeProp: true,
              },
              {
                type: "text",
                name: "Value",
                label: "Value",
                changeProp: true,
              },
            ],

            changeProp: true,
            "script-props": [
              "Autofocus",
              "Disabled",
              "Required",
              "Checked",
              "Value",
            ],
          },
        },
      });

      editor.DomComponents.addType("checkbox_label_new", {
        model: {
          defaults: {
            tagName: "label",
            type: "checkbox_label_new",
            attributes: {
              for: "",
            },

            components: [
              {
                tagName: "p",
                type: "text",
                editable: true,

                style: {
                  width: "max-content",
                  "word-break": "break-all",
                },

                "style-default": {
                  width: "max-content",
                  "word-break": "break-all",
                },

                components: {
                  type: "textnode",
                  content: "checkbox",
                },
              },
            ],

            traits: ["id", "for"],
            changeProp: true,
          },
        },
      });

      // for run-time replication
      const checkboxRegularFormNewScript = async function (props) {
        console.log(
          "checkbox_regular_form_new props",
          props,
          this,
          this.childNodes.length
        );

        // For LB download manipulation
        // checking if the url or script is not running in the redsling editor, only then run the script to plot checkboxes
        let idEl = this.id;
        const urlDownload = window.top.location.href;
        const isSubstringPresent =
          (urlDownload.indexOf("/editor/") !== -1 &&
            urlDownload.indexOf("?projectId=") !== -1) ||
          urlDownload.indexOf("/large_preview/") !== -1 ||
          urlDownload.indexOf("/tab_preview/") !== -1 ||
          urlDownload.indexOf("/mobile_preview/") !== -1 ||
          urlDownload.indexOf("/fragment_editor/") !== -1;
        if (!isSubstringPresent) {
          setInterval(function () {
            Object.keys(props).forEach(function (key) {
              if (window[`${key}${idEl}`]) {
                props[key] = window[`${key}${idEl}`];
              }
            });
          }, 500);
        }

        // base url bearer token taken directly from local storage after getting downloaded
        let baseUrlData,
          dynamicBaseUrlBearerToken,
          baseUrl1BearerToken,
          baseUrl2BearerToken,
          baseUrl3BearerToken,
          baseUrl4BearerToken,
          baseUrl5BearerToken;
        // getting baseUrl data from local storage for run-time access
        let baseUrlDataFromStorage = localStorage.getItem("baseUrlData");
        if (baseUrlDataFromStorage) {
          baseUrlData = JSON.parse(baseUrlDataFromStorage);
        }
        // extracting token values from base URLs from baseUrlData
        if (baseUrlData) {
          try {
            if (`baseUrl1_${props.projectId}` in baseUrlData) {
              baseUrl1BearerToken =
                baseUrlData[`baseUrl1_${props.projectId}`].token;
            }
            if (`baseUrl2_${props.projectId}` in baseUrlData) {
              baseUrl2BearerToken =
                baseUrlData[`baseUrl2_${props.projectId}`].token;
            }
            if (`baseUrl3_${props.projectId}` in baseUrlData) {
              baseUrl3BearerToken =
                baseUrlData[`baseUrl3_${props.projectId}`].token;
            }
            if (`baseUrl4_${props.projectId}` in baseUrlData) {
              baseUrl4BearerToken =
                baseUrlData[`baseUrl4_${props.projectId}`].token;
            }
            if (`baseUrl5_${props.projectId}` in baseUrlData) {
              baseUrl5BearerToken =
                baseUrlData[`baseUrl5_${props.projectId}`].token;
            }
          } catch (e) {
            // statements
            console.log(e);
          }
        }

        // helper function to check if a variable is an array-of-objects or not
        function isArrayofObjects(variable) {
          // Check if the variable is an array
          if (!Array.isArray(variable)) {
            return false;
          }

          // Check if all elements in the array are objects
          for (const element of variable) {
            if (
              typeof element !== "object" ||
              Array.isArray(element) ||
              element === null
            ) {
              return false;
            }
          }
          return true;
        }

        // helper function to get value of a key in nested object
        function findKeyValue(obj, key) {
          if (obj.hasOwnProperty(key)) {
            // If the current object has the key, return its value
            return obj[key];
          }

          for (var prop in obj) {
            if (obj.hasOwnProperty(prop) && typeof obj[prop] === "object") {
              // If the current property is an object, recursively search within it
              var result = findKeyValue(obj[prop], key);
              if (result !== undefined) {
                return result;
              }
            }
          }
          // Key not found in the object
          return undefined;
        }

        // helper function to create an ID string with characters randomly
        function generateRandomString(length) {
          const characters =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
          let result = "";
          for (let i = 0; i < length; i++) {
            result += characters.charAt(
              Math.floor(Math.random() * characters.length)
            );
          }
          return result;
        }

        let mainContainer = this;
        let apiData, API;

        if (props.APIPath) {
          API = props.APIPath;
        }

        // dynamic addition and deletion for the downloaded code
        if (!isSubstringPresent) {
          // -------- Getting API Data
          // if CustomUrl is provided, use only that
          if (
            props.CustomUrl &&
            (!props.BaseUrl || props.BaseUrl === "null") &&
            props.APIMethod !== "POST"
          ) {
            // if nothing is provided for auth
            if (!props.BearerToken && !props.Username && !props.Password) {
              // add extra headers, if needed
              let config = {
                headers: {},
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${props.CustomUrl}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a bearer token is provided but not api_key or usr+pwd
            else if (props.BearerToken && !props.Username && !props.Password) {
              // add extra headers, if needed
              let config = {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${props.BearerToken}`,
                },
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${props.CustomUrl}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a bearer token and api_key not provided but usr+pwd are provided
            else if (!props.BearerToken && props.Username && props.Password) {
              // add extra headers, if needed
              let config = {
                headers: {
                  Authorization:
                    "Basic " + btoa(props.Username + ":" + props.Password),
                },
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${props.CustomUrl}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }
          }

          // if base url is the choice and provided
          else if (
            props.BaseUrl &&
            API &&
            !props.CustomUrl &&
            props.APIMethod !== "POST"
          ) {
            // concatenating base url and its remaining part
            let url, baseUrlBearerToken;
            let forDownloadUrl;
            if (props.BaseUrl === "baseUrl1") {
              url = props.options.baseUrl1 + API;
              forDownloadUrl = "{{API_URL1}}" + API;
              baseUrlBearerToken = props.options.baseUrl1BearerToken;
              dynamicBaseUrlBearerToken = baseUrl1BearerToken;
            } else if (props.BaseUrl === "baseUrl2") {
              url = props.options.baseUrl2 + API;
              forDownloadUrl = "{{API_URL2}}" + API;
              baseUrlBearerToken = props.options.baseUrl2BearerToken;
              dynamicBaseUrlBearerToken = baseUrl2BearerToken;
            } else if (props.BaseUrl === "baseUrl3") {
              url = props.options.baseUrl3 + API;
              forDownloadUrl = "{{API_URL3}}" + API;
              baseUrlBearerToken = props.options.baseUrl3BearerToken;
              dynamicBaseUrlBearerToken = baseUrl3BearerToken;
            } else if (props.BaseUrl === "baseUrl4") {
              url = props.options.baseUrl4 + API;
              forDownloadUrl = "{{API_URL4}}" + API;
              baseUrlBearerToken = props.options.baseUrl4BearerToken;
              dynamicBaseUrlBearerToken = baseUrl4BearerToken;
            } else if (props.BaseUrl === "baseUrl5") {
              url = props.options.baseUrl5 + API;
              forDownloadUrl = "{{API_URL5}}" + API;
              baseUrlBearerToken = props.options.baseUrl5BearerToken;
              dynamicBaseUrlBearerToken = baseUrl5BearerToken;
            }

            // running in download
            url = forDownloadUrl;

            console.log(
              "url, dynamicBaseUrlBearerToken",
              url,
              dynamicBaseUrlBearerToken
            );

            // if nothing is provided for auth
            if (
              !props.BearerToken &&
              !dynamicBaseUrlBearerToken &&
              !props.Username &&
              !props.Password
            ) {
              // add extra headers, if needed
              let config = {
                headers: {},
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${url}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a bearer token is provided but not usr+pwd
            else if (props.BearerToken && !props.Username && !props.Password) {
              // add extra headers, if needed
              let config = {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${props.BearerToken}`,
                },
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${url}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a dynamicBaseUrlBearerToken is provided but not Custom Bearer Token and usr+pwd
            else if (
              dynamicBaseUrlBearerToken &&
              !props.BearerToken &&
              !props.Username &&
              !props.Password
            ) {
              // add extra headers, if needed
              let config = {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${dynamicBaseUrlBearerToken}`,
                },
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config@:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${url}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a bearer token is not provided but usr+pwd are provided
            else if (!props.BearerToken && props.Username && props.Password) {
              // add extra headers, if needed
              let config = {
                headers: {
                  Authorization:
                    "Basic " + btoa(props.Username + ":" + props.Password),
                },
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${url}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }
          }

          // POST method
          // if CustomUrl is provided, use only that
          if (
            props.CustomUrl &&
            (!props.BaseUrl || props.BaseUrl === "null") &&
            props.APIMethod === "POST"
          ) {
            // if nothing is provided for auth
            if (!props.BearerToken && !props.Username && !props.Password) {
              // add extra headers, if needed
              let config = {
                method: "POST",
                headers: {},
                body:
                  typeof props.APIBody === "object"
                    ? JSON.stringify(props.APIBody)
                    : props.APIBody,
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${props.CustomUrl}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a bearer token is provided but not api_key or usr+pwd
            else if (props.BearerToken && !props.Username && !props.Password) {
              // add extra headers, if needed
              let config = {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${props.BearerToken}`,
                },
                body:
                  typeof props.APIBody === "object"
                    ? JSON.stringify(props.APIBody)
                    : props.APIBody,
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${props.CustomUrl}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a bearer token and api_key not provided but usr+pwd are provided
            else if (!props.BearerToken && props.Username && props.Password) {
              // add extra headers, if needed
              let config = {
                method: "POST",
                headers: {
                  Authorization:
                    "Basic " + btoa(props.Username + ":" + props.Password),
                },
                body:
                  typeof props.APIBody === "object"
                    ? JSON.stringify(props.APIBody)
                    : props.APIBody,
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${props.CustomUrl}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }
          }

          // if base url is the choice and provided
          if (
            props.BaseUrl &&
            API &&
            !props.CustomUrl &&
            props.APIMethod === "POST"
          ) {
            // concatenating base url and its remaining part
            let url, baseUrlBearerToken;
            let forDownloadUrl;
            if (props.BaseUrl === "baseUrl1") {
              url = props.options.baseUrl1 + API;
              forDownloadUrl = "{{API_URL1}}" + API;
              baseUrlBearerToken = props.options.baseUrl1BearerToken;
              dynamicBaseUrlBearerToken = baseUrl1BearerToken;
            } else if (props.BaseUrl === "baseUrl2") {
              url = props.options.baseUrl2 + API;
              forDownloadUrl = "{{API_URL2}}" + API;
              baseUrlBearerToken = props.options.baseUrl2BearerToken;
              dynamicBaseUrlBearerToken = baseUrl2BearerToken;
            } else if (props.BaseUrl === "baseUrl3") {
              url = props.options.baseUrl3 + API;
              forDownloadUrl = "{{API_URL3}}" + API;
              baseUrlBearerToken = props.options.baseUrl3BearerToken;
              dynamicBaseUrlBearerToken = baseUrl3BearerToken;
            } else if (props.BaseUrl === "baseUrl4") {
              url = props.options.baseUrl4 + API;
              forDownloadUrl = "{{API_URL4}}" + API;
              baseUrlBearerToken = props.options.baseUrl4BearerToken;
              dynamicBaseUrlBearerToken = baseUrl4BearerToken;
            } else if (props.BaseUrl === "baseUrl5") {
              url = props.options.baseUrl5 + API;
              forDownloadUrl = "{{API_URL5}}" + API;
              baseUrlBearerToken = props.options.baseUrl5BearerToken;
              dynamicBaseUrlBearerToken = baseUrl5BearerToken;
            }

            // running in download
            url = forDownloadUrl;

            console.log(
              "url, dynamicBaseUrlBearerToken",
              url,
              dynamicBaseUrlBearerToken
            );

            // if nothing is provided for auth
            if (
              !props.BearerToken &&
              !dynamicBaseUrlBearerToken &&
              !props.Username &&
              !props.Password
            ) {
              // add extra headers, if needed
              let config = {
                method: "POST",
                headers: {},
                body:
                  typeof props.APIBody === "object"
                    ? JSON.stringify(props.APIBody)
                    : props.APIBody,
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${url}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a bearer token is provided but not usr+pwd
            else if (props.BearerToken && !props.Username && !props.Password) {
              // add extra headers, if needed
              let config = {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${props.BearerToken}`,
                },
                body:
                  typeof props.APIBody === "object"
                    ? JSON.stringify(props.APIBody)
                    : props.APIBody,
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${url}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a dynamicBaseUrlBearerToken is provided but not Custom Bearer Token and usr+pwd
            else if (
              dynamicBaseUrlBearerToken &&
              !props.BearerToken &&
              !props.Username &&
              !props.Password
            ) {
              // add extra headers, if needed
              let config = {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${dynamicBaseUrlBearerToken}`,
                },
                body:
                  typeof props.APIBody === "object"
                    ? JSON.stringify(props.APIBody)
                    : props.APIBody,
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config@:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${url}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a bearer token is not provided but usr+pwd are provided
            else if (!props.BearerToken && props.Username && props.Password) {
              // add extra headers, if needed
              let config = {
                method: "POST",
                headers: {
                  Authorization:
                    "Basic " + btoa(props.Username + ":" + props.Password),
                },
                body:
                  typeof props.APIBody === "object"
                    ? JSON.stringify(props.APIBody)
                    : props.APIBody,
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${url}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }
          }

          console.log("apiData (in export):", apiData);

          // checking if the url or script is not running in the redsling editor, only then run the script to plot checkboxes

          if (apiData) {
            console.log("#");

            if (isArrayofObjects(apiData)) {
              if (props.ArrOfObjKyename) {
                console.log("##");

                // dynamic add
                // to check if any '_id' data was changed in the backend object, then update the frontend labels of checkboxes also
                if (mainContainer.innerHTML !== "") {
                  // check if these are database plotted checkboxes or not
                  let isNotDefaultCheckbox = mainContainer
                    .getElementsByClassName("group_checkbox_label")[0]
                    .getElementsByClassName("checkbox_input_new")[0]
                    .getElementsByTagName("input")[0]
                    .getAttribute("data_db_id");
                  console.log("isNotDefaultCheckbox", isNotDefaultCheckbox);

                  // if they are database plotted checkboxes then scan through them using data_db_id and update if any
                  if (isNotDefaultCheckbox && isNotDefaultCheckbox !== "") {
                    let allMiniContainers =
                      mainContainer.getElementsByClassName(
                        "group_checkbox_label"
                      );
                    Array.from(allMiniContainers).forEach(
                      (groupCheckboxLabel, idx) => {
                        let checkbox = groupCheckboxLabel
                          .getElementsByClassName("checkbox_input_new")[0]
                          .getElementsByTagName("input")[0];
                        let checkbox_dataDbId = groupCheckboxLabel
                          .getElementsByClassName("checkbox_input_new")[0]
                          .getElementsByTagName("input")[0]
                          .getAttribute("data_db_id");
                        let label =
                          groupCheckboxLabel.getElementsByTagName("label")[0];

                        // get the object from apiData that has the checkbox_dataDbId
                        let currentObj = apiData.filter(
                          (obj) => obj["_id"] === checkbox_dataDbId
                        );

                        if (currentObj.length > 0) {
                          let labelInnerText =
                            label.getElementsByTagName("p")[0].innerHTML;
                          currentObj.forEach((obj) => {
                            console.log("labelInnerText", labelInnerText);

                            // check if the IDs match, if not then update the label's inner text
                            if (
                              labelInnerText !== obj[`${props.ArrOfObjKyename}`]
                            ) {
                              label.getElementsByTagName("p")[0].innerHTML =
                                obj[`${props.ArrOfObjKyename}`];
                              checkbox.setAttribute(
                                "value",
                                obj[`${props.ArrOfObjKyename}`]
                              );

                              console.log("currentObj", currentObj);
                            }
                          });
                        }
                      }
                    );

                    // if there are equal number of objects in apiData as checkboxes then plot new ones
                    if (apiData.length > allMiniContainers.length) {
                      // Calculate the remaining items to append
                      let remainingItems = apiData.slice(
                        allMiniContainers.length
                      );

                      remainingItems.forEach((opt) => {
                        let randomString = generateRandomString(7);
                        let groupEle = document.createElement("span");
                        groupEle.setAttribute("data-gjs-type", "default");
                        groupEle.setAttribute("class", "group_checkbox_label");
                        Object.assign(groupEle.style, {
                          display: "flex",
                          flexWrap: "no-wrap",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          width: props.CommonWidth
                            ? props.CommonWidth + "%"
                            : "8%",
                        });

                        let checkboxInputNew = document.createElement("span");
                        checkboxInputNew.setAttribute(
                          "data-gjs-type",
                          "checkbox_input_new"
                        );
                        checkboxInputNew.setAttribute(
                          "class",
                          "checkbox_input_new"
                        );

                        let checkboxInput = document.createElement("input");
                        checkboxInput.setAttribute("type", "checkbox");
                        checkboxInput.setAttribute("id", `${randomString}`);
                        checkboxInput.setAttribute("name", `${randomString}`);
                        checkboxInput.setAttribute(
                          "value",
                          `${opt[`${props.ArrOfObjKyename}`]}`
                        );
                        checkboxInput.setAttribute(
                          "data_db_id",
                          `${opt[`_id`]}`
                            ? `${opt[`_id`]}`
                            : `${opt[`${props.ArrOfObjKyename}`]}`
                        );

                        checkboxInputNew.appendChild(checkboxInput);

                        let label = document.createElement("label");
                        label.setAttribute("type", "checkbox_label_new");
                        label.setAttribute("for", `${randomString}`);
                        label.innerHTML = `<p id="${generateRandomString(6)}">${
                          opt[`${props.ArrOfObjKyename}`]
                        }</p>`;

                        groupEle.appendChild(checkboxInputNew);
                        groupEle.appendChild(label);

                        mainContainer.appendChild(groupEle);
                      });
                    }
                  }
                  // else {
                  //   mainContainer.innerHTML = "";

                  //   apiData.forEach((opt) => {
                  //     let randomString = generateRandomString(7);
                  //     let groupEle = document.createElement("span");
                  //     groupEle.setAttribute("data-gjs-type", "default");
                  //     groupEle.setAttribute("class", "group_checkbox_label");
                  //     Object.assign(groupEle.style, {
                  //       display: "flex",
                  //       flexWrap: "no-wrap",
                  //       justifyContent: "flex-start",
                  //       alignItems: "flex-start",
                  //       width: props.CommonWidth
                  //         ? props.CommonWidth + "%"
                  //         : "8%",
                  //     });

                  //     let checkboxInputNew = document.createElement("span");
                  //     checkboxInputNew.setAttribute(
                  //       "data-gjs-type",
                  //       "checkbox_input_new"
                  //     );
                  //     checkboxInputNew.setAttribute(
                  //       "class",
                  //       "checkbox_input_new"
                  //     );

                  //     let checkboxInput = document.createElement("input");
                  //     checkboxInput.setAttribute("type", "checkbox");
                  //     checkboxInput.setAttribute("id", `${randomString}`);
                  //     checkboxInput.setAttribute("name", `${randomString}`);
                  //     checkboxInput.setAttribute(
                  //       "value",
                  //       `${opt[`${props.ArrOfObjKyename}`]}`
                  //     );
                  //     checkboxInput.setAttribute(
                  //       "data_db_id",
                  //       `${opt[`_id`]}`
                  //         ? `${opt[`_id`]}`
                  //         : `${opt[`${props.ArrOfObjKyename}`]}`
                  //     );

                  //     checkboxInputNew.appendChild(checkboxInput);

                  //     let label = document.createElement("label");
                  //     label.setAttribute("type", "checkbox_label_new");
                  //     label.setAttribute("for", `${randomString}`);
                  //     // Object.assign(label.style, {
                  //     //   wordBreak: "break-all",
                  //     // });
                  //     label.innerHTML = `<p id="${generateRandomString(6)}">${
                  //       opt[`${props.ArrOfObjKyename}`]
                  //     }</p>`;

                  //     groupEle.appendChild(checkboxInputNew);
                  //     groupEle.appendChild(label);

                  //     mainContainer.appendChild(groupEle);
                  //   });
                  // }
                }

                // reasons -
                // container.components().length === 0 : plot checkboxes if there are no checkboxes present in the container
                // container.components().length === 2 : plot checkboxes the first time when there are the 2 initial checkboxes
                // apiData.length > container.components().length : plot checkboxes if apiData has more objects than checkboxes in the container meaning update the checkboxes when there is an update done in the backend database, make this dynamic
                if (
                  mainContainer.childNodes.length === 0 ||
                  (mainContainer.childNodes.length === 2 && apiData.length > 2)
                ) {
                  mainContainer.innerHTML = "";

                  apiData.forEach((opt) => {
                    let randomString = generateRandomString(7);
                    let groupEle = document.createElement("span");
                    groupEle.setAttribute("data-gjs-type", "default");
                    groupEle.setAttribute("class", "group_checkbox_label");
                    Object.assign(groupEle.style, {
                      display: "flex",
                      flexWrap: "no-wrap",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      width: props.CommonWidth ? props.CommonWidth + "%" : "8%",
                    });

                    let checkboxInputNew = document.createElement("span");
                    checkboxInputNew.setAttribute(
                      "data-gjs-type",
                      "checkbox_input_new"
                    );
                    checkboxInputNew.setAttribute(
                      "class",
                      "checkbox_input_new"
                    );

                    let checkboxInput = document.createElement("input");
                    checkboxInput.setAttribute("type", "checkbox");
                    checkboxInput.setAttribute("id", `${randomString}`);
                    checkboxInput.setAttribute("name", `${randomString}`);
                    checkboxInput.setAttribute(
                      "value",
                      `${opt[`${props.ArrOfObjKyename}`]}`
                    );
                    checkboxInput.setAttribute(
                      "data_db_id",
                      `${opt[`_id`]}`
                        ? `${opt[`_id`]}`
                        : `${opt[`${props.ArrOfObjKyename}`]}`
                    );

                    checkboxInputNew.appendChild(checkboxInput);

                    let label = document.createElement("label");
                    label.setAttribute("type", "checkbox_label_new");
                    label.setAttribute("for", `${randomString}`);
                    // Object.assign(label.style, {
                    //   wordBreak: "break-all",
                    // });
                    label.innerHTML = `<p id="${generateRandomString(6)}">${
                      opt[`${props.ArrOfObjKyename}`]
                    }</p>`;

                    groupEle.appendChild(checkboxInputNew);
                    groupEle.appendChild(label);

                    mainContainer.appendChild(groupEle);
                  });
                }

                // update only when the checkboxes have already been plotted previously from apiData but not updating if the apiData had only 2 fields
                if (
                  apiData.length > mainContainer.childNodes.length &&
                  mainContainer.childNodes.length > 2
                ) {
                  // only add what's missing from api as a dynamic update

                  // get all the labels' inner content and compare it with the keyname of the apiData to be plotted and add the ones missing
                  let allLabelEles = Array.from(
                    mainContainer.getElementsByTagName("label")
                  );
                  let allLabels = allLabelEles.map(
                    (label) => label.textContent
                  );
                  console.log("allLabelEles", allLabelEles, allLabels);

                  if (allLabelEles.length > 0) {
                    // if you find a label thats not in the apiData then add it to the existing checkbox container
                    apiData.forEach((dbRow, idx) => {
                      let randomString = generateRandomString(7);
                      // if that object from apiData is not present in the checkbox container then plot it
                      if (
                        !allLabels.includes(dbRow[`${props.ArrOfObjKyename}`])
                      ) {
                        let groupEle = document.createElement("span");
                        groupEle.setAttribute("data-gjs-type", "default");
                        groupEle.setAttribute("class", "group_checkbox_label");
                        Object.assign(groupEle.style, {
                          display: "flex",
                          flexWrap: "no-wrap",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          width: props.CommonWidth
                            ? props.CommonWidth + "%"
                            : "8%",
                        });

                        let checkboxInputNew = document.createElement("span");
                        checkboxInputNew.setAttribute(
                          "data-gjs-type",
                          "checkbox_input_new"
                        );
                        checkboxInputNew.setAttribute(
                          "class",
                          "checkbox_input_new"
                        );

                        let checkboxInput = document.createElement("input");
                        checkboxInput.setAttribute("type", "checkbox");
                        checkboxInput.setAttribute("id", `${randomString}`);
                        checkboxInput.setAttribute("name", `${randomString}`);
                        checkboxInput.setAttribute(
                          "value",
                          `${dbRow[`${props.ArrOfObjKyename}`]}`
                        );
                        checkboxInput.setAttribute(
                          "data_db_id",
                          `${dbRow[`_id`]}`
                            ? `${dbRow[`_id`]}`
                            : `${dbRow[`${props.ArrOfObjKyename}`]}`
                        );

                        checkboxInputNew.appendChild(checkboxInput);

                        let label = document.createElement("label");
                        label.setAttribute("type", "checkbox_label_new");
                        label.setAttribute("for", `${randomString}`);
                        // Object.assign(label.style, {
                        //   wordBreak: "break-all",
                        // });
                        label.innerHTML = `<p id="${generateRandomString(6)}">${
                          dbRow[`${props.ArrOfObjKyename}`]
                        }</p>`;

                        groupEle.appendChild(checkboxInputNew);
                        groupEle.appendChild(label);

                        mainContainer.appendChild(groupEle);
                      }
                    });
                  }
                }

                // plot when the apiData has only around 2 entries
                // else if (apiData.length <= 2) {
                //   // see if the checkboxes are the default checkboxes by checking if they have this attribute 'data_db_id', if yes then clear the body and append new else append new checkboxes anyways
                //   let isNotDefaultCheckbox = mainContainer
                //     .getElementsByTagName("input")[0]
                //     .getAttribute("data_db_id");

                //   // if it is a default checkbox then empty the body before appending apiData checkboxes
                //   if (!isNotDefaultCheckbox) {
                //     mainContainer.innerHTML = "";
                //     apiData.forEach((opt) => {
                //       let randomString = generateRandomString(7);
                //       let groupEle = document.createElement("span");
                //       groupEle.setAttribute("data-gjs-type", "default");
                //       groupEle.setAttribute("class", "group_checkbox_label");
                //       Object.assign(groupEle.style, {
                //         display: "flex",
                //         flexWrap: "no-wrap",
                //         justifyContent: "flex-start",
                //         alignItems: "flex-start",
                //         width: props.CommonWidth
                //           ? props.CommonWidth + "%"
                //           : "8%",
                //       });

                //       let checkboxInputNew = document.createElement("span");
                //       checkboxInputNew.setAttribute(
                //         "data-gjs-type",
                //         "checkbox_input_new"
                //       );
                //       checkboxInputNew.setAttribute(
                //         "class",
                //         "checkbox_input_new"
                //       );

                //       let checkboxInput = document.createElement("input");
                //       checkboxInput.setAttribute("type", "checkbox");
                //       checkboxInput.setAttribute("id", `${randomString}`);
                //       checkboxInput.setAttribute("name", `${randomString}`);
                //       checkboxInput.setAttribute(
                //         "value",
                //         `${opt[`${props.ArrOfObjKyename}`]}`
                //       );
                //       checkboxInput.setAttribute(
                //         "data_db_id",
                //         `${opt[`_id`]}`
                //           ? `${opt[`_id`]}`
                //           : `${opt[`${props.ArrOfObjKyename}`]}`
                //       );

                //       checkboxInputNew.appendChild(checkboxInput);

                //       let label = document.createElement("label");
                //       label.setAttribute("type", "checkbox_label_new");
                //       label.setAttribute("for", `${randomString}`);
                //       // Object.assign(label.style, {
                //       //   wordBreak: "break-all",
                //       // });
                //       label.innerHTML = `<p id="${generateRandomString(6)}">${
                //         opt[`${props.ArrOfObjKyename}`]
                //       }</p>`;

                //       groupEle.appendChild(checkboxInputNew);
                //       groupEle.appendChild(label);

                //       mainContainer.appendChild(groupEle);
                //     });
                //   } else {
                //     mainContainer.innerHTML = "";

                //     apiData.forEach((opt) => {
                //       let randomString = generateRandomString(7);
                //       let groupEle = document.createElement("span");
                //       groupEle.setAttribute("data-gjs-type", "default");
                //       groupEle.setAttribute("class", "group_checkbox_label");
                //       Object.assign(groupEle.style, {
                //         display: "flex",
                //         flexWrap: "no-wrap",
                //         justifyContent: "flex-start",
                //         alignItems: "flex-start",
                //         width: props.CommonWidth
                //           ? props.CommonWidth + "%"
                //           : "8%",
                //       });

                //       let checkboxInputNew = document.createElement("span");
                //       checkboxInputNew.setAttribute(
                //         "data-gjs-type",
                //         "checkbox_input_new"
                //       );
                //       checkboxInputNew.setAttribute(
                //         "class",
                //         "checkbox_input_new"
                //       );

                //       let checkboxInput = document.createElement("input");
                //       checkboxInput.setAttribute("type", "checkbox");
                //       checkboxInput.setAttribute("id", `${randomString}`);
                //       checkboxInput.setAttribute("name", `${randomString}`);
                //       checkboxInput.setAttribute(
                //         "value",
                //         `${opt[`${props.ArrOfObjKyename}`]}`
                //       );
                //       checkboxInput.setAttribute(
                //         "data_db_id",
                //         `${opt[`_id`]}`
                //           ? `${opt[`_id`]}`
                //           : `${opt[`${props.ArrOfObjKyename}`]}`
                //       );

                //       checkboxInputNew.appendChild(checkboxInput);

                //       let label = document.createElement("label");
                //       label.setAttribute("type", "checkbox_label_new");
                //       label.setAttribute("for", `${randomString}`);
                //       // Object.assign(label.style, {
                //       //   wordBreak: "break-all",
                //       // });
                //       label.innerHTML = `<p id="${generateRandomString(6)}">${
                //         opt[`${props.ArrOfObjKyename}`]
                //       }</p>`;

                //       groupEle.appendChild(checkboxInputNew);
                //       groupEle.appendChild(label);

                //       mainContainer.appendChild(groupEle);
                //     });
                //   }
                // }

                // dynamic delete
                if (mainContainer.childNodes.length > apiData.length) {
                  console.log("removing extra group_checkbox_labels");

                  let groupCheckboxLabels =
                    mainContainer.getElementsByClassName(
                      "group_checkbox_label"
                    );
                  Array.from(groupCheckboxLabels).forEach(
                    (groupCheckboxLabel) => {
                      let checkbox = groupCheckboxLabel
                        .getElementsByClassName("checkbox_input_new")[0]
                        .getElementsByTagName("input")[0];
                      let checkboxDataDbId =
                        checkbox.getAttribute("data_db_id");

                      // see if checkboxDataDbId is in apiData _ids and if not there, delete this group_checkbox_label
                      let apiData_id = apiData.map((obj) => obj["_id"]);

                      if (!apiData_id.includes(checkboxDataDbId)) {
                        groupCheckboxLabel.remove();
                        console.log("removed");
                      }
                    }
                  );
                }
              }
            }

            // if API response is a plain array of single elements
            else if (Array.isArray(apiData) && !isArrayofObjects(apiData)) {
              console.log("###");

              // either no checkboxes are plotted or the default 2 checkboxes are there
              if (
                mainContainer.childNodes.length === 0 ||
                mainContainer.childNodes.length <= 2
              ) {
                mainContainer.innerHTML = "";

                apiData.forEach((opt) => {
                  let randomString = generateRandomString(7);
                  let groupEle = document.createElement("span");
                  groupEle.setAttribute("data-gjs-type", "default");
                  groupEle.setAttribute("class", "group_checkbox_label");
                  Object.assign(groupEle.style, {
                    display: "flex",
                    flexWrap: "no-wrap",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    width: props.CommonWidth ? props.CommonWidth + "%" : "8%",
                  });

                  let checkboxInputNew = document.createElement("span");
                  checkboxInputNew.setAttribute(
                    "data-gjs-type",
                    "checkbox_input_new"
                  );
                  checkboxInputNew.setAttribute("class", "checkbox_input_new");

                  let checkboxInput = document.createElement("input");
                  checkboxInput.setAttribute("type", "checkbox");
                  checkboxInput.setAttribute("id", `${randomString}`);
                  checkboxInput.setAttribute("name", `${randomString}`);
                  checkboxInput.setAttribute("value", `${opt}`);

                  checkboxInputNew.appendChild(checkboxInput);

                  let label = document.createElement("label");
                  label.setAttribute("type", "checkbox_label_new");
                  label.setAttribute("for", `${randomString}`);
                  // Object.assign(label.style, {
                  //   wordBreak: "break-all",
                  // });
                  label.innerHTML = `<p id="${generateRandomString(
                    6
                  )}">${opt}</p>`;

                  groupEle.appendChild(checkboxInputNew);
                  groupEle.appendChild(label);

                  mainContainer.appendChild(groupEle);
                });
              }

              // else if the apiData checkboxes are already plotted then check for updated values and add those here without changing the IDd of already plotted ones
              else if (
                apiData.length > mainContainer.childNodes.length &&
                mainContainer.childNodes.length > 2
              ) {
                // only add what's missing from api as a dynamic update

                // get all the labels' inner content and compare it with the keyname of the apiData to be plotted and add the ones missing
                let allLabelEles = Array.from(
                  mainContainer.getElementsByTagName("label")
                );
                let allLabels = allLabelEles.map((label) => label.textContent);
                console.log("allLabelEles", allLabelEles, allLabels);

                if (allLabelEles.length > 0) {
                  // if you find a label thats not in the apiData then add it to the existing checkbox container
                  apiData.forEach((opt, idx) => {
                    let randomString = generateRandomString(7);
                    // if that object from apiData is not present in the checkbox container then plot it
                    if (!allLabels.includes(opt)) {
                      let groupEle = document.createElement("span");
                      groupEle.setAttribute("data-gjs-type", "default");
                      groupEle.setAttribute("class", "group_checkbox_label");
                      Object.assign(groupEle.style, {
                        display: "flex",
                        flexWrap: "no-wrap",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        width: props.CommonWidth
                          ? props.CommonWidth + "%"
                          : "8%",
                      });

                      let checkboxInputNew = document.createElement("span");
                      checkboxInputNew.setAttribute(
                        "data-gjs-type",
                        "checkbox_input_new"
                      );
                      checkboxInputNew.setAttribute(
                        "class",
                        "checkbox_input_new"
                      );

                      let checkboxInput = document.createElement("input");
                      checkboxInput.setAttribute("type", "checkbox");
                      checkboxInput.setAttribute("id", `${randomString}`);
                      checkboxInput.setAttribute("name", `${randomString}`);
                      checkboxInput.setAttribute("value", `${opt}`);

                      checkboxInputNew.appendChild(checkboxInput);

                      let label = document.createElement("label");
                      label.setAttribute("type", "checkbox_label_new");
                      label.setAttribute("for", `${randomString}`);
                      // Object.assign(label.style, {
                      //   wordBreak: "break-all",
                      // });
                      label.innerHTML = `<p id="${generateRandomString(
                        6
                      )}">${opt}</p>`;

                      groupEle.appendChild(checkboxInputNew);
                      groupEle.appendChild(label);

                      mainContainer.appendChild(groupEle);
                    }
                  });
                }
              }
            }

            // if API response is an object
            else if (
              !isArrayofObjects(apiData) &&
              typeof apiData === "object"
            ) {
              // if API response to plot is a nested array-of-objects inside the main response object
              if (props.NestedKeyname && props.ArrOfObjKyename) {
                console.log("####");
                // container.components("");

                // find the array-of-objects value
                let data = findKeyValue(apiData, props.NestedKeyname);

                if (isArrayofObjects(data)) {
                  // to check if any '_id' data was changed in the backend object, then update the frontend labels of checkboxes also
                  if (mainContainer.innerHTML !== "") {
                    // check if these are database plotted checkboxes or not
                    let isNotDefaultCheckbox = mainContainer
                      .getElementsByClassName("group_checkbox_label")[0]
                      .getElementsByClassName("checkbox_input_new")[0]
                      .getElementsByTagName("input")[0]
                      .getAttribute("data_db_id");
                    console.log("isNotDefaultCheckbox", isNotDefaultCheckbox);

                    // if they are database plotted checkboxes then scan through them using data_db_id and update if any
                    if (isNotDefaultCheckbox) {
                      let allMiniContainers =
                        mainContainer.getElementsByClassName(
                          "group_checkbox_label"
                        );
                      Array.from(allMiniContainers).forEach(
                        (groupCheckboxLabel, idx) => {
                          let checkbox = groupCheckboxLabel
                            .getElementsByClassName("checkbox_input_new")[0]
                            .getElementsByTagName("input")[0];
                          let checkbox_dataDbId = groupCheckboxLabel
                            .getElementsByClassName("checkbox_input_new")[0]
                            .getElementsByTagName("input")[0]
                            .getAttribute("data_db_id");
                          let label =
                            groupCheckboxLabel.getElementsByTagName("label")[0];

                          // get the object from apiData that has the checkbox_dataDbId
                          let currentObj = data.filter(
                            (obj) => obj["_id"] === checkbox_dataDbId
                          );

                          if (currentObj.length > 0) {
                            currentObj.forEach((obj) => {
                              let labelInnerText =
                                label.getElementsByTagName("p")[0].innerHTML;
                              console.log("labelInnerText", labelInnerText);

                              // check if the IDs match, if not then update the label's inner text
                              if (
                                labelInnerText !==
                                obj[`${props.ArrOfObjKyename}`]
                              ) {
                                label.getElementsByTagName("p")[0].innerHTML =
                                  obj[`${props.ArrOfObjKyename}`];
                                checkbox.setAttribute(
                                  "value",
                                  obj[`${props.ArrOfObjKyename}`]
                                );

                                console.log("currentObj", currentObj);
                              }
                            });
                          }
                        }
                      );
                    }
                  }

                  // reasons -
                  // container.components().length === 0 : plot checkboxes if there are no checkboxes present in the container
                  // container.components().length === 2 : plot checkboxes the first time when there are the 2 initial checkboxes
                  // apiData.length > container.components().length : plot checkboxes if apiData has more objects than checkboxes in the container meaning update the checkboxes when there is an update done in the backend database, make this dynamic
                  if (
                    mainContainer.childNodes.length === 0 ||
                    (mainContainer.childNodes.length === 2 && data.length > 2)
                  ) {
                    mainContainer.innerHTML = "";

                    data.forEach((opt) => {
                      let randomString = generateRandomString(7);
                      let groupEle = document.createElement("span");
                      groupEle.setAttribute("data-gjs-type", "default");
                      groupEle.setAttribute("class", "group_checkbox_label");
                      Object.assign(groupEle.style, {
                        display: "flex",
                        flexWrap: "no-wrap",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        width: props.CommonWidth
                          ? props.CommonWidth + "%"
                          : "8%",
                      });

                      let checkboxInputNew = document.createElement("span");
                      checkboxInputNew.setAttribute(
                        "data-gjs-type",
                        "checkbox_input_new"
                      );
                      checkboxInputNew.setAttribute(
                        "class",
                        "checkbox_input_new"
                      );

                      let checkboxInput = document.createElement("input");
                      checkboxInput.setAttribute("type", "checkbox");
                      checkboxInput.setAttribute("id", `${randomString}`);
                      checkboxInput.setAttribute("name", `${randomString}`);
                      checkboxInput.setAttribute(
                        "value",
                        `${opt[`${props.ArrOfObjKyename}`]}`
                      );
                      checkboxInput.setAttribute(
                        "data_db_id",
                        `${opt[`_id`]}`
                          ? `${opt[`_id`]}`
                          : `${opt[`${props.ArrOfObjKyename}`]}`
                      );

                      checkboxInputNew.appendChild(checkboxInput);

                      let label = document.createElement("label");
                      label.setAttribute("type", "checkbox_label_new");
                      label.setAttribute("for", `${randomString}`);
                      // Object.assign(label.style, {
                      //   wordBreak: "break-all",
                      // });
                      label.innerHTML = `<p id="${generateRandomString(6)}">${
                        opt[`${props.ArrOfObjKyename}`]
                      }</p>`;

                      groupEle.appendChild(checkboxInputNew);
                      groupEle.appendChild(label);

                      mainContainer.appendChild(groupEle);
                    });
                  }

                  // update only when the checkboxes have already been plotted previously from apiData but not updating if the apiData had only 2 fields
                  if (
                    data.length > mainContainer.childNodes.length &&
                    mainContainer.childNodes.length > 2
                  ) {
                    // only add what's missing from api as a dynamic update

                    // get all the labels' inner content and compare it with the keyname of the apiData to be plotted and add the ones missing
                    let allLabelEles = Array.from(
                      mainContainer.getElementsByTagName("label")
                    );
                    let allLabels = allLabelEles.map(
                      (label) => label.textContent
                    );
                    console.log("allLabelEles", allLabelEles, allLabels);

                    if (allLabelEles.length > 0) {
                      // if you find a label thats not in the apiData then add it to the existing checkbox container
                      data.forEach((dbRow, idx) => {
                        let randomString = generateRandomString(7);
                        // if that object from apiData is not present in the checkbox container then plot it
                        if (
                          !allLabels.includes(dbRow[`${props.ArrOfObjKyename}`])
                        ) {
                          let groupEle = document.createElement("span");
                          groupEle.setAttribute("data-gjs-type", "default");
                          groupEle.setAttribute(
                            "class",
                            "group_checkbox_label"
                          );
                          Object.assign(groupEle.style, {
                            display: "flex",
                            flexWrap: "no-wrap",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            width: props.CommonWidth
                              ? props.CommonWidth + "%"
                              : "8%",
                          });

                          let checkboxInputNew = document.createElement("span");
                          checkboxInputNew.setAttribute(
                            "data-gjs-type",
                            "checkbox_input_new"
                          );
                          checkboxInputNew.setAttribute(
                            "class",
                            "checkbox_input_new"
                          );

                          let checkboxInput = document.createElement("input");
                          checkboxInput.setAttribute("type", "checkbox");
                          checkboxInput.setAttribute("id", `${randomString}`);
                          checkboxInput.setAttribute("name", `${randomString}`);
                          checkboxInput.setAttribute(
                            "value",
                            `${dbRow[`${props.ArrOfObjKyename}`]}`
                          );
                          checkboxInput.setAttribute(
                            "data_db_id",
                            `${dbRow[`_id`]}`
                              ? `${dbRow[`_id`]}`
                              : `${dbRow[`${props.ArrOfObjKyename}`]}`
                          );

                          checkboxInputNew.appendChild(checkboxInput);

                          let label = document.createElement("label");
                          label.setAttribute("type", "checkbox_label_new");
                          label.setAttribute("for", `${randomString}`);
                          // Object.assign(label.style, {
                          //   wordBreak: "break-all",
                          // });
                          label.innerHTML = `<p id="${generateRandomString(
                            6
                          )}">${dbRow[`${props.ArrOfObjKyename}`]}</p>`;

                          groupEle.appendChild(checkboxInputNew);
                          groupEle.appendChild(label);

                          mainContainer.appendChild(groupEle);
                        }
                      });
                    }
                  }

                  // plot when the apiData has only around 2 entries
                  else if (data.length <= 2) {
                    // see if the checkboxes are the default checkboxes by checking if they have this attribute 'data_db_id', if yes then clear the body and append new else append new checkboxes anyways
                    let isNotDefaultCheckbox = mainContainer
                      .getElementsByTagName("input")[0]
                      .getAttribute("data_db_id");

                    // if it is a default checkbox then empty the body before appending apiData checkboxes
                    if (!isNotDefaultCheckbox) {
                      mainContainer.innerHTML = "";
                      data.forEach((opt) => {
                        let randomString = generateRandomString(7);
                        let groupEle = document.createElement("span");
                        groupEle.setAttribute("data-gjs-type", "default");
                        groupEle.setAttribute("class", "group_checkbox_label");
                        Object.assign(groupEle.style, {
                          display: "flex",
                          flexWrap: "no-wrap",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          width: props.CommonWidth
                            ? props.CommonWidth + "%"
                            : "8%",
                        });

                        let checkboxInputNew = document.createElement("span");
                        checkboxInputNew.setAttribute(
                          "data-gjs-type",
                          "checkbox_input_new"
                        );
                        checkboxInputNew.setAttribute(
                          "class",
                          "checkbox_input_new"
                        );

                        let checkboxInput = document.createElement("input");
                        checkboxInput.setAttribute("type", "checkbox");
                        checkboxInput.setAttribute("id", `${randomString}`);
                        checkboxInput.setAttribute("name", `${randomString}`);
                        checkboxInput.setAttribute(
                          "value",
                          `${opt[`${props.ArrOfObjKyename}`]}`
                        );
                        checkboxInput.setAttribute(
                          "data_db_id",
                          `${opt[`_id`]}`
                            ? `${opt[`_id`]}`
                            : `${opt[`${props.ArrOfObjKyename}`]}`
                        );

                        checkboxInputNew.appendChild(checkboxInput);

                        let label = document.createElement("label");
                        label.setAttribute("type", "checkbox_label_new");
                        label.setAttribute("for", `${randomString}`);
                        // Object.assign(label.style, {
                        //   wordBreak: "break-all",
                        // });
                        label.innerHTML = `<p id="${generateRandomString(6)}">${
                          opt[`${props.ArrOfObjKyename}`]
                        }</p>`;

                        groupEle.appendChild(checkboxInputNew);
                        groupEle.appendChild(label);

                        mainContainer.appendChild(groupEle);
                      });
                    }
                  }

                  // dynamic delete
                  if (mainContainer.childNodes.length > data.length) {
                    console.log("removing extra group_checkbox_labels");

                    let groupCheckboxLabels =
                      mainContainer.getElementsByClassName(
                        "group_checkbox_label"
                      );
                    Array.from(groupCheckboxLabels).forEach(
                      (groupCheckboxLabel) => {
                        let checkbox = groupCheckboxLabel
                          .getElementsByClassName("checkbox_input_new")[0]
                          .getElementsByTagName("input")[0];
                        let checkboxDataDbId =
                          checkbox.getAttribute("data_db_id");

                        // see if checkboxDataDbId is in apiData _ids and if not there, delete this group_checkbox_label
                        let apiData_id = data.map((obj) => obj["_id"]);

                        if (!apiData_id.includes(checkboxDataDbId)) {
                          groupCheckboxLabel.remove();
                          console.log("removed");
                        }
                      }
                    );
                  }
                }
              } else if (props.NestedKeyname && !props.ArrOfObjKyename) {
                // container.components("");

                // find the array value
                let data = findKeyValue(apiData, props.NestedKeyname);

                // if API response to plot is a nested plain array of single elements inside the main response object
                if (Array.isArray(apiData) && !isArrayofObjects(apiData)) {
                  console.log("###");

                  // either no checkboxes are plotted or the default 2 checkboxes are there
                  if (
                    mainContainer.childNodes.length === 0 ||
                    mainContainer.childNodes.length <= 2
                  ) {
                    mainContainer.innerHTML = "";

                    data.forEach((opt) => {
                      let randomString = generateRandomString(7);
                      let groupEle = document.createElement("span");
                      groupEle.setAttribute("data-gjs-type", "default");
                      groupEle.setAttribute("class", "group_checkbox_label");
                      Object.assign(groupEle.style, {
                        display: "flex",
                        flexWrap: "no-wrap",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        width: props.CommonWidth
                          ? props.CommonWidth + "%"
                          : "8%",
                      });

                      let checkboxInputNew = document.createElement("span");
                      checkboxInputNew.setAttribute(
                        "data-gjs-type",
                        "checkbox_input_new"
                      );
                      checkboxInputNew.setAttribute(
                        "class",
                        "checkbox_input_new"
                      );

                      let checkboxInput = document.createElement("input");
                      checkboxInput.setAttribute("type", "checkbox");
                      checkboxInput.setAttribute("id", `${randomString}`);
                      checkboxInput.setAttribute("name", `${randomString}`);
                      checkboxInput.setAttribute("value", `${opt}`);

                      checkboxInputNew.appendChild(checkboxInput);

                      let label = document.createElement("label");
                      label.setAttribute("type", "checkbox_label_new");
                      label.setAttribute("for", `${randomString}`);
                      // Object.assign(label.style, {
                      //   wordBreak: "break-all",
                      // });
                      label.innerHTML = `<p id="${generateRandomString(
                        6
                      )}">${opt}</p>`;

                      groupEle.appendChild(checkboxInputNew);
                      groupEle.appendChild(label);

                      mainContainer.appendChild(groupEle);
                    });
                  }

                  // else if the apiData checkboxes are already plotted then check for updated values and add those here without changing the IDd of already plotted ones
                  else if (
                    data.length > mainContainer.childNodes.length &&
                    mainContainer.childNodes.length > 2
                  ) {
                    // only add what's missing from api as a dynamic update

                    // get all the labels' inner content and compare it with the keyname of the apiData to be plotted and add the ones missing
                    let allLabelEles = Array.from(
                      mainContainer.getElementsByTagName("label")
                    );
                    let allLabels = allLabelEles.map(
                      (label) => label.textContent
                    );
                    console.log("allLabelEles", allLabelEles, allLabels);

                    if (allLabelEles.length > 0) {
                      // if you find a label thats not in the apiData then add it to the existing checkbox container
                      data.forEach((opt, idx) => {
                        let randomString = generateRandomString(7);
                        // if that object from apiData is not present in the checkbox container then plot it
                        if (!allLabels.includes(opt)) {
                          let groupEle = document.createElement("span");
                          groupEle.setAttribute("data-gjs-type", "default");
                          groupEle.setAttribute(
                            "class",
                            "group_checkbox_label"
                          );
                          Object.assign(groupEle.style, {
                            display: "flex",
                            flexWrap: "no-wrap",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            width: props.CommonWidth
                              ? props.CommonWidth + "%"
                              : "8%",
                          });

                          let checkboxInputNew = document.createElement("span");
                          checkboxInputNew.setAttribute(
                            "data-gjs-type",
                            "checkbox_input_new"
                          );
                          checkboxInputNew.setAttribute(
                            "class",
                            "checkbox_input_new"
                          );

                          let checkboxInput = document.createElement("input");
                          checkboxInput.setAttribute("type", "checkbox");
                          checkboxInput.setAttribute("id", `${randomString}`);
                          checkboxInput.setAttribute("name", `${randomString}`);
                          checkboxInput.setAttribute("value", `${opt}`);

                          checkboxInputNew.appendChild(checkboxInput);

                          let label = document.createElement("label");
                          label.setAttribute("type", "checkbox_label_new");
                          label.setAttribute("for", `${randomString}`);
                          // Object.assign(label.style, {
                          //   wordBreak: "break-all",
                          // });
                          label.innerHTML = `<p id="${generateRandomString(
                            6
                          )}">${opt}</p>`;

                          groupEle.appendChild(checkboxInputNew);
                          groupEle.appendChild(label);

                          mainContainer.appendChild(groupEle);
                        }
                      });
                    }
                  }
                }

                // if API response to plot are all key:value pairs of a plain object inside main object
                else if (
                  !Array.isArray(data) &&
                  !isArrayofObjects(data) &&
                  typeof data === "object"
                ) {
                  console.log("######");
                  Object.keys(data).forEach((key) => {
                    if (
                      !Array.isArray(data[`${key}`]) &&
                      typeof data[`${key}`] !== "object"
                    ) {
                      let randomString = generateRandomString(7);

                      let groupEle = document.createElement("span");
                      groupEle.setAttribute("data-gjs-type", "default");
                      groupEle.setAttribute("class", "group_checkbox_label");
                      Object.assign(groupEle.style, {
                        display: "flex",
                        flexWrap: "no-wrap",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        width: props.CommonWidth
                          ? props.CommonWidth + "%"
                          : "8%",
                      });

                      let checkboxInputNew = document.createElement("span");
                      checkboxInputNew.setAttribute(
                        "data-gjs-type",
                        "checkbox_input_new"
                      );
                      checkboxInputNew.setAttribute(
                        "class",
                        "checkbox_input_new"
                      );

                      let checkboxInput = document.createElement("input");
                      checkboxInput.setAttribute("type", "checkbox");
                      checkboxInput.setAttribute("id", `${randomString}`);
                      checkboxInput.setAttribute("name", `${randomString}`);
                      checkboxInput.setAttribute("value", `${data[`${key}`]}`);

                      checkboxInputNew.appendChild(checkboxInput);

                      let label = document.createElement("label");
                      label.setAttribute("type", "checkbox_label_new");
                      label.setAttribute("for", `${randomString}`);
                      // Object.assign(label.style, {
                      //   wordBreak: "break-all",
                      // });
                      label.innerHTML = `<p id="${generateRandomString(
                        6
                      )}">${key}</p>`;

                      groupEle.appendChild(checkboxInputNew);
                      groupEle.appendChild(label);

                      mainContainer.appendChild(groupEle);
                    }
                  });
                }
              }

              // if API response to plot are all key:value pairs of the plain object
              else if (!props.NestedKeyname && !props.ArrOfObjKyename) {
                console.log("#######");
                mainContainer.innerHTML = "";

                Object.keys(apiData).forEach((key) => {
                  let randomString = generateRandomString(7);

                  if (
                    !Array.isArray(apiData[`${key}`]) &&
                    typeof apiData[`${key}`] !== "object"
                  ) {
                    let groupEle = document.createElement("span");
                    groupEle.setAttribute("data-gjs-type", "default");
                    groupEle.setAttribute("class", "group_checkbox_label");
                    Object.assign(groupEle.style, {
                      display: "flex",
                      flexWrap: "no-wrap",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      width: props.CommonWidth ? props.CommonWidth + "%" : "8%",
                    });

                    let checkboxInputNew = document.createElement("span");
                    checkboxInputNew.setAttribute(
                      "data-gjs-type",
                      "checkbox_input_new"
                    );
                    checkboxInputNew.setAttribute(
                      "class",
                      "checkbox_input_new"
                    );

                    let checkboxInput = document.createElement("input");
                    checkboxInput.setAttribute("type", "checkbox");
                    checkboxInput.setAttribute("id", `${randomString}`);
                    checkboxInput.setAttribute("name", `${randomString}`);
                    checkboxInput.setAttribute("value", `${apiData[`${key}`]}`);

                    checkboxInputNew.appendChild(checkboxInput);

                    let label = document.createElement("label");
                    label.setAttribute("type", "checkbox_label_new");
                    label.setAttribute("for", `${randomString}`);
                    // Object.assign(label.style, {
                    //   wordBreak: "break-all",
                    // });
                    label.innerHTML = `<p id="${generateRandomString(
                      6
                    )}">${key}</p>`;

                    groupEle.appendChild(checkboxInputNew);
                    groupEle.appendChild(label);

                    mainContainer.appendChild(groupEle);
                  }
                });
              }

              // if there is a 'message' in api response instead of data
              else if (Object.keys(apiData).includes("message")) {
                console.log("#@@");

                mainContainer.innerHTML = "";
                let randomString = generateRandomString(7);
                let groupEle = document.createElement("span");
                groupEle.setAttribute("data-gjs-type", "default");
                groupEle.setAttribute("class", "group_checkbox_label");
                Object.assign(groupEle.style, {
                  display: "flex",
                  flexWrap: "no-wrap",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  width: props.CommonWidth ? props.CommonWidth + "%" : "8%",
                });

                let checkboxInputNew = document.createElement("span");
                checkboxInputNew.setAttribute(
                  "data-gjs-type",
                  "checkbox_input_new"
                );
                checkboxInputNew.setAttribute("class", "checkbox_input_new");

                let checkboxInput = document.createElement("input");
                checkboxInput.setAttribute("type", "checkbox");
                checkboxInput.setAttribute("id", `${randomString}`);
                checkboxInput.setAttribute("name", `${randomString}`);
                checkboxInput.style.display = "none";

                checkboxInputNew.appendChild(checkboxInput);

                let label = document.createElement("label");
                label.setAttribute("type", "checkbox_label_new");
                label.setAttribute("for", `${randomString}`);
                // Object.assign(label.style, {
                //   wordBreak: "break-all",
                // });
                label.innerHTML = `<p id="${generateRandomString(
                  6
                )}">No Values.</p>`;

                groupEle.appendChild(checkboxInputNew);
                groupEle.appendChild(label);

                mainContainer.appendChild(groupEle);
              }
            }

            replicateStyle();
          } else {
            console.log(
              '"/editor/" & "?projectId=" substrings are present together in the browser URL.'
            );
          }
        }

        // helper function to apply styling
        function applyStyle(element, style) {
          if (!element) {
            console.error("Element is undefined:", element);
            return;
          }

          for (let key in style) {
            if (style.hasOwnProperty(key)) {
              element.style[key] = style[key];
            }
          }
        }

        // for style replication of first checkbox to the rest
        function replicateStyle() {
          if (props.ReplicateStyling) {
            // Get the first radio component
            let firstGroup = mainContainer.querySelector(
              ".group_checkbox_label"
            );

            if (firstGroup) {
              let firstGroupStyle = window.getComputedStyle(firstGroup);

              // Apply styling to all other group_radio_label components
              let groups = mainContainer.querySelectorAll(
                ".group_checkbox_label"
              );
              groups.forEach((group) => {
                if (group !== firstGroup) {
                  // Apply the style of the first group to each group
                  applyStyle(group, firstGroupStyle);

                  // Apply the style to the children of each group
                  let firstGroupChildren = firstGroup.querySelectorAll("*");
                  let groupChildren = group.querySelectorAll("*");

                  if (firstGroupChildren.length === groupChildren.length) {
                    for (let i = 0; i < firstGroupChildren.length; i++) {
                      applyStyle(
                        groupChildren[i],
                        window.getComputedStyle(firstGroupChildren[i])
                      );
                    }
                  } else {
                    console.error(
                      "Number of children elements is different between groups."
                    );
                  }
                }
              });
            } else {
              console.error("First group not found.");
            }
          }
        }

        replicateStyle();
      };

      editor.DomComponents.addType("checkbox_regular_form_new", {
        model: {
          defaults: {
            tagName: "span",
            type: "checkbox_regular_form_new",
            script: checkboxRegularFormNewScript,

            attributes: {
              // id: "checkbox_regular_form",
              class: "checkbox_regular_form_new",
            },

            style: {
              display: "flex",
              "flex-wrap": "wrap",
              "align-items": "center",
              "justify-content": "flex-start",
              gap: "1%",
            },

            "style-default": {
              display: "flex",
              "flex-wrap": "wrap",
              "align-items": "center",
              "justify-content": "flex-start",
              gap: "1%",
            },

            components: [
              {
                tagName: "span",
                type: "default",
                attributes: {
                  class: "group_checkbox_label",
                },

                "style-default": {
                  display: "flex",
                  "flex-wrap": "no-wrap",
                  "justify-content": "flex-start",
                  "align-items": "flex-start",
                  width: "8%",
                },

                style: {
                  display: "flex",
                  "flex-wrap": "no-wrap",
                  "justify-content": "flex-start",
                  "align-items": "flex-start",
                  width: "8%",
                },

                components: [
                  {
                    type: "checkbox_input_new",
                  },
                  {
                    type: "checkbox_label_new",
                  },
                ],
              },
              {
                tagName: "span",
                type: "default",
                attributes: {
                  class: "group_checkbox_label",
                },

                "style-default": {
                  display: "flex",
                  "flex-wrap": "no-wrap",
                  "justify-content": "flex-start",
                  "align-items": "flex-start",
                  width: "8%",
                },

                style: {
                  display: "flex",
                  "flex-wrap": "no-wrap",
                  "justify-content": "flex-start",
                  "align-items": "flex-start",
                  width: "8%",
                },

                components: [
                  {
                    type: "checkbox_input_new",
                  },
                  {
                    type: "checkbox_label_new",
                  },
                ],
              },
            ],

            // traits
            CustomUrl: "",
            BaseUrl: "",
            APIPath: "",
            BearerToken: "",
            Username: "",
            Password: "",
            MoreHeaders: "",
            APIMethod: "GET",
            APIBody: "",
            ArrOfObjKyename: "",
            NestedKeyname: "",
            options: {
              baseUrl1,
              baseUrl2,
              baseUrl3,
              baseUrl4,
              baseUrl5,
              baseUrl1BearerToken,
              baseUrl2BearerToken,
              baseUrl3BearerToken,
              baseUrl4BearerToken,
              baseUrl5BearerToken,
            },

            // to give width to all the divs at once
            CommonWidth: "8",

            ReplicateStyling: "",

            projectId: localStorage.getItem("project_id")
              ? localStorage.getItem("project_id")
              : "",

            traits: [
              "id",
              {
                type: "text",
                name: "CustomUrl",
                label: "Custom URL",
                changeProp: true,
              },
              {
                type: "select",
                name: "BaseUrl",
                label: "Base URL",
                options: [
                  { id: "baseUrl1", name: "Base URL #1" },
                  { id: "baseUrl2", name: "Base URL #2" },
                  { id: "baseUrl3", name: "Base URL #3" },
                  { id: "baseUrl4", name: "Base URL #4" },
                  { id: "baseUrl5", name: "Base URL #5" },
                  { id: "null", name: "No Base URL" },
                ],
                changeProp: true,
              },
              {
                type: "text",
                name: "APIPath",
                label: "API Path",
                placeholder: "Don't start with '/'",
                changeProp: true,
              },
              {
                type: "text",
                name: "BearerToken",
                label: "Bearer Token",
                placeholder: "No bearer token provided",
                changeProp: true,
              },
              {
                type: "text",
                name: "Username",
                label: "Username",
                changeProp: true,
              },
              {
                type: "text",
                name: "Password",
                label: "Password",
                changeProp: true,
              },
              {
                type: "text",
                name: "MoreHeaders",
                label: "More Headers",
                placeholder: "k1:v1,k2:v2,k3:v3,...",
                changeProp: true,
              },
              {
                type: "select",
                name: "APIMethod",
                label: "API Method",
                options: [
                  // { id: "GET", name: "Get" },
                  { id: "POST", name: "Post" },
                ],
                // value: "GET",
                changeProp: true,
              },
              {
                type: "text",
                name: "APIBody",
                label: "API Body",
                placeholder: "Json format",
                changeProp: true,
              },
              {
                type: "text",
                name: "ArrOfObjKyename",
                label: "Keyname From Array Of Object",
                placeholder: "[ {k1:v1}, {k1:v2} ]",
                changeProp: true,
              },
              {
                type: "text",
                name: "NestedKeyname",
                label: "Keyname For Nested Structure",
                placeholder: "{ k1: [{...}, {...}] }",
                changeProp: true,
              },
              {
                type: "number",
                name: "CommonWidth",
                label: "Common Width",
                placeholder: "Unit %",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "ReplicateStyling",
                label: "Replicate Styling",
                changeProp: true,
              },
            ],

            changeProp: true,
            "script-props": [
              "CustomUrl",
              "BaseUrl",
              "APIPath",
              "BearerToken",
              "Username",
              "Password",
              "MoreHeaders",
              "APIMethod",
              "APIBody",
              "ArrOfObjKyename",
              "NestedKeyname",
              "options",
              "CommonWidth",
              "ReplicateStyling",
              "projectId",
            ],
          },

          init() {
            this.listenTo(this, "change:CustomUrl", this.handlePropChange);
            this.listenTo(this, "change:BaseUrl", this.handlePropChange);
            this.listenTo(this, "change:APIPath", this.handlePropChange);
            this.listenTo(this, "change:BearerToken", this.handlePropChange);
            this.listenTo(this, "change:Username", this.handlePropChange);
            this.listenTo(this, "change:Password", this.handlePropChange);
            this.listenTo(this, "change:MoreHeaders", this.handlePropChange);
            this.listenTo(this, "change:APIMethod", this.handlePropChange);
            this.listenTo(this, "change:APIBody", this.handlePropChange);
            this.listenTo(
              this,
              "change:ArrOfObjKyename",
              this.handlePropChange
            );
            this.listenTo(this, "change:NestedKeyname", this.handlePropChange);

            this.listenTo(this, "change:CommonWidth", this.commonWidthChange);
          },

          updated(property, value, prevValue) {
            console.log(
              "+++ property",
              property,
              "value",
              value,
              "prevValue",
              prevValue
            );
            console.log("this from updated()", this.getEl());

            // for editor part, it will not be in download for which script is written for style replication
            this.replicateStyling();
          },

          // only needed during development
          commonWidthChange() {
            const { CommonWidth } = this.props();

            const mainContainer = this;
            const groupCheckboxLabels = mainContainer.find(
              ".group_checkbox_label"
            );

            if (groupCheckboxLabels.length > 0) {
              groupCheckboxLabels.forEach((groupCheckboxLabel) => {
                groupCheckboxLabel.setStyle({
                  display: "flex",
                  "flex-wrap": "no-wrap",
                  "justify-content": "flex-start",
                  "align-items": "flex-start",
                  width: CommonWidth ? CommonWidth + "%" : "8% !important",
                });
              });
            }
          },

          // needed both in development and after download
          replicateStyling() {
            console.log("replicating style");
            const { ReplicateStyling } = this.props();
            const mainContainer = this;

            if (ReplicateStyling) {
              // Get the first group_checkbox_label component
              let firstGroup = mainContainer.find(".group_checkbox_label")[0];

              if (firstGroup) {
                let firstGroupStyle = firstGroup.getStyle();

                // Apply styling to all other group_checkbox_label components
                let groups = mainContainer.find(".group_checkbox_label");
                groups.forEach((group) => {
                  if (group !== firstGroup) {
                    // Apply the style of the first group to each group
                    group.setStyle(firstGroupStyle);

                    // Apply the style to the children of each group
                    let firstGroupChildren = firstGroup.find("*");
                    let groupChildren = group.find("*");

                    for (let i = 0; i < firstGroupChildren.length; i++) {
                      let firstChildStyle = firstGroupChildren[i].getStyle();
                      groupChildren[i].setStyle(firstChildStyle);
                    }
                  }
                });
              }
              this.view.render();
              console.log("replicated");
            }
          },

          // needed both in development and after download
          async handlePropChange() {
            const {
              CustomUrl,
              BaseUrl,
              APIPath,
              BearerToken,
              Username,
              Password,
              MoreHeaders,
              APIMethod,
              APIBody,
              ArrOfObjKyename,
              NestedKeyname,
              CommonWidth,
            } = this.props();

            // to rename a variable because API var is getting used in many places in this block scope
            let API;
            if (APIPath) {
              API = APIPath;
            }

            let container = this;
            console.log("container:", container, container.components().length);

            // helper function to check if a variable is an array-of-objects or not
            function isArrayofObjects(variable) {
              // Check if the variable is an array
              if (!Array.isArray(variable)) {
                return false;
              }

              // Check if all elements in the array are objects
              for (const element of variable) {
                if (
                  typeof element !== "object" ||
                  Array.isArray(element) ||
                  element === null
                ) {
                  return false;
                }
              }
              return true;
            }

            // helper function to get value of a key in nested object
            function findKeyValue(obj, key) {
              if (obj.hasOwnProperty(key)) {
                // If the current object has the key, return its value
                return obj[key];
              }

              for (var prop in obj) {
                if (obj.hasOwnProperty(prop) && typeof obj[prop] === "object") {
                  // If the current property is an object, recursively search within it
                  var result = findKeyValue(obj[prop], key);
                  if (result !== undefined) {
                    return result;
                  }
                }
              }
              // Key not found in the object
              return undefined;
            }

            let apiData;

            // -------- Getting API Data
            // if CustomUrl is provided, use only that
            if (
              CustomUrl &&
              (!BaseUrl || (BaseUrl === "null" && APIMethod !== "POST"))
            ) {
              // if nothing is provided for auth
              if (!BearerToken && !Username && !Password) {
                // add extra headers, if needed
                let config = {
                  headers: {},
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${CustomUrl}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token is provided but not api_key or usr+pwd
              else if (BearerToken && !Username && !Password) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${BearerToken}`,
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${CustomUrl}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token and api_key not provided but usr+pwd are provided
              else if (!BearerToken && Username && Password) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    Authorization: "Basic " + btoa(Username + ":" + Password),
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${CustomUrl}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }
            }

            // if base url is the choice and provided
            else if (BaseUrl && API && !CustomUrl && APIMethod !== "POST") {
              // concatenating base url and its remaining part
              let url, baseUrlBearerToken;
              if (BaseUrl === "baseUrl1") {
                url = baseUrl1 + API;
                baseUrlBearerToken = baseUrl1BearerToken;
              } else if (BaseUrl === "baseUrl2") {
                url = baseUrl2 + API;
                baseUrlBearerToken = baseUrl2BearerToken;
              } else if (BaseUrl === "baseUrl3") {
                url = baseUrl3 + API;
                baseUrlBearerToken = baseUrl3BearerToken;
              } else if (BaseUrl === "baseUrl4") {
                url = baseUrl4 + API;
                baseUrlBearerToken = baseUrl4BearerToken;
              } else if (BaseUrl === "baseUrl5") {
                url = baseUrl5 + API;
                baseUrlBearerToken = baseUrl5BearerToken;
              }
              console.log("url, baseUrlBearerToken", url, baseUrlBearerToken);

              // if nothing is provided for auth
              if (
                !BearerToken &&
                !baseUrlBearerToken &&
                !Username &&
                !Password
              ) {
                // add extra headers, if needed
                let config = {
                  headers: {},
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token is provided but not usr+pwd
              else if (BearerToken && !Username && !Password) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${BearerToken}`,
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a baseUrlBearerToken is provided but not Custom Bearer Token and usr+pwd
              else if (
                baseUrlBearerToken &&
                !BearerToken &&
                !Username &&
                !Password
              ) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${baseUrlBearerToken}`,
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config@:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token is not provided but usr+pwd are provided
              else if (!BearerToken && Username && Password) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    Authorization: "Basic " + btoa(Username + ":" + Password),
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }
            }

            // POST method
            // if CustomUrl is provided, use only that
            if (
              CustomUrl &&
              (!BaseUrl || BaseUrl === "null") &&
              APIMethod === "POST"
            ) {
              // if nothing is provided for auth
              if (!BearerToken && !Username && !Password) {
                // add extra headers, if needed
                let config = {
                  method: "POST",
                  headers: {},
                  body:
                    typeof APIBody === "object"
                      ? JSON.stringify(APIBody)
                      : APIBody,
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${CustomUrl}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token is provided but not api_key or usr+pwd
              else if (BearerToken && !Username && !Password) {
                // add extra headers, if needed
                let config = {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${BearerToken}`,
                  },
                  body:
                    typeof APIBody === "object"
                      ? JSON.stringify(APIBody)
                      : APIBody,
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${CustomUrl}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token and api_key not provided but usr+pwd are provided
              else if (!BearerToken && Username && Password) {
                // add extra headers, if needed
                let config = {
                  method: "POST",
                  headers: {
                    Authorization: "Basic " + btoa(Username + ":" + Password),
                  },
                  body:
                    typeof APIBody === "object"
                      ? JSON.stringify(APIBody)
                      : APIBody,
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${CustomUrl}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }
            }

            // if base url is the choice and provided
            if (BaseUrl && API && !CustomUrl && APIMethod === "POST") {
              // concatenating base url and its remaining part
              let url, baseUrlBearerToken;
              if (BaseUrl === "baseUrl1") {
                url = baseUrl1 + API;
                baseUrlBearerToken = baseUrl1BearerToken;
              } else if (BaseUrl === "baseUrl2") {
                url = baseUrl2 + API;
                baseUrlBearerToken = baseUrl2BearerToken;
              } else if (BaseUrl === "baseUrl3") {
                url = baseUrl3 + API;
                baseUrlBearerToken = baseUrl3BearerToken;
              } else if (BaseUrl === "baseUrl4") {
                url = baseUrl4 + API;
                baseUrlBearerToken = baseUrl4BearerToken;
              } else if (BaseUrl === "baseUrl5") {
                url = baseUrl5 + API;
                baseUrlBearerToken = baseUrl5BearerToken;
              }
              console.log("url, baseUrlBearerToken", url, baseUrlBearerToken);

              // if nothing is provided for auth
              if (
                !BearerToken &&
                !baseUrlBearerToken &&
                !Username &&
                !Password
              ) {
                // add extra headers, if needed
                let config = {
                  method: "POST",
                  headers: {},
                  body:
                    typeof APIBody === "object"
                      ? JSON.stringify(APIBody)
                      : APIBody,
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token is provided but not usr+pwd
              else if (BearerToken && !Username && !Password) {
                // add extra headers, if needed
                let config = {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${BearerToken}`,
                  },
                  body:
                    typeof APIBody === "object"
                      ? JSON.stringify(APIBody)
                      : APIBody,
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a baseUrlBearerToken is provided but not Custom Bearer Token and usr+pwd
              else if (
                baseUrlBearerToken &&
                !BearerToken &&
                !Username &&
                !Password
              ) {
                // add extra headers, if needed
                let config = {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${baseUrlBearerToken}`,
                  },
                  body:
                    typeof APIBody === "object"
                      ? JSON.stringify(APIBody)
                      : APIBody,
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config@:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token is not provided but usr+pwd are provided
              else if (!BearerToken && Username && Password) {
                // add extra headers, if needed
                let config = {
                  method: "POST",
                  headers: {
                    Authorization: "Basic " + btoa(Username + ":" + Password),
                  },
                  body:
                    typeof APIBody === "object"
                      ? JSON.stringify(APIBody)
                      : APIBody,
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }
            }

            // console.log("apiData:", apiData);
            let allLabels = container.find(
              'label[data-gjs-type="checkbox_label_new"]'
            );
            console.log("allLabels", allLabels);

            // -------- Populating API Data, into the dropdown list
            if (apiData !== undefined) {
              console.log("#");
              // if API response is directly an array-of-objects
              if (isArrayofObjects(apiData)) {
                if (ArrOfObjKyename) {
                  console.log("##");
                  // container.components("");

                  // dynamic add
                  // to check if any '_id' data was changed in the backend object, then update the frontend labels of checkboxes also
                  if (container.components().length > 0) {
                    // check if these are database plotted checkboxes or not
                    let isNotDefaultCheckbox =
                      "data_db_id" in
                        container
                          .find('input[type="checkbox"]')[0]
                          .getAttributes() &&
                      container
                        .find('input[type="checkbox"]')[0]
                        .getAttributes()["data_db_id"] !== "";
                    console.log("isNotDefaultCheckbox", isNotDefaultCheckbox);

                    // if they are database plotted checkboxes then scan through them using data_db_id and update if any and append it more (apiData.length > number of checkboxes)
                    if (isNotDefaultCheckbox) {
                      let allMiniContainers = container.find(
                        ".group_checkbox_label"
                      );
                      allMiniContainers.forEach((groupCheckboxLabel, idx) => {
                        let checkbox = groupCheckboxLabel.find(
                          'input[type="checkbox"]'
                        )[0];
                        let checkbox_dataDbId = groupCheckboxLabel
                          .find('input[type="checkbox"]')[0]
                          .getAttributes()["data_db_id"];
                        let label = groupCheckboxLabel.find(
                          'label[data-gjs-type="checkbox_label_new"]'
                        )[0];
                        // get the object from apiData that has the checkbox_dataDbId
                        let currentObj = apiData.filter(
                          (obj) => obj["_id"] === checkbox_dataDbId
                        );

                        if (currentObj.length > 0) {
                          let labelInnerText = label
                            .components()
                            .models[0].get("content");

                          currentObj.forEach((obj) => {
                            // check if the IDs match, if not then update the label's inner text and value of checkbox
                            if (labelInnerText !== obj[`${ArrOfObjKyename}`]) {
                              // label.getLastChild().getLastChild().set("content", obj[`${ArrOfObjKyename}`]);
                              label
                                .components()
                                .models[0].set(
                                  "content",
                                  obj[`${ArrOfObjKyename}`]
                                );
                              checkbox.addAttributes({
                                value: obj[`${ArrOfObjKyename}`],
                              });
                              // to rerender the view of the component to show that it has been updated in the editor, instantly
                              this.view.render();
                              console.log("currentObj", currentObj);
                            }
                          });
                        }
                      });

                      // if there are equal number of objects in apiData as checkboxes then plot new ones
                      if (
                        apiData.length > allMiniContainers.length &&
                        apiData[0]["_id"] !==
                          container
                            .find('input[type="checkbox"]')[0]
                            .getAttributes()["data_db_id"]
                      ) {
                        // clear the body and then plot
                        container.components("");
                        apiData.forEach((opt) => {
                          let groupEle = {
                            tagName: "span",
                            type: "default",
                            attributes: {
                              class: "group_checkbox_label",
                            },

                            "style-default": {
                              display: "flex",
                              "flex-wrap": "no-wrap",
                              "justify-content": "flex-start",
                              "align-items": "flex-start",
                              width: CommonWidth
                                ? CommonWidth + "%"
                                : "8% !important",
                            },

                            style: {
                              display: "flex",
                              "flex-wrap": "no-wrap",
                              "justify-content": "flex-start",
                              "align-items": "flex-start",
                              width: CommonWidth
                                ? CommonWidth + "%"
                                : "8% !important",
                            },

                            components: [
                              {
                                tagName: "span",
                                type: "checkbox_input_new",
                                script: individualCheckboxScriptNew,

                                attributes: {
                                  class: "checkbox_input_new",
                                },

                                components: [
                                  {
                                    tagName: "input",
                                    type: "default",
                                    attributes: {
                                      type: "checkbox",
                                      id: `checkbox_1_${uniqid()}`,
                                      name: `checkbox_1_${uniqid()}`,
                                      value: `${opt[`${ArrOfObjKyename}`]}`,
                                      data_db_id: `${opt[`_id`]}`
                                        ? `${opt[`_id`]}`
                                        : `${opt[`${ArrOfObjKyename}`]}`,
                                    },
                                  },
                                ],

                                Autofocus: false,
                                Disabled: false,
                                Required: false,
                                Checked: false,

                                traits: [
                                  "id",
                                  "name",
                                  "value",
                                  {
                                    type: "checkbox",
                                    name: "Autofocus",
                                    label: "Autofocus",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Disabled",
                                    label: "Disabled",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Required",
                                    label: "Required",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Checked",
                                    label: "Checked",
                                    changeProp: true,
                                  },
                                ],

                                changeProp: true,
                                "script-props": [
                                  "Autofocus",
                                  "Disabled",
                                  "Required",
                                  "Checked",
                                ],
                              },
                              {
                                tagName: "label",
                                type: "checkbox_label_new",
                                attributes: {
                                  for: ``,
                                },

                                components: [
                                  {
                                    tagName: "p",
                                    type: "text",
                                    editable: true,

                                    style: {
                                      "word-break": "break-all",
                                    },

                                    "style-default": {
                                      "word-break": "break-all",
                                    },

                                    components: {
                                      type: "textnode",
                                      content: `${opt[`${ArrOfObjKyename}`]}`,
                                    },
                                  },
                                ],

                                traits: ["id", "for"],
                                changeProp: true,
                              },
                            ],
                          };

                          container.append(groupEle);
                        });
                      }
                    } else {
                      // clear the body and then plot because the first-time plotting will happen here
                      container.components("");
                      apiData.forEach((opt) => {
                        let groupEle = {
                          tagName: "span",
                          type: "default",
                          attributes: {
                            class: "group_checkbox_label",
                          },

                          "style-default": {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          style: {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          components: [
                            {
                              tagName: "span",
                              type: "checkbox_input_new",
                              script: individualCheckboxScriptNew,

                              attributes: {
                                class: "checkbox_input_new",
                              },

                              components: [
                                {
                                  tagName: "input",
                                  type: "default",
                                  attributes: {
                                    type: "checkbox",
                                    id: `checkbox_1_${uniqid()}`,
                                    name: `checkbox_1_${uniqid()}`,
                                    value: `${opt[`${ArrOfObjKyename}`]}`,
                                    data_db_id: `${opt[`_id`]}`
                                      ? `${opt[`_id`]}`
                                      : `${opt[`${ArrOfObjKyename}`]}`,
                                  },
                                },
                              ],

                              Autofocus: false,
                              Disabled: false,
                              Required: false,
                              Checked: false,

                              traits: [
                                "id",
                                "name",
                                "value",
                                {
                                  type: "checkbox",
                                  name: "Autofocus",
                                  label: "Autofocus",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Disabled",
                                  label: "Disabled",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Required",
                                  label: "Required",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Checked",
                                  label: "Checked",
                                  changeProp: true,
                                },
                              ],

                              changeProp: true,
                              "script-props": [
                                "Autofocus",
                                "Disabled",
                                "Required",
                                "Checked",
                              ],
                            },
                            {
                              tagName: "label",
                              type: "checkbox_label_new",
                              attributes: {
                                for: ``,
                              },

                              components: [
                                {
                                  tagName: "p",
                                  type: "text",
                                  editable: true,

                                  style: {
                                    "word-break": "break-all",
                                  },

                                  "style-default": {
                                    "word-break": "break-all",
                                  },

                                  components: {
                                    type: "textnode",
                                    content: `${opt[`${ArrOfObjKyename}`]}`,
                                  },
                                },
                              ],

                              traits: ["id", "for"],
                              changeProp: true,
                            },
                          ],
                        };

                        container.append(groupEle);
                      });
                    }
                  }

                  // reasons -
                  // container.components().length === 0 : plot checkboxes if there are no checkboxes present in the container
                  // container.components().length === 2 : plot checkboxes the first time when there are the 2 initial checkboxes
                  // apiData.length > container.components().length : plot checkboxes if apiData has more objects than checkboxes in the container meaning update the checkboxes when there is an update done in the backend database, make this dynamic
                  if (
                    container.components().length === 0 ||
                    (container.components().length === 2 && apiData.length > 2)
                  ) {
                    // clear the body and then plot because the first-time plotting will happen here
                    container.components("");
                    apiData.forEach((opt) => {
                      let groupEle = {
                        tagName: "span",
                        type: "default",
                        attributes: {
                          class: "group_checkbox_label",
                        },

                        "style-default": {
                          display: "flex",
                          "flex-wrap": "no-wrap",
                          "justify-content": "flex-start",
                          "align-items": "flex-start",
                          width: CommonWidth
                            ? CommonWidth + "%"
                            : "8% !important",
                        },

                        style: {
                          display: "flex",
                          "flex-wrap": "no-wrap",
                          "justify-content": "flex-start",
                          "align-items": "flex-start",
                          width: CommonWidth
                            ? CommonWidth + "%"
                            : "8% !important",
                        },

                        components: [
                          {
                            tagName: "span",
                            type: "checkbox_input_new",
                            script: individualCheckboxScriptNew,

                            attributes: {
                              class: "checkbox_input_new",
                            },

                            components: [
                              {
                                tagName: "input",
                                type: "default",
                                attributes: {
                                  type: "checkbox",
                                  id: `checkbox_1_${uniqid()}`,
                                  name: `checkbox_1_${uniqid()}`,
                                  value: `${opt[`${ArrOfObjKyename}`]}`,
                                  data_db_id: `${opt[`_id`]}`
                                    ? `${opt[`_id`]}`
                                    : `${opt[`${ArrOfObjKyename}`]}`,
                                },
                              },
                            ],

                            Autofocus: false,
                            Disabled: false,
                            Required: false,
                            Checked: false,

                            traits: [
                              "id",
                              "name",
                              "value",
                              {
                                type: "checkbox",
                                name: "Autofocus",
                                label: "Autofocus",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Disabled",
                                label: "Disabled",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Required",
                                label: "Required",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Checked",
                                label: "Checked",
                                changeProp: true,
                              },
                            ],

                            changeProp: true,
                            "script-props": [
                              "Autofocus",
                              "Disabled",
                              "Required",
                              "Checked",
                            ],
                          },
                          {
                            tagName: "label",
                            type: "checkbox_label_new",
                            attributes: {
                              for: ``,
                            },

                            components: [
                              {
                                tagName: "p",
                                type: "text",
                                editable: true,

                                style: {
                                  "word-break": "break-all",
                                },

                                "style-default": {
                                  "word-break": "break-all",
                                },

                                components: {
                                  type: "textnode",
                                  content: `${opt[`${ArrOfObjKyename}`]}`,
                                },
                              },
                            ],

                            traits: ["id", "for"],
                            changeProp: true,
                          },
                        ],
                      };

                      // let inputEle = {
                      //   tagName: "input",
                      //   type: "default", // so that the input component doesn't throw error of 'undefined'

                      //   script: individualCheckboxScript,

                      //   attributes: {
                      //     type: "checkbox",
                      //     // id: `${opt[`${ArrOfObjKyename}`]}`,
                      //     name: `${opt[`${ArrOfObjKyename}`]}`,
                      //     value: `${opt[`${ArrOfObjKyename}`]}`,
                      //   },

                      //   Autofocus: false,
                      //   Disabled: false,
                      //   Required: false,
                      //   Checked: false,

                      //   traits: [
                      //     "id",
                      //     "name",
                      //     "value",
                      //     {
                      //       type: "checkbox",
                      //       name: "Autofocus",
                      //       label: "Autofocus",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Disabled",
                      //       label: "Disabled",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Required",
                      //       label: "Required",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Checked",
                      //       label: "Checked",
                      //       changeProp: true,
                      //     },
                      //   ],

                      //   changeProp: true,
                      //   "script-props": [
                      //     "Autofocus",
                      //     "Disabled",
                      //     "Required",
                      //     "Checked",
                      //   ],
                      // };

                      // let labelEle = {
                      //   tagName: "label",
                      //   attributes: {
                      //     for: ``,
                      //   },

                      //   components: [
                      //     {
                      //       tagName: "p",
                      //       type: "text",
                      //       editable: true,

                      //       components: {
                      //         type: "textnode",
                      //         content: `${opt[`${ArrOfObjKyename}`]}`,
                      //       },
                      //     },
                      //   ],

                      //   traits: ["id", "for"],
                      // };

                      // container.append(inputEle);
                      // container.append(labelEle);
                      container.append(groupEle);
                    });
                  }

                  // update only when the checkboxes have already been plotted previously from apiData but not updating if the apiData had only 2 fields
                  if (
                    apiData.length > container.components().length &&
                    container.components().length > 2
                  ) {
                    // only add what's missing from api as a dynamic update

                    // get all the labels' inner content and compare it with the keyname of the apiData to be plotted and add the ones missing
                    let allLabelEles = container.find(
                      'label[data-gjs-type="checkbox_label_new"]'
                    );
                    let allLabels = allLabelEles.map(
                      (label) =>
                        label.find('p[data-gjs-type="text"]')[0].getEl()
                          .innerHTML
                    );
                    console.log("allLabelEles", allLabelEles, allLabels);

                    if (allLabelEles.length > 0) {
                      // if you find a label thats not in the apiData then add it to the existing checkbox container
                      apiData.forEach((dbRow, idx) => {
                        // if that object from apiData is not present in the checkbox container then plot it
                        if (!allLabels.includes(dbRow[`${ArrOfObjKyename}`])) {
                          let groupEle = {
                            tagName: "span",
                            type: "default",
                            attributes: {
                              class: "group_checkbox_label",
                            },

                            "style-default": {
                              display: "flex",
                              "flex-wrap": "no-wrap",
                              "justify-content": "flex-start",
                              "align-items": "flex-start",
                              width: CommonWidth
                                ? CommonWidth + "%"
                                : "8% !important",
                            },

                            style: {
                              display: "flex",
                              "flex-wrap": "no-wrap",
                              "justify-content": "flex-start",
                              "align-items": "flex-start",
                              width: CommonWidth
                                ? CommonWidth + "%"
                                : "8% !important",
                            },

                            components: [
                              {
                                tagName: "span",
                                type: "checkbox_input_new",
                                script: individualCheckboxScriptNew,

                                attributes: {
                                  class: "checkbox_input_new",
                                },

                                components: [
                                  {
                                    tagName: "input",
                                    type: "default",
                                    attributes: {
                                      type: "checkbox",
                                      id: `checkbox_1_${uniqid()}`,
                                      name: `checkbox_1_${uniqid()}`,
                                      value: `${dbRow[`${ArrOfObjKyename}`]}`,
                                      data_db_id: `${dbRow[`_id`]}`
                                        ? `${dbRow[`_id`]}`
                                        : `${dbRow[`${ArrOfObjKyename}`]}`,
                                    },
                                  },
                                ],

                                Autofocus: false,
                                Disabled: false,
                                Required: false,
                                Checked: false,

                                traits: [
                                  "id",
                                  "name",
                                  "value",
                                  {
                                    type: "checkbox",
                                    name: "Autofocus",
                                    label: "Autofocus",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Disabled",
                                    label: "Disabled",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Required",
                                    label: "Required",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Checked",
                                    label: "Checked",
                                    changeProp: true,
                                  },
                                ],

                                changeProp: true,
                                "script-props": [
                                  "Autofocus",
                                  "Disabled",
                                  "Required",
                                  "Checked",
                                ],
                              },
                              {
                                tagName: "label",
                                type: "checkbox_label_new",
                                attributes: {
                                  for: ``,
                                },

                                components: [
                                  {
                                    tagName: "p",
                                    type: "text",
                                    editable: true,

                                    style: {
                                      "word-break": "break-all",
                                    },

                                    "style-default": {
                                      "word-break": "break-all",
                                    },

                                    components: {
                                      type: "textnode",
                                      content: `${dbRow[`${ArrOfObjKyename}`]}`,
                                    },
                                  },
                                ],

                                traits: ["id", "for"],
                                changeProp: true,
                              },
                            ],
                          };

                          container.append(groupEle);
                        }
                      });
                    }
                  }

                  // plot when the apiData has only around 2 entries
                  else if (apiData.length <= 2) {
                    console.log("_");

                    // see if the checkboxes are the default checkboxes by checking if they have this attribute 'data_db_id', if yes then clear the body and append new else append new checkboxes anyways
                    let isNotDefaultCheckbox =
                      "data_db_id" in
                      container
                        .find('input[type="checkbox"]')[0]
                        .getAttributes();
                    console.log("isNotDefaultCheckbox", isNotDefaultCheckbox);

                    // if it is a default checkbox then empty the body before appending apiData checkboxes
                    if (!isNotDefaultCheckbox) {
                      container.components("");
                      apiData.forEach((opt) => {
                        let groupEle = {
                          tagName: "span",
                          type: "default",
                          attributes: {
                            class: "group_checkbox_label",
                          },

                          "style-default": {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          style: {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          components: [
                            {
                              tagName: "span",
                              type: "checkbox_input_new",
                              script: individualCheckboxScriptNew,

                              attributes: {
                                class: "checkbox_input_new",
                              },

                              components: [
                                {
                                  tagName: "input",
                                  type: "default",
                                  attributes: {
                                    type: "checkbox",
                                    id: `checkbox_1_${uniqid()}`,
                                    name: `checkbox_1_${uniqid()}`,
                                    value: `${opt[`${ArrOfObjKyename}`]}`,
                                    data_db_id: `${opt[`_id`]}`
                                      ? `${opt[`_id`]}`
                                      : `${opt[`${ArrOfObjKyename}`]}`,
                                  },
                                },
                              ],

                              Autofocus: false,
                              Disabled: false,
                              Required: false,
                              Checked: false,

                              traits: [
                                "id",
                                "name",
                                "value",
                                {
                                  type: "checkbox",
                                  name: "Autofocus",
                                  label: "Autofocus",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Disabled",
                                  label: "Disabled",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Required",
                                  label: "Required",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Checked",
                                  label: "Checked",
                                  changeProp: true,
                                },
                              ],

                              changeProp: true,
                              "script-props": [
                                "Autofocus",
                                "Disabled",
                                "Required",
                                "Checked",
                              ],
                            },
                            {
                              tagName: "label",
                              type: "checkbox_label_new",
                              attributes: {
                                for: ``,
                              },

                              components: [
                                {
                                  tagName: "p",
                                  type: "text",
                                  editable: true,

                                  style: {
                                    "word-break": "break-all",
                                  },

                                  "style-default": {
                                    "word-break": "break-all",
                                  },

                                  components: {
                                    type: "textnode",
                                    content: `${opt[`${ArrOfObjKyename}`]}`,
                                  },
                                },
                              ],

                              traits: ["id", "for"],
                              changeProp: true,
                            },
                          ],
                        };
                        container.append(groupEle);
                      });
                      console.log("plotted1");
                    } else {
                      // clear the body and then plot because the first-time plotting will happen here
                      container.components("");
                      apiData.forEach((opt) => {
                        let groupEle = {
                          tagName: "span",
                          type: "default",
                          attributes: {
                            class: "group_checkbox_label",
                          },

                          "style-default": {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          style: {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          components: [
                            {
                              tagName: "span",
                              type: "checkbox_input_new",
                              script: individualCheckboxScriptNew,

                              attributes: {
                                class: "checkbox_input_new",
                              },

                              components: [
                                {
                                  tagName: "input",
                                  type: "default",
                                  attributes: {
                                    type: "checkbox",
                                    id: `checkbox_1_${uniqid()}`,
                                    name: `checkbox_1_${uniqid()}`,
                                    value: `${opt[`${ArrOfObjKyename}`]}`,
                                    data_db_id: `${opt[`_id`]}`
                                      ? `${opt[`_id`]}`
                                      : `${opt[`${ArrOfObjKyename}`]}`,
                                  },
                                },
                              ],

                              Autofocus: false,
                              Disabled: false,
                              Required: false,
                              Checked: false,

                              traits: [
                                "id",
                                "name",
                                "value",
                                {
                                  type: "checkbox",
                                  name: "Autofocus",
                                  label: "Autofocus",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Disabled",
                                  label: "Disabled",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Required",
                                  label: "Required",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Checked",
                                  label: "Checked",
                                  changeProp: true,
                                },
                              ],

                              changeProp: true,
                              "script-props": [
                                "Autofocus",
                                "Disabled",
                                "Required",
                                "Checked",
                              ],
                            },
                            {
                              tagName: "label",
                              type: "checkbox_label_new",
                              attributes: {
                                for: ``,
                              },

                              components: [
                                {
                                  tagName: "p",
                                  type: "text",
                                  editable: true,

                                  style: {
                                    "word-break": "break-all",
                                  },

                                  "style-default": {
                                    "word-break": "break-all",
                                  },

                                  components: {
                                    type: "textnode",
                                    content: `${opt[`${ArrOfObjKyename}`]}`,
                                  },
                                },
                              ],

                              traits: ["id", "for"],
                              changeProp: true,
                            },
                          ],
                        };

                        container.append(groupEle);
                      });
                      console.log("plotted1");
                    }
                  }

                  // dynamic delete
                  if (container.components().length > apiData.length) {
                    console.log("removing extra group_checkbox_labels");

                    let groupCheckboxLabels = container.find(
                      ".group_checkbox_label"
                    );
                    groupCheckboxLabels.forEach((groupCheckboxLabel) => {
                      // get the data_db_url from checkbox and check if _id is present in apiData, if not, remove it
                      let checkbox = groupCheckboxLabel
                        .find(".checkbox_input_new")[0]
                        .find('input[type="checkbox"]')[0];
                      let checkboxDataDbId =
                        checkbox.getAttributes()["data_db_id"];

                      // see if checkboxDataDbId is in apiData _ids and if not there, delete this group_checkbox_label
                      let apiData_id = apiData.map((obj) => obj["_id"]);

                      if (!apiData_id.includes(checkboxDataDbId)) {
                        groupCheckboxLabel.remove();
                        console.log("removed");
                      }
                    });
                  }
                }
              }

              // if API response is a plain array of single elements
              else if (Array.isArray(apiData) && !isArrayofObjects(apiData)) {
                console.log("###");

                // either no checkboxes are plotted or the default 2 checkboxes are there
                if (
                  container.components().length === 0 ||
                  container.components().length <= 2
                ) {
                  container.components("");
                  apiData.forEach((opt) => {
                    let groupEle = {
                      tagName: "span",
                      type: "default",
                      attributes: {
                        class: "group_checkbox_label",
                      },

                      "style-default": {
                        display: "flex",
                        "flex-wrap": "no-wrap",
                        "justify-content": "flex-start",
                        "align-items": "flex-start",
                        width: CommonWidth
                          ? CommonWidth + "%"
                          : "8% !important",
                      },

                      style: {
                        display: "flex",
                        "flex-wrap": "no-wrap",
                        "justify-content": "flex-start",
                        "align-items": "flex-start",
                        width: CommonWidth
                          ? CommonWidth + "%"
                          : "8% !important",
                      },

                      components: [
                        {
                          tagName: "span",
                          type: "checkbox_input_new",
                          script: individualCheckboxScriptNew,

                          attributes: {
                            class: "checkbox_input_new",
                          },

                          components: [
                            {
                              tagName: "input",
                              type: "default",
                              attributes: {
                                type: "checkbox",
                                id: `checkbox_1_${uniqid()}`,
                                name: `checkbox_1_${uniqid()}`,
                                value: `${opt}`,
                              },
                            },
                          ],

                          Autofocus: false,
                          Disabled: false,
                          Required: false,
                          Checked: false,

                          traits: [
                            "id",
                            "name",
                            "value",
                            {
                              type: "checkbox",
                              name: "Autofocus",
                              label: "Autofocus",
                              changeProp: true,
                            },
                            {
                              type: "checkbox",
                              name: "Disabled",
                              label: "Disabled",
                              changeProp: true,
                            },
                            {
                              type: "checkbox",
                              name: "Required",
                              label: "Required",
                              changeProp: true,
                            },
                            {
                              type: "checkbox",
                              name: "Checked",
                              label: "Checked",
                              changeProp: true,
                            },
                          ],

                          changeProp: true,
                          "script-props": [
                            "Autofocus",
                            "Disabled",
                            "Required",
                            "Checked",
                          ],
                        },
                        {
                          tagName: "label",
                          type: "checkbox_label_new",
                          attributes: {
                            for: ``,
                          },

                          components: [
                            {
                              tagName: "p",
                              type: "text",
                              editable: true,

                              style: {
                                "word-break": "break-all",
                              },

                              "style-default": {
                                "word-break": "break-all",
                              },

                              components: {
                                type: "textnode",
                                content: `${opt}`,
                              },
                            },
                          ],

                          traits: ["id", "for"],
                        },
                      ],
                    };

                    // let inputEle = {
                    //   tagName: "input",
                    //   type: "default", // so that the input component doesn't throw error of 'undefined'

                    //   script: individualCheckboxScript,

                    //   attributes: {
                    //     type: "checkbox",
                    //     // id: `ch-${opt}`,
                    //     name: `ch-${opt}`,
                    //     value: `${opt}`,
                    //   },

                    //   Autofocus: false,
                    //   Disabled: false,
                    //   Required: false,
                    //   Checked: false,

                    //   traits: [
                    //     "id",
                    //     "name",
                    //     "value",
                    //     {
                    //       type: "checkbox",
                    //       name: "Autofocus",
                    //       label: "Autofocus",
                    //       changeProp: true,
                    //     },
                    //     {
                    //       type: "checkbox",
                    //       name: "Disabled",
                    //       label: "Disabled",
                    //       changeProp: true,
                    //     },
                    //     {
                    //       type: "checkbox",
                    //       name: "Required",
                    //       label: "Required",
                    //       changeProp: true,
                    //     },
                    //     {
                    //       type: "checkbox",
                    //       name: "Checked",
                    //       label: "Checked",
                    //       changeProp: true,
                    //     },
                    //   ],

                    //   changeProp: true,
                    //   "script-props": [
                    //     "Autofocus",
                    //     "Disabled",
                    //     "Required",
                    //     "Checked",
                    //   ],
                    // };

                    // let labelEle = {
                    //   tagName: "label",
                    //   attributes: {
                    //     for: ``,
                    //   },

                    //   components: [
                    //     {
                    //       tagName: "p",
                    //       type: "text",
                    //       editable: true,

                    //       components: {
                    //         type: "textnode",
                    //         content: `${opt}`,
                    //       },
                    //     },
                    //   ],

                    //   traits: ["id", "for"],
                    // };

                    // container.append(inputEle);
                    // container.append(labelEle);
                    container.append(groupEle);
                  });
                }

                // else if the apiData checkboxes are already plotted then check for updated values and add those here without changing the IDd of already plotted ones
                else if (
                  apiData.length > container.components().length &&
                  container.components().length > 2
                ) {
                  // only add what's missing from api as a dynamic update

                  // get all the labels' inner content and compare it with the keyname of the apiData to be plotted and add the ones missing
                  let allLabelEles = container.find(
                    'label[data-gjs-type="checkbox_label_new"]'
                  );
                  let allLabels = allLabelEles.map(
                    (label) =>
                      label.find('p[data-gjs-type="text"]')[0].getEl().innerHTML
                  );
                  console.log("allLabelEles", allLabelEles, allLabels);

                  if (allLabelEles.length > 0) {
                    // if you find a label thats not in the apiData then add it to the existing checkbox container
                    apiData.forEach((opt, idx) => {
                      // if that object from apiData is not present in the checkbox container then plot it
                      if (!allLabels.includes(opt)) {
                        let groupEle = {
                          tagName: "span",
                          type: "default",
                          attributes: {
                            class: "group_checkbox_label",
                          },

                          "style-default": {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          style: {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          components: [
                            {
                              tagName: "span",
                              type: "checkbox_input_new",
                              script: individualCheckboxScriptNew,

                              attributes: {
                                class: "checkbox_input_new",
                              },

                              components: [
                                {
                                  tagName: "input",
                                  type: "default",
                                  attributes: {
                                    type: "checkbox",
                                    id: `checkbox_1_${uniqid()}`,
                                    name: `checkbox_1_${uniqid()}`,
                                    value: `${opt}`,
                                  },
                                },
                              ],

                              Autofocus: false,
                              Disabled: false,
                              Required: false,
                              Checked: false,

                              traits: [
                                "id",
                                "name",
                                "value",
                                {
                                  type: "checkbox",
                                  name: "Autofocus",
                                  label: "Autofocus",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Disabled",
                                  label: "Disabled",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Required",
                                  label: "Required",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Checked",
                                  label: "Checked",
                                  changeProp: true,
                                },
                              ],

                              changeProp: true,
                              "script-props": [
                                "Autofocus",
                                "Disabled",
                                "Required",
                                "Checked",
                              ],
                            },
                            {
                              tagName: "label",
                              type: "checkbox_label_new",
                              attributes: {
                                for: ``,
                              },

                              components: [
                                {
                                  tagName: "p",
                                  type: "text",
                                  editable: true,

                                  style: {
                                    "word-break": "break-all",
                                  },

                                  "style-default": {
                                    "word-break": "break-all",
                                  },

                                  components: {
                                    type: "textnode",
                                    content: `${opt}`,
                                  },
                                },
                              ],

                              traits: ["id", "for"],
                            },
                          ],
                        };

                        container.append(groupEle);
                      }
                    });
                  }
                }
              }

              // if API response is an object
              else if (
                !isArrayofObjects(apiData) &&
                typeof apiData === "object"
              ) {
                // if API response to plot is a nested array-of-objects inside the main response object
                if (NestedKeyname && ArrOfObjKyename) {
                  console.log("####");
                  // container.components("");

                  // find the array-of-objects value
                  let data = findKeyValue(apiData, NestedKeyname);

                  if (isArrayofObjects(data)) {
                    // to check if any '_id' data was changed in the backend object, then update the frontend labels of checkboxes also
                    if (container.components().length > 0) {
                      // check if these are database plotted checkboxes or not
                      let isNotDefaultCheckbox =
                        "data_db_id" in
                        container
                          .find('input[type="checkbox"]')[0]
                          .getAttributes();
                      console.log("isNotDefaultCheckbox", isNotDefaultCheckbox);

                      // if they are database plotted checkboxes then scan through them using data_db_id and update if any
                      if (isNotDefaultCheckbox) {
                        let allMiniContainers = container.find(
                          ".group_checkbox_label"
                        );
                        allMiniContainers.forEach((groupCheckboxLabel, idx) => {
                          let checkbox_dataDbId = groupCheckboxLabel
                            .find('input[type="checkbox"]')[0]
                            .getAttributes()["data_db_id"];
                          let label = groupCheckboxLabel.find(
                            'label[data-gjs-type="checkbox_label_new"]'
                          )[0];

                          // get the object from apiData that has the checkbox_dataDbId
                          let currentObj = apiData.filter(
                            (obj) => obj["_id"] === checkbox_dataDbId
                          );

                          if (currentObj.length > 0) {
                            currentObj.forEach((obj) => {
                              let labelInnerText = label
                                .find('p[data-gjs-type="text"]')[0]
                                .getEl().innerHTML;

                              // check if the IDs match, if not then update the label's inner text
                              if (
                                labelInnerText !== obj[`${ArrOfObjKyename}`]
                              ) {
                                label
                                  .getLastChild()
                                  .getLastChild()
                                  .set("content", obj[`${ArrOfObjKyename}`]);
                                // to rerender the view of the component to show that it has been updated in the editor, instantly
                                this.view.render();
                                console.log("currentObj", currentObj);
                              }
                            });
                          }
                        });
                      }
                    }

                    // reasons -
                    // container.components().length === 0 : plot checkboxes if there are no checkboxes present in the container
                    // container.components().length === 2 : plot checkboxes the first time when there are the 2 initial checkboxes
                    // data.length > container.components().length : plot checkboxes if apiData has more objects than checkboxes in the container meaning update the checkboxes when there is an update done in the backend database, make this dynamic
                    if (
                      container.components().length === 0 ||
                      (container.components().length === 2 && data.length > 2)
                    ) {
                      container.components("");
                      data.forEach((opt) => {
                        let groupEle = {
                          tagName: "span",
                          type: "default",
                          attributes: {
                            class: "group_checkbox_label",
                          },

                          "style-default": {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          style: {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          components: [
                            {
                              tagName: "span",
                              type: "checkbox_input_new",
                              script: individualCheckboxScriptNew,

                              attributes: {
                                class: "checkbox_input_new",
                              },

                              components: [
                                {
                                  tagName: "input",
                                  type: "default",
                                  attributes: {
                                    type: "checkbox",
                                    id: `checkbox_1_${uniqid()}`,
                                    name: `checkbox_1_${uniqid()}`,
                                    value: `${opt[`${ArrOfObjKyename}`]}`,
                                    data_db_id: `${opt[`_id`]}`
                                      ? `${opt[`_id`]}`
                                      : `${opt[`${ArrOfObjKyename}`]}`,
                                  },
                                },
                              ],

                              Autofocus: false,
                              Disabled: false,
                              Required: false,
                              Checked: false,

                              traits: [
                                "id",
                                "name",
                                "value",
                                {
                                  type: "checkbox",
                                  name: "Autofocus",
                                  label: "Autofocus",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Disabled",
                                  label: "Disabled",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Required",
                                  label: "Required",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Checked",
                                  label: "Checked",
                                  changeProp: true,
                                },
                              ],

                              changeProp: true,
                              "script-props": [
                                "Autofocus",
                                "Disabled",
                                "Required",
                                "Checked",
                              ],
                            },
                            {
                              tagName: "label",
                              type: "checkbox_label_new",
                              attributes: {
                                for: ``,
                              },

                              components: [
                                {
                                  tagName: "p",
                                  type: "text",
                                  editable: true,

                                  style: {
                                    "word-break": "break-all",
                                  },

                                  "style-default": {
                                    "word-break": "break-all",
                                  },

                                  components: {
                                    type: "textnode",
                                    content: `${opt[`${ArrOfObjKyename}`]}`,
                                  },
                                },
                              ],

                              traits: ["id", "for"],
                            },
                          ],
                        };

                        // let inputEle = {
                        //   tagName: "input",
                        //   type: "default", // so that the input component doesn't throw error of 'undefined'

                        //   script: individualCheckboxScript,

                        //   attributes: {
                        //     type: "checkbox",
                        //     // id: `${opt[`${ArrOfObjKyename}`]}`,
                        //     name: `${opt[`${ArrOfObjKyename}`]}`,
                        //     value: `${opt[`${ArrOfObjKyename}`]}`,
                        //   },

                        //   Autofocus: false,
                        //   Disabled: false,
                        //   Required: false,
                        //   Checked: false,

                        //   traits: [
                        //     "id",
                        //     "name",
                        //     "value",
                        //     {
                        //       type: "checkbox",
                        //       name: "Autofocus",
                        //       label: "Autofocus",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Disabled",
                        //       label: "Disabled",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Required",
                        //       label: "Required",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Checked",
                        //       label: "Checked",
                        //       changeProp: true,
                        //     },
                        //   ],

                        //   changeProp: true,
                        //   "script-props": [
                        //     "Autofocus",
                        //     "Disabled",
                        //     "Required",
                        //     "Checked",
                        //   ],
                        // };

                        // let labelEle = {
                        //   tagName: "label",
                        //   attributes: {
                        //     for: ``,
                        //   },

                        //   components: [
                        //     {
                        //       tagName: "p",
                        //       type: "text",
                        //       editable: true,

                        //       components: {
                        //         type: "textnode",
                        //         content: `${opt[`${ArrOfObjKyename}`]}`,
                        //       },
                        //     },
                        //   ],

                        //   traits: ["id", "for"],
                        // };

                        // container.append(inputEle);
                        // container.append(labelEle);
                        container.append(groupEle);
                      });
                    }

                    // update only when the checkboxes have already been plotted previously from apiData but not updating if the apiData had only 2 fields
                    if (
                      data.length > container.components().length &&
                      container.components().length > 2
                    ) {
                      // only add what's missing from api as a dynamic update

                      // get all the labels' inner content and compare it with the keyname of the apiData to be plotted and add the ones missing
                      let allLabelEles = container.find(
                        'label[data-gjs-type="checkbox_label_new"]'
                      );
                      let allLabels = allLabelEles.map(
                        (label) =>
                          label.find('p[data-gjs-type="text"]')[0].getEl()
                            .innerHTML
                      );
                      console.log("allLabelEles", allLabelEles, allLabels);

                      if (allLabelEles.length > 0) {
                        // if you find a label thats not in the apiData then add it to the existing checkbox container
                        data.forEach((opt, idx) => {
                          // if that object from apiData is not present in the checkbox container then plot it
                          if (!allLabels.includes(opt[`${ArrOfObjKyename}`])) {
                            let groupEle = {
                              tagName: "span",
                              type: "default",
                              attributes: {
                                class: "group_checkbox_label",
                              },

                              "style-default": {
                                display: "flex",
                                "flex-wrap": "no-wrap",
                                "justify-content": "flex-start",
                                "align-items": "flex-start",
                                width: CommonWidth
                                  ? CommonWidth + "%"
                                  : "8% !important",
                              },

                              style: {
                                display: "flex",
                                "flex-wrap": "no-wrap",
                                "justify-content": "flex-start",
                                "align-items": "flex-start",
                                width: CommonWidth
                                  ? CommonWidth + "%"
                                  : "8% !important",
                              },

                              components: [
                                {
                                  tagName: "span",
                                  type: "checkbox_input_new",
                                  script: individualCheckboxScriptNew,

                                  attributes: {
                                    class: "checkbox_input_new",
                                  },

                                  components: [
                                    {
                                      tagName: "input",
                                      type: "default",
                                      attributes: {
                                        type: "checkbox",
                                        id: `checkbox_1_${uniqid()}`,
                                        name: `checkbox_1_${uniqid()}`,
                                        value: `${opt[`${ArrOfObjKyename}`]}`,
                                        data_db_id: `${opt[`_id`]}`
                                          ? `${opt[`_id`]}`
                                          : `${opt[`${ArrOfObjKyename}`]}`,
                                      },
                                    },
                                  ],

                                  Autofocus: false,
                                  Disabled: false,
                                  Required: false,
                                  Checked: false,

                                  traits: [
                                    "id",
                                    "name",
                                    "value",
                                    {
                                      type: "checkbox",
                                      name: "Autofocus",
                                      label: "Autofocus",
                                      changeProp: true,
                                    },
                                    {
                                      type: "checkbox",
                                      name: "Disabled",
                                      label: "Disabled",
                                      changeProp: true,
                                    },
                                    {
                                      type: "checkbox",
                                      name: "Required",
                                      label: "Required",
                                      changeProp: true,
                                    },
                                    {
                                      type: "checkbox",
                                      name: "Checked",
                                      label: "Checked",
                                      changeProp: true,
                                    },
                                  ],

                                  changeProp: true,
                                  "script-props": [
                                    "Autofocus",
                                    "Disabled",
                                    "Required",
                                    "Checked",
                                  ],
                                },
                                {
                                  tagName: "label",
                                  type: "checkbox_label_new",
                                  attributes: {
                                    for: ``,
                                  },

                                  components: [
                                    {
                                      tagName: "p",
                                      type: "text",
                                      editable: true,

                                      style: {
                                        "word-break": "break-all",
                                      },

                                      "style-default": {
                                        "word-break": "break-all",
                                      },

                                      components: {
                                        type: "textnode",
                                        content: `${opt[`${ArrOfObjKyename}`]}`,
                                      },
                                    },
                                  ],

                                  traits: ["id", "for"],
                                },
                              ],
                            };

                            container.append(groupEle);
                          }
                        });
                      }
                    }

                    // plot when the data has only around 2 entries
                    else if (data.length <= 2) {
                      console.log("_");

                      // see if the checkboxes are the default checkboxes by checking if they have this attribute 'data_db_id', if yes then clear the body and append new else append new checkboxes anyways
                      let isNotDefaultCheckbox =
                        "data_db_id" in
                        container
                          .find('input[type="checkbox"]')[0]
                          .getAttributes();
                      console.log("isNotDefaultCheckbox", isNotDefaultCheckbox);

                      // if it is a default checkbox then empty the body before appending apiData checkboxes
                      if (!isNotDefaultCheckbox) {
                        container.components("");
                        data.forEach((opt) => {
                          let groupEle = {
                            tagName: "span",
                            type: "default",
                            attributes: {
                              class: "group_checkbox_label",
                            },

                            "style-default": {
                              display: "flex",
                              "flex-wrap": "no-wrap",
                              "justify-content": "flex-start",
                              "align-items": "flex-start",
                              width: CommonWidth
                                ? CommonWidth + "%"
                                : "8% !important",
                            },

                            style: {
                              display: "flex",
                              "flex-wrap": "no-wrap",
                              "justify-content": "flex-start",
                              "align-items": "flex-start",
                              width: CommonWidth
                                ? CommonWidth + "%"
                                : "8% !important",
                            },

                            components: [
                              {
                                tagName: "span",
                                type: "checkbox_input_new",
                                script: individualCheckboxScriptNew,

                                attributes: {
                                  class: "checkbox_input_new",
                                },

                                components: [
                                  {
                                    tagName: "input",
                                    type: "default",
                                    attributes: {
                                      type: "checkbox",
                                      id: `checkbox_1_${uniqid()}`,
                                      name: `checkbox_1_${uniqid()}`,
                                      value: `${opt[`${ArrOfObjKyename}`]}`,
                                      data_db_id: `${opt[`_id`]}`
                                        ? `${opt[`_id`]}`
                                        : `${opt[`${ArrOfObjKyename}`]}`,
                                    },
                                  },
                                ],

                                Autofocus: false,
                                Disabled: false,
                                Required: false,
                                Checked: false,

                                traits: [
                                  "id",
                                  "name",
                                  "value",
                                  {
                                    type: "checkbox",
                                    name: "Autofocus",
                                    label: "Autofocus",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Disabled",
                                    label: "Disabled",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Required",
                                    label: "Required",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Checked",
                                    label: "Checked",
                                    changeProp: true,
                                  },
                                ],

                                changeProp: true,
                                "script-props": [
                                  "Autofocus",
                                  "Disabled",
                                  "Required",
                                  "Checked",
                                ],
                              },
                              {
                                tagName: "label",
                                type: "checkbox_label_new",
                                attributes: {
                                  for: ``,
                                },

                                components: [
                                  {
                                    tagName: "p",
                                    type: "text",
                                    editable: true,

                                    style: {
                                      "word-break": "break-all",
                                    },

                                    "style-default": {
                                      "word-break": "break-all",
                                    },

                                    components: {
                                      type: "textnode",
                                      content: `${opt[`${ArrOfObjKyename}`]}`,
                                    },
                                  },
                                ],

                                traits: ["id", "for"],
                              },
                            ],
                          };

                          // let inputEle = {
                          //   tagName: "input",
                          //   type: "default", // so that the input component doesn't throw error of 'undefined'

                          //   script: individualCheckboxScript,

                          //   attributes: {
                          //     type: "checkbox",
                          //     // id: `${opt[`${ArrOfObjKyename}`]}`,
                          //     name: `${opt[`${ArrOfObjKyename}`]}`,
                          //     value: `${opt[`${ArrOfObjKyename}`]}`,
                          //   },

                          //   Autofocus: false,
                          //   Disabled: false,
                          //   Required: false,
                          //   Checked: false,

                          //   traits: [
                          //     "id",
                          //     "name",
                          //     "value",
                          //     {
                          //       type: "checkbox",
                          //       name: "Autofocus",
                          //       label: "Autofocus",
                          //       changeProp: true,
                          //     },
                          //     {
                          //       type: "checkbox",
                          //       name: "Disabled",
                          //       label: "Disabled",
                          //       changeProp: true,
                          //     },
                          //     {
                          //       type: "checkbox",
                          //       name: "Required",
                          //       label: "Required",
                          //       changeProp: true,
                          //     },
                          //     {
                          //       type: "checkbox",
                          //       name: "Checked",
                          //       label: "Checked",
                          //       changeProp: true,
                          //     },
                          //   ],

                          //   changeProp: true,
                          //   "script-props": [
                          //     "Autofocus",
                          //     "Disabled",
                          //     "Required",
                          //     "Checked",
                          //   ],
                          // };

                          // let labelEle = {
                          //   tagName: "label",
                          //   attributes: {
                          //     for: ``,
                          //   },

                          //   components: [
                          //     {
                          //       tagName: "p",
                          //       type: "text",
                          //       editable: true,

                          //       components: {
                          //         type: "textnode",
                          //         content: `${opt[`${ArrOfObjKyename}`]}`,
                          //       },
                          //     },
                          //   ],

                          //   traits: ["id", "for"],
                          // };

                          // container.append(inputEle);
                          // container.append(labelEle);
                          container.append(groupEle);
                        });
                      }
                    }

                    // dynamic delete
                    if (container.components().length > data.length) {
                      console.log("removing extra group_checkbox_labels");

                      let groupCheckboxLabels = container.find(
                        ".group_checkbox_label"
                      );
                      groupCheckboxLabels.forEach((groupCheckboxLabel) => {
                        // get the data_db_url from checkbox and check if _id is present in apiData, if not, remove it
                        let checkbox = groupCheckboxLabel
                          .find(".checkbox_input_new")[0]
                          .find('input[type="checkbox"]')[0];
                        let checkboxDataDbId =
                          checkbox.getAttributes()["data_db_id"];

                        // see if checkboxDataDbId is in apiData _ids and if not there, delete this group_checkbox_label
                        let apiData_id = data.map((obj) => obj["_id"]);

                        if (!apiData_id.includes(checkboxDataDbId)) {
                          groupCheckboxLabel.remove();
                          console.log("removed");
                        }
                      });
                    }
                  }
                } else if (NestedKeyname && !ArrOfObjKyename) {
                  // container.components("");

                  // find the array value
                  let data = findKeyValue(apiData, NestedKeyname);

                  // if API response to plot is a nested plain array of single elements inside the main response object
                  if (Array.isArray(data) && !isArrayofObjects(data)) {
                    console.log("#####");

                    // either no checkboxes are plotted or the default 2 checkboxes are there
                    if (
                      container.components().length === 0 ||
                      container.components().length <= 2
                    ) {
                      container.components("");

                      data.forEach((opt) => {
                        let groupEle = {
                          tagName: "span",
                          type: "default",
                          attributes: {
                            class: "group_checkbox_label",
                          },

                          "style-default": {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          style: {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          components: [
                            {
                              tagName: "span",
                              type: "checkbox_input_new",
                              script: individualCheckboxScriptNew,

                              attributes: {
                                class: "checkbox_input_new",
                              },

                              components: [
                                {
                                  tagName: "input",
                                  type: "default",
                                  attributes: {
                                    type: "checkbox",
                                    id: `checkbox_1_${uniqid()}`,
                                    name: `checkbox_1_${uniqid()}`,
                                    value: `${opt}`,
                                  },
                                },
                              ],

                              Autofocus: false,
                              Disabled: false,
                              Required: false,
                              Checked: false,

                              traits: [
                                "id",
                                "name",
                                "value",
                                {
                                  type: "checkbox",
                                  name: "Autofocus",
                                  label: "Autofocus",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Disabled",
                                  label: "Disabled",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Required",
                                  label: "Required",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Checked",
                                  label: "Checked",
                                  changeProp: true,
                                },
                              ],

                              changeProp: true,
                              "script-props": [
                                "Autofocus",
                                "Disabled",
                                "Required",
                                "Checked",
                              ],
                            },
                            {
                              tagName: "label",
                              type: "checkbox_label_new",
                              attributes: {
                                for: ``,
                              },

                              components: [
                                {
                                  tagName: "p",
                                  type: "text",
                                  editable: true,

                                  style: {
                                    "word-break": "break-all",
                                  },

                                  "style-default": {
                                    "word-break": "break-all",
                                  },

                                  components: {
                                    type: "textnode",
                                    content: `${opt}`,
                                  },
                                },
                              ],

                              traits: ["id", "for"],
                            },
                          ],
                        };

                        // let inputEle = {
                        //   tagName: "input",
                        //   type: "default", // so that the input component doesn't throw error of 'undefined'

                        //   script: individualCheckboxScript,

                        //   attributes: {
                        //     type: "checkbox",
                        //     // id: `ch-${opt}`,
                        //     name: `ch-${opt}`,
                        //     value: `${opt}`,
                        //   },

                        //   Autofocus: false,
                        //   Disabled: false,
                        //   Required: false,
                        //   Checked: false,

                        //   traits: [
                        //     "id",
                        //     "name",
                        //     "value",
                        //     {
                        //       type: "checkbox",
                        //       name: "Autofocus",
                        //       label: "Autofocus",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Disabled",
                        //       label: "Disabled",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Required",
                        //       label: "Required",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Checked",
                        //       label: "Checked",
                        //       changeProp: true,
                        //     },
                        //   ],

                        //   changeProp: true,
                        //   "script-props": [
                        //     "Autofocus",
                        //     "Disabled",
                        //     "Required",
                        //     "Checked",
                        //   ],
                        // };

                        // let labelEle = {
                        //   tagName: "label",
                        //   attributes: {
                        //     for: ``,
                        //   },

                        //   components: [
                        //     {
                        //       tagName: "p",
                        //       type: "text",
                        //       editable: true,

                        //       components: {
                        //         type: "textnode",
                        //         content: `${opt}`,
                        //       },
                        //     },
                        //   ],

                        //   traits: ["id", "for"],
                        // };

                        // container.append(inputEle);
                        // container.append(labelEle);
                        container.append(groupEle);
                      });
                    }

                    // else if the apiData checkboxes are already plotted then check for updated values and add those here without changing the IDd of already plotted ones
                    else if (
                      data.length > container.components().length &&
                      container.components().length > 2
                    ) {
                      // only add what's missing from api as a dynamic update

                      // get all the labels' inner content and compare it with the keyname of the apiData to be plotted and add the ones missing
                      let allLabelEles = container.find(
                        'label[data-gjs-type="checkbox_label_new"]'
                      );
                      let allLabels = allLabelEles.map(
                        (label) =>
                          label.find('p[data-gjs-type="text"]')[0].getEl()
                            .innerHTML
                      );
                      console.log("allLabelEles", allLabelEles, allLabels);

                      if (allLabelEles.length > 0) {
                        // if you find a label thats not in the apiData then add it to the existing checkbox container
                        data.forEach((opt, idx) => {
                          let groupEle = {
                            tagName: "span",
                            type: "default",
                            attributes: {
                              class: "group_checkbox_label",
                            },

                            "style-default": {
                              display: "flex",
                              "flex-wrap": "no-wrap",
                              "justify-content": "flex-start",
                              "align-items": "flex-start",
                              width: CommonWidth
                                ? CommonWidth + "%"
                                : "8% !important",
                            },

                            style: {
                              display: "flex",
                              "flex-wrap": "no-wrap",
                              "justify-content": "flex-start",
                              "align-items": "flex-start",
                              width: CommonWidth
                                ? CommonWidth + "%"
                                : "8% !important",
                            },

                            components: [
                              {
                                tagName: "span",
                                type: "checkbox_input_new",
                                script: individualCheckboxScriptNew,

                                attributes: {
                                  class: "checkbox_input_new",
                                },

                                components: [
                                  {
                                    tagName: "input",
                                    type: "default",
                                    attributes: {
                                      type: "checkbox",
                                      id: `checkbox_1_${uniqid()}`,
                                      name: `checkbox_1_${uniqid()}`,
                                      value: `${opt}`,
                                    },
                                  },
                                ],

                                Autofocus: false,
                                Disabled: false,
                                Required: false,
                                Checked: false,

                                traits: [
                                  "id",
                                  "name",
                                  "value",
                                  {
                                    type: "checkbox",
                                    name: "Autofocus",
                                    label: "Autofocus",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Disabled",
                                    label: "Disabled",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Required",
                                    label: "Required",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Checked",
                                    label: "Checked",
                                    changeProp: true,
                                  },
                                ],

                                changeProp: true,
                                "script-props": [
                                  "Autofocus",
                                  "Disabled",
                                  "Required",
                                  "Checked",
                                ],
                              },
                              {
                                tagName: "label",
                                type: "checkbox_label_new",
                                attributes: {
                                  for: ``,
                                },

                                components: [
                                  {
                                    tagName: "p",
                                    type: "text",
                                    editable: true,

                                    style: {
                                      "word-break": "break-all",
                                    },

                                    "style-default": {
                                      "word-break": "break-all",
                                    },

                                    components: {
                                      type: "textnode",
                                      content: `${opt}`,
                                    },
                                  },
                                ],

                                traits: ["id", "for"],
                              },
                            ],
                          };

                          // let inputEle = {
                          //   tagName: "input",
                          //   type: "default", // so that the input component doesn't throw error of 'undefined'

                          //   script: individualCheckboxScript,

                          //   attributes: {
                          //     type: "checkbox",
                          //     // id: `ch-${opt}`,
                          //     name: `ch-${opt}`,
                          //     value: `${opt}`,
                          //   },

                          //   Autofocus: false,
                          //   Disabled: false,
                          //   Required: false,
                          //   Checked: false,

                          //   traits: [
                          //     "id",
                          //     "name",
                          //     "value",
                          //     {
                          //       type: "checkbox",
                          //       name: "Autofocus",
                          //       label: "Autofocus",
                          //       changeProp: true,
                          //     },
                          //     {
                          //       type: "checkbox",
                          //       name: "Disabled",
                          //       label: "Disabled",
                          //       changeProp: true,
                          //     },
                          //     {
                          //       type: "checkbox",
                          //       name: "Required",
                          //       label: "Required",
                          //       changeProp: true,
                          //     },
                          //     {
                          //       type: "checkbox",
                          //       name: "Checked",
                          //       label: "Checked",
                          //       changeProp: true,
                          //     },
                          //   ],

                          //   changeProp: true,
                          //   "script-props": [
                          //     "Autofocus",
                          //     "Disabled",
                          //     "Required",
                          //     "Checked",
                          //   ],
                          // };

                          // let labelEle = {
                          //   tagName: "label",
                          //   attributes: {
                          //     for: ``,
                          //   },

                          //   components: [
                          //     {
                          //       tagName: "p",
                          //       type: "text",
                          //       editable: true,

                          //       components: {
                          //         type: "textnode",
                          //         content: `${opt}`,
                          //       },
                          //     },
                          //   ],

                          //   traits: ["id", "for"],
                          // };

                          // container.append(inputEle);
                          // container.append(labelEle);
                          container.append(groupEle);
                        });
                      }
                    }
                  }

                  // if API response to plot are all key:value pairs of a plain object inside main object
                  else if (
                    !Array.isArray(data) &&
                    !isArrayofObjects(data) &&
                    typeof data === "object"
                  ) {
                    console.log("######");
                    Object.keys(data).forEach((key) => {
                      if (
                        !Array.isArray(data[`${key}`]) &&
                        typeof data[`${key}`] !== "object"
                      ) {
                        let groupEle = {
                          tagName: "span",
                          type: "default",
                          attributes: {
                            class: "group_checkbox_label",
                          },

                          "style-default": {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          style: {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          components: [
                            {
                              tagName: "span",
                              type: "checkbox_input_new",
                              script: individualCheckboxScriptNew,

                              attributes: {
                                class: "checkbox_input_new",
                              },

                              components: [
                                {
                                  tagName: "input",
                                  type: "default",
                                  attributes: {
                                    type: "checkbox",
                                    id: `checkbox_1_${uniqid()}`,
                                    name: `checkbox_1_${uniqid()}`,
                                    value: `${data[`${key}`]}`,
                                  },
                                },
                              ],

                              Autofocus: false,
                              Disabled: false,
                              Required: false,
                              Checked: false,

                              traits: [
                                "id",
                                "name",
                                "value",
                                {
                                  type: "checkbox",
                                  name: "Autofocus",
                                  label: "Autofocus",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Disabled",
                                  label: "Disabled",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Required",
                                  label: "Required",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Checked",
                                  label: "Checked",
                                  changeProp: true,
                                },
                              ],

                              changeProp: true,
                              "script-props": [
                                "Autofocus",
                                "Disabled",
                                "Required",
                                "Checked",
                              ],
                            },
                            {
                              tagName: "label",
                              type: "checkbox_label_new",
                              attributes: {
                                for: ``,
                              },

                              components: [
                                {
                                  tagName: "p",
                                  type: "text",
                                  editable: true,

                                  style: {
                                    "word-break": "break-all",
                                  },

                                  "style-default": {
                                    "word-break": "break-all",
                                  },

                                  components: {
                                    type: "textnode",
                                    content: `${key}`,
                                  },
                                },
                              ],

                              traits: ["id", "for"],
                            },
                          ],
                        };

                        // let inputEle = {
                        //   tagName: "input",
                        //   type: "default", // so that the input component doesn't throw error of 'undefined'

                        //   script: individualCheckboxScript,

                        //   attributes: {
                        //     type: "checkbox",
                        //     // id: `${data[`${key}`]}`,
                        //     name: `${data[`${key}`]}`,
                        //     value: `${data[`${key}`]}`,
                        //   },

                        //   Autofocus: false,
                        //   Disabled: false,
                        //   Required: false,
                        //   Checked: false,

                        //   traits: [
                        //     "id",
                        //     "name",
                        //     "value",
                        //     {
                        //       type: "checkbox",
                        //       name: "Autofocus",
                        //       label: "Autofocus",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Disabled",
                        //       label: "Disabled",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Required",
                        //       label: "Required",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Checked",
                        //       label: "Checked",
                        //       changeProp: true,
                        //     },
                        //   ],

                        //   changeProp: true,
                        //   "script-props": [
                        //     "Autofocus",
                        //     "Disabled",
                        //     "Required",
                        //     "Checked",
                        //   ],
                        // };

                        // let labelEle = {
                        //   tagName: "label",
                        //   attributes: {
                        //     for: ``,
                        //   },

                        //   components: [
                        //     {
                        //       tagName: "p",
                        //       type: "text",
                        //       editable: true,

                        //       components: {
                        //         type: "textnode",
                        //         content: `${key}`,
                        //       },
                        //     },
                        //   ],

                        //   traits: ["id", "for"],
                        // };

                        // container.append(inputEle);
                        // container.append(labelEle);
                        container.append(groupEle);
                      }
                    });
                  }
                }

                // if API response to plot are all key:value pairs of the plain object
                else if (!NestedKeyname && !ArrOfObjKyename) {
                  console.log("#######");
                  container.components("");

                  Object.keys(apiData).forEach((key) => {
                    if (
                      !Array.isArray(apiData[`${key}`]) &&
                      typeof apiData[`${key}`] !== "object"
                    ) {
                      let groupEle = {
                        tagName: "span",
                        type: "default",
                        attributes: {
                          class: "group_checkbox_label",
                        },

                        "style-default": {
                          display: "flex",
                          "flex-wrap": "no-wrap",
                          "justify-content": "flex-start",
                          "align-items": "flex-start",
                          width: CommonWidth
                            ? CommonWidth + "%"
                            : "8% !important",
                        },

                        style: {
                          display: "flex",
                          "flex-wrap": "no-wrap",
                          "justify-content": "flex-start",
                          "align-items": "flex-start",
                          width: CommonWidth
                            ? CommonWidth + "%"
                            : "8% !important",
                        },

                        components: [
                          {
                            tagName: "span",
                            type: "checkbox_input_new",
                            script: individualCheckboxScriptNew,

                            attributes: {
                              class: "checkbox_input_new",
                            },

                            components: [
                              {
                                tagName: "input",
                                type: "default",
                                attributes: {
                                  type: "checkbox",
                                  id: `checkbox_1_${uniqid()}`,
                                  name: `checkbox_1_${uniqid()}`,
                                  value: `${apiData[`${key}`]}`,
                                },
                              },
                            ],

                            Autofocus: false,
                            Disabled: false,
                            Required: false,
                            Checked: false,

                            traits: [
                              "id",
                              "name",
                              "value",
                              {
                                type: "checkbox",
                                name: "Autofocus",
                                label: "Autofocus",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Disabled",
                                label: "Disabled",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Required",
                                label: "Required",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Checked",
                                label: "Checked",
                                changeProp: true,
                              },
                            ],

                            changeProp: true,
                            "script-props": [
                              "Autofocus",
                              "Disabled",
                              "Required",
                              "Checked",
                            ],
                          },
                          {
                            tagName: "label",
                            type: "checkbox_label_new",
                            attributes: {
                              for: ``,
                            },

                            components: [
                              {
                                tagName: "p",
                                type: "text",
                                editable: true,

                                style: {
                                  "word-break": "break-all",
                                },

                                "style-default": {
                                  "word-break": "break-all",
                                },

                                components: {
                                  type: "textnode",
                                  content: `${key}`,
                                },
                              },
                            ],

                            traits: ["id", "for"],
                          },
                        ],
                      };

                      // let inputEle = {
                      //   tagName: "input",
                      //   type: "default", // so that the input component doesn't throw error of 'undefined'

                      //   script: individualCheckboxScript,

                      //   attributes: {
                      //     type: "checkbox",
                      //     // id: `${apiData[`${key}`]}`,
                      //     name: `${apiData[`${key}`]}`,
                      //     value: `${apiData[`${key}`]}`,
                      //   },

                      //   Autofocus: false,
                      //   Disabled: false,
                      //   Required: false,
                      //   Checked: false,

                      //   traits: [
                      //     "id",
                      //     "name",
                      //     "value",
                      //     {
                      //       type: "checkbox",
                      //       name: "Autofocus",
                      //       label: "Autofocus",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Disabled",
                      //       label: "Disabled",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Required",
                      //       label: "Required",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Checked",
                      //       label: "Checked",
                      //       changeProp: true,
                      //     },
                      //   ],

                      //   changeProp: true,
                      //   "script-props": [
                      //     "Autofocus",
                      //     "Disabled",
                      //     "Required",
                      //     "Checked",
                      //   ],
                      // };

                      // let labelEle = {
                      //   tagName: "label",
                      //   attributes: {
                      //     for: ``,
                      //   },

                      //   components: [
                      //     {
                      //       tagName: "p",
                      //       type: "text",
                      //       editable: true,

                      //       components: {
                      //         type: "textnode",
                      //         content: `${key}`,
                      //       },
                      //     },
                      //   ],

                      //   traits: ["id", "for"],
                      // };

                      // container.append(inputEle);
                      // container.append(labelEle);
                      container.append(groupEle);
                    }
                  });
                }

                // if there is a 'message' in api response instead of data
                else if (Object.keys(apiData).includes("message")) {
                  console.log("#@@");

                  container.components("");
                  container.components().push({
                    tagName: "span",
                    type: "default",
                    attributes: {
                      class: "group_checkbox_label",
                    },

                    "style-default": {
                      display: "flex",
                      "flex-wrap": "no-wrap",
                      "justify-content": "flex-start",
                      "align-items": "flex-start",
                      width: "8%",
                    },

                    style: {
                      display: "flex",
                      "flex-wrap": "no-wrap",
                      "justify-content": "flex-start",
                      "align-items": "flex-start",
                      width: "8%",
                    },

                    components: [
                      {
                        tagName: "label",
                        type: "checkbox_label_new",
                        attributes: {
                          for: "",
                        },

                        components: [
                          {
                            tagName: "p",
                            type: "text",
                            editable: true,

                            style: {
                              width: "max-content",
                              "word-break": "break-all",
                            },

                            "style-default": {
                              width: "max-content",
                              "word-break": "break-all",
                            },

                            components: {
                              type: "textnode",
                              content: "No Values.",
                            },
                          },
                        ],

                        traits: ["id", "for"],
                        changeProp: true,
                      },
                      {
                        tagName: "span",
                        type: "checkbox_input_new",

                        attributes: {
                          class: "checkbox_input_new",
                        },

                        style: {
                          "margin-right": "5%",
                          display: "none",
                        },

                        "style-default": {
                          "margin-right": "5%",
                          display: "none",
                        },

                        components: [
                          {
                            tagName: "input",
                            type: "default",
                            attributes: {
                              type: "checkbox",
                              // id: `checkbox_1_${uniqid()}`,
                              name: `checkbox_1_${uniqid()}`,
                              value: "checkbox_1",
                            },
                          },
                        ],
                      },
                    ],
                  });
                }
              }
            }
          },
        },

        view: {
          onRender({ el, model }) {
            if (
              el.getAttribute("data-gjs-type") === "checkbox_regular_form_new"
            ) {
              console.log("rendering", el);
              model.handlePropChange();
            }
          },
        },
      });

      const checkboxRegularFormSingleScript = async function (props) {
        let container = this;

        let idEl = this.id;
        const urlDownload = window.top.location.href;
        const isSubstringPresent =
          (urlDownload.indexOf("/editor/") !== -1 &&
            urlDownload.indexOf("?projectId=") !== -1) ||
          urlDownload.indexOf("/large_preview/") !== -1 ||
          urlDownload.indexOf("/tab_preview/") !== -1 ||
          urlDownload.indexOf("/mobile_preview/") !== -1 ||
          urlDownload.indexOf("/fragment_editor/") !== -1;

        // to update table props as soon as window is updated and then trigger rendering
        if (!isSubstringPresent) {
          setInterval(function () {
            Object.keys(props).forEach(function (key) {
              if (window[`${key}${idEl}`]) {
                if (props[key] === window[`${key}${idEl}`]) {
                  // console.log('');
                } else {
                  props[key] = window[`${key}${idEl}`];
                  initLib(props);
                }
              }
            });
          }, 500);
        }

        function initLib(props) {
          let checkboxEle = container.getElementsByClassName("checkbox")[0];

          if (checkboxEle) {
            checkboxEle.setAttribute("name", props["name"]);
            checkboxEle.setAttribute("value", props["value"]);
            checkboxEle.setAttribute("title", props["title"]);

            if (props.checked) checkboxEle.setAttribute("checked", "checked");
            else checkboxEle.removeAttribute("checked");

            if (props.required)
              checkboxEle.setAttribute("required", "required");
            else checkboxEle.removeAttribute("required");
          }
        }
      };

      editor.DomComponents.addType("checkbox_regular_form_single", {
        model: {
          defaults: {
            tagName: "div",
            script: checkboxRegularFormSingleScript,
            attributes: {
              class: "checkbox_regular_form_single",
            },

            name: "checkbox",
            value: "checkbox",
            checked: false,
            required: false,

            style: {
              width: "max-content",
            },

            "style-default": {
              width: "max-content",
            },

            components: [
              {
                tagName: "input",
                type: "checkbox",
                attributes: {
                  type: "checkbox",
                  class: "checkbox",
                  name: "checkbox",
                  value: "checkbox",
                },

                traits: ["id", "name", "value"],
              },
              {
                tagName: "label",
                attributes: {
                  class: "label",
                  for: "",
                },

                components: [
                  {
                    tagName: "p",
                    type: "text",
                    editable: true,

                    style: {
                      width: "max-content",
                      "word-break": "break-all",
                    },

                    "style-default": {
                      width: "max-content",
                      "word-break": "break-all",
                    },

                    components: {
                      type: "textnode",
                      content: "checkbox",
                    },
                  },
                ],
                traits: ["for"],
              },
            ],

            traits: [
              "id",
              "title",
              {
                type: "text",
                name: "name",
                label: "Name",
                changeProp: true,
              },
              {
                type: "text",
                name: "value",
                label: "value",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "checked",
                label: "checked",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "required",
                label: "required",
                changeProp: true,
              },
            ],

            "script-props": [
              "id",
              "title",
              "name",
              "value",
              "checked",
              "required",
            ],

            changeProp: true,
          },

          init() {
            // Assign a persistent ID to the input child component
            const inputComponent = this.get("components").at(0); // First child is the input
            const labelComponent = this.get("components").at(1); // Second child is the label

            if (inputComponent && inputComponent.get("type") === "checkbox") {
              const currentId = inputComponent.getAttributes().id;
              let persistentId = currentId;

              // If the ID is not already set, generate a deterministic one
              if (!currentId) {
                persistentId = `checkbox_${this.cid}`; // Generate a unique ID
                inputComponent.addAttributes({ id: persistentId });
              }

              // Update the label's "for" attribute with the same ID
              if (labelComponent) {
                const labelAttributes = labelComponent.getAttributes();
                const currentFor = labelAttributes.for;
                if (!currentFor || currentFor !== persistentId) {
                  labelComponent.addAttributes({ for: persistentId });
                }
              }
            }

            this.on("change:name", this.nameChangeHandler);
            this.on("change:value", this.valueChangeHandler);
            this.on("change:checked", this.checkedChangeHandler);
            this.on("change:required", this.requiredChangeHandler);
          },

          nameChangeHandler() {
            let { name } = this.props();
            let checkboxComp = this.find("input[type='checkbox']")[0];

            if (checkboxComp) {
              checkboxComp.addAttributes({
                name,
              });
            }
          },

          valueChangeHandler() {
            let { value } = this.props();
            let checkboxComp = this.find("input[type='checkbox']")[0];

            if (checkboxComp) {
              checkboxComp.addAttributes({
                value,
              });
            }
          },

          checkedChangeHandler() {
            let { checked } = this.props();
            let checkboxComp = this.find("input[type='checkbox']")[0];

            if (checkboxComp) {
              if (checked) {
                checkboxComp.addAttributes({
                  checked: "checked",
                });
              } else {
                checkboxComp.removeAttributes("checked");
              }
            }
          },

          requiredChangeHandler() {
            let { required } = this.props();
            let checkboxComp = this.find("input[type='checkbox']")[0];

            if (checkboxComp) {
              if (required) {
                checkboxComp.addAttributes({
                  required: "required",
                });
              } else {
                checkboxComp.removeAttributes("required");
              }
            }
          },
        },
      });

      const individualRadioScript = function (props) {
        console.log("this element:", this, props);

        let container = this.getElementsByTagName("input")[0];

        if (props.Autofocus) {
          container.setAttribute("autofocus", true);
        }

        if (props.Disabled) {
          container.setAttribute("disabled", true);
        }

        if (props.Required) {
          container.setAttribute("required", true);
        }

        if (props.Checked) {
          container.setAttribute("checked", true);
        }

        if (props.Value) {
          container.setAttribute("value", props.Value);
        }

        if (props.Name) {
          console.log("radio", container);
          container.setAttribute("name", props.Name);
        }

        let wrapperNew = this.parentNode.parentNode;
        let inputs = wrapperNew.querySelectorAll("input");

        function generateRandomString(length) {
          const characters =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
          let result = "";
          for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            result += characters.charAt(randomIndex);
          }
          return result;
        }

        // Example usage
        // const randomString = generateRandomString(6); // Generates a random string of length 10

        // Iterate over each input element and change its name attribute to 'radio'
        // inputs.forEach((input) => {
        //   input.setAttribute("name", `${randomString}`);
        // });

        // Event delegation: Attach the event listener to a common parent
        const parentElement = this.parentNode.parentNode; // The parent container for all radio buttons

        if (parentElement) {
          parentElement.addEventListener("change", function (event) {
            // Check if the event target is a radio button
            if (event.target && event.target.type === "radio") {
              console.log("Radio button changed:", event.target);

              let wrapper = event.target.parentNode.parentNode; // Find the wrapper for the radio button
              let mainDiv = wrapper.parentNode; // Find the main container
              console.log("wrapper:::::", wrapper);
              console.log("mainDiv:::::", mainDiv);

              console.log(
                "data_db_id::::",
                event.target.getAttribute("data_db_id")
              );

              if (event.target.checked) {
                // Update attributes for the wrapper and main container
                wrapper.setAttribute("value", event.target.value);
                wrapper.setAttribute(
                  "data_db_id",
                  event.target.getAttribute("data_db_id")
                );
                mainDiv.setAttribute("value", event.target.value);
                mainDiv.setAttribute(
                  "data_db_id",
                  event.target.getAttribute("data_db_id")
                );
              }
            }
          });
        }
      };

      editor.DomComponents.addType("radio_input", {
        model: {
          defaults: {
            tagName: "span",
            type: "radio_input",
            script: individualRadioScript,

            attributes: {
              class: "radio_input",
            },

            style: {
              "margin-right": "5%",
            },

            "style-default": {
              "margin-right": "5%",
            },

            components: [
              {
                tagName: "input",
                type: "default",
                attributes: {
                  type: "radio",
                  id: `radio_1_${uniqid()}`,
                  name: "radio_1",
                  value: "radio_1",
                },
              },
            ],

            Autofocus: false,
            Disabled: false,
            Required: false,
            Checked: false,
            Name: "radio_1",

            traits: [
              {
                type: "checkbox",
                name: "Autofocus",
                label: "Autofocus",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "Disabled",
                label: "Disabled",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "Required",
                label: "Required",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "Checked",
                label: "Checked",
                changeProp: true,
              },
              {
                type: "text",
                name: "Value",
                label: "Value",
                changeProp: true,
              },
              {
                type: "text",
                name: "Name",
                label: "Name",
                changeProp: true,
              },
              "id",
            ],

            changeProp: true,
            "script-props": [
              "Value",
              "Autofocus",
              "Disabled",
              "Required",
              "Checked",
              "Name",
            ],
          },
        },
      });

      editor.DomComponents.addType("radio_label", {
        model: {
          defaults: {
            tagName: "label",
            type: "radio_label",
            attributes: {
              for: "",
            },

            components: [
              {
                tagName: "p",
                type: "text",
                editable: true,

                style: {
                  width: "max-content",
                  "word-break": "break-all",
                },

                "style-default": {
                  width: "max-content",
                  "word-break": "break-all",
                },

                components: {
                  type: "textnode",
                  content: "radio_1",
                },
              },
            ],

            traits: ["id", "for"],
            changeProp: true,
          },
        },
      });

      // for run-time replication
      const radioRegularFormScript = async function (props) {
        console.log(
          "radio_regular_form_new props",
          props,
          this,
          this.id,
          this.childNodes.length
        );

        // For LB download manipulation
        // checking if the url or script is not running in the redsling editor, only then run the script to plot checkboxes
        let idEl = this.id;
        const urlDownload = window.top.location.href;
        const isSubstringPresent =
          (urlDownload.indexOf("/editor/") !== -1 &&
            urlDownload.indexOf("?projectId=") !== -1) ||
          urlDownload.indexOf("/large_preview/") !== -1 ||
          urlDownload.indexOf("/tab_preview/") !== -1 ||
          urlDownload.indexOf("/mobile_preview/") !== -1 ||
          urlDownload.indexOf("/fragment_editor/") !== -1;
        if (!isSubstringPresent) {
          setInterval(function () {
            Object.keys(props).forEach(function (key) {
              if (window[`${key}${idEl}`]) {
                props[key] = window[`${key}${idEl}`];
              }
            });
          }, 500);
        }

        // base url bearer token taken directly from local storage after getting downloaded
        let baseUrlData,
          dynamicBaseUrlBearerToken,
          baseUrl1BearerToken,
          baseUrl2BearerToken,
          baseUrl3BearerToken,
          baseUrl4BearerToken,
          baseUrl5BearerToken;
        // getting baseUrl data from local storage for run-time access
        let baseUrlDataFromStorage = localStorage.getItem("baseUrlData");
        if (baseUrlDataFromStorage) {
          baseUrlData = JSON.parse(baseUrlDataFromStorage);
        }
        // extracting token values from base URLs from baseUrlData
        if (baseUrlData) {
          try {
            if (`baseUrl1_${props.projectId}` in baseUrlData) {
              baseUrl1BearerToken =
                baseUrlData[`baseUrl1_${props.projectId}`].token;
            }
            if (`baseUrl2_${props.projectId}` in baseUrlData) {
              baseUrl2BearerToken =
                baseUrlData[`baseUrl2_${props.projectId}`].token;
            }
            if (`baseUrl3_${props.projectId}` in baseUrlData) {
              baseUrl3BearerToken =
                baseUrlData[`baseUrl3_${props.projectId}`].token;
            }
            if (`baseUrl4_${props.projectId}` in baseUrlData) {
              baseUrl4BearerToken =
                baseUrlData[`baseUrl4_${props.projectId}`].token;
            }
            if (`baseUrl5_${props.projectId}` in baseUrlData) {
              baseUrl5BearerToken =
                baseUrlData[`baseUrl5_${props.projectId}`].token;
            }
          } catch (e) {
            // statements
            console.log(e);
          }
        }

        // helper function to check if a variable is an array-of-objects or not
        function isArrayofObjects(variable) {
          // Check if the variable is an array
          if (!Array.isArray(variable)) {
            return false;
          }

          // Check if all elements in the array are objects
          for (const element of variable) {
            if (
              typeof element !== "object" ||
              Array.isArray(element) ||
              element === null
            ) {
              return false;
            }
          }
          return true;
        }

        // helper function to get value of a key in nested object
        function findKeyValue(obj, key) {
          if (obj.hasOwnProperty(key)) {
            // If the current object has the key, return its value
            return obj[key];
          }

          for (var prop in obj) {
            if (obj.hasOwnProperty(prop) && typeof obj[prop] === "object") {
              // If the current property is an object, recursively search within it
              var result = findKeyValue(obj[prop], key);
              if (result !== undefined) {
                return result;
              }
            }
          }
          // Key not found in the object
          return undefined;
        }

        // helper function to create an ID string with characters randomly
        function generateRandomString(length) {
          const characters =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
          let result = "";
          for (let i = 0; i < length; i++) {
            result += characters.charAt(
              Math.floor(Math.random() * characters.length)
            );
          }
          return result;
        }

        let mainContainer = this;
        let apiData, API;

        if (props.APIPath) {
          API = props.APIPath;
        }

        // dynamic addition and deletion for the downloaded code
        if (!isSubstringPresent) {
          // -------- Getting API Data
          // if CustomUrl is provided, use only that
          if (
            props.CustomUrl &&
            (!props.BaseUrl || props.BaseUrl === "null") &&
            props.APIMethod !== "POST"
          ) {
            // if nothing is provided for auth
            if (!props.BearerToken && !props.Username && !props.Password) {
              // add extra headers, if needed
              let config = {
                headers: {},
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${props.CustomUrl}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a bearer token is provided but not api_key or usr+pwd
            else if (props.BearerToken && !props.Username && !props.Password) {
              // add extra headers, if needed
              let config = {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${props.BearerToken}`,
                },
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${props.CustomUrl}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a bearer token and api_key not provided but usr+pwd are provided
            else if (!props.BearerToken && props.Username && props.Password) {
              // add extra headers, if needed
              let config = {
                headers: {
                  Authorization:
                    "Basic " + btoa(props.Username + ":" + props.Password),
                },
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${props.CustomUrl}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }
          }

          // if base url is the choice and provided
          else if (
            props.BaseUrl &&
            API &&
            !props.CustomUrl &&
            props.APIMethod !== "POST"
          ) {
            // concatenating base url and its remaining part
            let url, baseUrlBearerToken;
            let forDownloadUrl;
            if (props.BaseUrl === "baseUrl1") {
              url = props.options.baseUrl1 + API;
              forDownloadUrl = "{{API_URL1}}" + API;
              baseUrlBearerToken = props.options.baseUrl1BearerToken;
              dynamicBaseUrlBearerToken = baseUrl1BearerToken;
            } else if (props.BaseUrl === "baseUrl2") {
              url = props.options.baseUrl2 + API;
              forDownloadUrl = "{{API_URL2}}" + API;
              baseUrlBearerToken = props.options.baseUrl2BearerToken;
              dynamicBaseUrlBearerToken = baseUrl2BearerToken;
            } else if (props.BaseUrl === "baseUrl3") {
              url = props.options.baseUrl3 + API;
              forDownloadUrl = "{{API_URL3}}" + API;
              baseUrlBearerToken = props.options.baseUrl3BearerToken;
              dynamicBaseUrlBearerToken = baseUrl3BearerToken;
            } else if (props.BaseUrl === "baseUrl4") {
              url = props.options.baseUrl4 + API;
              forDownloadUrl = "{{API_URL4}}" + API;
              baseUrlBearerToken = props.options.baseUrl4BearerToken;
              dynamicBaseUrlBearerToken = baseUrl4BearerToken;
            } else if (props.BaseUrl === "baseUrl5") {
              url = props.options.baseUrl5 + API;
              forDownloadUrl = "{{API_URL5}}" + API;
              baseUrlBearerToken = props.options.baseUrl5BearerToken;
              dynamicBaseUrlBearerToken = baseUrl5BearerToken;
            }

            // running in download
            url = forDownloadUrl;

            console.log(
              "url, dynamicBaseUrlBearerToken",
              url,
              dynamicBaseUrlBearerToken
            );

            // if nothing is provided for auth
            if (
              !props.BearerToken &&
              !dynamicBaseUrlBearerToken &&
              !props.Username &&
              !props.Password
            ) {
              // add extra headers, if needed
              let config = {
                headers: {},
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${url}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a bearer token is provided but not usr+pwd
            else if (props.BearerToken && !props.Username && !props.Password) {
              // add extra headers, if needed
              let config = {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${props.BearerToken}`,
                },
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${url}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a dynamicBaseUrlBearerToken is provided but not Custom Bearer Token and usr+pwd
            else if (
              dynamicBaseUrlBearerToken &&
              !props.BearerToken &&
              !props.Username &&
              !props.Password
            ) {
              // add extra headers, if needed
              let config = {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${dynamicBaseUrlBearerToken}`,
                },
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config@:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${url}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a bearer token is not provided but usr+pwd are provided
            else if (!props.BearerToken && props.Username && props.Password) {
              // add extra headers, if needed
              let config = {
                headers: {
                  Authorization:
                    "Basic " + btoa(props.Username + ":" + props.Password),
                },
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${url}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }
          }

          // POST method
          // if CustomUrl is provided, use only that
          if (
            props.CustomUrl &&
            (!props.BaseUrl || props.BaseUrl === "null") &&
            props.APIMethod === "POST"
          ) {
            // if nothing is provided for auth
            if (!props.BearerToken && !props.Username && !props.Password) {
              // add extra headers, if needed
              let config = {
                method: "POST",
                headers: {},
                body:
                  typeof props.APIBody === "object"
                    ? JSON.stringify(props.APIBody)
                    : props.APIBody,
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${props.CustomUrl}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a bearer token is provided but not api_key or usr+pwd
            else if (props.BearerToken && !props.Username && !props.Password) {
              // add extra headers, if needed
              let config = {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${props.BearerToken}`,
                },
                body:
                  typeof props.APIBody === "object"
                    ? JSON.stringify(props.APIBody)
                    : props.APIBody,
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${props.CustomUrl}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a bearer token and api_key not provided but usr+pwd are provided
            else if (!props.BearerToken && props.Username && props.Password) {
              // add extra headers, if needed
              let config = {
                method: "POST",
                headers: {
                  Authorization:
                    "Basic " + btoa(props.Username + ":" + props.Password),
                },
                body:
                  typeof props.APIBody === "object"
                    ? JSON.stringify(props.APIBody)
                    : props.APIBody,
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${props.CustomUrl}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }
          }

          // if base url is the choice and provided
          if (
            props.BaseUrl &&
            API &&
            !props.CustomUrl &&
            props.APIMethod === "POST"
          ) {
            // concatenating base url and its remaining part
            let url, baseUrlBearerToken;
            let forDownloadUrl;
            if (props.BaseUrl === "baseUrl1") {
              url = props.options.baseUrl1 + API;
              forDownloadUrl = "{{API_URL1}}" + API;
              baseUrlBearerToken = props.options.baseUrl1BearerToken;
              dynamicBaseUrlBearerToken = baseUrl1BearerToken;
            } else if (props.BaseUrl === "baseUrl2") {
              url = props.options.baseUrl2 + API;
              forDownloadUrl = "{{API_URL2}}" + API;
              baseUrlBearerToken = props.options.baseUrl2BearerToken;
              dynamicBaseUrlBearerToken = baseUrl2BearerToken;
            } else if (props.BaseUrl === "baseUrl3") {
              url = props.options.baseUrl3 + API;
              forDownloadUrl = "{{API_URL3}}" + API;
              baseUrlBearerToken = props.options.baseUrl3BearerToken;
              dynamicBaseUrlBearerToken = baseUrl3BearerToken;
            } else if (props.BaseUrl === "baseUrl4") {
              url = props.options.baseUrl4 + API;
              forDownloadUrl = "{{API_URL4}}" + API;
              baseUrlBearerToken = props.options.baseUrl4BearerToken;
              dynamicBaseUrlBearerToken = baseUrl4BearerToken;
            } else if (props.BaseUrl === "baseUrl5") {
              url = props.options.baseUrl5 + API;
              forDownloadUrl = "{{API_URL5}}" + API;
              baseUrlBearerToken = props.options.baseUrl5BearerToken;
              dynamicBaseUrlBearerToken = baseUrl5BearerToken;
            }

            // running in download
            url = forDownloadUrl;

            console.log(
              "url, dynamicBaseUrlBearerToken",
              url,
              dynamicBaseUrlBearerToken
            );

            // if nothing is provided for auth
            if (
              !props.BearerToken &&
              !dynamicBaseUrlBearerToken &&
              !props.Username &&
              !props.Password
            ) {
              // add extra headers, if needed
              let config = {
                method: "POST",
                headers: {},
                body:
                  typeof props.APIBody === "object"
                    ? JSON.stringify(props.APIBody)
                    : props.APIBody,
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${url}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a bearer token is provided but not usr+pwd
            else if (props.BearerToken && !props.Username && !props.Password) {
              // add extra headers, if needed
              let config = {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${props.BearerToken}`,
                },
                body:
                  typeof props.APIBody === "object"
                    ? JSON.stringify(props.APIBody)
                    : props.APIBody,
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${url}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a dynamicBaseUrlBearerToken is provided but not Custom Bearer Token and usr+pwd
            else if (
              dynamicBaseUrlBearerToken &&
              !props.BearerToken &&
              !props.Username &&
              !props.Password
            ) {
              // add extra headers, if needed
              let config = {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${dynamicBaseUrlBearerToken}`,
                },
                body:
                  typeof props.APIBody === "object"
                    ? JSON.stringify(props.APIBody)
                    : props.APIBody,
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config@:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${url}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }

            // if a bearer token is not provided but usr+pwd are provided
            else if (!props.BearerToken && props.Username && props.Password) {
              // add extra headers, if needed
              let config = {
                method: "POST",
                headers: {
                  Authorization:
                    "Basic " + btoa(props.Username + ":" + props.Password),
                },
                body:
                  typeof props.APIBody === "object"
                    ? JSON.stringify(props.APIBody)
                    : props.APIBody,
              };

              if (props.MoreHeaders) {
                // ['a:b', "c:d"]
                // extracting headers from More_Headers trait
                props.MoreHeaders.split(",").forEach((header) => {
                  let key, val;
                  [key, val] = header.split(":");
                  console.log("[key, val]:\n", key, val);

                  config.headers[key] = val;
                });
              }

              console.log("config:", config);

              try {
                // GET call to get the data
                let response = await fetch(`${url}`, config);
                let responseData = await response.json();
                apiData = responseData;
              } catch (e) {
                // statements
                console.log(e);
              }
            }
          }

          console.log("apiData (in export):", apiData);

          // checking if the url or script is not running in the redsling editor, only then run the script to plot radio

          if (apiData) {
            console.log("#");

            if (isArrayofObjects(apiData)) {
              if (props.ArrOfObjKyename) {
                console.log("##");

                // dynamic add
                // to check if any '_id' data was changed in the backend object, then update the frontend labels of radio also
                if (mainContainer.innerHTML !== "") {
                  console.log("@1");
                  // check if these are database plotted radio or not
                  let isNotDefaultRadio = mainContainer
                    .getElementsByClassName("group_radio_label")[0]
                    .getElementsByClassName("radio_input")[0]
                    .getElementsByTagName("input")[0]
                    .getAttribute("data_db_id");
                  console.log("isNotDefaultRadio", isNotDefaultRadio);

                  // if they are database plotted radio then scan through them using data_db_id and update if any
                  if (isNotDefaultRadio && isNotDefaultRadio !== "") {
                    console.log("@2");
                    let allMiniContainers =
                      mainContainer.getElementsByClassName("group_radio_label");
                    Array.from(allMiniContainers).forEach(
                      (groupRadioLabel, idx) => {
                        let radio = groupRadioLabel
                          .getElementsByClassName("radio_input")[0]
                          .getElementsByTagName("input")[0];
                        let radio_dataDbId = groupRadioLabel
                          .getElementsByClassName("radio_input")[0]
                          .getElementsByTagName("input")[0]
                          .getAttribute("data_db_id");
                        let label =
                          groupRadioLabel.getElementsByTagName("label")[0];

                        // get the object from apiData that has the radio
                        let currentObj = apiData.filter(
                          (obj) => obj["_id"] === radio_dataDbId
                        );

                        if (currentObj.length > 0) {
                          let labelInnerText =
                            label.getElementsByTagName("p")[0].innerHTML;
                          console.log("labelInnerText", labelInnerText);

                          currentObj.forEach((obj) => {
                            // check if the IDs match, if not then update the label's inner text
                            if (
                              labelInnerText !== obj[`${props.ArrOfObjKyename}`]
                            ) {
                              label.getElementsByTagName("p")[0].innerHTML =
                                obj[`${props.ArrOfObjKyename}`];
                              radio.setAttribute(
                                "value",
                                obj[`${props.ArrOfObjKyename}`]
                              );

                              console.log("currentObj", currentObj);
                            }
                          });
                        }
                      }
                    );

                    // if there are equal number of objects in apiData as checkboxes then plot new ones
                    // Check if there are remaining items in apiData to append
                    if (apiData.length > allMiniContainers.length) {
                      let remainingItems = apiData.slice(
                        allMiniContainers.length
                      );
                      remainingItems.forEach((opt) => {
                        let randomString = generateRandomString(7);
                        let groupEle = document.createElement("span");
                        groupEle.setAttribute("data-gjs-type", "default");
                        groupEle.setAttribute("class", "group_radio_label");
                        Object.assign(groupEle.style, {
                          display: "flex",
                          flexWrap: "no-wrap",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          width: props.CommonWidth
                            ? props.CommonWidth + "%"
                            : "8%",
                        });

                        let radioInputNew = document.createElement("span");
                        radioInputNew.setAttribute(
                          "data-gjs-type",
                          "radio_input"
                        );
                        radioInputNew.setAttribute("class", "radio_input");

                        let radioInput = document.createElement("input");
                        radioInput.setAttribute("type", "radio");
                        radioInput.setAttribute("id", `${randomString}`);
                        radioInput.setAttribute(
                          "name",
                          `radio_${mainContainer.id}`
                        );
                        radioInput.setAttribute(
                          "value",
                          `${opt[`${props.ArrOfObjKyename}`]}`
                        );
                        radioInput.setAttribute(
                          "data_db_id",
                          `${opt[`_id`]}`
                            ? `${opt[`_id`]}`
                            : `${opt[`${props.ArrOfObjKyename}`]}`
                        );

                        radioInputNew.appendChild(radioInput);

                        let label = document.createElement("label");
                        label.setAttribute("type", "radio_label");
                        label.setAttribute("for", `${randomString}`);
                        label.innerHTML = `<p id="${generateRandomString(6)}">${
                          opt[`${props.ArrOfObjKyename}`]
                        }</p>`;

                        groupEle.appendChild(label);
                        groupEle.appendChild(radioInputNew);

                        mainContainer.appendChild(groupEle);
                      });
                    }
                  }
                  // else {
                  //   console.log('@3');
                  //   mainContainer.innerHTML = "";

                  //   apiData.forEach((opt) => {
                  //     let randomString = generateRandomString(7);
                  //     let groupEle = document.createElement("span");
                  //     groupEle.setAttribute("data-gjs-type", "default");
                  //     groupEle.setAttribute("class", "group_radio_label");
                  //     Object.assign(groupEle.style, {
                  //       display: "flex",
                  //       flexWrap: "no-wrap",
                  //       justifyContent: "flex-start",
                  //       alignItems: "flex-start",
                  //       width: props.CommonWidth
                  //         ? props.CommonWidth + "%"
                  //         : "8%",
                  //     });

                  //     let radioInputNew = document.createElement("span");
                  //     radioInputNew.setAttribute(
                  //       "data-gjs-type",
                  //       "radio_input"
                  //     );
                  //     radioInputNew.setAttribute("class", "radio_input");

                  //     let radioInput = document.createElement("input");
                  //     radioInput.setAttribute("type", "radio");
                  //     radioInput.setAttribute("id", `${randomString}`);
                  //     radioInput.setAttribute(
                  //       "name",
                  //       `radio_${mainContainer.id}`
                  //     );
                  //     radioInput.setAttribute(
                  //       "value",
                  //       `${opt[`${props.ArrOfObjKyename}`]}`
                  //     );
                  //     radioInput.setAttribute(
                  //       "data_db_id",
                  //       `${opt[`_id`]}`
                  //         ? `${opt[`_id`]}`
                  //         : `${opt[`${props.ArrOfObjKyename}`]}`
                  //     );

                  //     radioInputNew.appendChild(radioInput);

                  //     let label = document.createElement("label");
                  //     label.setAttribute("type", "radio_label");
                  //     label.setAttribute("for", `${randomString}`);
                  //     // Object.assign(label.style, {
                  //     //   wordBreak: "break-all",
                  //     // });
                  //     label.innerHTML = `<p id="${generateRandomString(6)}">${
                  //       opt[`${props.ArrOfObjKyename}`]
                  //     }</p>`;

                  //     groupEle.appendChild(label);
                  //     groupEle.appendChild(radioInputNew);

                  //     mainContainer.appendChild(groupEle);
                  //   });
                  // }
                }

                // reasons -
                // container.components().length === 0 : plot radio if there are no radio present in the container
                // container.components().length === 2 : plot radio the first time when there are the 2 initial radio
                // apiData.length > container.components().length : plot radio if apiData has more objects than radio in the container meaning update the radio when there is an update done in the backend database, make this dynamic
                if (
                  mainContainer.childNodes.length === 0 ||
                  (mainContainer.childNodes.length === 2 && apiData.length > 2)
                ) {
                  console.log("@4");
                  mainContainer.innerHTML = "";

                  apiData.forEach((opt) => {
                    let randomString = generateRandomString(7);
                    let groupEle = document.createElement("span");
                    groupEle.setAttribute("data-gjs-type", "default");
                    groupEle.setAttribute("class", "group_radio_label");
                    Object.assign(groupEle.style, {
                      display: "flex",
                      flexWrap: "no-wrap",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      width: props.CommonWidth ? props.CommonWidth + "%" : "8%",
                    });

                    let radioInputNew = document.createElement("span");
                    radioInputNew.setAttribute("data-gjs-type", "radio_input");
                    radioInputNew.setAttribute("class", "radio_input");

                    let radioInput = document.createElement("input");
                    radioInput.setAttribute("type", "radio");
                    radioInput.setAttribute("id", `${randomString}`);
                    radioInput.setAttribute(
                      "name",
                      `radio_${mainContainer.id}`
                    );
                    radioInput.setAttribute(
                      "value",
                      `${opt[`${props.ArrOfObjKyename}`]}`
                    );
                    radioInput.setAttribute(
                      "data_db_id",
                      `${opt[`_id`]}`
                        ? `${opt[`_id`]}`
                        : `${opt[`${props.ArrOfObjKyename}`]}`
                    );

                    radioInputNew.appendChild(radioInput);

                    let label = document.createElement("label");
                    label.setAttribute("type", "radio_label");
                    label.setAttribute("for", `${randomString}`);
                    // Object.assign(label.style, {
                    //   wordBreak: "break-all",
                    // });
                    label.innerHTML = `<p id="${generateRandomString(6)}">${
                      opt[`${props.ArrOfObjKyename}`]
                    }</p>`;

                    groupEle.appendChild(label);
                    groupEle.appendChild(radioInputNew);

                    mainContainer.appendChild(groupEle);
                  });
                }

                // update only when the radio have already been plotted previously from apiData but not updating if the apiData had only 2 fields
                if (
                  apiData.length > mainContainer.childNodes.length &&
                  mainContainer.childNodes.length > 2
                ) {
                  console.log("@5");
                  // only add what's missing from api as a dynamic update

                  // get all the labels' inner content and compare it with the keyname of the apiData to be plotted and add the ones missing
                  let allLabelEles = Array.from(
                    mainContainer.getElementsByTagName("label")
                  );
                  let allLabels = allLabelEles.map(
                    (label) => label.textContent
                  );
                  console.log("allLabelEles", allLabelEles, allLabels);

                  if (allLabelEles.length > 0) {
                    // if you find a label thats not in the apiData then add it to the existing radio container
                    apiData.forEach((dbRow, idx) => {
                      let randomString = generateRandomString(7);
                      // if that object from apiData is not present in the radio container then plot it
                      if (
                        !allLabels.includes(dbRow[`${props.ArrOfObjKyename}`])
                      ) {
                        let groupEle = document.createElement("span");
                        groupEle.setAttribute("data-gjs-type", "default");
                        groupEle.setAttribute("class", "group_radio_label");
                        Object.assign(groupEle.style, {
                          display: "flex",
                          flexWrap: "no-wrap",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          width: props.CommonWidth
                            ? props.CommonWidth + "%"
                            : "8%",
                        });

                        let radioInputNew = document.createElement("span");
                        radioInputNew.setAttribute(
                          "data-gjs-type",
                          "radio_input"
                        );
                        radioInputNew.setAttribute("class", "radio_input");

                        let radioInput = document.createElement("input");
                        radioInput.setAttribute("type", "radio");
                        radioInput.setAttribute("id", `${randomString}`);
                        radioInput.setAttribute(
                          "name",
                          `radio_${mainContainer.id}`
                        );
                        radioInput.setAttribute(
                          "value",
                          `${dbRow[`${props.ArrOfObjKyename}`]}`
                        );
                        radioInput.setAttribute(
                          "data_db_id",
                          `${dbRow[`_id`]}`
                            ? `${dbRow[`_id`]}`
                            : `${dbRow[`${props.ArrOfObjKyename}`]}`
                        );

                        radioInputNew.appendChild(radioInput);

                        let label = document.createElement("label");
                        // label.setAttribute('type', 'radio_label');
                        label.setAttribute("for", `${randomString}`);
                        // Object.assign(label.style, {
                        //   wordBreak: "break-all",
                        // });
                        label.innerHTML = `<p id="${generateRandomString(6)}">${
                          dbRow[`${props.ArrOfObjKyename}`]
                        }</p>`;

                        groupEle.appendChild(radioInputNew);

                        groupEle.appendChild(label);

                        mainContainer.appendChild(groupEle);
                      }
                    });
                  }
                }

                // plot when the apiData has only around 2 entries
                // else if (apiData.length <= 2) {
                //   console.log('@6');
                //   // see if the radio are the default radio by checking if they have this attribute 'data_db_id', if yes then clear the body and append new else append new checkboxes anyways
                //   let isNotDefaultRadio = mainContainer
                //     .getElementsByTagName("input")[0]
                //     .getAttribute("data_db_id");

                //   // if it is a default radio then empty the body before appending apiData radio
                //   if (!isNotDefaultRadio) {
                //     mainContainer.innerHTML = "";
                //     apiData.forEach((opt) => {
                //       let randomString = generateRandomString(7);
                //       let groupEle = document.createElement("span");
                //       groupEle.setAttribute("data-gjs-type", "default");
                //       groupEle.setAttribute("class", "group_radio_label");
                //       Object.assign(groupEle.style, {
                //         display: "flex",
                //         flexWrap: "no-wrap",
                //         justifyContent: "flex-start",
                //         alignItems: "flex-start",
                //         width: props.CommonWidth
                //           ? props.CommonWidth + "%"
                //           : "8%",
                //       });

                //       let radioInputNew = document.createElement("span");
                //       radioInputNew.setAttribute(
                //         "data-gjs-type",
                //         "radio_input"
                //       );
                //       radioInputNew.setAttribute("class", "cradio_input");

                //       let radioInput = document.createElement("input");
                //       radioInput.setAttribute("type", "radio");
                //       radioInput.setAttribute("id", `${randomString}`);
                //       radioInput.setAttribute(
                //         "name",
                //         `radio_${mainContainer.id}`
                //       );
                //       radioInput.setAttribute(
                //         "value",
                //         `${opt[`${props.ArrOfObjKyename}`]}`
                //       );
                //       radioInput.setAttribute(
                //         "data_db_id",
                //         `${opt[`_id`]}`
                //           ? `${opt[`_id`]}`
                //           : `${opt[`${props.ArrOfObjKyename}`]}`
                //       );

                //       radioInputNew.appendChild(radioInput);

                //       let label = document.createElement("label");
                //       label.setAttribute("type", "radio_label");
                //       label.setAttribute("for", `${randomString}`);
                //       // Object.assign(label.style, {
                //       //   wordBreak: "break-all",
                //       // });
                //       label.innerHTML = `<p id="${generateRandomString(6)}">${
                //         opt[`${props.ArrOfObjKyename}`]
                //       }</p>`;

                //       groupEle.appendChild(radioInputNew);
                //       groupEle.appendChild(label);

                //       mainContainer.appendChild(groupEle);
                //     });
                //   } else {
                //     mainContainer.innerHTML = "";

                //     apiData.forEach((opt) => {
                //       let randomString = generateRandomString(7);
                //       let groupEle = document.createElement("span");
                //       groupEle.setAttribute("data-gjs-type", "default");
                //       groupEle.setAttribute("class", "group_radio_label");
                //       Object.assign(groupEle.style, {
                //         display: "flex",
                //         flexWrap: "no-wrap",
                //         justifyContent: "flex-start",
                //         alignItems: "flex-start",
                //         width: props.CommonWidth
                //           ? props.CommonWidth + "%"
                //           : "8%",
                //       });

                //       let radioInputNew = document.createElement("span");
                //       radioInputNew.setAttribute(
                //         "data-gjs-type",
                //         "radio_input"
                //       );
                //       radioInputNew.setAttribute("class", "radio_input");

                //       let radioInput = document.createElement("input");
                //       radioInput.setAttribute("type", "radio");
                //       radioInput.setAttribute("id", `${randomString}`);
                //       radioInput.setAttribute(
                //         "name",
                //         `radio_${mainContainer.id}`
                //       );
                //       radioInput.setAttribute(
                //         "value",
                //         `${opt[`${props.ArrOfObjKyename}`]}`
                //       );
                //       radioInput.setAttribute(
                //         "data_db_id",
                //         `${opt[`_id`]}`
                //           ? `${opt[`_id`]}`
                //           : `${opt[`${props.ArrOfObjKyename}`]}`
                //       );

                //       radioInputNew.appendChild(radioInput);

                //       let label = document.createElement("label");
                //       label.setAttribute("type", "radio_label");
                //       label.setAttribute("for", `${randomString}`);
                //       // Object.assign(label.style, {
                //       //   wordBreak: "break-all",
                //       // });
                //       label.innerHTML = `<p id="${generateRandomString(6)}">${
                //         opt[`${props.ArrOfObjKyename}`]
                //       }</p>`;

                //       groupEle.appendChild(label);
                //       groupEle.appendChild(radioInputNew);

                //       mainContainer.appendChild(groupEle);
                //     });
                //   }
                // }

                // dynamic delete
                if (mainContainer.childNodes.length > apiData.length) {
                  console.log("@7");
                  console.log("removing extra group_radio_labels");

                  let groupRadioLabels =
                    mainContainer.getElementsByClassName("group_radio_label");
                  Array.from(groupRadioLabels).forEach((groupRadioLabel) => {
                    let radio = groupRadioLabel
                      .getElementsByClassName("radio_input")[0]
                      .getElementsByTagName("input")[0];
                    let radioDataDbId = radio.getAttribute("data_db_id");

                    // see if radioDataDbId is in apiData _ids and if not there, delete this group_radio_label
                    let apiData_id = apiData.map((obj) => obj["_id"]);

                    if (!apiData_id.includes(radioDataDbId)) {
                      groupRadioLabel.remove();
                      console.log("removed");
                    }
                  });
                }
              }
            }

            // if API response is a plain array of single elements
            else if (Array.isArray(apiData) && !isArrayofObjects(apiData)) {
              console.log("###");

              // either no radio are plotted or the default 2 radio are there
              if (
                mainContainer.childNodes.length === 0 ||
                mainContainer.childNodes.length <= 2
              ) {
                mainContainer.innerHTML = "";

                apiData.forEach((opt) => {
                  let randomString = generateRandomString(7);
                  let groupEle = document.createElement("span");
                  groupEle.setAttribute("data-gjs-type", "default");
                  groupEle.setAttribute("class", "group_radio_label");
                  Object.assign(groupEle.style, {
                    display: "flex",
                    flexWrap: "no-wrap",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    width: props.CommonWidth ? props.CommonWidth + "%" : "8%",
                  });

                  let radioInputNew = document.createElement("span");
                  radioInputNew.setAttribute("data-gjs-type", "radio_input");
                  radioInputNew.setAttribute("class", "radio_input");

                  let radioInput = document.createElement("input");
                  radioInput.setAttribute("type", "radio");
                  radioInput.setAttribute("id", `${randomString}`);
                  radioInput.setAttribute("name", `radio_${mainContainer.id}`);
                  radioInput.setAttribute("value", `${opt}`);

                  radioInputNew.appendChild(radioInput);

                  let label = document.createElement("label");
                  label.setAttribute("type", "radio_label");
                  label.setAttribute("for", `${randomString}`);
                  // Object.assign(label.style, {
                  //   wordBreak: "break-all",
                  // });
                  label.innerHTML = `<p id="${generateRandomString(
                    6
                  )}">${opt}</p>`;

                  groupEle.appendChild(radioInputNew);
                  groupEle.appendChild(label);

                  mainContainer.appendChild(groupEle);
                });
              }

              // else if the apiData radio are already plotted then check for updated values and add those here without changing the IDd of already plotted ones
              else if (
                apiData.length > mainContainer.childNodes.length &&
                mainContainer.childNodes.length > 2
              ) {
                // only add what's missing from api as a dynamic update

                // get all the labels' inner content and compare it with the keyname of the apiData to be plotted and add the ones missing
                let allLabelEles = Array.from(
                  mainContainer.getElementsByTagName("label")
                );
                let allLabels = allLabelEles.map((label) => label.textContent);
                console.log("allLabelEles", allLabelEles, allLabels);

                if (allLabelEles.length > 0) {
                  // if you find a label thats not in the apiData then add it to the existing radio container
                  apiData.forEach((opt, idx) => {
                    let randomString = generateRandomString(7);
                    // if that object from apiData is not present in the radio container then plot it
                    if (!allLabels.includes(opt)) {
                      let groupEle = document.createElement("span");
                      groupEle.setAttribute("data-gjs-type", "default");
                      groupEle.setAttribute("class", "group_radio_label");
                      Object.assign(groupEle.style, {
                        display: "flex",
                        flexWrap: "no-wrap",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        width: props.CommonWidth
                          ? props.CommonWidth + "%"
                          : "8%",
                      });

                      let radioInputNew = document.createElement("span");
                      radioInputNew.setAttribute(
                        "data-gjs-type",
                        "radio_input"
                      );
                      radioInputNew.setAttribute("class", "radio_input");

                      let radioInput = document.createElement("input");
                      radioInput.setAttribute("type", "radio");
                      radioInput.setAttribute("id", `${randomString}`);
                      radioInput.setAttribute(
                        "name",
                        `radio_${mainContainer.id}`
                      );
                      radioInput.setAttribute("value", `${opt}`);

                      radioInputNew.appendChild(radioInput);

                      let label = document.createElement("label");
                      label.setAttribute("type", "radio_label");
                      label.setAttribute("for", `${randomString}`);
                      // Object.assign(label.style, {
                      //   wordBreak: "break-all",
                      // });
                      label.innerHTML = `<p id="${generateRandomString(
                        6
                      )}">${opt}</p>`;

                      groupEle.appendChild(radioInputNew);
                      groupEle.appendChild(label);

                      mainContainer.appendChild(groupEle);
                    }
                  });
                }
              }
            }

            // if API response is an object
            else if (
              !isArrayofObjects(apiData) &&
              typeof apiData === "object"
            ) {
              // if API response to plot is a nested array-of-objects inside the main response object
              if (props.NestedKeyname && props.ArrOfObjKyename) {
                console.log("####");
                // container.components("");

                // find the array-of-objects value
                let data = findKeyValue(apiData, props.NestedKeyname);

                if (isArrayofObjects(data)) {
                  // to check if any '_id' data was changed in the backend object, then update the frontend labels of radio also
                  if (mainContainer.innerHTML !== "") {
                    // check if these are database plotted radio or not
                    let isNotDefaultRadio = mainContainer
                      .getElementsByClassName("group_radio_label")[0]
                      .getElementsByClassName("radio_input")[0]
                      .getElementsByTagName("input")[0]
                      .getAttribute("data_db_id");
                    console.log("isNotDefaultRadio", isNotDefaultRadio);

                    // if they are database plotted radio then scan through them using data_db_id and update if any
                    if (isNotDefaultRadio) {
                      let allMiniContainers =
                        mainContainer.getElementsByClassName(
                          "group_radio_label"
                        );
                      Array.from(allMiniContainers).forEach(
                        (groupRadioLabel, idx) => {
                          let radio = groupRadioLabel
                            .getElementsByClassName("radio_input")[0]
                            .getElementsByTagName("input")[0];
                          let radio_dataDbId = groupRadioLabel
                            .getElementsByClassName("radio_input")[0]
                            .getElementsByTagName("input")[0]
                            .getAttribute("data_db_id");
                          let label =
                            groupRadioLabel.getElementsByTagName("label")[0];

                          // get the object from apiData that has the radio
                          let currentObj = data.filter(
                            (obj) => obj["_id"] === radio_dataDbId
                          );

                          if (currentObj.length > 0) {
                            currentObj.forEach((obj) => {
                              let labelInnerText =
                                label.getElementsByTagName("p")[0].innerHTML;
                              console.log("labelInnerText", labelInnerText);

                              // check if the IDs match, if not then update the label's inner text
                              if (
                                labelInnerText !==
                                obj[`${props.ArrOfObjKyename}`]
                              ) {
                                label.getElementsByTagName("p")[0].innerHTML =
                                  obj[`${props.ArrOfObjKyename}`];
                                radio.setAttribute(
                                  "value",
                                  obj[`${props.ArrOfObjKyename}`]
                                );

                                console.log("currentObj", currentObj);
                              }
                            });
                          }
                        }
                      );
                    }
                  }

                  // reasons -
                  // container.components().length === 0 : plot radio if there are no radio present in the container
                  // container.components().length === 2 : plot radio the first time when there are the 2 initial radio
                  // apiData.length > container.components().length : plot radio if apiData has more objects than radio in the container meaning update the radio when there is an update done in the backend database, make this dynamic
                  if (
                    mainContainer.childNodes.length === 0 ||
                    (mainContainer.childNodes.length === 2 && data.length > 2)
                  ) {
                    mainContainer.innerHTML = "";

                    data.forEach((opt) => {
                      let randomString = generateRandomString(7);
                      let groupEle = document.createElement("span");
                      groupEle.setAttribute("data-gjs-type", "default");
                      groupEle.setAttribute("class", "group_radio_label");
                      Object.assign(groupEle.style, {
                        display: "flex",
                        flexWrap: "no-wrap",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        width: props.CommonWidth
                          ? props.CommonWidth + "%"
                          : "8%",
                      });

                      let radioInputNew = document.createElement("span");
                      radioInputNew.setAttribute(
                        "data-gjs-type",
                        "radio_input"
                      );
                      radioInputNew.setAttribute("class", "radio_input");

                      let radioInput = document.createElement("input");
                      radioInput.setAttribute("type", "radio");
                      radioInput.setAttribute("id", `${randomString}`);
                      radioInput.setAttribute(
                        "name",
                        `radio_${mainContainer.id}`
                      );
                      radioInput.setAttribute(
                        "value",
                        `${opt[`${props.ArrOfObjKyename}`]}`
                      );
                      radioInput.setAttribute(
                        "data_db_id",
                        `${opt[`_id`]}`
                          ? `${opt[`_id`]}`
                          : `${opt[`${props.ArrOfObjKyename}`]}`
                      );

                      radioInputNew.appendChild(radioInput);

                      let label = document.createElement("label");
                      label.setAttribute("type", "radio_label");
                      label.setAttribute("for", `${randomString}`);
                      // Object.assign(label.style, {
                      //   wordBreak: "break-all",
                      // });
                      label.innerHTML = `<p id="${generateRandomString(6)}">${
                        opt[`${props.ArrOfObjKyename}`]
                      }</p>`;

                      groupEle.appendChild(radioInputNew);
                      groupEle.appendChild(label);

                      mainContainer.appendChild(groupEle);
                    });
                  }

                  // update only when the radio have already been plotted previously from apiData but not updating if the apiData had only 2 fields
                  if (
                    data.length > mainContainer.childNodes.length &&
                    mainContainer.childNodes.length > 2
                  ) {
                    // only add what's missing from api as a dynamic update

                    // get all the labels' inner content and compare it with the keyname of the apiData to be plotted and add the ones missing
                    let allLabelEles = Array.from(
                      mainContainer.getElementsByTagName("label")
                    );
                    let allLabels = allLabelEles.map(
                      (label) => label.textContent
                    );
                    console.log("allLabelEles", allLabelEles, allLabels);

                    if (allLabelEles.length > 0) {
                      // if you find a label thats not in the apiData then add it to the existing radio container
                      data.forEach((dbRow, idx) => {
                        let randomString = generateRandomString(7);
                        // if that object from apiData is not present in the radio container then plot it
                        if (
                          !allLabels.includes(dbRow[`${props.ArrOfObjKyename}`])
                        ) {
                          let groupEle = document.createElement("span");
                          groupEle.setAttribute("data-gjs-type", "default");
                          groupEle.setAttribute("class", "group_radio_label");
                          Object.assign(groupEle.style, {
                            display: "flex",
                            flexWrap: "no-wrap",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            width: props.CommonWidth
                              ? props.CommonWidth + "%"
                              : "8%",
                          });

                          let radioInputNew = document.createElement("span");
                          radioInputNew.setAttribute(
                            "data-gjs-type",
                            "radio_input"
                          );
                          radioInputNew.setAttribute("class", "radio_input");

                          let radioInput = document.createElement("input");
                          radioInput.setAttribute("type", "radio");
                          radioInput.setAttribute("id", `${randomString}`);
                          radioInput.setAttribute(
                            "name",
                            `radio_${mainContainer.id}`
                          );
                          radioInput.setAttribute(
                            "value",
                            `${dbRow[`${props.ArrOfObjKyename}`]}`
                          );
                          radioInput.setAttribute(
                            "data_db_id",
                            `${dbRow[`_id`]}`
                              ? `${dbRow[`_id`]}`
                              : `${dbRow[`${props.ArrOfObjKyename}`]}`
                          );

                          radioInputNew.appendChild(radioInput);

                          let label = document.createElement("label");
                          label.setAttribute("type", "radio_label");
                          label.setAttribute("for", `${randomString}`);
                          // Object.assign(label.style, {
                          //   wordBreak: "break-all",
                          // });
                          label.innerHTML = `<p id="${generateRandomString(
                            6
                          )}">${dbRow[`${props.ArrOfObjKyename}`]}</p>`;

                          groupEle.appendChild(radioInputNew);
                          groupEle.appendChild(label);

                          mainContainer.appendChild(groupEle);
                        }
                      });
                    }
                  }

                  // plot when the apiData has only around 2 entries
                  else if (data.length <= 2) {
                    // see if the radioes are the default radioes by checking if they have this attribute 'data_db_id', if yes then clear the body and append new else append new radioes anyways
                    let isNotDefaultradio = mainContainer
                      .getElementsByTagName("input")[0]
                      .getAttribute("data_db_id");

                    // if it is a default radio then empty the body before appending apiData radioes
                    if (!isNotDefaultradio) {
                      mainContainer.innerHTML = "";
                      data.forEach((opt) => {
                        let randomString = generateRandomString(7);
                        let groupEle = document.createElement("span");
                        groupEle.setAttribute("data-gjs-type", "default");
                        groupEle.setAttribute("class", "group_radio_label");
                        Object.assign(groupEle.style, {
                          display: "flex",
                          flexWrap: "no-wrap",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          width: props.CommonWidth
                            ? props.CommonWidth + "%"
                            : "8%",
                        });

                        let radioInputNew = document.createElement("span");
                        radioInputNew.setAttribute(
                          "data-gjs-type",
                          "radio_input"
                        );
                        radioInputNew.setAttribute("class", "radio_input");

                        let radioInput = document.createElement("input");
                        radioInput.setAttribute("type", "radio");
                        radioInput.setAttribute("id", `${randomString}`);
                        radioInput.setAttribute(
                          "name",
                          `radio_${mainContainer.id}`
                        );
                        radioInput.setAttribute(
                          "value",
                          `${opt[`${props.ArrOfObjKyename}`]}`
                        );
                        radioInput.setAttribute(
                          "data_db_id",
                          `${opt[`_id`]}`
                            ? `${opt[`_id`]}`
                            : `${opt[`${props.ArrOfObjKyename}`]}`
                        );

                        radioInputNew.appendChild(radioInput);

                        let label = document.createElement("label");
                        label.setAttribute("type", "radio_label");
                        label.setAttribute("for", `${randomString}`);
                        // Object.assign(label.style, {
                        //   wordBreak: "break-all",
                        // });
                        label.innerHTML = `<p id="${generateRandomString(6)}">${
                          opt[`${props.ArrOfObjKyename}`]
                        }</p>`;

                        groupEle.appendChild(radioInputNew);
                        groupEle.appendChild(label);

                        mainContainer.appendChild(groupEle);
                      });
                    }
                  }

                  // dynamic delete
                  if (mainContainer.childNodes.length > data.length) {
                    console.log("removing extra group_radio_labels");

                    let groupradioLabels =
                      mainContainer.getElementsByClassName("group_radio_label");
                    Array.from(groupradioLabels).forEach((groupradioLabel) => {
                      let radio = groupradioLabel
                        .getElementsByClassName("radio_input")[0]
                        .getElementsByTagName("input")[0];
                      let radioDataDbId = radio.getAttribute("data_db_id");

                      // see if radioDataDbId is in apiData _ids and if not there, delete this group_radio_label
                      let apiData_id = data.map((obj) => obj["_id"]);

                      if (!apiData_id.includes(radioDataDbId)) {
                        groupradioLabel.remove();
                        console.log("removed");
                      }
                    });
                  }
                }
              } else if (props.NestedKeyname && !props.ArrOfObjKyename) {
                // container.components("");

                // find the array value
                let data = findKeyValue(apiData, props.NestedKeyname);

                // if API response to plot is a nested plain array of single elements inside the main response object
                if (Array.isArray(apiData) && !isArrayofObjects(apiData)) {
                  console.log("###");

                  // either no radioes are plotted or the default 2 radioes are there
                  if (
                    mainContainer.childNodes.length === 0 ||
                    mainContainer.childNodes.length <= 2
                  ) {
                    mainContainer.innerHTML = "";

                    data.forEach((opt) => {
                      let randomString = generateRandomString(7);
                      let groupEle = document.createElement("span");
                      groupEle.setAttribute("data-gjs-type", "default");
                      groupEle.setAttribute("class", "group_radio_label");
                      Object.assign(groupEle.style, {
                        display: "flex",
                        flexWrap: "no-wrap",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        width: props.CommonWidth
                          ? props.CommonWidth + "%"
                          : "8%",
                      });

                      let radioInputNew = document.createElement("span");
                      radioInputNew.setAttribute(
                        "data-gjs-type",
                        "radio_input"
                      );
                      radioInputNew.setAttribute("class", "radio_input");

                      let radioInput = document.createElement("input");
                      radioInput.setAttribute("type", "radio");
                      radioInput.setAttribute("id", `${randomString}`);
                      radioInput.setAttribute(
                        "name",
                        `radio_${mainContainer.id}`
                      );
                      radioInput.setAttribute("value", `${opt}`);

                      radioInputNew.appendChild(radioInput);

                      let label = document.createElement("label");
                      label.setAttribute("type", "radio_label");
                      label.setAttribute("for", `${randomString}`);
                      // Object.assign(label.style, {
                      //   wordBreak: "break-all",
                      // });
                      label.innerHTML = `<p id="${generateRandomString(
                        6
                      )}">${opt}</p>`;

                      groupEle.appendChild(radioInputNew);
                      groupEle.appendChild(label);

                      mainContainer.appendChild(groupEle);
                    });
                  }

                  // else if the apiData radioes are already plotted then check for updated values and add those here without changing the IDd of already plotted ones
                  else if (
                    data.length > mainContainer.childNodes.length &&
                    mainContainer.childNodes.length > 2
                  ) {
                    // only add what's missing from api as a dynamic update

                    // get all the labels' inner content and compare it with the keyname of the apiData to be plotted and add the ones missing
                    let allLabelEles = Array.from(
                      mainContainer.getElementsByTagName("label")
                    );
                    let allLabels = allLabelEles.map(
                      (label) => label.textContent
                    );
                    console.log("allLabelEles", allLabelEles, allLabels);

                    if (allLabelEles.length > 0) {
                      // if you find a label thats not in the apiData then add it to the existing radio container
                      data.forEach((opt, idx) => {
                        let randomString = generateRandomString(7);
                        // if that object from apiData is not present in the radio container then plot it
                        if (!allLabels.includes(opt)) {
                          let groupEle = document.createElement("span");
                          groupEle.setAttribute("data-gjs-type", "default");
                          groupEle.setAttribute("class", "group_radio_label");
                          Object.assign(groupEle.style, {
                            display: "flex",
                            flexWrap: "no-wrap",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            width: props.CommonWidth
                              ? props.CommonWidth + "%"
                              : "8%",
                          });

                          let radioInputNew = document.createElement("span");
                          radioInputNew.setAttribute(
                            "data-gjs-type",
                            "radio_input"
                          );
                          radioInputNew.setAttribute("class", "radio_input");

                          let radioInput = document.createElement("input");
                          radioInput.setAttribute("type", "radio");
                          radioInput.setAttribute("id", `${randomString}`);
                          radioInput.setAttribute(
                            "name",
                            `radio_${mainContainer.id}`
                          );
                          radioInput.setAttribute("value", `${opt}`);

                          radioInputNew.appendChild(radioInput);

                          let label = document.createElement("label");
                          label.setAttribute("type", "radio_label");
                          label.setAttribute("for", `${randomString}`);
                          // Object.assign(label.style, {
                          //   wordBreak: "break-all",
                          // });
                          label.innerHTML = `<p id="${generateRandomString(
                            6
                          )}">${opt}</p>`;

                          groupEle.appendChild(radioInputNew);
                          groupEle.appendChild(label);

                          mainContainer.appendChild(groupEle);
                        }
                      });
                    }
                  }
                }

                // if API response to plot are all key:value pairs of a plain object inside main object
                else if (
                  !Array.isArray(data) &&
                  !isArrayofObjects(data) &&
                  typeof data === "object"
                ) {
                  console.log("######");
                  Object.keys(data).forEach((key) => {
                    if (
                      !Array.isArray(data[`${key}`]) &&
                      typeof data[`${key}`] !== "object"
                    ) {
                      let randomString = generateRandomString(7);

                      let groupEle = document.createElement("span");
                      groupEle.setAttribute("data-gjs-type", "default");
                      groupEle.setAttribute("class", "group_radio_label");
                      Object.assign(groupEle.style, {
                        display: "flex",
                        flexWrap: "no-wrap",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        width: props.CommonWidth
                          ? props.CommonWidth + "%"
                          : "8%",
                      });

                      let radioInputNew = document.createElement("span");
                      radioInputNew.setAttribute(
                        "data-gjs-type",
                        "radio_input"
                      );
                      radioInputNew.setAttribute("class", "radio_input");

                      let radioInput = document.createElement("input");
                      radioInput.setAttribute("type", "radio");
                      radioInput.setAttribute("id", `${randomString}`);
                      radioInput.setAttribute("name", `${randomString}`);
                      radioInput.setAttribute("value", `${data[`${key}`]}`);

                      radioInputNew.appendChild(radioInput);

                      let label = document.createElement("label");
                      label.setAttribute("type", "radio_label");
                      label.setAttribute("for", `${randomString}`);
                      // Object.assign(label.style, {
                      //   wordBreak: "break-all",
                      // });
                      label.innerHTML = `<p id="${generateRandomString(
                        6
                      )}">${key}</p>`;

                      groupEle.appendChild(radioInputNew);
                      groupEle.appendChild(label);

                      mainContainer.appendChild(groupEle);
                    }
                  });
                }
              }

              // if API response to plot are all key:value pairs of the plain object
              else if (!props.NestedKeyname && !props.ArrOfObjKyename) {
                console.log("#######");
                mainContainer.innerHTML = "";

                Object.keys(apiData).forEach((key) => {
                  let randomString = generateRandomString(7);

                  if (
                    !Array.isArray(apiData[`${key}`]) &&
                    typeof apiData[`${key}`] !== "object"
                  ) {
                    let groupEle = document.createElement("span");
                    groupEle.setAttribute("data-gjs-type", "default");
                    groupEle.setAttribute("class", "group_radio_label");
                    Object.assign(groupEle.style, {
                      display: "flex",
                      flexWrap: "no-wrap",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      width: props.CommonWidth ? props.CommonWidth + "%" : "8%",
                    });

                    let radioInputNew = document.createElement("span");
                    radioInputNew.setAttribute("data-gjs-type", "radio_input");
                    radioInputNew.setAttribute("class", "radio_input");

                    let radioInput = document.createElement("input");
                    radioInput.setAttribute("type", "radio");
                    radioInput.setAttribute("id", `${randomString}`);
                    radioInput.setAttribute(
                      "name",
                      `radio_${mainContainer.id}`
                    );
                    radioInput.setAttribute("value", `${apiData[`${key}`]}`);

                    radioInputNew.appendChild(radioInput);

                    let label = document.createElement("label");
                    label.setAttribute("type", "radio_label");
                    label.setAttribute("for", `${randomString}`);
                    // Object.assign(label.style, {
                    //   wordBreak: "break-all",
                    // });
                    label.innerHTML = `<p id="${generateRandomString(
                      6
                    )}">${key}</p>`;

                    groupEle.appendChild(radioInputNew);
                    groupEle.appendChild(label);

                    mainContainer.appendChild(groupEle);
                  }
                });
              }

              // if there is a 'message' in api response instead of data
              else if (Object.keys(apiData).includes("message")) {
                console.log("#@@");

                mainContainer.innerHTML = "";
                let randomString = generateRandomString(7);
                let groupEle = document.createElement("span");
                groupEle.setAttribute("data-gjs-type", "default");
                groupEle.setAttribute("class", "group_radio_label");
                Object.assign(groupEle.style, {
                  display: "flex",
                  flexWrap: "no-wrap",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  width: props.CommonWidth ? props.CommonWidth + "%" : "8%",
                });

                let radioInputNew = document.createElement("span");
                radioInputNew.setAttribute("data-gjs-type", "radio_input");
                radioInputNew.setAttribute("class", "radio_input");

                let radioInput = document.createElement("input");
                radioInput.setAttribute("type", "radio");
                radioInput.setAttribute("id", `${randomString}`);
                radioInput.setAttribute("name", `radio_${mainContainer.id}`);
                radioInput.style.display = "none";

                radioInputNew.appendChild(radioInput);

                let label = document.createElement("label");
                label.setAttribute("type", "radio_label");
                label.setAttribute("for", `${randomString}`);
                // Object.assign(label.style, {
                //   wordBreak: "break-all",
                // });
                label.innerHTML = `<p id="${generateRandomString(
                  6
                )}">No Values.</p>`;

                groupEle.appendChild(radioInputNew);
                groupEle.appendChild(label);

                mainContainer.appendChild(groupEle);
              }
            }

            replicateStyle();
          } else {
            console.log(
              '"/editor/" & "?projectId=" substrings are present together in the browser URL.'
            );
          }
        }

        // helper function to apply styling
        function applyStyle(element, style) {
          if (!element) {
            console.error("Element is undefined:", element);
            return;
          }

          for (let key in style) {
            if (style.hasOwnProperty(key)) {
              element.style[key] = style[key];
            }
          }
        }

        // for style replication of first radio to the rest
        function replicateStyle() {
          if (props.ReplicateStyling) {
            // Get the first radio component
            let firstGroup = mainContainer.querySelector(".group_radio_label");

            if (firstGroup) {
              let firstGroupStyle = window.getComputedStyle(firstGroup);

              // Apply styling to all other group_radio_label components
              let groups = mainContainer.querySelectorAll(".group_radio_label");
              groups.forEach((group) => {
                if (group !== firstGroup) {
                  // Apply the style of the first group to each group
                  applyStyle(group, firstGroupStyle);

                  // Apply the style to the children of each group
                  let firstGroupChildren = firstGroup.querySelectorAll("*");
                  let groupChildren = group.querySelectorAll("*");

                  if (firstGroupChildren.length === groupChildren.length) {
                    for (let i = 0; i < firstGroupChildren.length; i++) {
                      // Apply styles to individual children
                      let firstChildStyle = window.getComputedStyle(
                        firstGroupChildren[i]
                      );
                      applyStyle(groupChildren[i], firstChildStyle);
                    }
                  } else {
                    console.error(
                      "Number of children elements is different between groups."
                    );
                  }
                }
              });
            } else {
              console.error("First group not found.");
            }
          }
        }

        replicateStyle();
      };

      editor.DomComponents.addType("radio_regular_form", {
        model: {
          defaults: {
            tagName: "span",
            // script: radioGroupScript,
            type: "radio_regular_form",
            script: radioRegularFormScript,
            attributes: {
              // id: "radio_regular_form",
              class: "radio_regular_form",
              value: "",
            },

            style: {
              display: "flex",
              "flex-wrap": "wrap",
              "align-items": "center",
              "justify-content": "flex-start",
              gap: "1%",
            },

            "style-default": {
              display: "flex",
              "flex-wrap": "wrap",
              "align-items": "center",
              "justify-content": "flex-start",
              gap: "1%",
            },

            components: [
              {
                tagName: "span",
                type: "default",
                attributes: {
                  class: "group_radio_label",
                },

                "style-default": {
                  display: "flex",
                  "flex-wrap": "no-wrap",
                  "justify-content": "flex-start",
                  "align-items": "flex-start",
                },

                style: {
                  display: "flex",
                  "flex-wrap": "no-wrap",
                  "justify-content": "flex-start",
                  "align-items": "flex-start",
                },

                components: [
                  {
                    type: "radio_input",
                  },
                  {
                    type: "radio_label",
                  },
                ],
              },
              {
                tagName: "span",
                type: "default",
                attributes: {
                  class: "group_radio_label",
                },

                "style-default": {
                  display: "flex",
                  "flex-wrap": "no-wrap",
                  "justify-content": "flex-start",
                  "align-items": "flex-start",
                },

                style: {
                  display: "flex",
                  "flex-wrap": "no-wrap",
                  "justify-content": "flex-start",
                  "align-items": "flex-start",
                },

                components: [
                  {
                    type: "radio_input",
                  },
                  {
                    type: "radio_label",
                  },
                ],
              },
            ],

            // traits
            CustomUrl: "",
            BaseUrl: "",
            APIPath: "",
            BearerToken: "",
            Username: "",
            Password: "",
            MoreHeaders: "",
            APIMethod: "GET",
            APIBody: "",
            ArrOfObjKyename: "",
            NestedKeyname: "",
            options: {
              baseUrl1,
              baseUrl2,
              baseUrl3,
              baseUrl4,
              baseUrl5,
              baseUrl1BearerToken,
              baseUrl2BearerToken,
              baseUrl3BearerToken,
              baseUrl4BearerToken,
              baseUrl5BearerToken,
            },

            // to give width to all the divs at once
            CommonWidth: "8",

            ReplicateStyling: "",

            projectId: localStorage.getItem("project_id")
              ? localStorage.getItem("project_id")
              : "",

            traits: [
              "id",
              {
                type: "text",
                name: "CustomUrl",
                label: "Custom URL",
                changeProp: true,
              },
              {
                type: "select",
                name: "BaseUrl",
                label: "Base URL",
                options: [
                  { id: "baseUrl1", name: "Base URL #1" },
                  { id: "baseUrl2", name: "Base URL #2" },
                  { id: "baseUrl3", name: "Base URL #3" },
                  { id: "baseUrl4", name: "Base URL #4" },
                  { id: "baseUrl5", name: "Base URL #5" },
                  { id: "null", name: "No Base URL" },
                ],
                changeProp: true,
              },
              {
                type: "text",
                name: "APIPath",
                label: "API Path",
                placeholder: "Don't start with '/'",
                changeProp: true,
              },
              {
                type: "text",
                name: "BearerToken",
                label: "Bearer Token",
                placeholder: "No bearer token provided",
                changeProp: true,
              },
              {
                type: "text",
                name: "Username",
                label: "Username",
                changeProp: true,
              },
              {
                type: "text",
                name: "Password",
                label: "Password",
                changeProp: true,
              },
              {
                type: "text",
                name: "MoreHeaders",
                label: "More Headers",
                placeholder: "k1:v1,k2:v2,k3:v3,...",
                changeProp: true,
              },
              {
                type: "select",
                name: "APIMethod",
                label: "API Method",
                options: [
                  { id: "GET", name: "Get" },
                  { id: "POST", name: "Post" },
                ],
                // value: "GET",
                changeProp: true,
              },
              {
                type: "text",
                name: "APIBody",
                label: "API Body",
                placeholder: "Json format",
                changeProp: true,
              },
              {
                type: "text",
                name: "ArrOfObjKyename",
                label: "Keyname From Array Of Object",
                placeholder: "[ {k1:v1}, {k1:v2} ]",
                changeProp: true,
              },
              {
                type: "text",
                name: "NestedKeyname",
                label: "Keyname For Nested Structure",
                placeholder: "{ k1: [{...}, {...}] }",
                changeProp: true,
              },
              {
                type: "number",
                name: "CommonWidth",
                label: "Common Width",
                placeholder: "Unit %",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "ReplicateStyling",
                label: "Replicate Styling",
                changeProp: true,
              },
            ],

            changeProp: true,
            "script-props": [
              "CustomUrl",
              "BaseUrl",
              "APIPath",
              "BearerToken",
              "Username",
              "Password",
              "MoreHeaders",
              "ArrOfObjKyename",
              "NestedKeyname",
              "options",
              "CommonWidth",
              "ReplicateStyling",
              "projectId",
            ],
          },

          init() {
            this.listenTo(this, "change:CustomUrl", this.handlePropChange);
            this.listenTo(this, "change:BaseUrl", this.handlePropChange);
            this.listenTo(this, "change:APIPath", this.handlePropChange);
            this.listenTo(this, "change:BearerToken", this.handlePropChange);
            this.listenTo(this, "change:Username", this.handlePropChange);
            this.listenTo(this, "change:Password", this.handlePropChange);
            this.listenTo(this, "change:MoreHeaders", this.handlePropChange);
            this.listenTo(this, "change:APIMethod", this.handlePropChange);
            this.listenTo(this, "change:APIBody", this.handlePropChange);
            this.listenTo(
              this,
              "change:ArrOfObjKyename",
              this.handlePropChange
            );
            this.listenTo(this, "change:NestedKeyname", this.handlePropChange);
            this.listenTo(this, "change:CommonWidth", this.commonWidthChange);
          },

          updated(property, value, prevValue) {
            console.log(
              "+++ property",
              property,
              "value",
              value,
              "prevValue",
              prevValue
            );
            console.log("this from updated()", this.getEl());

            // for editor part, it will not be in download for which script is written for style replication
            this.replicateStyling();
          },

          // only needed during development
          commonWidthChange() {
            const { CommonWidth } = this.props();

            const mainContainer = this;
            const groupRadioLabels = mainContainer.find(".group_radio_label");

            if (groupRadioLabels.length > 0) {
              groupRadioLabels.forEach((groupRadioLabel) => {
                groupRadioLabel.setStyle({
                  display: "flex",
                  "flex-wrap": "no-wrap",
                  "justify-content": "flex-start",
                  "align-items": "flex-start",
                  width: CommonWidth ? CommonWidth + "%" : "8% !important",
                });
              });
            }
          },

          // needed both in development and after download
          replicateStyling() {
            console.log("replicating style");
            const { ReplicateStyling } = this.props();
            const mainContainer = this;

            if (ReplicateStyling) {
              // Get the first group_radio_label component
              let firstGroup = mainContainer.find(".group_radio_label")[0];

              if (firstGroup) {
                let firstGroupStyle = firstGroup.getStyle();

                // Apply styling to all other group_checkbox_label components
                let groups = mainContainer.find(".group_radio_label");
                groups.forEach((group) => {
                  if (group !== firstGroup) {
                    // Apply the style of the first group to each group
                    group.setStyle(firstGroupStyle);

                    // Apply the style to the children of each group
                    let firstGroupChildren = firstGroup.find("*");
                    let groupChildren = group.find("*");

                    for (let i = 0; i < firstGroupChildren.length; i++) {
                      let firstChildStyle = firstGroupChildren[i].getStyle();
                      groupChildren[i].setStyle(firstChildStyle);
                    }
                  }
                });
              }
              this.view.render();
              console.log("replicated");
            }
          },

          async handlePropChange() {
            const {
              CustomUrl,
              BaseUrl,
              APIPath,
              BearerToken,
              Username,
              Password,
              MoreHeaders,
              APIMethod,
              APIBody,
              ArrOfObjKyename,
              NestedKeyname,
              CommonWidth,
            } = this.props();

            // to rename a variable because API var is getting used in many places in this block scope
            let API;
            if (APIPath) {
              API = APIPath;
            }

            let container = this;
            let containerId = this.getAttributes()["id"];
            console.log("container:", container, containerId);

            // helper function to check if a variable is an array-of-objects or not
            function isArrayofObjects(variable) {
              // Check if the variable is an array
              if (!Array.isArray(variable)) {
                return false;
              }

              // Check if all elements in the array are objects
              for (const element of variable) {
                if (
                  typeof element !== "object" ||
                  Array.isArray(element) ||
                  element === null
                ) {
                  return false;
                }
              }
              return true;
            }

            // helper function to get value of a key in nested object
            function findKeyValue(obj, key) {
              if (obj.hasOwnProperty(key)) {
                // If the current object has the key, return its value
                return obj[key];
              }

              for (var prop in obj) {
                if (obj.hasOwnProperty(prop) && typeof obj[prop] === "object") {
                  // If the current property is an object, recursively search within it
                  var result = findKeyValue(obj[prop], key);
                  if (result !== undefined) {
                    return result;
                  }
                }
              }
              // Key not found in the object
              return undefined;
            }

            let apiData;

            // -------- Getting API Data
            // to use API to populate the dropdown list
            // if CustomUrl is provided, use only that
            if (CustomUrl && (!BaseUrl || BaseUrl === "null")) {
              // if nothing is provided for auth
              if (!BearerToken && !Username && !Password) {
                // add extra headers, if needed
                let config = {
                  headers: {},
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${CustomUrl}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token is provided but not api_key or usr+pwd
              else if (BearerToken && !Username && !Password) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${BearerToken}`,
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${CustomUrl}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token and api_key not provided but usr+pwd are provided
              else if (!BearerToken && Username && Password) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    Authorization: "Basic " + btoa(Username + ":" + Password),
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${CustomUrl}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }
            }

            // if base url is the choice and provided
            else if (BaseUrl && API && !CustomUrl) {
              // concatenating base url and its remaining part
              let url, baseUrlBearerToken;
              if (BaseUrl === "baseUrl1") {
                url = baseUrl1 + API;
                baseUrlBearerToken = baseUrl1BearerToken;
              } else if (BaseUrl === "baseUrl2") {
                url = baseUrl2 + API;
                baseUrlBearerToken = baseUrl2BearerToken;
              } else if (BaseUrl === "baseUrl3") {
                url = baseUrl3 + API;
                baseUrlBearerToken = baseUrl3BearerToken;
              } else if (BaseUrl === "baseUrl4") {
                url = baseUrl4 + API;
                baseUrlBearerToken = baseUrl4BearerToken;
              } else if (BaseUrl === "baseUrl5") {
                url = baseUrl5 + API;
                baseUrlBearerToken = baseUrl5BearerToken;
              }
              console.log("url, baseUrlBearerToken", url, baseUrlBearerToken);

              // if nothing is provided for auth
              if (
                !BearerToken &&
                !baseUrlBearerToken &&
                !Username &&
                !Password
              ) {
                // add extra headers, if needed
                let config = {
                  headers: {},
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token is provided but not usr+pwd
              else if (BearerToken && !Username && !Password) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${BearerToken}`,
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a baseUrlBearerToken is provided but not Custom Bearer Token and usr+pwd
              else if (
                baseUrlBearerToken &&
                !BearerToken &&
                !Username &&
                !Password
              ) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${baseUrlBearerToken}`,
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config@:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token is not provided but usr+pwd are provided
              else if (!BearerToken && Username && Password) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    Authorization: "Basic " + btoa(Username + ":" + Password),
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }
            }

            // POST method
            // if CustomUrl is provided, use only that
            if (
              CustomUrl &&
              (!BaseUrl || BaseUrl === "null") &&
              APIMethod === "POST"
            ) {
              // if nothing is provided for auth
              if (!BearerToken && !Username && !Password) {
                // add extra headers, if needed
                let config = {
                  method: "POST",
                  headers: {},
                  body:
                    typeof APIBody === "object"
                      ? JSON.stringify(APIBody)
                      : APIBody,
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${CustomUrl}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token is provided but not api_key or usr+pwd
              else if (BearerToken && !Username && !Password) {
                // add extra headers, if needed
                let config = {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${BearerToken}`,
                  },
                  body:
                    typeof APIBody === "object"
                      ? JSON.stringify(APIBody)
                      : APIBody,
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${CustomUrl}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token and api_key not provided but usr+pwd are provided
              else if (!BearerToken && Username && Password) {
                // add extra headers, if needed
                let config = {
                  method: "POST",
                  headers: {
                    Authorization: "Basic " + btoa(Username + ":" + Password),
                  },
                  body:
                    typeof APIBody === "object"
                      ? JSON.stringify(APIBody)
                      : APIBody,
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${CustomUrl}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }
            }

            // if base url is the choice and provided
            if (BaseUrl && API && !CustomUrl && APIMethod === "POST") {
              // concatenating base url and its remaining part
              let url, baseUrlBearerToken;
              if (BaseUrl === "baseUrl1") {
                url = baseUrl1 + API;
                baseUrlBearerToken = baseUrl1BearerToken;
              } else if (BaseUrl === "baseUrl2") {
                url = baseUrl2 + API;
                baseUrlBearerToken = baseUrl2BearerToken;
              } else if (BaseUrl === "baseUrl3") {
                url = baseUrl3 + API;
                baseUrlBearerToken = baseUrl3BearerToken;
              } else if (BaseUrl === "baseUrl4") {
                url = baseUrl4 + API;
                baseUrlBearerToken = baseUrl4BearerToken;
              } else if (BaseUrl === "baseUrl5") {
                url = baseUrl5 + API;
                baseUrlBearerToken = baseUrl5BearerToken;
              }
              console.log("url, baseUrlBearerToken", url, baseUrlBearerToken);

              // if nothing is provided for auth
              if (
                !BearerToken &&
                !baseUrlBearerToken &&
                !Username &&
                !Password
              ) {
                // add extra headers, if needed
                let config = {
                  method: "POST",
                  headers: {},
                  body:
                    typeof APIBody === "object"
                      ? JSON.stringify(APIBody)
                      : APIBody,
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token is provided but not usr+pwd
              else if (BearerToken && !Username && !Password) {
                // add extra headers, if needed
                let config = {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${BearerToken}`,
                  },
                  body:
                    typeof APIBody === "object"
                      ? JSON.stringify(APIBody)
                      : APIBody,
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a baseUrlBearerToken is provided but not Custom Bearer Token and usr+pwd
              else if (
                baseUrlBearerToken &&
                !BearerToken &&
                !Username &&
                !Password
              ) {
                // add extra headers, if needed
                let config = {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${baseUrlBearerToken}`,
                  },
                  body:
                    typeof APIBody === "object"
                      ? JSON.stringify(APIBody)
                      : APIBody,
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config@:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token is not provided but usr+pwd are provided
              else if (!BearerToken && Username && Password) {
                // add extra headers, if needed
                let config = {
                  method: "POST",
                  headers: {
                    Authorization: "Basic " + btoa(Username + ":" + Password),
                  },
                  body:
                    typeof APIBody === "object"
                      ? JSON.stringify(APIBody)
                      : APIBody,
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }
            }

            console.log("apiData:", apiData);

            // -------- Populating API Data, into the dropdown list
            if (apiData !== undefined) {
              console.log("#");
              // if API response is directly an array-of-objects
              if (isArrayofObjects(apiData)) {
                if (ArrOfObjKyename) {
                  console.log("##");
                  // container.components("");

                  // dynamic add
                  // to check if any '_id' data was changed in the backend object, then update the frontend labels of radio also
                  if (container.components().length > 0) {
                    console.log("@1");
                    // check if these are database plotted radio or not
                    let isNotDefaultRadio =
                      "data_db_id" in
                        container
                          .find('input[type="radio"]')[0]
                          .getAttributes() &&
                      container.find('input[type="radio"]')[0].getAttributes()[
                        "data_db_id"
                      ] !== "";
                    console.log("isNotDefaultRadio", isNotDefaultRadio);

                    // if they are database plotted radio then scan through them using data_db_id and update if any
                    if (isNotDefaultRadio) {
                      console.log("@1@");
                      let allMiniContainers =
                        container.find(".group_radio_label");
                      allMiniContainers.forEach((groupRadioLabel, idx) => {
                        let radio = groupRadioLabel.find(
                          'input[type="radio"]'
                        )[0];
                        let radio_dataDbId = groupRadioLabel
                          .find('input[type="radio"]')[0]
                          .getAttributes()["data_db_id"];
                        let label = groupRadioLabel.find("label")[0];

                        // get the object from apiData that has the radio
                        let currentObj = apiData.filter(
                          (obj) => obj["_id"] === radio_dataDbId
                        );

                        if (currentObj.length > 0) {
                          let labelInnerText = label
                            .components()
                            .models[0].components()
                            .models[0].get("content");
                          // console.log('*+*+*+ labelInnerText 1', label.components().models[0].components().models[0].get('content'), '2', label.getLastChild().getLastChild().get('content'));

                          currentObj.forEach((obj) => {
                            // check if the IDs match, if not then update the label's inner text and value of radio
                            if (labelInnerText !== obj[`${ArrOfObjKyename}`]) {
                              // console.log('*+*+*+', labelInnerText, '------', obj[`${ArrOfObjKyename}`]);
                              label
                                .components()
                                .models[0].components()
                                .models[0].set(
                                  "content",
                                  obj[`${ArrOfObjKyename}`]
                                );
                              radio.addAttributes({
                                value: obj[`${ArrOfObjKyename}`],
                              });
                              // to rerender the view of the component to show that it has been updated in the editor, instantly
                              this.view.render();
                              console.log("currentObj", currentObj);
                            }
                          });
                        }
                      });
                      // console.log('@apiData.length, allMiniContainers.length', apiData.length, allMiniContainers.length);
                      // if there are equal number of objects in apiData as checkboxes then plot new ones
                      if (apiData.length > allMiniContainers.length) {
                        console.log("@11@");
                        container.components("");
                        apiData.forEach((opt) => {
                          let groupEle = {
                            tagName: "span",
                            type: "default",
                            attributes: {
                              class: "group_radio_label",
                            },

                            "style-default": {
                              display: "flex",
                              "flex-wrap": "no-wrap",
                              "justify-content": "flex-start",
                              "align-items": "flex-start",
                              width: CommonWidth
                                ? CommonWidth + "%"
                                : "8% !important",
                            },

                            style: {
                              display: "flex",
                              "flex-wrap": "no-wrap",
                              "justify-content": "flex-start",
                              "align-items": "flex-start",
                              width: CommonWidth
                                ? CommonWidth + "%"
                                : "8% !important",
                            },

                            components: [
                              {
                                tagName: "span",
                                type: "radio_input",
                                script: individualRadioScript,

                                attributes: {
                                  class: "radio_input",
                                },

                                components: [
                                  {
                                    tagName: "input",
                                    type: "default",
                                    attributes: {
                                      type: "radio",
                                      id: `radio_1_${uniqid()}`,
                                      name: `radio_${containerId}`,
                                      value: `${opt[`${ArrOfObjKyename}`]}`,
                                      data_db_id: `${opt[`_id`]}`
                                        ? `${opt[`_id`]}`
                                        : `${opt[`${ArrOfObjKyename}`]}`,
                                    },
                                  },
                                ],

                                Autofocus: false,
                                Disabled: false,
                                Required: false,
                                Checked: false,

                                traits: [
                                  "id",
                                  "name",
                                  "value",
                                  {
                                    type: "checkbox",
                                    name: "Autofocus",
                                    label: "Autofocus",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Disabled",
                                    label: "Disabled",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Required",
                                    label: "Required",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Checked",
                                    label: "Checked",
                                    changeProp: true,
                                  },
                                ],

                                changeProp: true,
                                "script-props": [
                                  "Autofocus",
                                  "Disabled",
                                  "Required",
                                  "Checked",
                                ],
                              },
                              {
                                tagName: "label",
                                attributes: {
                                  for: ``,
                                },

                                components: [
                                  {
                                    tagName: "p",
                                    type: "text",
                                    editable: true,

                                    style: {
                                      "word-break": "break-all",
                                    },

                                    "style-default": {
                                      "word-break": "break-all",
                                    },

                                    components: {
                                      type: "textnode",
                                      content: `${opt[`${ArrOfObjKyename}`]}`,
                                    },
                                  },
                                ],

                                traits: ["id", "for"],
                                changeProp: true,
                              },
                            ],
                          };

                          container.append(groupEle);
                        });
                      }
                    } else {
                      console.log("@2@");
                      container.components("");
                      apiData.forEach((opt) => {
                        let groupEle = {
                          tagName: "span",
                          type: "default",
                          attributes: {
                            class: "group_radio_label",
                          },

                          "style-default": {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          style: {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          components: [
                            {
                              tagName: "span",
                              type: "radio_input",
                              script: individualRadioScript,

                              attributes: {
                                class: "radio_input",
                              },

                              components: [
                                {
                                  tagName: "input",
                                  type: "default",
                                  attributes: {
                                    type: "radio",
                                    id: `radio_1_${uniqid()}`,
                                    name: `radio_${containerId}`,
                                    value: `${opt[`${ArrOfObjKyename}`]}`,
                                    data_db_id: `${opt[`_id`]}`
                                      ? `${opt[`_id`]}`
                                      : `${opt[`${ArrOfObjKyename}`]}`,
                                  },
                                },
                              ],

                              Autofocus: false,
                              Disabled: false,
                              Required: false,
                              Checked: false,

                              traits: [
                                "id",
                                "name",
                                "value",
                                {
                                  type: "checkbox",
                                  name: "Autofocus",
                                  label: "Autofocus",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Disabled",
                                  label: "Disabled",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Required",
                                  label: "Required",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Checked",
                                  label: "Checked",
                                  changeProp: true,
                                },
                              ],

                              changeProp: true,
                              "script-props": [
                                "Autofocus",
                                "Disabled",
                                "Required",
                                "Checked",
                              ],
                            },
                            {
                              tagName: "label",
                              attributes: {
                                for: ``,
                              },

                              components: [
                                {
                                  tagName: "p",
                                  type: "text",
                                  editable: true,

                                  style: {
                                    "word-break": "break-all",
                                  },

                                  "style-default": {
                                    "word-break": "break-all",
                                  },

                                  components: {
                                    type: "textnode",
                                    content: `${opt[`${ArrOfObjKyename}`]}`,
                                  },
                                },
                              ],

                              traits: ["id", "for"],
                              changeProp: true,
                            },
                          ],
                        };

                        container.append(groupEle);
                      });
                    }
                  }

                  // reasons -
                  // container.components().length === 0 : plot radio if there are no radio present in the container
                  // container.components().length === 2 : plot radio the first time when there are the 2 initial radio
                  // apiData.length > container.components().length : plot radio if apiData has more objects than radio in the container meaning update the radio when there is an update done in the backend database, make this dynamic
                  if (
                    container.components().length === 0 ||
                    (container.components().length === 2 && apiData.length > 2)
                  ) {
                    // clear the body and then plot because the first-time plotting will happen here
                    console.log("@2");
                    container.components("");
                    apiData.forEach((opt) => {
                      let groupEle = {
                        tagName: "span",
                        type: "default",
                        attributes: {
                          class: "group_radio_label",
                        },

                        "style-default": {
                          display: "flex",
                          "flex-wrap": "no-wrap",
                          "justify-content": "flex-start",
                          "align-items": "flex-start",
                          width: CommonWidth
                            ? CommonWidth + "%"
                            : "8% !important",
                        },

                        style: {
                          display: "flex",
                          "flex-wrap": "no-wrap",
                          "justify-content": "flex-start",
                          "align-items": "flex-start",
                          width: CommonWidth
                            ? CommonWidth + "%"
                            : "8% !important",
                        },

                        components: [
                          {
                            tagName: "span",
                            type: "radio_input",
                            script: individualRadioScript,

                            attributes: {
                              class: "radio_input",
                            },

                            components: [
                              {
                                tagName: "input",
                                type: "default",
                                attributes: {
                                  type: "radio",
                                  id: `radio_1_${uniqid()}`,
                                  name: `radio_${containerId}`,
                                  value: `${opt[`${ArrOfObjKyename}`]}`,
                                  data_db_id: `${opt[`_id`]}`
                                    ? `${opt[`_id`]}`
                                    : `${opt[`${ArrOfObjKyename}`]}`,
                                },
                              },
                            ],

                            Autofocus: false,
                            Disabled: false,
                            Required: false,
                            Checked: false,

                            traits: [
                              "id",
                              "name",
                              "value",
                              {
                                type: "checkbox",
                                name: "Autofocus",
                                label: "Autofocus",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Disabled",
                                label: "Disabled",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Required",
                                label: "Required",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Checked",
                                label: "Checked",
                                changeProp: true,
                              },
                            ],

                            changeProp: true,
                            "script-props": [
                              "Autofocus",
                              "Disabled",
                              "Required",
                              "Checked",
                            ],
                          },
                          {
                            tagName: "label",
                            attributes: {
                              for: ``,
                            },

                            components: [
                              {
                                tagName: "p",
                                type: "text",
                                editable: true,

                                style: {
                                  "word-break": "break-all",
                                },

                                "style-default": {
                                  "word-break": "break-all",
                                },

                                components: {
                                  type: "textnode",
                                  content: `${opt[`${ArrOfObjKyename}`]}`,
                                },
                              },
                            ],

                            traits: ["id", "for"],
                            changeProp: true,
                          },
                        ],
                      };

                      // let inputEle = {
                      //   tagName: "input",
                      //   type: "default", // so that the input component doesn't throw error of 'undefined'

                      //   script: individualCheckboxScript,

                      //   attributes: {
                      //     type: "checkbox",
                      //     // id: `${opt[`${ArrOfObjKyename}`]}`,
                      //     name: `${opt[`${ArrOfObjKyename}`]}`,
                      //     value: `${opt[`${ArrOfObjKyename}`]}`,
                      //   },

                      //   Autofocus: false,
                      //   Disabled: false,
                      //   Required: false,
                      //   Checked: false,

                      //   traits: [
                      //     "id",
                      //     "name",
                      //     "value",
                      //     {
                      //       type: "checkbox",
                      //       name: "Autofocus",
                      //       label: "Autofocus",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Disabled",
                      //       label: "Disabled",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Required",
                      //       label: "Required",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Checked",
                      //       label: "Checked",
                      //       changeProp: true,
                      //     },
                      //   ],

                      //   changeProp: true,
                      //   "script-props": [
                      //     "Autofocus",
                      //     "Disabled",
                      //     "Required",
                      //     "Checked",
                      //   ],
                      // };

                      // let labelEle = {
                      //   tagName: "label",
                      //   attributes: {
                      //     for: ``,
                      //   },

                      //   components: [
                      //     {
                      //       tagName: "p",
                      //       type: "text",
                      //       editable: true,

                      //       components: {
                      //         type: "textnode",
                      //         content: `${opt[`${ArrOfObjKyename}`]}`,
                      //       },
                      //     },
                      //   ],

                      //   traits: ["id", "for"],
                      // };

                      // container.append(inputEle);
                      // container.append(labelEle);
                      container.append(groupEle);
                    });
                  }

                  // update only when the radio have already been plotted previously from apiData but not updating if the apiData had only 2 fields
                  if (
                    apiData.length > container.components().length &&
                    container.components().length > 2
                  ) {
                    // only add what's missing from api as a dynamic update
                    console.log("@3");
                    // get all the labels' inner content and compare it with the keyname of the apiData to be plotted and add the ones missing
                    let allLabelEles = container.find("label");
                    let allLabels = allLabelEles.map(
                      (label) =>
                        label.find('p[data-gjs-type="text"]')[0].getEl()
                          .innerHTML
                    );
                    console.log("allLabelEles", allLabelEles, allLabels);

                    if (allLabelEles.length > 0) {
                      // if you find a label thats not in the apiData then add it to the existing radio container
                      apiData.forEach((dbRow, idx) => {
                        // if that object from apiData is not present in the radio container then plot it
                        if (!allLabels.includes(dbRow[`${ArrOfObjKyename}`])) {
                          let groupEle = {
                            tagName: "span",
                            type: "default",
                            attributes: {
                              class: "group_radio_label",
                            },

                            "style-default": {
                              display: "flex",
                              "flex-wrap": "no-wrap",
                              "justify-content": "flex-start",
                              "align-items": "flex-start",
                              width: CommonWidth
                                ? CommonWidth + "%"
                                : "8% !important",
                            },

                            style: {
                              display: "flex",
                              "flex-wrap": "no-wrap",
                              "justify-content": "flex-start",
                              "align-items": "flex-start",
                              width: CommonWidth
                                ? CommonWidth + "%"
                                : "8% !important",
                            },

                            components: [
                              {
                                tagName: "span",
                                type: "radio_input",
                                script: individualRadioScript,

                                attributes: {
                                  class: "radio_input",
                                },

                                components: [
                                  {
                                    tagName: "input",
                                    type: "default",
                                    attributes: {
                                      type: "radio",
                                      id: `radio_1_${uniqid()}`,
                                      name: `radio_${containerId}`,
                                      value: `${dbRow[`${ArrOfObjKyename}`]}`,
                                      data_db_id: `${dbRow[`_id`]}`
                                        ? `${dbRow[`_id`]}`
                                        : `${dbRow[`${ArrOfObjKyename}`]}`,
                                    },
                                  },
                                ],

                                Autofocus: false,
                                Disabled: false,
                                Required: false,
                                Checked: false,

                                traits: [
                                  "id",
                                  "name",
                                  "value",
                                  {
                                    type: "checkbox",
                                    name: "Autofocus",
                                    label: "Autofocus",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Disabled",
                                    label: "Disabled",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Required",
                                    label: "Required",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Checked",
                                    label: "Checked",
                                    changeProp: true,
                                  },
                                ],

                                changeProp: true,
                                "script-props": [
                                  "Autofocus",
                                  "Disabled",
                                  "Required",
                                  "Checked",
                                ],
                              },
                              {
                                tagName: "label",
                                attributes: {
                                  for: ``,
                                },

                                components: [
                                  {
                                    tagName: "p",
                                    type: "text",
                                    editable: true,

                                    style: {
                                      "word-break": "break-all",
                                    },

                                    "style-default": {
                                      "word-break": "break-all",
                                    },

                                    components: {
                                      type: "textnode",
                                      content: `${dbRow[`${ArrOfObjKyename}`]}`,
                                    },
                                  },
                                ],

                                traits: ["id", "for"],
                                changeProp: true,
                              },
                            ],
                          };

                          container.append(groupEle);
                        }
                      });
                    }
                  }

                  // plot when the apiData has only around 2 entries
                  else if (apiData.length <= 2) {
                    console.log("@4");

                    // see if the radio are the default radio by checking if they have this attribute 'data_db_id', if yes then clear the body and append new else append new radio anyways
                    let isNotDefaultCheckbox =
                      "data_db_id" in
                      container.find('input[type="radio"]')[0].getAttributes();
                    console.log("isNotDefaultCheckbox", isNotDefaultCheckbox);

                    // if it is a default radio then empty the body before appending apiData radio
                    if (!isNotDefaultCheckbox) {
                      container.components("");
                      apiData.forEach((opt) => {
                        let groupEle = {
                          tagName: "span",
                          type: "default",
                          attributes: {
                            class: "group_radio_label",
                          },

                          "style-default": {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          style: {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          components: [
                            {
                              tagName: "span",
                              type: "radio_input",
                              script: individualRadioScript,

                              attributes: {
                                class: "radio_input",
                              },

                              components: [
                                {
                                  tagName: "input",
                                  type: "default",
                                  attributes: {
                                    type: "radio",
                                    id: `radio_1_${uniqid()}`,
                                    name: `radio_${containerId}`,
                                    value: `${opt[`${ArrOfObjKyename}`]}`,
                                    data_db_id: `${opt[`_id`]}`
                                      ? `${opt[`_id`]}`
                                      : `${opt[`${ArrOfObjKyename}`]}`,
                                  },
                                },
                              ],

                              Autofocus: false,
                              Disabled: false,
                              Required: false,
                              Checked: false,

                              traits: [
                                "id",
                                "name",
                                "value",
                                {
                                  type: "checkbox",
                                  name: "Autofocus",
                                  label: "Autofocus",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Disabled",
                                  label: "Disabled",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Required",
                                  label: "Required",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Checked",
                                  label: "Checked",
                                  changeProp: true,
                                },
                              ],

                              changeProp: true,
                              "script-props": [
                                "Autofocus",
                                "Disabled",
                                "Required",
                                "Checked",
                              ],
                            },
                            {
                              tagName: "label",
                              attributes: {
                                for: ``,
                              },

                              components: [
                                {
                                  tagName: "p",
                                  type: "text",
                                  editable: true,

                                  style: {
                                    "word-break": "break-all",
                                  },

                                  "style-default": {
                                    "word-break": "break-all",
                                  },

                                  components: {
                                    type: "textnode",
                                    content: `${opt[`${ArrOfObjKyename}`]}`,
                                  },
                                },
                              ],

                              traits: ["id", "for"],
                              changeProp: true,
                            },
                          ],
                        };
                        container.append(groupEle);
                        console.log("appended", opt);
                      });
                    } else {
                      container.components("");
                      apiData.forEach((opt) => {
                        let groupEle = {
                          tagName: "span",
                          type: "default",
                          attributes: {
                            class: "group_radio_label",
                          },

                          "style-default": {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          style: {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          components: [
                            {
                              tagName: "span",
                              type: "radio_input",
                              script: individualRadioScript,

                              attributes: {
                                class: "radio_input",
                              },

                              components: [
                                {
                                  tagName: "input",
                                  type: "default",
                                  attributes: {
                                    type: "radio",
                                    id: `radio_1_${uniqid()}`,
                                    name: `radio_${containerId}`,
                                    value: `${opt[`${ArrOfObjKyename}`]}`,
                                    data_db_id: `${opt[`_id`]}`
                                      ? `${opt[`_id`]}`
                                      : `${opt[`${ArrOfObjKyename}`]}`,
                                  },
                                },
                              ],

                              Autofocus: false,
                              Disabled: false,
                              Required: false,
                              Checked: false,

                              traits: [
                                "id",
                                "name",
                                "value",
                                {
                                  type: "checkbox",
                                  name: "Autofocus",
                                  label: "Autofocus",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Disabled",
                                  label: "Disabled",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Required",
                                  label: "Required",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Checked",
                                  label: "Checked",
                                  changeProp: true,
                                },
                              ],

                              changeProp: true,
                              "script-props": [
                                "Autofocus",
                                "Disabled",
                                "Required",
                                "Checked",
                              ],
                            },
                            {
                              tagName: "label",
                              attributes: {
                                for: ``,
                              },

                              components: [
                                {
                                  tagName: "p",
                                  type: "text",
                                  editable: true,

                                  style: {
                                    "word-break": "break-all",
                                  },

                                  "style-default": {
                                    "word-break": "break-all",
                                  },

                                  components: {
                                    type: "textnode",
                                    content: `${opt[`${ArrOfObjKyename}`]}`,
                                  },
                                },
                              ],

                              traits: ["id", "for"],
                              changeProp: true,
                            },
                          ],
                        };

                        container.append(groupEle);
                      });
                    }
                  }

                  // dynamic delete
                  if (container.components().length > apiData.length) {
                    console.log("@5");
                    console.log("removing extra group_radio_labels");

                    let groupRadioLabels = container.find(".group_radio_label");
                    groupRadioLabels.forEach((groupRadioLabel) => {
                      // get the data_db_url from radio and check if _id is present in apiData, if not, remove it
                      let radio = groupRadioLabel
                        .find(".radio_input")[0]
                        .find('input[type="radio"]')[0];
                      let radioDataDbId = radio.getAttributes()["data_db_id"];

                      // see if radioDataDbId is in apiData _ids and if not there, delete this group_radio_label
                      let apiData_id = apiData.map((obj) => obj["_id"]);

                      if (!apiData_id.includes(radioDataDbId)) {
                        groupRadioLabel.remove();
                        console.log("removed");
                      }
                    });
                  }
                }
              }

              // if API response is a plain array of single elements
              else if (Array.isArray(apiData) && !isArrayofObjects(apiData)) {
                console.log("###");

                // either no radio are plotted or the default 2 radio are there
                if (
                  container.components().length === 0 ||
                  container.components().length <= 2
                ) {
                  container.components("");
                  apiData.forEach((opt) => {
                    let groupEle = {
                      tagName: "span",
                      type: "default",
                      attributes: {
                        class: "group_radio_label",
                      },

                      "style-default": {
                        display: "flex",
                        "flex-wrap": "no-wrap",
                        "justify-content": "flex-start",
                        "align-items": "flex-start",
                        width: CommonWidth
                          ? CommonWidth + "%"
                          : "8% !important",
                      },

                      style: {
                        display: "flex",
                        "flex-wrap": "no-wrap",
                        "justify-content": "flex-start",
                        "align-items": "flex-start",
                        width: CommonWidth
                          ? CommonWidth + "%"
                          : "8% !important",
                      },

                      components: [
                        {
                          tagName: "span",
                          type: "radio_input",
                          script: individualRadioScript,

                          attributes: {
                            class: "radio_input",
                          },

                          components: [
                            {
                              tagName: "input",
                              type: "default",
                              attributes: {
                                type: "radio",
                                id: `radio_1_${uniqid()}`,
                                name: `radio_${containerId}`,
                                value: `${opt}`,
                              },
                            },
                          ],

                          Autofocus: false,
                          Disabled: false,
                          Required: false,
                          Checked: false,

                          traits: [
                            "id",
                            "name",
                            "value",
                            {
                              type: "checkbox",
                              name: "Autofocus",
                              label: "Autofocus",
                              changeProp: true,
                            },
                            {
                              type: "checkbox",
                              name: "Disabled",
                              label: "Disabled",
                              changeProp: true,
                            },
                            {
                              type: "checkbox",
                              name: "Required",
                              label: "Required",
                              changeProp: true,
                            },
                            {
                              type: "checkbox",
                              name: "Checked",
                              label: "Checked",
                              changeProp: true,
                            },
                          ],

                          changeProp: true,
                          "script-props": [
                            "Autofocus",
                            "Disabled",
                            "Required",
                            "Checked",
                          ],
                        },
                        {
                          tagName: "label",
                          attributes: {
                            for: ``,
                          },

                          components: [
                            {
                              tagName: "p",
                              type: "text",
                              editable: true,

                              style: {
                                "word-break": "break-all",
                              },

                              "style-default": {
                                "word-break": "break-all",
                              },

                              components: {
                                type: "textnode",
                                content: `${opt}`,
                              },
                            },
                          ],

                          traits: ["id", "for"],
                        },
                      ],
                    };

                    // let inputEle = {
                    //   tagName: "input",
                    //   type: "default", // so that the input component doesn't throw error of 'undefined'

                    //   script: individualCheckboxScript,

                    //   attributes: {
                    //     type: "checkbox",
                    //     // id: `ch-${opt}`,
                    //     name: `ch-${opt}`,
                    //     value: `${opt}`,
                    //   },

                    //   Autofocus: false,
                    //   Disabled: false,
                    //   Required: false,
                    //   Checked: false,

                    //   traits: [
                    //     "id",
                    //     "name",
                    //     "value",
                    //     {
                    //       type: "checkbox",
                    //       name: "Autofocus",
                    //       label: "Autofocus",
                    //       changeProp: true,
                    //     },
                    //     {
                    //       type: "checkbox",
                    //       name: "Disabled",
                    //       label: "Disabled",
                    //       changeProp: true,
                    //     },
                    //     {
                    //       type: "checkbox",
                    //       name: "Required",
                    //       label: "Required",
                    //       changeProp: true,
                    //     },
                    //     {
                    //       type: "checkbox",
                    //       name: "Checked",
                    //       label: "Checked",
                    //       changeProp: true,
                    //     },
                    //   ],

                    //   changeProp: true,
                    //   "script-props": [
                    //     "Autofocus",
                    //     "Disabled",
                    //     "Required",
                    //     "Checked",
                    //   ],
                    // };

                    // let labelEle = {
                    //   tagName: "label",
                    //   attributes: {
                    //     for: ``,
                    //   },

                    //   components: [
                    //     {
                    //       tagName: "p",
                    //       type: "text",
                    //       editable: true,

                    //       components: {
                    //         type: "textnode",
                    //         content: `${opt}`,
                    //       },
                    //     },
                    //   ],

                    //   traits: ["id", "for"],
                    // };

                    // container.append(inputEle);
                    // container.append(labelEle);
                    container.append(groupEle);
                  });
                }

                // else if the apiData radio are already plotted then check for updated values and add those here without changing the IDd of already plotted ones
                else if (
                  apiData.length > container.components().length &&
                  container.components().length > 2
                ) {
                  // only add what's missing from api as a dynamic update

                  // get all the labels' inner content and compare it with the keyname of the apiData to be plotted and add the ones missing
                  let allLabelEles = container.find("label");
                  let allLabels = allLabelEles.map(
                    (label) =>
                      label.find('p[data-gjs-type="text"]')[0].getEl().innerHTML
                  );
                  console.log("allLabelEles", allLabelEles, allLabels);

                  if (allLabelEles.length > 0) {
                    // if you find a label thats not in the apiData then add it to the existing radio container
                    apiData.forEach((opt, idx) => {
                      // if that object from apiData is not present in the radio container then plot it
                      if (!allLabels.includes(opt)) {
                        let groupEle = {
                          tagName: "span",
                          type: "default",
                          attributes: {
                            class: "group_radio_label",
                          },

                          "style-default": {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          style: {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          components: [
                            {
                              tagName: "span",
                              type: "radio_input",
                              script: individualRadioScript,

                              attributes: {
                                class: "radio_input",
                              },

                              components: [
                                {
                                  tagName: "input",
                                  type: "default",
                                  attributes: {
                                    type: "radio",
                                    id: `radio_1_${uniqid()}`,
                                    name: `radio_${containerId}`,
                                    value: `${opt}`,
                                  },
                                },
                              ],

                              Autofocus: false,
                              Disabled: false,
                              Required: false,
                              Checked: false,

                              traits: [
                                "id",
                                "name",
                                "value",
                                {
                                  type: "checkbox",
                                  name: "Autofocus",
                                  label: "Autofocus",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Disabled",
                                  label: "Disabled",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Required",
                                  label: "Required",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Checked",
                                  label: "Checked",
                                  changeProp: true,
                                },
                              ],

                              changeProp: true,
                              "script-props": [
                                "Autofocus",
                                "Disabled",
                                "Required",
                                "Checked",
                              ],
                            },
                            {
                              tagName: "label",
                              attributes: {
                                for: ``,
                              },

                              components: [
                                {
                                  tagName: "p",
                                  type: "text",
                                  editable: true,

                                  style: {
                                    "word-break": "break-all",
                                  },

                                  "style-default": {
                                    "word-break": "break-all",
                                  },

                                  components: {
                                    type: "textnode",
                                    content: `${opt}`,
                                  },
                                },
                              ],

                              traits: ["id", "for"],
                            },
                          ],
                        };

                        container.append(groupEle);
                      }
                    });
                  }
                }
              }

              // if API response is an object
              else if (
                !isArrayofObjects(apiData) &&
                typeof apiData === "object"
              ) {
                // if API response to plot is a nested array-of-objects inside the main response object
                if (NestedKeyname && ArrOfObjKyename) {
                  console.log("####");
                  // container.components("");

                  // find the array-of-objects value
                  let data = findKeyValue(apiData, NestedKeyname);

                  if (isArrayofObjects(data)) {
                    // to check if any '_id' data was changed in the backend object, then update the frontend labels of radio also
                    if (container.components().length > 0) {
                      // check if these are database plotted radio or not
                      let isNotDefaultRadio =
                        "data_db_id" in
                        container
                          .find('input[type="radio"]')[0]
                          .getAttributes();
                      console.log("isNotDefaultRadio", isNotDefaultRadio);

                      // if they are database plotted radio then scan through them using data_db_id and update if any
                      if (isNotDefaultRadio) {
                        let allMiniContainers =
                          container.find(".group_radio_label");
                        allMiniContainers.forEach((groupRadioLabel, idx) => {
                          let radio_dataDbId = groupRadioLabel
                            .find('input[type="radio"]')[0]
                            .getAttributes()["data_db_id"];
                          let label = groupRadioLabel.find("label")[0];

                          // get the object from apiData that has the radio
                          let currentObj = apiData.filter(
                            (obj) => obj["_id"] === radio_dataDbId
                          );

                          if (currentObj.length > 0) {
                            currentObj.forEach((obj) => {
                              let labelInnerText = label
                                .find('p[data-gjs-type="text"]')[0]
                                .getEl().innerHTML;

                              // check if the IDs match, if not then update the label's inner text
                              if (
                                labelInnerText !== obj[`${ArrOfObjKyename}`]
                              ) {
                                label
                                  .getLastChild()
                                  .getLastChild()
                                  .set("content", obj[`${ArrOfObjKyename}`]);
                                // to rerender the view of the component to show that it has been updated in the editor, instantly
                                this.view.render();
                                console.log("currentObj", currentObj);
                              }
                            });
                          }
                        });
                      }
                    }

                    // reasons -
                    // container.components().length === 0 : plot radio if there are no radio present in the container
                    // container.components().length === 2 : plot radio the first time when there are the 2 initial radio
                    // data.length > container.components().length : plot radio if apiData has more objects than radio in the container meaning update the radio when there is an update done in the backend database, make this dynamic
                    if (
                      container.components().length === 0 ||
                      (container.components().length === 2 && data.length > 2)
                    ) {
                      container.components("");
                      data.forEach((opt) => {
                        let groupEle = {
                          tagName: "span",
                          type: "default",
                          attributes: {
                            class: "group_radio_label",
                          },

                          "style-default": {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          style: {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          components: [
                            {
                              tagName: "span",
                              type: "radio_input",
                              script: individualRadioScript,

                              attributes: {
                                class: "radio_input",
                              },

                              components: [
                                {
                                  tagName: "input",
                                  type: "default",
                                  attributes: {
                                    type: "radio",
                                    id: `radio_1_${uniqid()}`,
                                    name: `radio_${containerId}`,
                                    value: `${opt[`${ArrOfObjKyename}`]}`,
                                    data_db_id: `${opt[`_id`]}`
                                      ? `${opt[`_id`]}`
                                      : `${opt[`${ArrOfObjKyename}`]}`,
                                  },
                                },
                              ],

                              Autofocus: false,
                              Disabled: false,
                              Required: false,
                              Checked: false,

                              traits: [
                                "id",
                                "name",
                                "value",
                                {
                                  type: "checkbox",
                                  name: "Autofocus",
                                  label: "Autofocus",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Disabled",
                                  label: "Disabled",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Required",
                                  label: "Required",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Checked",
                                  label: "Checked",
                                  changeProp: true,
                                },
                              ],

                              changeProp: true,
                              "script-props": [
                                "Autofocus",
                                "Disabled",
                                "Required",
                                "Checked",
                              ],
                            },
                            {
                              tagName: "label",
                              attributes: {
                                for: ``,
                              },

                              components: [
                                {
                                  tagName: "p",
                                  type: "text",
                                  editable: true,

                                  style: {
                                    "word-break": "break-all",
                                  },

                                  "style-default": {
                                    "word-break": "break-all",
                                  },

                                  components: {
                                    type: "textnode",
                                    content: `${opt[`${ArrOfObjKyename}`]}`,
                                  },
                                },
                              ],

                              traits: ["id", "for"],
                            },
                          ],
                        };

                        // let inputEle = {
                        //   tagName: "input",
                        //   type: "default", // so that the input component doesn't throw error of 'undefined'

                        //   script: individualCheckboxScript,

                        //   attributes: {
                        //     type: "checkbox",
                        //     // id: `${opt[`${ArrOfObjKyename}`]}`,
                        //     name: `${opt[`${ArrOfObjKyename}`]}`,
                        //     value: `${opt[`${ArrOfObjKyename}`]}`,
                        //   },

                        //   Autofocus: false,
                        //   Disabled: false,
                        //   Required: false,
                        //   Checked: false,

                        //   traits: [
                        //     "id",
                        //     "name",
                        //     "value",
                        //     {
                        //       type: "checkbox",
                        //       name: "Autofocus",
                        //       label: "Autofocus",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Disabled",
                        //       label: "Disabled",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Required",
                        //       label: "Required",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Checked",
                        //       label: "Checked",
                        //       changeProp: true,
                        //     },
                        //   ],

                        //   changeProp: true,
                        //   "script-props": [
                        //     "Autofocus",
                        //     "Disabled",
                        //     "Required",
                        //     "Checked",
                        //   ],
                        // };

                        // let labelEle = {
                        //   tagName: "label",
                        //   attributes: {
                        //     for: ``,
                        //   },

                        //   components: [
                        //     {
                        //       tagName: "p",
                        //       type: "text",
                        //       editable: true,

                        //       components: {
                        //         type: "textnode",
                        //         content: `${opt[`${ArrOfObjKyename}`]}`,
                        //       },
                        //     },
                        //   ],

                        //   traits: ["id", "for"],
                        // };

                        // container.append(inputEle);
                        // container.append(labelEle);
                        container.append(groupEle);
                      });
                    }

                    // update only when the radio have already been plotted previously from apiData but not updating if the apiData had only 2 fields
                    if (
                      data.length > container.components().length &&
                      container.components().length > 2
                    ) {
                      // only add what's missing from api as a dynamic update

                      // get all the labels' inner content and compare it with the keyname of the apiData to be plotted and add the ones missing
                      let allLabelEles = container.find("label");
                      let allLabels = allLabelEles.map(
                        (label) =>
                          label.find('p[data-gjs-type="text"]')[0].getEl()
                            .innerHTML
                      );
                      console.log("allLabelEles", allLabelEles, allLabels);

                      if (allLabelEles.length > 0) {
                        // if you find a label thats not in the apiData then add it to the existing radio container
                        data.forEach((opt, idx) => {
                          // if that object from apiData is not present in the radio container then plot it
                          if (!allLabels.includes(opt[`${ArrOfObjKyename}`])) {
                            let groupEle = {
                              tagName: "span",
                              type: "default",
                              attributes: {
                                class: "group_radio_label",
                              },

                              "style-default": {
                                display: "flex",
                                "flex-wrap": "no-wrap",
                                "justify-content": "flex-start",
                                "align-items": "flex-start",
                                width: CommonWidth
                                  ? CommonWidth + "%"
                                  : "8% !important",
                              },

                              style: {
                                display: "flex",
                                "flex-wrap": "no-wrap",
                                "justify-content": "flex-start",
                                "align-items": "flex-start",
                                width: CommonWidth
                                  ? CommonWidth + "%"
                                  : "8% !important",
                              },

                              components: [
                                {
                                  tagName: "span",
                                  type: "radio_input",
                                  script: individualRadioScript,

                                  attributes: {
                                    class: "radio_input",
                                  },

                                  components: [
                                    {
                                      tagName: "input",
                                      type: "default",
                                      attributes: {
                                        type: "radio",
                                        id: `radio_1_${uniqid()}`,
                                        name: `radio_${containerId}`,
                                        value: `${opt[`${ArrOfObjKyename}`]}`,
                                        data_db_id: `${opt[`_id`]}`
                                          ? `${opt[`_id`]}`
                                          : `${opt[`${ArrOfObjKyename}`]}`,
                                      },
                                    },
                                  ],

                                  Autofocus: false,
                                  Disabled: false,
                                  Required: false,
                                  Checked: false,

                                  traits: [
                                    "id",
                                    "name",
                                    "value",
                                    {
                                      type: "checkbox",
                                      name: "Autofocus",
                                      label: "Autofocus",
                                      changeProp: true,
                                    },
                                    {
                                      type: "checkbox",
                                      name: "Disabled",
                                      label: "Disabled",
                                      changeProp: true,
                                    },
                                    {
                                      type: "checkbox",
                                      name: "Required",
                                      label: "Required",
                                      changeProp: true,
                                    },
                                    {
                                      type: "checkbox",
                                      name: "Checked",
                                      label: "Checked",
                                      changeProp: true,
                                    },
                                  ],

                                  changeProp: true,
                                  "script-props": [
                                    "Autofocus",
                                    "Disabled",
                                    "Required",
                                    "Checked",
                                  ],
                                },
                                {
                                  tagName: "label",
                                  attributes: {
                                    for: ``,
                                  },

                                  components: [
                                    {
                                      tagName: "p",
                                      type: "text",
                                      editable: true,

                                      style: {
                                        "word-break": "break-all",
                                      },

                                      "style-default": {
                                        "word-break": "break-all",
                                      },

                                      components: {
                                        type: "textnode",
                                        content: `${opt[`${ArrOfObjKyename}`]}`,
                                      },
                                    },
                                  ],

                                  traits: ["id", "for"],
                                },
                              ],
                            };

                            container.append(groupEle);
                          }
                        });
                      }
                    }

                    // plot when the data has only around 2 entries
                    else if (data.length <= 2) {
                      console.log("_");

                      // see if the radio are the default radio by checking if they have this attribute 'data_db_id', if yes then clear the body and append new else append new checkboxes anyways
                      let isNotDefaultRadio =
                        "data_db_id" in
                        container
                          .find('input[type="radio"]')[0]
                          .getAttributes();
                      console.log("isNotDefaultRadio", isNotDefaultRadio);

                      // if it is a default radio then empty the body before appending apiData radio
                      if (!isNotDefaultRadio) {
                        container.components("");
                        data.forEach((opt) => {
                          let groupEle = {
                            tagName: "span",
                            type: "default",
                            attributes: {
                              class: "group_radio_label",
                            },

                            "style-default": {
                              display: "flex",
                              "flex-wrap": "no-wrap",
                              "justify-content": "flex-start",
                              "align-items": "flex-start",
                              width: CommonWidth
                                ? CommonWidth + "%"
                                : "8% !important",
                            },

                            style: {
                              display: "flex",
                              "flex-wrap": "no-wrap",
                              "justify-content": "flex-start",
                              "align-items": "flex-start",
                              width: CommonWidth
                                ? CommonWidth + "%"
                                : "8% !important",
                            },

                            components: [
                              {
                                tagName: "span",
                                type: "radio_input",
                                script: individualRadioScript,

                                attributes: {
                                  class: "radio_input",
                                },

                                components: [
                                  {
                                    tagName: "input",
                                    type: "default",
                                    attributes: {
                                      type: "radio",
                                      id: `radio_1_${uniqid()}`,
                                      name: `radio_${containerId}`,
                                      value: `${opt[`${ArrOfObjKyename}`]}`,
                                      data_db_id: `${opt[`_id`]}`
                                        ? `${opt[`_id`]}`
                                        : `${opt[`${ArrOfObjKyename}`]}`,
                                    },
                                  },
                                ],

                                Autofocus: false,
                                Disabled: false,
                                Required: false,
                                Checked: false,

                                traits: [
                                  "id",
                                  "name",
                                  "value",
                                  {
                                    type: "checkbox",
                                    name: "Autofocus",
                                    label: "Autofocus",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Disabled",
                                    label: "Disabled",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Required",
                                    label: "Required",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Checked",
                                    label: "Checked",
                                    changeProp: true,
                                  },
                                ],

                                changeProp: true,
                                "script-props": [
                                  "Autofocus",
                                  "Disabled",
                                  "Required",
                                  "Checked",
                                ],
                              },
                              {
                                tagName: "label",
                                attributes: {
                                  for: ``,
                                },

                                components: [
                                  {
                                    tagName: "p",
                                    type: "text",
                                    editable: true,

                                    style: {
                                      "word-break": "break-all",
                                    },

                                    "style-default": {
                                      "word-break": "break-all",
                                    },

                                    components: {
                                      type: "textnode",
                                      content: `${opt[`${ArrOfObjKyename}`]}`,
                                    },
                                  },
                                ],

                                traits: ["id", "for"],
                              },
                            ],
                          };

                          // let inputEle = {
                          //   tagName: "input",
                          //   type: "default", // so that the input component doesn't throw error of 'undefined'

                          //   script: individualCheckboxScript,

                          //   attributes: {
                          //     type: "checkbox",
                          //     // id: `${opt[`${ArrOfObjKyename}`]}`,
                          //     name: `${opt[`${ArrOfObjKyename}`]}`,
                          //     value: `${opt[`${ArrOfObjKyename}`]}`,
                          //   },

                          //   Autofocus: false,
                          //   Disabled: false,
                          //   Required: false,
                          //   Checked: false,

                          //   traits: [
                          //     "id",
                          //     "name",
                          //     "value",
                          //     {
                          //       type: "checkbox",
                          //       name: "Autofocus",
                          //       label: "Autofocus",
                          //       changeProp: true,
                          //     },
                          //     {
                          //       type: "checkbox",
                          //       name: "Disabled",
                          //       label: "Disabled",
                          //       changeProp: true,
                          //     },
                          //     {
                          //       type: "checkbox",
                          //       name: "Required",
                          //       label: "Required",
                          //       changeProp: true,
                          //     },
                          //     {
                          //       type: "checkbox",
                          //       name: "Checked",
                          //       label: "Checked",
                          //       changeProp: true,
                          //     },
                          //   ],

                          //   changeProp: true,
                          //   "script-props": [
                          //     "Autofocus",
                          //     "Disabled",
                          //     "Required",
                          //     "Checked",
                          //   ],
                          // };

                          // let labelEle = {
                          //   tagName: "label",
                          //   attributes: {
                          //     for: ``,
                          //   },

                          //   components: [
                          //     {
                          //       tagName: "p",
                          //       type: "text",
                          //       editable: true,

                          //       components: {
                          //         type: "textnode",
                          //         content: `${opt[`${ArrOfObjKyename}`]}`,
                          //       },
                          //     },
                          //   ],

                          //   traits: ["id", "for"],
                          // };

                          // container.append(inputEle);
                          // container.append(labelEle);
                          container.append(groupEle);
                        });
                      }
                    }

                    // dynamic delete
                    if (container.components().length > data.length) {
                      console.log("removing extra group_radio_labels");

                      let groupRadioLabels =
                        container.find(".group_radio_label");
                      groupRadioLabels.forEach((groupRadioLabel) => {
                        // get the data_db_url from radio and check if _id is present in apiData, if not, remove it
                        let radio = groupRadioLabel
                          .find(".radio_input")[0]
                          .find('input[type="radio"]')[0];
                        let radioDataDbId = radio.getAttributes()["data_db_id"];

                        // see if radioDataDbId is in apiData _ids and if not there, delete this group_radio_label
                        let apiData_id = data.map((obj) => obj["_id"]);

                        if (!apiData_id.includes(radioDataDbId)) {
                          groupRadioLabel.remove();
                          console.log("removed");
                        }
                      });
                    }
                  }
                } else if (NestedKeyname && !ArrOfObjKyename) {
                  // container.components("");

                  // find the array value
                  let data = findKeyValue(apiData, NestedKeyname);

                  // if API response to plot is a nested plain array of single elements inside the main response object
                  if (Array.isArray(data) && !isArrayofObjects(data)) {
                    console.log("#####");

                    // either no radio are plotted or the default 2 radio are there
                    if (
                      container.components().length === 0 ||
                      container.components().length <= 2
                    ) {
                      container.components("");

                      data.forEach((opt) => {
                        let groupEle = {
                          tagName: "span",
                          type: "default",
                          attributes: {
                            class: "group_radio_label",
                          },

                          "style-default": {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          style: {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          components: [
                            {
                              tagName: "span",
                              type: "radio_input",
                              script: individualRadioScript,

                              attributes: {
                                class: "radio_input",
                              },

                              components: [
                                {
                                  tagName: "input",
                                  type: "default",
                                  attributes: {
                                    type: "radio",
                                    id: `radio_1_${uniqid()}`,
                                    name: `radio_${containerId}`,
                                    value: `${opt}`,
                                  },
                                },
                              ],

                              Autofocus: false,
                              Disabled: false,
                              Required: false,
                              Checked: false,

                              traits: [
                                "id",
                                "name",
                                "value",
                                {
                                  type: "checkbox",
                                  name: "Autofocus",
                                  label: "Autofocus",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Disabled",
                                  label: "Disabled",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Required",
                                  label: "Required",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Checked",
                                  label: "Checked",
                                  changeProp: true,
                                },
                              ],

                              changeProp: true,
                              "script-props": [
                                "Autofocus",
                                "Disabled",
                                "Required",
                                "Checked",
                              ],
                            },
                            {
                              tagName: "label",
                              attributes: {
                                for: ``,
                              },

                              components: [
                                {
                                  tagName: "p",
                                  type: "text",
                                  editable: true,

                                  style: {
                                    "word-break": "break-all",
                                  },

                                  "style-default": {
                                    "word-break": "break-all",
                                  },

                                  components: {
                                    type: "textnode",
                                    content: `${opt}`,
                                  },
                                },
                              ],

                              traits: ["id", "for"],
                            },
                          ],
                        };

                        // let inputEle = {
                        //   tagName: "input",
                        //   type: "default", // so that the input component doesn't throw error of 'undefined'

                        //   script: individualCheckboxScript,

                        //   attributes: {
                        //     type: "checkbox",
                        //     // id: `ch-${opt}`,
                        //     name: `ch-${opt}`,
                        //     value: `${opt}`,
                        //   },

                        //   Autofocus: false,
                        //   Disabled: false,
                        //   Required: false,
                        //   Checked: false,

                        //   traits: [
                        //     "id",
                        //     "name",
                        //     "value",
                        //     {
                        //       type: "checkbox",
                        //       name: "Autofocus",
                        //       label: "Autofocus",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Disabled",
                        //       label: "Disabled",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Required",
                        //       label: "Required",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Checked",
                        //       label: "Checked",
                        //       changeProp: true,
                        //     },
                        //   ],

                        //   changeProp: true,
                        //   "script-props": [
                        //     "Autofocus",
                        //     "Disabled",
                        //     "Required",
                        //     "Checked",
                        //   ],
                        // };

                        // let labelEle = {
                        //   tagName: "label",
                        //   attributes: {
                        //     for: ``,
                        //   },

                        //   components: [
                        //     {
                        //       tagName: "p",
                        //       type: "text",
                        //       editable: true,

                        //       components: {
                        //         type: "textnode",
                        //         content: `${opt}`,
                        //       },
                        //     },
                        //   ],

                        //   traits: ["id", "for"],
                        // };

                        // container.append(inputEle);
                        // container.append(labelEle);
                        container.append(groupEle);
                      });
                    }

                    // else if the apiData radio are already plotted then check for updated values and add those here without changing the IDd of already plotted ones
                    else if (
                      data.length > container.components().length &&
                      container.components().length > 2
                    ) {
                      // only add what's missing from api as a dynamic update

                      // get all the labels' inner content and compare it with the keyname of the apiData to be plotted and add the ones missing
                      let allLabelEles = container.find("label");
                      let allLabels = allLabelEles.map(
                        (label) =>
                          label.find('p[data-gjs-type="text"]')[0].getEl()
                            .innerHTML
                      );
                      console.log("allLabelEles", allLabelEles, allLabels);

                      if (allLabelEles.length > 0) {
                        // if you find a label thats not in the apiData then add it to the existing radio container
                        data.forEach((opt, idx) => {
                          let groupEle = {
                            tagName: "span",
                            type: "default",
                            attributes: {
                              class: "group_radio_label",
                            },

                            "style-default": {
                              display: "flex",
                              "flex-wrap": "no-wrap",
                              "justify-content": "flex-start",
                              "align-items": "flex-start",
                              width: CommonWidth
                                ? CommonWidth + "%"
                                : "8% !important",
                            },

                            style: {
                              display: "flex",
                              "flex-wrap": "no-wrap",
                              "justify-content": "flex-start",
                              "align-items": "flex-start",
                              width: CommonWidth
                                ? CommonWidth + "%"
                                : "8% !important",
                            },

                            components: [
                              {
                                tagName: "span",
                                type: "radio_input",
                                script: individualRadioScript,

                                attributes: {
                                  class: "radio_input",
                                },

                                components: [
                                  {
                                    tagName: "input",
                                    type: "default",
                                    attributes: {
                                      type: "radio",
                                      id: `radio_1_${uniqid()}`,
                                      name: `radio_${containerId}`,
                                      value: `${opt}`,
                                    },
                                  },
                                ],

                                Autofocus: false,
                                Disabled: false,
                                Required: false,
                                Checked: false,

                                traits: [
                                  "id",
                                  "name",
                                  "value",
                                  {
                                    type: "checkbox",
                                    name: "Autofocus",
                                    label: "Autofocus",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Disabled",
                                    label: "Disabled",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Required",
                                    label: "Required",
                                    changeProp: true,
                                  },
                                  {
                                    type: "checkbox",
                                    name: "Checked",
                                    label: "Checked",
                                    changeProp: true,
                                  },
                                ],

                                changeProp: true,
                                "script-props": [
                                  "Autofocus",
                                  "Disabled",
                                  "Required",
                                  "Checked",
                                ],
                              },
                              {
                                tagName: "label",
                                attributes: {
                                  for: ``,
                                },

                                components: [
                                  {
                                    tagName: "p",
                                    type: "text",
                                    editable: true,

                                    style: {
                                      "word-break": "break-all",
                                    },

                                    "style-default": {
                                      "word-break": "break-all",
                                    },

                                    components: {
                                      type: "textnode",
                                      content: `${opt}`,
                                    },
                                  },
                                ],

                                traits: ["id", "for"],
                              },
                            ],
                          };

                          // let inputEle = {
                          //   tagName: "input",
                          //   type: "default", // so that the input component doesn't throw error of 'undefined'

                          //   script: individualCheckboxScript,

                          //   attributes: {
                          //     type: "checkbox",
                          //     // id: `ch-${opt}`,
                          //     name: `ch-${opt}`,
                          //     value: `${opt}`,
                          //   },

                          //   Autofocus: false,
                          //   Disabled: false,
                          //   Required: false,
                          //   Checked: false,

                          //   traits: [
                          //     "id",
                          //     "name",
                          //     "value",
                          //     {
                          //       type: "checkbox",
                          //       name: "Autofocus",
                          //       label: "Autofocus",
                          //       changeProp: true,
                          //     },
                          //     {
                          //       type: "checkbox",
                          //       name: "Disabled",
                          //       label: "Disabled",
                          //       changeProp: true,
                          //     },
                          //     {
                          //       type: "checkbox",
                          //       name: "Required",
                          //       label: "Required",
                          //       changeProp: true,
                          //     },
                          //     {
                          //       type: "checkbox",
                          //       name: "Checked",
                          //       label: "Checked",
                          //       changeProp: true,
                          //     },
                          //   ],

                          //   changeProp: true,
                          //   "script-props": [
                          //     "Autofocus",
                          //     "Disabled",
                          //     "Required",
                          //     "Checked",
                          //   ],
                          // };

                          // let labelEle = {
                          //   tagName: "label",
                          //   attributes: {
                          //     for: ``,
                          //   },

                          //   components: [
                          //     {
                          //       tagName: "p",
                          //       type: "text",
                          //       editable: true,

                          //       components: {
                          //         type: "textnode",
                          //         content: `${opt}`,
                          //       },
                          //     },
                          //   ],

                          //   traits: ["id", "for"],
                          // };

                          // container.append(inputEle);
                          // container.append(labelEle);
                          container.append(groupEle);
                        });
                      }
                    }
                  }

                  // if API response to plot are all key:value pairs of a plain object inside main object
                  else if (
                    !Array.isArray(data) &&
                    !isArrayofObjects(data) &&
                    typeof data === "object"
                  ) {
                    console.log("######");
                    Object.keys(data).forEach((key) => {
                      if (
                        !Array.isArray(data[`${key}`]) &&
                        typeof data[`${key}`] !== "object"
                      ) {
                        let groupEle = {
                          tagName: "span",
                          type: "default",
                          attributes: {
                            class: "group_radio_label",
                          },

                          "style-default": {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          style: {
                            display: "flex",
                            "flex-wrap": "no-wrap",
                            "justify-content": "flex-start",
                            "align-items": "flex-start",
                            width: CommonWidth
                              ? CommonWidth + "%"
                              : "8% !important",
                          },

                          components: [
                            {
                              tagName: "span",
                              type: "radio_input",
                              script: individualRadioScript,

                              attributes: {
                                class: "radio_input",
                              },

                              components: [
                                {
                                  tagName: "input",
                                  type: "default",
                                  attributes: {
                                    type: "radio",
                                    id: `radio_1_${uniqid()}`,
                                    name: `radio_${containerId}`,
                                    value: `${data[`${key}`]}`,
                                  },
                                },
                              ],

                              Autofocus: false,
                              Disabled: false,
                              Required: false,
                              Checked: false,

                              traits: [
                                "id",
                                "name",
                                "value",
                                {
                                  type: "checkbox",
                                  name: "Autofocus",
                                  label: "Autofocus",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Disabled",
                                  label: "Disabled",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Required",
                                  label: "Required",
                                  changeProp: true,
                                },
                                {
                                  type: "checkbox",
                                  name: "Checked",
                                  label: "Checked",
                                  changeProp: true,
                                },
                              ],

                              changeProp: true,
                              "script-props": [
                                "Autofocus",
                                "Disabled",
                                "Required",
                                "Checked",
                              ],
                            },
                            {
                              tagName: "label",
                              attributes: {
                                for: ``,
                              },

                              components: [
                                {
                                  tagName: "p",
                                  type: "text",
                                  editable: true,

                                  style: {
                                    "word-break": "break-all",
                                  },

                                  "style-default": {
                                    "word-break": "break-all",
                                  },

                                  components: {
                                    type: "textnode",
                                    content: `${key}`,
                                  },
                                },
                              ],

                              traits: ["id", "for"],
                            },
                          ],
                        };

                        // let inputEle = {
                        //   tagName: "input",
                        //   type: "default", // so that the input component doesn't throw error of 'undefined'

                        //   script: individualCheckboxScript,

                        //   attributes: {
                        //     type: "checkbox",
                        //     // id: `${data[`${key}`]}`,
                        //     name: `${data[`${key}`]}`,
                        //     value: `${data[`${key}`]}`,
                        //   },

                        //   Autofocus: false,
                        //   Disabled: false,
                        //   Required: false,
                        //   Checked: false,

                        //   traits: [
                        //     "id",
                        //     "name",
                        //     "value",
                        //     {
                        //       type: "checkbox",
                        //       name: "Autofocus",
                        //       label: "Autofocus",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Disabled",
                        //       label: "Disabled",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Required",
                        //       label: "Required",
                        //       changeProp: true,
                        //     },
                        //     {
                        //       type: "checkbox",
                        //       name: "Checked",
                        //       label: "Checked",
                        //       changeProp: true,
                        //     },
                        //   ],

                        //   changeProp: true,
                        //   "script-props": [
                        //     "Autofocus",
                        //     "Disabled",
                        //     "Required",
                        //     "Checked",
                        //   ],
                        // };

                        // let labelEle = {
                        //   tagName: "label",
                        //   attributes: {
                        //     for: ``,
                        //   },

                        //   components: [
                        //     {
                        //       tagName: "p",
                        //       type: "text",
                        //       editable: true,

                        //       components: {
                        //         type: "textnode",
                        //         content: `${key}`,
                        //       },
                        //     },
                        //   ],

                        //   traits: ["id", "for"],
                        // };

                        // container.append(inputEle);
                        // container.append(labelEle);
                        container.append(groupEle);
                      }
                    });
                  }
                }

                // if API response to plot are all key:value pairs of the plain object
                else if (!NestedKeyname && !ArrOfObjKyename) {
                  console.log("#######");
                  container.components("");

                  Object.keys(apiData).forEach((key) => {
                    if (
                      !Array.isArray(apiData[`${key}`]) &&
                      typeof apiData[`${key}`] !== "object"
                    ) {
                      let groupEle = {
                        tagName: "span",
                        type: "default",
                        attributes: {
                          class: "group_radio_label",
                        },

                        "style-default": {
                          display: "flex",
                          "flex-wrap": "no-wrap",
                          "justify-content": "flex-start",
                          "align-items": "flex-start",
                          width: CommonWidth
                            ? CommonWidth + "%"
                            : "8% !important",
                        },

                        style: {
                          display: "flex",
                          "flex-wrap": "no-wrap",
                          "justify-content": "flex-start",
                          "align-items": "flex-start",
                          width: CommonWidth
                            ? CommonWidth + "%"
                            : "8% !important",
                        },

                        components: [
                          {
                            tagName: "span",
                            type: "radio_input",
                            script: individualRadioScript,

                            attributes: {
                              class: "radio_input",
                            },

                            components: [
                              {
                                tagName: "input",
                                type: "default",
                                attributes: {
                                  type: "radio",
                                  id: `radio_1_${uniqid()}`,
                                  name: `radio_${containerId}`,
                                  value: `${apiData[`${key}`]}`,
                                },
                              },
                            ],

                            Autofocus: false,
                            Disabled: false,
                            Required: false,
                            Checked: false,

                            traits: [
                              "id",
                              "name",
                              "value",
                              {
                                type: "checkbox",
                                name: "Autofocus",
                                label: "Autofocus",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Disabled",
                                label: "Disabled",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Required",
                                label: "Required",
                                changeProp: true,
                              },
                              {
                                type: "checkbox",
                                name: "Checked",
                                label: "Checked",
                                changeProp: true,
                              },
                            ],

                            changeProp: true,
                            "script-props": [
                              "Autofocus",
                              "Disabled",
                              "Required",
                              "Checked",
                            ],
                          },
                          {
                            tagName: "label",
                            attributes: {
                              for: ``,
                            },

                            components: [
                              {
                                tagName: "p",
                                type: "text",
                                editable: true,

                                style: {
                                  "word-break": "break-all",
                                },

                                "style-default": {
                                  "word-break": "break-all",
                                },

                                components: {
                                  type: "textnode",
                                  content: `${key}`,
                                },
                              },
                            ],

                            traits: ["id", "for"],
                          },
                        ],
                      };

                      // let inputEle = {
                      //   tagName: "input",
                      //   type: "default", // so that the input component doesn't throw error of 'undefined'

                      //   script: individualCheckboxScript,

                      //   attributes: {
                      //     type: "checkbox",
                      //     // id: `${apiData[`${key}`]}`,
                      //     name: `${apiData[`${key}`]}`,
                      //     value: `${apiData[`${key}`]}`,
                      //   },

                      //   Autofocus: false,
                      //   Disabled: false,
                      //   Required: false,
                      //   Checked: false,

                      //   traits: [
                      //     "id",
                      //     "name",
                      //     "value",
                      //     {
                      //       type: "checkbox",
                      //       name: "Autofocus",
                      //       label: "Autofocus",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Disabled",
                      //       label: "Disabled",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Required",
                      //       label: "Required",
                      //       changeProp: true,
                      //     },
                      //     {
                      //       type: "checkbox",
                      //       name: "Checked",
                      //       label: "Checked",
                      //       changeProp: true,
                      //     },
                      //   ],

                      //   changeProp: true,
                      //   "script-props": [
                      //     "Autofocus",
                      //     "Disabled",
                      //     "Required",
                      //     "Checked",
                      //   ],
                      // };

                      // let labelEle = {
                      //   tagName: "label",
                      //   attributes: {
                      //     for: ``,
                      //   },

                      //   components: [
                      //     {
                      //       tagName: "p",
                      //       type: "text",
                      //       editable: true,

                      //       components: {
                      //         type: "textnode",
                      //         content: `${key}`,
                      //       },
                      //     },
                      //   ],

                      //   traits: ["id", "for"],
                      // };

                      // container.append(inputEle);
                      // container.append(labelEle);
                      container.append(groupEle);
                    }
                  });
                }

                // if there is a 'message' in api response instead of data
                else if (Object.keys(apiData).includes("message")) {
                  console.log("#@@");

                  container.components("");
                  container.components().push({
                    tagName: "span",
                    type: "default",
                    attributes: {
                      class: "group_radio_label",
                    },

                    "style-default": {
                      display: "flex",
                      "flex-wrap": "no-wrap",
                      "justify-content": "flex-start",
                      "align-items": "flex-start",
                    },

                    style: {
                      display: "flex",
                      "flex-wrap": "no-wrap",
                      "justify-content": "flex-start",
                      "align-items": "flex-start",
                    },

                    components: [
                      {
                        tagName: "span",
                        type: "radio_input",

                        attributes: {
                          class: "radio_input",
                        },

                        style: {
                          "margin-right": "5%",
                          display: "none",
                        },

                        "style-default": {
                          "margin-right": "5%",
                          display: "none",
                        },

                        components: [
                          {
                            tagName: "input",
                            type: "default",
                            attributes: {
                              type: "radio",
                              id: `radio_1_${uniqid()}`,
                              name: "radio_1",
                              value: "radio_1",
                            },
                          },
                        ],
                      },
                      {
                        tagName: "label",
                        type: "radio_label",
                        attributes: {
                          for: "",
                        },

                        components: [
                          {
                            tagName: "p",
                            type: "text",
                            editable: true,

                            style: {
                              width: "max-content",
                              "word-break": "break-all",
                            },

                            "style-default": {
                              width: "max-content",
                              "word-break": "break-all",
                            },

                            components: {
                              type: "textnode",
                              content: "No Values.",
                            },
                          },
                        ],

                        traits: ["id", "for"],
                        changeProp: true,
                      },
                    ],
                  });
                }
              }
            }
          },
        },

        view: {
          onRender({ el, model }) {
            if (el.getAttribute("data-gjs-type") === "radio_regular_form") {
              console.log("rendering", el);
              model.handlePropChange();
            }
          },
        },
      });

      // script for input-select
      const dropdownListScript = async function (props) {
        console.log("this element:", this, props);

        // helper function to check if a variable is an array-of-objects or not
        function isArrayofObjects(variable) {
          // Check if the variable is an array
          if (!Array.isArray(variable)) {
            return false;
          }

          // Check if all elements in the array are objects
          for (const element of variable) {
            if (
              typeof element !== "object" ||
              Array.isArray(element) ||
              element === null
            ) {
              return false;
            }
          }
          return true;
        }

        // helper function to get value of a key in nested object
        function findKeyValue(obj, key) {
          if (obj.hasOwnProperty(key)) {
            // If the current object has the key, return its value
            return obj[key];
          }

          for (var prop in obj) {
            if (obj.hasOwnProperty(prop) && typeof obj[prop] === "object") {
              // If the current property is an object, recursively search within it
              var result = findKeyValue(obj[prop], key);
              if (result !== undefined) {
                return result;
              }
            }
          }
          // Key not found in the object
          return undefined;
        }

        const container = this;
        let apiData;

        // to manually populate the dropdown list
        if (props.SetOptionsManually) {
          let options = props.SetOptionsManually.split(",");

          container.innerHTML = "";

          options.forEach((opt) => {
            let option = document.createElement("option");
            option.setAttribute("value", `${opt}`);
            option.innerHTML = opt;

            container.appendChild(option);
          });
        }

        if (props.Autofocus) {
          container.setAttribute("autofocus", true);
        }

        if (props.Multiple) {
          container.setAttribute("multiple", true);
        }

        if (props.Disabled) {
          container.setAttribute("disabled", true);
        }

        if (props.Required) {
          container.setAttribute("required", true);
        }

        if (props.Size) {
          container.setAttribute("size", `${props.Size}`);
        }

        // -------- Getting API Data
        // to use API to populate the dropdown list
        if (
          (props.CustomUrl && !props.BaseUrl) ||
          (props.CustomUrl && props.BaseUrl === "null")
        ) {
          console.log("props.CustomUrl:", props.CustomUrl);
        } else if (props.BaseUrl && !props.CustomUrl) {
          console.log("props.BaseUrl:", props.BaseUrl);
        }

        if (props.API) {
          // if nothing is provided for auth
          if (!props.BearerToken && !props.Username && !props.Password) {
            // add extra headers, if needed
            let config = {
              headers: {},
            };

            if (props.MoreHeaders) {
              // ['a:b', "c:d"]
              // extracting headers from More_Headers trait
              props.MoreHeaders.split(",").forEach((header) => {
                let key, val;
                [key, val] = header.split(":");
                console.log("[key, val]:\n", key, val);

                config.headers[key] = val;
              });
            }

            console.log("config:", config);

            // GET call to get the data
            let response = await fetch(`${props.API}`, config);
            let responseData = await response.json();
            apiData = responseData;
          }

          // if a bearer token is provided but not api_key or usr+pwd
          else if (props.BearerToken && !props.Username && !props.Password) {
            // add extra headers, if needed
            let config = {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${props.BearerToken}`,
              },
            };

            if (props.MoreHeaders) {
              // ['a:b', "c:d"]
              // extracting headers from More_Headers trait
              props.MoreHeaders.split(",").forEach((header) => {
                let key, val;
                [key, val] = header.split(":");
                console.log("[key, val]:\n", key, val);

                config.headers[key] = val;
              });
            }

            console.log("config:", config);

            // GET call to get the data
            let response = await fetch(`${props.API}`, config);
            let responseData = await response.json();
            apiData = responseData;
          }

          // if a bearer token and api_key not provided but usr+pwd are provided
          else if (!props.BearerToken && props.Username && props.Password) {
            // add extra headers, if needed
            let config = {
              headers: {
                Authorization:
                  "Basic " + btoa(props.Username + ":" + props.Password),
              },
            };

            if (props.MoreHeaders) {
              // ['a:b', "c:d"]
              // extracting headers from More_Headers trait
              props.MoreHeaders.split(",").forEach((header) => {
                let key, val;
                [key, val] = header.split(":");
                console.log("[key, val]:\n", key, val);

                config.headers[key] = val;
              });
            }

            console.log("config:", config);

            // GET call to get the data
            let response = await fetch(`${props.API}`, config);
            let responseData = await response.json();
            apiData = responseData;
          }
        }

        console.log("apiData:", apiData);

        // -------- Populating API Data, into the dropdown list
        if (apiData !== undefined) {
          console.log("#");
          // if API response is directly an array-of-objects
          if (isArrayofObjects(apiData)) {
            if (props.ArrOfObjKyename) {
              console.log("##");
              container.innerHTML = "";

              apiData.forEach((opt) => {
                let option = document.createElement("option");
                option.setAttribute(
                  "value",
                  `${opt[`${props.ArrOfObjKyename}`]}`
                );
                option.innerHTML = opt[`${props.ArrOfObjKyename}`];

                container.appendChild(option);
              });
            }
          }

          // if API response is a plain array of single elements
          else if (Array.isArray(apiData) && !isArrayofObjects(apiData)) {
            console.log("###");
            container.innerHTML = "";
            apiData.forEach((opt) => {
              let option = document.createElement("option");
              option.setAttribute("value", `${opt}`);
              option.innerHTML = opt;

              container.appendChild(option);
            });
          }

          // if API response is an object
          else if (!isArrayofObjects(apiData) && typeof apiData === "object") {
            // if API response to plot is a nested array-of-objects inside the main response object
            if (props.NestedKeyname && props.ArrOfObjKyename) {
              console.log("####");
              container.innerHTML = "";

              // find the array-of-objects value
              let data = findKeyValue(apiData, props.NestedKeyname);

              if (isArrayofObjects(data)) {
                data.forEach((opt) => {
                  let option = document.createElement("option");
                  option.setAttribute(
                    "value",
                    `${opt[`${props.ArrOfObjKyename}`]}`
                  );
                  option.innerHTML = opt[`${props.ArrOfObjKyename}`];

                  container.appendChild(option);
                });
              }
            } else if (props.NestedKeyname && !props.ArrOfObjKyename) {
              container.innerHTML = "";

              // find the array value
              let data = findKeyValue(apiData, props.NestedKeyname);

              // if API response to plot is a nested plain array of single elements inside the main response object
              if (Array.isArray(data) && !isArrayofObjects(data)) {
                console.log("#####");
                data.forEach((opt) => {
                  let option = document.createElement("option");
                  option.setAttribute("value", `${opt}`);
                  option.innerHTML = opt;

                  container.appendChild(option);
                });
              }

              // if API response to plot are all key:value pairs of a plain object inside main object
              else if (
                !Array.isArray(data) &&
                !isArrayofObjects(data) &&
                typeof data === "object"
              ) {
                console.log("######");
                Object.keys(data).forEach((key) => {
                  if (
                    !Array.isArray(data[`${key}`]) &&
                    typeof data[`${key}`] !== "object"
                  ) {
                    let option = document.createElement("option");
                    option.setAttribute("value", `${data[`${key}`]}`);
                    option.innerHTML = key;

                    container.appendChild(option);
                  }
                });
              }
            }

            // if API response to plot are all key:value pairs of the plain object
            else if (!props.NestedKeyname && !props.ArrOfObjKyename) {
              console.log("#######");
              container.innerHTML = "";

              Object.keys(apiData).forEach((key) => {
                if (
                  !Array.isArray(apiData[`${key}`]) &&
                  typeof apiData[`${key}`] !== "object"
                ) {
                  let option = document.createElement("option");
                  option.setAttribute("value", `${apiData[`${key}`]}`);
                  option.innerHTML = key;

                  container.appendChild(option);
                }
              });
            }
          }
        }
      };

      editor.DomComponents.addType("rich_text_area", {
        model: {
          defaults: {
            tagName: "div",
            type: "rich_text_area",
            script: function () {
              console.log("this", this);

              console.log("this id:::::::", this.id);

              const initLib = async function (id) {
                try {
                  const container = document.getElementById(id);
                  const quill = new Quill(container, {
                    modules: {
                      toolbar: [
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        ["bold", "italic", "underline", "strike"],
                        [{ list: "bullet" }, { list: "ordered" }],
                        ["link"],
                        [{ align: [] }],
                        [{ color: [] }, { background: [] }],
                      ],
                    },
                    placeholder: "",
                    theme: "snow", // or 'bubble'
                  });

                  quill.on("text-change", () => {
                    const delta = quill.getContents();

                    localStorage.setItem(
                      `redslingRichText_${id}`,
                      JSON.stringify(delta)
                    );
                  });

                  let richTextContent = localStorage.getItem(
                    `redslingRichText_${id}`
                  );
                  if (richTextContent) {
                    quill.setContents(JSON.parse(richTextContent));
                  }
                } catch (e) {
                  console.error(e);
                }
              };

              if (typeof Quill == "undefined") {
                console.log("this undefined case::::::::", this);
                const script = document.createElement("script");
                script.onload = initLib;
                script.src =
                  "https://cdn.jsdelivr.net/npm/quill@2.0.0-rc.2/dist/quill.js";
                document.body.appendChild(script);
              } else {
                console.log("InitLib");
                initLib(this.id);
              }
            },
            attributes: {
              // id: "radio_regular_form",
              class: "rich_text_area",
            },

            content: `<div id="rich_text_area_child"></div>`,

            traits: [],
          },

          // removed() {

          // },
        },
      });

      editor.DomComponents.addType("rich_text_area_container", {
        model: {
          defaults: {
            tagName: "div",
            type: "rich_text_area_container",

            attributes: {
              // id: "radio_regular_form",
              class: "rich_text_area_container",
            },

            components: [
              {
                type: "rich_text_area",
                tagName: "div",
              },
            ],

            traits: [],
          },

          // removed() {

          // },
        },
      });

      editor.DomComponents.addType("input_select", {
        model: {
          defaults: {
            tagName: "span",
            attributes: {
              // id: "input_select_container",
              name: "input_select_container",
              class: "input_select_container",
            },

            components: [
              {
                tagName: "label",
                attributes: {
                  for: "",
                },

                components: [
                  {
                    tagName: "p",
                    type: "text",
                    editable: true,
                    content: "Select an option:",
                  },
                ],

                traits: ["for"],
              },
              {
                tagName: "select",
                // script: dropdownListScript,
                attributes: {
                  // id: "input_select",
                  name: "input_select",
                  class: "input_select",
                },

                components: [
                  {
                    tagName: "option",
                    attributes: {
                      value: "option1",
                    },

                    components: [
                      {
                        tagName: "p",
                        type: "text",
                        editable: true,

                        components: {
                          type: "textnode",
                          content: "Option 1",
                        },
                      },
                    ],
                  },
                  {
                    tagName: "option",
                    attributes: {
                      value: "option2",
                    },

                    components: [
                      {
                        tagName: "p",
                        type: "text",
                        editable: true,

                        components: {
                          type: "textnode",
                          content: "Option 2",
                        },
                      },
                    ],
                  },
                  {
                    tagName: "option",
                    attributes: {
                      value: "option3",
                    },

                    components: [
                      {
                        tagName: "p",
                        type: "text",
                        editable: true,

                        components: {
                          type: "textnode",
                          content: "Option 3",
                        },
                      },
                    ],
                  },
                ],
              },
            ],

            // traits
            SetOptionsManually: "",

            CustomUrl: "",
            BaseUrl: "",
            APIPath: "",
            BearerToken: "",
            Username: "",
            Password: "",
            MoreHeaders: "",
            ArrOfObjKyename: "",
            NestedKeyname: "",

            Autofocus: false,
            Multiple: false,
            Disabled: false,
            Required: false,
            Size: "",

            traits: [
              // "id",
              // "name",
              // "form",
              {
                type: "text",
                name: "SetOptionsManually",
                label: "Set Options Manually",
                placeholder: "Option 1,Option 2,Option 3",
                changeProp: true,
              },
              {
                type: "text",
                name: "CustomUrl",
                label: "Custom URL",
                changeProp: true,
              },
              {
                type: "select",
                name: "BaseUrl",
                label: "Base URL",
                options: [
                  { id: "baseUrl1", name: "Base URL #1" },
                  { id: "baseUrl2", name: "Base URL #2" },
                  { id: "baseUrl3", name: "Base URL #3" },
                  { id: "baseUrl4", name: "Base URL #4" },
                  { id: "baseUrl5", name: "Base URL #5" },
                  { id: "null", name: "No Base URL" },
                ],
                changeProp: true,
              },
              {
                type: "text",
                name: "APIPath",
                label: "API Path",
                placeholder: "Don't start with '/'",
                changeProp: true,
              },
              {
                type: "text",
                name: "BearerToken",
                label: "Bearer Token",
                placeholder: "No bearer token provided",
                changeProp: true,
              },
              {
                type: "text",
                name: "Username",
                label: "Username",
                changeProp: true,
              },
              {
                type: "text",
                name: "Password",
                label: "Password",
                changeProp: true,
              },
              {
                type: "text",
                name: "MoreHeaders",
                label: "More Headers",
                placeholder: "k1:v1,k2:v2,k3:v3,...",
                changeProp: true,
              },
              {
                type: "text",
                name: "ArrOfObjKyename",
                label: "Keyname From Array Of Object",
                placeholder: "[ {k1:v1}, {k1:v2} ]",
                changeProp: true,
              },
              {
                type: "text",
                name: "NestedKeyname",
                label: "Keyname For Nested Structure",
                placeholder: "{ k1: [{...}, {...}] }",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "Autofocus",
                label: "Autofocus",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "Multiple",
                label: "Multiple",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "Disabled",
                label: "Disabled",
                changeProp: true,
              },
              {
                type: "checkbox",
                name: "Required",
                label: "Required",
                changeProp: true,
              },
              {
                type: "number",
                name: "Size",
                label: "Size",
                min: "1",
                changeProp: true,
              },
            ],

            changeProp: true,

            "script-props": [
              "SetOptionsManually",
              "CustomUrl",
              "BaseUrl",
              "APIPath",
              "BearerToken",
              "Username",
              "Password",
              "MoreHeaders",
              "ArrOfObjKyename",
              "NestedKeyname",
              "Multiple",
              "Autofocus",
              "Disabled",
              "Required",
              "Size",
            ],
          },

          init() {
            this.on("change:SetOptionsManually", this.handlePropChange);
            this.on("change:CustomUrl", this.handlePropChange);
            this.on("change:BaseUrl", this.handlePropChange);
            this.on("change:APIPath", this.handlePropChange);
            this.on("change:BearerToken", this.handlePropChange);
            this.on("change:Username", this.handlePropChange);
            this.on("change:Password", this.handlePropChange);
            this.on("change:MoreHeaders", this.handlePropChange);
            this.on("change:ArrOfObjKyename", this.handlePropChange);
            this.on("change:NestedKeyname", this.handlePropChange);
            this.on("change:Multiple", this.handlePropChange);
            this.on("change:Autofocus", this.handlePropChange);
            this.on("change:Disabled", this.handlePropChange);
            this.on("change:Required", this.handlePropChange);
            this.on("change:Size", this.handlePropChange);
          },

          async handlePropChange() {
            const {
              SetOptionsManually,
              CustomUrl,
              BaseUrl,
              APIPath,
              BearerToken,
              Username,
              Password,
              MoreHeaders,
              ArrOfObjKyename,
              NestedKeyname,
              Multiple,
              Autofocus,
              Disabled,
              Required,
              Size,
            } = this.props();
            console.log(
              "this, SetOptionsManually, CustomUrl, BaseUrl, APIPath, BearerToken, Username, Password, MoreHeaders, ArrOfObjKyename, NestedKeyname, Multiple, Autofocus, Disabled, Required, Size",
              this,
              SetOptionsManually,
              APIPath,
              BearerToken,
              Username,
              Password,
              MoreHeaders,
              ArrOfObjKyename,
              NestedKeyname,
              Multiple,
              Autofocus,
              Disabled,
              Required,
              Size
            );
            console.log("baseUrlData", baseUrlData);

            // to rename a variable because API var is getting used in many places in this block scope
            let API;
            if (APIPath) {
              API = APIPath;
            }

            // helper function to check if a variable is an array-of-objects or not
            function isArrayofObjects(variable) {
              // Check if the variable is an array
              if (!Array.isArray(variable)) {
                return false;
              }

              // Check if all elements in the array are objects
              for (const element of variable) {
                if (
                  typeof element !== "object" ||
                  Array.isArray(element) ||
                  element === null
                ) {
                  return false;
                }
              }
              return true;
            }

            // helper function to get value of a key in nested object
            function findKeyValue(obj, key) {
              if (obj.hasOwnProperty(key)) {
                // If the current object has the key, return its value
                return obj[key];
              }

              for (var prop in obj) {
                if (obj.hasOwnProperty(prop) && typeof obj[prop] === "object") {
                  // If the current property is an object, recursively search within it
                  var result = findKeyValue(obj[prop], key);
                  if (result !== undefined) {
                    return result;
                  }
                }
              }
              // Key not found in the object
              return undefined;
            }

            const container = this;
            let apiData;
            console.log("container", container);
            const dropdown = container.find("select.input_select")[0];
            console.log("dropdown", dropdown);

            if (SetOptionsManually) {
              let options = SetOptionsManually.split(",");

              dropdown.components("");

              options.forEach((opt) => {
                let optionEle = {
                  tagName: "option",
                  attributes: {
                    value: `${opt}`,
                  },

                  components: [
                    {
                      tagName: "p",
                      type: "text",
                      editable: true,

                      components: {
                        type: "textnode",
                        content: `${opt}`,
                      },
                    },
                  ],
                };

                dropdown.append(optionEle);
              });
            }
            if (Autofocus) {
              if (dropdown) {
                dropdown.addAttributes({ autofocus: true });
              }
            } else {
              if (dropdown) {
                dropdown.removeAttributes("autofocus");
              }
            }
            if (Multiple) {
              if (dropdown) {
                dropdown.addAttributes({ multiple: true });
              }
            } else {
              if (dropdown) {
                dropdown.removeAttributes("multiple");
              }
            }
            if (Disabled) {
              if (dropdown) {
                dropdown.addAttributes({ disabled: true });
              }
            } else {
              if (dropdown) {
                dropdown.removeAttributes("disabled");
              }
            }
            if (Required) {
              if (dropdown) {
                dropdown.addAttributes({ required: true });
              }
            } else {
              if (dropdown) {
                dropdown.removeAttributes("required");
              }
            }
            if (Size) {
              if (dropdown) {
                dropdown.addAttributes({ size: `${Size}` });
              }
            } else {
              if (dropdown) {
                dropdown.removeAttributes("size");
              }
            }

            // -------- Getting API Data

            // if CustomUrl is provided, use only that
            if (CustomUrl && (!BaseUrl || BaseUrl === "null")) {
              console.log("CustomUrl", CustomUrl);
              // if nothing is provided for auth
              if (!BearerToken && !Username && !Password) {
                // add extra headers, if needed
                let config = {
                  headers: {},
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${CustomUrl}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token is provided but not api_key or usr+pwd
              else if (BearerToken && !Username && !Password) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${BearerToken}`,
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${CustomUrl}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token and api_key not provided but usr+pwd are provided
              else if (!BearerToken && Username && Password) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    Authorization: "Basic " + btoa(Username + ":" + Password),
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${CustomUrl}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }
            }

            // if base url is the choice and provided
            else if (BaseUrl && API && !CustomUrl) {
              // concatenating base url and its remaining part
              let url, baseUrlBearerToken;
              if (BaseUrl === "baseUrl1") {
                url = baseUrl1 + API;
                baseUrlBearerToken = baseUrl1BearerToken;
              } else if (BaseUrl === "baseUrl2") {
                url = baseUrl2 + API;
                baseUrlBearerToken = baseUrl2BearerToken;
              } else if (BaseUrl === "baseUrl3") {
                url = baseUrl3 + API;
                baseUrlBearerToken = baseUrl3BearerToken;
              } else if (BaseUrl === "baseUrl4") {
                url = baseUrl4 + API;
                baseUrlBearerToken = baseUrl4BearerToken;
              } else if (BaseUrl === "baseUrl5") {
                url = baseUrl5 + API;
                baseUrlBearerToken = baseUrl5BearerToken;
              }
              console.log("url, baseUrlBearerToken", url, baseUrlBearerToken);

              // if nothing is provided for auth
              if (
                !BearerToken &&
                !baseUrlBearerToken &&
                !Username &&
                !Password
              ) {
                // add extra headers, if needed
                let config = {
                  headers: {},
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token is provided but not usr+pwd
              else if (BearerToken && !Username && !Password) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${BearerToken}`,
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a baseUrlBearerToken is provided but not Custom Bearer Token and usr+pwd
              else if (
                baseUrlBearerToken &&
                !BearerToken &&
                !Username &&
                !Password
              ) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${baseUrlBearerToken}`,
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config@:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }

              // if a bearer token is not provided but usr+pwd are provided
              else if (!BearerToken && Username && Password) {
                // add extra headers, if needed
                let config = {
                  headers: {
                    Authorization: "Basic " + btoa(Username + ":" + Password),
                  },
                };

                if (MoreHeaders) {
                  // ['a:b', "c:d"]
                  // extracting headers from More_Headers trait
                  MoreHeaders.split(",").forEach((header) => {
                    let key, val;
                    [key, val] = header.split(":");
                    console.log("[key, val]:\n", key, val);

                    config.headers[key] = val;
                  });
                }

                console.log("config:", config);

                try {
                  // GET call to get the data
                  let response = await fetch(`${url}`, config);
                  let responseData = await response.json();
                  apiData = responseData;
                } catch (e) {
                  // statements
                  console.log(e);
                }
              }
            }

            console.log("apiData:", apiData);

            // -------- Populating API Data, into the dropdown list
            if (apiData !== undefined) {
              console.log("#");
              // if API response is directly an array-of-objects
              if (isArrayofObjects(apiData)) {
                if (ArrOfObjKyename) {
                  console.log("##");
                  dropdown.components("");

                  apiData.forEach((opt) => {
                    let optionEle = {
                      tagName: "option",
                      attributes: {
                        value: `${opt[`${ArrOfObjKyename}`]}`,
                        data_db_id: `${opt[`_id`]}`
                          ? `${opt[`_id`]}`
                          : `${opt[`${ArrOfObjKyename}`]}`,
                      },

                      components: [
                        {
                          tagName: "p",
                          type: "text",
                          editable: true,

                          components: {
                            type: "textnode",
                            content: `${opt[`${ArrOfObjKyename}`]}`,
                          },
                        },
                      ],
                    };

                    dropdown.append(optionEle);
                  });
                }
              }

              // if API response is a plain array of single elements
              else if (Array.isArray(apiData) && !isArrayofObjects(apiData)) {
                console.log("###");
                dropdown.components("");

                apiData.forEach((opt) => {
                  let optionEle = {
                    tagName: "option",
                    attributes: {
                      value: `${opt}`,
                    },

                    components: [
                      {
                        tagName: "p",
                        type: "text",
                        editable: true,

                        components: {
                          type: "textnode",
                          content: `${opt}`,
                        },
                      },
                    ],
                  };

                  dropdown.append(optionEle);
                });
              }

              // if API response is an object
              else if (
                !isArrayofObjects(apiData) &&
                typeof apiData === "object"
              ) {
                // if API response to plot is a nested array-of-objects inside the main response object
                if (NestedKeyname && ArrOfObjKyename) {
                  console.log("####");
                  dropdown.components("");

                  // find the array-of-objects value
                  let data = findKeyValue(apiData, NestedKeyname);

                  if (isArrayofObjects(data)) {
                    data.forEach((opt) => {
                      let optionEle = {
                        tagName: "option",
                        attributes: {
                          value: `${opt[`${ArrOfObjKyename}`]}`,
                        },

                        components: [
                          {
                            tagName: "p",
                            type: "text",
                            editable: true,

                            components: {
                              type: "textnode",
                              content: `${opt[`${ArrOfObjKyename}`]}`,
                            },
                          },
                        ],
                      };

                      dropdown.append(optionEle);
                    });
                  }
                } else if (NestedKeyname && !ArrOfObjKyename) {
                  dropdown.components("");

                  // find the array value
                  let data = findKeyValue(apiData, NestedKeyname);

                  // if API response to plot is a nested plain array of single elements inside the main response object
                  if (Array.isArray(data) && !isArrayofObjects(data)) {
                    console.log("#####");
                    data.forEach((opt) => {
                      let optionEle = {
                        tagName: "option",
                        attributes: {
                          value: `${opt}`,
                        },

                        components: [
                          {
                            tagName: "p",
                            type: "text",
                            editable: true,

                            components: {
                              type: "textnode",
                              content: `${opt}`,
                            },
                          },
                        ],
                      };

                      dropdown.append(optionEle);
                    });
                  }

                  // if API response to plot are all key:value pairs of a plain object inside main object
                  else if (
                    !Array.isArray(data) &&
                    !isArrayofObjects(data) &&
                    typeof data === "object"
                  ) {
                    console.log("######");
                    Object.keys(data).forEach((key) => {
                      if (
                        !Array.isArray(data[`${key}`]) &&
                        typeof data[`${key}`] !== "object"
                      ) {
                        let optionEle = {
                          tagName: "option",
                          attributes: {
                            value: `${data[`${key}`]}`,
                          },

                          components: [
                            {
                              tagName: "p",
                              type: "text",
                              editable: true,

                              components: {
                                type: "textnode",
                                content: `${key}`,
                              },
                            },
                          ],
                        };

                        dropdown.append(optionEle);
                      }
                    });
                  }
                }

                // if API response to plot are all key:value pairs of the plain object
                else if (!NestedKeyname && !ArrOfObjKyename) {
                  console.log("#######");
                  dropdown.components("");

                  Object.keys(apiData).forEach((key) => {
                    if (
                      !Array.isArray(apiData[`${key}`]) &&
                      typeof apiData[`${key}`] !== "object"
                    ) {
                      let optionEle = {
                        tagName: "option",
                        attributes: {
                          value: `${apiData[`${key}`]}`,
                        },

                        components: [
                          {
                            tagName: "p",
                            type: "text",
                            editable: true,

                            components: {
                              type: "textnode",
                              content: `${key}`,
                            },
                          },
                        ],
                      };

                      dropdown.append(optionEle);
                    }
                  });
                }
              }
            }
          },
        },

        view: {
          onRender({ el, model }) {
            console.log("el", el, el.tagName);
            if (
              el.getAttribute("data-gjs-type") === "input_select" &&
              (el.tagName === "DIV" || el.tagName === "SPAN")
            ) {
              console.log("rendering", el);
              model.handlePropChange();
            }
          },
        },
      });

      editor.DomComponents.addType("rest-api-display", {
        model: {
          defaults: {
            script: rest_api_displayScript,

            tagName: "rest-api-display",

            REST_API_URL: "",

            Number_of_items: 0,

            Name: "",

            traits: [
              {
                type: "text",

                name: "REST_API_URL",

                changeProp: true,
              },

              {
                type: "number",

                name: "Number_of_items",

                changeProp: true,
              },

              {
                type: "text",

                name: "Name",

                changeProp: true,
              },
            ],

            "script-props": ["REST_API_URL", "Number_of_items", "Name"],

            // tagName: 'div',

            attributes: { title: "Hello" },

            // Can be a string

            components: `

                    <p>Paragraph test</p>

                `,
          },
        },
      });

      editor.DomComponents.addType("rest-api-label", {
        isComponent: (el) =>
          el.tagName === "SECTION" && el.classList.contains("row"),

        extend: "default",

        // extendFn: ['init', 'view'], // array of model functions to extend from `parent-type`

        model: {
          defaults: Object.assign(
            {},
            editor.DomComponents.getType("default").model.prototype.defaults,
            {
              customProp: "custom-value",

              tagName: "section",

              draggable: ".row",

              droppable: true,

              // Add your own custom properties here

              LabelName: "",

              REST_API_URL: "",

              script: rest_api_displayScript,

              Property_Name: "",

              traits: [
                {
                  type: "text",

                  name: "LabelName",

                  changeProp: true,
                },

                {
                  type: "text",

                  name: "Property_Name",

                  changeProp: true,
                },

                {
                  type: "text",

                  name: "REST_API_URL",

                  changeProp: true,
                },
              ],

              "script-props": ["LabelName", "Property_Name", "REST_API_URL"],

              components: `<div class="row"><div class="col"></div></div>`,
            }
          ),
        },

        view: editor.DomComponents.getType("default").view.extend({
          init() {
            // Set the initial style of the component view

            console.log("HEREHRER");

            this.listenTo(this.model, "change:style", this.updateStyle);
          },

          updateStyle() {
            console.log("UPDSTTTTIIIIII....");

            // Update the style of the component view

            this.el.setAttribute("style", this.model.get("style"));
          },
        }),

        // init() {

        // // do something

        // },

        // },

        // model: {

        //     defaults: {

        //         tagName: 'rest-api-label',

        //         Property_Name: '',

        //         traits: [

        //             {

        //                 type: "text",

        //                 name: "Property_Name",

        //                 changeProp: true

        //             }

        //         ],

        //         'script-props': ["Property_Name"],

        //         components: `<div class="rest-api-label" style={{max-width: "100%", min-height: "10%", min-width: "10%"}}> </div>`

        //     }

        // }
      });

      editor.DomComponents.addType("test-multiple", {
        model: {
          defaults: {
            items: ["Item 1", "Item 2", "Item 3"],

            traits: [
              {
                type: "checkbox",

                name: "items",

                changeProp: true,

                value: "Item1",
              },

              {
                type: "checkbox",

                name: "items",

                changeProp: true,

                value: "Item2",
              },

              {
                type: "checkbox",

                name: "items",

                changeProp: true,

                value: "Item3",
              },
            ],
          },
        },

        view: {
          render: function () {
            console.log("EHRJKWEHKJRHE");

            var items = this.model.get("items");

            console.log("ITEMS ---- ", items);

            var html = "<ul>";

            for (var i = 0; i < items.length; i++) {
              html += "<li>" + items[i] + "</li>";
            }

            html += "</ul>";

            this.$el.html(html);

            console.log("HTML _______ ", html);

            return this;
          },
        },
      });

      editor.StyleManager.addType("test-multiple-2", {
        name: "Test Multiple 2",

        properties: [
          {
            name: "Count",

            property: "count",

            type: "integer",
          },
          {
            name: "Text",

            property: "text",
          },
        ],
      });

      // editor component

      editor.DomComponents.addType("helper-editor", {
        model: {
          defaults: {
            tagName: "div",

            traits: [
              // Add traits for configuration if needed
            ],
          },
        },

        view: {
          init() {
            const model = this.model;

            const props = model.getAttributes();

            ReactDOM.render(<PageInModal {...props} />, this.el);
          },

          update() {
            const model = this.model;

            const props = model.getAttributes();

            ReactDOM.render(<PageInModal {...props} />, this.el);
          },

          onRemove() {
            ReactDOM.unmountComponentAtNode(this.el);
          },
        },
      });

      // Text box with auto search and api
      editor.DomComponents.addType("text-box-auto-search", {
        model: {
          defaults: {
            tagName: "div",

            attributes: {
              id: "text-box-auto-search",
            },

            styles: `
            
                                    #text-box-auto-search-container {
            
                                        width: 100%;
            
                                        padding: 0.5em;
            
                                    }
            
                                `,

            components: [
              {
                tagName: "input",

                attributes: {
                  type: "text",

                  placeholder: "Search",

                  name: "text-box-auto-search-input",

                  id: "text-box-auto-search-input",

                  class: "text-box-auto-search-input",
                },

                styles: `
            
                                            .text-box-auto-search-input {
            
                                                width: 100%;
            
                                            }
            
                                        `,

                // traits

                API: "",

                Username: "",

                Password: "",

                API_Key: "",

                Subject_Key: "",

                Nested_Array_Of_Objects: "",

                Nested_Subject_Key: "",

                traits: [
                  {
                    type: "text",

                    name: "API",

                    label: "API",

                    changeProp: true,
                  },
                  {
                    type: "text",

                    name: "Username",

                    label: "Username",

                    changeProp: true,
                  },
                  {
                    type: "text",

                    name: "Password",

                    label: "Password",

                    changeProp: true,
                  },
                  {
                    type: "text",

                    name: "API_Key",

                    label: "API Key",

                    changeProp: true,
                  },
                  {
                    type: "text",

                    name: "Subject_Key", // the seach/filtering will be performed on the value (as array of element) of this key

                    label: "Subject Key",

                    changeProp: true,
                  },
                  {
                    type: "select",

                    name: "Nested_Array_Of_Objects",

                    label: "Nested Array Of Objects",

                    options: [
                      { id: "true", name: "True" },

                      { id: "false", name: "False" },
                    ],

                    changeProp: true,
                  },
                  {
                    type: "text",

                    name: "Nested_Subject_Key",

                    label: "Nested Subject Key",

                    changeProp: true,
                  },
                ],

                "script-props": [
                  "API",
                  "Username",
                  "Password",
                  "API_Key",
                  "Subject_Key",
                  "Nested_Array_Of_Objects",
                  "Nested_Subject_Key",
                ],
              },
            ],
          },
        },

        view: {
          async onRender({ el, model }) {
            let api = model.get("API");

            let username = model.get("Username");

            let password = model.get("Password");

            let apiKey = model.get("API_Key");

            // the seach/filtering will be performed on the value (as array of element) of this key

            let subjectKey = model.get("Subject_Key");

            let nestedSubjectKey = model.get("Nested_Subject_Key");

            let nestedArrayOfObjects = model.get("Nested_Array_Of_Objects");

            console.log(
              "log 1",
              "\nel:",
              el,
              "\napi:",
              api,
              "\nusername:",
              username,
              "\npassword:",
              password,
              "\napiKey:",
              apiKey,
              "\nsubjectKey:",
              subjectKey,
              "\nnestedSubjectKey:",
              nestedSubjectKey,
              "\nnestedArrayOfObjects:",
              nestedArrayOfObjects
            );

            // because onRender will run as many times as there are components in this definition. It will run for every render.

            if (el.id === "text-box-auto-search-input") {
              console.log("inside text-box-auto-search-input");

              // getting the parent component to attact the suggestion box to it

              let parentComponent = this.model.parent().getEl();

              console.log("parentComponent:", parentComponent);

              let apiData;

              // making a get call

              // test - https://datausa.io/api/data?drilldowns=Nation&measures=Population (nested key: data, search: United)

              // test - https://swapi.dev/api/planets/ (nested key: results)

              // test - https://swapi.dev/api/starships/ (nested key: results)

              // when api is provided but nothing else is provided

              if (
                (api !== undefined || api !== "") &&
                (username === undefined || username === "") &&
                (password === undefined || password === "") &&
                (apiKey === undefined || apiKey === "")
              ) {
                let response = await fetch(`${api}`);

                let responseData = await response.json();

                apiData = responseData;

                console.log("responseData:", responseData);
              }

              // when api, username and password is provided but not api key
              else if (
                (api !== undefined || api !== "") &&
                (username !== undefined || username !== "") &&
                (password !== undefined || password !== "") &&
                (apiKey === undefined || apiKey === "")
              ) {
                let token = authenticateUser(username, password);

                console.log("token:", token);

                let config = {
                  Authorization: `${token}`,
                };

                let response = await fetch(`${api}`, {
                  method: "GET",

                  headers: config,
                });

                let responseData = await response.json();

                apiData = responseData;

                console.log("responseData:", responseData);
              }

              // when api and api key is provided but not username and password
              else if (
                (api !== undefined || api !== "") &&
                (username === undefined || username === "") &&
                (password === undefined || password === "") &&
                (apiKey !== undefined || apiKey !== "")
              ) {
                console.log("apiKey:", apiKey);

                let config = {
                  "X-API-KEY": `${apiKey}`,
                };

                let response = await fetch(`${api}`, {
                  method: "GET",

                  headers: config,
                });

                let responseData = await response.json();

                apiData = responseData;

                console.log("responseData:", responseData);
              }

              // when everything is provided
              else if (
                (api !== undefined || api !== "") &&
                (username !== undefined || username !== "") &&
                (password !== undefined || password !== "") &&
                (apiKey !== undefined || apiKey !== "")
              ) {
                let token = authenticateUser(username, password);

                console.log("token:", token, "\napiKey:", apiKey);

                let config = {
                  "X-API-KEY": `${apiKey}`,

                  Authorization: `${token}`,
                };

                let response = await fetch(`${api}`, {
                  method: "GET",

                  headers: config,
                });

                let responseData = await response.json();

                apiData = responseData;

                console.log("responseData:", responseData);
              }

              console.log("apiData:", apiData);

              // creating suggestion box

              let suggestionBox = document.createElement("ul");

              suggestionBox.style.display = "flex";

              suggestionBox.style.flexDirection = "column";

              suggestionBox.style.alignItems = "flex-start";

              suggestionBox.style.justifyContent = "center";

              suggestionBox.style.rowGap = "1em";

              suggestionBox.style.backgroundColor = "white";

              suggestionBox.style.width = "max-content";

              suggestionBox.style.padding = "1em";

              suggestionBox.style.borderRadius = "10px";

              // making a search filter

              el.addEventListener("change", function (event) {
                console.log(
                  "attaching event listener to text-box-auto-search-input"
                );

                let matchValue = this.value;

                console.log("searchBar value:", matchValue);

                // searching for keys

                // let searchedKeys = Object.keys(apiData).filter((key) => key.includes(matchValue));

                // console.log('searchedKeys:', searchedKeys);

                let searchResult;

                // proceed the filtering/searching only if the apiData/response and the subject key is provided

                if (
                  (apiData !== undefined &&
                    (subjectKey !== undefined || subjectKey !== "") &&
                    nestedArrayOfObjects === undefined) ||
                  nestedArrayOfObjects === false
                ) {
                  // first check if the key's value is an array or not at level 1; it should be an array to proceed

                  if (Array.isArray(apiData[subjectKey])) {
                    console.log("it is an array");

                    searchResult =
                      Number(matchValue) === NaN
                        ? apiData[subjectKey].filter((value) =>
                            value.includes(matchValue)
                          )
                        : apiData[subjectKey].filter(
                            (value) => value === matchValue
                          );

                    console.log("searchResult:", searchResult);
                  } else {
                    toast.error(
                      `The value of the key '${subjectKey}' is not an array. Please try another key.`,
                      successTheme
                    );
                  }
                }

                let nestedSearchResult;

                // proceed the filtering/searching only if the apiData/response and the subject key is provided and the response contains a key that is an array of objects

                if (apiData !== undefined && nestedArrayOfObjects) {
                  // check if the parent key and the nested key is provided or not

                  if (nestedSubjectKey !== undefined) {
                    console.log("it is in a nested array of objects");

                    // loop over the nested objects in the array, then, first get the values of each object 1 by 1 and find the match value, if found, push it to the search result

                    apiData[nestedSubjectKey].forEach((element) => {
                      let valuesArray = Object.values(element);

                      console.log("valuesArray:", valuesArray);

                      let matchedResults = valuesArray.filter((val) => {
                        if (typeof val === "string")
                          if (val.includes(matchValue)) return true;
                          else if (typeof val === "number")
                            if (val === matchValue) return true;
                            else return false;
                      });

                      console.log("matchedResults:", matchedResults);

                      nestedSearchResult = matchedResults;
                    });
                  }
                }

                console.log("searchResult:", searchResult);

                console.log("nestedSearchResult:", nestedSearchResult);

                // make that suggestion box only if the search results are present

                if (searchResult !== undefined) {
                  // temporary demo

                  // for (let item = 0; item <= 3; item++) {

                  //     let listItem = document.createElement('li');

                  //     listItem.style.cursor = 'pointer';

                  //     listItem.innerHTML = `${item} abcdef ghi`;

                  //     listItem.addEventListener('click', function() {

                  //         // replace the value with the clicked item

                  //         el.value = item;

                  //     });

                  //     suggestionBox.appendChild(listItem);

                  // }

                  searchResult.forEach((ele) => {
                    let listItem = document.createElement("li");

                    listItem.style.cursor = "pointer";

                    listItem.innerHTML = `${ele}`;

                    listItem.addEventListener("click", function () {
                      // replace the value with the clicked ele

                      el.value = ele;

                      suggestionBox.remove();
                    });

                    suggestionBox.appendChild(listItem);
                  });
                }

                // make a suggestion box only if the nested search results are present

                if (nestedSearchResult !== undefined) {
                  // temporary demo

                  // for (let item = 0; item <= 3; item++) {

                  //     let listItem = document.createElement('li');

                  //     listItem.style.cursor = 'pointer';

                  //     listItem.innerHTML = `${item} abcdef ghi`;

                  //     listItem.addEventListener('click', function() {

                  //         // replace the value with the clicked item

                  //         el.value = item;

                  //     });

                  //     suggestionBox2.appendChild(listItem);

                  // }

                  nestedSearchResult.forEach((ele) => {
                    let listItem = document.createElement("li");

                    listItem.style.cursor = "pointer";

                    listItem.innerHTML = `${ele}`;

                    listItem.addEventListener("click", function () {
                      // replace the value with the clicked ele

                      el.value = ele;

                      suggestionBox.remove();
                    });

                    suggestionBox.appendChild(listItem);
                  });
                }

                // append the suggestionBox it only when the user inputs into the search bar

                parentComponent.appendChild(suggestionBox);
              });
            }
          },
        },
      });

      // editor.getSelected().append({ type: 'dataGrid' })

      editor.DomComponents.addType("progress-bar-height1px", {
        model: {
          defaults: {
            tagName: "div",
            attributes: {
              class: "progress",
              style: "height: 1px;",
            },

            components: [
              {
                tagName: "div",
                attributes: {
                  class: "progress-bar",
                  role: "progressbar",
                  style: "width: 25%;",
                  "aria-label": "1px High",
                  "aria-valuenow": "25",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100",
                },

                // traits
                traits: [
                  {
                    type: "text",
                    name: "aria-valuenow",
                    label: "Aria Value Now",
                    changeProp: true,
                  },
                  {
                    type: "text",
                    name: "aria-valuemin",
                    label: "Aria Value Min",
                    changeProp: true,
                  },
                  {
                    type: "text",
                    name: "aria-valuemax",
                    label: "Aria Value Max",
                    changeProp: true,
                  },
                ],

                changeProp: true,

                "script-props": [
                  "aria-valuenow",
                  "aria-valuemin",
                  "aria-valuemax",
                ],
              },
            ],
          },
        },
      });

      editor.DomComponents.addType("ion-toggle-menu", {
        model: {
          defaults: {
            tagName: "div",
            attributes: {
              class: "ion-toggle-menu",
              id: "ion-toggle-menu",
            },

            components: [
              {
                tagName: "ion-menu",
                attributes: {
                  "content-id": "main-content",
                },

                components: [
                  {
                    tagName: "ion-header",

                    components: [
                      {
                        tagName: "ion-toolbar",

                        components: [
                          {
                            tagName: "ion-title",
                            content: "Menu Content",
                          },
                        ],
                      },
                    ],
                  },
                  {
                    tagName: "ion-content",
                    attributes: {
                      class: "ion-padding",
                    },

                    components: [
                      {
                        tagName: "ion-menu-toggle",

                        components: [
                          {
                            tagName: "ion-button",
                            content: "toggle off",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                tagName: "div",
                attributes: {
                  class: "ion-page",
                  id: "main-content",
                },

                components: [
                  {
                    tagName: "ion-header",

                    components: [
                      {
                        tagName: "ion-toolbar",

                        components: [
                          {
                            tagName: "ion-title",
                            content: "menu",
                          },
                        ],
                      },
                    ],
                  },
                  {
                    tagName: "ion-content",
                    attributes: {
                      class: "ion-padding",
                    },

                    components: [
                      {
                        tagName: "ion-menu-toggle",

                        components: [
                          {
                            tagName: "ion-button",
                            content: "Toggle Open",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        },
      });

      const offConvasMenuBtnScript = function (props) {
        if (props.Data_Bs_Toggle) {
          this.getElementsByClassName("offcanvas-menu-btn")[0].setAttribute(
            "data-bs-toggle",
            `${props.Data_Bs_Toggle}`
          );
        }

        if (props.Data_Bs_Target) {
          this.getElementsByClassName("offcanvas-menu-btn")[0].setAttribute(
            "data-bs-target",
            `${props.Data_Bs_Target}`
          );
        }

        if (props.Aria_Controls) {
          this.getElementsByClassName("offcanvas-menu-btn")[0].setAttribute(
            "aria-controls",
            `${props.Aria_Controls}`
          );
        }
      };

      // dependent on type: ion-toggle-menu
      editor.DomComponents.addType("offcanvas-menu-btn-container", {
        model: {
          defaults: {
            tagName: "span",
            type: "offcanvas-menu-btn-container",
            script: offConvasMenuBtnScript,
            attributes: {
              class: "offcanvas-menu-btn-container",
            },

            components: [
              {
                tagName: "button",
                type: "offcanvas-menu-btn",
                attributes: {
                  // type: "button",
                  class: "offcanvas-menu-btn",
                  "data-bs-toggle": "offcanvas",
                  "data-bs-target": "#offcanvasExample",
                  "aria-controls": "offcanvasExample",
                },

                styles: `
                  .offcanvas-menu-btn {
                    padding: 0.5em;
                    width: max-content;
                    border-radius: 10px;
                  }
                `,

                components: [
                  {
                    tagName: "p",
                    type: "text",
                    editable: true,

                    components: {
                      type: "textnode",
                      content: "Toggle Menu",
                    },
                  },
                ],
              },
            ],

            // traits
            Data_Bs_Toggle: "offcanvas",
            Data_Bs_Target: "#offcanvasExample",
            Aria_Controls: "offcanvasExample",

            traits: [
              {
                type: "text",
                name: "Data_Bs_Toggle",
                label: "data-bs-toggle",
                changeProp: true,
              },
              {
                type: "text",
                name: "Data_Bs_Target",
                label: "data-bs-target",
                changeProp: true,
              },
              {
                type: "text",
                name: "Aria_Controls",
                label: "aria-controls",
                changeProp: true,
              },
            ],

            changeProp: true,

            "script-props": [
              "Data_Bs_Toggle",
              "Data_Bs_Target",
              "Aria_Controls",
            ],
          },
        },

        // view: {
        //   tagName: "button",

        //   init({ model }) {
        //     // to attach event listener on initialization
        //     this.listenTo(
        //       model,
        //       "change:Data_Bs_Toggle",
        //       this.handleDataBsToggleTrait
        //     );
        //     this.listenTo(
        //       model,
        //       "change:Data_Bs_Target",
        //       this.handleDataBsTargetTrait
        //     );
        //     this.listenTo(
        //       model,
        //       "change:Aria_Controls",
        //       this.handleAriaControlsTrait
        //     );
        //   },

        //   handleDataBsToggleTrait() {
        //     const dataBsToggle = this.model.get("Data_Bs_Toggle");
        //     console.log("dataBsToggle:", dataBsToggle);

        //     // let parentComponent = this.model.parent().getEl();
        //     let button = this.model;

        //     button.setAttributes({ "data-bs-toggle": dataBsToggle });

        //     console.log("button:", button);
        //   },

        //   handleDataBsTargetTrait() {
        //     const dataBsTarget = this.model.get("Data_Bs_Target");
        //     console.log("dataBsTarget:", dataBsTarget);

        //     // let parentComponent = this.model.parent().getEl();
        //     let button = this.model;

        //     button.setAttributes({ "data-bs-target": dataBsTarget });

        //     console.log("button:", button);
        //   },

        //   handleAriaControlsTrait() {
        //     const ariaControls = this.model.get("Aria_Controls");
        //     console.log("ariaControls:", ariaControls);

        //     // let parentComponent = this.model.parent().getEl();
        //     let button = this.model;

        //     button.setAttributes({ "aria-controls": ariaControls });

        //     console.log("button:", button);
        //   },
        // },
      });

      const offConvasMenuScript = function (props) {
        if (props.Offcanvas_Direction) {
          this.setAttribute("class", `offcanvas ${props.Offcanvas_Direction}`);
        }
      };

      editor.DomComponents.addType("offcanvas-menu", {
        model: {
          defaults: {
            tagName: "div",
            type: "offcanvas-menu",
            script: offConvasMenuScript,
            attributes: {
              class: "offcanvas offcanvas-start",
              tabindex: "-1",
              id: "offcanvasExample",
              "aria-labelledby": "offcanvasExampleLabel",
            },

            // traits
            Offcanvas_Direction: "",

            traits: [
              "id",
              "aria-labelledby",
              {
                type: "select",
                name: "Offcanvas_Direction",
                label: "Offcanvas Direction",
                options: [
                  { id: "offcanvas-start", name: "Start" },
                  { id: "offcanvas-end", name: "End" },
                ],
                changeProp: true,
              },
            ],

            changeProp: true,

            "script-props": ["Offcanvas_Direction"],

            components: [
              {
                tagName: "div",
                type: "offcanvas-header",
                attributes: {
                  class: "offcanvas-header",
                },

                components: [
                  {
                    tagName: "h5",
                    type: "offcanvas-title",
                    attributes: {
                      class: "offcanvas-title",
                      id: "offcanvasExampleLabel",
                    },

                    components: {
                      tagName: "p",
                      type: "text",
                      editable: true,

                      components: {
                        type: "textnode",
                        content: "Menu Title",
                      },
                    },
                  },
                  {
                    tagName: "button",
                    type: "offcanvas-close-btn",
                    attributes: {
                      class: "btn-close",
                      "data-bs-dismiss": "offcanvas",
                      "aria-label": "Close",
                    },
                  },
                ],
              },
              {
                tagName: "div",
                type: "offcanvas-body",
                attributes: {
                  class: "offcanvas-body",
                },

                components: [
                  {
                    tagName: "div",

                    components: {
                      tagName: "p",
                      type: "text",
                      editable: true,

                      components: {
                        type: "textnode",
                        content:
                          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec nisl est, volutpat non elit ac, viverra laoreet mauris. In cursus a eros vel pulvinar.",
                      },
                    },
                  },
                ],
              },
            ],
          },
        },

        // view: {
        //   init({ model }) {
        //     // to attach event listener on initialization
        //     this.listenTo(
        //       model,
        //       "change:Offcanvas_Direction",
        //       this.handleOffcanvasDirectionTrait
        //     );
        //   },

        //   handleOffcanvasDirectionTrait() {
        //     const offcanvasDirection = this.model.get("Offcanvas_Direction");
        //     console.log("offcanvasDirection:", offcanvasDirection);

        //     // let parentComponent = this.model.parent().getEl();
        //     let menuDiv = this.model;

        //     menuDiv.setAttributes({
        //       class: "offcanvas" + " " + offcanvasDirection,
        //     });

        //     console.log("menuDiv:", menuDiv);
        //   },
        // },
      });

      // Bootstrap Tabs
      // how to use it - drop and create as many panels as you want. then go into traits of each button and give them data-bs--targets and aria-controls to #pill-home-1, 2, 3,... and then when the tab-contents open on clicking the button, change their IDs from traits to whatever you want and give those IDs to menu buttons as well again.
      editor.DomComponents.addType("button-tabs-btn-container", {
        model: {
          defaults: {
            tagName: "div",
            type: "button-tabs-btn-container",
            attributes: {
              class: "button-tabs-btn-container",
            },

            "style-default": {
              padding: "0.5em",
            },

            style: {
              padding: "0.5em",
            },

            components: [
              {
                tagName: "button",
                type: "button-tabs-btn",
                attributes: {
                  class: "nav-link",
                  "data-bs-toggle": "pill",
                  "data-bs-target": "#pills-home",
                  "aria-controls": "#pills-home",
                  role: "tab",
                },

                components: {
                  tagName: "p",
                  type: "text",
                  editable: true,

                  components: {
                    type: "textnode",
                    content: "Tab Button",
                  },
                },
              },
            ],

            // traits
            Data_Bs_Target: "#pills-home",
            Aria_Controls: "#pills-home",

            traits: [
              {
                type: "text",
                name: "Data_Bs_Target",
                label: "(Target's ID) data-bs-target",
                changeProp: true,
              },
              {
                type: "text",
                name: "Aria_Controls",
                label: "(Control's ID) aria-controls",
                changeProp: true,
              },
            ],

            changeProp: true,
            "script-props": ["Data_Bs_Target", "Aria_Controls"],
          },

          init() {
            this.on("change:Data_Bs_Target", this.handlePropChange);
            this.on("change:Aria_Controls", this.handlePropChange);
          },

          handlePropChange() {
            let { Data_Bs_Target, Aria_Controls } = this.props();
            console.log(
              "Data_Bs_Target, Aria_Controls",
              Data_Bs_Target,
              Aria_Controls
            );

            let btn = this.find("button.nav-link")[0];

            if (Data_Bs_Target) {
              btn.attributes.attributes["data-bs-target"] = Data_Bs_Target;
            }

            if (Data_Bs_Target) {
              btn.attributes.attributes["aria-controls"] = Aria_Controls;
            }

            console.log("btn", btn);
          },
        },
      });

      editor.DomComponents.addType("button-tabs-tab-content-panel", {
        model: {
          defaults: {
            tagName: "div",
            type: "button-tabs-tab-content-panel",
            attributes: {
              id: "pills-home",
              class: "tab-pane fade",
              role: "tabpanel",
              "aria-labelledby": "pills-home-tab",
              tabindex: "0",
            },

            "style-default": {
              padding: "0.5em",
            },

            style: {
              padding: "0.5em",
            },

            content:
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent pretium mi ut lacinia vehicula. In faucibus rutrum lorem, eu sagittis nibh dignissim non. Sed convallis tempus urna eu elementum. Quisque congue tempor tellus, hendrerit tempor nibh rhoncus non. Phasellus tincidunt orci a arcu porta maximus. Pellentesque lacinia lacus at euismod molestie. Aenean ut nulla bibendum, viverra tortor lobortis, gravida arcu.",

            traits: ["id"],
            changeProp: true,
          },
        },
      });

      editor.DomComponents.addType("button-tabs", {
        model: {
          defaults: {
            tagName: "div",
            type: "button-tabs",
            attributes: {
              class: "button-tabs",
            },

            components: [
              {
                tagName: "ul",
                type: "button-tabs-ul",
                attributes: {
                  class: "nav nav-pills mb-3",
                  // id: "pills-tab",
                  role: "tablist",
                },

                components: [
                  {
                    tagName: "li",
                    type: "button-tabs-ul-li",
                    attributes: {
                      class: "nav-item",
                      role: "presentation",
                    },

                    components: [
                      {
                        type: "button-tabs-btn-container",
                      },
                    ],
                  },
                ],
              },
              {
                tagName: "div",
                type: "button-tabs-tab-content",
                attributes: {
                  class: "tab-content",
                  // id: "pills-tabContent",
                },

                components: [
                  {
                    type: "button-tabs-tab-content-panel",
                  },
                ],
              },
            ],

            // traits
            AddTabs: 0,

            traits: [
              {
                type: "number",
                name: "AddTabs",
                label: "Add tabs",
                placeholder: "how many more",
                min: "0",
                changeProp: true,
              },
            ],

            changeProp: true,
            "script-props": ["AddTabs"],
          },

          init() {
            this.on("change:AddTabs", this.handlePropChange);
          },

          handlePropChange() {
            let { AddTabs } = this.props();
            console.log("AddTabs", AddTabs);

            let navItem = this.find(".nav-item")[0];
            let tabContent = this.find(".tab-content")[0];

            // adding more tabs and panels as required
            for (let i = 0; i < AddTabs; i++) {
              navItem.append({
                type: "button-tabs-btn-container",
              });

              tabContent.append({
                type: "button-tabs-tab-content-panel",
              });
            }
          },
        },
      });

      editor.DomComponents.addType("anchor", {
        model: {
          defaults: {
            tagName: "a",

            attributes: {
              href: "#",
            },

            // traits
            href: "#",

            traits: [
              {
                name: "href",
                label: "href",
                placeholder: "Hyperlink reference",
                changeProp: true,
              },
            ],

            changeProp: true,

            components: {
              tagName: "p",
              type: "text",
              editable: true,

              components: {
                type: "textnode",
                content: "Link",
              },
            },
          },
        },

        view: {
          init({ model }) {
            // to attach event listener on initialization
            this.listenTo(model, "change:href", this.handleHrefTrait);
          },

          handleHrefTrait() {
            const href = this.model.get("href");
            console.log("href:", href);

            // let parentComponent = this.model.parent().getEl();
            let anchor = this.model;

            anchor.setAttributes({
              href: href,
            });

            console.log("anchor:", anchor);
          },
        },
      });

      // NAV-BAR
      editor.DomComponents.addType("nav-bar", {
        model: {
          defaults: {
            tagName: "nav",
            attributes: {
              class: "nav-bar",
              id: "nav-bar",
            },

            components: [
              {
                type: "anchor",
              },
              {
                tagName: "a",
                attributes: {
                  href: "#",
                },

                // traits
                href: "#",

                traits: [
                  {
                    name: "href",
                    label: "href",
                    placeholder: "Hyperlink reference",
                    changeProp: true,
                  },
                ],

                changeProp: true,

                components: {
                  tagName: "p",
                  type: "text",
                  editable: true,

                  components: {
                    type: "textnode",
                    content: "Contact us",
                  },
                },
              },
            ],
          },
        },
      });

      const dropdownItemScript = function (props) {
        console.log("this, props", this, props);
        let project_id = props.projectId;

        if (
          props.Navigate &&
          props.InternalTarget &&
          (!props.ExternalTarget || props.ExternalTarget === "#")
        ) {
          this.onclick = function (event) {
            console.log("props.InternalTarget", props.InternalTarget);

            const origin = window.location.origin;

            if (window.location.href.includes("/large_preview")) {
              window.top.location.href =
                origin + "/large_preview/" + `${props.InternalTarget}`;
            } else if (window.top.location.href.includes("/editor")) {
              window.top.location.href =
                origin +
                `/editor/` +
                `${props.InternalTarget}` +
                "?projectId=" +
                `${project_id}`;
            } else {
              window.top.location.href = `{{HOST_URL}}/${props.InternalTarget}.html`;
            }
          };
        } else if (
          props.Navigate &&
          props.ExternalTarget &&
          !props.InternalTarget
        ) {
          this.onclick = function (event) {
            console.log("props.ExternalTarget", props.ExternalTarget);

            let origin = "https://";
            let modifiedUrl =
              props.ExternalTarget.includes("http://") ||
              props.ExternalTarget.includes("https://")
                ? props.ExternalTarget
                : origin + `${props.ExternalTarget}`;
            console.log("modifiedUrl:", modifiedUrl);
            let win = window.open(modifiedUrl, "_blank");
            if (win) {
              win.focus();
            }
          };
        }
      };

      editor.DomComponents.addType("dropdown-item", {
        model: {
          defaults: {
            tagName: "a",
            type: "dropdown-item",
            script: dropdownItemScript,
            type: "link",
            attributes: {
              class: "dropdown-item",
            },

            "style-default": {
              padding: "0.5em",
              cursor: "pointer",
            },

            style: {
              padding: "0.5em",
              cursor: "pointer",
            },

            components: {
              tagName: "p",
              type: "text",
              editable: true,

              components: {
                type: "textnode",
                content: "Menu Item",
              },
            },

            Navigate: false,
            ExternalTarget: "#",
            InternalTarget: "",
            // pageByProjectData: pageByProjectData ? pageByProjectData : "",
            projectId: localStorage.getItem("project_id")
              ? localStorage.getItem("project_id")
              : "",

            traits: [
              {
                type: "select",
                name: "Navigate",
                label: "Navigate",
                options: [
                  { id: "true", value: true, name: "True" },
                  { id: "false", value: false, name: "False" },
                ],
                changeProp: true,
              },
              {
                type: "text",
                name: "ExternalTarget",
                label: "External Target",
                placeholder: "http(s)://www.example.com/",
                changeProp: true,
              },
              {
                type: "select",
                name: "InternalTarget",
                label: "Internal Target",
                changeProp: true,
                options: pageByProjectData
                  ? pageByProjectData?.map((x) => {
                      const arr = {
                        value: x._id,
                        name: x.name,
                      };
                      return arr;
                    })
                  : "",
              },
            ],

            "script-props": [
              "Navigate",
              "ExternalTarget",
              "InternalTarget",
              "projectId",
            ],
          },
        },
      });

      const dropdownDDScript = function () {
        console.log("this", this);

        let button = this.getElementsByClassName("dropdown-dd-btn")[0];
        let itemContainer = this.getElementsByClassName(
          "dropdown-item-container"
        )[0];

        // on click, the dropdown-item-container should appear and again on click, it should disappear
        // button.addEventListener("click", function (event) {
        //   // itemContainer.classList.toggle('toggle-dropdown-item-container');
        //   itemContainer.style.display =
        //     itemContainer.style.display === "none" ? "inline" : "none";
        // });

        button.onclick = function (event) {
          // console.log('@@clicked', window.getComputedStyle(itemContainer).display);
          // itemContainer.classList.toggle('toggle-dropdown-item-container');
          // itemContainer.style.display =
          //   itemContainer.style.display === "none" ? "inline" : "none";
          
          itemContainer.style.display = window.getComputedStyle(itemContainer).display === "none" ? "inline" : "none";
        };

        // if (props.Expand) {
        //   itemContainer.style.display = 'block';
        // }

        // if (!props.Expand) {
        //   itemContainer.style.display = 'none';
        // }

        // if (props.Direction === 'top') {
        //   itemContainer.style.top = 'auto';
        //   itemContainer.style.bottom = '105%';
        //   itemContainer.style.left = '0';
        //   itemContainer.style.right = 'auto';
        //   itemContainer.style.position = 'absolute';
        // }

        // if (props.Direction === 'right') {
        //   itemContainer.style.top = '0';
        //   itemContainer.style.bottom = 'auto';
        //   itemContainer.style.left = '105%';
        //   itemContainer.style.right = 'auto';
        //   itemContainer.style.position = 'absolute';
        // }

        // if (props.Direction === 'bottom') {
        //   itemContainer.style.top = '105%';
        //   itemContainer.style.bottom = 'auto';
        //   itemContainer.style.left = '0';
        //   itemContainer.style.right = 'auto';
        //   itemContainer.style.position = 'absolute';
        // }

        // if (props.Direction === 'left') {
        //   itemContainer.style.top = '0';
        //   itemContainer.style.bottom = 'auto';
        //   itemContainer.style.left = 'auto';
        //   itemContainer.style.right = '105%';
        //   itemContainer.style.position = 'absolute';
        // }
      };

      editor.DomComponents.addType("directional-dd", {
        model: {
          defaults: {
            tagName: "div",
            type: "directional-dd",
            script: dropdownDDScript,
            attributes: {
              class: "dropdown-dd",
            },

            "style-default": {
              width: "max-content",
              padding: "0.5em",
              position: "relative",
            },

            style: {
              width: "max-content",
              padding: "0.5em",
              position: "relative",
            },

            components: [
              {
                tagName: "button",
                type: "dropdown-dd-btn",
                attributes: {
                  class: "dropdown-dd-btn",
                },

                "style-default": {
                  width: "15vw",
                  padding: "0.5em",
                  cursor: "pointer",
                },

                style: {
                  width: "15vw",
                  padding: "0.5em",
                  cursor: "pointer",
                },

                components: {
                  tagName: "p",
                  type: "text",
                  editable: true,

                  components: {
                    type: "textnode",
                    content: "Menu Button",
                  },
                },
              },
              {
                tagName: "div",
                type: "dropdown-item-container",
                attributes: {
                  class: "dropdown-item-container",
                },

                "style-default": {
                  display: "none",
                  padding: "0.5em",
                  width: "15vw",
                  position: "absolute !important",
                  top: "105%",
                  left: "0",
                  "border-radius": "10px",
                  "background-color": "white !important",
                  border: "1px solid gray",
                },

                style: {
                  display: "none",
                  padding: "0.5em",
                  width: "15vw",
                  position: "absolute !important",
                  top: "105%",
                  left: "0",
                  "border-radius": "10px",
                  "background-color": "white !important",
                  border: "1px solid gray",
                },

                components: [
                  {
                    type: "dropdown-item",
                  },
                  {
                    type: "dropdown-item",
                  },
                  {
                    type: "dropdown-item",
                  },
                ],
              },
            ],

            // traits
            // Expand: "",
            // Direction: "",

            // traits: [
            //   {
            //     type: "select",
            //     name: "Expand",
            //     label: "Expand",
            //     options: [
            //       { id: "true", value: true, name: "True" },
            //       { id: "false", value: false, name: "False" },
            //     ],
            //     changeProp: true,
            //   },
            //   {
            //     type: "select",
            //     name: "Direction",
            //     label: "Direction",
            //     options: [
            //       { id: "top", value: "top", name: "Top" },
            //       { id: "right", value: "right", name: "Right" },
            //       { id: "bottom", value: "bottom", name: "Bottom" },
            //       { id: "left", value: "left", name: "Left" },
            //     ],
            //     changeProp: true,
            //   },
            // ],

            // "script-props": ["Expand", "Direction"],
            changeProp: true,
          },
        },
      });
    }
  };

  const createDynamicForm = (editor) => {
    let table_name = tableName;
    console.log("table_name123", table_name);
    const uniqueId = uniqid("ft-");
    let submitBtn = uniqid("submit-");
    const mainDiv = document.createElement("div");
    mainDiv.style.display = "flex";
    mainDiv.style.justifyContent = "center";
    mainDiv.style.alignItems = "center";
    mainDiv.style.padding = "0.5em";
    mainDiv.style.width = "fit-content";
    mainDiv.setAttribute("id", uniqueId);

    const wrapperDiv = document.createElement("div");
    wrapperDiv.style.width = "100%";
    wrapperDiv.style.display = "flex";
    wrapperDiv.style.alignItems = "center";
    wrapperDiv.style.justifyContent = "center";
    wrapperDiv.style.flexDirection = "column";
    wrapperDiv.style.border = "1px solid #ccc";
    wrapperDiv.style.borderRadius = "5px";
    wrapperDiv.style.boxShadow = "0px 0px 5px #ccc";
    const paraTag = document.createElement("p");
    paraTag.innerHTML = `${table_name} Form`;
    paraTag.style.textAlign = "center";
    paraTag.style.fontSize = "1.5rem";
    paraTag.style.fontWeight = "600";
    paraTag.style.marginBottom = "20px";
    wrapperDiv.appendChild(paraTag);

    // for storing the user inputs

    if (dynamicFormData) {
      for (let i of dynamicFormData?.fields) {
        console.log("iiiiiiiiiiiiii", typeof i);
        console.log("iiiiiiiiiiiiii2", i);
        let row = document.createElement("div");
        let innerDiv = document.createElement("div");
        row.style.display = "flex";
        row.style.flexDirection = "column";
        row.style.alignItems = "center";
        row.style.justifyContent = "center";
        row.style.width = "100%";
        innerDiv.style.display = "flex";
        innerDiv.style.width = "100%";
        innerDiv.style.alignItems = "center";
        innerDiv.style.justifyContent = "space-between";
        innerDiv.style.padding = "0px 12px";

        let fieldName = document.createElement("label");
        fieldName.innerHTML += `${i.field_name}`;

        innerDiv.appendChild(fieldName);
        let fieldId = uniqid(`${i.field_name}-`);

        if (i.field_type !== "Reference") {
          // Only add UI elements for non-Reference fields
          if (i.field_type === "Boolean") {
            let fieldType = document.createElement("div");
            fieldType.innerHTML = `
                        <p id="${i.field_name}">
                          <ion-checkbox  id="${fieldId}" name="${i.field_name}"></ion-checkbox>
                        </p>
                      `;
            innerDiv.appendChild(fieldType);
          } else if (i.field_type === "String") {
            let fieldType = document.createElement("input");
            fieldType.setAttribute("id", fieldId);
            fieldType.style.margin = "0 0.5rem 0 0";
            fieldType.setAttribute("type", "text");
            fieldType.setAttribute("name", i.field_name);
            innerDiv.appendChild(fieldType);
          } else if (i.field_type === "Number") {
            console.log("inside NUMBER field type");
            let fieldType = document.createElement("input");
            fieldType.setAttribute("id", fieldId);
            fieldType.style.margin = "0 0.5rem 0 0";
            fieldType.setAttribute("type", "text");
            fieldType.setAttribute("name", i.field_name);
            innerDiv.appendChild(fieldType);
          } else if (i.field_type === "Date-Time") {
            let fieldType = document.createElement("div");
            fieldType.setAttribute("id", fieldId);
            let calenderId = uniqid("calender-");
            let dateId = uniqid("dateId-");
            let dateId1 = uniqid("dateId1-");
            fieldType.innerHTML = `
                        <p id="${i.field_name}">
                          <ion-item>
                            <ion-input id="${dateId}" class="ion-text-end"></ion-input>
                            <ion-popover trigger="${dateId}" size="cover" id="${i.field_name}">
                              <ion-datetime id="${calenderId}" name="${i.field_name}"></ion-datetime>
                            </ion-popover>
                          </ion-item>
                        </p>
                                  
                        <script type="text/javascript">
                          document.querySelector('#${calenderId}').addEventListener('ionChange', (event) => {
                            const selectedDate = event.detail.value;
                            const newUtc = new Date(selectedDate);
                            var date = new Date(newUtc),
                              mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                              day = ("0" + date.getDate()).slice(-2);
                            const finalDate = [date.getFullYear(), mnth, day].join("-");
                            document.querySelector('#${dateId}').innerHTML = finalDate;
                          });
                        </script>
                      `;
            innerDiv.appendChild(fieldType);
          } else if (i.field_type === "File") {
            let fieldType = document.createElement("div");
            fieldType.setAttribute("id", fieldId);
            let ionInputId = uniqid(`file-`);
            let ionBtnId = uniqid(`IonBtn-`);

            fieldType.innerHTML = `
                        <p>
                          <ion-item>
                            <label id="${ionBtnId}" for="${ionInputId}" >Browse Files</label>
                            <input type="file" id="${ionInputId}" style="display:none;">
                          </ion-item>
                        </p>
                      `;

            fieldType.addEventListener("change", (e) => {
              let file = e.target.files[0];
              if (file) {
                let reader = new FileReader();
                reader.onload = function (e) {
                  let uploadedFile = e.target.result;
                  console.log(uploadedFile);
                };
                reader.readAsDataURL(file);
              }
            });

            innerDiv.appendChild(fieldType);
          } else {
            let fieldType = document.createElement("div");
            fieldType.setAttribute("id", fieldId);
            let ionSelectId = uniqid("select-");
            let selectOptions = Object.values(i)
              .map(
                (option) =>
                  `<ion-select-option value="${option}">${option}</ion-select-option>`
              )
              .join("");

            fieldType.innerHTML = `
                        <p>
                          <ion-item>
                            <ion-select id="${ionSelectId}" placeholder="${i.field_name}">
                              ${selectOptions}
                            </ion-select>
                          </ion-item>
                        </p>
                      `;

            innerDiv.appendChild(fieldType);
          }
        } else {
          let fieldType = document.createElement("div");
          fieldType.setAttribute("id", fieldId);

          // Example array of objects

          // Create the select element
          let selectElement = document.createElement("select");
          selectElement.setAttribute("id", `select-${fieldId}`);
          console.log("formData===========>", formData);

          // Create and add options to the select element

          formData.forEach((obj) => {
            Object.keys(obj).forEach((key) => {
              if (key == "_id") {
                let optionElement = document.createElement("option");
                optionElement.setAttribute("value", obj[key]);
                optionElement.innerHTML = obj[key];

                optionElement.setAttribute("data-attribute", i.field_name);
                selectElement.appendChild(optionElement);
              }
            });
          });

          // Add the select element to the field type container
          fieldType.appendChild(selectElement);

          innerDiv.appendChild(fieldType);
        }

        row.appendChild(innerDiv);
        wrapperDiv.appendChild(row);
      }

      let formBtn = document.createElement("button");
      formBtn.innerHTML += "Submit";
      formBtn.setAttribute("id", submitBtn);
      formBtn.style.backgroundColor = "red";
      formBtn.style.color = "white";
      formBtn.style.borderRadius = "6px";
      formBtn.style.padding = "12px 30px";
      formBtn.style.width = "100%";
      wrapperDiv.appendChild(formBtn);
      console.log("starts here");
      wrapperDiv.innerHTML += `
                <script type="text/javascript">
                 document.querySelector("#${submitBtn}").addEventListener('click',function(){
                    if("${table_name}" == 'login_table'){
                   
                        const inputs = document.querySelector('#${uniqueId}').getElementsByTagName('input');
                
                        console.log('loginInput', inputs)
                
                        let to_insert = {}
                
                        for (let i = 0; i < inputs.length; i++) {
                            if (inputs[i].value !== undefined && inputs[i].value !== null) {
                                console.log('loginInput111', inputs[i].value)
                                console.log('loginInput222', inputs[i].name)
                                to_insert[inputs[i].name] = inputs[i].value
                            }
                        }
                
                        fetch('${API_HOST}customRoutes/table_data/${table_name}', {
                            method: 'POST',
                            headers: {
                                "Content-type": "application/json",
                                "Authorization": "Bearer ${userInfo.token}",
                            },
                            body: JSON.stringify(to_insert)
                        }).then(function (result) {
                            return result.json();
                        })
                        .then(function (data) {
                            for(let i = 0; i < inputs.length; i++){
                                inputs[i].value=''
                            }
                               alert(data.message)
                        })
                        .catch(function (error) {
                            console.error(error);
                        });
            }else{
                const inputs = document.querySelector('#${uniqueId}').getElementsByTagName('input');
                    const labels = document.querySelector('#${uniqueId}').getElementsByTagName('span');
                    const inputs2 = document.querySelector('#${uniqueId}').getElementsByTagName('select')

                    let to_insert = {};
                    for(let i = 0; i < inputs.length; i++){
                        console.log('inputs[i].value',inputs[i].value)
                        if(inputs[i].value!==undefined && inputs[i].value !== null ){
                            if(inputs[i].type==='number'){
                                let numberRegex = ${/^[-+]?\d*\.?\d+$/};
                                let checkRegex= numberRegex.test(inputs[i].value);
                                if(checkRegex===true){
                                  to_insert[inputs[i].name] = Number(inputs[i].value);
                                }else{
                                  alert('please enter a valid number')
                                }
                            }else if(inputs[i].type==='hidden'){
                                if(inputs[i].name==='process_all'){
                                        if(inputs[i].checked){
                                            to_insert[inputs[i].name] = inputs[i].checked;
                                        }else{
                                            to_insert[inputs[i].name] = inputs[i].checked;
                                        }
                                }else{
                                    const selectedDate = inputs[i].value;
                                    const newUtc=new Date(selectedDate)
                                    var date = new Date(newUtc),
                                    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                                    day = ("0" + date.getDate()).slice(-2);
                                    const finalDate = [date.getFullYear(), mnth, day].join("-");
                                    to_insert[inputs[i].name] = finalDate;
                                } 
                            }else if(inputs[i].type==='text'){
                                  to_insert[inputs[i].name] = inputs[i].value;
                             }
                        }else{
                          
                        }
                       
                    }

                    for(let i = 0; i < inputs2.length;i++){
                        if(inputs2[i].value){
                            const selectedOption = inputs2[i].options[inputs2[i].selectedIndex];
                            const dataAttribute = selectedOption.dataset.attribute;
                            to_insert[dataAttribute] = inputs2[i].value
                        }
                    }

                    console.log('to_insert',to_insert)

                    const to_insert2 = {
                        "to_insert": to_insert
                    }

                   fetch('${API_HOST}customRoutes/table_data/${table_name}',{
                    method: 'POST',
                    headers: {
                      "Content-type": "application/json",
                      "Authorization": "Bearer ${userInfo.token}",
                    },
                    body: JSON.stringify(to_insert2)
                    }).then(function (response) {
                    if (response.ok) {
                       alert('data has been added to the database')
                       for(let i = 0; i < inputs.length; i++){
                            if(inputs[i].type==='number'){
                                inputs[i].value=''
                            }else if(inputs[i].type==='hidden'){
                                if(inputs[i].hasOwnProperty('checked')){
                                    inputs[i].checked=false
                                }else{
                                    inputs[i].value=''
                                }
                            }else if(inputs[i].type==='text'){
                                inputs[i].value=''
                            }else {
                                inputs[i].value=''
                            }
                        }
                        for(let i = 0; i < inputs2.length; i++){
                                inputs2[i].value=''
                            }
                        return response
                    }
                      return Promise.reject(response);
                    }).then(function (data) {
                     console.log(data);
                    }).catch(function (error) {
                      console.warn('Something went wrong.', error);
                    })
            }

                    
            })
                   
                </script>
                `;
      mainDiv.appendChild(wrapperDiv);
      console.log("main11111111111", mainDiv);
    }

    return mainDiv.outerHTML;
  };

  async function setMobileViewport(editor, userInfo, pageId) {
    console.log("checking is_mobile");

    const response = await fetch(`${API_HOST}pages/${pageId}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    });
    const data = await response.json();

    if (data.is_mobile) {
      editor.on("load", () => {
        editor.setDevice("Mobile");
      });
      mobileViewport.current = "Mobile";
    } else {
      editor.on("load", () => {
        editor.setDevice("Desktop");
      });
      mobileViewport.current = "Desktop";
    }
  }

  const userInfoFromStorage = JSON.parse(localStorage.getItem("userInfo"));

  // get custom function :
  const getCustomFunctions = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    let payload = {
      project: project_id,
    };
    try {
      const { data } = await axios.post(
        `${API_HOST}custom_functions/`,
        payload,
        config
      );
      // if(data.status ===)
      if (data.message) {
        // toast.error(data.message)
        console.log("No functions");
      } else {
        console.log("dataatatat", data.length);
        functionList.current = data;
      }
    } catch (err) {
      console.log("no custom functions");
    }
  };

  // get temp vars :
  const getTempVars = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    let payload = {
      project: project_id,
    };
    try {
      const { data } = await axios.post(
        `${API_HOST}temp_vars/`,
        payload,
        config
      );
      if (data.message) {
        console.log("No tempvars");
        // toast.error(data.message)
      } else {
        tempVarList.current = data;
      }
    } catch (err) {
      console.log("No temp vars err");
    }
  };

  const getUserDataFraunhofer = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(
      `${API_HOST}customroutes/data_grid/fraunhofer_user_table`,
      config
    );
    if (data.message) {
      toast.error(data.message);
    } else {
      data.forEach((obj) => {
        delete obj.password;
      });
      fraunhoferUserData.current = data;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      dispatch(getAllModels(project_id));
      dispatch(getAllProject());
      // console.log("FETCHING DATA");
      await getCustomFunctions();
      await getTempVars();
      // await getUserDataFraunhofer
      setEditor2();
    };
    fetchData();
    // getUserDataFraunhofer()
  }, []);

  // REDIRECT TO LOGIN SCREEN IF USER AUTHENTICATION FAILS
  useEffect(() => {
    if (!userInfoFromStorage.token) {
      navigate("/login");
    }
  }, [userInfoFromStorage, loggedOut]);

  const tempArray = [];

  // on loading or storing of data, its updating the load and store call functions as the default content object is incorrect
  grapesjs.plugins.add("customRemoteFragment", (editor) => {
    let pageIdNew = window.location.pathname.split("editor/")[1];
    editor.Storage.add("customRemoteFragment", {
      async load() {
        // return await axios.get(`${API_HOST}pages/${pageId}/content`);
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
        const { data } = await axios.get(
          `${API_HOST}template_fragment/${pageIdNew}`,
          config
        );

        if (!data.message) {
          // Manipulate the loaded HTML data to add the grapes-iframe-body id
          data["my-html"] = `<div>${data["my-html"]}</div>`;
          return data;
        } else {
          const fragment_content = {};
          fragment_content["my-html"] = editor.getHtml();
          fragment_content["my-components"] = JSON.stringify(
            editor.getComponents()
          );
          fragment_content["my-css"] = editor.getCss();
          fragment_content["my-js"] = editor.getJs();

          // Store the HTML data with the grapes-iframe-body id
          fragment_content[
            "my-html"
          ] = `<div>${fragment_content["my-html"]}</div>`;

          let data = await axios.put(
            `${API_HOST}template_fragment/${pageIdNew}`,
            fragment_content,
            config
          );

          if (data) {
            window.location.reload();
          }
        }
      },

      async store(data) {
        console.log("pageId during storing:", pageIdNew);
        // console.log("data:", data);

        // Create the dynamic content object
        const fragment_content = {};

        // Check if "my-html" exists in the original data
        // if (data.hasOwnProperty("my-html")) {
        fragment_content["my-html"] = editor.getHtml();
        // }

        // Check if "my-components" exists in the original data
        // if (data.hasOwnProperty("my-components")) {
        fragment_content["my-components"] = JSON.stringify(
          editor.getComponents()
        );
        // }

        // Check if "assets" exists in the original data
        if (data.hasOwnProperty("assets")) {
          fragment_content["my-assets"] = JSON.stringify(data["assets"]);
        }

        // Check if "my-css" exists in the original data
        // if (data.hasOwnProperty("my-css")) {
        fragment_content["my-css"] = editor.getCss();

        fragment_content["my-js"] = editor.getJs();
        // }

        // Check if "styles" exists in the original data
        if (data.hasOwnProperty("styles")) {
          fragment_content["my-styles"] = JSON.stringify(data["styles"]);
        }
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };

        // console.log("content:", content);

        fragment_content[
          "my-html"
        ] = `<div>${fragment_content["my-html"]}</div>`;

        console.log("@fragment_content", fragment_content["my-html"]);

        return await axios.put(
          `${API_HOST}template_fragment/${pageIdNew}`,
          fragment_content,
          config
        );
      },
    });

    editor.Storage.getStorageOptions(
      "remote"
    ).urlStore = `${API_HOST}template_fragment/${pageIdNew}`;
    editor.Storage.getStorageOptions(
      "remote"
    ).urlLoad = `${API_HOST}template_fragment/${pageIdNew}`;

    console.log(
      'editor.Storage.getStorageOptions("remote"):',
      editor.Storage.getStorageOptions("remote")
    );
  });

  const setEditor2 = () => {
    async function initializeEditor() {
      // TODO: Clear HTML then append content
      $(".panel__devices").html("");
      $(".panel__basic-actions").html("");
      $(".panel__editor").html("");
      $("#blocks").html("");
      $("#styles-container").html("");
      $("#layers-container").html("");
      $("#traits-container").html("");
      // console.log("here1");

      // disabling screen button so that users cannot change dimensions during editor initialization, otherwise that raises an error
      setDisableScreensBtn(true);

      const editor = grapesjs.init({
        container: "#fragmentEditor",

        width: "100%",

        height: "100% ",

        overflowY: "scroll",

        allowScripts: 1,

        fromElement: true,

        noticeOnUnload: true, // This disables the "Changes you made may not be saved" warning

        modal: {
          title: "Initialize",
          content: "",
          backdrop: false,
        },
        blockManager: {
          appendTo: designAndLayoutRef.current, // Set the appendTo option to the blocksContainerRef
        },

        assetManager: {
          // Upload endpoint, set `false` to disable upload, default `false`

          uploadFile: function (e) {
            console.log(e);
            var files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
            // ...send somewhere
            console.log(files);

            var formData = new FormData();

            for (var i in files) {
              console.log("iiii", i);
              formData.append("file", files[i]);
            }
            var fileInput = e.target; // Get a reference to the file input element

            $.ajax({
              url: `${API_HOST}assets/uploadphoto/${pageId}`,
              type: "POST",
              data: formData,
              contentType: false,
              crossDomain: true,
              mimeType: "multipart/form-data",
              processData: false,
              success: function (result) {
                console.log(result);
                if (result === "Please upload an Image less than 5 mb") {
                  return;
                } else {
                  var images = result;
                  editor.AssetManager.add({
                    src: images,
                    name: "Uploaded Image",
                  });

                  console.log("resetuuuu === ", result);
                  console.log("Imgmgee:---- ", images);
                  //
                  // made a change
                  // e.target.value = `"${images}"`;
                  // Set the name of the uploaded image to the file input
                  // fileInput.value = images;
                  fileInput.name = images;
                }
              },
            });
          },

          // The name used in POST to pass uploaded files, default: `'files'`
          uploadName: "file",
          // Text on upload input
          uploadText: "Drop files here or click to upload",
          // Label for the add button
          addBtnText: "Add image",
          assets: [
            "http://placehold.it/350x250/78c5d6/fff/image1.jpg",
            // Pass an object with your properties
            {
              type: "image",
              src: "http://placehold.it/350x250/459ba8/fff/image2.jpg",
              height: 350,
              width: 250,
              name: "displayName",
            },
            {
              // As the 'image' is the base type of assets, omitting it will
              // be set as `image` by default
              src: "http://placehold.it/350x250/79c267/fff/image3.jpg",
              height: 350,
              width: 250,
              name: "displayName",
            },
          ],
          multiUpload: true,
        },

        storageManager: {
          type: "customRemoteFragment",
          autosave: true,
          autoload: true,
          stepsBeforeSave: 1,
          contentTypeJson: true,
          storeComponents: true,
          storeStyles: true,
          storeHtml: true,
          storeCss: true,
          id: "my-",
          // urlStore: `${API_HOST}pages/${pageId}/content`,
          // urlLoad: `${API_HOST}pages/${pageId}/content`,
          // headers: {
          //     'Content-Type': 'application/json'
          // },
        },

        parser: {
          parserCss,
        },

        styleManager: styleManager,

        layerManager: layerManager,

        traitManager: traitManager,

        selectorManager: selectorManager,

        panels: updatedPanels,

        deviceManager: deviceManager,

        plugins: [
          "customRemoteFragment",
          gjsBlockBasic,
          myNewComponentTypes,
          // tailwindComponent,
          grapesjsBlockBootstrap,
          grapesjsPluginExport,
          // grapesjsStyleBg,
          grapesjsGradient,
          // grapesjsCkEditor,
          grapesjsTuiImageEditor,
          CustomTablePlugin,
          CustomTablePluginNew,
          // grapesjsTailwind,
          MobileTabPlugin,
          // 'grapesjs-blockly'
          plugin,
          BusinessDashboardTemplate,
          // QuestionnaireTemplate,
          PatchupProviderPlugin,
          CustomCardPlugin,
          customCardListPlugin,
          customFormElements,
          customCardFH,
          pdfPreviewButton,
          DrillDownBarChartV2,
          ThreeDCharts,
          TwoDCharts,
          CustomDynamicCarouselPlugin,
        ],

        pluginsOpts: {
          [gjsBlockBasic]: {
            labelImage: "Add Image",
            labelVideo: "Add Video",
            showBasic: false,
            labelColumn1: "Column 1",
            labelColumn2: "Column 2",
            labelColumn37: "Column 1:3",
            labelText: "Add Text",
            labelLink: "Add Link",
            labelMap: "Add Maps",
            labelColumn3: "Column 3",
          },
          // tailwindComponent: {},
          // plugin: [plugin],
          swiperComponent: {},
          [grapesjsBlockBootstrap]: {
            blockCategories: {
              forms: false,
              layout: false,
            },

            blocks: {
              alert: false,
              card: false,
              card_container: true,
              collapse: false,
              tabs: false,
              dropdown: false,
            },

            labels: {
              image: "Group Image Component",
              video: "Group Video Component",
            },
          },
          [grapesjsPluginExport]: {
            root: {
              css: {
                "main.css": (editor: Editor) => editor.getCss(),
              },

              js: {
                "main.js": (editor: Editor) => editor.getJs(),
              },
              bootstrap: {
                "bootstrap.min.css": (editor) =>
                  readTextFile("/bootstrap/css/bootstrap.min.css"),
                "bootstrap.bundle.min.js": (editor) =>
                  readTextFile("/bootstrap/js/bootstrap.bundle.min.js"),
                "jquery-3.5.1.slim.min.js": (editor) =>
                  readTextFile("/bootstrap/jquery/jquery-3.5.1.slim.min.js"),
              },
              swiper: {
                "swiper-bundle.min.css": (editor) =>
                  readTextFile("/swiper/css/swiper-bundle.min.css"),
                "swiper-bundle.min.js": (editor) =>
                  readTextFile("/swiper/js/swiper-bundle.min.js"),
              },
              "index.html": (editor: Editor) =>
                `<!doctype html>
                            <html lang="en">
                              <head>
                                <meta charset="utf-8">
                                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                                
                                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.1/css/all.min.css" integrity="sha512-MV7K8+y+gLIBoVD59lQIYicR65iaqukzvf/nwasF0nqhPay5w/9lJmVM2hMDcnK1OnMGCdVK+iQrJ7lzPJQd1w==" crossorigin="anonymous" referrerpolicy="no-referrer" />
                                <script src="./bootstrap/jquery-3.5.1.slim.min.js"></script>
                                <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-rbsA2VBKQhggwzxH7pPCaAqO46MgnOM80zW1RWuH61DGLwZJEdK2Kadq2F9CUG65" crossorigin="anonymous">
                                <link rel="stylesheet" href="./bootstrap/bootstrap.min.css">
                                <script src="./bootstrap/bootstrap.bundle.min.js"></script>   
                                <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/js/bootstrap.min.js" integrity="sha384-cuYeSxntonz0PPNlHhBs68uyIAVpIIOZZ5JqeqvYYIcEL727kskC66kF92t6Xl2V" crossorigin="anonymous"></script>                             
                                <script src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.11.6/dist/umd/popper.min.js" integrity="sha384-oBqDVmMz9ATKxIep9tiCxS/Z9fNfEXiDAYTujMAeBAsjFuCZSmKbSSUnQlmh/jp3" crossorigin="anonymous"></script>
                                <link rel="stylesheet" href="./swiper/swiper-bundle.min.css">
                                <script src="./swiper/swiper-bundle.min.js"></script>
                                <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@ionic/core/css/ionic.bundle.css" />
                                <script nomodule src="https://cdn.jsdelivr.net/npm/@ionic/core/dist/ionic/ionic.js"></script>
                                <script type="module" src="https://cdn.jsdelivr.net/npm/@ionic/core/dist/ionic/ionic.esm.js"></script>
                                <link rel="stylesheet" href="https://unpkg.com/tailwindcss@^1.0/dist/tailwind.min.css">  
                                <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/4.2.1/chart.min.js" integrity="sha512-v3ygConQmvH0QehvQa6gSvTE2VdBZ6wkLOlmK7Mcy2mZ0ZF9saNbbk19QeaoTHdWIEiTlWmrwAL4hS8ElnGFbA==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>
                                
                                <!-- uikit pagination -->
                                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/uikit/2.27.5/css/uikit.min.css" integrity="sha512-b/j0MsmsRINkL4YUIZWvtf9tQr4KYQt2ld3NjEdakM7QRRWLenfe9OmG5K9GjNW56hE0QJCwWMv11fAVFELR2w==" crossorigin="anonymous" referrerpolicy="no-referrer" />
                                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/uikit/2.27.5/css/uikit.almost-flat.min.css" integrity="sha512-Jp2nLWKQpLJFf+F70YA8LmLeYL6a2Kp+Bc0wxtgGdUvSElxYd4dwEieQ7aKFWDkJDA6LDlU7qkYbDhQC51hB1w==" crossorigin="anonymous" referrerpolicy="no-referrer" />
                                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/uikit/2.27.5/css/uikit.gradient.min.css" integrity="sha512-Vjr6Vz5D/gNvTBfQW581ssADQr1j8fAOU0seE2SxO8UvsCBZBoFQS9Lec3hkmZbpcYnsifkBtdQaHU4x6MylGw==" crossorigin="anonymous" referrerpolicy="no-referrer" />
                                <script src="https://cdnjs.cloudflare.com/ajax/libs/uikit/2.27.5/js/uikit.min.js" integrity="sha512-KI08ZutCgdasDMwp5rPKd9nF8r+eAy/bZH3Rjova6HfkDv1W7J72sNW+K++KvMp3HL7z0cCykV9vixJACHeCew==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>
                                <script src="https://cdnjs.cloudflare.com/ajax/libs/uikit/2.27.5/js/components/pagination.min.js" integrity="sha512-9YP1whKX+JyRX+HyqhyTOed88+GR4z7x45Y+t//FsEWIGf7PhjvvWEBQsO2xkYO1PsPX4m6iQhXRX9A92lxcuQ==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>

                                <!-- <link rel="stylesheet" href="path/to/grapick.min.css"> -->
                                <!-- <script src="path/to/grapick.min.js"></script> -->   
                                
                                <link rel="stylesheet" href="./css/main.css">
                                <!-- <script type="text/javascript" src="./js/main.js" defer></script> -->  
                              </head>
                              <body>
                                    ${editor.getHtml()}                                 
                              </body>
                            </html>`,
            },
            filenamePfx: `redSling_bundle_${pageId}`,
          },

          [pdfPreviewButton]: {
            handlePreviewPdf: handlePreviewPdf,
          },
          // grapesjsStyleBg: {},
          // [grapesjsCkEditor]: {
          //   position: {
          //     top: "50%", // Adjust the vertical position as a percentage
          //     left: "50%", // Adjust the horizontal position as a percentage
          //   },
          //   options: {
          //     language: "en",
          //     toolbarGroups: [
          //       { name: "document", groups: ["mode", "document", "doctools"] },
          //       { name: "clipboard", groups: ["clipboard", "undo"] },
          //       {
          //         name: "editing",
          //         groups: ["find", "selection", "spellchecker", "editing"],
          //       },
          //       { name: "forms", groups: ["forms"] },
          //       "/",
          //       { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
          //       {
          //         name: "paragraph",
          //         groups: [
          //           "list",
          //           "indent",
          //           "blocks",
          //           "align",
          //           "bidi",
          //           "paragraph",
          //         ],
          //       },
          //       { name: "links", groups: ["links"] },
          //       { name: "insert", groups: ["insert"] },
          //       "/",
          //       { name: "styles", groups: ["styles"] },
          //       { name: "colors", groups: ["colors"] },
          //       { name: "tools", groups: ["tools"] },
          //       { name: "others", groups: ["others"] },
          //       { name: "about", groups: ["about"] },
          //     ],
          //     removeButtons: "NewPage",
          //   },
          // },
          [grapesjsTuiImageEditor]: {
            config: {
              includeUI: {
                initMenu: "filter",
              },
            },
            width: "80vw !important",
            script: [
              "https://uicdn.toast.com/tui.code-snippet/v1.5.2/tui-code-snippet.min.js",
              "https://uicdn.toast.com/tui-color-picker/v2.2.7/tui-color-picker.min.js",
              "https://uicdn.toast.com/tui-image-editor/v3.15.2/tui-image-editor.min.js",
            ],
            style: [
              "https://uicdn.toast.com/tui-color-picker/v2.2.7/tui-color-picker.min.css",
              "https://uicdn.toast.com/tui-image-editor/v3.15.2/tui-image-editor.min.css",
            ],
          },
          // [plugin]: {
          //   toolbox: {
          //     // Add your custom blocks here
          //   },

          //   // The workspace specifies the size and position of the Blockly editor.
          //   workspace: {
          //     width: 600,
          //     height: 400,
          //     position: 'bottom-right',
          //   },

          //   // The theme specifies the theme that will be used for the Blockly editor.
          //   theme: 'classic',
          // },
          // The theme specifies the theme that will be used for the Blockly editor.
          theme: "classic",
          // },

          BusinessDashboardTemplate: {},
          // QuestionnaireTemplate: {},
          PatchupProviderPlugin: {},
          PatchupProviderPlugin: {},
          DrillDownBarChartV2: {},
          [ThreeDCharts]: {
            baseUrl1,
            baseUrl2,
            baseUrl3,
            baseUrl4,
            baseUrl5,
            baseUrl1BearerToken,
            baseUrl2BearerToken,
            baseUrl3BearerToken,
            baseUrl4BearerToken,
            baseUrl5BearerToken,
            projectId: localStorage.getItem("project_id") ? localStorage.getItem("project_id") : "",
          },

          [TwoDCharts]: {
            baseUrl1,
            baseUrl2,
            baseUrl3,
            baseUrl4,
            baseUrl5,
            baseUrl1BearerToken,
            baseUrl2BearerToken,
            baseUrl3BearerToken,
            baseUrl4BearerToken,
            baseUrl5BearerToken,
            projectId: localStorage.getItem("project_id") ? localStorage.getItem("project_id") : "",
          },
          [CustomTablePlugin]: {
            baseUrl1,
            baseUrl2,
            baseUrl3,
            baseUrl4,
            baseUrl5,
            baseUrl1BearerToken,
            baseUrl2BearerToken,
            baseUrl3BearerToken,
            baseUrl4BearerToken,
            baseUrl5BearerToken,
            projectId: localStorage.getItem("project_id") ? localStorage.getItem("project_id") : "",
          },

          [CustomTablePluginNew]: {
            baseUrl1,
            baseUrl2,
            baseUrl3,
            baseUrl4,
            baseUrl5,
            baseUrl1BearerToken,
            baseUrl2BearerToken,
            baseUrl3BearerToken,
            baseUrl4BearerToken,
            baseUrl5BearerToken,
            projectId: localStorage.getItem("project_id") ? localStorage.getItem("project_id") : "",
          },

          [CustomDynamicCarouselPlugin]: {
            baseUrl1,
            baseUrl2,
            baseUrl3,
            baseUrl4,
            baseUrl5,
            baseUrl1BearerToken,
            baseUrl2BearerToken,
            baseUrl3BearerToken,
            baseUrl4BearerToken,
            baseUrl5BearerToken,
            projectId: localStorage.getItem("project_id") ? localStorage.getItem("project_id") : "",
          },
        },

        canvas: {
          styles: [
            "https://unpkg.com/swiper@8/swiper-bundle.min.css",
            "https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css",
            "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.2/font/bootstrap-icons.css",
            "https://cdn.jsdelivr.net/npm/@ionic/core/css/ionic.bundle.css",
            "/styles/main.scss",

            "https://fonts.googleapis.com/css2?family=Roboto:wght@300&display=swap",
            "https://fonts.googleapis.com/css2?family=Poppins:wght@300&display=swap",
            "https://fonts.googleapis.com/css2?family=Open+Sans:wght@300&display=swap",
            "https://fonts.googleapis.com/css2?family=Montserrat:wght@300&display=swap",
            "https://fonts.googleapis.com/css2?family=Noto+Sans:wght@300&display=swap",
            "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@300&display=swap",
            "https://fonts.googleapis.com/css2?family=Lato:wght@300&display=swap",
            "https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300&display=swap",
            "https://fonts.googleapis.com/css2?family=Raleway:wght@300&display=swap",
            "https://fonts.googleapis.com/css2?family=Bacasime+Antique&display=swap",
            "https://fonts.googleapis.com/css2?family=League+Spartan:wght@300&display=swap",
            "https://fonts.googleapis.com/css2?family=Manrope:wght@300&display=swap",
            "https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap",
            "https://fonts.googleapis.com/css2?family=Marcellus&display=swap",
            "https://fonts.googleapis.com/css2?family=Ubuntu:wght@300&display=swap",

            "https://cdn.jsdelivr.net/npm/gridjs/dist/theme/mermaid.min.css",

            "https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css",

            "https://fonts.googleapis.com/css?family=Montserrat:300,300i,400,400i,500,500i,600,600i,700,700i&amp;display=swap",
            "https://fonts.googleapis.com/css?family=Roboto:300,300i,400,400i,500,500i,700&amp;display=swap",
            "/assets/css/datatables.css",
            "/assets/css/datatable-extension.css",
            "/assets/css/bootstrap.css",
            "/assets/css/bootstrap.css.map",

            "/assets/css/fontawesome.css",
            "/assets/css/fontawesome.css.map",
            "/assets/css/ionic-icon.css",
            "/assets/css/ionic-icon.css.map",
            "/assets/css/themify.css",
            "/assets/css/themify.css.map",
            "/assets/css/icofont.css",
            "/assets/css/icofont.css.map",
            "/assets/css/simple-line-icon.css",
            "/assets/css/simple-line-icon.css.map",
            "/assets/css/material-design-icon.css",
            "/assets/css/material-design-icon.css.map",
            "/assets/css/pe7-icon.css",
            "/assets/css/pe7-icon.css.map",
            "/assets/css/typicon-icon.css",
            "/assets/css/typicon-icon.css.map",

            // NOTE --> style.css and style.css.map causes issues/conflict with redSling builder's typography functionality
            // "/assets/css/style.css",
            // "/assets/css/style.css.map",
            "/assets/css/chartist.css",
            "/assets/css/prism.css",
            "/assets/css/color-1.css",
            "/assets/css/responsive.css",

            // "/Frutiger-LT-Com-45-Light.ttf",
            // "/styles/Frutiger-LT-Com-45-Light.ttf",
            "/korebotComponents/sdk/UI/libs/jquery-ui.min.css",
            "/korebotComponents/sdk/UI/chatWindow.css",
            "/korebotComponents/sdk/libs/emojione.sprites.css",
            "/korebotComponents/sdk/libs/purejscarousel.css",
            "/korebotComponents/sdk/UI/custom/customTemplate.css",

            // for pagination - uikit framework
            "https://cdnjs.cloudflare.com/ajax/libs/uikit/2.27.5/css/uikit.min.css",
            "https://cdnjs.cloudflare.com/ajax/libs/uikit/2.27.5/css/uikit.almost-flat.min.css",
            "https://cdnjs.cloudflare.com/ajax/libs/uikit/2.27.5/css/uikit.gradient.min.css",

            //  quill.js for rte
            "https://cdn.quilljs.com/1.3.6/quill.snow.css",
          ],
          scripts: [
            "https://cdn.jsdelivr.net/npm/@popperjs/core@2.10.2/dist/umd/popper.min.js",
            "https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/js/bootstrap.min.js",
            "https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/js/bootstrap.bundle.min.js",
            "https://code.jquery.com/jquery-3.6.0.min.js",
            "https://code.jquery.com/jquery-3.7.1.min.js",
            "https://cdn.jsdelivr.net/npm/@ionic/core/dist/ionic/ionic.js",
            "https://cdn.jsdelivr.net/npm/@ionic/core/dist/ionic/ionic.esm.js",
            "https://unpkg.com/swiper@8/swiper-bundle.min.js",
            "https://www.jsdelivr.com/package/npm/chart.js?path=dist",
            // "https://unpkg.com/blockly",
            // "https://unpkg.com/@blockly/block-plus-minus",

            // "plotly-2.20.0.min.js",
            "http://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit",
            "https://cdn.jsdelivr.net/npm/gridjs/dist/gridjs.umd.js",

            "https://smtpjs.com/v3/smtp.js",

            // "/bootstrap/js/bootstrap.bundle.min.js",
            // "/assets/js/jquery-3.5.1.min.js",
            "/assets/js/datatable/datatables/jquery.dataTables.min.js",
            // "/assets/js/bootstrap/popper.min.js",
            // "/assets/js/bootstrap/bootstrap.js",

            "/korebotComponents/sdk/UI/libs/jquery.js",
            "/korebotComponents/sdk/UI/libs/jquery.tmpl.min.js",
            "/korebotComponents/sdk/UI/libs/jquery-ui.min.js",
            "/korebotComponents/sdk/UI/libs/moment.js",
            "/korebotComponents/sdk/libs/lodash.min.js",
            "/korebotComponents/sdk/libs/d3.v4.min.js",
            "/korebotComponents/sdk/libs/KoreGraphAdapter.js",
            "/korebotComponents/sdk/libs/anonymousassertion.js",
            "/korebotComponents/sdk/kore-bot-sdk-client.js",
            "/korebotComponents/sdk/UI/chatWindow.js",
            "/korebotComponents/sdk/libs/emoji.js",
            "/korebotComponents/sdk/libs/recorder.js",
            "/korebotComponents/sdk/libs/recorderWorker.js",
            "/korebotComponents/sdk/libs/purejscarousel.js",
            "/korebotComponents/sdk/UI/custom/customTemplate.js",
            "/korebotComponents/sdk/libs/perfect-scrollbar.js",
            //"/korebotComponents/sdk/UI/kore-config.js",
            "/korebotComponents/sdk/UI/kore-main.js",
            "../src/api_utils/index.js",

            "/assets/js/icons/feather-icon/feather.min.js",
            "/assets/js/icons/feather-icon/feather-icon.js",
            "/assets/js/sidebar-menu.js",
            "/assets/js/config.js",
            "/assets/js/chart/chartist/chartist.js",
            "/assets/js/chart/chartist/chartist-plugin-tooltip.js",
            "/assets/js/chart/apex-chart/apex-chart.js",
            "/assets/js/chart/apex-chart/stock-prices.js",
            "/assets/js/prism/prism.min.js",
            "/assets/js/clipboard/clipboard.min.js",
            "/assets/js/counter/jquery.waypoints.min.js",
            "/assets/js/counter/jquery.counterup.min.js",
            "/assets/js/counter/counter-custom.js",
            "/assets/js/custom-card/custom-card.js",

            // .load inner data bug solution
            // "/assets/js/notify/bootstrap-notify.min.js",

            "/assets/js/dashboard/default.js",
            "/assets/js/notify/index.js",
            "/assets/js/tooltip-init.js",
            "/assets/js/script.js",

            "https://unpkg.com/vis-graph3d@latest/dist/vis-graph3d.min.js",
            "https://cdn.jsdelivr.net/npm/chart.js",

            // .load inner data bug solution
            // "/assets/js/theme-customizer/customizer.js",

            // for pagination - uikit framework
            "https://cdnjs.cloudflare.com/ajax/libs/uikit/2.27.5/js/uikit.min.js",
            "https://cdnjs.cloudflare.com/ajax/libs/uikit/2.27.5/js/components/pagination.min.js",

            // quill.js for rte
            "https://cdn.quilljs.com/1.3.6/quill.js",
          ],
        },

        baseUrl1,
        baseUrl2,
        baseUrl3,
        baseUrl4,
        baseUrl5,
        baseUrl1BearerToken,
        baseUrl2BearerToken,
        baseUrl3BearerToken,
        baseUrl4BearerToken,
        baseUrl5BearerToken,
      });

      // Add gradient picker as a single input
      editor.StyleManager.addProperty("decorations", {
        type: "gradient", // <- new type
        name: "Gradient",
        property: "background-image",
        defaults: "none",
        full: true,
      });

      // Add the new background-image bulti-in type
      // editor.StyleManager.addProperty('decorations', {
      //   extend: 'background-image', // <- extend the built-in type
      //   name: 'Gradient Background',
      // });

      // editor.load()
      //     .then(() => {
      //         console.log('Editor content loaded successfully!');
      //     })
      //     .catch((error) => {
      //         console.error('Failed to load editor content:', error);
      // });

      // editor.on('storage:start:load', () => {
      //     editor.Storage.getStorageOptions('remote').urlLoad = `${API_HOST}pages/${pageId}/content`;

      //     console.log('loading...\neditor.Storage.getStorageOptions("remote"):', editor.Storage.getStorageOptions('remote'));
      // });

      editor.on("storage:start:store", async (objectToBeStored) => {
        // console.log("object to be stored:", objectToBeStored);

        const data = editor.getProjectData();

        // console.log("data to be stored:", data);

        // await editor.Storage.store(data);

        // console.log('stored data - ', data);
      });

      editor.on("load", async () => {
        // const { Parser } = editor;
        // const resHtml = Parser.parseHtml(`<table><div>Hi</div></table><style>.cls-cls {color: red;}</style><script>console.log('adios');</script>`, {
        //   htmlType: 'text/html', // default
        // });
        // console.log('resHtml', resHtml);

        // const res = Parser.parseCss('.cls { color: red }');
        // console.log('res -=', res);

        // once editor has loaded, set the screen button to true
        setDisableScreensBtn(false);

        console.log("editor loaded");
        console.log("@pageByProjectData", pageByProjectData);
        if (
          allProjectData &&
          pageByProjectData &&
          pageByProjectData[0]?.project
        ) {
          //console.log("allProjectData::::::", allProjectData);
          //console.log("pageByProjectData::::::", pageByProjectData);
          const appTypeCheck = allProjectData.find(
            (project) => project._id === pageByProjectData[0].project
          );
          // console.log("pageByProjectData", typeof pageByProjectData);
          // console.log("pageByProjectData1", pageByProjectData);
          // console.log("allProjectData", allProjectData);
          // console.log("appTypeCheck", appTypeCheck);

          if (appTypeCheck) {
            if (appTypeCheck.application_type === "mobile") {
              editor.setDevice("Mobile");
            } else {
              editor.setDevice("Desktop");
            }
          }
        }
        // console.log('loading...');

        // making a load call manually, as the default one is not working
        // const data = await editor.Storage.load();
        // console.log('on load - data:', data, '\non load - data.data:', data.data);

        // editor.loadProjectData(data.data);
        // console.log('loaded');

        console.log("editor after loading", editor);

        if (editor.getSelected()) {
          const component = editor.getSelected(); // Component selected in canvas
          const traits = component.get("traits");
          console.log("component here", component);
          traits.forEach((trait) => console.log(trait.props()));
        }

        manageInputTagTraits(editor);
      });

      editor.setStyle(` #grapes-iframe-body {
                min-height:100% !important;
                    height:100% !important;
                    padding-bottom:2rem;
                }`);

      // rerunning/calling the traits managing function everytime when the editor html template is updated; otherwise the traits don't appear in the traitsmanager UI
      editor.on("update", async () => {
        let extractedJs = editor.getJs();

        console.log("EDITOR HTML/CSS TEMPLATE UPDATED, TRAITS ADDED");

        if (customTablesRef.current !== null) {
          manageInputTagTraits(editor, customTablesRef.current, project_id);
        }

        if (
          editor.getSelected() !== undefined &&
          editor.getSelected() !== null
        ) {
          editor.getSelected().get("traits");
        }

        // if (editor.getSelected()) {
        //     getAttributesForInput(editor.getSelected());
        // }

        await editor.store();
        // console.log('STORING DATA on editor.update', storedProjectData1);
        // console.log('EDITOR CSS:', editor.getCss());
        // editor.getCss();
      });

      // editor.on("component:selected", (selectedComponent) => {
      //   console.log('selectedComponent:', selectedComponent);
      // });

      // to make conponent definitions, individual components so that they don't affect each other
      // editor.on('component:add', (model) => {
      //     console.log('component model added:', model);

      //     // provide unique id to stellar button
      //     if (model.attributes.type === 'stellar-button') {
      //         const uniqueId = uniqid('stellar-btn-');
      //         console.log('creating unique ID for class:', uniqueId);

      //         model.addClass(`${uniqueId}`);
      //         console.log('updated stellar-btn model:', model);
      //     }

      //     // provide unique id to predefined email dispatch
      //     else if (model.attributes.type === 'predefined-email-dispatch') {
      //         const uniqueId = uniqid('predefined-email-dispatch-');
      //         console.log('creating unique ID for class:', uniqueId);

      //         model.addClass(`${uniqueId}`);
      //         console.log('updated predefined-email-dispatch model:', model);
      //     }

      //     // provide unique id to customize receiver email dispatch
      //     else if (model.attributes.type === 'customize-receiver-email-dispatch') {
      //         const uniqueId = uniqid('customize-receiver-email-dispatch-');
      //         console.log('creating unique ID for class:', uniqueId);

      //         model.addClass(`${uniqueId}`);
      //         console.log('updated customize-receiver-email-dispatch model:', model);
      //     }

      //     // provide unique id to popup button
      //     else if (model.attributes.type === 'popup-button') {
      //         const uniqueId = uniqid('popup-btn-');
      //         console.log('creating unique ID for class:', uniqueId);

      //         model.addClass(`${uniqueId}`);
      //         console.log('updated popup-button model:', model);
      //     }

      //     // provide unique id to page popup button
      //     // else if (model.attributes.type === 'page-popup') {
      //     //     const uniqueId = uniqid('page-popup-');
      //     //     console.log('creating unique ID for class:', uniqueId);

      //     //     model.addClass(`${uniqueId}`);
      //     //     console.log('updated page-popup model:', model);
      //     // }
      // });

      // editor.Commands.isActive("preview");

      // Add command to switch the view for Desktop/large screen
      editor.Commands.add("set-device-desktop", {
        run: (editor) => editor.setDevice("Desktop"),
      });

      // Add command to switch the view for mobile device
      editor.Commands.add("set-device-mobile", {
        run: (editor) => editor.setDevice("Mobile"),
      });

      //Save
      editor.Commands.add("saveDb", {
        run: function (editor, sender) {
          console.log("editor:", editor, "\nsender:", sender);
          sender && sender.set("active");
          editor.store();
        },
      });

      // Clear Button
      editor.Commands.add("cmd-clear", {
        run: (editor) => {
          // creating a form
          let form = document.createElement("form");
          form.setAttribute("class", "clear-editor-form");

          let h5 = document.createElement("h5");
          h5.innerHTML = "Are you sure?";

          form.appendChild(h5);

          let btnDiv = document.createElement("div");
          btnDiv.style.display = "flex";
          btnDiv.style.columnGap = "3em";

          let noBtn = document.createElement("button");
          noBtn.setAttribute("type", "button");
          noBtn.setAttribute("class", "noBtn");
          noBtn.innerHTML = "No";
          btnDiv.appendChild(noBtn);

          let yesBtn = document.createElement("button");
          yesBtn.setAttribute("type", "button");
          yesBtn.setAttribute("class", "yesBtn");
          yesBtn.innerHTML = "Yes";
          btnDiv.appendChild(yesBtn);

          form.appendChild(btnDiv);

          editor.Modal.open({
            title: "Clear Editor",

            content: `${form.outerHTML}`,
          });

          // clear the editor on clicking the YES button
          document
            .querySelector(".yesBtn")
            .addEventListener("click", (event) => {
              event.preventDefault();
              console.log("8888");
              editor.DomComponents.clear();
              editor.CssComposer.clear();
              editor.setStyle(`
                    #grapes-iframe-body {
                        min-height:100% !important;
                        height:100% !important;
                        padding-bottom:2rem;
                    }
                `);

              editor.Modal.close();
            });

          // do nothing on clicking the No button
          document
            .querySelector(".noBtn")
            .addEventListener("click", (event) => {
              event.preventDefault();
              editor.Modal.close();
            });
        },
      });

      // Undo
      editor.Commands.add("undo", {
        run: (editor) => editor.UndoManager.undo(),
      });

      // Redo
      editor.Commands.add("redo", {
        run: (editor) => editor.UndoManager.redo(),
      });

      editor.Commands.add("export", {
        run: (editor) => {
          editor.runCommand("gjs-export-zip");
        },
      });

      editor.Commands.add("import", {
        run: (editor) => {
          // editor.runCommand("gjs-export-zip");
          console.log("import a file");

          let form = document.createElement("form");
          form.setAttribute("class", "import-form");

          let h5 = document.createElement("h5");
          h5.innerHTML = "Select a data table/model:";

          form.appendChild(h5);

          let selectCustomTable = document.createElement("select");
          selectCustomTable.setAttribute("id", "selectCustomTable");
          selectCustomTable.setAttribute("name", "selectCustomTable");
          selectCustomTable.setAttribute("class", "selectCustomTable");

          customTablesRef.current.forEach((table) => {
            const option = document.createElement("option");
            option.innerHTML += `${table.table_name}`;
            option.setAttribute("value", `${table.table_name}`);
            selectCustomTable.appendChild(option);
          });

          form.appendChild(selectCustomTable);

          let btnDiv = document.createElement("div");
          btnDiv.style.display = "flex";
          btnDiv.style.columnGap = "3em";

          let submitBtn = document.createElement("button");
          submitBtn.setAttribute("type", "button");
          submitBtn.setAttribute("class", "submitBtn");
          submitBtn.innerHTML = "Import File";
          btnDiv.appendChild(submitBtn);

          form.appendChild(btnDiv);

          editor.Modal.open({
            title: "Save File",

            content: `${form.outerHTML}`,
          });

          document
            .querySelector(".submitBtn")
            .addEventListener("click", (event) => {
              event.preventDefault();
              console.log("9999");

              const project_id = location.search
                ? location.search.split("=")[1]
                : "/";

              let selectedTable =
                document.querySelector(".selectCustomTable").value;
              console.log(
                "selectedTable:",
                selectedTable,
                "project_id:",
                project_id
              );

              // Trigger the file input element to open the file dialog
              xlFileInputRef.current.click();

              // Listen for changes in the file input
              xlFileInputRef.current.addEventListener("change", (e) => {
                const file = e.target.files[0];

                if (file) {
                  // Handle the file here
                  handleFile(file, editor, selectedTable, project_id);
                }
              });

              editor.Modal.close();
            });

          editor.addComponents(`
                <div id="table-container"></div>
                <button id="prev-button" disabled>Previous</button>
                <button id="next-button">Next</button>
            `);
        },
      });

      editor.Commands.add("view-import", {
        run: (editor) => {
          // editor.runCommand("gjs-export-zip");
          console.log("view a file");

          editor.addComponents(`
                <div id="table-container"></div>
                <button id="prev-button" disabled>Previous</button>
                <button id="next-button">Next</button>
            `);

          let form = document.createElement("form");
          form.setAttribute("class", "import-form");

          let h5 = document.createElement("h5");
          h5.innerHTML = "Select a data table of an imported file:";

          form.appendChild(h5);

          let selectCustomTable = document.createElement("select");
          selectCustomTable.setAttribute("id", "selectCustomTable");
          selectCustomTable.setAttribute("name", "selectCustomTable");
          selectCustomTable.setAttribute("class", "selectCustomTable");

          customTablesRef.current.forEach((table) => {
            const option = document.createElement("option");
            option.innerHTML += `${table.table_name}`;
            option.setAttribute("value", `${table.table_name}`);
            selectCustomTable.appendChild(option);
          });

          form.appendChild(selectCustomTable);

          let btnDiv = document.createElement("div");
          btnDiv.style.display = "flex";
          btnDiv.style.columnGap = "3em";

          let submitBtn = document.createElement("button");
          submitBtn.setAttribute("type", "button");
          submitBtn.setAttribute("class", "submitBtn");
          submitBtn.innerHTML = "View Imported Data";
          btnDiv.appendChild(submitBtn);

          form.appendChild(btnDiv);

          editor.Modal.open({
            title: "Save File",

            content: `${form.outerHTML}`,
          });

          document
            .querySelector(".submitBtn")
            .addEventListener("click", (event) => {
              event.preventDefault();
              console.log("9999");

              const project_id = location.search
                ? location.search.split("=")[1]
                : "/";

              let selectedTable =
                document.querySelector(".selectCustomTable").value;
              console.log("selectedTable:", selectedTable);

              viewImport(editor, selectedTable);

              editor.Modal.close();
            });
        },
      });

      // preview commands
      editor.on("run:preview", () => {
        editor.stopCommand("sw-visibility");
        const previewWindow = window.open("", "_blank");

        const htmlContent = editor.getHtml();
        const cssContent = editor.getCss();
        const jsContent = editor.getJs();

        // Write the HTML content and include CSS and JS
        previewWindow.document.write(`
            <html>
                <head>
                    <style>${cssContent}</style>
                </head>
                <body>${htmlContent}</body>
                <script>${jsContent}</script>
            </html>
        `);

        // Listen for changes in the preview and update the new window
        editor.on("change:device", () => {
          const updatedHtml = editor.getHtml();
          const updatedCss = editor.getCss();
          const updatedJs = editor.getJs();

          // Update the HTML content and include updated CSS and JS
          previewWindow.document.open();
          previewWindow.document.write(`
                <html>
                    <head>
                        <style>${updatedCss}</style>
                    </head>
                    <body>${updatedHtml}</body>
                    <script>${updatedJs}</script>
                </html>
            `);
          previewWindow.document.close();
        });
      });

      editor.on("stop:preview", () => {
        editor.runCommand("sw-visibility");
      });

      editor.on("storage:start:store", (storedData) => {
        // console.log("progress saved!", storedData);
        const panelSpace = document.querySelector(".panel__basic-actions");

        const progressNotification = document.querySelector(".progress-notification");
        progressNotification && progressNotification.remove();

        const notify = document.createElement("div");
        notify.setAttribute("class", "progress-notification");
        notify.style.display = "flex";
        notify.style.alignItems = "center";
        notify.style.justifyContent = "space-between";
        notify.innerHTML = "Saving in progress...";
        notify.style.padding = "0.7em 1.2em";
        notify.style.borderRadius = "8px";
        notify.style.backgroundColor = "rgba(253, 224, 71, 0.15)"; // amber translucent
        notify.style.color = "#92400E"; // darker yellow-brown
        notify.style.border = "none";
        notify.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.1)";
        notify.style.backdropFilter = "blur(4px)";
        notify.style.transition = "opacity 0.4s ease-in-out";
        notify.style.opacity = "0";
        notify.style.width = "max-content";
        setTimeout(() => {
          notify.style.opacity = "1";
        }, 10);

        notify.style.position = "absolute";
        notify.style.left = "100%";

        // if (mobileView) {
        //     notify.style.top = '-30%';
        // } else {

        // }
        notify.style.top = "7%";

        // const signalSave = document.createElement("span");
        // signalSave.setAttribute("class", "bi bi-check-circle-fill");
        // signalSave.innerHTML = `
        //             <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="green" class="bi bi-check-circle" viewBox="0 0 16 16">
        //               <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
        //               <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
        //             </svg>
        //         `;

        // signalSave.style.display = "inline-block";
        // signalSave.style.marginBottom = "5%";

        // notify?.appendChild(signalSave);

        panelSpace?.appendChild(notify);
        // panelSpace.insertBefore(notify, panelSpace.children[1]);

        const timer = setTimeout(() => {
          notify.style.transition = 'opacity 0.5s ease';
          notify.style.opacity = '0';

          // Wait for the transition to complete, then remove the element
          setTimeout(() => {
            notify.remove();
          }, 400); // match the duration in the transition
        }, 3000); // original delay before fading out
      });

      editor.on("storage:end:store", (storedData) => {
        // console.log("progress saved!", storedData);
        const panelSpace = document.querySelector(".panel__basic-actions");

        const progressNotification = document.querySelector(".progress-notification");
        progressNotification && progressNotification.remove();

        const notify = document.createElement("div");
        notify.setAttribute("class", "progress-notification");
        notify.style.display = "flex";
        notify.style.alignItems = "center";
        notify.style.justifyContent = "space-between";
        notify.innerHTML = "Progress saved";
        notify.style.padding = "0.7em 1.2em";
        notify.style.borderRadius = "8px";
        notify.style.backgroundColor = "rgba(34, 197, 94, 0.15)"; // green translucent
        notify.style.color = "#065F46"; // dark green text
        notify.style.border = "none";
        notify.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.1)";
        notify.style.backdropFilter = "blur(4px)";
        notify.style.transition = "opacity 0.4s ease-in-out";
        notify.style.opacity = "0";
        notify.style.width = "max-content";
        setTimeout(() => {
          notify.style.opacity = "1";
        }, 10);

        notify.style.position = "absolute";
        notify.style.left = "100%";

        // if (mobileView) {
        //     notify.style.top = '-30%';
        // } else {

        // }
        notify.style.top = "7%";

        // const signalSave = document.createElement("span");
        // signalSave.setAttribute("class", "bi bi-check-circle-fill");
        // signalSave.innerHTML = `
        //             <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="green" class="bi bi-check-circle" viewBox="0 0 16 16">
        //               <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
        //               <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
        //             </svg>
        //         `;

        // signalSave.style.display = "inline-block";
        // signalSave.style.marginBottom = "5%";

        // notify?.appendChild(signalSave);

        panelSpace?.appendChild(notify);
        // panelSpace.insertBefore(notify, panelSpace.children[1]);

        const timer = setTimeout(() => {
          notify.style.transition = 'opacity 0.5s ease';
          notify.style.opacity = '0';

          // Wait for the transition to complete, then remove the element
          setTimeout(() => {
            notify.remove();
          }, 400); // match the duration in the transition
        }, 3000); // original delay before fading out
      });

      editor.on("storage:error", (error) => {
        console.log("Error in saving progress!", error);
        // const panelSpace = document.querySelector('.panel__devices');

        // const notifyErr = document.createElement('div');
        // notifyErr.style.display = 'flex';
        // notifyErr.style.alignItems = 'center';
        // notifyErr.style.justifyContent = 'space-between';
        // notifyErr.innerHTML = 'Progress saving error';
        // notifyErr.style.padding = '0.3em';
        // notifyErr.style.borderRadius = '10px';
        // notifyErr.style.border = '2px solid red';
        // notifyErr.style.color = 'black';
        // notifyErr.style.fontFamily = 'Mont-Regular';
        // notifyErr.style.fontStyle = 'normal';
        // notifyErr.style.width = '10em';

        // notifyErr.style.position = 'absolute';
        // notifyErr.style.left = '-150%';
        // notifyErr.style.top = '7%';

        // const signalError = document.createElement('span');
        // signalError.setAttribute('class', 'bi bi-x-circle');
        // signalError.innerHTML = `
        //     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" class="bi bi-check-circle" viewBox="0 0 16 16">
        //         <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
        //         <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
        //     </svg>
        // `;

        // signalError.style.display = 'inline-block';
        // signalError.style.marginBottom = '5%';

        // notifyErr.appendChild(signalError);

        // panelSpace.appendChild(signalError);
        // // panelSpace.insertBefore(notifyErr, panelSpace.children[2]);

        // const timer = setTimeout(() => {
        //     notifyErr.remove();
        // }, 3000);

        // an alert notification
        // alert('Progress saving error.\nPlease pause and try restarting the server.');
        editor.Modal.open({
          title: "Progress Saving Error!",
          content: `
                        <p style="color: black; font-weight: bolder;">
                            Saving Paused - It looks like there's a connection issue.
                            <br>
                            Please ensure you're online and manually save your work before continuing.
                        </p>
                    `,
          attributes: {
            class: "server-crashed-error",
          },
        });
      });

      const wrapper = editor.getWrapper();
      wrapper.set("attributes", { id: "grapes-iframe-body" });
      wrapper.set(
        "style",
        "min-height:100%;height:100%;padding-bottom:100%;overflow-y:scroll"
      );

      // dynamic api call begins here:
      const dynamicApiCall = async (urlData) => {
        console.log("calling dynamicApiCall\nurlData:", urlData);
        // toy api url: https://swapi.dev/api/
        let method = urlData.method;
        let config;

        if (method === "GET") {
          console.log("GET request");
          if (urlData.auth_type === "basic auth") {
            console.log("BAIDC AUTH");

            // when (nothing) is provided
            if (
              urlData.api_key === "" &&
              urlData.username === "" &&
              urlData.password === ""
            ) {
              fetch(`${urlData.url}`, {
                method: "GET",
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }

            // when (api_key) is not provided but (username and password) is provided
            if (
              urlData.api_key === "" &&
              urlData.username !== "" &&
              urlData.password !== ""
            ) {
              config = {
                Authorization: `${urlData.token}`,
              };

              fetch(`${urlData.url}`, {
                method: "GET",
                headers: config,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }

            // when (api_key, username and password) is not provided but (bearer token) is provided
            if (
              urlData.api_key === "" &&
              urlData.username == "" &&
              urlData.password === "" &&
              urlData.bearer_token !== ""
            ) {
              console.log(
                "Bearer token during API call:",
                urlData.bearer_token
              );
              config = {
                Authorization: `Bearer ${urlData.bearer_token}`,
              };

              fetch(`${urlData.url}`, {
                method: "GET",
                headers: config,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }

            // when (everything) is provided
            if (
              urlData.api_key !== "" &&
              urlData.username !== "" &&
              urlData.password !== ""
            ) {
              config = {
                "X-API-KEY": `${urlData.api_key}`,
                Authorization: `${urlData.token}`,
              };

              fetch(`${urlData.url}`, {
                method: "GET",
                headers: config,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }

            // when (api_key) is provided but (username and password) is not provided
            if (
              urlData.api_key !== "" &&
              urlData.username === "" &&
              urlData.password === ""
            ) {
              config = {
                "X-API-KEY": `${urlData.api_key}`,
              };

              fetch(`${urlData.url}`, {
                method: "GET",
                headers: config,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }

            // function call to create tabular structure of response data and append to the editor
            // createDynamicApiCallResponseTable(editor, data);
          } else {
            console.log("ELES BAISC AUTH");
            config = {
              "Content-Type": urlData.contentType,
              // Authorization: `Bearer ${urlData.token}`
              Authorization: `Basic ${urlData.token}`,
            };

            fetch(`${urlData.url}`, {
              method: "GET",
              headers: config,
            })
              .then((response) => response.json())
              .then((data) => {
                console.log("Success:", data);
                createDynamicApiCallResponseTable(editor, data);
              })
              .catch((error) => {
                console.log("Error:", error);
              });
            // createDynamicApiCallResponseTable(editor, data);
          }
        } else if (method === "POST") {
          console.log("POST request");

          if (urlData.auth_type === "basic auth") {
            // if api_key or token (username/password) are not sent by the user, then don't send Authorization in headers
            if (
              urlData.api_key === "" &&
              urlData.username === "" &&
              urlData.password === ""
            ) {
              console.log("1");
              fetch(`${urlData.url}`, {
                method: method,
                headers: {
                  "Content-Type": `${urlData.contentType}`,
                },

                body: urlData.body,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }

            // if api_key is provided
            if (urlData.api_key !== "") {
              console.log("2");
              fetch(`${urlData.url}`, {
                method: method,
                headers: {
                  "Content-Type": `${urlData.contentType}`,
                  Authorization: `Bearer ${urlData.api_key}`,
                },

                body: urlData.body,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }

            // if token is provided
            if (urlData.username !== "" && urlData.password !== "") {
              console.log("3");
              fetch(`${urlData.url}`, {
                method: method,
                headers: {
                  "Content-Type": `${urlData.contentType}`,
                  Authorization: `${urlData.token}`,
                },

                body: urlData.body,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success >>:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }

            // when (api_key, username and password) is not provided but (bearer token) is provided
            if (
              urlData.api_key === "" &&
              urlData.username == "" &&
              urlData.password === "" &&
              urlData.bearer_token !== ""
            ) {
              console.log(
                "Bearer token during API call:",
                urlData.bearer_token
              );
              config = {
                Authorization: `Bearer ${urlData.bearer_token}`,
              };

              fetch(`${urlData.url}`, {
                method: method,
                headers: config,
                body: urlData.body,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }
          }
        } else if (method === "PUT") {
          console.log("PUT request");
          if (urlData.auth_type === "basic auth") {
            if (
              urlData.api_key === "" &&
              urlData.username === "" &&
              urlData.password === ""
            ) {
              fetch(`${urlData.url}`, {
                method: method,
                headers: {
                  "Content-Type": `${urlData.contentType}`,
                },

                body: urlData.body,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }

            // if api_key is provided
            if (urlData.api_key !== "") {
              fetch(`${urlData.url}`, {
                method: method,
                headers: {
                  "Content-Type": `${urlData.contentType}`,
                  Authorization: `Bearer ${urlData.api_key}`,
                },

                body: urlData.body,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }

            // if token is provided
            if (urlData.username !== "" && urlData.password !== "") {
              fetch(`${urlData.url}`, {
                method: method,
                headers: {
                  "Content-Type": `${urlData.contentType}`,
                  Authorization: `${urlData.token}`,
                },

                body: urlData.body,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }

            // when (api_key, username and password) is not provided but (bearer token) is provided
            if (
              urlData.api_key === "" &&
              urlData.username == "" &&
              urlData.password === "" &&
              urlData.bearer_token !== ""
            ) {
              console.log(
                "Bearer token during API call:",
                urlData.bearer_token
              );
              config = {
                Authorization: `Bearer ${urlData.bearer_token}`,
              };

              fetch(`${urlData.url}`, {
                method: method,
                headers: config,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }
          }
        } else if (method === "PATCH") {
          console.log("PATCH request");
          if (urlData.auth_type === "basic auth") {
            if (
              urlData.api_key === "" &&
              urlData.username === "" &&
              urlData.password === ""
            ) {
              fetch(`${urlData.url}`, {
                method: method,
                headers: {
                  "Content-Type": `${urlData.contentType}`,
                },

                body: urlData.body,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }

            // if api_key is provided
            if (urlData.api_key !== "") {
              fetch(`${urlData.url}`, {
                method: method,
                headers: {
                  "Content-Type": `${urlData.contentType}`,
                  Authorization: `Bearer ${urlData.api_key}`,
                },

                body: urlData.body,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }

            // if token is provided
            if (urlData.username !== "" && urlData.password !== "") {
              fetch(`${urlData.url}`, {
                method: method,
                headers: {
                  "Content-Type": `${urlData.contentType}`,
                  Authorization: `${urlData.token}`,
                },

                body: urlData.body,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }

            // when (api_key, username and password) is not provided but (bearer token) is provided
            if (
              urlData.api_key === "" &&
              urlData.username == "" &&
              urlData.password === "" &&
              urlData.bearer_token !== ""
            ) {
              console.log(
                "Bearer token during API call:",
                urlData.bearer_token
              );
              config = {
                Authorization: `Bearer ${urlData.bearer_token}`,
              };

              fetch(`${urlData.url}`, {
                method: method,
                headers: config,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }
          }
        } else if (method === "DELETE") {
          console.log("DELETE request");
          if (urlData.auth_type === "basic auth") {
            if (
              urlData.api_key === "" &&
              urlData.username === "" &&
              urlData.password === ""
            ) {
              fetch(`${urlData.url}`, {
                method: method,
                headers: {
                  "Content-Type": `${urlData.contentType}`,
                },

                body: urlData.body,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }

            // if api_key is provided
            if (urlData.api_key !== "") {
              fetch(`${urlData.url}`, {
                method: method,
                headers: {
                  "Content-Type": `${urlData.contentType}`,
                  Authorization: `Bearer ${urlData.api_key}`,
                },

                body: urlData.body,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }

            // if token is provided
            if (urlData.username !== "" && urlData.password !== "") {
              fetch(`${urlData.url}`, {
                method: method,
                headers: {
                  "Content-Type": `${urlData.contentType}`,
                  Authorization: `${urlData.token}`,
                },

                body: urlData.body,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }

            // when (api_key, username and password) is not provided but (bearer token) is provided
            if (
              urlData.api_key === "" &&
              urlData.username == "" &&
              urlData.password === "" &&
              urlData.bearer_token !== ""
            ) {
              console.log(
                "Bearer token during API call:",
                urlData.bearer_token
              );
              config = {
                Authorization: `Bearer ${urlData.bearer_token}`,
              };

              fetch(`${urlData.url}`, {
                method: method,
                headers: config,
              })
                .then((response) => response.json())
                .then((data) => {
                  console.log("Success:", data);
                  createDynamicApiCallResponseTable(editor, data);
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }
          }
        }
      };

      const modal = editor.Modal;

      editor.on("component:mount", async (component) => {
        // ONE-TIME-CHANGES: IF conditions to fix existing components for the docker generation process
        if (
          component &&
          component.get("tagName") === "div" &&
          "src" in component.getAttributes()
        ) {
          component.set("tagName", "img");
          component.set("type", "image");
          console.log("@docker img component", component);
        }

        if (
          component &&
          component.get("tagName") === "div" &&
          component.getLastChild()?.get("tagName") === "select" &&
          "name" in component.getAttributes()
        ) {
          component.removeAttributes("name");
          console.log("@docker input selects", component);
        }

        if (
          component &&
          component.get("tagName") === "label" &&
          "for" in component.getAttributes()
        ) {
          component.removeAttributes("for");
          console.log("@docker label component", component);
        }
      });

      // BASIC::::::::::::
      // blockManager.add('circular-container', {
      //     label: 'Circular Container',
      //     category: 'Basic',
      //     select: true,
      //     media: '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/></svg>',
      //     content: `<div id="circular-container"
      //                     style="display: flex;
      //                     justify-content: center;
      //                     align-items: center;
      //                     overflow: hidden;
      //                     width: max-content;
      //                     border-radius: 50%;
      //                     min-width: 10em;
      //                     min-height: 10em;"></div>`,
      //     draggable: 'target, target *'
      // });

      // ADD BLOCKS TO MEDIA CATEGORY

      const blockManager = editor.BlockManager;

      blockManager.add("calendy", {
        label: "Book Appointment",
        category: "Extra",
        select: true,
        media: `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor"  viewBox="0 0 24 24"><path d="M14 14H7v2h7m5 3H5V8h14m0-5h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-2 7H7v2h10v-2z"></path></svg>`,
        content: { type: "calendy" },
      });

      // blockManager.add("korebot-client", {
      //   label: "Kore.ai Chat",
      //   category: "Extra",
      //   select: true,
      //   media: `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor"  viewBox="0 0 24 24"><path d="M14 14H7v2h7m5 3H5V8h14m0-5h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-2 7H7v2h10v-2z"></path></svg>`,
      //   content: { type: "korebot-client" },
      // });

      blockManager.add("calendy-admin", {
        label: "View Appointment",
        category: "Extra",
        select: true,
        media: `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor"  viewBox="0 0 24 24"><path d="M14 14H7v2h7m5 3H5V8h14m0-5h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-2 7H7v2h10v-2z"></path></svg>`,
        content: { type: "calendy-admin" },
      });

      blockManager.add("3d-urdf", {
        label: "3D Animation",
        category: "3D Simulation",
        select: true,
        media: `<svg viewBox="0 0 24 24"><path d="M12 10.2308L3.08495 7.02346M12 10.2308L20.9178 7.03406M12 10.2308V20.8791M5.13498 18.5771L10.935 20.6242C11.3297 20.7635 11.527 20.8331 11.7294 20.8608C11.909 20.8853 12.091 20.8853 12.2706 20.8608C12.473 20.8331 12.6703 20.7635 13.065 20.6242L18.865 18.5771C19.6337 18.3058 20.018 18.1702 20.3018 17.9269C20.5523 17.7121 20.7459 17.4386 20.8651 17.1308C21 16.7823 21 16.3747 21 15.5595V8.44058C21 7.62542 21 7.21785 20.8651 6.86935C20.7459 6.56155 20.5523 6.28804 20.3018 6.0732C20.018 5.82996 19.6337 5.69431 18.865 5.42301L13.065 3.37595C12.6703 3.23665 12.473 3.167 12.2706 3.13936C12.091 3.11484 11.909 3.11484 11.7294 3.13936C11.527 3.167 11.3297 3.23665 10.935 3.37595L5.13498 5.42301C4.36629 5.69431 3.98195 5.82996 3.69824 6.0732C3.44766 6.28804 3.25414 6.56155 3.13495 6.86935C3 7.21785 3 7.62542 3 8.44058V15.5595C3 16.3747 3 16.7823 3.13495 17.1308C3.25414 17.4386 3.44766 17.7121 3.69824 17.9269C3.98195 18.1702 4.36629 18.3058 5.13498 18.5771Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>`,
        content: { type: "3d-urdf" },
      });

      // blockManager.add("mobile-nav-new", {
      //   label: "Mobile Nav",
      //   category: "Tabs",
      //   select: true,
      //   editable: true,
      //   media: ``,
      //   content: { type: "mobile-nav-new" },
      // });

      // Button Types
      blockManager.add("stellar-button", {
        label: "Stellar Button",
        category: "Buttons",
        select: true,
        media: `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"/><path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"/></svg>`,
        content: { type: "stellar-button" },
      });

      blockManager.add("predefined-email-dispatch", {
        label: "Predefined Email",
        category: "Buttons",
        select: true,
        media: `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/></svg>`,
        content: { type: "predefined-email-dispatch" },
      });

      blockManager.add("customize-receiver-email-dispatch", {
        label: "Email Dispatch",
        category: "Buttons",
        select: true,
        media: `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/></svg>`,
        content: { type: "customize-receiver-email-dispatch" },
      });

      blockManager.add("popup-button", {
        label: "Popup Button",
        category: "Buttons",
        select: true,
        media: `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm5 10v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2v5a2 2 0 0 1-2 2H5z"/></svg>`,
        content: { type: "popup-button" },
      });

      // Add map block to media panel
      blockManager.add("map", {
        label: "Maps",
        category: "Maps",
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 16 16"><path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM2.04 4.326c.325 1.329 2.532 2.54 3.717 3.19.48.263.793.434.743.484-.08.08-.162.158-.242.234-.416.396-.787.749-.758 1.266.035.634.618.824 1.214 1.017.577.188 1.168.38 1.286.983.082.417-.075.988-.22 1.52-.215.782-.406 1.48.22 1.48 1.5-.5 3.798-3.186 4-5 .138-1.243-2-2-3.5-2.5-.478-.16-.755.081-.99.284-.172.15-.322.279-.51.216-.445-.148-2.5-2-1.5-2.5.78-.39.952-.171 1.227.182.078.099.163.208.273.318.609.304.662-.132.723-.633.039-.322.081-.671.277-.867.434-.434 1.265-.791 2.028-1.12.712-.306 1.365-.587 1.579-.88A7 7 0 1 1 2.04 4.327Z"/></svg>',
        content: '<div data-gjs-type="map" class="map">Map</div>',
      });

      // blockManager.add('g-map', {
      //     label: 'G-Map',
      //     category: 'Basic',
      //     media: '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" viewBox="0 0 16 16"><path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM2.04 4.326c.325 1.329 2.532 2.54 3.717 3.19.48.263.793.434.743.484-.08.08-.162.158-.242.234-.416.396-.787.749-.758 1.266.035.634.618.824 1.214 1.017.577.188 1.168.38 1.286.983.082.417-.075.988-.22 1.52-.215.782-.406 1.48.22 1.48 1.5-.5 3.798-3.186 4-5 .138-1.243-2-2-3.5-2.5-.478-.16-.755.081-.99.284-.172.15-.322.279-.51.216-.445-.148-2.5-2-1.5-2.5.78-.39.952-.171 1.227.182.078.099.163.208.273.318.609.304.662-.132.723-.633.039-.322.081-.671.277-.867.434-.434 1.265-.791 2.028-1.12.712-.306 1.365-.587 1.579-.88A7 7 0 1 1 2.04 4.327Z"/></svg>',
      //     content: { type: 'g-map' },
      // });

      // ICONS BLOCK
      blockManager.add("fa-icon-palette", {
        label: "Font Awesome Icon",
        category: "Font Awesome",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 2A3.5 3.5 0 0 0 2 5.5v5A3.5 3.5 0 0 0 5.5 14h5a3.5 3.5 0 0 0 3.5-3.5V8a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4.5 4.5h-5A4.5 4.5 0 0 1 1 10.5v-5A4.5 4.5 0 0 1 5.5 1H8a.5.5 0 0 1 0 1H5.5z"/><path d="M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>',
        content: `<span id="fa-icon-palette" style="min-width: max-content; min-height: max-content; padding: 0.5em"></span>`,
      });

      blockManager.add("ico-icon-palette", {
        label: "Ico Icon",
        category: "Ico Icon",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 2A3.5 3.5 0 0 0 2 5.5v5A3.5 3.5 0 0 0 5.5 14h5a3.5 3.5 0 0 0 3.5-3.5V8a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4.5 4.5h-5A4.5 4.5 0 0 1 1 10.5v-5A4.5 4.5 0 0 1 5.5 1H8a.5.5 0 0 1 0 1H5.5z"/><path d="M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>',
        content: `<span id="ico-icon-palette" style="min-width: max-content; min-height: max-content; padding: 0.5em"></span>`,
      });

      blockManager.add("ionic-icon-palette", {
        label: "Ionic Icon",
        category: "Ionic Icon",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 2A3.5 3.5 0 0 0 2 5.5v5A3.5 3.5 0 0 0 5.5 14h5a3.5 3.5 0 0 0 3.5-3.5V8a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4.5 4.5h-5A4.5 4.5 0 0 1 1 10.5v-5A4.5 4.5 0 0 1 5.5 1H8a.5.5 0 0 1 0 1H5.5z"/><path d="M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>',
        content: `<span id="ionic-icon-palette" style="min-width: max-content; min-height: max-content; padding: 0.5em"></span>`,
      });

      blockManager.add("themify-icon-palette", {
        label: "Themify Icon",
        category: "Themify Icon",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 2A3.5 3.5 0 0 0 2 5.5v5A3.5 3.5 0 0 0 5.5 14h5a3.5 3.5 0 0 0 3.5-3.5V8a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4.5 4.5h-5A4.5 4.5 0 0 1 1 10.5v-5A4.5 4.5 0 0 1 5.5 1H8a.5.5 0 0 1 0 1H5.5z"/><path d="M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>',
        content: `<span id="themify-icon-palette" style="min-width: max-content; min-height: max-content; padding: 0.5em"></span>`,
      });

      blockManager.add("simple-line-icon-palette", {
        label: "Simple Line Icon",
        category: "Simple Line Icon",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 2A3.5 3.5 0 0 0 2 5.5v5A3.5 3.5 0 0 0 5.5 14h5a3.5 3.5 0 0 0 3.5-3.5V8a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4.5 4.5h-5A4.5 4.5 0 0 1 1 10.5v-5A4.5 4.5 0 0 1 5.5 1H8a.5.5 0 0 1 0 1H5.5z"/><path d="M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>',
        content: `<span id="simple-line-icon-palette" style="min-width: max-content; min-height: max-content; padding: 0.5em"></span>`,
      });

      blockManager.add("material-design-icon-palette", {
        label: "Material Design Icon",
        category: "Material Design Icon",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 2A3.5 3.5 0 0 0 2 5.5v5A3.5 3.5 0 0 0 5.5 14h5a3.5 3.5 0 0 0 3.5-3.5V8a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4.5 4.5h-5A4.5 4.5 0 0 1 1 10.5v-5A4.5 4.5 0 0 1 5.5 1H8a.5.5 0 0 1 0 1H5.5z"/><path d="M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>',
        content: `<span id="material-design-icon-palette" style="min-width: max-content; min-height: max-content; padding: 0.5em"></span>`,
      });

      blockManager.add("pe7-icon-palette", {
        label: "PE7 Icon",
        category: "pe7 Icon",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 2A3.5 3.5 0 0 0 2 5.5v5A3.5 3.5 0 0 0 5.5 14h5a3.5 3.5 0 0 0 3.5-3.5V8a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4.5 4.5h-5A4.5 4.5 0 0 1 1 10.5v-5A4.5 4.5 0 0 1 5.5 1H8a.5.5 0 0 1 0 1H5.5z"/><path d="M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>',
        content: `<span id="pe7-icon-palette" style="min-width: max-content; min-height: max-content; padding: 0.5em"></span>`,
      });

      blockManager.add("typicons-icon-palette", {
        label: "Typicons Icon",
        category: "Typicons Icon",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 2A3.5 3.5 0 0 0 2 5.5v5A3.5 3.5 0 0 0 5.5 14h5a3.5 3.5 0 0 0 3.5-3.5V8a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4.5 4.5h-5A4.5 4.5 0 0 1 1 10.5v-5A4.5 4.5 0 0 1 5.5 1H8a.5.5 0 0 1 0 1H5.5z"/><path d="M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>',
        content: `<span id="typicons-icon-palette" style="min-width: max-content; min-height: max-content; padding: 0.5em"></span>`,
      });

      // ADD BLOCKS TO TYPOGRAPHY CATEGORY:

      // Add link block to media panel
      blockManager.add("link", {
        label: "Link Block",
        category: "Media",
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"  viewBox="0 0 16 16"><path d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9c-.086 0-.17.01-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z"/><path d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4.02 4.02 0 0 1-.82 1H12a3 3 0 1 0 0-6H9z"/></svg>',
        content: '<a href="#">Link</a>',
      });

      // Add text block to media panel
      blockManager.add("text", {
        label: "Text Block",
        category: "Media",
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"  viewBox="0 0 16 16"><path d="M12.258 3h-8.51l-.083 2.46h.479c.26-1.544.758-1.783 2.693-1.845l.424-.013v7.827c0 .663-.144.82-1.3.923v.52h4.082v-.52c-1.162-.103-1.306-.26-1.306-.923V3.602l.431.013c1.934.062 2.434.301 2.693 1.846h.479L12.258 3z"/></svg>',
        content: "<p style='color: black;'>Text</p>",
      });

      // CHARTS::::::::

      // blockManager.add("lineBarBubbleMixChart", {
      //   label: "Mix Chart",
      //   category: "Charts",
      //   select: true,
      //   media: `<svg viewBox="0 -0.5 25 25" fill="none"  width="40" height="40" xmlns="http://www.w3.org/2000/svg"><path d="M5.11413 8.35688C4.75894 8.56999 4.64377 9.03069 4.85688 9.38587C5.06999 9.74106 5.53069 9.85623 5.88587 9.64312L5.11413 8.35688ZM10.5 6L10.95 5.4C10.7061 5.21704 10.3756 5.19999 10.1141 5.35688L10.5 6ZM14.5 9L14.05 9.6C14.3236 9.80522 14.7014 9.79932 14.9685 9.58565L14.5 9ZM19.9685 5.58565C20.292 5.32689 20.3444 4.85493 20.0857 4.53148C19.8269 4.20803 19.3549 4.15559 19.0315 4.41435L19.9685 5.58565ZM17.75 19C17.75 19.4142 18.0858 19.75 18.5 19.75C18.9142 19.75 19.25 19.4142 19.25 19H17.75ZM19.25 11C19.25 10.5858 18.9142 10.25 18.5 10.25C18.0858 10.25 17.75 10.5858 17.75 11H19.25ZM9.75 19C9.75 19.4142 10.0858 19.75 10.5 19.75C10.9142 19.75 11.25 19.4142 11.25 19H9.75ZM11.25 11C11.25 10.5858 10.9142 10.25 10.5 10.25C10.0858 10.25 9.75 10.5858 9.75 11H11.25ZM13.75 19C13.75 19.4142 14.0858 19.75 14.5 19.75C14.9142 19.75 15.25 19.4142 15.25 19H13.75ZM15.25 14C15.25 13.5858 14.9142 13.25 14.5 13.25C14.0858 13.25 13.75 13.5858 13.75 14H15.25ZM5.75 19C5.75 19.4142 6.08579 19.75 6.5 19.75C6.91421 19.75 7.25 19.4142 7.25 19H5.75ZM7.25 14C7.25 13.5858 6.91421 13.25 6.5 13.25C6.08579 13.25 5.75 13.5858 5.75 14H7.25ZM5.88587 9.64312L10.8859 6.64312L10.1141 5.35688L5.11413 8.35688L5.88587 9.64312ZM10.05 6.6L14.05 9.6L14.95 8.4L10.95 5.4L10.05 6.6ZM14.9685 9.58565L19.9685 5.58565L19.0315 4.41435L14.0315 8.41435L14.9685 9.58565ZM19.25 19V11H17.75V19H19.25ZM11.25 19V11H9.75V19H11.25ZM15.25 19V14H13.75V19H15.25ZM7.25 19V14H5.75V19H7.25Z"></path> </g></svg>`,
      //   content: `<canvas id="lineBarBubbleMixChart" width="100" height="100" data-gjs-type="lineBarBubbleMixChart"></canvas>`,
      //   draggable: "target, target *",
      // });

      // for webapp and mobileapp
      blockManager.add("arr-nav-carousel", {
        label: "Arrow Carousel",
        category: "Lists",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M5 6a.5.5 0 0 0-.496.438l-.5 4A.5.5 0 0 0 4.5 11h3v2.016c-.863.055-1.5.251-1.5.484 0 .276.895.5 2 .5s2-.224 2-.5c0-.233-.637-.429-1.5-.484V11h3a.5.5 0 0 0 .496-.562l-.5-4A.5.5 0 0 0 11 6H5zm2 3.78V7.22c0-.096.106-.156.19-.106l2.13 1.279a.125.125 0 0 1 0 .214l-2.13 1.28A.125.125 0 0 1 7 9.778z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/></svg>',
        content: `<div id="arr-nav-carousel" style="min-width: 100%; min-height: 50px; padding: 0.5em"></div>`,
        draggable: "target, target *",
      });

      // for webapp and mobileapp
      blockManager.add("caption-carousel", {
        label: "Caption Carousel",
        category: "Lists",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/><path d="M6 5a1 1 0 0 1 1-1h1.188a2.75 2.75 0 0 1 0 5.5H7v2a.5.5 0 0 1-1 0V5zm1 3.5h1.188a1.75 1.75 0 1 0 0-3.5H7v3.5z"/></svg>',
        content: `<div id="caption-carousel" style="min-width: 100%; min-height: 50px;"></div>`,
        draggable: "target, target *",
      });

      // DATA TABLES:::::::::::

      //=================================================================================================================================================== FORM  SECTION STARTS HERE  ========================================================================================================================//

      blockManager.add("rest-api-display-block", {
        label: "REST Datatable",
        category: "Js-Data-Table",
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v2A1.5 1.5 0 0 0 1.5 5h13A1.5 1.5 0 0 0 16 3.5v-2A1.5 1.5 0 0 0 14.5 0h-13zm1 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm9.927.427A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0l-.396-.396zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/></svg>',
        content: { type: "rest-api-display" },
        draggable: "target, target *",
      });

      blockManager.add("rest-api-label", {
        label: "API Datatable",
        category: "Js-Data-Table",
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v2A1.5 1.5 0 0 0 1.5 5h13A1.5 1.5 0 0 0 16 3.5v-2A1.5 1.5 0 0 0 14.5 0h-13zm1 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm9.927.427A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0l-.396-.396zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/></svg>',
        content: { type: "rest-api-label" },
        draggable: "target, target *",
      });

      blockManager.add("login_fraunhofer", {
        label: "Login Screen",
        category: "Js-Data-Table",
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v2A1.5 1.5 0 0 0 1.5 5h13A1.5 1.5 0 0 0 16 3.5v-2A1.5 1.5 0 0 0 14.5 0h-13zm1 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm9.927.427A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0l-.396-.396zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/></svg>',
        content: { type: "login_fraunhofer" },
        draggable: "target, target *",
      });

      // DYNAMIC TABLE BLOCK
      blockManager.add("diy-table", {
        label: "Basic Table",
        category: "Bootstrap Tables",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 16 16"><path fill="currentColor" d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm15 2h-4v3h4V4zm0 4h-4v3h4V8zm0 4h-4v3h3a1 1 0 0 0 1-1v-2zm-5 3v-3H6v3h4zm-5 0v-3H1v2a1 1 0 0 0 1 1h3zm-4-4h4V8H1v3zm0-4h4V4H1v3zm5-3v3h4V4H6zm4 4H6v3h4V8z"/> </svg>',
        content: `<div id="diy-table" style="min-width: 100%; min-height: 50px; padding: 0.5em; margin: auto;"></div>`,
      });

      blockManager.add("grid-table", {
        label: "Grid Table",
        category: "Bootstrap-Table",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 16 16"><path fill="currentColor" d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm15 2h-4v3h4V4zm0 4h-4v3h4V8zm0 4h-4v3h3a1 1 0 0 0 1-1v-2zm-5 3v-3H6v3h4zm-5 0v-3H1v2a1 1 0 0 0 1 1h3zm-4-4h4V8H1v3zm0-4h4V4H1v3zm5-3v3h4V4H6zm4 4H6v3h4V8z"/> </svg>',
        content: `<div id="grid-table" style="min-width: 100%; min-height: 50px; padding: 0.5em; margin: auto;"></div>`,
      });

      // for mobileapp and webapp
      blockManager.add("mob-basic-accordion", {
        label: "Mobile Accordion",
        category: "Accordion",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16"><path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v2A1.5 1.5 0 0 0 1.5 5h13A1.5 1.5 0 0 0 16 3.5v-2A1.5 1.5 0 0 0 14.5 0h-13zm1 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm9.927.427A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0l-.396-.396zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/></svg>',
        content: `<div id="mob-basic-accordion" style="min-width: 100%; min-height: 50px; padding: 0.5em"></div>`,
        draggable: "target, target *",
      });

      // for mobileapp and webapp
      blockManager.add("mob-insetx-basic-accordion", {
        label: "Insetx Accordion",
        category: "Accordion",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16"><path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v2A1.5 1.5 0 0 0 1.5 5h8A1.5 1.5 0 0 0 11 3.5v-2A1.5 1.5 0 0 0 9.5 0h-8zm5.927 2.427A.25.25 0 0 1 7.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0l-.396-.396zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/></svg>',
        content: `<div id="mob-insetx-basic-accordion" style="min-width: 100%; min-height: 50px; padding: 0.5em"></div>`,
        draggable: "target, target *",
      });

      // for mobileapp and webapp
      blockManager.add("mob-multiple-accordion", {
        label: "Multi-Accordion",
        category: "Accordion",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16"><path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v2A1.5 1.5 0 0 1 14.5 5h-13A1.5 1.5 0 0 1 0 3.5v-2zM1.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-13z"/><path d="M2 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm10.823.323-.396-.396A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/></svg>',
        content: `<div id="mob-multiple-accordion" style="min-width: 100%; min-height: 50px; padding: 0.5em"></div>`,
        draggable: "target, target *",
      });

      // NAVBAR COMPONENT
      blockManager.add("nav-bar", {
        label: "Nav Bar",
        category: "Navs",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="40" height="40" viewBox="0 0 50 50"><path d="M 0 7.5 L 0 12.5 L 50 12.5 L 50 7.5 Z M 0 22.5 L 0 27.5 L 50 27.5 L 50 22.5 Z M 0 37.5 L 0 42.5 L 50 42.5 L 50 37.5 Z"></path></svg>',
        content: createNavBar(editor),
        // content: {type: 'nav-bar'},
      });

      blockManager.add("nav-mob-bar", {
        label: "Mobile Navbar",
        category: "Navs",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="40" height="40" viewBox="0 0 50 50"><path d="M 0 7.5 L 0 12.5 L 50 12.5 L 50 7.5 Z M 0 22.5 L 0 27.5 L 50 27.5 L 50 22.5 Z M 0 37.5 L 0 42.5 L 50 42.5 L 50 37.5 Z"></path></svg>',
        content: createNavBarMob(editor),
        draggable: "target, target *",
      });

      blockManager.add("directional-dd", {
        label: "Directional Dropdown",
        category: "Dropdown",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16"><path d="M7.646.146a.5.5 0 0 1 .708 0L10.207 2H14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h3.793L7.646.146zM1 7v3h14V7H1zm14-1V4a1 1 0 0 0-1-1h-3.793a1 1 0 0 1-.707-.293L8 1.207l-1.5 1.5A1 1 0 0 1 5.793 3H2a1 1 0 0 0-1 1v2h14zm0 5H1v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2zM2 4.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/></svg>',
        // content: `<div id="directional-dd" style="min-width: 100%; min-height: 50px; padding: 0.5em"></div>`,
        content: { type: "directional-dd" },
      });

      // CARD COMPONENTS
      // for webapp
      blockManager.add("full-card-one", {
        label: "Full Card One",
        category: "Basic Card",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2ZM1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4Zm7.5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7ZM2 5.5a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1-.5-.5ZM10.5 5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3ZM13 8h-2V6h2v2Z"/></svg>',
        content: `<div id="full-card-one" style="min-width: 100%; min-height: 50px; padding: 0.5em"></div>`,
        draggable: "target, target *",
      });

      // for mobileapp

      // // IONIC TABS
      // blockManager.add("ionic-tabs", {
      //   label: "Mobile Tabs",
      //   category: "Tabs",
      //   select: true,
      //   media:
      //     '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor"  viewBox="0 0 16 16"><path fill-rule="evenodd" d="M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6zm6 3h4V5H6v4zm9-1V6a1 1 0 0 0-1-1h-3v4h3a1 1 0 0 0 1-1z"/></svg>',
      //   content: `<div id="ionic-tabs" style="min-width: 100%; min-height: 50px; padding: 0.5em;position:absolute;bottom:0;"></div>`,
      //   draggable: "target, target *",
      // });

      // IONIC SEARCH BAR
      blockManager.add("ionic-search-bar", {
        label: "Search Bar",
        category: "Navs",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor"  viewBox="0 0 16 16"><path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/></svg>',
        content: `<div id="ionic-search-bar" style="min-width: 100%; min-height: 50px; padding: 0.5em;"></div>`,
        draggable: "target, target *",
      });

      // IONIC LIST
      blockManager.add("ionic-list", {
        label: "List",
        category: "Typography",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor"  viewBox="0 0 16 16"><path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/></svg>',
        content: `<div id="ionic-list" style="min-width: 100%; min-height: 50px; padding: 0.5em;"></div>`,
        draggable: "target, target *",
      });

      //     // IONIC ITEM
      blockManager.add("ionic-item", {
        label: "Item",
        category: "Components",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 2 7h5.5V6A1.5 1.5 0 0 1 6 4.5v-1zm-6 8A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5v-1zm6 0A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5v-1zm6 0a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-1z"/></svg>',
        content: `<p id="ionic-item" style="min-width: 100%; ">List Item</p>`,
        draggable: "target, target *",
      });

      // IONIC MENU
      blockManager.add("ionic-menu", {
        label: "Menu",
        category: "Menus",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor"  viewBox="0 0 16 16"><path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v2A1.5 1.5 0 0 1 14.5 5h-13A1.5 1.5 0 0 1 0 3.5v-2zM1.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-13z"/><path d="M2 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm10.823.323-.396-.396A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/></svg>',
        content: `<div id="ionic-menu" style="min-width: 100%; min-height: 50px; padding: 0.5em;"></div>`,
        draggable: "target, target *",
      });

      blockManager.add("ion-toggle-menu", {
        label: "Ion Toggle Menu",
        category: "Menus",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor"  viewBox="0 0 16 16"><path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v2A1.5 1.5 0 0 1 14.5 5h-13A1.5 1.5 0 0 1 0 3.5v-2zM1.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-13z"/><path d="M2 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm10.823.323-.396-.396A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/></svg>',
        content: { type: "ion-toggle-menu" },
        draggable: "target, target *",
      });

      blockManager.add("offcanvas-menu-btn-container", {
        label: "Offcanvas Menu Button",
        category: "Menus",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor"  viewBox="0 0 16 16"><path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v2A1.5 1.5 0 0 1 14.5 5h-13A1.5 1.5 0 0 1 0 3.5v-2zM1.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-13z"/><path d="M2 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm10.823.323-.396-.396A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/></svg>',
        content: { type: "offcanvas-menu-btn-container" },
        draggable: "target, target *",
      });

      blockManager.add("offcanvas-menu", {
        label: "Offcanvas Menu",
        category: "Menus",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor"  viewBox="0 0 16 16"><path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v2A1.5 1.5 0 0 1 14.5 5h-13A1.5 1.5 0 0 1 0 3.5v-2zM1.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-13z"/><path d="M2 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm10.823.323-.396-.396A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/></svg>',
        content: { type: "offcanvas-menu" },
        draggable: "target, target *",
      });

      blockManager.add("button-tabs", {
        label: "Button Tabs",
        category: "Tabs",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16"><path d="M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6 3h4V5H6zm9-1V6a1 1 0 0 0-1-1h-3v4h3a1 1 0 0 0 1-1"/></svg>',
        content: { type: "button-tabs" },
        draggable: "target, target *",
      });

      blockManager.add("smiley-ratings-slider", {
        label: "Ratings Slider",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M7 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zM0 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm7-1.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zm0-5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 8a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zM3 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/></svg>',
        content: { type: "smiley-ratings-slider" },
        draggable: "target, target *",
      });

      blockManager.add("colorPalette-regular-form", {
        label: "Select Color",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M12.433 10.07C14.133 10.585 16 11.15 16 8a8 8 0 1 0-8 8c1.996 0 1.826-1.504 1.649-3.08-.124-1.101-.252-2.237.351-2.92.465-.527 1.42-.237 2.433.07zM8 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm4.5 3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM5 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/></svg>',
        content: { type: "colorPalette-regular-form" },
        draggable: "target, target *",
      });

      blockManager.add("date-regular-form", {
        label: "Date Input",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/></svg>',
        // content: `<input type="date"  name="date">`,
        content: { type: "dateTimeInputNew" },
        draggable: "target, target *",
      });

      blockManager.add("week-regular-form", {
        label: "Week Input",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/></svg>',
        content: { type: "week-regular-form" },
        draggable: "target, target *",
      });

      blockManager.add("monthYear-regular-form", {
        label: "Month Year Form",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M2.56 11.332 3.1 9.73h1.984l.54 1.602h.718L4.444 6h-.696L1.85 11.332h.71zm1.544-4.527L4.9 9.18H3.284l.8-2.375h.02zm5.746.422h-.676V9.77c0 .652-.414 1.023-1.004 1.023-.539 0-.98-.246-.98-1.012V7.227h-.676v2.746c0 .941.606 1.425 1.453 1.425.656 0 1.043-.28 1.188-.605h.027v.539h.668V7.227zm2.258 5.046c-.563 0-.91-.304-.985-.636h-.687c.094.683.625 1.199 1.668 1.199.93 0 1.746-.527 1.746-1.578V7.227h-.649v.578h-.019c-.191-.348-.637-.64-1.195-.64-.965 0-1.64.679-1.64 1.886v.34c0 1.23.683 1.902 1.64 1.902.558 0 1.008-.293 1.172-.648h.02v.605c0 .645-.423 1.023-1.071 1.023zm.008-4.53c.648 0 1.062.527 1.062 1.359v.253c0 .848-.39 1.364-1.062 1.364-.692 0-1.098-.512-1.098-1.364v-.253c0-.868.406-1.36 1.098-1.36z"/>  <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/></svg>',
        content: { type: "monthYear-regular-form" },
        draggable: "target, target *",
      });

      blockManager.add("time-regular-form", {
        label: "Time Input",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/></svg>',
        content: { type: "time-regular-form" },
        draggable: "target, target *",
      });

      blockManager.add("number-regular-form", {
        label: "Form Input",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M2.873 11.297V4.142H1.699L0 5.379v1.137l1.64-1.18h.06v5.961h1.174Zm3.213-5.09v-.063c0-.618.44-1.169 1.196-1.169.676 0 1.174.44 1.174 1.106 0 .624-.42 1.101-.807 1.526L4.99 10.553v.744h4.78v-.99H6.643v-.069L8.41 8.252c.65-.724 1.237-1.332 1.237-2.27C9.646 4.849 8.723 4 7.308 4c-1.573 0-2.36 1.064-2.36 2.15v.057h1.138Zm6.559 1.883h.786c.823 0 1.374.481 1.379 1.179.01.707-.55 1.216-1.421 1.21-.77-.005-1.326-.419-1.379-.953h-1.095c.042 1.053.938 1.918 2.464 1.918 1.478 0 2.642-.839 2.62-2.144-.02-1.143-.922-1.651-1.551-1.714v-.063c.535-.09 1.347-.66 1.326-1.678-.026-1.053-.933-1.855-2.359-1.845-1.5.005-2.317.88-2.348 1.898h1.116c.032-.498.498-.944 1.206-.944.703 0 1.206.435 1.206 1.07.005.64-.504 1.106-1.2 1.106h-.75v.96Z"/></svg>',
        content: { type: "number-regular-form" },
        draggable: "target, target *",
      });

      blockManager.add("range-regular-form", {
        label: "Range Input",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3h9.05zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8h2.05zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1h9.05z"/></svg>',
        content: { type: "range-regular-form" },
        draggable: "target, target *",
      });

      blockManager.add("checkbox_regular_form", {
        label: "Checkbox",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M2 10h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm9-9h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm0 9a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-3zm0-10a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-3zM2 9a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H2zm7 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3zM0 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.354.854a.5.5 0 1 0-.708-.708L3 3.793l-.646-.647a.5.5 0 1 0-.708.708l1 1a.5.5 0 0 0 .708 0l2-2z"/></svg>',
        content: { type: "checkbox_regular_form" },
        draggable: true,
      });

      blockManager.add("checkbox_regular_form_new", {
        label: "Checkbox (v2)",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M2 10h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm9-9h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm0 9a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-3zm0-10a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-3zM2 9a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H2zm7 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3zM0 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.354.854a.5.5 0 1 0-.708-.708L3 3.793l-.646-.647a.5.5 0 1 0-.708.708l1 1a.5.5 0 0 0 .708 0l2-2z"/></svg>',
        content: { type: "checkbox_regular_form_new" },
        draggable: true,
      });

      blockManager.add("checkbox_regular_form_single", {
        label: "Single Checkbox",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"> <path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5z"/> <path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0"/> </svg>',
        content: { type: "checkbox_regular_form_single" },
        draggable: true,
      });

      blockManager.add("radio_regular_form", {
        label: "Radio Button",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M3.5 15a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm9-9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm0 9a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zM16 3.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm-9 9a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm5.5 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zm-9-11a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/></svg>',
        content: { type: "radio_regular_form" },
        draggable: true,
      });

      blockManager.add("input_select", {
        label: "Form Dropdown List",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v2A1.5 1.5 0 0 0 1.5 5h13A1.5 1.5 0 0 0 16 3.5v-2A1.5 1.5 0 0 0 14.5 0h-13zm1 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm9.927.427A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0l-.396-.396zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/></svg>',
        content: { type: "input_select" },
        draggable: true,
      });

      blockManager.add("rich_text_area_container", {
        label: "Rich Text Area",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v2A1.5 1.5 0 0 0 1.5 5h13A1.5 1.5 0 0 0 16 3.5v-2A1.5 1.5 0 0 0 14.5 0h-13zm1 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm9.927.427A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0l-.396-.396zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/></svg>',
        content: { type: "rich_text_area_container" },
        draggable: true,
      });

      blockManager.add("reset-regular-form", {
        label: "Regular Form",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/></svg>',
        content: { type: "reset-regular-form" },
        draggable: "target, target *",
      });

      blockManager.add("submit-regular-form", {
        label: "Form Submit",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" fill="currentColor" viewBox="0 0 16 16"><path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z"/></svg>',
        content: { type: "submit-regular-form" },
        draggable: "target, target *",
      });

      blockManager.add("normal_text_area_regular_form", {
        label: "Form Text Area",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 16 16"><path d="M0 4.5A2.5 2.5 0 0 1 2.5 2h11A2.5 2.5 0 0 1 16 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 0 11.5zM2.5 3A1.5 1.5 0 0 0 1 4.5v7A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 13.5 3zm10.854 4.646a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708l3-3a.5.5 0 0 1 .708 0m0 2.5a.5.5 0 0 1 0 .708l-.5.5a.5.5 0 0 1-.708-.708l.5-.5a.5.5 0 0 1 .708 0"/></svg>>',
        content: { type: "normal_text_area_regular_form" },
      });

      //     // IONIC ACTION
      blockManager.add("ionic-action", {
        label: "Action",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor"  viewBox="0 0 16 16"><path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2z"/></svg>',
        content: `<div id="ionic-action" style="min-width: 100%; min-height: 50px; padding:0.5em;"></div>`,
        draggable: "target, target *",
      });

      // IONIC ACTION
      blockManager.add("ionic-dateTime", {
        label: "Calender",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor"  viewBox="0 0 16 16"><path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/></svg>',
        content: `<div id="ionic-dateTime" style="min-width: 100%; min-height: 50px; padding:0.5em;"></div>`,
        draggable: "target, target *",
      });

      // IONIC FLOATING ACTION BUTTONS
      blockManager.add("ionic-floating-action", {
        label: "Floating Action Buttons",
        category: "Floating",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor"  viewBox="0 0 16 16"><path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v2A1.5 1.5 0 0 0 1.5 5h8A1.5 1.5 0 0 0 11 3.5v-2A1.5 1.5 0 0 0 9.5 0h-8zm5.927 2.427A.25.25 0 0 1 7.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0l-.396-.396zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/></svg>',
        content: `<div id="ionic-floating-action" style="min-width: 100%; min-height: 50px; padding:0.5em;"></div>`,
        draggable: "target, target *",
      });

      //   // IONIC ALERT
      blockManager.add("ionic-alert", {
        label: "Alert",
        category: "Alert",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor"  viewBox="0 0 16 16"><path d="M0 1.5V13a1 1 0 0 0 1 1V1.5a.5.5 0 0 1 .5-.5H14a1 1 0 0 0-1-1H1.5A1.5 1.5 0 0 0 0 1.5z"/><path d="M3.5 2A1.5 1.5 0 0 0 2 3.5v11A1.5 1.5 0 0 0 3.5 16h6.086a1.5 1.5 0 0 0 1.06-.44l4.915-4.914A1.5 1.5 0 0 0 16 9.586V3.5A1.5 1.5 0 0 0 14.5 2h-11zm6 8.5a1 1 0 0 1 1-1h4.396a.25.25 0 0 1 .177.427l-5.146 5.146a.25.25 0 0 1-.427-.177V10.5z"/></svg>',
        content: `<div id="ionic-alert" style="min-width: 100%; min-height: 50px; padding:0.5em;"></div>`,
        draggable: "target, target *",
      });

      blockManager.add("full-card-two", {
        label: "Full Card",
        category: "Basic Card",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16"><path d="M11 8h2V6h-2v2Z"/><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm8.5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7ZM2 5.5a.5.5 0 0 0 .5.5H6a.5.5 0 0 0 0-1H2.5a.5.5 0 0 0-.5.5ZM2.5 7a.5.5 0 0 0 0 1H6a.5.5 0 0 0 0-1H2.5ZM2 9.5a.5.5 0 0 0 .5.5H6a.5.5 0 0 0 0-1H2.5a.5.5 0 0 0-.5.5Zm8-4v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5Z"/></svg>',
        content: `<div id="full-card-two" style="min-width: 100%; min-height: 50px; padding: 0.5em;"></div>`,
        draggable: "target, target *",
      });

      // for mobileapp
      blockManager.add("mob-title-card", {
        label: "Imageless Title Card",
        category: "Basic Card",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16"><path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/><path d="M2 5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"/></svg>',
        content: `<div id="mob-title-card" style="min-width: 100%; min-height: 50px; padding: 0.5em"></div>`,
        draggable: "target, target *",
      });

      // for webapp
      blockManager.add("title-card", {
        label: "Imageless Title Card",
        category: "Basic Card",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16"><path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/><path d="M2 5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"/></svg>',
        content: `<div id="title-card" style="min-width: 100%; min-height: 50px; padding: 0.5em"></div>`,
        draggable: "target, target *",
      });

      // for mobileapp and webapp
      blockManager.add("btn-card", {
        label: "Basic Card",
        category: "Basic Card",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16"><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2.5 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2zm0 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"/></svg>',
        content: createButtonCard(editor),
        draggable: "target, target *",
      });

      // for mobileapp and webapp
      // blockManager.add("list-card", {
      //   label: "List Card",
      //   category: "Draggable Card",
      //   select: true,
      //   media:
      //     '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16"><path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/><path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/></svg>',
      //   // content: createListCard(editor),
      //   content: {type: 'list-card'},
      // });

      // for mobileapp
      blockManager.add("mob-toggle", {
        label: "Mobile Toggles",
        category: "Form-Control",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M9.465 10H12a2 2 0 1 1 0 4H9.465c.34-.588.535-1.271.535-2 0-.729-.195-1.412-.535-2z"/><path d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 1a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm.535-10a3.975 3.975 0 0 1-.409-1H4a1 1 0 0 1 0-2h2.126c.091-.355.23-.69.41-1H4a2 2 0 1 0 0 4h2.535z"/><path d="M14 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0z"/></svg>',
        content: `<div id="mob-toggle" style="min-width: 100%; min-height: 50px; padding: 0.5em;"></div>`,
        draggable: "target, target *",
      });

      // for mobileapp
      blockManager.add("mob-segment-button", {
        label: "Buttons' Segment",
        category: "Buttons",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6zm6 3h4V5H6v4zm9-1V6a1 1 0 0 0-1-1h-3v4h3a1 1 0 0 0 1-1z"/></svg>',
        content: `<div id="mob-segment-button" style="min-width: 100%; min-height: 50px; padding: 0.5em;"></div>`,
        draggable: "target, target *",
      });

      // for mobileapp
      // blockManager.add("mob-tabs", {
      //   label: "Mobile Tabs",
      //   category: "Tabs",
      //   select: true,
      //   media:
      //     '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M2.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0V8h10v.5a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5h-11Z"/><path d="M1 5a1 1 0 0 0-1 1v3.191a1 1 0 0 0 .553.894l1.618.81a1 1 0 0 0 .447.105H15a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H1Zm0 1h14v4H2.618L1 9.191V6Z"/></svg>',
      //   content: `<div id="mob-tabs" sstyle="min-width: 100%; min-height: 50px; padding: 0.5em;"></div>`,
      //   draggable: "target, target *",
      // });

      blockManager.add("text-box-auto-search", {
        label: "Text Auto Search",
        category: "Components",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M4.5 1A1.5 1.5 0 0 0 3 2.5V3h4v-.5A1.5 1.5 0 0 0 5.5 1h-1zM7 4v1h2V4h4v.882a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V13H9v-1.5a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5V13H1V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V4h4zM1 14v.5A1.5 1.5 0 0 0 2.5 16h3A1.5 1.5 0 0 0 7 14.5V14H1zm8 0v.5a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5V14H9zm4-11H9v-.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5V3z"/></svg>',
        content: { type: "text-box-auto-search" },
        draggable: "target, target *",
      });

      blockManager.add("page-popup", {
        label: "Page Popup",
        category: "Popover",
        select: true,
        media: `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm5 10v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2v5a2 2 0 0 1-2 2H5z"/></svg>`,
        content: { type: "page-popup" },
      });

      blockManager.add("live-alert", {
        label: "LIVE Alert",
        category: "Alert",
        select: true,
        media: `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/><path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/></svg>`,
        content: { type: "live-alert" },
      });

      // for webapp
      // blockManager.add('login-form-temp1', {
      //     label: 'Login Form (Type 1)',
      //     category: 'Templates',
      //     select: true,
      //     media: '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/><path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/></svg>',
      //     content: { type: 'login-form-temp1' },
      // });

      // blockManager.add('login-form-temp2', {
      //     label: 'Login Form (Type 2)',
      //     category: 'Templates',
      //     select: true,
      //     media: '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/><path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/></svg>',
      //     content: { type: 'login-form-temp2' },
      // });
      // TEMPLATES ----------------------------

      // DATA-GRID COMPONENTS
      // STEP 1

      blockManager.add("data-grid", {
        label: "Data Grid",
        category: "Form Widgets",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M4 4v2H2V4h2zm1 7V9a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm5 5V9a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zM9 4v2H7V4h2zm5 0h-2v2h2V4zM4 9v2H2V9h2zm5 0v2H7V9h2zm5 0v2h-2V9h2zm-3-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-2z"/></svg>',
        content: `<div id="data-grid"></div>`,
        // { type: 'dataGrid' },
        draggable: "target, target *",
      });

      // for webapp
      blockManager.add("dynamic-form", {
        label: "Dynamic Form",
        category: "Form Widgets",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M4 4v2H2V4h2zm1 7V9a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm5 5V9a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zM9 4v2H7V4h2zm5 0h-2v2h2V4zM4 9v2H2V9h2zm5 0v2H7V9h2zm5 0v2h-2V9h2zm-3-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-2z"/></svg>',
        content: `<div id="dynamic-form" ></div>`,
        draggable: "target, target *",
      });

      // // manager form
      // blockManager.add('manager-form', {
      //     label: 'Add Manager',
      //     category: 'Data-Components',
      //     select: true,
      //     media: '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M4 4v2H2V4h2zm1 7V9a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm5 5V9a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zM9 4v2H7V4h2zm5 0h-2v2h2V4zM4 9v2H2V9h2zm5 0v2H7V9h2zm5 0v2h-2V9h2zm-3-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-2z"/></svg>',
      //     content: `<div id="manager-form" style="display:flex;justify-content:center;align-items:center" ></div>`,
      //     draggable: 'target, target *',
      // });

      // // user role table
      // blockManager.add('userRole-form', {
      //     label: 'Add User Roles',
      //     category: 'Data-Components',
      //     select: true,
      //     media: '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M4 4v2H2V4h2zm1 7V9a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm5 5V9a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zM9 4v2H7V4h2zm5 0h-2v2h2V4zM4 9v2H2V9h2zm5 0v2H7V9h2zm5 0v2h-2V9h2zm-3-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-2z"/></svg>',
      //     content: `<div id="userRole-form" style="display:flex;justify-content:center;align-items:center" ></div>`,
      //     draggable: 'target, target *',
      // });

      blockManager.add("connection-form-add", {
        label: "Connection Form",
        category: "Form Widgets",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M4 4v2H2V4h2zm1 7V9a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm5 5V9a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zM9 4v2H7V4h2zm5 0h-2v2h2V4zM4 9v2H2V9h2zm5 0v2H7V9h2zm5 0v2h-2V9h2zm-3-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-2z"/></svg>',
        content: `<div id="connection-form-add" style="display: none;"></div>`,
        draggable: "target, target *",
      });

      // for webapp
      blockManager.add("connection-grid", {
        label: "Connection Grid",
        category: "Js-Data-Table",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M4 4v2H2V4h2zm1 7V9a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm5 5V9a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zM9 4v2H7V4h2zm5 0h-2v2h2V4zM4 9v2H2V9h2zm5 0v2H7V9h2zm5 0v2h-2V9h2zm-3-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-2z"/></svg>',
        content: `<div id="connection-grid" ></div>`,
        draggable: "target, target *",
        onRender() {
          // get the current styles set in GrapesJS
          const styles = this.get("styleManager").getStyle(this.getId());
          // update the HTML element's attributes and styles
          this.listenTo(
            this.model,
            "change:attributes:class",
            this.handleClassChange
          );
        },
        handleClassChange() {
          const classes = this.model.getAttributes().class || "";
          this.el.setAttribute("class", "my-custom-class " + classes);
        },
      });

      // LOGIN UNIVERSAL
      blockManager.add("login_universal", {
        label: "Universal Login",
        category: "Login Page",
        select: true,
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M4 4v2H2V4h2zm1 7V9a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm5 5V9a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zM9 4v2H7V4h2zm5 0h-2v2h2V4zM4 9v2H2V9h2zm5 0v2H7V9h2zm5 0v2h-2V9h2zm-3-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-2z"/></svg>',
        content: { type: "login_universal" },
        draggable: "target, target *",
      });

      // for webapp and mobileapp
      blockManager.add("g-translate-container", {
        label: "Google Translate",
        // category: "Google API's",
        category: "Basic",
        select: true,
        // attributes: { class: '.gjs-block' },
        media:
          '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286H4.545zm1.634-.736L5.5 3.956h-.049l-.679 2.022H6.18z"/><path d="M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2zm7.138 9.995c.193.301.402.583.63.846-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6.066 6.066 0 0 1-.415-.492 1.988 1.988 0 0 1-.94.31z"/></svg>',
        content: { type: "g-translate-container" },
        // draggable: 'target, target *',
      });

      // SPECIAL CONTAINER ONLY FOR EMAIL TEMPALTE LAYOUTS
      blockManager.add("email-template-wrapper", {
        label: "Email Template Wrapper",
        category: "Basic",
        select: true,
        media: `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M8.941.435a2 2 0 0 0-1.882 0l-6 3.2A2 2 0 0 0 0 5.4v.314l6.709 3.932L8 8.928l1.291.718L16 5.714V5.4a2 2 0 0 0-1.059-1.765zM16 6.873l-5.693 3.337L16 13.372v-6.5Zm-.059 7.611L8 10.072.059 14.484A2 2 0 0 0 2 16h12a2 2 0 0 0 1.941-1.516M0 13.373l5.693-3.163L0 6.873z"/></svg>`,
        content:
          '<div class="email-template-wrapper" data-gjs-type="email-template-wrapper" style="width: 100%; height: 10em; padding: 1%;"><div class="email-template-inner-wrapper" data-gjs-type="email-template-inner-wrapper" style="width: 100%; height: 100%;"></div></div>',
      });

      editor.Blocks.add("pdf-downloader-wrapper", {
        label: "PDF Wrapper",
        category: "Basic",
        select: true,
        media: `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" class="bi bi-filetype-pdf" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z"/></svg>`,
        content:
          '<div class="pdf-downloader-wrapper" data-gjs-type="pdf-downloader-wrapper" style="width: 100%; height: 10em; padding: 1%;"><div class="pdf-downloader-inner-wrapper" data-gjs-type="pdf-downloader-inner-wrapper" style="width: 100%; height: 100%;"></div></div>',
      });

      // progress-bars
      blockManager.add("progress-bar-height1px", {
        label: "Progress Bar - H1Px",
        category: "Progress",
        select: true,
        media: `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M2 6h5v4H2V6z"/><path d="M2 4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H2zm10 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h10zm4 3a1.5 1.5 0 0 1-1.5 1.5v-3A1.5 1.5 0 0 1 16 8z"/></svg>`,
        content: { type: "progress-bar-height1px" },
      });

      // BLOGS:
      // blockManager.add('blog-1',{
      //     label:'',
      //     category:'Blogs',
      //     select:true,
      //     media:'<svg viewBox="0 0 266 150" fill="none" width="50"  height="50" ><path fill="#FFFFFF" d="M0 0h266v150H0z"></path><rect x="20.5" y="43.5" width="67" height="62" rx="1.5" fill="#FFFFFF" stroke="#CBD5E0"></rect><path d="M48.556 69h10.888c.86 0 1.556-.696 1.556-1.556V56.556c0-.86-.696-1.556-1.556-1.556H48.556c-.86 0-1.556.696-1.556 1.556v10.888c0 .86.696 1.556 1.556 1.556zm0 0l8.555-8.556L61 64.334m-8.556-5.056a1.167 1.167 0 11-2.333 0 1.167 1.167 0 012.333 0z" stroke="#A0AEC0" stroke-width="1.2px" stroke-linecap="round" stroke-linejoin="round" fill="none"></path><path d="M26 88a1 1 0 011-1h48a1 1 0 110 2H27a1 1 0 01-1-1zM26 93a1 1 0 011-1h40a1 1 0 110 2H27a1 1 0 01-1-1z" fill="#A0AEC0"></path><path d="M26 98a1 1 0 011-1h11a1 1 0 110 2H27a1 1 0 01-1-1z" fill="#6366F1"></path><path d="M26 82.5a1.5 1.5 0 011.5-1.5h32a1.5 1.5 0 010 3h-32a1.5 1.5 0 01-1.5-1.5z" fill="#4A5568"></path><rect x="99.5" y="43.5" width="67" height="62" rx="1.5" fill="#FFFFFF" stroke="#CBD5E0"></rect><path d="M127.556 69h10.888c.86 0 1.556-.696 1.556-1.556V56.556c0-.86-.696-1.556-1.556-1.556h-10.888c-.86 0-1.556.696-1.556 1.556v10.888c0 .86.696 1.556 1.556 1.556zm0 0l8.555-8.556 3.889 3.89m-8.556-5.056a1.166 1.166 0 11-2.333 0 1.166 1.166 0 012.333 0z" stroke="#A0AEC0" stroke-width="1.2px" stroke-linecap="round" stroke-linejoin="round" fill="none"></path><path d="M105 88a1 1 0 011-1h48a1 1 0 010 2h-48a1 1 0 01-1-1zM105 93a1 1 0 011-1h40a1 1 0 010 2h-40a1 1 0 01-1-1z" fill="#A0AEC0"></path><path d="M105 98a1 1 0 011-1h11a1 1 0 010 2h-11a1 1 0 01-1-1z" fill="#6366F1"></path><path d="M105 82.5a1.5 1.5 0 011.5-1.5h32a1.5 1.5 0 010 3h-32a1.5 1.5 0 01-1.5-1.5z" fill="#4A5568"></path><rect x="178.5" y="43.5" width="67" height="62" rx="1.5" fill="#FFFFFF" stroke="#CBD5E0"></rect><path d="M206.556 69h10.888c.86 0 1.556-.696 1.556-1.556V56.556c0-.86-.696-1.556-1.556-1.556h-10.888c-.86 0-1.556.696-1.556 1.556v10.888c0 .86.696 1.556 1.556 1.556zm0 0l8.555-8.556 3.889 3.89m-8.556-5.056a1.166 1.166 0 11-2.333 0 1.166 1.166 0 012.333 0z" stroke="#A0AEC0" stroke-width="1.2px" stroke-linecap="round" stroke-linejoin="round" fill="none"></path><path d="M184 88a1 1 0 011-1h48a1 1 0 010 2h-48a1 1 0 01-1-1zM184 93a1 1 0 011-1h40a1 1 0 010 2h-40a1 1 0 01-1-1z" fill="#A0AEC0"></path><path d="M184 98a1 1 0 011-1h11a1 1 0 010 2h-11a1 1 0 01-1-1z" fill="#6366F1"></path><path d="M184 82.5a1.5 1.5 0 011.5-1.5h32a1.5 1.5 0 010 3h-32a1.5 1.5 0 01-1.5-1.5z" fill="#4A5568"></path></svg>',
      //     content:`<section class="text-gray-600 body-font"><div class="container px-5 py-24 mx-auto"><div class="flex -m-4"><div class="p-4 lg:w-1/3"><div class="h-full bg-gray-100 bg-opacity-75 px-8 pt-16 pb-24 rounded-lg overflow-hidden text-center relative"><h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">CATEGORY</h2><h1 class="title-font sm:text-2xl text-xl font-medium text-gray-900 mb-3">Raclette Blueberry Nextious Level</h1><p class="leading-relaxed mb-3">Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.</p><a class="text-indigo-500 inline-flex items-center">Learn More<svg class="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="M12 5l7 7-7 7"></path></svg></a><div class="text-center mt-2 leading-none flex justify-center absolute bottom-0 left-0 w-full py-4"><span class="text-gray-400 mr-3 inline-flex items-center leading-none text-sm pr-3 py-1 border-r-2 border-gray-200"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>1.2K</span><span class="text-gray-400 inline-flex items-center leading-none text-sm"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path></svg>6</span></div></div></div><div class="p-4 lg:w-1/3"><div class="h-full bg-gray-100 bg-opacity-75 px-8 pt-16 pb-24 rounded-lg overflow-hidden text-center relative"><h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">CATEGORY</h2><h1 class="title-font sm:text-2xl text-xl font-medium text-gray-900 mb-3">Ennui Snackwave Thundercats</h1><p class="leading-relaxed mb-3">Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.</p><a class="text-indigo-500 inline-flex items-center">Learn More<svg class="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="M12 5l7 7-7 7"></path></svg></a><div class="text-center mt-2 leading-none flex justify-center absolute bottom-0 left-0 w-full py-4"><span class="text-gray-400 mr-3 inline-flex items-center leading-none text-sm pr-3 py-1 border-r-2 border-gray-200"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>1.2K</span><span class="text-gray-400 inline-flex items-center leading-none text-sm"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path></svg>6</span></div></div></div><div class="p-4 lg:w-1/3"><div class="h-full bg-gray-100 bg-opacity-75 px-8 pt-16 pb-24 rounded-lg overflow-hidden text-center relative"><h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">CATEGORY</h2><h1 class="title-font sm:text-2xl text-xl font-medium text-gray-900 mb-3">Selvage Poke Waistcoat Godard</h1><p class="leading-relaxed mb-3">Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.</p><a class="text-indigo-500 inline-flex items-center">Learn More<svg class="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="M12 5l7 7-7 7"></path></svg></a><div class="text-center mt-2 leading-none flex justify-center absolute bottom-0 left-0 w-full py-4"><span class="text-gray-400 mr-3 inline-flex items-center leading-none text-sm pr-3 py-1 border-r-2 border-gray-200"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>1.2K</span><span class="text-gray-400 inline-flex items-center leading-none text-sm"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path></svg>6</span></div></div></div></div></div></section>`
      // })

      // blockManager.add('blog-2',{
      //     label:'',
      //     category:'Blogs',
      //     select:true,
      //     media:'<svg viewBox="0 0 266 150" fill="none" width="50"  height="50" ><path fill="#FFFFFF" d="M0 0h266v150H0z"></path><rect x="20" y="43" width="68" height="63" rx="2" fill="#E2E8F0"></rect><path d="M29 73a1 1 0 011-1h48a1 1 0 110 2H30a1 1 0 01-1-1zM33 78a1 1 0 011-1h40a1 1 0 110 2H34a1 1 0 01-1-1z" fill="#A0AEC0"></path><path d="M48 83a1 1 0 011-1h11a1 1 0 110 2H49a1 1 0 01-1-1z" fill="#6366F1"></path><path d="M37 67.5a1.5 1.5 0 011.5-1.5h32a1.5 1.5 0 010 3h-32a1.5 1.5 0 01-1.5-1.5z" fill="#4A5568"></path><rect x="99" y="43" width="68" height="63" rx="2" fill="#E2E8F0"></rect><path d="M108 73a1 1 0 011-1h48a1 1 0 010 2h-48a1 1 0 01-1-1zM112 78a1 1 0 011-1h40a1 1 0 010 2h-40a1 1 0 01-1-1z" fill="#A0AEC0"></path><path d="M127 83a1 1 0 011-1h11a1 1 0 010 2h-11a1 1 0 01-1-1z" fill="#6366F1"></path><path d="M116 67.5a1.5 1.5 0 011.5-1.5h32a1.5 1.5 0 010 3h-32a1.5 1.5 0 01-1.5-1.5z" fill="#4A5568"></path><rect x="178" y="43" width="68" height="63" rx="2" fill="#E2E8F0"></rect><path d="M187 73a1 1 0 011-1h48a1 1 0 010 2h-48a1 1 0 01-1-1zM191 78a1 1 0 011-1h40a1 1 0 010 2h-40a1 1 0 01-1-1z" fill="#A0AEC0"></path><path d="M206 83a1 1 0 011-1h11a1 1 0 010 2h-11a1 1 0 01-1-1z" fill="#6366F1"></path><path d="M195 67.5a1.5 1.5 0 011.5-1.5h32a1.5 1.5 0 010 3h-32a1.5 1.5 0 01-1.5-1.5z" fill="#4A5568"></path></svg>',
      //     content:`<section class="text-gray-600 body-font"><div class="container px-5 py-24 mx-auto"><div class="flex -m-4"><div class="p-4 md:w-1/3"><div class="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden"><img class="lg:h-48 md:h-36 w-full object-cover object-center" src="https://dummyimage.com/720x400" alt="blog"><div class="p-6"><h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">CATEGORY</h2><h1 class="title-font text-lg font-medium text-gray-900 mb-3">The Catalyzer</h1><p class="leading-relaxed mb-3">Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.</p><div class="flex items-center flex-wrap "><a class="text-indigo-500 inline-flex items-center md:mb-2 lg:mb-0">Learn More<svg class="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="M12 5l7 7-7 7"></path></svg></a><span class="text-gray-400 mr-3 inline-flex items-center lg:ml-auto md:ml-0 ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>1.2K</span><span class="text-gray-400 inline-flex items-center leading-none text-sm"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path></svg>6</span></div></div></div></div><div class="p-4 md:w-1/3"><div class="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden"><img class="lg:h-48 md:h-36 w-full object-cover object-center" src="https://dummyimage.com/721x401" alt="blog"><div class="p-6"><h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">CATEGORY</h2><h1 class="title-font text-lg font-medium text-gray-900 mb-3">The 400 Blows</h1><p class="leading-relaxed mb-3">Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.</p><div class="flex items-center flex-wrap"><a class="text-indigo-500 inline-flex items-center md:mb-2 lg:mb-0">Learn More<svg class="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="M12 5l7 7-7 7"></path></svg></a><span class="text-gray-400 mr-3 inline-flex items-center lg:ml-auto md:ml-0 ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>1.2K</span><span class="text-gray-400 inline-flex items-center leading-none text-sm"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path></svg>6</span></div></div></div></div><div class="p-4 md:w-1/3"><div class="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden"><img class="lg:h-48 md:h-36 w-full object-cover object-center" src="https://dummyimage.com/722x402" alt="blog"><div class="p-6"><h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">CATEGORY</h2><h1 class="title-font text-lg font-medium text-gray-900 mb-3">Shooting Stars</h1><p class="leading-relaxed mb-3">Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.</p><div class="flex items-center flex-wrap "><a class="text-indigo-500 inline-flex items-center md:mb-2 lg:mb-0">Learn More<svg class="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="M12 5l7 7-7 7"></path></svg></a><span class="text-gray-400 mr-3 inline-flex items-center lg:ml-auto md:ml-0 ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>1.2K</span><span class="text-gray-400 inline-flex items-center leading-none text-sm"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path></svg>6</span></div></div></div></div></div></div></section>`
      // })

      // blockManager.add('blog-3',{
      //     label:'',
      //     category:'Blogs',
      //     select:true,
      //     media:'<svg viewBox="0 0 266 150" fill="none" width="50"  height="50" ><path fill="#FFFFFF" d="M0 0h266v150H0z"></path><rect x="20" y="48" width="70" height="5" rx="2.5" fill="#4A5568"></rect><rect x="20" y="36" width="34" height="8" rx="2" fill="#EBF4FF"></rect><rect x="20" y="58" width="92" height="4" rx="2" fill="#A0AEC0"></rect><rect x="20" y="66" width="82" height="4" rx="2" fill="#A0AEC0"></rect><rect x="20" y="74" width="68" height="4" rx="2" fill="#A0AEC0"></rect><rect x="20" y="82" width="18" height="4" rx="2" fill="#6366F1"></rect><rect x="23" y="39" width="28" height="2" rx="1" fill="#6366F1"></rect><path d="M121.5 93a.5.5 0 010 1h-101a.5.5 0 010-1h101z" fill="#E2E8F0"></path><circle cx="27.5" cy="107.5" r="7.5" fill="#E2E8F0"></circle><path d="M39 110a1 1 0 011-1h19a1 1 0 010 2H40a1 1 0 01-1-1z" fill="#A0AEC0"></path><rect x="39" y="103" width="35" height="3" rx="1.5" fill="#4A5568"></rect><rect x="144" y="48" width="70" height="5" rx="2.5" fill="#4A5568"></rect><rect x="144" y="36" width="34" height="8" rx="2" fill="#EBF4FF"></rect><rect x="144" y="58" width="92" height="4" rx="2" fill="#A0AEC0"></rect><rect x="144" y="66" width="82" height="4" rx="2" fill="#A0AEC0"></rect><rect x="144" y="74" width="68" height="4" rx="2" fill="#A0AEC0"></rect><rect x="144" y="82" width="18" height="4" rx="2" fill="#6366F1"></rect><rect x="147" y="39" width="28" height="2" rx="1" fill="#6366F1"></rect><path d="M245.5 93a.5.5 0 010 1h-101a.5.5 0 010-1h101z" fill="#E2E8F0"></path><circle cx="151.5" cy="107.5" r="7.5" fill="#E2E8F0"></circle><path d="M163 110a1 1 0 011-1h19a1 1 0 010 2h-19a1 1 0 01-1-1z" fill="#A0AEC0"></path><rect x="163" y="103" width="35" height="3" rx="1.5" fill="#4A5568"></rect></svg>',
      //     content:`<section class="text-gray-600 body-font overflow-hidden"><div class="container px-5 py-24 mx-auto"><div class="flex  -m-12"><div class="p-12 md:w-1/2 flex flex-col items-start"><span class="inline-block py-1 px-2 rounded bg-indigo-50 text-indigo-500 text-xs font-medium tracking-widest">CATEGORY</span><h2 class="sm:text-3xl text-2xl title-font font-medium text-gray-900 mt-4 mb-4">Roof party normcore before they sold out, cornhole vape</h2><p class="leading-relaxed mb-8">Live-edge letterpress cliche, salvia fanny pack humblebrag narwhal portland. VHS man braid palo santo hoodie brunch trust fund. Bitters hashtag waistcoat fashion axe chia unicorn. Plaid fixie chambray 90's, slow-carb etsy tumeric. Cray pug you probably haven't heard of them hexagon kickstarter craft beer pork chic.</p><div class="flex items-center flex-wrap pb-4 mb-4 border-b-2 border-gray-100 mt-auto w-full"><a class="text-indigo-500 inline-flex items-center">Learn More<svg class="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="M12 5l7 7-7 7"></path></svg></a><span class="text-gray-400 mr-3 inline-flex items-center ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>1.2K</span><span class="text-gray-400 inline-flex items-center leading-none text-sm"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path></svg>6</span></div><a class="inline-flex items-center"><img alt="blog" src="https://dummyimage.com/104x104" class="w-12 h-12 rounded-full flex-shrink-0 object-cover object-center"><span class="flex-grow flex flex-col pl-4"><span class="title-font font-medium text-gray-900">Holden Caulfield</span><span class="text-gray-400 text-xs tracking-widest mt-0.5">UI DEVELOPER</span></span></a></div><div class="p-12 md:w-1/2 flex flex-col items-start"><span class="inline-block py-1 px-2 rounded bg-indigo-50 text-indigo-500 text-xs font-medium tracking-widest">CATEGORY</span><h2 class="sm:text-3xl text-2xl title-font font-medium text-gray-900 mt-4 mb-4">Pinterest DIY dreamcatcher gentrify single-origin coffee</h2><p class="leading-relaxed mb-8">Live-edge letterpress cliche, salvia fanny pack humblebrag narwhal portland. VHS man braid palo santo hoodie brunch trust fund. Bitters hashtag waistcoat fashion axe chia unicorn. Plaid fixie chambray 90's, slow-carb etsy tumeric.</p><div class="flex items-center flex-wrap pb-4 mb-4 border-b-2 border-gray-100 mt-auto w-full"><a class="text-indigo-500 inline-flex items-center">Learn More<svg class="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="M12 5l7 7-7 7"></path></svg></a><span class="text-gray-400 mr-3 inline-flex items-center ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>1.2K</span><span class="text-gray-400 inline-flex items-center leading-none text-sm"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path></svg>6</span></div><a class="inline-flex items-center"><img alt="blog" src="https://dummyimage.com/103x103" class="w-12 h-12 rounded-full flex-shrink-0 object-cover object-center"><span class="flex-grow flex flex-col pl-4"><span class="title-font font-medium text-gray-900">Alper Kamu</span><span class="text-gray-400 text-xs tracking-widest mt-0.5">DESIGNER</span></span></a></div></div></div></section>`
      // })

      // blockManager.add('blog-4',{
      //     label:'',
      //     category:'Blogs',
      //     select:true,
      //     media:'<svg viewBox="0 0 266 150" fill="none" width="50"  height="50" ><path fill="#FFFFFF" d="M0 0h266v150H0z"></path><rect x="84" y="20" width="70" height="5" rx="2.5" fill="#4A5568"></rect><rect x="84" y="29" width="145" height="3" rx="1.5" fill="#A0AEC0"></rect><rect x="20" y="26" width="12" height="2" rx="1" fill="#A0AEC0"></rect><rect x="84" y="35" width="129" height="3" rx="1.5" fill="#A0AEC0"></rect><rect x="84" y="41" width="18" height="3" rx="1.5" fill="#6366F1"></rect><path d="M245.5 53a.5.5 0 010 1h-225a.5.5 0 010-1h225zM245.5 96a.5.5 0 010 1h-225a.5.5 0 010-1h225z" fill="#E2E8F0"></path><rect x="20" y="20" width="23" height="3" rx="1.5" fill="#4A5568"></rect><rect x="84" y="63" width="70" height="5" rx="2.5" fill="#4A5568"></rect><rect x="84" y="72" width="145" height="3" rx="1.5" fill="#A0AEC0"></rect><rect x="20" y="69" width="12" height="2" rx="1" fill="#A0AEC0"></rect><rect x="84" y="78" width="129" height="3" rx="1.5" fill="#A0AEC0"></rect><rect x="84" y="84" width="18" height="3" rx="1.5" fill="#6366F1"></rect><rect x="20" y="63" width="23" height="3" rx="1.5" fill="#4A5568"></rect><rect x="84" y="106" width="70" height="5" rx="2.5" fill="#4A5568"></rect><rect x="84" y="115" width="145" height="3" rx="1.5" fill="#A0AEC0"></rect><rect x="20" y="112" width="12" height="2" rx="1" fill="#A0AEC0"></rect><rect x="84" y="121" width="129" height="3" rx="1.5" fill="#A0AEC0"></rect><rect x="84" y="127" width="18" height="3" rx="1.5" fill="#6366F1"></rect><rect x="20" y="106" width="23" height="3" rx="1.5" fill="#4A5568"></rect></svg>',
      //     content:`<section class="text-gray-600 body-font overflow-hidden"><div class="container px-5 py-24 mx-auto"><div class="-my-8 divide-y-2 divide-gray-100"><div class="py-8 flex  md:flex-nowrap"><div class="md:w-64 md:mb-0 mb-6 flex-shrink-0 flex flex-col"><span class="font-semibold title-font text-gray-700">CATEGORY</span><span class="mt-1 text-gray-500 text-sm">12 Jun 2019</span></div><div class="md:flex-grow"><h2 class="text-2xl font-medium text-gray-900 title-font mb-2">Bitters hashtag waistcoat fashion axe chia unicorn</h2><p class="leading-relaxed">Glossier echo park pug, church-key sartorial biodiesel vexillologist pop-up snackwave ramps cornhole. Marfa 3 wolf moon party messenger bag selfies, poke vaporware kombucha lumbersexual pork belly polaroid hoodie portland craft beer.</p><a class="text-indigo-500 inline-flex items-center mt-4">Learn More<svg class="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="M12 5l7 7-7 7"></path></svg></a></div></div><div class="py-8 flex flex-wrap md:flex-nowrap"><div class="md:w-64 md:mb-0 mb-6 flex-shrink-0 flex flex-col"><span class="font-semibold title-font text-gray-700">CATEGORY</span><span class="mt-1 text-gray-500 text-sm">12 Jun 2019</span></div><div class="md:flex-grow"><h2 class="text-2xl font-medium text-gray-900 title-font mb-2">Meditation bushwick direct trade taxidermy shaman</h2><p class="leading-relaxed">Glossier echo park pug, church-key sartorial biodiesel vexillologist pop-up snackwave ramps cornhole. Marfa 3 wolf moon party messenger bag selfies, poke vaporware kombucha lumbersexual pork belly polaroid hoodie portland craft beer.</p><a class="text-indigo-500 inline-flex items-center mt-4">Learn More<svg class="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="M12 5l7 7-7 7"></path></svg></a></div></div><div class="py-8 flex flex-wrap md:flex-nowrap"><div class="md:w-64 md:mb-0 mb-6 flex-shrink-0 flex flex-col"><span class="font-semibold title-font text-gray-700">CATEGORY</span><span class="text-sm text-gray-500">12 Jun 2019</span></div><div class="md:flex-grow"><h2 class="text-2xl font-medium text-gray-900 title-font mb-2">Woke master cleanse drinking vinegar salvia</h2><p class="leading-relaxed">Glossier echo park pug, church-key sartorial biodiesel vexillologist pop-up snackwave ramps cornhole. Marfa 3 wolf moon party messenger bag selfies, poke vaporware kombucha lumbersexual pork belly polaroid hoodie portland craft beer.</p><a class="text-indigo-500 inline-flex items-center mt-4">Learn More<svg class="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="M12 5l7 7-7 7"></path></svg></a></div></div></div></div></section>`
      // })

      // blockManager.add('blog-5',{
      //     label:'',
      //     category:'Blogs',
      //     select:true,
      //     media:'<svg viewBox="0 0 266 150" fill="none" width="50"  height="50" ><path fill="#FFFFFF" d="M0 0h266v150H0z"></path><path d="M39 70.5a1.5 1.5 0 011.5-1.5h46a1.5 1.5 0 010 3h-46a1.5 1.5 0 01-1.5-1.5zM39 76.5a1.5 1.5 0 011.5-1.5h40a1.5 1.5 0 010 3h-40a1.5 1.5 0 01-1.5-1.5z" fill="#A0AEC0"></path><path d="M39 58.5a1.5 1.5 0 011.5-1.5h14a1.5 1.5 0 010 3h-14a1.5 1.5 0 01-1.5-1.5z" fill="#6366F1"></path><path d="M39 64.5a1.5 1.5 0 011.5-1.5h32a1.5 1.5 0 010 3h-32a1.5 1.5 0 01-1.5-1.5z" fill="#4A5568"></path><path d="M20 60a3 3 0 013-3h6a3 3 0 110 6h-6a3 3 0 01-3-3z" fill="#E2E8F0"></path><circle cx="44" cy="88" r="5" fill="#E2E8F0"></circle><path d="M51 87.5a1.5 1.5 0 011.5-1.5h18a1.5 1.5 0 010 3h-18a1.5 1.5 0 01-1.5-1.5z" fill="#4A5568"></path><path d="M118 70.5a1.5 1.5 0 011.5-1.5h46a1.5 1.5 0 010 3h-46a1.5 1.5 0 01-1.5-1.5zM118 76.5a1.5 1.5 0 011.5-1.5h40a1.5 1.5 0 010 3h-40a1.5 1.5 0 01-1.5-1.5z" fill="#A0AEC0"></path><path d="M118 58.5a1.5 1.5 0 011.5-1.5h14a1.5 1.5 0 010 3h-14a1.5 1.5 0 01-1.5-1.5z" fill="#6366F1"></path><path d="M118 64.5a1.5 1.5 0 011.5-1.5h32a1.5 1.5 0 010 3h-32a1.5 1.5 0 01-1.5-1.5z" fill="#4A5568"></path><path d="M99 60a3 3 0 013-3h6a3 3 0 110 6h-6a3 3 0 01-3-3z" fill="#E2E8F0"></path><circle cx="123" cy="88" r="5" fill="#E2E8F0"></circle><path d="M130 87.5a1.5 1.5 0 011.5-1.5h18a1.5 1.5 0 010 3h-18a1.5 1.5 0 01-1.5-1.5z" fill="#4A5568"></path><path d="M197 70.5a1.5 1.5 0 011.5-1.5h46a1.5 1.5 0 010 3h-46a1.5 1.5 0 01-1.5-1.5zM197 76.5a1.5 1.5 0 011.5-1.5h40a1.5 1.5 0 010 3h-40a1.5 1.5 0 01-1.5-1.5z" fill="#A0AEC0"></path><path d="M197 58.5a1.5 1.5 0 011.5-1.5h14a1.5 1.5 0 010 3h-14a1.5 1.5 0 01-1.5-1.5z" fill="#6366F1"></path><path d="M197 64.5a1.5 1.5 0 011.5-1.5h32a1.5 1.5 0 010 3h-32a1.5 1.5 0 01-1.5-1.5z" fill="#4A5568"></path><path d="M178 60a3 3 0 013-3h6a3 3 0 110 6h-6a3 3 0 01-3-3z" fill="#E2E8F0"></path><circle cx="202" cy="88" r="5" fill="#E2E8F0"></circle><path d="M209 87.5a1.5 1.5 0 011.5-1.5h18a1.5 1.5 0 010 3h-18a1.5 1.5 0 01-1.5-1.5z" fill="#4A5568"></path></svg>',
      //     content:`<section class="text-gray-600 body-font"><div class="container px-5 py-24 mx-auto"><div class="flex  -mx-4 -my-8"><div class="py-8 px-4 lg:w-1/3"><div class="h-full flex items-start"><div class="w-12 flex-shrink-0 flex flex-col text-center leading-none"><span class="text-gray-500 pb-2 mb-2 border-b-2 border-gray-200">Jul</span><span class="font-medium text-lg text-gray-800 title-font leading-none">18</span></div><div class="flex-grow pl-6"><h2 class="tracking-widest text-xs title-font font-medium text-indigo-500 mb-1">CATEGORY</h2><h1 class="title-font text-xl font-medium text-gray-900 mb-3">The 400 Blows</h1><p class="leading-relaxed mb-5">Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.</p><a class="inline-flex items-center"><img alt="blog" src="https://dummyimage.com/103x103" class="w-8 h-8 rounded-full flex-shrink-0 object-cover object-center"><span class="flex-grow flex flex-col pl-3"><span class="title-font font-medium text-gray-900">Alper Kamu</span></span></a></div></div></div><div class="py-8 px-4 lg:w-1/3"><div class="h-full flex items-start"><div class="w-12 flex-shrink-0 flex flex-col text-center leading-none"><span class="text-gray-500 pb-2 mb-2 border-b-2 border-gray-200">Jul</span><span class="font-medium text-lg text-gray-800 title-font leading-none">18</span></div><div class="flex-grow pl-6"><h2 class="tracking-widest text-xs title-font font-medium text-indigo-500 mb-1">CATEGORY</h2><h1 class="title-font text-xl font-medium text-gray-900 mb-3">Shooting Stars</h1><p class="leading-relaxed mb-5">Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.</p><a class="inline-flex items-center"><img alt="blog" src="https://dummyimage.com/102x102" class="w-8 h-8 rounded-full flex-shrink-0 object-cover object-center"><span class="flex-grow flex flex-col pl-3"><span class="title-font font-medium text-gray-900">Holden Caulfield</span></span></a></div></div></div><div class="py-8 px-4 lg:w-1/3"><div class="h-full flex items-start"><div class="w-12 flex-shrink-0 flex flex-col text-center leading-none"><span class="text-gray-500 pb-2 mb-2 border-b-2 border-gray-200">Jul</span><span class="font-medium text-lg text-gray-800 title-font leading-none">18</span></div><div class="flex-grow pl-6"><h2 class="tracking-widest text-xs title-font font-medium text-indigo-500 mb-1">CATEGORY</h2><h1 class="title-font text-xl font-medium text-gray-900 mb-3">Neptune</h1><p class="leading-relaxed mb-5">Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.</p><a class="inline-flex items-center"><img alt="blog" src="https://dummyimage.com/101x101" class="w-8 h-8 rounded-full flex-shrink-0 object-cover object-center"><span class="flex-grow flex flex-col pl-3"><span class="title-font font-medium text-gray-900">Henry Letham</span></span></a></div></div></div></div></div></section>`
      // })

      editor.on("block:drag", (block) => {
        let blockContent = Object.values(block)[4].content;
        // console.log(blockContent);

        if (blockContent.type === "text") {
          blockContent.content = "";
        }
      });

      editor.on(`component:mount`, (model) => {});
      // listening to block events after adding them to the b.manager

      // const wrapperDiv = document.createElement('div');
      // wrapperDiv.style.overflow = 'auto';
      // wrapperDiv.style.height = '100%';
      // wrapperDiv.style.paddingBottom = '2rem';

      editor.on("block:drag:stop", (block) => {
        try {
          // const selectedComponents = editor.getSelectedAll();
          // console.log('selectedComponents:::::', selectedComponents)
          // const wrapperComponent = selectedComponents.find(
          //     component => component.getAttributes()['data-gjs-type'] === 'wrapper'
          // );
          // if (wrapperComponent) {

          //     wrapperComponent.appendChild(wrapperDiv)
          // }

          const blockId = block.getId();
          console.log(`block ID: ${blockId}`, block);

          block.set("draggable", "*");
          console.log(block);

          // TRAITS MANAGER - appending new, more traits (doesn't add/affect default traits) - this is managed inside blog:drag:stop event so that whenever a new block is dragged, all the traits-managing functions are called to restore the last updated traits of every component
          manageInputTagTraits(editor);

          if (blockId === "" && blockId === null && blockId === undefined)
            console.log("redrag");
          // nav-bar block
          // else if (blockId.startsWith('nav-bar')) {
          //     console.log('inside nav-bar');
          //     createNavBar(editor);
          // }
          // to set 'img' tag to image component (earlier they were having 'div' tag by default)
          else if (
            block.attributes.type === "image" ||
            block.attributes.type === "bs-image"
          ) {
            // block.set("tagName", "img");
            // block.set("hoverable", false);
            console.log(block);
          } else if (block.attributes.type === "label") {
            block.set("tagName", "label");
            console.log(block);
          } else if (block.attributes.type === "video") {
            // block.set("tagName", "video");
            block.set("autoplay", "true");
            // block.set("hoverable", false);
            console.log(block);
          } else if (block.attributes.autoplay === "true") {
            block.addAttributes("autoplay", 1);
            console.log("@#@#", block);
          }

          // else if (block.attributes.type === 'file') {
          //     block.set('tagName', 'input');
          //     console.log(block);
          // }
          else if (block.attributes.tagName === "button") {
            block.set("draggable", "true");
            console.log(block);
          }

          // to make the button dynamic
          else if (block.attributes.type === "stellar-button") {
            console.log("stellar btn block:", block);
          } else if (blockId.startsWith("dynamic-form")) {
            console.log("inside dynamic-form");

            const pagesAndProjectsForm = document.createElement("div");
            pagesAndProjectsForm.setAttribute("class", "dynamic-form");

            const formTitle = document.createElement("p");
            formTitle.innerHTML += "Form tables:<br>";
            pagesAndProjectsForm.appendChild(formTitle);

            const innerDiv = document.createElement("div");

            customTablesRef.current.forEach((table) => {
              const button = document.createElement("button");
              button.innerHTML += `${table.table_name}`;
              innerDiv.appendChild(button);
            });

            pagesAndProjectsForm.appendChild(innerDiv);

            modal.open({
              title: "Data Form",
              content: `${pagesAndProjectsForm.outerHTML}`,
            });

            // const x = modal.getContent()
            // console.log(x, typeof x);
          } else if (blockId.startsWith("connection-form-add")) {
            console.log("inside connection-form-add");

            const connectionForm = document.createElement("form");
            connectionForm.setAttribute("class", "connection-form-add");

            // url div
            const urlDiv = document.createElement("div");

            const urlLabel = document.createElement("label");
            urlLabel.setAttribute("for", "urlInput");
            urlLabel.innerHTML = "URL:";
            urlDiv.appendChild(urlLabel);

            const urlInput = document.createElement("input");
            urlInput.setAttribute("type", "url");
            urlInput.setAttribute("id", "urlInput");
            urlInput.setAttribute("name", "urlInput");
            urlInput.setAttribute("size", "80");
            urlDiv.appendChild(urlInput);

            connectionForm.appendChild(urlDiv);

            // method div
            const methodDiv = document.createElement("div");

            const methodLabel = document.createElement("label");
            methodLabel.setAttribute("for", "methodSelectInput");
            methodLabel.innerHTML = "Method:";
            methodDiv.appendChild(methodLabel);

            const methodSelectInput = document.createElement("select");
            methodSelectInput.setAttribute("id", "methodSelectInput");
            methodSelectInput.setAttribute("name", "methodSelectInput");

            const methodOptions = [
              "GET",
              "POST",
              "PUT",
              "PATCH",
              "DELETE",
              "COPY",
              "HEAD",
              "OPTIONS",
              "LINK",
              "UNLINK",
              "PURGE",
              "LOCK",
              "UNLOCK",
              "PROPFIND",
              "VIEW",
            ];
            methodOptions.forEach((action) => {
              let methodOptionInput = document.createElement("option");
              methodOptionInput.setAttribute("value", `${action}`);
              methodOptionInput.innerHTML = `${action}`;

              methodSelectInput.appendChild(methodOptionInput);
            });
            methodDiv.appendChild(methodSelectInput);

            connectionForm.appendChild(methodDiv);

            // body div
            const bodyDiv = document.createElement("div");

            const bodyLabel = document.createElement("label");
            bodyLabel.setAttribute("for", "bodyInput");
            bodyLabel.innerHTML += "Body:";
            bodyDiv.appendChild(bodyLabel);

            const bodyInput = document.createElement("textarea");
            bodyInput.setAttribute("id", "bodyInput");
            bodyInput.setAttribute("name", "bodyInput");
            bodyInput.setAttribute("rows", "5");
            bodyInput.setAttribute("cols", "50");
            bodyDiv.appendChild(bodyInput);

            connectionForm.appendChild(bodyDiv);

            // content-type div
            const contentTypeDiv = document.createElement("div");

            const contentTypeLabel = document.createElement("label");
            contentTypeLabel.setAttribute("for", "contentTypeSelectInput");
            contentTypeLabel.innerHTML = "Content-Type:";
            contentTypeDiv.appendChild(contentTypeLabel);

            const contentTypeSelectInput = document.createElement("select");
            contentTypeSelectInput.setAttribute("id", "contentTypeSelectInput");
            contentTypeSelectInput.setAttribute(
              "name",
              "contentTypeSelectInput"
            );

            // https://stackoverflow.com/questions/23714383/what-are-all-the-possible-values-for-http-content-type-header
            const contentTypeOptions = [
              "application/java-archive",
              "application/EDI-X12",
              "application/EDIFACT",
              "application/javascript",
              "application/octet-stream",
              "application/ogg",
              "application/pdf",
              "application/xhtml+xml",
              "application/x-shockwave-flash",
              "application/json",
              "application/ld+json",
              "application/xml",
              "application/zip",
              "application/x-www-form-urlencoded",
              "text/css",
              "text/csv",
              "text/html",
              "text/plain",
              "text/xml",
              "audio/mpeg",
              "audio/x-ms-wma",
              "audio/vnd.rn-realaudio",
              "audio/x-wav",
              "image/gif",
              "image/jpeg",
              "image/png",
              "image/tiff",
              "image/vnd.microsoft.icon",
              "image/x-icon",
              "image/vnd.djvu",
              "image/svg+xml",
              "video/mpeg",
              "video/mp4",
              "video/quicktime",
              "video/x-ms-wmv",
              "video/x-msvideo",
              "video/x-flv",
              "video/webm",
              "multipart/mixed",
              "multipart/alternative",
              "multipart/form-data",
              "application/vnd.android.package-archive",
              "application/vnd.oasis.opendocument.text",
              "application/vnd.oasis.opendocument.spreadsheet",
              "application/vnd.oasis.opendocument.presentation",
              "application/vnd.oasis.opendocument.graphics",
              "application/vnd.ms-excel",
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              "application/vnd.ms-powerpoint",
              "application/vnd.openxmlformats-officedocument.presentationml.presentation",
              "application/msword",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
              "application/vnd.mozilla.xul+xml",
            ];
            contentTypeOptions.forEach((action) => {
              let contentTypeOptionInput = document.createElement("option");
              contentTypeOptionInput.setAttribute("value", `${action}`);
              contentTypeOptionInput.innerHTML = `${action}`;

              contentTypeSelectInput.appendChild(contentTypeOptionInput);
            });
            contentTypeDiv.appendChild(contentTypeSelectInput);

            connectionForm.appendChild(contentTypeDiv);

            // API-KEY div
            const apiKeyDiv = document.createElement("div");

            const apiKeyLabel = document.createElement("label");
            apiKeyLabel.setAttribute("for", "apiKeyVal");
            apiKeyLabel.innerHTML = "API Key:";
            apiKeyDiv.appendChild(apiKeyLabel);

            const apiKeyVal = document.createElement("input");
            apiKeyVal.setAttribute("type", "text");
            apiKeyVal.setAttribute("id", "apiKeyVal");
            apiKeyVal.setAttribute("name", "apiKeyVal");
            apiKeyVal.setAttribute("size", "80");
            apiKeyDiv.appendChild(apiKeyVal);

            connectionForm.appendChild(apiKeyDiv);

            // auth div
            const authDiv = document.createElement("div");

            const authLabel = document.createElement("label");
            authLabel.setAttribute("for", "authInput");
            authLabel.innerHTML = "Authentication:";
            authDiv.appendChild(authLabel);

            const authUsername = document.createElement("input");
            authUsername.setAttribute("type", "text");
            authUsername.setAttribute("id", "authUsername");
            authUsername.setAttribute("name", "authUsername");
            authUsername.setAttribute("placeholder", "Username");
            authDiv.appendChild(authUsername);

            const authPassword = document.createElement("input");
            authPassword.setAttribute("type", "password");
            authPassword.setAttribute("id", "authPassword");
            authPassword.setAttribute("name", "authPassword");
            authPassword.setAttribute("placeholder", "Password");
            authDiv.appendChild(authPassword);
            connectionForm.appendChild(authDiv);

            // BEARER TOKEN div
            const bearerTokenDiv = document.createElement("div");

            const bearerTokenLabel = document.createElement("label");
            bearerTokenLabel.setAttribute("for", "bearerTokenInput");
            bearerTokenLabel.innerHTML = "Bearer token:";
            bearerTokenDiv.appendChild(bearerTokenLabel);

            const bearerTokenInput = document.createElement("input");
            bearerTokenInput.setAttribute("type", "text");
            bearerTokenInput.setAttribute("id", "bearerTokenInput");
            bearerTokenInput.setAttribute("name", "bearerTokenInput");
            bearerTokenInput.setAttribute("size", "80");
            bearerTokenInput.setAttribute("placeholder", "Bearer");
            bearerTokenDiv.appendChild(bearerTokenInput);

            connectionForm.appendChild(bearerTokenDiv);

            //
            const responseCodes = document.createElement("div");

            // 200
            const responseStatus200 = document.createElement("label");
            responseStatus200.setAttribute("for", "responseStatus200");
            responseStatus200.innerHTML = "Response Status 200:";
            responseCodes.appendChild(responseStatus200);

            const responseCode200 = document.createElement("input");
            responseCode200.setAttribute("type", "text");
            responseCode200.setAttribute("id", "responseCode200");
            responseCode200.setAttribute("name", "responseCode200");
            responseCode200.setAttribute("placeholder", "URL For 200");
            responseCodes.appendChild(responseCode200);

            // 201
            const div201 = document.createElement("div");
            const responseStatus201 = document.createElement("label");
            responseStatus201.setAttribute("for", "responseStatus201");
            responseStatus201.innerHTML = "Response Status 201:";
            div201.appendChild(responseStatus201);

            const responseCode201 = document.createElement("input");
            responseCode201.setAttribute("type", "text");
            responseCode201.setAttribute("id", "responseCode201");
            responseCode201.setAttribute("name", "responseCode201");
            responseCode201.setAttribute("placeholder", "URL For 201");
            div201.appendChild(responseCode201);

            responseCodes.appendChild(div201);

            // 204
            const div204 = document.createElement("div");
            const responseStatus204 = document.createElement("label");
            responseStatus204.setAttribute("for", "responseStatus204");
            responseStatus204.innerHTML = "Response Status 204:";
            // responseCodes.appendChild(responseStatus204);
            div204.appendChild(responseStatus204);
            const responseCode204 = document.createElement("input");
            responseCode204.setAttribute("type", "text");
            responseCode204.setAttribute("id", "responseCode204");
            responseCode204.setAttribute("name", "responseCode204");
            responseCode204.setAttribute("placeholder", "URL For 204");
            responseCodes.appendChild(responseCode204);
            div204.appendChild(responseCode204);

            responseCodes.appendChild(div204);
            // 400
            const div400 = document.createElement("div");
            const responseStatus400 = document.createElement("label");
            responseStatus400.setAttribute("for", "responseStatus400");
            responseStatus400.innerHTML = "Response Status 400:";
            // responseCodes.appendChild(responseStatus400);
            div400.appendChild(responseStatus400);

            const responseCode400 = document.createElement("input");
            responseCode400.setAttribute("type", "text");
            responseCode400.setAttribute("id", "responseCode400");
            responseCode400.setAttribute("name", "responseCode400");
            responseCode400.setAttribute("placeholder", "URL For 400");
            // responseCodes.appendChild(responseCode400);
            div400.appendChild(responseCode400);
            responseCodes.appendChild(div400);

            // 404
            const div404 = document.createElement("div");
            const responseStatus404 = document.createElement("label");
            responseStatus404.setAttribute("for", "responseStatus404");
            responseStatus404.innerHTML = "Response Status 404:";
            // responseCodes.appendChild(responseStatus404);
            div404.appendChild(responseStatus404);

            const responseCode404 = document.createElement("input");
            responseCode404.setAttribute("type", "text");
            responseCode404.setAttribute("id", "responseCode404");
            responseCode404.setAttribute("name", "responseCode404");
            responseCode404.setAttribute("placeholder", "URL For 404");
            // responseCodes.appendChild(responseCode404);
            div404.appendChild(responseCode404);

            responseCodes.appendChild(div404);

            // 500
            const responseStatus500 = document.createElement("label");
            responseStatus500.setAttribute("for", "responseStatus500");
            responseStatus500.innerHTML = "Response Status 500:";
            responseCodes.appendChild(responseStatus500);

            const responseCode500 = document.createElement("input");
            responseCode500.setAttribute("type", "text");
            responseCode500.setAttribute("id", "responseCode500");
            responseCode500.setAttribute("name", "responseCode500");
            responseCode500.setAttribute("placeholder", "URL For 500");
            responseCodes.appendChild(responseCode500);

            connectionForm.appendChild(responseCodes);

            // submit button div
            const submitBtn = document.createElement("button");
            submitBtn.setAttribute("class", "connectionForm-btn");
            submitBtn.innerHTML = "Submit";

            connectionForm.appendChild(submitBtn);

            modal.open({
              title: "Connection Form",
              content: `${connectionForm.outerHTML}`,
            });
            // const x = modal.getContent()
            // console.log(x, typeof x);
          } else if (blockId.startsWith("diy-table")) {
            console.log("inside diy-table");

            // GRAPESJS MODAL LOGIC
            const form = document.createElement("div");
            form.setAttribute("class", "table-form");
            form.innerHTML = `
                                <div>
                                    <!-- number of rows -->
                                    <label htmlFor="numRows">Number of rows</label>
                                    <input type="number" name="numRows" id="numRows" placeholder="Rows" min="1">
                                </div>
                                <div>
                                    <!-- number of columns -->
                                    <label htmlFor="numCols">Number of columns</label>
                                    <input type="number" name="numCols" id="numCols" placeholder="Columns" min="1">
                                </div>
                                <!-- submit button -->
                                <button class="table-btn">create table</button>
                        `;

            modal.open({
              title: "Table Form",
              content: `${form.outerHTML}`,
            });
          } else if (blockId.startsWith("grid-table")) {
            console.log("inside diy-table");

            // GRAPESJS MODAL LOGIC
            const form = document.createElement("div");
            form.setAttribute("class", "table-form");
            form.innerHTML = `
                                <div>
                                    <!-- number of rows -->
                                    <label htmlFor="numRows">Number of rows</label>
                                    <input type="number" name="numRows" id="numRows" placeholder="Rows" min="1">
                                </div>
                                <div>
                                    <!-- number of columns -->
                                    <label htmlFor="numCols">Number of columns</label>
                                    <input type="number" name="numCols" id="numCols" placeholder="Columns" min="1">
                                </div>
                                <!-- submit button -->
                                <button class="grid-btn">create table</button>
                        `;

            modal.open({
              title: "Table Form",
              content: `${form.outerHTML}`,
            });
          } else if (blockId.startsWith("carousel")) {
            console.log("inside carousel");

            // GRAPESJS MODAL LOGIC
            const carouselForm = document.createElement("div");
            carouselForm.setAttribute("class", "carousel-form");
            carouselForm.innerHTML = `
                                <div>
                                    <!-- number of slides -->
                                    <label htmlFor="numSlides">Number of slides</label>
                                    <input type="number" name="numSlides" id="numSlides" placeholder="Slides" min="1">
                                </div>
                                <!-- submit button -->
                                <button class="carousel-btn">create carousel</button>
                        `;

            modal.open({
              title: "Carousel Form",
              content: `${carouselForm.outerHTML}`,
            });
          } else if (blockId.startsWith("upload-file")) {
            console.log("inside upload-file");

            const bearerToken = userInfo?.token;

            // createFileUploadButton(editor, bearerToken);
          } else if (blockId.startsWith("arr-nav-carousel")) {
            console.log("inside arr-nav-carousel");

            // GRAPESJS MODAL LOGIC
            const arrNavCarouselForm = document.createElement("div");
            arrNavCarouselForm.setAttribute("class", "carousel-form");
            arrNavCarouselForm.innerHTML = `
                                <div>
                                    <!-- number of slides -->
                                    <label htmlFor="numArrSlides">Number of slides</label>
                                    <input type="number" name="numArrSlides" id="numArrSlides" placeholder="Slides" min="1">
                                </div>
                                <!-- submit button -->
                                <button class="arr-nav-carousel-btn">create carousel</button>
                        `;

            modal.open({
              title: "Carousel Form",
              content: `${arrNavCarouselForm.outerHTML}`,
            });
          } else if (blockId.startsWith("caption-carousel")) {
            console.log("inside caption-carousel");

            // GRAPESJS MODAL LOGIC
            const captionCarouselForm = document.createElement("div");
            captionCarouselForm.setAttribute("class", "carousel-form");
            captionCarouselForm.innerHTML = `
                                <div>
                                    <!-- number of slides -->
                                    <label htmlFor="numCapSlides">Number of slides</label>
                                    <input type="number" name="numCapSlides" id="numCapSlides" placeholder="Slides" min="1">
                                </div>
                                <!-- submit button -->
                                <button class="caption-carousel-btn">create carousel</button>
                        `;

            modal.open({
              title: "Carousel Form",
              content: `${captionCarouselForm.outerHTML}`,
            });
          } else if (blockId.startsWith("dd")) {
            console.log("inside dd");

            // https://mdbootstrap.com/docs/standard/extended/dropdown-multilevel/
            createDropDown(editor);
          }
          // else if (blockId.startsWith("directional-dd")) {
          //   console.log("inside directional-dd");

          //   const directionalDropdownUniqueId = uniqid("ddd-");
          //   console.log(
          //     "creating unique ID for class:",
          //     directionalDropdownUniqueId
          //   );

          //   createDirectionalDropDown(editor, directionalDropdownUniqueId);
          // }
          else if (blockId.startsWith("mob-select")) {
            console.log("inside mob-select");

            createMobSelect(editor);
          } else if (blockId.startsWith("mob-toggle")) {
            console.log("inside mob-toggle");

            createMobToggle(editor);
          }

          // accordion block
          else if (blockId.startsWith("accordion")) {
            console.log("inside accordion");

            // GRAPESJS ACCORDION LOGIC
            const accordionForm = document.createElement("div");
            accordionForm.setAttribute("class", "accordion-form");
            accordionForm.innerHTML = `
                                <div>
                                    <!-- number of items -->
                                    <label htmlFor="numAccordionItems">Number of accordion items</label>
                                    <input type="number" name="numAccordionItems" id="numAccordionItems" placeholder="Items" min="1">
                                </div>
                                <!-- submit button -->
                                <button class="accordion-btn">create accordion</button>
                        `;

            modal.open({
              title: "Accordion Form",
              content: `${accordionForm.outerHTML}`,
            });
          }

          // mob-basic-accordion block
          else if (blockId.startsWith("mob-basic-accordion")) {
            console.log("inside mob-basic-accordion");

            // GRAPESJS ACCORDION LOGIC
            const mobBasicAccordionForm = document.createElement("div");
            mobBasicAccordionForm.setAttribute("class", "accordion-form");
            mobBasicAccordionForm.innerHTML = `
                                <div>
                                    <!-- number of items -->
                                    <label htmlFor="numAccordionItems">Number of accordion items</label>
                                    <input type="number" name="numAccordionItems" id="numAccordionItems" placeholder="Items" min="1">
                                </div>
                                <!-- submit button -->
                                <button class="mobBasicAccordionForm-btn">create accordion</button>
                        `;

            modal.open({
              title: "Accordion Form",
              content: `${mobBasicAccordionForm.outerHTML}`,
            });
          }
          // Basic form
          else if (blockId.startsWith("regularform")) {
            console.log("SETTTTTGINGNGGNGN ======");
          }

          // mob-basic-accordion block
          else if (blockId.startsWith("mob-insetx-basic-accordion")) {
            console.log("inside mob-insetx-basic-accordion");

            // GRAPESJS ACCORDION LOGIC
            const mobInsetXBasicAccordionForm = document.createElement("div");
            mobInsetXBasicAccordionForm.setAttribute("class", "accordion-form");
            mobInsetXBasicAccordionForm.innerHTML = `
                                <div>
                                    <!-- number of items -->
                                    <label htmlFor="numAccordionItems">Number of accordion items</label>
                                    <input type="number" name="numAccordionItems" id="numAccordionItems" placeholder="Items" min="1">
                                </div>
                                <!-- submit button -->
                                <button class="mobInsetXBasicAccordionForm-btn">create accordion</button>
                        `;

            modal.open({
              title: "Accordion Form",
              content: `${mobInsetXBasicAccordionForm.outerHTML}`,
            });
          }

          // mob-multiple-accordion block
          else if (blockId.startsWith("mob-multiple-accordion")) {
            console.log("inside mob-multiple-accordion");

            // GRAPESJS ACCORDION LOGIC
            const mobMultipleAccordionForm = document.createElement("div");
            mobMultipleAccordionForm.setAttribute("class", "accordion-form");
            mobMultipleAccordionForm.innerHTML = `
                                <div>
                                    <!-- number of items -->
                                    <label htmlFor="numAccordionItems">Number of accordion items</label>
                                    <input type="number" name="numAccordionItems" id="numAccordionItems" placeholder="Items" min="1">
                                </div>
                                <!-- submit button -->
                                <button class="mobMultipleAccordionForm-btn">create accordion</button>
                        `;

            modal.open({
              title: "Accordion Form",
              content: `${mobMultipleAccordionForm.outerHTML}`,
            });
          }

          // full-card block
          else if (blockId.startsWith("full-card-one")) {
            console.log("inside full-card-one");

            // GRAPESJS CARD LOGIC (doesn't need modal)
            createFullCard1(editor);
          } else if (blockId.startsWith("full-card-two")) {
            console.log("inside full-card-two");

            // GRAPESJS CARD LOGIC (doesn't need modal)
            createFullCard2(editor);
          }

          // IONIC TABS
          // else if (blockId.startsWith("ionic-tabs")) {
          //   // GRAPESJS CARD LOGIC (doesn't need modal)
          //   createIonicTabs(editor);
          // }

          // IONIC SEARCH BAR
          else if (blockId.startsWith("ionic-search-bar")) {
            // GRAPESJS CARD LOGIC (doesn't need modal)
            createIonicSearchBar(editor);
          }

          // IONIC LIST
          else if (blockId.startsWith("ionic-list")) {
            // GRAPESJS CARD LOGIC (doesn't need modal)
            createIonicList(editor);
          }

          // IONIC MENU
          else if (blockId.startsWith("ionic-menu")) {
            // GRAPESJS CARD LOGIC (doesn't need modal)
            createIonicMenu(editor);
          }

          // IONIC ACTION
          else if (blockId.startsWith("ionic-action")) {
            // GRAPESJS CARD LOGIC (doesn't need modal)
            createIonicAction(editor);
          }

          // IONIC DATE-TIME
          else if (blockId.startsWith("ionic-dateTime")) {
            // GRAPESJS CARD LOGIC (doesn't need modal)
            createIonicDateTime(editor);
          }

          // IONIC FLOATING ACTION BUTTONS
          else if (blockId.startsWith("ionic-floating-action")) {
            // GRAPESJS CARD LOGIC (doesn't need modal)
            createIonicFloatingBtn(editor);
          }

          // IONIC MODAL
          else if (blockId.startsWith("ionic-modal")) {
            // GRAPESJS CARD LOGIC (doesn't need modal)
            createIonicModal(editor);
          }

          // IONIC POPOVER
          else if (blockId.startsWith("ionic-popover")) {
            // GRAPESJS CARD LOGIC (doesn't need modal)
            createIonicPopover(editor);
          }

          // IONIC CHECKBOX
          else if (blockId.startsWith("ionic-checkbox")) {
            // GRAPESJS CARD LOGIC (doesn't need modal)
            createIonicCheckbox(editor);
          }

          // IONIC HEADER
          else if (blockId.startsWith("ionic-header")) {
            // GRAPESJS CARD LOGIC (doesn't need modal)
            createIonicHeader(editor);
          }

          // IONIC FOOTER
          else if (blockId.startsWith("ionic-footer")) {
            // GRAPESJS CARD LOGIC (doesn't need modal)
            createIonicFooter(editor);
          }

          // IONIC CONTENT
          else if (blockId.startsWith("ionic-content")) {
            // GRAPESJS CARD LOGIC (doesn't need modal)
            createIonicContent(editor);
          }

          // IONIC TOGGLE
          else if (blockId.startsWith("ionic-toggle")) {
            // GRAPESJS CARD LOGIC (doesn't need modal)
            createIonicToggle(editor);
          }

          // IONIC TOAST
          else if (blockId.startsWith("ionic-toast")) {
            // GRAPESJS CARD LOGIC (doesn't need modal)
            createIonicToast(editor);
          }

          // IONIC ALERT
          else if (blockId.startsWith("ionic-alert")) {
            // GRAPESJS CARD LOGIC (doesn't need modal)
            createIonicAlert(editor);
          }

          // IONIC SEGMENT
          else if (blockId.startsWith("ionic-segment")) {
            // GRAPESJS CARD LOGIC (doesn't need modal)
            createIonicSegment(editor);
          }

          // IONIC SELECT
          else if (blockId.startsWith("ionic-select")) {
            // GRAPESJS CARD LOGIC (doesn't need modal)
            createIonicSelect(editor);
          }

          // mob-title-card block
          else if (blockId.startsWith("mob-title-card")) {
            console.log("inside mob-title-card");

            // GRAPESJS CARD LOGIC (doesn't need modal)
            createMobTitleCard(editor);
          }

          // title-card block
          else if (blockId.startsWith("title-card")) {
            console.log("inside title-card");

            // GRAPESJS CARD LOGIC (doesn't need modal)
            createTitleCard(editor);
          }

          // mob-segment-button block
          else if (blockId.startsWith("mob-segment-button")) {
            console.log("inside mob-segment-button");

            // GRAPESJS ACCORDION LOGIC
            const mobSegmentBtnForm = document.createElement("div");
            mobSegmentBtnForm.setAttribute("class", "segment-btn-form");
            mobSegmentBtnForm.innerHTML = `
                                <div>
                                    <!-- number of items -->
                                    <label htmlFor="numSegmentBtn">Number of tabs</label>
                                    <input type="number" name="numSegmentBtn" id="numSegmentBtn" placeholder="Tabs" min="1">
                                </div>
                                <!-- submit button -->
                                <button class="mobSegmentBtnForm-btn">create tabs</button>
                        `;

            modal.open({
              title: "Segment Form",
              content: `${mobSegmentBtnForm.outerHTML}`,
            });
          }

          // mob-segment-button block
          else if (blockId.startsWith("mob-individual-segment-button")) {
            console.log("inside mob-individual-segment-button");

            createIndividualSegmentButton(editor);
          }

          // mob-segment-button block
          // else if (blockId.startsWith("mob-tabs")) {
          //   //console.log("inside mob-tabs");

          //   createMobTabs(editor);
          // }

          // template blocks
          else if (blockId.startsWith("template-redSling")) {
            console.log("inside template-redSling");
            // appending template to editor
            editor.addComponents(templateRedsling);
          } else if (blockId.startsWith("template-ecommProductPage")) {
            console.log("inside template-ecommProductPage");
            // appending template to editor
            editor.addComponents(templateEcommProductPage);
          } else if (blockId.startsWith("template-detailsPage")) {
            console.log("inside template-detailsPage");
            // appending template to editor
            editor.addComponents(templateDetailsPage);
          } else if (blockId.startsWith("template-productPage")) {
            console.log("inside template-productPage");
            // appending template to editor
            editor.addComponents(templateProductPage);
          } else if (blockId.startsWith("template-checkoutPage")) {
            console.log("inside template-checkoutPage");
            // appending template to editor
            editor.addComponents(templateCheckoutPage);
          } else if (blockId.startsWith("template-receiptPage")) {
            console.log("inside template-receiptPage");
            // appending template to editor
            editor.addComponents(templateReceiptPage);
          } else if (blockId.startsWith("template-paymentPage")) {
            console.log("inside template-paymentPage");
            // appending template to editor
            editor.addComponents(templatePaymentPage);
          } else if (blockId.startsWith("template-dashboardPage")) {
            console.log("inside template-dashboardPage");
            // appending template to editor
            editor.addComponents(templateDashboardPage);
          } else if (blockId.startsWith("template-addNewProductPage")) {
            console.log("inside template-addNewProductPage");
            // appending template to editor
            editor.addComponents(templateAddNewProductPage);
          }

          // For icons
          else if (blockId.startsWith("fa-icon-palette")) {
            console.log("inside fa-icon-palette");

            // GRAPESJS MODAL LOGIC
            const iconForm = document.createElement("div");
            iconForm.setAttribute("class", "icon-form");
            iconForm.innerHTML = `
                                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" integrity="sha512-SfTiTlX6kk+qitfevl/7LibUOeJWlt9rbyDn92a1DqWOw9vWG2MFoays0sgObmWazO5BQPiFucnnEAjpAB+/Sw==" crossorigin="anonymous" referrerpolicy="no-referrer" />

                                <p>Common Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-bluetooth"></i> fa fa-bluetooth</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-bluetooth-b"></i> fa fa-bluetooth-b</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-codiepie"></i> fa fa-codiepie</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-credit-card-alt"></i>fa fa-credit-card-alt</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-edge"></i>fa fa-edge</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-fort-awesome"></i>fa fa-fort-awesome</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-hashtag"></i>fa fa-hashtag</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-mixcloud"></i>fa fa-mixcloud</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-modx"></i>fa fa-modx</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-pause-circle"></i>fa fa-pause-circle</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-pause-circle-o"></i>fa fa-pause-circle-o</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-percent"></i>fa fa-percent</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-product-hunt"></i>fa fa-product-hunt</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-reddit-alien"></i>fa fa-reddit-alien</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-scribd"></i>fa fa-scribd</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-shopping-bag"></i>fa fa-shopping-bag</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-shopping-basket"></i>fa fa-shopping-basket</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-stop-circle"></i>fa fa-stop-circle</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-stop-circle-o"></i>fa fa-stop-circle-o</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-usb"></i>fa fa-usb</div>
                                </section>

                                <br>

                                <p>Currency Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-bitcoin"></i> fa-bitcoin<span class="text-muted">(alias)</span></div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-btc"></i> fa-btc</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-cny"></i> fa-cny<span class="text-muted">(alias)</span></div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-dollar"></i> fa-dollar <span class="text-muted">(alias)</span></div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-eur"></i> fa-eur</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-euro"></i> fa-euro <span class="text-muted">(alias)</span></div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-gbp"></i> fa-gbp</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-inr"></i> fa-inr</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-jpy"></i> fa-jpy</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-krw"></i> fa-krw</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-money"></i> fa-money</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-rmb"></i> fa-rmb <span class="text-muted">(alias)</span></div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-rouble"></i> fa-rouble <span class="text-muted">(alias)</span></div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-rub"></i> fa-rub</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-ruble"></i> fa-ruble <span class="text-muted">(alias)</span></div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-rupee"></i> fa-rupee <span class="text-muted">(alias)</span></div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-try"></i> fa-try</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-turkish-lira"></i> fa-turkish-lira <span class="text-muted">(alias)</span></div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-usd"></i> fa-usd</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-won"></i> fa-won <span class="text-muted">(alias)</span></div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-yen"></i> fa-yen <span class="text-muted">(alias)</span></div>
                                </section>

                                <br>

                                <p>Web App Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-adjust"></i> fa-adjust</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-anchor"></i> fa-anchor</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-archive"></i> fa-archive</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrows"></i> fa-arrows</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrows-h"></i> fa-arrows-h</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrows-v"></i> fa-arrows-v</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-asterisk"></i> fa-asterisk</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-automobile"></i> fa-automobile <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-ban"></i> fa-ban</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-bank"></i> fa-bank <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-bar-chart-o"></i> fa-bar-chart-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-barcode"></i> fa-barcode</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-bars"></i> fa-bars</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-beer"></i> fa-beer</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-bell"></i> fa-bell</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-bell-o"></i> fa-bell-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-bolt"></i> fa-bolt</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-bomb"></i> fa-bomb</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-book"></i> fa-book</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-bookmark"></i> fa-bookmark</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-bookmark-o"></i> fa-bookmark-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-briefcase"></i> fa-briefcase</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-bug"></i> fa-bug</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-building"></i> fa-building</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-building-o"></i> fa-building-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-bullhorn"></i> fa-bullhorn</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-bullseye"></i> fa-bullseye</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-cab"></i> fa-cab <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-calendar"></i> fa-calendar</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-calendar-o"></i> fa-calendar-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-camera"></i> fa-camera</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-camera-retro"></i> fa-camera-retro</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-car"></i> fa-car</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-caret-square-o-down"></i> fa-caret-square-o-down</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-caret-square-o-left"></i> fa-caret-square-o-left</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-caret-square-o-right"></i> fa-caret-square-o-right</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-caret-square-o-up"></i> fa-caret-square-o-up</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-certificate"></i> fa-certificate</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-check"></i> fa-check</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-check-circle"></i> fa-check-circle</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-check-circle-o"></i> fa-check-circle-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-check-square"></i> fa-check-square</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-check-square-o"></i> fa-check-square-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-child"></i> fa-child</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-circle"></i> fa-circle</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-circle-o"></i> fa-circle-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-circle-o-notch"></i> fa-circle-o-notch</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-circle-thin"></i> fa-circle-thin</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-clock-o"></i> fa-clock-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-cloud"></i> fa-cloud</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-cloud-download"></i> fa-cloud-download</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-cloud-upload"></i> fa-cloud-upload</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-code"></i> fa-code</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-code-fork"></i> fa-code-fork</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-coffee"></i> fa-coffee</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-cog"></i> fa-cog</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-cogs"></i> fa-cogs</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-comment"></i> fa-comment</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-comment-o"></i> fa-comment-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-comments"></i> fa-comments</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-comments-o"></i> fa-comments-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-compass"></i> fa-compass</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-credit-card"></i> fa-credit-card</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-crop"></i> fa-crop</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-crosshairs"></i> fa-crosshairs</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-cube"></i> fa-cube</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-cubes"></i> fa-cubes</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-cutlery"></i> fa-cutlery</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-dashboard"></i> fa-dashboard <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-database"></i> fa-database</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-desktop"></i> fa-desktop</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-dot-circle-o"></i> fa-dot-circle-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-download"></i> fa-download</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-edit"></i> fa-edit <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-ellipsis-h"></i> fa-ellipsis-h</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-ellipsis-v"></i> fa-ellipsis-v</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-envelope"></i> fa-envelope</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-envelope-o"></i> fa-envelope-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-envelope-square"></i> fa-envelope-square</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-eraser"></i> fa-eraser</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-exchange"></i> fa-exchange</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-exclamation"></i> fa-exclamation</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-exclamation-circle"></i> fa-exclamation-circle</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-exclamation-triangle"></i> fa-exclamation-triangle</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-external-link"></i> fa-external-link</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-external-link-square"></i> fa-external-link-square</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-eye"></i> fa-eye</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-eye-slash"></i> fa-eye-slash</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-fax"></i> fa-fax</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-female"></i> fa-female</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-fighter-jet"></i> fa-fighter-jet</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-file-archive-o"></i> fa-file-archive-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-file-audio-o"></i> fa-file-audio-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-file-code-o"></i> fa-file-code-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-file-excel-o"></i> fa-file-excel-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-file-image-o"></i> fa-file-image-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-file-movie-o"></i> fa-file-movie-o <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-file-pdf-o"></i> fa-file-pdf-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-file-photo-o"></i> fa-file-photo-o <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-file-picture-o"></i> fa-file-picture-o <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-file-powerpoint-o"></i> fa-file-powerpoint-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-file-sound-o"></i> fa-file-sound-o <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-file-video-o"></i> fa-file-video-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-file-word-o"></i> fa-file-word-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-file-zip-o"></i> fa-file-zip-o <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-film"></i> fa-film</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-filter"></i> fa-filter</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-fire"></i> fa-fire</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-fire-extinguisher"></i> fa-fire-extinguisher</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-flag"></i> fa-flag</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-flag-checkered"></i> fa-flag-checkered</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-flag-o"></i> fa-flag-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-flash"></i> fa-flash <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-flask"></i> fa-flask</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-folder"></i> fa-folder</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-folder-o"></i> fa-folder-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-folder-open"></i> fa-folder-open</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-folder-open-o"></i> fa-folder-open-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-frown-o"></i> fa-frown-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-gamepad"></i> fa-gamepad</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-gavel"></i> fa-gavel</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-gear"></i> fa-gear <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-gears"></i> fa-gears <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-gift"></i> fa-gift</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-glass"></i> fa-glass</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-globe"></i> fa-globe</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-graduation-cap"></i> fa-graduation-cap</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-group"></i> fa-group <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-hdd-o"></i> fa-hdd-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-headphones"></i> fa-headphones</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-heart"></i> fa-heart</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-heart-o"></i> fa-heart-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-history"></i> fa-history</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-home"></i> fa-home</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-image"></i> fa-image <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-inbox"></i> fa-inbox</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-info"></i> fa-info</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-info-circle"></i> fa-info-circle</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-institution"></i> fa-institution <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-key"></i> fa-key</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-keyboard-o"></i> fa-keyboard-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-language"></i> fa-language</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-laptop"></i> fa-laptop</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-leaf"></i> fa-leaf</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-legal"></i> fa-legal <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-lemon-o"></i> fa-lemon-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-level-down"></i> fa-level-down</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-level-up"></i> fa-level-up</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-life-bouy"></i> fa-life-bouy <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-life-ring"></i> fa-life-ring</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-life-saver"></i> fa-life-saver <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-lightbulb-o"></i> fa-lightbulb-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-location-arrow"></i> fa-location-arrow</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-lock"></i> fa-lock</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-magic"></i> fa-magic</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-magnet"></i> fa-magnet</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-mail-forward"></i> fa-mail-forward <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-mail-reply"></i> fa-mail-reply <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-mail-reply-all"></i> fa-mail-reply-all <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-male"></i> fa-male</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-map-marker"></i> fa-map-marker</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-meh-o"></i> fa-meh-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-microphone"></i> fa-microphone</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-microphone-slash"></i> fa-microphone-slash</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-minus"></i> fa-minus</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-minus-circle"></i> fa-minus-circle</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-minus-square"></i> fa-minus-square</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-minus-square-o"></i> fa-minus-square-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-mobile"></i> fa-mobile</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-mobile-phone"></i> fa-mobile-phone <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-money"></i> fa-money</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-moon-o"></i> fa-moon-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-mortar-board"></i> fa-mortar-board <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-music"></i> fa-music</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-navicon"></i> fa-navicon <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-paper-plane"></i> fa-paper-plane</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-paper-plane-o"></i> fa-paper-plane-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-paw"></i> fa-paw</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-pencil"></i> fa-pencil</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-pencil-square"></i> fa-pencil-square</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-pencil-square-o"></i> fa-pencil-square-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-phone"></i> fa-phone</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-phone-square"></i> fa-phone-square</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-photo"></i> fa-photo <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-picture-o"></i> fa-picture-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-plane"></i> fa-plane</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-plus"></i> fa-plus</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-plus-circle"></i> fa-plus-circle</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-plus-square"></i> fa-plus-square</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-plus-square-o"></i> fa-plus-square-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-power-off"></i> fa-power-off</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-print"></i> fa-print</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-puzzle-piece"></i> fa-puzzle-piece</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-qrcode"></i> fa-qrcode</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-question"></i> fa-question</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-question-circle"></i> fa-question-circle</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-quote-left"></i> fa-quote-left</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-quote-right"></i> fa-quote-right</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-random"></i> fa-random</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-recycle"></i> fa-recycle</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-refresh"></i> fa-refresh</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-reorder"></i> fa-reorder <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-reply"></i> fa-reply</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-reply-all"></i> fa-reply-all</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-retweet"></i> fa-retweet</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-road"></i> fa-road</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-rocket"></i> fa-rocket</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-rss"></i> fa-rss</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-rss-square"></i> fa-rss-square</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-search"></i> fa-search</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-search-minus"></i> fa-search-minus</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-search-plus"></i> fa-search-plus</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-send"></i> fa-send <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-send-o"></i> fa-send-o <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-share"></i> fa-share</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-share-alt"></i> fa-share-alt</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-share-alt-square"></i> fa-share-alt-square</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-share-square"></i> fa-share-square</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-share-square-o"></i> fa-share-square-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-shield"></i> fa-shield</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-shopping-cart"></i> fa-shopping-cart</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-sign-in"></i> fa-sign-in</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-sign-out"></i> fa-sign-out</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-signal"></i> fa-signal</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-sitemap"></i> fa-sitemap</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-sliders"></i> fa-sliders</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-smile-o"></i> fa-smile-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-sort"></i> fa-sort</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-sort-alpha-asc"></i> fa-sort-alpha-asc</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-sort-alpha-desc"></i> fa-sort-alpha-desc</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-sort-amount-asc"></i> fa-sort-amount-asc</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-sort-amount-desc"></i> fa-sort-amount-desc</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-sort-asc"></i> fa-sort-asc</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-sort-desc"></i> fa-sort-desc</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-sort-down"></i> fa-sort-down <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-sort-numeric-asc"></i> fa-sort-numeric-asc</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-sort-numeric-desc"></i> fa-sort-numeric-desc</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-sort-up"></i> fa-sort-up <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-space-shuttle"></i> fa-space-shuttle</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-spinner"></i> fa-spinner</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-spoon"></i> fa-spoon</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-square"></i> fa-square</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-square-o"></i> fa-square-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-star"></i> fa-star</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-star-half"></i> fa-star-half</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-star-half-empty"></i> fa-star-half-empty <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-star-half-full"></i> fa-star-half-full <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-star-half-o"></i> fa-star-half-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-star-o"></i> fa-star-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-suitcase"></i> fa-suitcase</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-sun-o"></i> fa-sun-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-support"></i> fa-support <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-tablet"></i> fa-tablet</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-tachometer"></i> fa-tachometer</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-tag"></i> fa-tag</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-tags"></i> fa-tags</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-tasks"></i> fa-tasks</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-taxi"></i> fa-taxi</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-terminal"></i> fa-terminal</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-thumb-tack"></i> fa-thumb-tack</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-thumbs-down"></i> fa-thumbs-down</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-thumbs-o-down"></i> fa-thumbs-o-down</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-thumbs-o-up"></i> fa-thumbs-o-up</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-thumbs-up"></i> fa-thumbs-up</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-ticket"></i> fa-ticket</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-times"></i> fa-times</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-times-circle"></i> fa-times-circle</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-times-circle-o"></i> fa-times-circle-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-tint"></i> fa-tint</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-toggle-down"></i> fa-toggle-down <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-toggle-left"></i> fa-toggle-left <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-toggle-right"></i> fa-toggle-right <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-toggle-up"></i> fa-toggle-up <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-trash-o"></i> fa-trash-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-tree"></i> fa-tree</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-trophy"></i> fa-trophy</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-truck"></i> fa-truck</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-umbrella"></i> fa-umbrella</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-university"></i> fa-university</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-unlock"></i> fa-unlock</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-unlock-alt"></i> fa-unlock-alt</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-unsorted"></i> fa-unsorted <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-upload"></i> fa-upload</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-user"></i> fa-user</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-users"></i> fa-users</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-video-camera"></i> fa-video-camera</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-volume-down"></i> fa-volume-down</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-volume-off"></i> fa-volume-off</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-volume-up"></i> fa-volume-up</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-warning"></i> fa-warning <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-wheelchair"></i> fa-wheelchair</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-wrench"></i> fa-wrench</div>
                                </section>

                                <br>

                                <p>Spinner Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-spin fa-circle-o-notch"></i> fa-circle-o-notch</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-spin fa-cog"></i> fa-cog</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-spin fa-gear"></i> fa-gear <span class="text-muted">(alias)</span></div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-spin fa-refresh"></i> fa-refresh</div>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-spin fa-spinner"></i> fa-spinner</div>
                                </section>

                                <br>

                                <p>Form Control Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-check-square"></i> fa-check-square</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-check-square-o"></i> fa-check-square-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-circle"></i> fa-circle</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-circle-o"></i> fa-circle-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-dot-circle-o"></i> fa-dot-circle-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-minus-square"></i> fa-minus-square</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-minus-square-o"></i> fa-minus-square-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-plus-square"></i> fa-plus-square</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-plus-square-o"></i> fa-plus-square-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-square"></i> fa-square</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-square-o"></i> fa-square-o</div>
                                </section>

                                <br>

                                <p>Text Editor Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-align-center"></i> fa-align-center</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-align-justify"></i> fa-align-justify</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-align-left"></i> fa-align-left</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-align-right"></i> fa-align-right</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-bold"></i> fa-bold</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-chain"></i> fa-chain <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-chain-broken"></i> fa-chain-broken</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-clipboard"></i> fa-clipboard</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-columns"></i> fa-columns</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-copy"></i> fa-copy <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-cut"></i> fa-cut <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-dedent"></i> fa-dedent <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-eraser"></i> fa-eraser</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-file"></i> fa-file</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-file-o"></i> fa-file-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-file-text"></i> fa-file-text</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-file-text-o"></i> fa-file-text-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-files-o"></i> fa-files-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-floppy-o"></i> fa-floppy-o</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-font"></i> fa-font</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-header"></i> fa-header</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-indent"></i> fa-indent</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-italic"></i> fa-italic</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-link"></i> fa-link</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-list"></i> fa-list</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-list-alt"></i> fa-list-alt</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-list-ol"></i> fa-list-ol</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-list-ul"></i> fa-list-ul</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-outdent"></i> fa-outdent</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-paperclip"></i> fa-paperclip</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-paragraph"></i> fa-paragraph</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-paste"></i> fa-paste <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-repeat"></i> fa-repeat</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-rotate-left"></i> fa-rotate-left <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-rotate-right"></i> fa-rotate-right <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-save"></i> fa-save <span class="text-muted">(alias)</span></div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-scissors"></i> fa-scissors</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-strikethrough"></i> fa-strikethrough</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-subscript"></i> fa-subscript</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-superscript"></i> fa-superscript</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-table"></i> fa-table</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-text-height"></i> fa-text-height</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-text-width"></i> fa-text-width</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-th"></i> fa-th</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-th-large"></i> fa-th-large</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-th-list"></i> fa-th-list</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-underline"></i> fa-underline</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-undo"></i> fa-undo</div>
                                  <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-unlink"></i> fa-unlink <span class="text-muted">(alias)</span></div>
                                </section>

                                <br>

                                <p>Directional Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-angle-double-down"></i> fa-angle-double-down</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-angle-double-left"></i> fa-angle-double-left</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-angle-double-right"></i> fa-angle-double-right</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-angle-double-up"></i> fa-angle-double-up</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-angle-down"></i> fa-angle-down</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-angle-left"></i> fa-angle-left</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-angle-right"></i> fa-angle-right</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-angle-up"></i> fa-angle-up</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrow-circle-down"></i> fa-arrow-circle-down</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrow-circle-left"></i> fa-arrow-circle-left</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrow-circle-o-down"></i> fa-arrow-circle-o-down</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrow-circle-o-left"></i> fa-arrow-circle-o-left</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrow-circle-o-right"></i> fa-arrow-circle-o-right</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrow-circle-o-up"></i> fa-arrow-circle-o-up</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrow-circle-right"></i> fa-arrow-circle-right</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrow-circle-up"></i> fa-arrow-circle-up</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrow-down"></i> fa-arrow-down</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrow-left"></i> fa-arrow-left</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrow-right"></i> fa-arrow-right</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrow-up"></i> fa-arrow-up</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrows"></i> fa-arrows</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrows-alt"></i> fa-arrows-alt</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrows-h"></i> fa-arrows-h</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrows-v"></i> fa-arrows-v</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-caret-down"></i> fa-caret-down</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-caret-left"></i> fa-caret-left</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-caret-right"></i> fa-caret-right</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-caret-up"></i> fa-caret-up</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-caret-square-o-left"></i> fa-caret-square-o-left</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-caret-square-o-right"></i> fa-caret-square-o-right</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-caret-square-o-up"></i> fa-caret-square-o-up</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-caret-square-o-down"></i> fa-caret-square-o-down</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-chevron-circle-down"></i> fa-chevron-circle-down</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-chevron-circle-left"></i> fa-chevron-circle-left</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-chevron-circle-right"></i> fa-chevron-circle-right</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-chevron-circle-up"></i> fa-chevron-circle-up</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-chevron-down"></i> fa-chevron-down</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-chevron-left"></i> fa-chevron-left</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-chevron-right"></i> fa-chevron-right</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-chevron-up"></i> fa-chevron-up</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-hand-o-down"></i> fa-hand-o-down</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-hand-o-left"></i> fa-hand-o-left</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-hand-o-right"></i> fa-hand-o-right</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-hand-o-up"></i> fa-hand-o-up</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-long-arrow-down"></i> fa-long-arrow-down</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-long-arrow-left"></i> fa-long-arrow-left</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-long-arrow-right"></i> fa-long-arrow-right</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-long-arrow-up"></i> fa-long-arrow-up</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-toggle-down"></i> fa-toggle-down <span class="text-muted">(alias)</span></div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-toggle-left"></i> fa-toggle-left <span class="text-muted">(alias)</span></div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-toggle-right"></i> fa-toggle-right <span class="text-muted">(alias)</span></div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-toggle-up"></i> fa-toggle-up <span class="text-muted">(alias)</span></div>
                                </section>

                                <br>

                                <p>Video Player Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-arrows-alt"></i> fa-arrows-alt</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-backward"></i> fa-backward</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-compress"></i> fa-compress</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-eject"></i> fa-eject</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-expand"></i> fa-expand</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-fast-backward"></i> fa-fast-backward</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-fast-forward"></i> fa-fast-forward</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-forward"></i> fa-forward</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-pause"></i> fa-pause</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-play"></i> fa-play</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-play-circle"></i> fa-play-circle</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-play-circle-o"></i> fa-play-circle-o</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-step-backward"></i> fa-step-backward</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-step-forward"></i> fa-step-forward</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-stop"></i> fa-stop</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-youtube-play"></i> fa-youtube-play</div>
                                </section>

                                <br>

                                <p>Brand Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-adn"></i> fa-adn</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-android"></i> fa-android</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-apple"></i> fa-apple</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-behance"></i> fa-behance</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-behance-square"></i> fa-behance-square</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-bitbucket"></i> fa-bitbucket</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-bitbucket-square"></i> fa-bitbucket-square</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-bitcoin"></i> fa-bitcoin <span class="text-muted">(alias)</span></div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-btc"></i> fa-btc</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-codepen"></i> fa-codepen</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-css3"></i> fa-css3</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-delicious"></i> fa-delicious</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-deviantart"></i> fa-deviantart</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-digg"></i> fa-digg</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-dribbble"></i> fa-dribbble</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-dropbox"></i> fa-dropbox</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-drupal"></i> fa-drupal</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-empire"></i> fa-empire</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-facebook"></i> fa-facebook</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-facebook-square"></i> fa-facebook-square</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-flickr"></i> fa-flickr</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-foursquare"></i> fa-foursquare</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-ge"></i> fa-ge <span class="text-muted">(alias)</span></div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-git"></i> fa-git</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-git-square"></i> fa-git-square</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-github"></i> fa-github</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-github-alt"></i> fa-github-alt</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-github-square"></i> fa-github-square</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-gittip"></i> fa-gittip</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-google"></i> fa-google</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-google-plus"></i> fa-google-plus</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-google-plus-square"></i> fa-google-plus-square</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-hacker-news"></i> fa-hacker-news</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-html5"></i> fa-html5</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-instagram"></i> fa-instagram</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-joomla"></i> fa-joomla</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-jsfiddle"></i> fa-jsfiddle</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-linkedin"></i> fa-linkedin</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-linkedin-square"></i> fa-linkedin-square</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-linux"></i> fa-linux</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-maxcdn"></i> fa-maxcdn</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-openid"></i> fa-openid</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-pagelines"></i> fa-pagelines</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-pied-piper"></i> fa-pied-piper</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-pied-piper-alt"></i> fa-pied-piper-alt</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-pinterest"></i> fa-pinterest</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-pinterest-square"></i> fa-pinterest-square</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-qq"></i> fa-qq</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-ra"></i> fa-ra <span class="text-muted">(alias)</span></div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-rebel"></i> fa-rebel</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-reddit"></i> fa-reddit</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-reddit-square"></i> fa-reddit-square</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-renren"></i> fa-renren</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-share-alt"></i> fa-share-alt</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-share-alt-square"></i> fa-share-alt-square</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-skype"></i> fa-skype</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-slack"></i> fa-slack</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-soundcloud"></i> fa-soundcloud</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-spotify"></i> fa-spotify</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-stack-exchange"></i> fa-stack-exchange</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-stack-overflow"></i> fa-stack-overflow</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-steam"></i> fa-steam</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-steam-square"></i> fa-steam-square</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-stumbleupon"></i> fa-stumbleupon</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-stumbleupon-circle"></i> fa-stumbleupon-circle</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-tencent-weibo"></i> fa-tencent-weibo</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-trello"></i> fa-trello</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-tumblr"></i> fa-tumblr</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-tumblr-square"></i> fa-tumblr-square</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-twitter"></i> fa-twitter</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-twitter-square"></i> fa-twitter-square</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-vimeo-square"></i> fa-vimeo-square</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-vine"></i> fa-vine</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-vk"></i> fa-vk</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-wechat"></i> fa-wechat <span class="text-muted">(alias)</span></div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-weibo"></i> fa-weibo</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-weixin"></i> fa-weixin</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-windows"></i> fa-windows</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-wordpress"></i> fa-wordpress</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-xing"></i> fa-xing</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-xing-square"></i> fa-xing-square</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-yahoo"></i> fa-yahoo</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-youtube"></i> fa-youtube</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-youtube-play"></i> fa-youtube-play</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-youtube-square"></i> fa-youtube-square</div>
                                </section>

                                <br>

                                <p>Medical Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-ambulance"></i> fa-ambulance</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-h-square"></i> fa-h-square</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-hospital-o"></i> fa-hospital-o</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-medkit"></i> fa-medkit</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-plus-square"></i> fa-plus-square</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-stethoscope"></i> fa-stethoscope</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-user-md"></i> fa-user-md</div>
                                      <div class="col-sm-6 col-md-4 col-xl-3"><i class="fa fa-wheelchair"></i> fa-wheelchair</div>
                                </section>
                        `;

            modal.open({
              title: "Icon Palette",
              content: `${iconForm.outerHTML}`,
            });
          } else if (blockId.startsWith("ico-icon-palette")) {
            console.log("inside ico-icon-palette");

            // GRAPESJS MODAL LOGIC
            const iconForm = document.createElement("div");
            iconForm.setAttribute("class", "icon-form");
            iconForm.innerHTML = `
                                <link rel="stylesheet" type="text/css" href="/assets/css/icofont.css">

                                <p>Abstract Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-angry-monster"></i>angry-monster</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bathtub"></i>bathtub</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bird-wings"></i>bird-wings</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bow"></i>bow</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brain-alt"></i>brain-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-butterfly-alt"></i>butterfly-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-castle"></i>castle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-circuit"></i>circuit</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-dart"></i>dart</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-dice-alt"></i>dice-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-disability-race"></i>disability-race</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-diving-goggle"></i>diving-goggle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-fire-alt"></i>fire-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-flame-torch"></i>flame-torch</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-flora"></i>flora</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-flora-flower"></i>flora-flower</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-gift-box"></i>gift-box</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-halloween-pumpkin"></i>halloween-pumpkin</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hand-power"></i>hand-power</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hand-thunder"></i>hand-thunder</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-king-crown"></i>king-crown</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-king-monster"></i>king-monster</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-love"></i>love</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-magician-hat"></i>magician-hat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-native-american"></i>native-american</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-open-eye"></i>open-eye</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-owl-look"></i>owl-look</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-phoenix"></i>phoenix</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-queen-crown"></i>queen-crown</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-robot-face"></i>robot-face</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sand-clock"></i>sand-clock</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-shield-alt"></i>shield-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ship-wheel"></i>ship-wheel</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-skull-danger"></i>skull-danger</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-skull-face"></i>skull-face</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snail"></i>snail</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snow-alt"></i>snow-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snow-flake"></i>snow-flake</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snowmobile"></i>snowmobile</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-space-shuttle"></i>space-shuttle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-star-shape"></i>star-shape</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-swirl"></i>swirl</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tattoo-wing"></i>tattoo-wing</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-throne"></i>throne</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-touch"></i>touch</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tree-alt"></i>tree-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-triangle"></i>triangle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-unity-hand"></i>unity-hand</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-weed"></i>weed</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-woman-bird"></i>woman-bird</div>
                                </section>

                                <br>

                                <p>Animal Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-bat"></i>animal-bat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-bear"></i>animal-bear</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-bear-tracks"></i>animal-bear-tracks</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-bird"></i>animal-bird</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-bird-alt"></i>animal-bird-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-bone"></i>animal-bone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-bull"></i>animal-bull</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-camel"></i>animal-camel</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-camel-alt"></i>animal-camel-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-camel-head"></i>animal-camel-head</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-cat"></i>animal-cat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-cat-alt-1"></i>animal-cat-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-cat-alt-2"></i>animal-cat-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-cat-alt-3"></i>animal-cat-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-cat-alt-4"></i>animal-cat-alt-4</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-cat-with-dog"></i>animal-cat-with-dog</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-cow"></i>animal-cow</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-cow-head"></i>animal-cow-head</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-crab"></i>animal-crab</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-crocodile"></i>animal-crocodile</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-deer-head"></i>animal-deer-head</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-dog"></i>animal-dog</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-dog-alt"></i>animal-dog-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-dog-barking"></i>animal-dog-barking</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-dolphin"></i>animal-dolphin</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-duck-tracks"></i>animal-duck-tracks</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-eagle-head"></i>animal-eagle-head</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-eaten-fish"></i>animal-eaten-fish</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-elephant"></i>animal-elephant</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-elephant-alt"></i>animal-elephant-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-elephant-head"></i>animal-elephant-head</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-elephant-head-alt"></i>animal-elephant-head-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-elk"></i>animal-elk</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-fish"></i>animal-fish</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-fish-alt-1"></i>animal-fish-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-fish-alt-2"></i>animal-fish-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-fish-alt-3"></i>animal-fish-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-fish-alt-4"></i>animal-fish-alt-4</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-fox"></i>animal-fox</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-fox-alt"></i>animal-fox-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-frog"></i>animal-frog</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-frog-tracks"></i>animal-frog-tracks</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-froggy"></i>animal-froggy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-giraffe"></i>animal-giraffe</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-giraffe-alt"></i>animal-giraffe-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-goat-head"></i>animal-goat-head</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-goat-head-alt-1"></i>animal-goat-head-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-goat-head-alt-2"></i>animal-goat-head-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-gorilla"></i>animal-gorilla</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-hen-tracks"></i>animal-hen-tracks</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-horse-head"></i>animal-horse-head</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-horse-head-alt-1"></i>animal-horse-head-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-horse-head-alt-2"></i>animal-horse-head-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-horse-tracks"></i>animal-horse-tracks</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-jellyfish"></i>animal-jellyfish</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-kangaroo"></i>animal-kangaroo</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-lemur"></i>animal-lemur</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-lion"></i>animal-lion</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-lion-alt"></i>animal-lion-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-lion-head"></i>animal-lion-head</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-lion-head-alt"></i>animal-lion-head-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-monkey"></i>animal-monkey</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-monkey-alt-1"></i>animal-monkey-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-monkey-alt-2"></i>animal-monkey-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-monkey-alt-3"></i>animal-monkey-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-octopus"></i>animal-octopus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-octopus-alt"></i>animal-octopus-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-owl"></i>animal-owl</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-panda"></i>animal-panda</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-panda-alt"></i>animal-panda-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-panther"></i>animal-panther</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-parrot"></i>animal-parrot</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-parrot-lip"></i>animal-parrot-lip</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-paw"></i>animal-paw</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-pelican"></i>animal-pelican</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-penguin"></i>animal-penguin</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-pig"></i>animal-pig</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-pig-alt"></i>animal-pig-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-pigeon"></i>animal-pigeon</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-pigeon-alt"></i>animal-pigeon-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-pigeons"></i>animal-pigeons</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-rabbit-running"></i>animal-rabbit-running</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-rat-alt"></i>animal-rat-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-rhino"></i>animal-rhino</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-rhino-head"></i>animal-rhino-head</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-rooster"></i>animal-rooster</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-seahorse"></i>animal-seahorse</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-seal"></i>animal-seal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-shrimp"></i>animal-shrimp</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-snail"></i>animal-snail</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-snail-alt-1"></i>animal-snail-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-snail-alt-2"></i>animal-snail-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-snake"></i>animal-snake</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-squid"></i>animal-squid</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-squirrel"></i>animal-squirrel</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-tiger"></i>animal-tiger</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-tiger-alt"></i>animal-tiger-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-turtle"></i>animal-turtle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-whale"></i>animal-whale</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-woodpecker"></i>animal-woodpecker</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-animal-zebra"></i>animal-zebra</div>
                                </section>

                                <br>

                                <p>Brand Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-acer"></i>brand-acer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-adidas"></i>brand-adidas</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-adobe"></i>brand-adobe</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-air-new-zealand"></i>brand-air-new-zealand</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-airbnb"></i>brand-airbnb</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-aircell"></i>brand-aircell</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-airtel"></i>brand-airtel</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-alcatel"></i>brand-alcatel</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-alibaba"></i>brand-alibaba</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-aliexpress"></i>brand-aliexpress</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-alipay"></i>brand-alipay</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-amazon"></i>brand-amazon</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-amd"></i>brand-amd</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-american-airlines"></i>brand-american-airlines</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-android"></i>brand-android</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-android-robot"></i>brand-android-robot</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-aol"></i>brand-aol</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-apple"></i>brand-apple</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-appstore"></i>brand-appstore</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-asus"></i>brand-asus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-ati"></i>brand-ati</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-att"></i>brand-att</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-audi"></i>brand-audi</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-axiata"></i>brand-axiata</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-bada"></i>brand-bada</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-bbc"></i>brand-bbc</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-bing"></i>brand-bing</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-blackberry"></i>brand-blackberry</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-bmw"></i>brand-bmw</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-box"></i>brand-box</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-burger-king"></i>brand-burger-king</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-business-insider"></i>brand-business-insider</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-buzzfeed"></i>brand-buzzfeed</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-cannon"></i>brand-cannon</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-casio"></i>brand-casio</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-china-mobile"></i>brand-china-mobile</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-china-telecom"></i>brand-china-telecom</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-china-unicom"></i>brand-china-unicom</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-cisco"></i>brand-cisco</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-citibank"></i>brand-citibank</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-cnet"></i>brand-cnet</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-cnn"></i>brand-cnn</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-cocal-cola"></i>brand-cocal-cola</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-compaq"></i>brand-compaq</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-copy"></i>brand-copy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-debian"></i>brand-debian</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-delicious"></i>brand-delicious</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-dell"></i>brand-dell</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-designbump"></i>brand-designbump</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-designfloat"></i>brand-designfloat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-disney"></i>brand-disney</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-dodge"></i>brand-dodge</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-dove"></i>brand-dove</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-ebay"></i>brand-ebay</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-eleven"></i>brand-eleven</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-emirates"></i>brand-emirates</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-espn"></i>brand-espn</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-etihad-airways"></i>brand-etihad-airways</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-etisalat"></i>brand-etisalat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-etsy"></i>brand-etsy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-facebook"></i>brand-facebook</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-fastrack"></i>brand-fastrack</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-fedex"></i>brand-fedex</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-ferrari"></i>brand-ferrari</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-fitbit"></i>brand-fitbit</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-flikr"></i>brand-flikr</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-forbes"></i>brand-forbes</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-foursquare"></i>brand-foursquare</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-fox"></i>brand-fox</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-foxconn"></i>brand-foxconn</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-fujitsu"></i>brand-fujitsu</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-general-electric"></i>brand-general-electric</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-gillette"></i>brand-gillette</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-gizmodo"></i>brand-gizmodo</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-gnome"></i>brand-gnome</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-google"></i>brand-google</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-gopro"></i>brand-gopro</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-gucci"></i>brand-gucci</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-hallmark"></i>brand-hallmark</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-hi5"></i>brand-hi5</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-honda"></i>brand-honda</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-hp"></i>brand-hp</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-hsbc"></i>brand-hsbc</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-htc"></i>brand-htc</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-huawei"></i>brand-huawei</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-hulu"></i>brand-hulu</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-hyundai"></i>brand-hyundai</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-ibm"></i>brand-ibm</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-icofont"></i>brand-icofont</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-icq"></i>brand-icq</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-ikea"></i>brand-ikea</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-imdb"></i>brand-imdb</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-indiegogo"></i>brand-indiegogo</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-intel"></i>brand-intel</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-ipair"></i>brand-ipair</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-jaguar"></i>brand-jaguar</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-java"></i>brand-java</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-joomla"></i>brand-joomla</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-joomshaper"></i>brand-joomshaper</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-kickstarter"></i>brand-kickstarter</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-kik"></i>brand-kik</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-lastfm"></i>brand-lastfm</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-lego"></i>brand-lego</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-lenovo"></i>brand-lenovo</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-levis"></i>brand-levis</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-lexus"></i>brand-lexus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-lg"></i>brand-lg</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-life-hacker"></i>brand-life-hacker</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-line-messenger"></i>brand-line-messenger</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-linkedin"></i>brand-linkedin</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-linux"></i>brand-linux</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-linux-mint"></i>brand-linux-mint</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-lionix"></i>brand-lionix</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-live-messenger"></i>brand-live-messenger</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-loreal"></i>brand-loreal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-louis-vuitton"></i>brand-louis-vuitton</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-mac-os"></i>brand-mac-os</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-marvel-app"></i>brand-marvel-app</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-mashable"></i>brand-mashable</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-mazda"></i>brand-mazda</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-mcdonals"></i>brand-mcdonals</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-mercedes"></i>brand-mercedes</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-micromax"></i>brand-micromax</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-microsoft"></i>brand-microsoft</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-mobileme"></i>brand-mobileme</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-mobily"></i>brand-mobily</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-motorola"></i>brand-motorola</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-msi"></i>brand-msi</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-mts"></i>brand-mts</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-myspace"></i>brand-myspace</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-mytv"></i>brand-mytv</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-nasa"></i>brand-nasa</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-natgeo"></i>brand-natgeo</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-nbc"></i>brand-nbc</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-nescafe"></i>brand-nescafe</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-nestle"></i>brand-nestle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-netflix"></i>brand-netflix</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-nexus"></i>brand-nexus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-nike"></i>brand-nike</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-nokia"></i>brand-nokia</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-nvidia"></i>brand-nvidia</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-omega"></i>brand-omega</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-opensuse"></i>brand-opensuse</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-oracle"></i>brand-oracle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-panasonic"></i>brand-panasonic</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-paypal"></i>brand-paypal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-pepsi"></i>brand-pepsi</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-philips"></i>brand-philips</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-pizza-hut"></i>brand-pizza-hut</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-playstation"></i>brand-playstation</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-puma"></i>brand-puma</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-qatar-air"></i>brand-qatar-air</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-qvc"></i>brand-qvc</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-readernaut"></i>brand-readernaut</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-redbull"></i>brand-redbull</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-reebok"></i>brand-reebok</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-reuters"></i>brand-reuters</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-samsung"></i>brand-samsung</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-sap"></i>brand-sap</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-saudia-airlines"></i>brand-saudia-airlines</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-scribd"></i>brand-scribd</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-shell"></i>brand-shell</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-siemens"></i>brand-siemens</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-sk-telecom"></i>brand-sk-telecom</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-slideshare"></i>brand-slideshare</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-smashing-magazine"></i>brand-smashing-magazine</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-snapchat"></i>brand-snapchat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-sony"></i>brand-sony</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-sony-ericsson"></i>brand-sony-ericsson</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-soundcloud"></i>brand-soundcloud</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-sprint"></i>brand-sprint</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-squidoo"></i>brand-squidoo</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-starbucks"></i>brand-starbucks</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-stc"></i>brand-stc</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-steam"></i>brand-steam</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-suzuki"></i>brand-suzuki</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-symbian"></i>brand-symbian</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-t-mobile"></i>brand-t-mobile</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-tango"></i>brand-tango</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-target"></i>brand-target</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-tata-indicom"></i>brand-tata-indicom</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-techcrunch"></i>brand-techcrunch</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-telenor"></i>brand-telenor</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-teliasonera"></i>brand-teliasonera</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-tesla"></i>brand-tesla</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-the-verge"></i>brand-the-verge</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-thenextweb"></i>brand-thenextweb</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-toshiba"></i>brand-toshiba</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-toyota"></i>brand-toyota</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-tribenet"></i>brand-tribenet</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-ubuntu"></i>brand-ubuntu</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-unilever"></i>brand-unilever</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-vaio"></i>brand-vaio</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-verizon"></i>brand-verizon</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-viber"></i>brand-viber</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-vodafone"></i>brand-vodafone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-volkswagen"></i>brand-volkswagen</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-walmart"></i>brand-walmart</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-warnerbros"></i>brand-warnerbros</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-whatsapp"></i>brand-whatsapp</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-wikipedia"></i>brand-wikipedia</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-windows"></i>brand-windows</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-wire"></i>brand-wire</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-wordpress"></i>brand-wordpress</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-xiaomi"></i>brand-xiaomi</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-yahoobuzz"></i>brand-yahoobuzz</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-yamaha"></i>brand-yamaha</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-youtube"></i>brand-youtube</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-zain"></i>brand-zain</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-envato"></i>social-envato</div>
                                </section>

                                <br>

                                <p>Business Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bank-alt"></i>bank-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-barcode"></i>barcode</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-basket"></i>basket</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bill-alt"></i>bill-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-billboard"></i>billboard</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-briefcase-alt-1"></i>briefcase-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-briefcase-alt-2"></i>briefcase-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-building-alt"></i>building-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-businessman"></i>businessman</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-businesswoman"></i>businesswoman</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cart-alt"></i>cart-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-chair"></i>chair</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-clip"></i>clip</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-coins"></i>coins</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-company"></i>company</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-contact-add"></i>contact-add</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-deal"></i>deal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-files"></i>files</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-growth"></i>growth</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-id-card"></i>id-card</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-idea"></i>idea</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-list"></i>list</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-meeting-add"></i>meeting-add</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-money-bag"></i>money-bag</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-people"></i>people</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pie-chart"></i>pie-chart</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-presentation-alt"></i>presentation-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-stamp"></i>stamp</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-stock-mobile"></i>stock-mobile</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-support"></i>support</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tasks-alt"></i>tasks-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wheel"></i>wheel</div>
                                </section>

                                <br>

                                <p>Chart Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-chart-arrows-axis"></i>chart-arrows-axis</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-chart-bar-graph"></i>chart-bar-graph</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-chart-flow"></i>chart-flow</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-chart-flow-alt-1"></i>chart-flow-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-chart-flow-alt-2"></i>chart-flow-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-chart-histogram"></i>chart-histogram</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-chart-histogram-alt"></i>chart-histogram-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-chart-line"></i>chart-line</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-chart-line-alt"></i>chart-line-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-chart-pie"></i>chart-pie</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-chart-pie-alt"></i>chart-pie-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-chart-radar-graph"></i>chart-radar-graph</div>
                                </section>

                                <br>

                                <p>Construction Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-architecture"></i>architecture</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-architecture-alt"></i>architecture-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-barricade"></i>barricade</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bricks"></i>bricks</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-calculations"></i>calculations</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cement-mix"></i>cement-mix</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cement-mixer"></i>cement-mixer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-danger-zone"></i>danger-zone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-drill"></i>drill</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-eco-energy"></i>eco-energy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-eco-environmen"></i>eco-environmen</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-energy-air"></i>energy-air</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-energy-oil"></i>energy-oil</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-energy-savings"></i>energy-savings</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-energy-solar"></i>energy-solar</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-energy-water"></i>energy-water</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-engineer"></i>engineer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-fire-extinguisher-alt"></i>fire-extinguisher-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-fix-tools"></i>fix-tools</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-glue-oil"></i>glue-oil</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hammer-alt"></i>hammer-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-help-robot"></i>help-robot</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-industries"></i>industries</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-industries-alt-1"></i>industries-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-industries-alt-2"></i>industries-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-industries-alt-3"></i>industries-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-industries-alt-4"></i>industries-alt-4</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-industries-alt-5"></i>industries-alt-5</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-labour"></i>labour</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mining"></i>mining</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-paint-brush"></i>paint-brush</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pollution"></i>pollution</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-power-zone"></i>power-zone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-radio-active"></i>radio-active</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-recycle-alt"></i>recycle-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-recycling-man"></i>recycling-man</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-safety-hat"></i>safety-hat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-safety-hat-light"></i>safety-hat-light</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-saw"></i>saw</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-screw-driver"></i>screw-driver</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-settings-alt"></i>settings-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tools-alt-1"></i>tools-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tools-alt-2"></i>tools-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tools-bag"></i>tools-bag</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-trolley"></i>trolley</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-trowel"></i>trowel</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-under-construction"></i>under-construction</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-under-construction-alt"></i>under-construction-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-vehicle-cement"></i>vehicle-cement</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-vehicle-crane"></i>vehicle-crane</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-vehicle-delivery-van"></i>vehicle-delivery-van</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-vehicle-dozer"></i>vehicle-dozer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-vehicle-excavator"></i>vehicle-excavator</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-vehicle-trucktor"></i>vehicle-trucktor</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-vehicle-wrecking"></i>vehicle-wrecking</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-worker"></i>worker</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-worker-group"></i>worker-group</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wrench"></i>wrench</div>
                                </section>

                                <br>

                                <p>Currency Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-afghani"></i>cur-afghani</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-afghani-false"></i>cur-afghani-false</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-afghani-minus"></i>cur-afghani-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-afghani-plus"></i>cur-afghani-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-afghani-true"></i>cur-afghani-true</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-baht"></i>cur-baht</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-baht-false"></i>cur-baht-false</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-baht-minus"></i>cur-baht-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-baht-plus"></i>cur-baht-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-baht-true"></i>cur-baht-true</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-bitcoin"></i>cur-bitcoin</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-bitcoin-false"></i>cur-bitcoin-false</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-bitcoin-minus"></i>cur-bitcoin-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-bitcoin-plus"></i>cur-bitcoin-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-bitcoin-true"></i>cur-bitcoin-true</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-dollar"></i>cur-dollar</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-dollar-flase"></i>cur-dollar-flase</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-dollar-minus"></i>cur-dollar-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-dollar-plus"></i>cur-dollar-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-dollar-true"></i>cur-dollar-true</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-dong"></i>cur-dong</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-dong-false"></i>cur-dong-false</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-dong-minus"></i>cur-dong-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-dong-plus"></i>cur-dong-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-dong-true"></i>cur-dong-true</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-euro"></i>cur-euro</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-euro-false"></i>cur-euro-false</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-euro-minus"></i>cur-euro-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-euro-plus"></i>cur-euro-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-euro-true"></i>cur-euro-true</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-frank"></i>cur-frank</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-frank-false"></i>cur-frank-false</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-frank-minus"></i>cur-frank-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-frank-plus"></i>cur-frank-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-frank-true"></i>cur-frank-true</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-hryvnia"></i>cur-hryvnia</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-hryvnia-false"></i>cur-hryvnia-false</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-hryvnia-minus"></i>cur-hryvnia-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-hryvnia-plus"></i>cur-hryvnia-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-hryvnia-true"></i>cur-hryvnia-true</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-lira"></i>cur-lira</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-lira-false"></i>cur-lira-false</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-lira-minus"></i>cur-lira-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-lira-plus"></i>cur-lira-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-lira-true"></i>cur-lira-true</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-peseta"></i>cur-peseta</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-peseta-false"></i>cur-peseta-false</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-peseta-minus"></i>cur-peseta-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-peseta-plus"></i>cur-peseta-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-peseta-true"></i>cur-peseta-true</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-peso"></i>cur-peso</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-peso-false"></i>cur-peso-false</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-peso-minus"></i>cur-peso-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-peso-plus"></i>cur-peso-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-peso-true"></i>cur-peso-true</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-pound"></i>cur-pound</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-pound-false"></i>cur-pound-false</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-pound-minus"></i>cur-pound-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-pound-plus"></i>cur-pound-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-pound-true"></i>cur-pound-true</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-renminbi"></i>cur-renminbi</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-renminbi-false"></i>cur-renminbi-false</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-renminbi-minus"></i>cur-renminbi-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-renminbi-plus"></i>cur-renminbi-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-renminbi-true"></i>cur-renminbi-true</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-riyal"></i>cur-riyal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-riyal-false"></i>cur-riyal-false</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-riyal-minus"></i>cur-riyal-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-riyal-plus"></i>cur-riyal-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-riyal-true"></i>cur-riyal-true</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-rouble"></i>cur-rouble</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-rouble-false"></i>cur-rouble-false</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-rouble-minus"></i>cur-rouble-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-rouble-plus"></i>cur-rouble-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-rouble-true"></i>cur-rouble-true</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-rupee"></i>cur-rupee</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-rupee-false"></i>cur-rupee-false</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-rupee-minus"></i>cur-rupee-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-rupee-plus"></i>cur-rupee-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-rupee-true"></i>cur-rupee-true</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-taka"></i>cur-taka</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-taka-false"></i>cur-taka-false</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-taka-minus"></i>cur-taka-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-taka-plus"></i>cur-taka-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-taka-true"></i>cur-taka-true</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-turkish-lira"></i>cur-turkish-lira</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-turkish-lira-false"></i>cur-turkish-lira-false</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-turkish-lira-minus"></i>cur-turkish-lira-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-turkish-lira-plus"></i>cur-turkish-lira-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-turkish-lira-true"></i>cur-turkish-lira-true</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-won"></i>cur-won</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-won-false"></i>cur-won-false</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-won-minus"></i>cur-won-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-won-plus"></i>cur-won-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-won-true"></i>cur-won-true</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-yen"></i>cur-yen</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-yen-false"></i>cur-yen-false</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-yen-minus"></i>cur-yen-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-yen-plus"></i>cur-yen-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cur-yen-true"></i>cur-yen-true</div>
                                </section>

                                <br>

                                <p>Device Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-android-nexus"></i>android-nexus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-android-tablet"></i>android-tablet</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-apple-watch"></i>apple-watch</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-drwaing-tablet"></i>drwaing-tablet</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-earphone"></i>earphone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-flash-drive"></i>flash-drive</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-game-control"></i>game-control</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-headphone-alt"></i>headphone-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-htc-one"></i>htc-one</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-imac"></i>imac</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ipad-touch"></i>ipad-touch</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-iphone"></i>iphone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ipod-nano"></i>ipod-nano</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ipod-touch"></i>ipod-touch</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-keyboard-alt"></i>keyboard-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-keyboard-wireless"></i>keyboard-wireless</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-laptop-alt"></i>laptop-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-macbook"></i>macbook</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-magic-mouse"></i>magic-mouse</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-microphone-alt"></i>microphone-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-monitor"></i>monitor</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mouse"></i>mouse</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-nintendo"></i>nintendo</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-playstation"></i>playstation</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-psvita"></i>psvita</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-radio-mic"></i>radio-mic</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-refrigerator"></i>refrigerator</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-samsung-galaxy"></i>samsung-galaxy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-surface-tablet"></i>surface-tablet</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-washing-machine"></i>washing-machine</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wifi-router"></i>wifi-router</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wii-u"></i>wii-u</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-windows-lumia"></i>windows-lumia</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wireless-mouse"></i>wireless-mouse</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-xbox-360"></i>xbox-360</div>
                                </section>

                                <br>

                                <p>Directional Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-arrow-down"></i>arrow-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-arrow-left"></i>arrow-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-arrow-right"></i>arrow-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-arrow-up"></i>arrow-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-block-down"></i>block-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-block-left"></i>block-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-block-right"></i>block-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-block-up"></i>block-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bubble-down"></i>bubble-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bubble-left"></i>bubble-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bubble-right"></i>bubble-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bubble-up"></i>bubble-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-caret-down"></i>caret-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-caret-left"></i>caret-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-caret-right"></i>caret-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-caret-up"></i>caret-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-circled-down"></i>circled-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-circled-left"></i>circled-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-circled-right"></i>circled-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-circled-up"></i>circled-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-collapse"></i>collapse</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cursor-drag"></i>cursor-drag</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-curved-double-left"></i>curved-double-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-curved-double-right"></i>curved-double-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-curved-down"></i>curved-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-curved-left"></i>curved-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-curved-right"></i>curved-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-curved-up"></i>curved-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-dotted-down"></i>dotted-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-dotted-left"></i>dotted-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-dotted-right"></i>dotted-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-dotted-up"></i>dotted-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-double-left"></i>double-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-double-right"></i>double-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-drag"></i>drag</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-drag1"></i>drag1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-drag2"></i>drag2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-drag3"></i>drag3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-expand-alt"></i>expand-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hand-down"></i>hand-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hand-drag"></i>hand-drag</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hand-drag1"></i>hand-drag1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hand-drag2"></i>hand-drag2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hand-drawn-alt-down"></i>hand-drawn-alt-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hand-drawn-alt-left"></i>hand-drawn-alt-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hand-drawn-alt-right"></i>hand-drawn-alt-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hand-drawn-alt-up"></i>hand-drawn-alt-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hand-drawn-down"></i>hand-drawn-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hand-drawn-left"></i>hand-drawn-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hand-drawn-right"></i>hand-drawn-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hand-drawn-up"></i>hand-drawn-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hand-left"></i>hand-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hand-right"></i>hand-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hand-up"></i>hand-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-line-block-down"></i>line-block-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-line-block-left"></i>line-block-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-line-block-right"></i>line-block-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-line-block-up"></i>line-block-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-long-arrow-down"></i>long-arrow-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-long-arrow-left"></i>long-arrow-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-long-arrow-right"></i>long-arrow-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-long-arrow-up"></i>long-arrow-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rounded-collapse"></i>rounded-collapse</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rounded-double-left"></i>rounded-double-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rounded-double-right"></i>rounded-double-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rounded-down"></i>rounded-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rounded-expand"></i>rounded-expand</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rounded-left"></i>rounded-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rounded-left-down"></i>rounded-left-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rounded-left-up"></i>rounded-left-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rounded-right"></i>rounded-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rounded-right-down"></i>rounded-right-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rounded-right-up"></i>rounded-right-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rounded-up"></i>rounded-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-scroll-bubble-down"></i>scroll-bubble-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-scroll-bubble-left"></i>scroll-bubble-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-scroll-bubble-right"></i>scroll-bubble-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-scroll-bubble-up"></i>scroll-bubble-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-scroll-double-down"></i>scroll-double-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-scroll-double-left"></i>scroll-double-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-scroll-double-right"></i>scroll-double-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-scroll-double-up"></i>scroll-double-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-scroll-down"></i>scroll-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-scroll-left"></i>scroll-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-scroll-long-down"></i>scroll-long-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-scroll-long-left"></i>scroll-long-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-scroll-long-right"></i>scroll-long-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-scroll-long-up"></i>scroll-long-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-scroll-right"></i>scroll-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-scroll-up"></i>scroll-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-simple-down"></i>simple-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-simple-left"></i>simple-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-simple-left-down"></i>simple-left-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-simple-left-up"></i>simple-left-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-simple-right"></i>simple-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-simple-right-down"></i>simple-right-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-simple-right-up"></i>simple-right-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-simple-up"></i>simple-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-square-down"></i>square-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-square-left"></i>square-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-square-right"></i>square-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-square-up"></i>square-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-stylish-down"></i>stylish-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-stylish-left"></i>stylish-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-stylish-right"></i>stylish-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-stylish-up"></i>stylish-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-swoosh-down"></i>swoosh-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-swoosh-left"></i>swoosh-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-swoosh-right"></i>swoosh-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-swoosh-up"></i>swoosh-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-thin-double-left"></i>thin-double-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-thin-double-right"></i>thin-double-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-thin-down"></i>thin-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-thin-left"></i>thin-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-thin-right"></i>thin-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-thin-up"></i>thin-up</div>
                                </section>

                                <br>

                                <p>Education Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-atom"></i>atom</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-award"></i>award</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bell-alt"></i>bell-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-book-alt"></i>book-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brainstorming"></i>brainstorming</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-certificate-alt-1"></i>certificate-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-certificate-alt-2"></i>certificate-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-dna-alt-2"></i>dna-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-education"></i>education</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-electron"></i>electron</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-fountain-pen"></i>fountain-pen</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-globe-alt"></i>globe-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-graduate-alt"></i>graduate-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-group-students"></i>group-students</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hat"></i>hat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hat-alt"></i>hat-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-instrument"></i>instrument</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-lamp-light"></i>lamp-light</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-microscope-alt"></i>microscope-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-paper"></i>paper</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pen-alt-4"></i>pen-alt-4</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pen-nib"></i>pen-nib</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pencil-alt-5"></i>pencil-alt-5</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-quill-pen"></i>quill-pen</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-read-book"></i>read-book</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-read-book-alt"></i>read-book-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-school-bag"></i>school-bag</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-school-bus"></i>school-bus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-student"></i>student</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-student-alt"></i>student-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-teacher"></i>teacher</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-test-bulb"></i>test-bulb</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-test-tube-alt"></i>test-tube-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-university"></i>university</div>
                                </section>

                                <br>

                                <p>Emoticon Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-angry"></i>emo-angry</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-astonished"></i>emo-astonished</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-confounded"></i>emo-confounded</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-confused"></i>emo-confused</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-crying"></i>emo-crying</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-dizzy"></i>emo-dizzy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-expressionless"></i>emo-expressionless</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-heart-eyes"></i>emo-heart-eyes</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-laughing"></i>emo-laughing</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-nerd-smile"></i>emo-nerd-smile</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-open-mouth"></i>emo-open-mouth</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-rage"></i>emo-rage</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-rolling-eyes"></i>emo-rolling-eyes</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-sad"></i>emo-sad</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-simple-smile"></i>emo-simple-smile</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-slightly-smile"></i>emo-slightly-smile</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-smirk"></i>emo-smirk</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-stuck-out-tongue"></i>emo-stuck-out-tongue</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-wink-smile"></i>emo-wink-smile</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-emo-worried"></i>emo-worried</div>
                                </section>

                                <br>

                                <p>File Type Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-audio"></i>file-audio</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-avi-mp4"></i>file-avi-mp4</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-bmp"></i>file-bmp</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-code"></i>file-code</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-css"></i>file-css</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-document"></i>file-document</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-eps"></i>file-eps</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-excel"></i>file-excel</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-exe"></i>file-exe</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-file"></i>file-file</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-flv"></i>file-flv</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-gif"></i>file-gif</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-html5"></i>file-html5</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-image"></i>file-image</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-iso"></i>file-iso</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-java"></i>file-java</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-javascript"></i>file-javascript</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-jpg"></i>file-jpg</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-midi"></i>file-midi</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-mov"></i>file-mov</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-mp3"></i>file-mp3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-pdf"></i>file-pdf</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-php"></i>file-php</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-png"></i>file-png</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-powerpoint"></i>file-powerpoint</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-presentation"></i>file-presentation</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-psb"></i>file-psb</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-psd"></i>file-psd</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-python"></i>file-python</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-ruby"></i>file-ruby</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-spreadsheet"></i>file-spreadsheet</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-sql"></i>file-sql</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-svg"></i>file-svg</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-text"></i>file-text</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-tiff"></i>file-tiff</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-video"></i>file-video</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-wave"></i>file-wave</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-wmv"></i>file-wmv</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-word"></i>file-word</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-zip"></i>file-zip</div>
                                </section>

                                <br>

                                <p>Food Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-apple"></i>apple</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-arabian-coffee"></i>arabian-coffee</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-artichoke"></i>artichoke</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-asparagus"></i>asparagus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-avocado"></i>avocado</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-baby-food"></i>baby-food</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-banana"></i>banana</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bbq"></i>bbq</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-beans"></i>beans</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-beer"></i>beer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bell-pepper-capsicum"></i>bell-pepper-capsicum</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-birthday-cake"></i>birthday-cake</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bread"></i>bread</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-broccoli"></i>broccoli</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-burger"></i>burger</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cabbage"></i>cabbage</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-carrot"></i>carrot</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cauli-flower"></i>cauli-flower</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cheese"></i>cheese</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-chef"></i>chef</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cherry"></i>cherry</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-chicken"></i>chicken</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-chicken-fry"></i>chicken-fry</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cocktail"></i>cocktail</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-coconut"></i>coconut</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-coffee-alt"></i>coffee-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-coffee-mug"></i>coffee-mug</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-coffee-pot"></i>coffee-pot</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cola"></i>cola</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-corn"></i>corn</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-croissant"></i>croissant</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-crop-plant"></i>crop-plant</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cucumber"></i>cucumber</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cup-cake"></i>cup-cake</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-dining-table"></i>dining-table</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-donut"></i>donut</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-egg-plant"></i>egg-plant</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-egg-poached"></i>egg-poached</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-farmer"></i>farmer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-farmer1"></i>farmer1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-fast-food"></i>fast-food</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-fish"></i>fish</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-food-basket"></i>food-basket</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-food-cart"></i>food-cart</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-fork-and-knife"></i>fork-and-knife</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-french-fries"></i>french-fries</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-fresh-juice"></i>fresh-juice</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-fruits"></i>fruits</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-grapes"></i>grapes</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-honey"></i>honey</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hot-dog"></i>hot-dog</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hotel-alt"></i>hotel-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ice-cream"></i>ice-cream</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ice-cream-alt"></i>ice-cream-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ketchup"></i>ketchup</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-kiwi"></i>kiwi</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-layered-cake"></i>layered-cake</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-lemon-alt"></i>lemon-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-lobster"></i>lobster</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mango"></i>mango</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-milk"></i>milk</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mushroom"></i>mushroom</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-noodles"></i>noodles</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-onion"></i>onion</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-orange"></i>orange</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pear"></i>pear</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-peas"></i>peas</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pepper"></i>pepper</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pie-alt"></i>pie-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pineapple"></i>pineapple</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pizza"></i>pizza</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pizza-slice"></i>pizza-slice</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-plant"></i>plant</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-popcorn"></i>popcorn</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-potato"></i>potato</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pumpkin"></i>pumpkin</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-raddish"></i>raddish</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-restaurant"></i>restaurant</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-restaurant-menu"></i>restaurant-menu</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-salt-and-pepper"></i>salt-and-pepper</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sandwich"></i>sandwich</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sausage"></i>sausage</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-shrimp"></i>shrimp</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sof-drinks"></i>sof-drinks</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-soup-bowl"></i>soup-bowl</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-spoon-and-fork"></i>spoon-and-fork</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-steak"></i>steak</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-strawberry"></i>strawberry</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sub-sandwich"></i>sub-sandwich</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sushi"></i>sushi</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-taco"></i>taco</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tea"></i>tea</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tea-pot"></i>tea-pot</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tomato"></i>tomato</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-waiter-alt"></i>waiter-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-watermelon"></i>watermelon</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wheat"></i>wheat</div>
                                </section>

                                <br>

                                <p>Kids & Toys Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-abc"></i>abc</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-baby-cloth"></i>baby-cloth</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-baby-milk-bottle"></i>baby-milk-bottle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-baby-trolley"></i>baby-trolley</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-back-pack"></i>back-pack</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-candy"></i>candy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cycling"></i>cycling</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-holding-hands"></i>holding-hands</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-infant-nipple"></i>infant-nipple</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-kids-scooter"></i>kids-scooter</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-safety-pin"></i>safety-pin</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-teddy-bear"></i>teddy-bear</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-toy-ball"></i>toy-ball</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-toy-cat"></i>toy-cat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-toy-duck"></i>toy-duck</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-toy-elephant"></i>toy-elephant</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-toy-hand"></i>toy-hand</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-toy-horse"></i>toy-horse</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-toy-lattu"></i>toy-lattu</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-toy-train"></i>toy-train</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-unique-idea"></i>unique-idea</div>
                                </section>

                                <br>

                                <p>Law Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bag-alt"></i>bag-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-burglar"></i>burglar</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cannon-firing"></i>cannon-firing</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cc-camera"></i>cc-camera</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cop"></i>cop</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cop-badge"></i>cop-badge</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-court"></i>court</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-court-hammer"></i>court-hammer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-finger-print"></i>finger-print</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-handcuff"></i>handcuff</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-handcuff-alt"></i>handcuff-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-investigation"></i>investigation</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-investigator"></i>investigator</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-jail"></i>jail</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-judge"></i>judge</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-law"></i>law</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-law-alt-1"></i>law-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-law-alt-2"></i>law-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-law-alt-3"></i>law-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-law-book"></i>law-book</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-law-document"></i>law-document</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-lawyer"></i>lawyer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-lawyer-alt-1"></i>lawyer-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-lawyer-alt-2"></i>lawyer-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-order"></i>order</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pistol"></i>pistol</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-police"></i>police</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-police-badge"></i>police-badge</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-police-cap"></i>police-cap</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-police-car-alt-1"></i>police-car-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-police-car-alt-2"></i>police-car-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-police-hat"></i>police-hat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-police-van"></i>police-van</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-protect"></i>protect</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-scales"></i>scales</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-thief"></i>thief</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-thief-alt"></i>thief-alt</div>
                                </section>

                                <br>

                                <p>Mathematical Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-abacus"></i>abacus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-abacus-alt"></i>abacus-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-angle"></i>angle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-calculator-alt-1"></i>calculator-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-calculator-alt-2"></i>calculator-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-circle-ruler"></i>circle-ruler</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-circle-ruler-alt"></i>circle-ruler-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-compass-alt-1"></i>compass-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-compass-alt-2"></i>compass-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-compass-alt-3"></i>compass-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-compass-alt-4"></i>compass-alt-4</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-degrees"></i>degrees</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-degrees-alt-1"></i>degrees-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-degrees-alt-2"></i>degrees-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-golden-ratio"></i>golden-ratio</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-marker-alt-1"></i>marker-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-marker-alt-2"></i>marker-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-marker-alt-3"></i>marker-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mathematical"></i>mathematical</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mathematical-alt-1"></i>mathematical-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mathematical-alt-2"></i>mathematical-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pen-alt-1"></i>pen-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pen-alt-2"></i>pen-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pen-alt-3"></i>pen-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pen-holder"></i>pen-holder</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pen-holder-alt-1"></i>pen-holder-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pencil-alt-1"></i>pencil-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pencil-alt-2"></i>pencil-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pencil-alt-3"></i>pencil-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pencil-alt-4"></i>pencil-alt-4</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ruler"></i>ruler</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ruler-alt-1"></i>ruler-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ruler-alt-2"></i>ruler-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ruler-compass"></i>ruler-compass</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ruler-compass-alt"></i>ruler-compass-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ruler-pencil"></i>ruler-pencil</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ruler-pencil-alt-1"></i>ruler-pencil-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ruler-pencil-alt-2"></i>ruler-pencil-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rulers"></i>rulers</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rulers-alt"></i>rulers-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-square-root"></i>square-root</div>
                                </section>

                                <br>

                                <p>Medical Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-aids"></i>aids</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ambulance"></i>ambulance</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-autism"></i>autism</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bandage"></i>bandage</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bed-patient"></i>bed-patient</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-blind"></i>blind</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-blood"></i>blood</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-blood-drop"></i>blood-drop</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-blood-test"></i>blood-test</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-capsule"></i>capsule</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-crutches"></i>crutches</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-dna"></i>dna</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-dna-alt-1"></i>dna-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-doctor"></i>doctor</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-doctor-alt"></i>doctor-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-drug"></i>drug</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-drug-pack"></i>drug-pack</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-eye-alt"></i>eye-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-first-aid-alt"></i>first-aid-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-garbage"></i>garbage</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-heart-alt"></i>heart-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-heartbeat"></i>heartbeat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-herbal"></i>herbal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hospital"></i>hospital</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-icu"></i>icu</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-injection-syringe"></i>injection-syringe</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-laboratory"></i>laboratory</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-medical-sign"></i>medical-sign</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-medical-sign-alt"></i>medical-sign-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-nurse"></i>nurse</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-nurse-alt"></i>nurse-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-nursing-home"></i>nursing-home</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-operation-theater"></i>operation-theater</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-paralysis-disability"></i>paralysis-disability</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pills"></i>pills</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-prescription"></i>prescription</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pulse"></i>pulse</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-stethoscope"></i>stethoscope</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-stethoscope-alt"></i>stethoscope-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-stretcher"></i>stretcher</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-surgeon"></i>surgeon</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-surgeon-alt"></i>surgeon-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tablets"></i>tablets</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-test-bottle"></i>test-bottle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-test-tube"></i>test-tube</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-thermometer-alt"></i>thermometer-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tooth"></i>tooth</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-xray"></i>xray</div>
                                </section>

                                <br>

                                <p>Mobile UI Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-add"></i>ui-add</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-alarm"></i>ui-alarm</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-battery"></i>ui-battery</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-block"></i>ui-block</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-bluetooth"></i>ui-bluetooth</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-brightness"></i>ui-brightness</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-browser"></i>ui-browser</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-calculator"></i>ui-calculator</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-calendar"></i>ui-calendar</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-call"></i>ui-call</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-camera"></i>ui-camera</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-cart"></i>ui-cart</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-cell-phone"></i>ui-cell-phone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-chat"></i>ui-chat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-check"></i>ui-check</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-clip"></i>ui-clip</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-clip-board"></i>ui-clip-board</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-clock"></i>ui-clock</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-close"></i>ui-close</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-contact-list"></i>ui-contact-list</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-copy"></i>ui-copy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-cut"></i>ui-cut</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-delete"></i>ui-delete</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-dial-phone"></i>ui-dial-phone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-edit"></i>ui-edit</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-email"></i>ui-email</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-file"></i>ui-file</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-fire-wall"></i>ui-fire-wall</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-flash-light"></i>ui-flash-light</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-flight"></i>ui-flight</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-folder"></i>ui-folder</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-game"></i>ui-game</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-handicapped"></i>ui-handicapped</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-head-phone"></i>ui-head-phone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-home"></i>ui-home</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-image"></i>ui-image</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-keyboard"></i>ui-keyboard</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-laoding"></i>ui-laoding</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-lock"></i>ui-lock</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-love"></i>ui-love</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-love-add"></i>ui-love-add</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-love-broken"></i>ui-love-broken</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-love-remove"></i>ui-love-remove</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-map"></i>ui-map</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-message"></i>ui-message</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-messaging"></i>ui-messaging</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-movie"></i>ui-movie</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-music"></i>ui-music</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-music-player"></i>ui-music-player</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-mute"></i>ui-mute</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-Refferal"></i>ui-Refferal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-next"></i>ui-next</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-note"></i>ui-note</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-office"></i>ui-office</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-password"></i>ui-password</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-pause"></i>ui-pause</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-play"></i>ui-play</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-play-stop"></i>ui-play-stop</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-pointer"></i>ui-pointer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-power"></i>ui-power</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-press"></i>ui-press</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-previous"></i>ui-previous</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-rate-add"></i>ui-rate-add</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-rate-blank"></i>ui-rate-blank</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-rate-remove"></i>ui-rate-remove</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-rating"></i>ui-rating</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-record"></i>ui-record</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-remove"></i>ui-remove</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-reply"></i>ui-reply</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-rotation"></i>ui-rotation</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-rss"></i>ui-rss</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-search"></i>ui-search</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-settings"></i>ui-settings</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-social-link"></i>ui-social-link</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-tag"></i>ui-tag</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-text-chat"></i>ui-text-chat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-text-loading"></i>ui-text-loading</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-theme"></i>ui-theme</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-timer"></i>ui-timer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-touch-phone"></i>ui-touch-phone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-travel"></i>ui-travel</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-unlock"></i>ui-unlock</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-user"></i>ui-user</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-user-group"></i>ui-user-group</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-v-card"></i>ui-v-card</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-video"></i>ui-video</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-video-chat"></i>ui-video-chat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-video-message"></i>ui-video-message</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-video-play"></i>ui-video-play</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-volume"></i>ui-volume</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-weather"></i>ui-weather</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-wifi"></i>ui-wifi</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-zoom-in"></i>ui-zoom-in</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ui-zoom-out"></i>ui-zoom-out</div>
                                </section>

                                <br>

                                <p>Multimedia Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cassette"></i>cassette</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cassette-player"></i>cassette-player</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-forward"></i>forward</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-game"></i>game</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-guiter"></i>guiter</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-headphone-alt-1"></i>headphone-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-headphone-alt-2"></i>headphone-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-headphone-alt-3"></i>headphone-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-listening"></i>listening</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-megaphone"></i>megaphone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-megaphone-alt"></i>megaphone-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-movie"></i>movie</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mp3-player"></i>mp3-player</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-multimedia"></i>multimedia</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-music-disk"></i>music-disk</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-music-note"></i>music-note</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pause"></i>pause</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-play-alt-1"></i>play-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-play-alt-2"></i>play-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-play-alt-3"></i>play-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-play-pause"></i>play-pause</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-record"></i>record</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-retro-music-disk"></i>retro-music-disk</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rewind"></i>rewind</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-song-notes"></i>song-notes</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sound-wave"></i>sound-wave</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sound-wave-alt"></i>sound-wave-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-stop"></i>stop</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-video-alt"></i>video-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-video-cam"></i>video-cam</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-volume-bar"></i>volume-bar</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-volume-mute"></i>volume-mute</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-youtube-play"></i>youtube-play</div>
                                </section>

                                <br>

                                <p>Payment Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-amazon"></i>amazon</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-amazon-alt"></i>amazon-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-american-express"></i>american-express</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-american-express-alt"></i>american-express-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-apple-pay"></i>apple-pay</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-apple-pay-alt"></i>apple-pay-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bank-transfer"></i>bank-transfer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bank-transfer-alt"></i>bank-transfer-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-braintree"></i>braintree</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-braintree-alt"></i>braintree-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cash-on-delivery"></i>cash-on-delivery</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cash-on-delivery-alt"></i>cash-on-delivery-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-checkout"></i>checkout</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-checkout-alt"></i>checkout-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-diners-club"></i>diners-club</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-diners-club-alt-1"></i>diners-club-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-diners-club-alt-2"></i>diners-club-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-diners-club-alt-3"></i>diners-club-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-discover"></i>discover</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-discover-alt"></i>discover-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-eway"></i>eway</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-eway-alt"></i>eway-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-google-wallet"></i>google-wallet</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-google-wallet-alt-1"></i>google-wallet-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-google-wallet-alt-2"></i>google-wallet-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-google-wallet-alt-3"></i>google-wallet-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-jcb"></i>jcb</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-jcb-alt"></i>jcb-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-maestro"></i>maestro</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-maestro-alt"></i>maestro-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mastercard"></i>mastercard</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mastercard-alt"></i>mastercard-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-payoneer"></i>payoneer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-payoneer-alt"></i>payoneer-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-paypal"></i>paypal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-paypal-alt"></i>paypal-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sage"></i>sage</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sage-alt"></i>sage-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-skrill"></i>skrill</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-skrill-alt"></i>skrill-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-stripe"></i>stripe</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-stripe-alt"></i>stripe-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-visa"></i>visa</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-visa-alt"></i>visa-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-visa-electron"></i>visa-electron</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-western-union"></i>western-union</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-western-union-alt"></i>western-union-alt</div>
                                </section>

                                <br>

                                <p>Person Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-boy"></i>boy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-business-man"></i>business-man</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-business-man-alt-1"></i>business-man-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-business-man-alt-2"></i>business-man-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-business-man-alt-3"></i>business-man-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-funky-man"></i>funky-man</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-girl"></i>girl</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-girl-alt"></i>girl-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hotel-boy"></i>hotel-boy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hotel-boy-alt"></i>hotel-boy-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-man-in-glasses"></i>man-in-glasses</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-user"></i>user</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-user-alt-1"></i>user-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-user-alt-2"></i>user-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-user-alt-3"></i>user-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-user-alt-4"></i>user-alt-4</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-user-alt-5"></i>user-alt-5</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-user-alt-6"></i>user-alt-6</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-user-alt-7"></i>user-alt-7</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-user-female"></i>user-female</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-user-male"></i>user-male</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-user-suited"></i>user-suited</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-users"></i>users</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-users-alt-1"></i>users-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-users-alt-2"></i>users-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-users-alt-3"></i>users-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-users-alt-4"></i>users-alt-4</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-users-alt-5"></i>users-alt-5</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-users-alt-6"></i>users-alt-6</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-users-social"></i>users-social</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-waiter"></i>waiter</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-woman-in-glasses"></i>woman-in-glasses</div>
                                </section>

                                <br>

                                <p>Search Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-document-search"></i>document-search</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-folder-search"></i>folder-search</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-home-search"></i>home-search</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-job-search"></i>job-search</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-map-search"></i>map-search</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-restaurant-search"></i>restaurant-search</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-search"></i>search</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-search-alt-1"></i>search-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-search-alt-2"></i>search-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-stock-search"></i>stock-search</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-user-search"></i>user-search</div>
                                </section>

                                <br>

                                <p>Social Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brand-drupal"></i>brand-drupal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-500px"></i>social-500px</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-aim"></i>social-aim</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-badoo"></i>social-badoo</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-baidu-tieba"></i>social-baidu-tieba</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-bbm-messenger"></i>social-bbm-messenger</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-bebo"></i>social-bebo</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-behance"></i>social-behance</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-blogger"></i>social-blogger</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-bootstrap"></i>social-bootstrap</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-brightkite"></i>social-brightkite</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-cloudapp"></i>social-cloudapp</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-concrete5"></i>social-concrete5</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-delicious"></i>social-delicious</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-designbump"></i>social-designbump</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-designfloat"></i>social-designfloat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-deviantart"></i>social-deviantart</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-digg"></i>social-digg</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-dotcms"></i>social-dotcms</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-dribbble"></i>social-dribbble</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-dribble"></i>social-dribble</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-dropbox"></i>social-dropbox</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-ebuddy"></i>social-ebuddy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-ello"></i>social-ello</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-ember"></i>social-ember</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-evernote"></i>social-evernote</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-facebook"></i>social-facebook</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-facebook-messenger"></i>social-facebook-messenger</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-feedburner"></i>social-feedburner</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-flikr"></i>social-flikr</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-folkd"></i>social-folkd</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-foursquare"></i>social-foursquare</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-friendfeed"></i>social-friendfeed</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-ghost"></i>social-ghost</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-github"></i>social-github</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-gnome"></i>social-gnome</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-google-buzz"></i>social-google-buzz</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-google-hangouts"></i>social-google-hangouts</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-google-map"></i>social-google-map</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-google-plus"></i>social-google-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-google-talk"></i>social-google-talk</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-hype-machine"></i>social-hype-machine</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-instagram"></i>social-instagram</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-kakaotalk"></i>social-kakaotalk</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-kickstarter"></i>social-kickstarter</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-kik"></i>social-kik</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-kiwibox"></i>social-kiwibox</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-line"></i>social-line</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-linkedin"></i>social-linkedin</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-linux-mint"></i>social-linux-mint</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-livejournal"></i>social-livejournal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-magento"></i>social-magento</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-meetme"></i>social-meetme</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-meetup"></i>social-meetup</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-mixx"></i>social-mixx</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-newsvine"></i>social-newsvine</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-nimbuss"></i>social-nimbuss</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-odnoklassniki"></i>social-odnoklassniki</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-opencart"></i>social-opencart</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-oscommerce"></i>social-oscommerce</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-pandora"></i>social-pandora</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-photobucket"></i>social-photobucket</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-picasa"></i>social-picasa</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-pinterest"></i>social-pinterest</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-prestashop"></i>social-prestashop</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-qik"></i>social-qik</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-qq"></i>social-qq</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-readernaut"></i>social-readernaut</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-reddit"></i>social-reddit</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-renren"></i>social-renren</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-rss"></i>social-rss</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-shopify"></i>social-shopify</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-silverstripe"></i>social-silverstripe</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-skype"></i>social-skype</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-slack"></i>social-slack</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-slashdot"></i>social-slashdot</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-slidshare"></i>social-slidshare</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-smugmug"></i>social-smugmug</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-snapchat"></i>social-snapchat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-soundcloud"></i>social-soundcloud</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-spotify"></i>social-spotify</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-stack-exchange"></i>social-stack-exchange</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-stack-overflow"></i>social-stack-overflow</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-steam"></i>social-steam</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-stumbleupon"></i>social-stumbleupon</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-tagged"></i>social-tagged</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-technorati"></i>social-technorati</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-telegram"></i>social-telegram</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-tinder"></i>social-tinder</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-trello"></i>social-trello</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-tumblr"></i>social-tumblr</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-twitch"></i>social-twitch</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-twitter"></i>social-twitter</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-typo3"></i>social-typo3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-ubercart"></i>social-ubercart</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-viber"></i>social-viber</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-viddler"></i>social-viddler</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-vimeo"></i>social-vimeo</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-vine"></i>social-vine</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-virb"></i>social-virb</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-virtuemart"></i>social-virtuemart</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-vk"></i>social-vk</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-wechat"></i>social-wechat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-weibo"></i>social-weibo</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-whatsapp"></i>social-whatsapp</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-xing"></i>social-xing</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-yahoo"></i>social-yahoo</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-yelp"></i>social-yelp</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-youku"></i>social-youku</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-youtube"></i>social-youtube</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-youtube-play"></i>social-youtube-play</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-social-zencart"></i>social-zencart</div>
                                </section>

                                <br>

                                <p>Sport Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-badminton-birdie"></i>badminton-birdie</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-baseball"></i>baseball</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-baseballer"></i>baseballer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-basketball"></i>basketball</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-basketball-hoop"></i>basketball-hoop</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-billiard-ball"></i>billiard-ball</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-boot-alt-1"></i>boot-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-boot-alt-2"></i>boot-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bowling"></i>bowling</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bowling-alt"></i>bowling-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-canoe"></i>canoe</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cheer-leader"></i>cheer-leader</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-climbing"></i>climbing</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-corner"></i>corner</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cyclist"></i>cyclist</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-dumbbell"></i>dumbbell</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-dumbbell-alt"></i>dumbbell-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-field"></i>field</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-field-alt"></i>field-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-football-alt"></i>football-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-foul"></i>foul</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-goal"></i>goal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-goal-keeper"></i>goal-keeper</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-golf"></i>golf</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-golf-alt"></i>golf-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-golf-bag"></i>golf-bag</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-golf-field"></i>golf-field</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-golfer"></i>golfer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-gym"></i>gym</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-gym-alt-1"></i>gym-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-gym-alt-2"></i>gym-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-gym-alt-3"></i>gym-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hand-grippers"></i>hand-grippers</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-heart-beat-alt"></i>heart-beat-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-helmet"></i>helmet</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hockey"></i>hockey</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hockey-alt"></i>hockey-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ice-skate"></i>ice-skate</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-jersey"></i>jersey</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-jersey-alt"></i>jersey-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-jumping"></i>jumping</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-kick"></i>kick</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-leg"></i>leg</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-match-review"></i>match-review</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-medal-alt"></i>medal-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-muscle"></i>muscle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-muscle-alt"></i>muscle-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-offside"></i>offside</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-olympic"></i>olympic</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-olympic-logo"></i>olympic-logo</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-padding"></i>padding</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-penalty-card"></i>penalty-card</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-racer"></i>racer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-racing-car"></i>racing-car</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-racing-flag"></i>racing-flag</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-racing-flag-alt"></i>racing-flag-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-racings-wheel"></i>racings-wheel</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-referee"></i>referee</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-refree-jersey"></i>refree-jersey</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-result"></i>result</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rugby"></i>rugby</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rugby-ball"></i>rugby-ball</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rugby-player"></i>rugby-player</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-runner"></i>runner</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-runner-alt-1"></i>runner-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-runner-alt-2"></i>runner-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-score-board"></i>score-board</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-skiing-man"></i>skiing-man</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-skydiving-goggles"></i>skydiving-goggles</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snow-mobile"></i>snow-mobile</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-steering"></i>steering</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-substitute"></i>substitute</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-swimmer"></i>swimmer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-table-tennis"></i>table-tennis</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-team"></i>team</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-team-alt"></i>team-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tennis"></i>tennis</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tennis-player"></i>tennis-player</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-time"></i>time</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-track"></i>track</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tracking"></i>tracking</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-trophy"></i>trophy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-trophy-alt"></i>trophy-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-volleyball"></i>volleyball</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-volleyball-alt"></i>volleyball-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-volleyball-fire"></i>volleyball-fire</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-water-bottle"></i>water-bottle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-whisle"></i>whisle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-win-trophy"></i>win-trophy</div>
                                </section>

                                <br>

                                <p>Text Editor Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-align-center"></i>align-center</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-align-left"></i>align-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-align-right"></i>align-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-all-caps"></i>all-caps</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bold"></i>bold</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brush"></i>brush</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-clip-board"></i>clip-board</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-code-alt"></i>code-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-color-bucket"></i>color-bucket</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-color-picker"></i>color-picker</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-copy-alt"></i>copy-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-copy-black"></i>copy-black</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cut"></i>cut</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-delete-alt"></i>delete-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-edit-alt"></i>edit-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-eraser-alt"></i>eraser-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file-alt"></i>file-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-font"></i>font</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-header"></i>header</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-indent"></i>indent</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-italic-alt"></i>italic-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-justify-all"></i>justify-all</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-justify-center"></i>justify-center</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-justify-left"></i>justify-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-justify-right"></i>justify-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-line-height"></i>line-height</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-link-alt"></i>link-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-listine-dots"></i>listine-dots</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-listing-box"></i>listing-box</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-listing-number"></i>listing-number</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-marker"></i>marker</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-outdent"></i>outdent</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-paper-clip"></i>paper-clip</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-paragraph"></i>paragraph</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pin"></i>pin</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-printer"></i>printer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-redo"></i>redo</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rotation"></i>rotation</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-save"></i>save</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-small-cap"></i>small-cap</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-strike-through"></i>strike-through</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sub-listing"></i>sub-listing</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-subscript"></i>subscript</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-superscript"></i>superscript</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-table"></i>table</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-text-height"></i>text-height</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-text-width"></i>text-width</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-trash"></i>trash</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-underline"></i>underline</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-undo"></i>undo</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-unlink"></i>unlink</div>
                                </section>

                                <br>

                                <p>Transport Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-air-balloon"></i>air-balloon</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-airplane"></i>airplane</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-airplane-alt"></i>airplane-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ambulance-crescent"></i>ambulance-crescent</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ambulance-cross"></i>ambulance-cross</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-articulated-truck"></i>articulated-truck</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-auto-rickshaw"></i>auto-rickshaw</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bicycle-alt-1"></i>bicycle-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bicycle-alt-2"></i>bicycle-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bull-dozer"></i>bull-dozer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bus-alt-1"></i>bus-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bus-alt-2"></i>bus-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bus-alt-3"></i>bus-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cable-car"></i>cable-car</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-car-alt-1"></i>car-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-car-alt-2"></i>car-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-car-alt-3"></i>car-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-car-alt-4"></i>car-alt-4</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-concrete-mixer"></i>concrete-mixer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-delivery-time"></i>delivery-time</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-excavator"></i>excavator</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-fast-delivery"></i>fast-delivery</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-fire-truck"></i>fire-truck</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-fire-truck-alt"></i>fire-truck-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-fork-lift"></i>fork-lift</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-free-delivery"></i>free-delivery</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-golf-cart"></i>golf-cart</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-helicopter"></i>helicopter</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-motor-bike"></i>motor-bike</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-motor-bike-alt"></i>motor-bike-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-motor-biker"></i>motor-biker</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-oil-truck"></i>oil-truck</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-police-car"></i>police-car</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rickshaw"></i>rickshaw</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rocket-alt-1"></i>rocket-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rocket-alt-2"></i>rocket-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sail-boat"></i>sail-boat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-scooter"></i>scooter</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sea-plane"></i>sea-plane</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ship-alt"></i>ship-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-speed-boat"></i>speed-boat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-taxi"></i>taxi</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tow-truck"></i>tow-truck</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tractor"></i>tractor</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-traffic-light"></i>traffic-light</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-train-line"></i>train-line</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-train-steam"></i>train-steam</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tram"></i>tram</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-truck"></i>truck</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-truck-alt"></i>truck-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-truck-loaded"></i>truck-loaded</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-van"></i>van</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-van-alt"></i>van-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-yacht"></i>yacht</div>
                                </section>

                                <br>

                                <p>Travel Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-5-star-hotel"></i>5-star-hotel</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-anchor-alt"></i>anchor-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-beach-bed"></i>beach-bed</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-camping-vest"></i>camping-vest</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-coconut-alt"></i>coconut-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-direction-sign"></i>direction-sign</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hill-side"></i>hill-side</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-island-alt"></i>island-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-long-drive"></i>long-drive</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-map-pins"></i>map-pins</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-plane-ticket"></i>plane-ticket</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sail-boat-alt-1"></i>sail-boat-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sail-boat-alt-2"></i>sail-boat-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sandals-female"></i>sandals-female</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sandals-male"></i>sandals-male</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-travelling"></i>travelling</div>
                                </section>

                                <br>

                                <p>Weather Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-breakdown"></i>breakdown</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-celsius"></i>celsius</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-clouds"></i>clouds</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cloudy"></i>cloudy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-compass-alt"></i>compass-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-dust"></i>dust</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-eclipse"></i>eclipse</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-fahrenheit"></i>fahrenheit</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-forest-fire"></i>forest-fire</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-full-night"></i>full-night</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-full-sunny"></i>full-sunny</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hail"></i>hail</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hail-night"></i>hail-night</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hail-rainy"></i>hail-rainy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hail-rainy-night"></i>hail-rainy-night</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hail-rainy-sunny"></i>hail-rainy-sunny</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hail-sunny"></i>hail-sunny</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hail-thunder"></i>hail-thunder</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hail-thunder-night"></i>hail-thunder-night</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hail-thunder-sunny"></i>hail-thunder-sunny</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hill"></i>hill</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hill-night"></i>hill-night</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hill-sunny"></i>hill-sunny</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hurricane"></i>hurricane</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-island"></i>island</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-meteor"></i>meteor</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-night"></i>night</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rainy"></i>rainy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rainy-night"></i>rainy-night</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rainy-sunny"></i>rainy-sunny</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rainy-thunder"></i>rainy-thunder</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-showy-night-hail"></i>showy-night-hail</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snow"></i>snow</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snow-temp"></i>snow-temp</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snowy"></i>snowy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snowy-hail"></i>snowy-hail</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snowy-night"></i>snowy-night</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snowy-night-rainy"></i>snowy-night-rainy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snowy-rainy"></i>snowy-rainy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snowy-sunny"></i>snowy-sunny</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snowy-sunny-hail"></i>snowy-sunny-hail</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snowy-sunny-rainy"></i>snowy-sunny-rainy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snowy-thunder"></i>snowy-thunder</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snowy-thunder-night"></i>snowy-thunder-night</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snowy-thunder-sunny"></i>snowy-thunder-sunny</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snowy-windy"></i>snowy-windy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snowy-windy-night"></i>snowy-windy-night</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-snowy-windy-sunny"></i>snowy-windy-sunny</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sun-alt"></i>sun-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sun-rise"></i>sun-rise</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sun-set"></i>sun-set</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sunny"></i>sunny</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sunny-day-temp"></i>sunny-day-temp</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-thermometer"></i>thermometer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-thinder-light"></i>thinder-light</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tornado"></i>tornado</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-umbrella-alt"></i>umbrella-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-volcano"></i>volcano</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wave"></i>wave</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wind"></i>wind</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wind-scale-0"></i>wind-scale-0</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wind-scale-1"></i>wind-scale-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wind-scale-10"></i>wind-scale-10</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wind-scale-11"></i>wind-scale-11</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wind-scale-12"></i>wind-scale-12</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wind-scale-2"></i>wind-scale-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wind-scale-3"></i>wind-scale-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wind-scale-4"></i>wind-scale-4</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wind-scale-5"></i>wind-scale-5</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wind-scale-6"></i>wind-scale-6</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wind-scale-7"></i>wind-scale-7</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wind-scale-8"></i>wind-scale-8</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wind-scale-9"></i>wind-scale-9</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wind-waves"></i>wind-waves</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-windy"></i>windy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-windy-hail"></i>windy-hail</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-windy-night"></i>windy-night</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-windy-raining"></i>windy-raining</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-windy-sunny"></i>windy-sunny</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-windy-thunder"></i>windy-thunder</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-windy-thunder-raining"></i>windy-thunder-raining</div>
                                </section>

                                <br>

                                <p>Web Application Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-addons"></i>addons</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-address-book"></i>address-book</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-adjust"></i>adjust</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-alarm"></i>alarm</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-anchor"></i>anchor</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-archive"></i>archive</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-at"></i>at</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-attachment"></i>attachment</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-audio"></i>audio</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-auto-mobile"></i>auto-mobile</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-automation"></i>automation</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-baby"></i>baby</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-badge"></i>badge</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bag"></i>bag</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ban"></i>ban</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bank"></i>bank</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bar-code"></i>bar-code</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bars"></i>bars</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-battery-empty"></i>battery-empty</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-battery-full"></i>battery-full</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-battery-half"></i>battery-half</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-battery-low"></i>battery-low</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-beach"></i>beach</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-beaker"></i>beaker</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bear"></i>bear</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-beard"></i>beard</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bed"></i>bed</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bell"></i>bell</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-beverage"></i>beverage</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bicycle"></i>bicycle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bill"></i>bill</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bin"></i>bin</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-binary"></i>binary</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-binoculars"></i>binoculars</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bird"></i>bird</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-birds"></i>birds</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-black-board"></i>black-board</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bluetooth"></i>bluetooth</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bolt"></i>bolt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bomb"></i>bomb</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-book"></i>book</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-book-mark"></i>book-mark</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-boot"></i>boot</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-box"></i>box</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-brain"></i>brain</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-briefcase"></i>briefcase</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-broken"></i>broken</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bucket"></i>bucket</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bucket1"></i>bucket1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bucket2"></i>bucket2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bug"></i>bug</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-building"></i>building</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bullet"></i>bullet</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bullhorn"></i>bullhorn</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bullseye"></i>bullseye</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-bus"></i>bus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-butterfly"></i>butterfly</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cab"></i>cab</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-calculator"></i>calculator</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-calendar"></i>calendar</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-camera"></i>camera</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-camera-alt"></i>camera-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-car"></i>car</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-card"></i>card</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cart"></i>cart</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cc"></i>cc</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-certificate"></i>certificate</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-charging"></i>charging</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-chat"></i>chat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-check"></i>check</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-check-alt"></i>check-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-check-circled"></i>check-circled</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-checked"></i>checked</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-children-care"></i>children-care</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-clock-time"></i>clock-time</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-close"></i>close</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-close-circled"></i>close-circled</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-close-line"></i>close-line</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-close-line-circled"></i>close-line-circled</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-close-line-squared"></i>close-line-squared</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-close-line-squared-alt"></i>close-line-squared-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-close-squared"></i>close-squared</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-close-squared-alt"></i>close-squared-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cloud"></i>cloud</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cloud-download"></i>cloud-download</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cloud-refresh"></i>cloud-refresh</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cloud-upload"></i>cloud-upload</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-code"></i>code</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-code-not-allowed"></i>code-not-allowed</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-coffee-cup"></i>coffee-cup</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-comment"></i>comment</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-compass"></i>compass</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-computer"></i>computer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-connection"></i>connection</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-console"></i>console</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-contacts"></i>contacts</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-contrast"></i>contrast</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-copy"></i>copy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-copyright"></i>copyright</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-credit-card"></i>credit-card</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-crop"></i>crop</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-crown"></i>crown</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cube"></i>cube</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-cubes"></i>cubes</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-culinary"></i>culinary</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-dashboard"></i>dashboard</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-dashboard-web"></i>dashboard-web</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-data"></i>data</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-database"></i>database</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-database-add"></i>database-add</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-database-locked"></i>database-locked</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-database-remove"></i>database-remove</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-delete"></i>delete</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-diamond"></i>diamond</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-dice"></i>dice</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-disabled"></i>disabled</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-disc"></i>disc</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-diskette"></i>diskette</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-document-folder"></i>document-folder</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-download"></i>download</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-download-alt"></i>download-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-downloaded"></i>downloaded</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-earth"></i>earth</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ebook"></i>ebook</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-edit"></i>edit</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-eject"></i>eject</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-email"></i>email</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-envelope"></i>envelope</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-envelope-open"></i>envelope-open</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-eraser"></i>eraser</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-error"></i>error</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-exchange"></i>exchange</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-exclamation"></i>exclamation</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-exclamation-circle"></i>exclamation-circle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-exclamation-square"></i>exclamation-square</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-exclamation-tringle"></i>exclamation-tringle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-exit"></i>exit</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-expand"></i>expand</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-external"></i>external</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-external-link"></i>external-link</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-eye"></i>eye</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-eye-blocked"></i>eye-blocked</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-eye-dropper"></i>eye-dropper</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-favourite"></i>favourite</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-fax"></i>fax</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-female"></i>female</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-file"></i>file</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-film"></i>film</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-filter"></i>filter</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-fire"></i>fire</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-fire-burn"></i>fire-burn</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-fire-extinguisher"></i>fire-extinguisher</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-first-aid"></i>first-aid</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-flag"></i>flag</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-flag-alt-1"></i>flag-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-flag-alt-2"></i>flag-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-flash"></i>flash</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-flash-light"></i>flash-light</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-flask"></i>flask</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-focus"></i>focus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-folder"></i>folder</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-folder-open"></i>folder-open</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-foot-print"></i>foot-print</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-football"></i>football</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-football-american"></i>football-american</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-game-console"></i>game-console</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-game-pad"></i>game-pad</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-gavel"></i>gavel</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-gear"></i>gear</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-gears"></i>gears</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-gift"></i>gift</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-glass"></i>glass</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-globe"></i>globe</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-graduate"></i>graduate</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-graffiti"></i>graffiti</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-grocery"></i>grocery</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-group"></i>group</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hammer"></i>hammer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hand"></i>hand</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hanger"></i>hanger</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hard-disk"></i>hard-disk</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-headphone"></i>headphone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-heart"></i>heart</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-heart-beat"></i>heart-beat</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-history"></i>history</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-home"></i>home</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-horn"></i>horn</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hotel"></i>hotel</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-hour-glass"></i>hour-glass</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-id"></i>id</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-image"></i>image</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-inbox"></i>inbox</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-infinite"></i>infinite</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-info"></i>info</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-info-circle"></i>info-circle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-info-square"></i>info-square</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-institution"></i>institution</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-interface"></i>interface</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-invisible"></i>invisible</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-italic"></i>italic</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-jacket"></i>jacket</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-jar"></i>jar</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-jewlery"></i>jewlery</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-karate"></i>karate</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-key"></i>key</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-key-hole"></i>key-hole</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-keyboard"></i>keyboard</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-kid"></i>kid</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-label"></i>label</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-lamp"></i>lamp</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-laptop"></i>laptop</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-layers"></i>layers</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-layout"></i>layout</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-leaf"></i>leaf</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-leaflet"></i>leaflet</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-learn"></i>learn</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-legal"></i>legal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-lego"></i>lego</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-lemon"></i>lemon</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-lens"></i>lens</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-letter"></i>letter</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-letterbox"></i>letterbox</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-library"></i>library</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-license"></i>license</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-life-bouy"></i>life-bouy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-life-buoy"></i>life-buoy</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-life-jacket"></i>life-jacket</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-life-ring"></i>life-ring</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-light-bulb"></i>light-bulb</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-lighter"></i>lighter</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-lightning-ray"></i>lightning-ray</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-like"></i>like</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-link"></i>link</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-live-support"></i>live-support</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-location-arrow"></i>location-arrow</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-location-pin"></i>location-pin</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-lock"></i>lock</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-login"></i>login</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-logout"></i>logout</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-lollipop"></i>lollipop</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-look"></i>look</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-loop"></i>loop</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-luggage"></i>luggage</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-lunch"></i>lunch</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-lungs"></i>lungs</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-magic"></i>magic</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-magic-alt"></i>magic-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-magnet"></i>magnet</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mail"></i>mail</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mail-box"></i>mail-box</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-male"></i>male</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-map"></i>map</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-math"></i>math</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-maximize"></i>maximize</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-measure"></i>measure</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-medal"></i>medal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-medical"></i>medical</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-medicine"></i>medicine</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mega-phone"></i>mega-phone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-memorial"></i>memorial</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-memory-card"></i>memory-card</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mic"></i>mic</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mic-mute"></i>mic-mute</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-micro-chip"></i>micro-chip</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-microphone"></i>microphone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-microscope"></i>microscope</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-military"></i>military</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mill"></i>mill</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-minus"></i>minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-minus-circle"></i>minus-circle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-minus-square"></i>minus-square</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mobile-phone"></i>mobile-phone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-molecule"></i>molecule</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-money"></i>money</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-moon"></i>moon</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mop"></i>mop</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-muffin"></i>muffin</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-music"></i>music</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-music-alt"></i>music-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-music-notes"></i>music-notes</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mustache"></i>mustache</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-mute-volume"></i>mute-volume</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-navigation"></i>navigation</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-navigation-menu"></i>navigation-menu</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-Refferal"></i>Refferal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-Refferal-tower"></i>Refferal-tower</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-news"></i>news</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-newspaper"></i>newspaper</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-no-smoking"></i>no-smoking</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-not-allowed"></i>not-allowed</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-notebook"></i>notebook</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-notepad"></i>notepad</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-notification"></i>notification</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-numbered"></i>numbered</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-opposite"></i>opposite</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-optic"></i>optic</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-options"></i>options</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-package"></i>package</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-page"></i>page</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-paint"></i>paint</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-paper-plane"></i>paper-plane</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-paperclip"></i>paperclip</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-papers"></i>papers</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-paw"></i>paw</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pay"></i>pay</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pen"></i>pen</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pencil"></i>pencil</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-penguin-linux"></i>penguin-linux</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pestle"></i>pestle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-phone"></i>phone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-phone-circle"></i>phone-circle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-picture"></i>picture</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pie"></i>pie</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pine"></i>pine</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-pixels"></i>pixels</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-play"></i>play</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-plugin"></i>plugin</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-plus"></i>plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-plus-circle"></i>plus-circle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-plus-square"></i>plus-square</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-polygonal"></i>polygonal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-power"></i>power</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-presentation"></i>presentation</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-price"></i>price</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-print"></i>print</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-puzzle"></i>puzzle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-qr-code"></i>qr-code</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-queen"></i>queen</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-question"></i>question</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-question-circle"></i>question-circle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-question-square"></i>question-square</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-quote-left"></i>quote-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-quote-right"></i>quote-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-radio"></i>radio</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-random"></i>random</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-recycle"></i>recycle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-refresh"></i>refresh</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-repair"></i>repair</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-reply"></i>reply</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-reply-all"></i>reply-all</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-resize"></i>resize</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-responsive"></i>responsive</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-retweet"></i>retweet</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-road"></i>road</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-robot"></i>robot</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rocket"></i>rocket</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-royal"></i>royal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-rss-feed"></i>rss-feed</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-safety"></i>safety</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sale-discount"></i>sale-discount</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-satellite"></i>satellite</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-send-mail"></i>send-mail</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-server"></i>server</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-settings"></i>settings</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-share"></i>share</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-share-alt"></i>share-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-share-boxed"></i>share-boxed</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-shield"></i>shield</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ship"></i>ship</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-shopping-cart"></i>shopping-cart</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sign-in"></i>sign-in</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sign-out"></i>sign-out</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-signal"></i>signal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-site-map"></i>site-map</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-smart-phone"></i>smart-phone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-soccer"></i>soccer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sort"></i>sort</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sort-alt"></i>sort-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-space"></i>space</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-spanner"></i>spanner</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-speech-comments"></i>speech-comments</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-speed-meter"></i>speed-meter</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-spinner"></i>spinner</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-spinner-alt-1"></i>spinner-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-spinner-alt-2"></i>spinner-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-spinner-alt-3"></i>spinner-alt-3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-spinner-alt-4"></i>spinner-alt-4</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-spinner-alt-5"></i>spinner-alt-5</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-spinner-alt-6"></i>spinner-alt-6</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-spreadsheet"></i>spreadsheet</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-square"></i>square</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ssl-security"></i>ssl-security</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-star"></i>star</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-star-alt-1"></i>star-alt-1</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-star-alt-2"></i>star-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-street-view"></i>street-view</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-sun"></i>sun</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-support-faq"></i>support-faq</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tack-pin"></i>tack-pin</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tag"></i>tag</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tags"></i>tags</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tasks"></i>tasks</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-telephone"></i>telephone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-telescope"></i>telescope</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-terminal"></i>terminal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-thumbs-down"></i>thumbs-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-thumbs-up"></i>thumbs-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tick-boxed"></i>tick-boxed</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tick-mark"></i>tick-mark</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-ticket"></i>ticket</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tie"></i>tie</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-toggle-off"></i>toggle-off</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-toggle-on"></i>toggle-on</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tools"></i>tools</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-transparent"></i>transparent</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-tree"></i>tree</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-umbrella"></i>umbrella</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-unlock"></i>unlock</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-unlocked"></i>unlocked</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-upload"></i>upload</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-upload-alt"></i>upload-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-usb"></i>usb</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-usb-drive"></i>usb-drive</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-vector-path"></i>vector-path</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-verification-check"></i>verification-check</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-video"></i>video</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-video-clapper"></i>video-clapper</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-volume-down"></i>volume-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-volume-off"></i>volume-off</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-volume-up"></i>volume-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wall"></i>wall</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wall-clock"></i>wall-clock</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wallet"></i>wallet</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-warning"></i>warning</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-warning-alt"></i>warning-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-water-drop"></i>water-drop</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-web"></i>web</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wheelchair"></i>wheelchair</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wifi"></i>wifi</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-wifi-alt"></i>wifi-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-world"></i>world</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-zigzag"></i>zigzag</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icofont icofont-zipped"></i>zipped</div>
                                </section>
                        `;

            modal.open({
              title: "Icon Palette",
              content: `${iconForm.outerHTML}`,
            });
          } else if (blockId.startsWith("ionic-icon-palette")) {
            console.log("inside ionic-icon-palette");

            // GRAPESJS MODAL LOGIC
            const iconForm = document.createElement("div");
            iconForm.setAttribute("class", "icon-form");
            iconForm.innerHTML = `
                                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/ionicons/2.0.0/css/ionicons.min.css" integrity="sha512-JApjWRnfonFeGBY7t4yq8SWr1A6xVYEJgO/UMIYONxaR3C9GETKUg0LharbJncEzJF5Nmiv+Pr5QNulr81LjGQ==" crossorigin="anonymous" referrerpolicy="no-referrer" />

                                <section>
                                    <div class="col-lg-4 col-sm-6"><i class="ion ion-ionic"></i>ion-ionic</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-up-a"></i>ion-arrow-up-a</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-right-a"></i>ion-arrow-right-a</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-down-a"></i>ion-arrow-down-a</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-left-a"></i>ion-arrow-left-a</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-up-b"></i>ion-arrow-up-b</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-right-b"></i>ion-arrow-right-b</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-down-b"></i>ion-arrow-down-b</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-left-b"></i>ion-arrow-left-b</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-up-c"></i>ion-arrow-up-c</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-right-c"></i>ion-arrow-right-c</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-down-c"></i>ion-arrow-down-c</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-left-c"></i>ion-arrow-left-c</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-return-right"></i>ion-arrow-return-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-return-left"></i>ion-arrow-return-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-swap"></i>ion-arrow-swap</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-shrink"></i>ion-arrow-shrink</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-expand"></i>ion-arrow-expand</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-move"></i>ion-arrow-move</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-resize"></i>ion-arrow-resize</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-chevron-up"></i>ion-chevron-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-chevron-right"></i>ion-chevron-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-chevron-down"></i>ion-chevron-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-chevron-left"></i>ion-chevron-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-navicon-round"></i>ion-navicon-round</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-navicon"></i>ion-navicon</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-drag"></i>ion-drag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-log-in"></i>ion-log-in</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-log-out"></i>ion-log-out</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-checkmark-round"></i>ion-checkmark-round</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-checkmark"></i>ion-checkmark</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-checkmark-circled"></i>ion-checkmark-circled</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-close-round"></i>ion-close-round</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-close"></i>ion-close</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-close-circled"></i>ion-close-circled</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-plus-round"></i>ion-plus-round</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-plus"></i>ion-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-plus-circled"></i>ion-plus-circled</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-minus-round"></i>ion-minus-round</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-minus"></i>ion-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-minus-circled"></i>ion-minus-circled</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-information"></i>ion-information</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-information-circled"></i>ion-information-circled</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-help"></i>ion-help</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-help-circled"></i>ion-help-circled</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-backspace-outline"></i>ion-backspace-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-backspace"></i>ion-backspace</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-help-buoy"></i>ion-help-buoy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-asterisk"></i>ion-asterisk</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-alert"></i>ion-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-alert-circled"></i>ion-alert-circled</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-refresh"></i>ion-refresh</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-loop"></i>ion-loop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-shuffle"></i>ion-shuffle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-home"></i>ion-home</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-search"></i>ion-search</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-flag"></i>ion-flag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-star"></i>ion-star</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-heart"></i>ion-heart</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-heart-broken"></i>ion-heart-broken</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-gear-a"></i>ion-gear-a</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-gear-b"></i>ion-gear-b</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-toggle-filled"></i>ion-toggle-filled</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-toggle"></i>ion-toggle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-settings"></i>ion-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-wrench"></i>ion-wrench</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-hammer"></i>ion-hammer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-edit"></i>ion-edit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-trash-a"></i>ion-trash-a</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-trash-b"></i>ion-trash-b</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-document"></i>ion-document</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-document-text"></i>ion-document-text</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-clipboard"></i>ion-clipboard</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-scissors"></i>ion-scissors</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-funnel"></i>ion-funnel</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-bookmark"></i>ion-bookmark</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-email"></i>ion-email</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-email-unread"></i>ion-email-unread</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-folder"></i>ion-folder</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-filing"></i>ion-filing</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-archive"></i>ion-archive</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-reply"></i>ion-reply</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-reply-all"></i>ion-reply-all</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-forward"></i>ion-forward</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-share"></i>ion-share</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-paper-airplane"></i>ion-paper-airplane</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-link"></i>ion-link</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-paperclip"></i>ion-paperclip</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-compose"></i>ion-compose</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-briefcase"></i>ion-briefcase</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-medkit"></i>ion-medkit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-at"></i>ion-at</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-pound"></i>ion-pound</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-quote"></i>ion-quote</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-cloud"></i>ion-cloud</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-upload"></i>ion-upload</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-more"></i>ion-more</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-grid"></i>ion-grid</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-calendar"></i>ion-calendar</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-clock"></i>ion-clock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-compass"></i>ion-compass</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-pinpoint"></i>ion-pinpoint</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-pin"></i>ion-pin</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-navigate"></i>ion-navigate</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-location"></i>ion-location</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-map"></i>ion-map</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-lock-combination"></i>ion-lock-combination</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-locked"></i>ion-locked</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-unlocked"></i>ion-unlocked</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-key"></i>ion-key</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-graph-up-right"></i>ion-arrow-graph-up-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-graph-down-right"></i>ion-arrow-graph-down-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-graph-up-left"></i>ion-arrow-graph-up-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-arrow-graph-down-left"></i>ion-arrow-graph-down-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-stats-bars"></i>ion-stats-bars</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-connection-bars"></i>ion-connection-bars</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-pie-graph"></i>ion-pie-graph</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-chatbubble"></i>ion-chatbubble</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-chatbubble-working"></i>ion-chatbubble-working</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-chatbubbles"></i>ion-chatbubbles</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-chatbox"></i>ion-chatbox</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-chatbox-working"></i>ion-chatbox-working</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-chatboxes"></i>ion-chatboxes</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-person"></i>ion-person</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-person-add"></i>ion-person-add</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-person-stalker"></i>ion-person-stalker</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-woman"></i>ion-woman</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-man"></i>ion-man</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-female"></i>ion-female</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-male"></i>ion-male</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-transgender"></i>ion-transgender</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-fork"></i>ion-fork</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-knife"></i>ion-knife</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-spoon"></i>ion-spoon</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-soup-can-outline"></i>ion-soup-can-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-soup-can"></i>ion-soup-can</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-beer"></i>ion-beer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-wineglass"></i>ion-wineglass</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-coffee"></i>ion-coffee</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-icecream"></i>ion-icecream</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-pizza"></i>ion-pizza</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-power"></i>ion-power</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-mouse"></i>ion-mouse</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-battery-full"></i>ion-battery-full</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-battery-half"></i>ion-battery-half</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-battery-low"></i>ion-battery-low</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-battery-empty"></i>ion-battery-empty</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-battery-charging"></i>ion-battery-charging</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-wifi"></i>ion-wifi</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-bluetooth"></i>ion-bluetooth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-calculator"></i>ion-calculator</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-camera"></i>ion-camera</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-eye"></i>ion-eye</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-eye-disabled"></i>ion-eye-disabled</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-flash"></i>ion-flash</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-flash-off"></i>ion-flash-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-qr-scanner"></i>ion-qr-scanner</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-image"></i>ion-image</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-images"></i>ion-images</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-wand"></i>ion-wand</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-contrast"></i>ion-contrast</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-aperture"></i>ion-aperture</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-crop"></i>ion-crop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-easel"></i>ion-easel</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-paintbrush"></i>ion-paintbrush</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-paintbucket"></i>ion-paintbucket</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-monitor"></i>ion-monitor</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-laptop"></i>ion-laptop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ipad"></i>ion-ipad</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-iphone"></i>ion-iphone</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ipod"></i>ion-ipod</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-printer"></i>ion-printer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-usb"></i>ion-usb</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-outlet"></i>ion-outlet</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-bug"></i>ion-bug</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-code"></i>ion-code</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-code-working"></i>ion-code-working</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-code-download"></i>ion-code-download</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-fork-repo"></i>ion-fork-repo</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-network"></i>ion-network</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-pull-request"></i>ion-pull-request</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-merge"></i>ion-merge</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-xbox"></i>ion-xbox</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-playstation"></i>ion-playstation</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-steam"></i>ion-steam</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-closed-captioning"></i>ion-closed-captioning</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-videocamera"></i>ion-videocamera</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-film-marker"></i>ion-film-marker</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-disc"></i>ion-disc</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-headphone"></i>ion-headphone</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-music-note"></i>ion-music-note</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-radio-waves"></i>ion-radio-waves</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-speakerphone"></i>ion-speakerphone</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-mic-a"></i>ion-mic-a</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-mic-b"></i>ion-mic-b</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-mic-c"></i>ion-mic-c</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-volume-high"></i>ion-volume-high</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-volume-medium"></i>ion-volume-medium</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-volume-low"></i>ion-volume-low</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-volume-mute"></i>ion-volume-mute</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-levels"></i>ion-levels</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-play"></i>ion-play</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-pause"></i>ion-pause</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-stop"></i>ion-stop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-record"></i>ion-record</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-skip-forward"></i>ion-skip-forward</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-skip-backward"></i>ion-skip-backward</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-eject"></i>ion-eject</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-bag"></i>ion-bag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-card"></i>ion-card</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-cash"></i>ion-cash</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-pricetag"></i>ion-pricetag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-pricetags"></i>ion-pricetags</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-thumbsup"></i>ion-thumbsup</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-thumbsdown"></i>ion-thumbsdown</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-happy-outline"></i>ion-happy-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-happy"></i>ion-happy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-sad-outline"></i>ion-sad-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-sad"></i>ion-sad</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-bowtie"></i>ion-bowtie</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-tshirt-outline"></i>ion-tshirt-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-tshirt"></i>ion-tshirt</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-trophy"></i>ion-trophy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-podium"></i>ion-podium</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ribbon-a"></i>ion-ribbon-a</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ribbon-b"></i>ion-ribbon-b</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-university"></i>ion-university</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-magnet"></i>ion-magnet</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-beaker"></i>ion-beaker</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-erlenmeyer-flask"></i>ion-erlenmeyer-flask</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-egg"></i>ion-egg</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-earth"></i>ion-earth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-planet"></i>ion-planet</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-lightbulb"></i>ion-lightbulb</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-cube"></i>ion-cube</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-leaf"></i>ion-leaf</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-waterdrop"></i>ion-waterdrop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-flame"></i>ion-flame</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-fireball"></i>ion-fireball</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-bonfire"></i>ion-bonfire</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-umbrella"></i>ion-umbrella</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-nuclear"></i>ion-nuclear</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-no-smoking"></i>ion-no-smoking</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-thermometer"></i>ion-thermometer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-speedometer"></i>ion-speedometer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-model-s"></i>ion-model-s</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-plane"></i>ion-plane</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-jet"></i>ion-jet</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-load-a"></i>ion-load-a</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-load-b"></i>ion-load-b</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-load-c"></i>ion-load-c</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-load-d"></i>ion-load-d</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-ionic-outline"></i>ion-ios-ionic-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-arrow-back"></i>ion-ios-arrow-back</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-arrow-forward"></i>ion-ios-arrow-forward</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-arrow-up"></i>ion-ios-arrow-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-arrow-right"></i>ion-ios-arrow-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-arrow-down"></i>ion-ios-arrow-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-arrow-left"></i>ion-ios-arrow-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-arrow-thin-up"></i>ion-ios-arrow-thin-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-arrow-thin-right"></i>ion-ios-arrow-thin-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-arrow-thin-down"></i>ion-ios-arrow-thin-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-arrow-thin-left"></i>ion-ios-arrow-thin-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-circle-filled"></i>ion-ios-circle-filled</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-circle-outline"></i>ion-ios-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-checkmark-empty"></i>ion-ios-checkmark-empty</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-checkmark-outline"></i>ion-ios-checkmark-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-checkmark"></i>ion-ios-checkmark</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-plus-empty"></i>ion-ios-plus-empty</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-plus-outline"></i>ion-ios-plus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-plus"></i>ion-ios-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-close-empty"></i>ion-ios-close-empty</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-close-outline"></i>ion-ios-close-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-close"></i>ion-ios-close</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-minus-empty"></i>ion-ios-minus-empty</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-minus-outline"></i>ion-ios-minus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-minus"></i>ion-ios-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-information-empty"></i>ion-ios-information-empty</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-information-outline"></i>ion-ios-information-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-information"></i>ion-ios-information</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-help-empty"></i>ion-ios-help-empty</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-help-outline"></i>ion-ios-help-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-help"></i>ion-ios-help</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-search"></i>ion-ios-search</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-search-strong"></i>ion-ios-search-strong</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-star"></i>ion-ios-star</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-star-half"></i>ion-ios-star-half</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-star-outline"></i>ion-ios-star-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-heart"></i>ion-ios-heart</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-heart-outline"></i>ion-ios-heart-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-more"></i>ion-ios-more</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-more-outline"></i>ion-ios-more-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-home"></i>ion-ios-home</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-home-outline"></i>ion-ios-home-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-cloud"></i>ion-ios-cloud</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-cloud-outline"></i>ion-ios-cloud-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-cloud-upload"></i>ion-ios-cloud-upload</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-cloud-upload-outline"></i>ion-ios-cloud-upload-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-cloud-download"></i>ion-ios-cloud-download</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-cloud-download-outline"></i>ion-ios-cloud-download-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-upload"></i>ion-ios-upload</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-upload-outline"></i>ion-ios-upload-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-download"></i>ion-ios-download</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-download-outline"></i>ion-ios-download-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-refresh"></i>ion-ios-refresh</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-refresh-outline"></i>ion-ios-refresh-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-refresh-empty"></i>ion-ios-refresh-empty</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-reload"></i>ion-ios-reload</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-loop-strong"></i>ion-ios-loop-strong</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-loop"></i>ion-ios-loop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-bookmarks"></i>ion-ios-bookmarks</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-bookmarks-outline"></i>ion-ios-bookmarks-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-book"></i>ion-ios-book</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-book-outline"></i>ion-ios-book-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-flag"></i>ion-ios-flag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-flag-outline"></i>ion-ios-flag-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-glasses"></i>ion-ios-glasses</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-glasses-outline"></i>ion-ios-glasses-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-browsers"></i>ion-ios-browsers</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-browsers-outline"></i>ion-ios-browsers-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-at"></i>ion-ios-at</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-at-outline"></i>ion-ios-at-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-pricetag"></i>ion-ios-pricetag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-pricetag-outline"></i>ion-ios-pricetag-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-pricetags"></i>ion-ios-pricetags</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-pricetags-outline"></i>ion-ios-pricetags-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-cart"></i>ion-ios-cart</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-cart-outline"></i>ion-ios-cart-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-chatboxes"></i>ion-ios-chatboxes</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-chatboxes-outline"></i>ion-ios-chatboxes-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-chatbubble"></i>ion-ios-chatbubble</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-chatbubble-outline"></i>ion-ios-chatbubble-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-cog"></i>ion-ios-cog</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-cog-outline"></i>ion-ios-cog-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-gear"></i>ion-ios-gear</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-gear-outline"></i>ion-ios-gear-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-settings"></i>ion-ios-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-settings-strong"></i>ion-ios-settings-strong</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-toggle"></i>ion-ios-toggle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-toggle-outline"></i>ion-ios-toggle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-analytics"></i>ion-ios-analytics</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-analytics-outline"></i>ion-ios-analytics-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-pie"></i>ion-ios-pie</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-pie-outline"></i>ion-ios-pie-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-pulse"></i>ion-ios-pulse</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-pulse-strong"></i>ion-ios-pulse-strong</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-filing"></i>ion-ios-filing</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-filing-outline"></i>ion-ios-filing-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-box"></i>ion-ios-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-box-outline"></i>ion-ios-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-compose"></i>ion-ios-compose</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-compose-outline"></i>ion-ios-compose-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-trash"></i>ion-ios-trash</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-trash-outline"></i>ion-ios-trash-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-copy"></i>ion-ios-copy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-copy-outline"></i>ion-ios-copy-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-email"></i>ion-ios-email</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-email-outline"></i>ion-ios-email-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-undo"></i>ion-ios-undo</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-undo-outline"></i>ion-ios-undo-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-redo"></i>ion-ios-redo</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-redo-outline"></i>ion-ios-redo-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-paperplane"></i>ion-ios-paperplane</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-paperplane-outline"></i>ion-ios-paperplane-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-folder"></i>ion-ios-folder</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-folder-outline"></i>ion-ios-folder-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-paper"></i>ion-ios-paper</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-paper-outline"></i>ion-ios-paper-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-list"></i>ion-ios-list</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-list-outline"></i>ion-ios-list-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-world"></i>ion-ios-world</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-world-outline"></i>ion-ios-world-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-alarm"></i>ion-ios-alarm</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-alarm-outline"></i>ion-ios-alarm-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-speedometer"></i>ion-ios-speedometer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-speedometer-outline"></i>ion-ios-speedometer-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-stopwatch"></i>ion-ios-stopwatch</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-stopwatch-outline"></i>ion-ios-stopwatch-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-timer"></i>ion-ios-timer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-timer-outline"></i>ion-ios-timer-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-clock"></i>ion-ios-clock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-clock-outline"></i>ion-ios-clock-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-time"></i>ion-ios-time</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-time-outline"></i>ion-ios-time-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-calendar"></i>ion-ios-calendar</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-calendar-outline"></i>ion-ios-calendar-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-photos"></i>ion-ios-photos</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-photos-outline"></i>ion-ios-photos-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-albums"></i>ion-ios-albums</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-albums-outline"></i>ion-ios-albums-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-camera"></i>ion-ios-camera</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-camera-outline"></i>ion-ios-camera-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-reverse-camera"></i>ion-ios-reverse-camera</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-reverse-camera-outline"></i>ion-ios-reverse-camera-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-eye"></i>ion-ios-eye</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-eye-outline"></i>ion-ios-eye-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-bolt"></i>ion-ios-bolt</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-bolt-outline"></i>ion-ios-bolt-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-color-wand"></i>ion-ios-color-wand</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-color-wand-outline"></i>ion-ios-color-wand-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-color-filter"></i>ion-ios-color-filter</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-color-filter-outline"></i>ion-ios-color-filter-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-grid-view"></i>ion-ios-grid-view</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-grid-view-outline"></i>ion-ios-grid-view-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-crop-strong"></i>ion-ios-crop-strong</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-crop"></i>ion-ios-crop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-barcode"></i>ion-ios-barcode</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-barcode-outline"></i>ion-ios-barcode-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-briefcase"></i>ion-ios-briefcase</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-briefcase-outline"></i>ion-ios-briefcase-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-medkit"></i>ion-ios-medkit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-medkit-outline"></i>ion-ios-medkit-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-medical"></i>ion-ios-medical</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-medical-outline"></i>ion-ios-medical-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-infinite"></i>ion-ios-infinite</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-infinite-outline"></i>ion-ios-infinite-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-calculator"></i>ion-ios-calculator</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-calculator-outline"></i>ion-ios-calculator-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-keypad"></i>ion-ios-keypad</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-keypad-outline"></i>ion-ios-keypad-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-telephone"></i>ion-ios-telephone</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-telephone-outline"></i>ion-ios-telephone-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-drag"></i>ion-ios-drag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-location"></i>ion-ios-location</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-location-outline"></i>ion-ios-location-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-navigate"></i>ion-ios-navigate</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-navigate-outline"></i>ion-ios-navigate-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-locked"></i>ion-ios-locked</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-locked-outline"></i>ion-ios-locked-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-unlocked"></i>ion-ios-unlocked</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-unlocked-outline"></i>ion-ios-unlocked-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-monitor"></i>ion-ios-monitor</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-monitor-outline"></i>ion-ios-monitor-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-printer"></i>ion-ios-printer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-printer-outline"></i>ion-ios-printer-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-game-controller-a"></i>ion-ios-game-controller-a</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-game-controller-a-outline"></i>ion-ios-game-controller-a-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-game-controller-b"></i>ion-ios-game-controller-b</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-game-controller-b-outline"></i>ion-ios-game-controller-b-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-americanfootball"></i>ion-ios-americanfootball</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-americanfootball-outline"></i>ion-ios-americanfootball-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-baseball"></i>ion-ios-baseball</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-baseball-outline"></i>ion-ios-baseball-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-basketball"></i>ion-ios-basketball</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-basketball-outline"></i>ion-ios-basketball-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-tennisball"></i>ion-ios-tennisball</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-tennisball-outline"></i>ion-ios-tennisball-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-football"></i>ion-ios-football</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-football-outline"></i>ion-ios-football-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-body"></i>ion-ios-body</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-body-outline"></i>ion-ios-body-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-person"></i>ion-ios-person</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-person-outline"></i>ion-ios-person-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-personadd"></i>ion-ios-personadd</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-personadd-outline"></i>ion-ios-personadd-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-people"></i>ion-ios-people</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-people-outline"></i>ion-ios-people-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-musical-notes"></i>ion-ios-musical-notes</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-musical-note"></i>ion-ios-musical-note</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-bell"></i>ion-ios-bell</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-bell-outline"></i>ion-ios-bell-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-mic"></i>ion-ios-mic</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-mic-outline"></i>ion-ios-mic-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-mic-off"></i>ion-ios-mic-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-volume-high"></i>ion-ios-volume-high</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-volume-low"></i>ion-ios-volume-low</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-play"></i>ion-ios-play</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-play-outline"></i>ion-ios-play-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-pause"></i>ion-ios-pause</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-pause-outline"></i>ion-ios-pause-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-recording"></i>ion-ios-recording</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-recording-outline"></i>ion-ios-recording-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-fastforward"></i>ion-ios-fastforward</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-fastforward-outline"></i>ion-ios-fastforward-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-rewind"></i>ion-ios-rewind</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-rewind-outline"></i>ion-ios-rewind-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-skipbackward"></i>ion-ios-skipbackward</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-skipbackward-outline"></i>ion-ios-skipbackward-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-skipforward"></i>ion-ios-skipforward</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-skipforward-outline"></i>ion-ios-skipforward-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-shuffle-strong"></i>ion-ios-shuffle-strong</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-shuffle"></i>ion-ios-shuffle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-videocam"></i>ion-ios-videocam</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-videocam-outline"></i>ion-ios-videocam-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-film"></i>ion-ios-film</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-film-outline"></i>ion-ios-film-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-flask"></i>ion-ios-flask</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-flask-outline"></i>ion-ios-flask-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-lightbulb"></i>ion-ios-lightbulb</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-lightbulb-outline"></i>ion-ios-lightbulb-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-wineglass"></i>ion-ios-wineglass</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-wineglass-outline"></i>ion-ios-wineglass-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-pint"></i>ion-ios-pint</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-pint-outline"></i>ion-ios-pint-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-nutrition"></i>ion-ios-nutrition</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-nutrition-outline"></i>ion-ios-nutrition-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-flower"></i>ion-ios-flower</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-flower-outline"></i>ion-ios-flower-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-rose"></i>ion-ios-rose</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-rose-outline"></i>ion-ios-rose-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-paw"></i>ion-ios-paw</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-paw-outline"></i>ion-ios-paw-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-flame"></i>ion-ios-flame</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-flame-outline"></i>ion-ios-flame-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-sunny"></i>ion-ios-sunny</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-sunny-outline"></i>ion-ios-sunny-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-partlysunny"></i>ion-ios-partlysunny</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-partlysunny-outline"></i>ion-ios-partlysunny-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-cloudy"></i>ion-ios-cloudy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-cloudy-outline"></i>ion-ios-cloudy-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-rainy"></i>ion-ios-rainy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-rainy-outline"></i>ion-ios-rainy-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-thunderstorm"></i>ion-ios-thunderstorm</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-thunderstorm-outline"></i>ion-ios-thunderstorm-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-snowy"></i>ion-ios-snowy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-moon"></i>ion-ios-moon</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-moon-outline"></i>ion-ios-moon-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-cloudy-night"></i>ion-ios-cloudy-night</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-ios-cloudy-night-outline"></i>ion-ios-cloudy-night-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-arrow-up"></i>ion-android-arrow-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-arrow-forward"></i>ion-android-arrow-forward</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-arrow-down"></i>ion-android-arrow-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-arrow-back"></i>ion-android-arrow-back</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-arrow-dropup"></i>ion-android-arrow-dropup</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-arrow-dropup-circle"></i>ion-android-arrow-dropup-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-arrow-dropright"></i>ion-android-arrow-dropright</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-arrow-dropright-circle"></i>ion-android-arrow-dropright-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-arrow-dropdown"></i>ion-android-arrow-dropdown</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-arrow-dropdown-circle"></i>ion-android-arrow-dropdown-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-arrow-dropleft"></i>ion-android-arrow-dropleft</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-arrow-dropleft-circle"></i>ion-android-arrow-dropleft-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-add"></i>ion-android-add</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-add-circle"></i>ion-android-add-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-remove"></i>ion-android-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-remove-circle"></i>ion-android-remove-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-close"></i>ion-android-close</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-cancel"></i>ion-android-cancel</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-radio-button-off"></i>ion-android-radio-button-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-radio-button-on"></i>ion-android-radio-button-on</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-checkmark-circle"></i>ion-android-checkmark-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-checkbox-outline-blank"></i>ion-android-checkbox-outline-blank</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-checkbox-outline"></i>ion-android-checkbox-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-checkbox-blank"></i>ion-android-checkbox-blank</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-checkbox"></i>ion-android-checkbox</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-done"></i>ion-android-done</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-done-all"></i>ion-android-done-all</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-menu"></i>ion-android-menu</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-more-horizontal"></i>ion-android-more-horizontal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-more-vertical"></i>ion-android-more-vertical</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-refresh"></i>ion-android-refresh</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-sync"></i>ion-android-sync</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-wifi"></i>ion-android-wifi</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-call"></i>ion-android-call</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-apps"></i>ion-android-apps</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-settings"></i>ion-android-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-options"></i>ion-android-options</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-funnel"></i>ion-android-funnel</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-search"></i>ion-android-search</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-home"></i>ion-android-home</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-cloud-outline"></i>ion-android-cloud-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-cloud"></i>ion-android-cloud</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-download"></i>ion-android-download</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-upload"></i>ion-android-upload</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-cloud-done"></i>ion-android-cloud-done</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-cloud-circle"></i>ion-android-cloud-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-favorite-outline"></i>ion-android-favorite-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-favorite"></i>ion-android-favorite</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-star-outline"></i>ion-android-star-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-star-half"></i>ion-android-star-half</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-star"></i>ion-android-star</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-calendar"></i>ion-android-calendar</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-alarm-clock"></i>ion-android-alarm-clock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-time"></i>ion-android-time</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-stopwatch"></i>ion-android-stopwatch</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-watch"></i>ion-android-watch</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-locate"></i>ion-android-locate</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-navigate"></i>ion-android-navigate</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-pin"></i>ion-android-pin</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-compass"></i>ion-android-compass</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-map"></i>ion-android-map</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-walk"></i>ion-android-walk</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-bicycle"></i>ion-android-bicycle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-car"></i>ion-android-car</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-bus"></i>ion-android-bus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-subway"></i>ion-android-subway</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-train"></i>ion-android-train</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-boat"></i>ion-android-boat</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-plane"></i>ion-android-plane</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-restaurant"></i>ion-android-restaurant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-bar"></i>ion-android-bar</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-cart"></i>ion-android-cart</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-camera"></i>ion-android-camera</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-image"></i>ion-android-image</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-film"></i>ion-android-film</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-color-palette"></i>ion-android-color-palette</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-create"></i>ion-android-create</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-mail"></i>ion-android-mail</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-drafts"></i>ion-android-drafts</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-send"></i>ion-android-send</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-archive"></i>ion-android-archive</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-delete"></i>ion-android-delete</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-attach"></i>ion-android-attach</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-share"></i>ion-android-share</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-share-alt"></i>ion-android-share-alt</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-bookmark"></i>ion-android-bookmark</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-document"></i>ion-android-document</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-clipboard"></i>ion-android-clipboard</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-list"></i>ion-android-list</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-folder-open"></i>ion-android-folder-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-folder"></i>ion-android-folder</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-print"></i>ion-android-print</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-open"></i>ion-android-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-exit"></i>ion-android-exit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-contract"></i>ion-android-contract</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-expand"></i>ion-android-expand</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-globe"></i>ion-android-globe</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-chat"></i>ion-android-chat</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-textsms"></i>ion-android-textsms</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-hangout"></i>ion-android-hangout</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-happy"></i>ion-android-happy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-sad"></i>ion-android-sad</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-person"></i>ion-android-person</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-people"></i>ion-android-people</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-person-add"></i>ion-android-person-add</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-contact"></i>ion-android-contact</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-contacts"></i>ion-android-contacts</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-playstore"></i>ion-android-playstore</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-lock"></i>ion-android-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-unlock"></i>ion-android-unlock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-microphone"></i>ion-android-microphone</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-microphone-off"></i>ion-android-microphone-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-notifications-none"></i>ion-android-notifications-none</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-notifications"></i>ion-android-notifications</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-notifications-off"></i>ion-android-notifications-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-volume-mute"></i>ion-android-volume-mute</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-volume-down"></i>ion-android-volume-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-volume-up"></i>ion-android-volume-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-volume-off"></i>ion-android-volume-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-hand"></i>ion-android-hand</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-desktop"></i>ion-android-desktop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-laptop"></i>ion-android-laptop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-phone-portrait"></i>ion-android-phone-portrait</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-phone-landscape"></i>ion-android-phone-landscape</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-bulb"></i>ion-android-bulb</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-sunny"></i>ion-android-sunny</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-alert"></i>ion-android-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-android-warning"></i>ion-android-warning</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-twitter"></i>ion-social-twitter</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-twitter-outline"></i>ion-social-twitter-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-facebook"></i>ion-social-facebook</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-facebook-outline"></i>ion-social-facebook-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-googleplus"></i>ion-social-googleplus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-googleplus-outline"></i>ion-social-googleplus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-google"></i>ion-social-google</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-google-outline"></i>ion-social-google-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-dribbble"></i>ion-social-dribbble</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-dribbble-outline"></i>ion-social-dribbble-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-octocat"></i>ion-social-octocat</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-github"></i>ion-social-github</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-github-outline"></i>ion-social-github-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-instagram"></i>ion-social-instagram</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-instagram-outline"></i>ion-social-instagram-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-whatsapp"></i>ion-social-whatsapp</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-whatsapp-outline"></i>ion-social-whatsapp-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-snapchat"></i>ion-social-snapchat</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-snapchat-outline"></i>ion-social-snapchat-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-foursquare"></i>ion-social-foursquare</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-foursquare-outline"></i>ion-social-foursquare-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-pinterest"></i>ion-social-pinterest</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-pinterest-outline"></i>ion-social-pinterest-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-rss"></i>ion-social-rss</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-rss-outline"></i>ion-social-rss-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-tumblr"></i>ion-social-tumblr</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-tumblr-outline"></i>ion-social-tumblr-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-wordpress"></i>ion-social-wordpress</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-wordpress-outline"></i>ion-social-wordpress-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-reddit"></i>ion-social-reddit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-reddit-outline"></i>ion-social-reddit-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-hackernews"></i>ion-social-hackernews</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-hackernews-outline"></i>ion-social-hackernews-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-designernews"></i>ion-social-designernews</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-designernews-outline"></i>ion-social-designernews-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-yahoo"></i>ion-social-yahoo</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-yahoo-outline"></i>ion-social-yahoo-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-buffer"></i>ion-social-buffer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-buffer-outline"></i>ion-social-buffer-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-skype"></i>ion-social-skype</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-skype-outline"></i>ion-social-skype-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-linkedin"></i>ion-social-linkedin</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-linkedin-outline"></i>ion-social-linkedin-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-vimeo"></i>ion-social-vimeo</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-vimeo-outline"></i>ion-social-vimeo-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-twitch"></i>ion-social-twitch</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-twitch-outline"></i>ion-social-twitch-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-youtube"></i>ion-social-youtube</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-youtube-outline"></i>ion-social-youtube-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-dropbox"></i>ion-social-dropbox</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-dropbox-outline"></i>ion-social-dropbox-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-apple"></i>ion-social-apple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-apple-outline"></i>ion-social-apple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-android"></i>ion-social-android</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-android-outline"></i>ion-social-android-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-windows"></i>ion-social-windows</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-windows-outline"></i>ion-social-windows-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-html5"></i>ion-social-html5</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-html5-outline"></i>ion-social-html5-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-css3"></i>ion-social-css3</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-css3-outline"></i>ion-social-css3-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-javascript"></i>ion-social-javascript</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-javascript-outline"></i>ion-social-javascript-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-angular"></i>ion-social-angular</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-angular-outline"></i>ion-social-angular-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-nodejs"></i>ion-social-nodejs</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-sass"></i>ion-social-sass</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-python"></i>ion-social-python</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-chrome"></i>ion-social-chrome</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-chrome-outline"></i>ion-social-chrome-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-codepen"></i>ion-social-codepen</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-codepen-outline"></i>ion-social-codepen-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-markdown"></i>ion-social-markdown</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-tux"></i>ion-social-tux</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-freebsd-devil"></i>ion-social-freebsd-devil</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-usd"></i>ion-social-usd</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-usd-outline"></i>ion-social-usd-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-bitcoin"></i>ion-social-bitcoin</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-bitcoin-outline"></i>ion-social-bitcoin-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-yen"></i>ion-social-yen</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-yen-outline"></i>ion-social-yen-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-euro"></i>ion-social-euro</div>
                                      <div class="col-lg-4 col-sm-6"><i class="ion ion-social-euro-outline"></i>ion-social-euro-outline</div>
                                </section>
                        `;

            modal.open({
              title: "Icon Palette",
              content: `${iconForm.outerHTML}`,
            });
          } else if (blockId.startsWith("themify-icon-palette")) {
            console.log("inside themify-icon-palette");

            // GRAPESJS MODAL LOGIC
            const iconForm = document.createElement("div");
            iconForm.setAttribute("class", "icon-form");
            iconForm.innerHTML = `
                                <link rel="stylesheet" type="text/css" href="/assets/css/themify.css">

                                <p>Arrows & Direction Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-arrow-up"></i> icon-arrow-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-arrow-right"></i> icon-arrow-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-arrow-left"></i> icon-arrow-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-arrow-down"></i> icon-arrow-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-arrows-vertical"></i> icon-arrows-vertical</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-arrows-horizontal"></i> icon-arrows-horizontal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-angle-up"></i> icon-angle-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-angle-right"></i> icon-angle-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-angle-left"></i> icon-angle-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-angle-down"></i> icon-angle-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-angle-double-up"></i> icon-angle-double-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-angle-double-right"></i> icon-angle-double-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-angle-double-left"></i> icon-angle-double-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-angle-double-down"></i> icon-angle-double-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-move"></i> icon-move</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-fullscreen"></i> icon-fullscreen</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-arrow-top-right"></i> icon-arrow-top-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-arrow-top-left"></i> icon-arrow-top-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-arrow-circle-up"></i> icon-arrow-circle-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-arrow-circle-right"></i> icon-arrow-circle-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-arrow-circle-left"></i> icon-arrow-circle-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-arrow-circle-down"></i> icon-arrow-circle-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-arrows-corner"></i> icon-arrows-corner</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-split-v"></i> icon-split-v</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-split-v-alt"></i> icon-split-v-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-split-h"></i> icon-split-h</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-hand-point-up"></i> icon-hand-point-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-hand-point-right"></i> icon-hand-point-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-hand-point-left"></i> icon-hand-point-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-hand-point-down"></i> icon-hand-point-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-back-right"></i> icon-back-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-back-left"></i> icon-back-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-exchange-vertical"></i> icon-exchange-vertical</div>
                                </section>

                                <br>

                                <p>Web App Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-wand"></i> icon-wand</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-save"></i> icon-save</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-save-alt"></i> icon-save-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-direction"></i> icon-direction</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-direction-alt"></i> icon-direction-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-user"></i> icon-user</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-link"></i> icon-link</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-unlink"></i> icon-unlink</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-trash"></i> icon-trash</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-target"></i> icon-target</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-tag"></i> icon-tag</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-desktop"></i> icon-desktop</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-tablet"></i> icon-tablet</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-mobile"></i> icon-mobile</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-email"></i> icon-email</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-star"></i> icon-star</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-spray"></i> icon-spray</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-signal"></i> icon-signal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-shopping-cart"></i> icon-shopping-cart</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-shopping-cart-full"></i> icon-shopping-cart-full</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-settings"></i> icon-settings</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-search"></i> icon-search</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-zoom-in"></i> icon-zoom-in</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-zoom-out"></i> icon-zoom-out</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-cut"></i> icon-cut</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-ruler"></i> icon-ruler</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-ruler-alt-2"></i> icon-ruler-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-ruler-pencil"></i> icon-ruler-pencil</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-ruler-alt"></i> icon-ruler-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-bookmark"></i> icon-bookmark</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-bookmark-alt"></i> icon-bookmark-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-reload"></i> icon-reload</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-plus"></i> icon-plus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-minus"></i> icon-minus</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-close"></i> icon-close</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-pin"></i> icon-pin</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-pencil"></i> icon-pencil</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-pencil-alt"></i> icon-pencil-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-paint-roller"></i> icon-paint-roller</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-paint-bucket"></i> icon-paint-bucket</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-na"></i> icon-na</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-medall"></i> icon-medall</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-medall-alt"></i> icon-medall-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-marker"></i> icon-marker</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-marker-alt"></i> icon-marker-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-lock"></i> icon-lock</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-unlock"></i> icon-unlock</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-location-arrow"></i> icon-location-arrow</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-layout"></i> icon-layout</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-layers"></i> icon-layers</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-layers-alt"></i> icon-layers-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-key"></i> icon-key</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-image"></i> icon-image</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-heart"></i> icon-heart</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-heart-broken"></i> icon-heart-broken</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-hand-stop"></i> icon-hand-stop</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-hand-open"></i> icon-hand-open</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-hand-drag"></i> icon-hand-drag</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-flag"></i> icon-flag</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-flag-alt"></i> icon-flag-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-flag-alt-2"></i> icon-flag-alt-2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-eye"></i> icon-eye</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-import"></i> icon-import</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-export"></i> icon-export</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-cup"></i> icon-cup</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-crown"></i> icon-crown</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-comments"></i> icon-comments</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-comment"></i> icon-comment</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-comment-alt"></i> icon-comment-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-thought"></i> icon-thought</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-clip"></i> icon-clip</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-check"></i> icon-check</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-check-box"></i> icon-check-box</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-camera"></i> icon-camera</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-announcement"></i> icon-announcement</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-brush"></i> icon-brush</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-brush-alt"></i> icon-brush-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-palette"></i> icon-palette</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-briefcase"></i> icon-briefcase</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-bolt"></i> icon-bolt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-bolt-alt"></i> icon-bolt-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-blackboard"></i> icon-blackboard</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-bag"></i> icon-bag</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-world"></i> icon-world</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-wheelchair"></i> icon-wheelchair</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-car"></i> icon-car</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-truck"></i> icon-truck</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-timer"></i> icon-timer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-ticket"></i> icon-ticket</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-thumb-up"></i> icon-thumb-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-thumb-down"></i> icon-thumb-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-stats-up"></i> icon-stats-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-stats-down"></i> icon-stats-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-shine"></i> icon-shine</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-shift-right"></i> icon-shift-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-shift-left"></i> icon-shift-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-shift-right-alt"></i> icon-shift-right-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-shift-left-alt"></i> icon-shift-left-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-shield"></i> icon-shield</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-notepad"></i> icon-notepad</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-server"></i> icon-server</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-pulse"></i> icon-pulse</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-printer"></i> icon-printer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-power-off"></i> icon-power-off</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-plug"></i> icon-plug</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-pie-chart"></i> icon-pie-chart</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-panel"></i> icon-panel</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-package"></i> icon-package</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-music"></i> icon-music</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-music-alt"></i> icon-music-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-mouse"></i> icon-mouse</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-mouse-alt"></i> icon-mouse-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-money"></i> icon-money</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-microphone"></i> icon-microphone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-menu"></i> icon-menu</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-menu-alt"></i> icon-menu-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-map"></i> icon-map</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-map-alt"></i> icon-map-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-location-pin"></i> icon-location-pin</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-light-bulb"></i> icon-light-bulb</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-info"></i> icon-info</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-infinite"></i> icon-infinite</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-id-badge"></i> icon-id-badge</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-hummer"></i> icon-hummer</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-home"></i> icon-home</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-help"></i> icon-help</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-headphone"></i> icon-headphone</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-harddrives"></i> icon-harddrives</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-harddrive"></i> icon-harddrive</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-gift"></i> icon-gift</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-game"></i> icon-game</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-filter"></i> icon-filter</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-files"></i> icon-files</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-file"></i> icon-file</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-zip"></i> icon-zip</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-folder"></i> icon-folder</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-envelope"></i> icon-envelope</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-dashboard"></i> icon-dashboard</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-cloud"></i> icon-cloud</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-cloud-up"></i> icon-cloud-up</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-cloud-down"></i> icon-cloud-down</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-clipboard"></i> icon-clipboard</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-calendar"></i> icon-calendar</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-book"></i> icon-book</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-bell"></i> icon-bell</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-basketball"></i> icon-basketball</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-bar-chart"></i> icon-bar-chart</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-bar-chart-alt"></i> icon-bar-chart-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-archive"></i> icon-archive</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-anchor"></i> icon-anchor</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-alert"></i> icon-alert</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-alarm-clock"></i> icon-alarm-clock</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-agenda"></i> icon-agenda</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-write"></i> icon-write</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-wallet"></i> icon-wallet</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-video-clapper"></i> icon-video-clapper</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-video-camera"></i> icon-video-camera</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-vector"></i> icon-vector</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-support"></i> icon-support</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-stamp"></i> icon-stamp</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-slice"></i> icon-slice</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-shortcode"></i> icon-shortcode</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-receipt"></i> icon-receipt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-pin2"></i> icon-pin2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-pin-alt"></i> icon-pin-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-pencil-alt2"></i> icon-pencil-alt2</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-eraser"></i> icon-eraser</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-more"></i> icon-more</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-more-alt"></i> icon-more-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-microphone-alt"></i> icon-microphone-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-magnet"></i> icon-magnet</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-line-double"></i> icon-line-double</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-line-dotted"></i> icon-line-dotted</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-line-dashed"></i> icon-line-dashed</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-ink-pen"></i> icon-ink-pen</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-info-alt"></i> icon-info-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-help-alt"></i> icon-help-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-headphone-alt"></i> icon-headphone-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-gallery"></i> icon-gallery</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-face-smile"></i> icon-face-smile</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-face-sad"></i> icon-face-sad</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-credit-card"></i> icon-credit-card</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-comments-smiley"></i> icon-comments-smiley</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-time"></i> icon-time</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-share"></i> icon-share</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-share-alt"></i> icon-share-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-rocket"></i> icon-rocket</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-new-window"></i> icon-new-window</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-rss"></i> icon-rss</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-rss-alt"></i> icon-rss-alt</div>
                                </section>

                                <br>

                                <p>Control Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-control-stop"></i> icon-control-stop</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-control-shuffle"></i> icon-control-shuffle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-control-play"></i> icon-control-play</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-control-pause"></i> icon-control-pause</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-control-forward"></i> icon-control-forward</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-control-backward"></i> icon-control-backward</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-volume"></i> icon-volume</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-control-skip-forward"></i> icon-control-skip-forward</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-control-skip-backward"></i> icon-control-skip-backward</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-control-record"></i> icon-control-record</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-control-eject"></i> icon-control-eject</div>
                                </section>

                                <br>

                                <p>Text Editor Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-paragraph"></i> icon-paragraph</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-uppercase"></i> icon-uppercase</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-underline"></i> icon-underline</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-text"></i> icon-text</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-Italic"></i> icon-Italic</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-smallcap"></i> icon-smallcap</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-list"></i> icon-list</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-list-ol"></i> icon-list-ol</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-align-right"></i> icon-align-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-align-left"></i> icon-align-left</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-align-justify"></i> icon-align-justify</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-align-center"></i> icon-align-center</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-quote-right"></i> icon-quote-right</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-quote-left"></i> icon-quote-left</div>
                                </section>

                                <br>

                                <p>Brand Icons</p>
                                <section>
                                    <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-flickr"></i> icon-flickr</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-flickr-alt"></i> icon-flickr-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-instagram"></i> icon-instagram</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-google"></i> icon-google</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-github"></i> icon-github</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-facebook"></i> icon-facebook</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-dropbox"></i> icon-dropbox</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-dropbox-alt"></i> icon-dropbox-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-dribbble"></i> icon-dribbble</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-apple"></i> icon-apple</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-android"></i> icon-android</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-yahoo"></i> icon-yahoo</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-trello"></i> icon-trello</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-stack-overflow"></i> icon-stack-overflow</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-soundcloud"></i> icon-soundcloud</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-sharethis"></i> icon-sharethis</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-sharethis-alt"></i> icon-sharethis-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-reddit"></i> icon-reddit</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-microsoft"></i> icon-microsoft</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-microsoft-alt"></i> icon-microsoft-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-linux"></i> icon-linux</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-jsfiddle"></i> icon-jsfiddle</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-joomla"></i> icon-joomla</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-html5"></i> icon-html5</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-css3"></i> icon-css3</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-drupal"></i> icon-drupal</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-wordpress"></i> icon-wordpress</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-tumblr"></i> icon-tumblr</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-tumblr-alt"></i> icon-tumblr-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-skype"></i> icon-skype</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-youtube"></i> icon-youtube</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-vimeo"></i> icon-vimeo</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-vimeo-alt"></i> icon-vimeo-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-twitter"></i> icon-twitter</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-twitter-alt"></i> icon-twitter-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-linkedin"></i> icon-linkedin</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-pinterest"></i> icon-pinterest</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-pinterest-alt"></i> icon-pinterest-alt</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-themify-logo"></i> icon-themify-logo</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-themify-favicon"></i> icon-themify-favicon</div>
                                      <div class="col-sm-6 col-md-6 col-lg-4"><i class="icon-themify-favicon-alt"></i> icon-themify-favicon-alt</div>
                                </section>
                        `;

            modal.open({
              title: "Icon Palette",
              content: `${iconForm.outerHTML}`,
            });
          } else if (blockId.startsWith("simple-line-icon-palette")) {
            console.log("inside simple-line-icon-palette");

            // GRAPESJS MODAL LOGIC
            const iconForm = document.createElement("div");
            iconForm.setAttribute("class", "icon-form");
            iconForm.innerHTML = `
                                <link rel="stylesheet" type="text/css" href="/assets/css/simple-line-icon.css">

                                <section>
                                    <div class="col-lg-4 col-sm-6"><i class="icon-user"></i>icon-user</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-user-female"></i>icon-user-female</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-people"></i>icon-people</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-user-follow"></i>icon-user-follow</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-user-following"></i>icon-user-following</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-user-unfollow"></i>icon-user-unfollow</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-trophy"></i>icon-trophy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-speedometer"></i>icon-speedometer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-social-youtube"></i>icon-social-youtube</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-social-twitter"></i>icon-social-twitter</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-social-tumblr"></i>icon-social-tumblr</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-social-facebook"></i>icon-social-facebook</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-social-dropbox"></i>icon-social-dropbox</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-social-dribbble"></i>icon-social-dribbble</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-shield"></i>icon-shield</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-screen-tablet"></i>icon-screen-tablet</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-screen-smartphone"></i>icon-screen-smartphone</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-screen-desktop"></i>icon-screen-desktop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-plane"></i>icon-plane</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-notebook"></i>icon-notebook</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-mustache"></i>icon-mustache</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-mouse"></i>icon-mouse</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-magnet"></i>icon-magnet</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-magic-wand"></i>icon-magic-wand</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-hourglass"></i>icon-hourglass</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-graduation"></i>icon-graduation</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-ghost"></i>icon-ghost</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-game-controller"></i>icon-game-controller</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-fire"></i>icon-fire</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-eyeglass"></i>icon-eyeglass</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-envelope-open"></i>icon-envelope-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-envelope-letter"></i>icon-envelope-letter</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-energy"></i>icon-energy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-disc"></i>icon-disc</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-cursor-move"></i>icon-cursor-move</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-crop"></i>icon-crop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-credit-card"></i>icon-credit-card</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-chemistry"></i>icon-chemistry</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-bell"></i>icon-bell</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-badge"></i>icon-badge</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-anchor"></i>icon-anchor</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-action-redo"></i>icon-action-redo</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-action-undo"></i>icon-action-undo</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-bag"></i>icon-bag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-basket"></i>icon-basket</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-basket-loaded"></i>icon-basket-loaded</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-book-open"></i>icon-book-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-briefcase"></i>icon-briefcase</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-bubbles"></i>icon-bubbles</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-calculator"></i>icon-calculator</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-call-end"></i>icon-call-end</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-call-in"></i>icon-call-in</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-call-out"></i>icon-call-out</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-compass"></i>icon-compass</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-cup"></i>icon-cup</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-diamond"></i>icon-diamond</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-direction"></i>icon-direction</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-directions"></i>icon-directions</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-docs"></i>icon-docs</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-drawer"></i>icon-drawer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-drop"></i>icon-drop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-earphones"></i>icon-earphones</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-earphones-alt"></i>icon-earphones-alt</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-feed"></i>icon-feed</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-film"></i>icon-film</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-folder-alt"></i>icon-folder-alt</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-frame"></i>icon-frame</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-globe"></i>icon-globe</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-globe-alt"></i>icon-globe-alt</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-handbag"></i>icon-handbag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-layers"></i>icon-layers</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-map"></i>icon-map</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-picture"></i>icon-picture</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-pin"></i>icon-pin</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-playlist"></i>icon-playlist</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-present"></i>icon-present</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-printer"></i>icon-printer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-puzzle"></i>icon-puzzle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-speech"></i>icon-speech</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-vector"></i>icon-vector</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-wallet"></i>icon-wallet</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-arrow-down"></i>icon-arrow-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-arrow-left"></i>icon-arrow-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-arrow-right"></i>icon-arrow-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-arrow-up"></i>icon-arrow-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-bar-chart"></i>icon-bar-chart</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-bulb"></i>icon-bulb</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-calendar"></i>icon-calendar</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-control-end"></i>icon-control-end</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-control-forward"></i>icon-control-forward</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-control-pause"></i>icon-control-pause</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-control-play"></i>icon-control-play</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-control-rewind"></i>icon-control-rewind</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-control-start"></i>icon-control-start</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-cursor"></i>icon-cursor</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-dislike"></i>icon-dislike</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-equalizer"></i>icon-equalizer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-graph"></i>icon-graph</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-grid"></i>icon-grid</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-home"></i>icon-home</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-like"></i>icon-like</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-list"></i>icon-list</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-login"></i>icon-login</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-logout"></i>icon-logout</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-loop"></i>icon-loop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-microphone"></i>icon-microphone</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-music-tone"></i>icon-music-tone</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-music-tone-alt"></i>icon-music-tone-alt</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-note"></i>icon-note</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-pencil"></i>icon-pencil</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-pie-chart"></i>icon-pie-chart</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-question"></i>icon-question</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-rocket"></i>icon-rocket</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-share"></i>icon-share</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-share-alt"></i>icon-share-alt</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-shuffle"></i>icon-shuffle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-size-actual"></i>icon-size-actual</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-size-fullscreen"></i>icon-size-fullscreen</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-support"></i>icon-support</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-tag"></i>icon-tag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-trash"></i>icon-trash</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-umbrella"></i>icon-umbrella</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-wrench"></i>icon-wrench</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-ban"></i>icon-ban</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-bubble"></i>icon-bubble</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-camcorder"></i>icon-camcorder</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-camera"></i>icon-camera</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-check"></i>icon-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-clock"></i>icon-clock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-close"></i>icon-close</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-cloud-download"></i>icon-cloud-download</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-cloud-upload"></i>icon-cloud-upload</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-doc"></i>icon-doc</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-envelope"></i>icon-envelope</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-eye"></i>icon-eye</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-flag"></i>icon-flag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-folder"></i>icon-folder</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-heart"></i>icon-heart</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-info"></i>icon-info</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-key"></i>icon-key</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-link"></i>icon-link</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-lock"></i>icon-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-lock-open"></i>icon-lock-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-magnifier"></i>icon-magnifier</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-magnifier-add"></i>icon-magnifier-add</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-magnifier-remove"></i>icon-magnifier-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-paper-clip"></i>icon-paper-clip</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-paper-plane"></i>icon-paper-plane</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-plus"></i>icon-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-minus"></i>icon-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-power"></i>icon-power</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-refresh"></i>icon-refresh</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-reload"></i>icon-reload</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-settings"></i>icon-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-star"></i>icon-star</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-symbol-female"></i>icon-symbol-female</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-symbol-male"></i>icon-symbol-male</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-target"></i>icon-target</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-volume-1"></i>icon-volume-1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-volume-2"></i>icon-volume-2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="icon-volume-off"></i>icon-volume-off</div>
                                </section>
                        `;

            modal.open({
              title: "Icon Palette",
              content: `${iconForm.outerHTML}`,
            });
          } else if (blockId.startsWith("material-design-icon-palette")) {
            console.log("inside material-design-icon-palette");

            // GRAPESJS MODAL LOGIC
            const iconForm = document.createElement("div");
            iconForm.setAttribute("class", "icon-form");
            iconForm.innerHTML = `
                                <link rel="stylesheet" type="text/css" href="/assets/css/material-design-icon.css">

                                <section>
                                    <div class="col-lg-4 col-sm-6"><i class="mdi mdi-access-point"></i>    access-point</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-access-point-network"></i>    access-point-network</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-access-point-network-off"></i>    access-point-network-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-alert"></i>    account-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-alert-outline"></i>    account-alert-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-arrow-left"></i>    account-arrow-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-arrow-left-outline"></i>    account-arrow-left-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-arrow-right"></i>    account-arrow-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-arrow-right-outline"></i>    account-arrow-right-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-badge"></i>    account-badge</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-badge-alert"></i>    account-badge-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-badge-alert-outline"></i>    account-badge-alert-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-badge-horizontal"></i>    account-badge-horizontal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-badge-horizontal-outline"></i>    account-badge-horizontal-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-badge-outline"></i>    account-badge-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-box"></i>    account-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-box-multiple"></i>    account-box-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-box-outline"></i>    account-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-card-details"></i>    account-card-details</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-card-details-outline"></i>    account-card-details-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-check"></i>    account-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-check-outline"></i>    account-check-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-child"></i>    account-child</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-child-circle"></i>    account-child-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-circle"></i>    account-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-circle-outline"></i>    account-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-clock"></i>    account-clock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-clock-outline"></i>    account-clock-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-convert"></i>    account-convert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-details"></i>    account-details</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-edit"></i>    account-edit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-group"></i>    account-group</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-group-outline"></i>    account-group-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-heart"></i>    account-heart</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-heart-outline"></i>    account-heart-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-key"></i>    account-key</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-key-outline"></i>    account-key-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-minus"></i>    account-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-minus-outline"></i>    account-minus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-multiple"></i>    account-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-multiple-check"></i>    account-multiple-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-account-multiple-minus"></i>    account-multiple-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-baseball-bat"></i>    baseball-bat</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-basket-fill"></i>    basket-fill</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-basket-unfill"></i>    basket-unfill</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-basketball-hoop"></i>    basketball-hoop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-basketball-hoop-outline"></i>    basketball-hoop-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-10"></i>    battery-10</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-10-bluetooth"></i>    battery-10-bluetooth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-20"></i>    battery-20</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-20-bluetooth"></i>    battery-20-bluetooth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-30"></i>    battery-30</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-30-bluetooth"></i>    battery-30-bluetooth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-40"></i>    battery-40</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-40-bluetooth"></i>    battery-40-bluetooth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-50"></i>    battery-50</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-50-bluetooth"></i>    battery-50-bluetooth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-60"></i>    battery-60</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-60-bluetooth"></i>    battery-60-bluetooth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-70"></i>    battery-70</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-70-bluetooth"></i>    battery-70-bluetooth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-80"></i>    battery-80</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-80-bluetooth"></i>    battery-80-bluetooth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-90"></i>    battery-90</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-90-bluetooth"></i>    battery-90-bluetooth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-alert"></i>    battery-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-alert-bluetooth"></i>    battery-alert-bluetooth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-bluetooth"></i>    battery-bluetooth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-bluetooth-variant"></i>    battery-bluetooth-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging"></i>    battery-charging</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-10"></i>    battery-charging-10</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-100"></i>    battery-charging-100</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-20"></i>    battery-charging-20</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-30"></i>    battery-charging-30</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-40"></i>    battery-charging-40</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-50"></i>    battery-charging-50</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-60"></i>    battery-charging-60</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-70"></i>    battery-charging-70</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-80"></i>    battery-charging-80</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-90"></i>    battery-charging-90</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-outline"></i>    battery-charging-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-wireless"></i>    battery-charging-wireless</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-wireless-10"></i>    battery-charging-wireless-10</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-wireless-20"></i>    battery-charging-wireless-20</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-wireless-30"></i>    battery-charging-wireless-30</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-wireless-40"></i>    battery-charging-wireless-40</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-wireless-50"></i>    battery-charging-wireless-50</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-wireless-60"></i>    battery-charging-wireless-60</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-wireless-70"></i>    battery-charging-wireless-70</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-wireless-80"></i>    battery-charging-wireless-80</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-wireless-90"></i>    battery-charging-wireless-90</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-wireless-alert"></i>    battery-charging-wireless-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-charging-wireless-outline"></i>    battery-charging-wireless-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-minus"></i>    battery-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-negative"></i>    battery-negative</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-outline"></i>    battery-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-plus"></i>    battery-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-positive"></i>    battery-positive</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-unknown"></i>    battery-unknown</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-battery-unknown-bluetooth"></i>    battery-unknown-bluetooth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-beaker-outline"></i>    beaker-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bed-empty"></i>    bed-empty</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bell-alert"></i>    bell-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bell-circle"></i>    bell-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bell-circle-outline"></i>    bell-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bell-off"></i>    bell-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bell-off-outline"></i>    bell-off-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bell-outline"></i>    bell-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bell-plus"></i>    bell-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bell-plus-outline"></i>    bell-plus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bell-ring"></i>    bell-ring</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bell-ring-outline"></i>    bell-ring-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bell-sleep"></i>    bell-sleep</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bell-sleep-outline"></i>    bell-sleep-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-billiards-rack"></i>    billiards-rack</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-black-mesa"></i>    black-mesa</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-blender-software"></i>    blender-software</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-block-helper"></i>    block-helper</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-blood-bag"></i>    blood-bag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bluetooth-audio"></i>    bluetooth-audio</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bluetooth-connect"></i>    bluetooth-connect</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bluetooth-off"></i>    bluetooth-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bluetooth-settings"></i>    bluetooth-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bluetooth-transfer"></i>    bluetooth-transfer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-blur-linear"></i>    blur-linear</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-blur-off"></i>    blur-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-blur-radial"></i>    blur-radial</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bolnisi-cross"></i>    bolnisi-cross</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bomb-off"></i>    bomb-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-book-lock"></i>    book-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-book-lock-open"></i>    book-lock-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-book-minus"></i>    book-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-book-multiple"></i>    book-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-book-multiple-minus"></i>    book-multiple-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-book-multiple-plus"></i>    book-multiple-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-book-multiple-remove"></i>    book-multiple-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-book-multiple-variant"></i>    book-multiple-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-book-open"></i>    book-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-book-open-outline"></i>    book-open-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-book-open-page-variant"></i>    book-open-page-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-book-open-variant"></i>    book-open-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-book-outline"></i>    book-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-book-plus"></i>    book-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-book-remove"></i>    book-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-book-variant"></i>    book-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bookmark-check"></i>    bookmark-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bookmark-minus"></i>    bookmark-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bookmark-minus-outline"></i>    bookmark-minus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bookmark-multiple"></i>    bookmark-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bookmark-multiple-outline"></i>    bookmark-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bookmark-music"></i>    bookmark-music</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bookmark-off"></i>    bookmark-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bookmark-off-outline"></i>    bookmark-off-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bookmark-outline"></i>    bookmark-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-bookmark-plus"></i>    bookmark-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-card-bulleted"></i>    card-bulleted</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-card-bulleted-off"></i>    card-bulleted-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-card-bulleted-off-outline"></i>    card-bulleted-off-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-card-bulleted-outline"></i>    card-bulleted-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-card-bulleted-settings"></i>    card-bulleted-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-card-bulleted-settings-outline"></i>    card-bulleted-settings-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-card-outline"></i>    card-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-card-text"></i>    card-text</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-card-text-outline"></i>    card-text-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cards-club"></i>    cards-club</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cards-diamond"></i>    cards-diamond</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cards-heart"></i>    cards-heart</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cards-outline"></i>    cards-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cards-playing-outline"></i>    cards-playing-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cards-spade"></i>    cards-spade</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cards-variant"></i>    cards-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-carry-on-bag-check"></i>    carry-on-bag-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cart-arrow-down"></i>    cart-arrow-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cart-arrow-right"></i>    cart-arrow-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cart-arrow-up"></i>    cart-arrow-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cart-minus"></i>    cart-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cart-off"></i>    cart-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cart-outline"></i>    cart-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cart-plus"></i>    cart-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cart-remove"></i>    cart-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-case-sensitive-alt"></i>    case-sensitive-alt</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cash-100"></i>    cash-100</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cash-marker"></i>    cash-marker</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cash-multiple"></i>    cash-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cash-refund"></i>    cash-refund</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cash-register"></i>    cash-register</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cash-usd"></i>    cash-usd</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cast-connected"></i>    cast-connected</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cast-education"></i>    cast-education</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cast-off"></i>    cast-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ceiling-light"></i>    ceiling-light</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cellphone-android"></i>    cellphone-android</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cellphone-arrow-down"></i>    cellphone-arrow-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cellphone-basic"></i>    cellphone-basic</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cellphone-dock"></i>    cellphone-dock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cellphone-erase"></i>    cellphone-erase</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cellphone-iphone"></i>    cellphone-iphone</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cellphone-key"></i>    cellphone-key</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cellphone-link"></i>    cellphone-link</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cellphone-link-off"></i>    cellphone-link-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cellphone-lock"></i>    cellphone-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cellphone-message"></i>    cellphone-message</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cellphone-off"></i>    cellphone-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cellphone-screenshot"></i>    cellphone-screenshot</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cellphone-settings"></i>    cellphone-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cellphone-settings-variant"></i>    cellphone-settings-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cellphone-sound"></i>    cellphone-sound</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cellphone-text"></i>    cellphone-text</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cellphone-wireless"></i>    cellphone-wireless</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-celtic-cross"></i>    celtic-cross</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chair-school"></i>    chair-school</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chart-arc"></i>    chart-arc</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chart-areaspline"></i>    chart-areaspline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chart-bar"></i>    chart-bar</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chart-bar-stacked"></i>    chart-bar-stacked</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chart-bell-curve"></i>    chart-bell-curve</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chart-bubble"></i>    chart-bubble</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chart-donut"></i>    chart-donut</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chart-donut-variant"></i>    chart-donut-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chart-gantt"></i>    chart-gantt</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chart-histogram"></i>    chart-histogram</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chart-line"></i>    chart-line</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chart-line-stacked"></i>    chart-line-stacked</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chart-line-variant"></i>    chart-line-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chart-multiline"></i>    chart-multiline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chart-pie"></i>    chart-pie</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chart-scatterplot-hexbin"></i>    chart-scatterplot-hexbin</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chart-timeline"></i>    chart-timeline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chat-alert"></i>    chat-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chat-processing"></i>    chat-processing</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-check-all"></i>    check-all</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-check-bold"></i>    check-bold</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-check-box-multiple-outline"></i>    check-box-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-check-box-outline"></i>    check-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-check-circle"></i>    check-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-check-circle-outline"></i>    check-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-check-decagram"></i>    check-decagram</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-check-network"></i>    check-network</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-check-network-outline"></i>    check-network-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-check-outline"></i>    check-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-check-underline"></i>    check-underline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-check-underline-circle"></i>    check-underline-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-check-underline-circle-outline"></i>    check-underline-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-checkbox-blank"></i>    checkbox-blank</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-checkbox-blank-circle"></i>    checkbox-blank-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-checkbox-blank-circle-outline"></i>    checkbox-blank-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-checkbox-blank-outline"></i>    checkbox-blank-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-checkbox-intermediate"></i>    checkbox-intermediate</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-checkbox-marked"></i>    checkbox-marked</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-checkbox-marked-circle"></i>    checkbox-marked-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-checkbox-marked-circle-outline"></i>    checkbox-marked-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-checkbox-marked-outline"></i>    checkbox-marked-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-checkbox-multiple-blank"></i>    checkbox-multiple-blank</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-checkbox-multiple-blank-circle"></i>    checkbox-multiple-blank-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-checkbox-multiple-blank-circle-outline"></i>    checkbox-multiple-blank-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-checkbox-multiple-blank-outline"></i>    checkbox-multiple-blank-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-checkbox-multiple-marked"></i>    checkbox-multiple-marked</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-checkbox-multiple-marked-circle"></i>    checkbox-multiple-marked-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-checkbox-multiple-marked-circle-outline"></i>    checkbox-multiple-marked-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-checkbox-multiple-marked-outline"></i>    checkbox-multiple-marked-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chef-hat"></i>    chef-hat</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chemical-weapon"></i>    chemical-weapon</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chess-bishop"></i>    chess-bishop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chess-king"></i>    chess-king</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chess-knight"></i>    chess-knight</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chess-pawn"></i>    chess-pawn</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chess-queen"></i>    chess-queen</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chess-rook"></i>    chess-rook</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-double-down"></i>    chevron-double-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-double-left"></i>    chevron-double-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-double-right"></i>    chevron-double-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-double-up"></i>    chevron-double-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-down"></i>    chevron-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-down-box"></i>    chevron-down-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-down-box-outline"></i>    chevron-down-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-down-circle"></i>    chevron-down-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-down-circle-outline"></i>    chevron-down-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-left"></i>    chevron-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-left-box"></i>    chevron-left-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-left-box-outline"></i>    chevron-left-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-left-circle"></i>    chevron-left-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-left-circle-outline"></i>    chevron-left-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-right"></i>    chevron-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-right-box"></i>    chevron-right-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-right-box-outline"></i>    chevron-right-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-right-circle"></i>    chevron-right-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-right-circle-outline"></i>    chevron-right-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-triple-down"></i>    chevron-triple-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-triple-left"></i>    chevron-triple-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-triple-right"></i>    chevron-triple-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-triple-up"></i>    chevron-triple-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-up"></i>    chevron-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-up-box"></i>    chevron-up-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-up-box-outline"></i>    chevron-up-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-up-circle"></i>    chevron-up-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chevron-up-circle-outline"></i>    chevron-up-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chili-hot"></i>    chili-hot</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chili-medium"></i>    chili-medium</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-chili-mild"></i>    chili-mild</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-christianity-outline"></i>    christianity-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-circle-edit-outline"></i>    circle-edit-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-circle-medium"></i>    circle-medium</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-circle-outline"></i>    circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-circle-slice-1"></i>    circle-slice-1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-circle-slice-2"></i>    circle-slice-2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-circle-slice-3"></i>    circle-slice-3</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-circle-slice-4"></i>    circle-slice-4</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-circle-slice-5"></i>    circle-slice-5</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-circle-slice-6"></i>    circle-slice-6</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-circle-slice-7"></i>    circle-slice-7</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-circle-slice-8"></i>    circle-slice-8</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-circle-small"></i>    circle-small</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-circular-saw"></i>    circular-saw</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cisco-webex"></i>    cisco-webex</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-city-variant"></i>    city-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-city-variant-outline"></i>    city-variant-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-account"></i>    clipboard-account</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-account-outline"></i>    clipboard-account-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-alert"></i>    clipboard-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-alert-outline"></i>    clipboard-alert-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-arrow-down"></i>    clipboard-arrow-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-arrow-down-outline"></i>    clipboard-arrow-down-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-arrow-left"></i>    clipboard-arrow-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-arrow-left-outline"></i>    clipboard-arrow-left-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-arrow-right"></i>    clipboard-arrow-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-arrow-right-outline"></i>    clipboard-arrow-right-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-arrow-up"></i>    clipboard-arrow-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-arrow-up-outline"></i>    clipboard-arrow-up-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-check"></i>    clipboard-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-check-outline"></i>    clipboard-check-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-flow"></i>    clipboard-flow</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-outline"></i>    clipboard-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-play"></i>    clipboard-play</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-play-outline"></i>    clipboard-play-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-plus"></i>    clipboard-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-pulse"></i>    clipboard-pulse</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-pulse-outline"></i>    clipboard-pulse-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-text"></i>    clipboard-text</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-text-outline"></i>    clipboard-text-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-text-play"></i>    clipboard-text-play</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clipboard-text-play-outline"></i>    clipboard-text-play-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clock-alert"></i>    clock-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clock-alert-outline"></i>    clock-alert-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clock-end"></i>    clock-end</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clock-fast"></i>    clock-fast</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clock-in"></i>    clock-in</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clock-out"></i>    clock-out</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clock-outline"></i>    clock-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-clock-start"></i>    clock-start</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-close-box"></i>    close-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-close-box-multiple"></i>    close-box-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-close-box-multiple-outline"></i>    close-box-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-close-box-outline"></i>    close-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-close-circle"></i>    close-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-close-circle-outline"></i>    close-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-close-network"></i>    close-network</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-close-network-outline"></i>    close-network-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-close-octagon"></i>    close-octagon</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-close-octagon-outline"></i>    close-octagon-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-close-outline"></i>    close-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-closed-caption"></i>    closed-caption</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-closed-caption-outline"></i>    closed-caption-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cloud-alert"></i>    cloud-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cloud-braces"></i>    cloud-braces</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cloud-check"></i>    cloud-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cloud-circle"></i>    cloud-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cloud-download"></i>    cloud-download</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cloud-download-outline"></i>    cloud-download-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cloud-off-outline"></i>    cloud-off-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cloud-outline"></i>    cloud-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cloud-print"></i>    cloud-print</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cloud-print-outline"></i>    cloud-print-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cloud-question"></i>    cloud-question</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cloud-search"></i>    cloud-search</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cloud-search-outline"></i>    cloud-search-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cloud-sync"></i>    cloud-sync</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cloud-tags"></i>    cloud-tags</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cloud-upload"></i>    cloud-upload</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cloud-upload-outline"></i>    cloud-upload-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-code-array"></i>    code-array</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-code-braces"></i>    code-braces</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-code-brackets"></i>    code-brackets</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-code-equal"></i>    code-equal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-code-greater-than"></i>    code-greater-than</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-code-greater-than-or-equal"></i>    code-greater-than-or-equal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-code-less-than"></i>    code-less-than</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-code-less-than-or-equal"></i>    code-less-than-or-equal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-code-not-equal"></i>    code-not-equal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-code-not-equal-variant"></i>    code-not-equal-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-code-parentheses"></i>    code-parentheses</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-code-string"></i>    code-string</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-code-tags"></i>    code-tags</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-code-tags-check"></i>    code-tags-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-coffee-outline"></i>    coffee-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-coffee-to-go"></i>    coffee-to-go</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-collapse-all"></i>    collapse-all</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-collapse-all-outline"></i>    collapse-all-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-color-helper"></i>    color-helper</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comma-box"></i>    comma-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comma-box-outline"></i>    comma-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comma-circle"></i>    comma-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comma-circle-outline"></i>    comma-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-account"></i>    comment-account</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-account-outline"></i>    comment-account-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-alert"></i>    comment-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-alert-outline"></i>    comment-alert-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-arrow-left"></i>    comment-arrow-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-arrow-left-outline"></i>    comment-arrow-left-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-arrow-right"></i>    comment-arrow-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-arrow-right-outline"></i>    comment-arrow-right-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-check"></i>    comment-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-check-outline"></i>    comment-check-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-eye"></i>    comment-eye</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-eye-outline"></i>    comment-eye-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-multiple"></i>    comment-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-multiple-outline"></i>    comment-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-outline"></i>    comment-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-plus"></i>    comment-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-plus-outline"></i>    comment-plus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-processing"></i>    comment-processing</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-processing-outline"></i>    comment-processing-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-question"></i>    comment-question</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-question-outline"></i>    comment-question-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-remove"></i>    comment-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-remove-outline"></i>    comment-remove-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-search"></i>    comment-search</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-search-outline"></i>    comment-search-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-text"></i>    comment-text</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-text-multiple"></i>    comment-text-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-text-multiple-outline"></i>    comment-text-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-comment-text-outline"></i>    comment-text-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-compass-off"></i>    compass-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-compass-off-outline"></i>    compass-off-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-compass-outline"></i>    compass-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-console-line"></i>    console-line</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-console-network"></i>    console-network</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-console-network-outline"></i>    console-network-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-contact-mail"></i>    contact-mail</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-contactless-payment"></i>    contactless-payment</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-contain-end"></i>    contain-end</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-contain-start"></i>    contain-start</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-content-copy"></i>    content-copy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-content-cut"></i>    content-cut</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-content-duplicate"></i>    content-duplicate</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-content-paste"></i>    content-paste</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-content-save"></i>    content-save</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-content-save-all"></i>    content-save-all</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-content-save-edit"></i>    content-save-edit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-content-save-edit-outline"></i>    content-save-edit-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-content-save-move"></i>    content-save-move</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-content-save-move-outline"></i>    content-save-move-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-content-save-outline"></i>    content-save-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-content-save-settings"></i>    content-save-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-content-save-settings-outline"></i>    content-save-settings-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-contrast-box"></i>    contrast-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-contrast-circle"></i>    contrast-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-controller-classic"></i>    controller-classic</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-controller-classic-outline"></i>    controller-classic-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-Xolo-commons"></i>    Xolo-commons</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-credit-card"></i>    credit-card</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-credit-card-marker"></i>    credit-card-marker</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-credit-card-multiple"></i>    credit-card-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-credit-card-off"></i>    credit-card-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-credit-card-plus"></i>    credit-card-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-credit-card-refund"></i>    credit-card-refund</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-credit-card-scan"></i>    credit-card-scan</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-credit-card-settings"></i>    credit-card-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-credit-card-wireless"></i>    credit-card-wireless</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-crop-free"></i>    crop-free</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-crop-landscape"></i>    crop-landscape</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-crop-portrait"></i>    crop-portrait</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-crop-rotate"></i>    crop-rotate</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-crop-square"></i>    crop-square</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-crosshairs-gps"></i>    crosshairs-gps</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-crystal-ball"></i>    crystal-ball</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cube-outline"></i>    cube-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cube-scan"></i>    cube-scan</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cube-send"></i>    cube-send</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cube-unfolded"></i>    cube-unfolded</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cup-off"></i>    cup-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cup-water"></i>    cup-water</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-bdt"></i>    currency-bdt</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-brl"></i>    currency-brl</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-btc"></i>    currency-btc</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-chf"></i>    currency-chf</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-cny"></i>    currency-cny</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-eth"></i>    currency-eth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-eur"></i>    currency-eur</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-gbp"></i>    currency-gbp</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-ils"></i>    currency-ils</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-inr"></i>    currency-inr</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-jpy"></i>    currency-jpy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-krw"></i>    currency-krw</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-kzt"></i>    currency-kzt</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-ngn"></i>    currency-ngn</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-php"></i>    currency-php</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-rub"></i>    currency-rub</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-sign"></i>    currency-sign</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-try"></i>    currency-try</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-twd"></i>    currency-twd</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-usd"></i>    currency-usd</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-currency-usd-off"></i>    currency-usd-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-current-ac"></i>    current-ac</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-current-dc"></i>    current-dc</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cursor-default"></i>    cursor-default</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cursor-default-click"></i>    cursor-default-click</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cursor-default-click-outline"></i>    cursor-default-click-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cursor-default-outline"></i>    cursor-default-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cursor-move"></i>    cursor-move</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cursor-pointer"></i>    cursor-pointer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-cursor-text"></i>    cursor-text</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-database-check"></i>    database-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-database-edit"></i>    database-edit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-database-export"></i>    database-export</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-database-import"></i>    database-import</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-database-lock"></i>    database-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-database-minus"></i>    database-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-database-plus"></i>    database-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-database-refresh"></i>    database-refresh</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-database-remove"></i>    database-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-database-search"></i>    database-search</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-database-settings"></i>    database-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-death-star"></i>    death-star</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-death-star-variant"></i>    death-star-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-deathly-hallows"></i>    deathly-hallows</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-debug-step-into"></i>    debug-step-into</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-debug-step-out"></i>    debug-step-out</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-debug-step-over"></i>    debug-step-over</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-decagram-outline"></i>    decagram-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-decimal-decrease"></i>    decimal-decrease</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-decimal-increase"></i>    decimal-increase</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-delete-circle"></i>    delete-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-delete-circle-outline"></i>    delete-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-delete-empty"></i>    delete-empty</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-delete-forever"></i>    delete-forever</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-delete-forever-outline"></i>    delete-forever-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-delete-outline"></i>    delete-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-delete-restore"></i>    delete-restore</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-delete-sweep"></i>    delete-sweep</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-delete-sweep-outline"></i>    delete-sweep-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-delete-variant"></i>    delete-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-desk-lamp"></i>    desk-lamp</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-desktop-classic"></i>    desktop-classic</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-desktop-mac"></i>    desktop-mac</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-desktop-mac-dashboard"></i>    desktop-mac-dashboard</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-desktop-tower"></i>    desktop-tower</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-desktop-tower-monitor"></i>    desktop-tower-monitor</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dev-to"></i>    dev-to</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-developer-board"></i>    developer-board</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-diameter-outline"></i>    diameter-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-diameter-variant"></i>    diameter-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-diamond-outline"></i>    diamond-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-diamond-stone"></i>    diamond-stone</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dice-1"></i>    dice-1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dice-2"></i>    dice-2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dice-3"></i>    dice-3</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dice-4"></i>    dice-4</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dice-5"></i>    dice-5</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dice-6"></i>    dice-6</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dice-d10"></i>    dice-d10</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dice-d12"></i>    dice-d12</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dice-d20"></i>    dice-d20</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dice-d4"></i>    dice-d4</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dice-d6"></i>    dice-d6</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dice-d8"></i>    dice-d8</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dice-multiple"></i>    dice-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dip-switch"></i>    dip-switch</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-directions-fork"></i>    directions-fork</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-disc-alert"></i>    disc-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-disc-player"></i>    disc-player</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-disqus-outline"></i>    disqus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-diving-flippers"></i>    diving-flippers</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-diving-helmet"></i>    diving-helmet</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-diving-scuba"></i>    diving-scuba</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-diving-scuba-flag"></i>    diving-scuba-flag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-diving-scuba-tank"></i>    diving-scuba-tank</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-diving-scuba-tank-multiple"></i>    diving-scuba-tank-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-diving-snorkel"></i>    diving-snorkel</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-division-box"></i>    division-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dns-outline"></i>    dns-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-do-not-disturb"></i>    do-not-disturb</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-do-not-disturb-off"></i>    do-not-disturb-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dog-service"></i>    dog-service</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dog-side"></i>    dog-side</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-domain-off"></i>    domain-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-door-closed"></i>    door-closed</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-door-open"></i>    door-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-doorbell-video"></i>    doorbell-video</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dot-net"></i>    dot-net</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dots-horizontal"></i>    dots-horizontal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dots-horizontal-circle"></i>    dots-horizontal-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dots-horizontal-circle-outline"></i>    dots-horizontal-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dots-vertical"></i>    dots-vertical</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dots-vertical-circle"></i>    dots-vertical-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dots-vertical-circle-outline"></i>    dots-vertical-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-download-multiple"></i>    download-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-download-network"></i>    download-network</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-download-network-outline"></i>    download-network-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-download-outline"></i>    download-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-drag-horizontal"></i>    drag-horizontal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-drag-variant"></i>    drag-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-drag-vertical"></i>    drag-vertical</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-drama-masks"></i>    drama-masks</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-drawing-box"></i>    drawing-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dribbble-box"></i>    dribbble-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-dump-truck"></i>    dump-truck</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ear-hearing"></i>    ear-hearing</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ear-hearing-off"></i>    ear-hearing-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-earth-box"></i>    earth-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-earth-box-off"></i>    earth-box-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-earth-off"></i>    earth-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-egg-easter"></i>    egg-easter</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-eight-track"></i>    eight-track</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-eject-outline"></i>    eject-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-elevation-decline"></i>    elevation-decline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-elevation-rise"></i>    elevation-rise</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-email-alert"></i>    email-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-email-box"></i>    email-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-email-check"></i>    email-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-email-check-outline"></i>    email-check-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-email-lock"></i>    email-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-email-mark-as-unread"></i>    email-mark-as-unread</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-email-open"></i>    email-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-email-open-outline"></i>    email-open-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-email-outline"></i>    email-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-email-plus"></i>    email-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-email-plus-outline"></i>    email-plus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-email-search"></i>    email-search</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-email-search-outline"></i>    email-search-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-email-variant"></i>    email-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-angry"></i>    emoticon-angry</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-angry-outline"></i>    emoticon-angry-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-cool"></i>    emoticon-cool</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-cool-outline"></i>    emoticon-cool-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-cry"></i>    emoticon-cry</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-cry-outline"></i>    emoticon-cry-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-dead"></i>    emoticon-dead</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-dead-outline"></i>    emoticon-dead-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-devil"></i>    emoticon-devil</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-devil-outline"></i>    emoticon-devil-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-excited"></i>    emoticon-excited</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-excited-outline"></i>    emoticon-excited-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-happy"></i>    emoticon-happy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-happy-outline"></i>    emoticon-happy-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-kiss"></i>    emoticon-kiss</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-kiss-outline"></i>    emoticon-kiss-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-neutral"></i>    emoticon-neutral</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-neutral-outline"></i>    emoticon-neutral-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-outline"></i>    emoticon-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-poop"></i>    emoticon-poop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-poop-outline"></i>    emoticon-poop-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-sad"></i>    emoticon-sad</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-sad-outline"></i>    emoticon-sad-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-tongue"></i>    emoticon-tongue</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-tongue-outline"></i>    emoticon-tongue-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-wink"></i>    emoticon-wink</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-emoticon-wink-outline"></i>    emoticon-wink-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-engine-off"></i>    engine-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-engine-off-outline"></i>    engine-off-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-engine-outline"></i>    engine-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-equal-box"></i>    equal-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-eraser-variant"></i>    eraser-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ethernet-cable"></i>    ethernet-cable</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ethernet-cable-off"></i>    ethernet-cable-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ev-station"></i>    ev-station</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-exit-run"></i>    exit-run</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-exit-to-app"></i>    exit-to-app</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-expand-all"></i>    expand-all</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-expand-all-outline"></i>    expand-all-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-exponent-box"></i>    exponent-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-export-variant"></i>    export-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-eye-check"></i>    eye-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-eye-check-outline"></i>    eye-check-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-eye-circle"></i>    eye-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-eye-circle-outline"></i>    eye-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-eye-off"></i>    eye-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-eye-off-outline"></i>    eye-off-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-eye-outline"></i>    eye-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-eye-plus"></i>    eye-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-eye-plus-outline"></i>    eye-plus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-eye-settings"></i>    eye-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-eye-settings-outline"></i>    eye-settings-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-eyedropper-variant"></i>    eyedropper-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-face-agent"></i>    face-agent</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-face-outline"></i>    face-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-face-profile"></i>    face-profile</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-face-recognition"></i>    face-recognition</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-facebook-box"></i>    facebook-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-facebook-messenger"></i>    facebook-messenger</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-facebook-workplace"></i>    facebook-workplace</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-fan-off"></i>    fan-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-fast-forward"></i>    fast-forward</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-fast-forward-10"></i>    fast-forward-10</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-fast-forward-30"></i>    fast-forward-30</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-fast-forward-outline"></i>    fast-forward-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-feature-search"></i>    feature-search</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-feature-search-outline"></i>    feature-search-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-account"></i>    file-account</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-alert"></i>    file-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-alert-outline"></i>    file-alert-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-cabinet"></i>    file-cabinet</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-cancel"></i>    file-cancel</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-cancel-outline"></i>    file-cancel-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-chart"></i>    file-chart</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-check"></i>    file-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-check-outline"></i>    file-check-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-cloud"></i>    file-cloud</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-compare"></i>    file-compare</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-delimited"></i>    file-delimited</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-document"></i>    file-document</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-document-box"></i>    file-document-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-document-box-multiple"></i>    file-document-box-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-document-box-multiple-outline"></i>    file-document-box-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-document-box-outline"></i>    file-document-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-document-edit"></i>    file-document-edit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-document-edit-outline"></i>    file-document-edit-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-document-outline"></i>    file-document-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-download"></i>    file-download</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-download-outline"></i>    file-download-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-excel"></i>    file-excel</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-excel-box"></i>    file-excel-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-export"></i>    file-export</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-eye"></i>    file-eye</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-eye-outline"></i>    file-eye-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-find"></i>    file-find</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-find-outline"></i>    file-find-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-hidden"></i>    file-hidden</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-image"></i>    file-image</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-import"></i>    file-import</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-lock"></i>    file-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-move"></i>    file-move</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-multiple"></i>    file-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-music"></i>    file-music</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-music-outline"></i>    file-music-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-outline"></i>    file-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-pdf"></i>    file-pdf</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-pdf-box"></i>    file-pdf-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-pdf-outline"></i>    file-pdf-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-percent"></i>    file-percent</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-plus"></i>    file-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-powerpoint"></i>    file-powerpoint</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-powerpoint-box"></i>    file-powerpoint-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-presentation-box"></i>    file-presentation-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-question"></i>    file-question</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-remove"></i>    file-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-replace"></i>    file-replace</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-replace-outline"></i>    file-replace-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-restore"></i>    file-restore</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-search"></i>    file-search</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-search-outline"></i>    file-search-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-send"></i>    file-send</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-table"></i>    file-table</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-table-outline"></i>    file-table-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-tree"></i>    file-tree</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-undo"></i>    file-undo</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-upload"></i>    file-upload</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-upload-outline"></i>    file-upload-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-video"></i>    file-video</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-video-outline"></i>    file-video-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-word"></i>    file-word</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-word-box"></i>    file-word-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-file-xml"></i>    file-xml</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-filmstrip-off"></i>    filmstrip-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-filter-outline"></i>    filter-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-filter-remove"></i>    filter-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-filter-remove-outline"></i>    filter-remove-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-filter-variant"></i>    filter-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-find-replace"></i>    find-replace</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-fire-truck"></i>    fire-truck</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-fireplace-off"></i>    fireplace-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flag-checkered"></i>    flag-checkered</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flag-minus"></i>    flag-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flag-outline"></i>    flag-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flag-plus"></i>    flag-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flag-remove"></i>    flag-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flag-triangle"></i>    flag-triangle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flag-variant"></i>    flag-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flag-variant-outline"></i>    flag-variant-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flash-auto"></i>    flash-auto</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flash-circle"></i>    flash-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flash-off"></i>    flash-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flash-outline"></i>    flash-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flash-red-eye"></i>    flash-red-eye</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flashlight-off"></i>    flashlight-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flask-empty"></i>    flask-empty</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flask-empty-outline"></i>    flask-empty-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flask-outline"></i>    flask-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flip-to-back"></i>    flip-to-back</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flip-to-front"></i>    flip-to-front</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-floor-lamp"></i>    floor-lamp</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-floor-plan"></i>    floor-plan</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-floppy-variant"></i>    floppy-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flower-outline"></i>    flower-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flower-poppy"></i>    flower-poppy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flower-tulip"></i>    flower-tulip</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-flower-tulip-outline"></i>    flower-tulip-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-account"></i>    folder-account</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-account-outline"></i>    folder-account-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-alert"></i>    folder-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-alert-outline"></i>    folder-alert-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-clock"></i>    folder-clock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-clock-outline"></i>    folder-clock-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-download"></i>    folder-download</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-edit"></i>    folder-edit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-edit-outline"></i>    folder-edit-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-google-drive"></i>    folder-google-drive</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-image"></i>    folder-image</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-key"></i>    folder-key</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-key-network"></i>    folder-key-network</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-key-network-outline"></i>    folder-key-network-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-lock"></i>    folder-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-lock-open"></i>    folder-lock-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-move"></i>    folder-move</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-multiple"></i>    folder-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-multiple-image"></i>    folder-multiple-image</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-multiple-outline"></i>    folder-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-network"></i>    folder-network</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-network-outline"></i>    folder-network-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-open"></i>    folder-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-open-outline"></i>    folder-open-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-outline"></i>    folder-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-plus"></i>    folder-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-plus-outline"></i>    folder-plus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-pound"></i>    folder-pound</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-pound-outline"></i>    folder-pound-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-remove"></i>    folder-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-remove-outline"></i>    folder-remove-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-search"></i>    folder-search</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-search-outline"></i>    folder-search-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-star"></i>    folder-star</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-star-outline"></i>    folder-star-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-sync"></i>    folder-sync</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-sync-outline"></i>    folder-sync-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-text"></i>    folder-text</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-text-outline"></i>    folder-text-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-folder-upload"></i>    folder-upload</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-font-awesome"></i>    font-awesome</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-food-apple"></i>    food-apple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-food-apple-outline"></i>    food-apple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-food-croissant"></i>    food-croissant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-food-fork-drink"></i>    food-fork-drink</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-food-off"></i>    food-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-food-variant"></i>    food-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-football-australian"></i>    football-australian</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-football-helmet"></i>    football-helmet</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-align-bottom"></i>    format-align-bottom</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-align-center"></i>    format-align-center</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-align-justify"></i>    format-align-justify</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-align-left"></i>    format-align-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-align-middle"></i>    format-align-middle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-align-right"></i>    format-align-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-align-top"></i>    format-align-top</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-annotation-minus"></i>    format-annotation-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-annotation-plus"></i>    format-annotation-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-bold"></i>    format-bold</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-clear"></i>    format-clear</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-color-fill"></i>    format-color-fill</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-color-highlight"></i>    format-color-highlight</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-color-text"></i>    format-color-text</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-columns"></i>    format-columns</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-float-center"></i>    format-float-center</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-float-left"></i>    format-float-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-float-none"></i>    format-float-none</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-float-right"></i>    format-float-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-font"></i>    format-font</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-font-size-decrease"></i>    format-font-size-decrease</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-font-size-increase"></i>    format-font-size-increase</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-header-1"></i>    format-header-1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-header-2"></i>    format-header-2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-header-3"></i>    format-header-3</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-header-4"></i>    format-header-4</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-header-5"></i>    format-header-5</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-header-6"></i>    format-header-6</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-header-decrease"></i>    format-header-decrease</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-header-equal"></i>    format-header-equal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-header-increase"></i>    format-header-increase</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-header-pound"></i>    format-header-pound</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-horizontal-align-center"></i>    format-horizontal-align-center</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-horizontal-align-left"></i>    format-horizontal-align-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-horizontal-align-right"></i>    format-horizontal-align-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-indent-decrease"></i>    format-indent-decrease</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-indent-increase"></i>    format-indent-increase</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-italic"></i>    format-italic</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-letter-case"></i>    format-letter-case</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-letter-case-lower"></i>    format-letter-case-lower</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-letter-case-upper"></i>    format-letter-case-upper</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-line-spacing"></i>    format-line-spacing</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-line-style"></i>    format-line-style</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-line-weight"></i>    format-line-weight</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-list-bulleted"></i>    format-list-bulleted</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-list-bulleted-square"></i>    format-list-bulleted-square</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-list-bulleted-type"></i>    format-list-bulleted-type</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-list-checkbox"></i>    format-list-checkbox</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-list-checks"></i>    format-list-checks</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-list-numbered"></i>    format-list-numbered</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-list-numbered-rtl"></i>    format-list-numbered-rtl</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-page-break"></i>    format-page-break</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-paint"></i>    format-paint</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-paragraph"></i>    format-paragraph</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-pilcrow"></i>    format-pilcrow</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-quote-close"></i>    format-quote-close</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-quote-open"></i>    format-quote-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-rotate-90"></i>    format-rotate-90</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-section"></i>    format-section</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-size"></i>    format-size</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-strikethrough"></i>    format-strikethrough</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-strikethrough-variant"></i>    format-strikethrough-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-subscript"></i>    format-subscript</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-superscript"></i>    format-superscript</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-text"></i>    format-text</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-text-rotation-down"></i>    format-text-rotation-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-text-rotation-none"></i>    format-text-rotation-none</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-text-variant"></i>    format-text-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-text-wrapping-clip"></i>    format-text-wrapping-clip</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-text-wrapping-overflow"></i>    format-text-wrapping-overflow</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-text-wrapping-wrap"></i>    format-text-wrapping-wrap</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-textbox"></i>    format-textbox</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-textdirection-l-to-r"></i>    format-textdirection-l-to-r</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-textdirection-r-to-l"></i>    format-textdirection-r-to-l</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-title"></i>    format-title</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-underline"></i>    format-underline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-vertical-align-bottom"></i>    format-vertical-align-bottom</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-vertical-align-center"></i>    format-vertical-align-center</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-vertical-align-top"></i>    format-vertical-align-top</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-wrap-inline"></i>    format-wrap-inline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-wrap-square"></i>    format-wrap-square</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-wrap-tight"></i>    format-wrap-tight</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-format-wrap-top-bottom"></i>    format-wrap-top-bottom</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-forum-outline"></i>    forum-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-fountain-pen"></i>    fountain-pen</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-fountain-pen-tip"></i>    fountain-pen-tip</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-fridge-bottom"></i>    fridge-bottom</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-fridge-outline"></i>    fridge-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-fridge-top"></i>    fridge-top</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-fullscreen-exit"></i>    fullscreen-exit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-function-variant"></i>    function-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-fuse-blade"></i>    fuse-blade</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gamepad-circle"></i>    gamepad-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gamepad-circle-down"></i>    gamepad-circle-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gamepad-circle-left"></i>    gamepad-circle-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gamepad-circle-outline"></i>    gamepad-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gamepad-circle-right"></i>    gamepad-circle-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gamepad-circle-up"></i>    gamepad-circle-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gamepad-down"></i>    gamepad-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gamepad-left"></i>    gamepad-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gamepad-right"></i>    gamepad-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gamepad-round"></i>    gamepad-round</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gamepad-round-down"></i>    gamepad-round-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gamepad-round-left"></i>    gamepad-round-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gamepad-round-outline"></i>    gamepad-round-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gamepad-round-right"></i>    gamepad-round-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gamepad-round-up"></i>    gamepad-round-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gamepad-up"></i>    gamepad-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gamepad-variant"></i>    gamepad-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gantry-crane"></i>    gantry-crane</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-garage-alert"></i>    garage-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-garage-open"></i>    garage-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gas-cylinder"></i>    gas-cylinder</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gas-station"></i>    gas-station</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gate-and"></i>    gate-and</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gate-nand"></i>    gate-nand</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gate-nor"></i>    gate-nor</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gate-not"></i>    gate-not</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gate-or"></i>    gate-or</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gate-xnor"></i>    gate-xnor</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gate-xor"></i>    gate-xor</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gauge-empty"></i>    gauge-empty</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gauge-full"></i>    gauge-full</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gauge-low"></i>    gauge-low</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gender-female"></i>    gender-female</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gender-male"></i>    gender-male</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gender-male-female"></i>    gender-male-female</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gender-transgender"></i>    gender-transgender</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gesture-double-tap"></i>    gesture-double-tap</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gesture-pinch"></i>    gesture-pinch</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gesture-spread"></i>    gesture-spread</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gesture-swipe"></i>    gesture-swipe</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gesture-swipe-down"></i>    gesture-swipe-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gesture-swipe-horizontal"></i>    gesture-swipe-horizontal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gesture-swipe-left"></i>    gesture-swipe-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gesture-swipe-right"></i>    gesture-swipe-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gesture-swipe-up"></i>    gesture-swipe-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gesture-swipe-vertical"></i>    gesture-swipe-vertical</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gesture-tap"></i>    gesture-tap</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gesture-tap-hold"></i>    gesture-tap-hold</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gesture-two-double-tap"></i>    gesture-two-double-tap</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gesture-two-tap"></i>    gesture-two-tap</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ghost-off"></i>    ghost-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-gift-outline"></i>    gift-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-github-box"></i>    github-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-github-circle"></i>    github-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-github-face"></i>    github-face</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-glass-cocktail"></i>    glass-cocktail</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-glass-flute"></i>    glass-flute</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-glass-mug"></i>    glass-mug</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-glass-stange"></i>    glass-stange</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-glass-tulip"></i>    glass-tulip</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-glass-wine"></i>    glass-wine</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-globe-model"></i>    globe-model</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-go-kart"></i>    go-kart</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-go-kart-track"></i>    go-kart-track</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-adwords"></i>    google-adwords</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-allo"></i>    google-allo</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-analytics"></i>    google-analytics</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-assistant"></i>    google-assistant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-cardboard"></i>    google-cardboard</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-chrome"></i>    google-chrome</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-circles"></i>    google-circles</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-circles-communities"></i>    google-circles-communities</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-circles-extended"></i>    google-circles-extended</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-circles-group"></i>    google-circles-group</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-classroom"></i>    google-classroom</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-controller"></i>    google-controller</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-controller-off"></i>    google-controller-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-drive"></i>    google-drive</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-earth"></i>    google-earth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-fit"></i>    google-fit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-glass"></i>    google-glass</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-hangouts"></i>    google-hangouts</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-home"></i>    google-home</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-keep"></i>    google-keep</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-lens"></i>    google-lens</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-maps"></i>    google-maps</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-nearby"></i>    google-nearby</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-pages"></i>    google-pages</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-photos"></i>    google-photos</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-physical-web"></i>    google-physical-web</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-play"></i>    google-play</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-plus"></i>    google-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-plus-box"></i>    google-plus-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-spreadsheet"></i>    google-spreadsheet</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-street-view"></i>    google-street-view</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-google-translate"></i>    google-translate</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hand-okay"></i>    hand-okay</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hand-peace"></i>    hand-peace</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hand-peace-variant"></i>    hand-peace-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hand-pointing-down"></i>    hand-pointing-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hand-pointing-left"></i>    hand-pointing-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hand-pointing-right"></i>    hand-pointing-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hand-pointing-up"></i>    hand-pointing-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hand-right"></i>    hand-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hand-saw"></i>    hand-saw</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hard-hat"></i>    hard-hat</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hat-fedora"></i>    hat-fedora</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hazard-lights"></i>    hazard-lights</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hdr-off"></i>    hdr-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-headphones-bluetooth"></i>    headphones-bluetooth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-headphones-box"></i>    headphones-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-headphones-off"></i>    headphones-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-headphones-settings"></i>    headphones-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-headset-dock"></i>    headset-dock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-headset-off"></i>    headset-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-heart-box"></i>    heart-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-heart-box-outline"></i>    heart-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-heart-broken"></i>    heart-broken</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-heart-broken-outline"></i>    heart-broken-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-heart-circle"></i>    heart-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-heart-circle-outline"></i>    heart-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-heart-half"></i>    heart-half</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-heart-half-full"></i>    heart-half-full</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-heart-half-outline"></i>    heart-half-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-heart-multiple"></i>    heart-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-heart-multiple-outline"></i>    heart-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-heart-off"></i>    heart-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-heart-outline"></i>    heart-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-heart-pulse"></i>    heart-pulse</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-help-box"></i>    help-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-help-circle"></i>    help-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-help-circle-outline"></i>    help-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-help-network"></i>    help-network</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-help-network-outline"></i>    help-network-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-help-rhombus"></i>    help-rhombus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-help-rhombus-outline"></i>    help-rhombus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hexagon-multiple"></i>    hexagon-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hexagon-outline"></i>    hexagon-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hexagon-slice-1"></i>    hexagon-slice-1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hexagon-slice-2"></i>    hexagon-slice-2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hexagon-slice-3"></i>    hexagon-slice-3</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-alert"></i>    home-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-assistant"></i>    home-assistant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-automation"></i>    home-automation</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-circle"></i>    home-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-city"></i>    home-city</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-city-outline"></i>    home-city-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-currency-usd"></i>    home-currency-usd</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-floor-0"></i>    home-floor-0</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-floor-1"></i>    home-floor-1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-floor-2"></i>    home-floor-2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-floor-3"></i>    home-floor-3</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-floor-a"></i>    home-floor-a</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-floor-b"></i>    home-floor-b</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-floor-g"></i>    home-floor-g</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-floor-l"></i>    home-floor-l</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-floor-negative-1"></i>    home-floor-negative-1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-group"></i>    home-group</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-heart"></i>    home-heart</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-lock"></i>    home-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-lock-open"></i>    home-lock-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-map-marker"></i>    home-map-marker</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-minus"></i>    home-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-modern"></i>    home-modern</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-outline"></i>    home-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-plus"></i>    home-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-variant"></i>    home-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-home-variant-outline"></i>    home-variant-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hook-off"></i>    hook-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hospital-building"></i>    hospital-building</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hospital-marker"></i>    hospital-marker</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-hot-tub"></i>    hot-tub</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-houzz-box"></i>    houzz-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-human-child"></i>    human-child</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-human-female"></i>    human-female</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-human-female-boy"></i>    human-female-boy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-human-female-female"></i>    human-female-female</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-human-female-girl"></i>    human-female-girl</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-human-greeting"></i>    human-greeting</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-human-handsdown"></i>    human-handsdown</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-human-handsup"></i>    human-handsup</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-human-male"></i>    human-male</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-human-male-boy"></i>    human-male-boy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-human-male-female"></i>    human-male-female</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-human-male-girl"></i>    human-male-girl</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-human-male-male"></i>    human-male-male</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-human-pregnant"></i>    human-pregnant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-humble-bundle"></i>    humble-bundle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ice-cream"></i>    ice-cream</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-iframe-outline"></i>    iframe-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-album"></i>    image-album</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-area"></i>    image-area</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-area-close"></i>    image-area-close</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-broken"></i>    image-broken</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-broken-variant"></i>    image-broken-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-filter"></i>    image-filter</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-filter-black-white"></i>    image-filter-black-white</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-filter-center-focus"></i>    image-filter-center-focus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-filter-center-focus-weak"></i>    image-filter-center-focus-weak</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-filter-drama"></i>    image-filter-drama</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-filter-frames"></i>    image-filter-frames</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-filter-hdr"></i>    image-filter-hdr</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-filter-none"></i>    image-filter-none</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-filter-tilt-shift"></i>    image-filter-tilt-shift</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-filter-vintage"></i>    image-filter-vintage</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-frame"></i>    image-frame</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-move"></i>    image-move</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-multiple"></i>    image-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-off"></i>    image-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-outline"></i>    image-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-plus"></i>    image-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-search"></i>    image-search</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-search-outline"></i>    image-search-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-size-select-actual"></i>    image-size-select-actual</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-size-select-large"></i>    image-size-select-large</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-image-size-select-small"></i>    image-size-select-small</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-inbox-arrow-down"></i>    inbox-arrow-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-inbox-arrow-up"></i>    inbox-arrow-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-inbox-multiple"></i>    inbox-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-inbox-multiple-outline"></i>    inbox-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-information-outline"></i>    information-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-information-variant"></i>    information-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-internet-explorer"></i>    internet-explorer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-invert-colors"></i>    invert-colors</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-invert-colors-off"></i>    invert-colors-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ip-network"></i>    ip-network</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ip-network-outline"></i>    ip-network-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-key-change"></i>    key-change</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-key-minus"></i>    key-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-key-outline"></i>    key-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-key-plus"></i>    key-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-key-remove"></i>    key-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-key-variant"></i>    key-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-keyboard-backspace"></i>    keyboard-backspace</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-keyboard-caps"></i>    keyboard-caps</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-keyboard-close"></i>    keyboard-close</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-keyboard-off"></i>    keyboard-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-keyboard-off-outline"></i>    keyboard-off-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-keyboard-outline"></i>    keyboard-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-keyboard-return"></i>    keyboard-return</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-keyboard-settings"></i>    keyboard-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-keyboard-settings-outline"></i>    keyboard-settings-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-keyboard-tab"></i>    keyboard-tab</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-keyboard-variant"></i>    keyboard-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-knife-military"></i>    knife-military</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-label-off"></i>    label-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-label-off-outline"></i>    label-off-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-label-outline"></i>    label-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-label-variant"></i>    label-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-label-variant-outline"></i>    label-variant-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lan-connect"></i>    lan-connect</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lan-disconnect"></i>    lan-disconnect</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lan-pending"></i>    lan-pending</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-language-c"></i>    language-c</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-language-cpp"></i>    language-cpp</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-language-csharp"></i>    language-csharp</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-language-css3"></i>    language-css3</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-language-go"></i>    language-go</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-language-haskell"></i>    language-haskell</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-language-html5"></i>    language-html5</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-language-java"></i>    language-java</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-language-javascript"></i>    language-javascript</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-language-lua"></i>    language-lua</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lava-lamp"></i>    lava-lamp</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-layers-minus"></i>    layers-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-layers-off"></i>    layers-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-layers-off-outline"></i>    layers-off-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-layers-outline"></i>    layers-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-layers-plus"></i>    layers-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-layers-remove"></i>    layers-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lead-pencil"></i>    lead-pencil</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-leaf-maple"></i>    leaf-maple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-leak-off"></i>    leak-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-led-off"></i>    led-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-led-on"></i>    led-on</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-led-outline"></i>    led-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-led-strip"></i>    led-strip</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-led-variant-off"></i>    led-variant-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-led-variant-on"></i>    led-variant-on</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-led-variant-outline"></i>    led-variant-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-less-than"></i>    less-than</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-less-than-or-equal"></i>    less-than-or-equal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-library-books"></i>    library-books</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-library-movie"></i>    library-movie</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-library-music"></i>    library-music</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-library-plus"></i>    library-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-library-shelves"></i>    library-shelves</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-library-video"></i>    library-video</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-light-switch"></i>    light-switch</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lightbulb-off"></i>    lightbulb-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lightbulb-off-outline"></i>    lightbulb-off-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lightbulb-on"></i>    lightbulb-on</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lightbulb-on-outline"></i>    lightbulb-on-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lightbulb-outline"></i>    lightbulb-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lighthouse-on"></i>    lighthouse-on</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-link-box"></i>    link-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-link-box-outline"></i>    link-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-link-box-variant"></i>    link-box-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-link-box-variant-outline"></i>    link-box-variant-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-link-off"></i>    link-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-link-plus"></i>    link-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-link-variant"></i>    link-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-link-variant-off"></i>    link-variant-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-linkedin-box"></i>    linkedin-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-linux-mint"></i>    linux-mint</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lock-alert"></i>    lock-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lock-clock"></i>    lock-clock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lock-open"></i>    lock-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lock-open-outline"></i>    lock-open-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lock-outline"></i>    lock-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lock-pattern"></i>    lock-pattern</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lock-plus"></i>    lock-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lock-question"></i>    lock-question</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lock-reset"></i>    lock-reset</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-lock-smart"></i>    lock-smart</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-locker-multiple"></i>    locker-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-login-variant"></i>    login-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-logout-variant"></i>    logout-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-magnet-on"></i>    magnet-on</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-magnify-close"></i>    magnify-close</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-magnify-minus"></i>    magnify-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-magnify-minus-cursor"></i>    magnify-minus-cursor</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-magnify-minus-outline"></i>    magnify-minus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-magnify-plus"></i>    magnify-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-magnify-plus-cursor"></i>    magnify-plus-cursor</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-magnify-plus-outline"></i>    magnify-plus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-mail-ru"></i>    mail-ru</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-mailbox-open"></i>    mailbox-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-mailbox-open-outline"></i>    mailbox-open-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-mailbox-open-up"></i>    mailbox-open-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-mailbox-open-up-outline"></i>    mailbox-open-up-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-mailbox-outline"></i>    mailbox-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-mailbox-up"></i>    mailbox-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-mailbox-up-outline"></i>    mailbox-up-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-map-clock"></i>    map-clock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-map-clock-outline"></i>    map-clock-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-map-legend"></i>    map-legend</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-map-marker"></i>    map-marker</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-map-marker-check"></i>    map-marker-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-map-marker-circle"></i>    map-marker-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-map-marker-distance"></i>    map-marker-distance</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-map-marker-minus"></i>    map-marker-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-map-marker-multiple"></i>    map-marker-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-map-marker-off"></i>    map-marker-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-map-marker-outline"></i>    map-marker-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-map-marker-path"></i>    map-marker-path</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-map-marker-plus"></i>    map-marker-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-map-marker-radius"></i>    map-marker-radius</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-map-minus"></i>    map-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-map-outline"></i>    map-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-map-plus"></i>    map-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-map-search"></i>    map-search</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-map-search-outline"></i>    map-search-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-marker-cancel"></i>    marker-cancel</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-marker-check"></i>    marker-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-mastodon-variant"></i>    mastodon-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-material-design"></i>    material-design</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-material-ui"></i>    material-ui</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-math-compass"></i>    math-compass</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-math-cos"></i>    math-cos</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-math-sin"></i>    math-sin</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-math-tan"></i>    math-tan</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-medical-bag"></i>    medical-bag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-menu-down"></i>    menu-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-menu-down-outline"></i>    menu-down-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-menu-left"></i>    menu-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-menu-left-outline"></i>    menu-left-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-menu-open"></i>    menu-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-menu-right"></i>    menu-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-menu-right-outline"></i>    menu-right-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-menu-swap"></i>    menu-swap</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-menu-swap-outline"></i>    menu-swap-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-menu-up"></i>    menu-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-menu-up-outline"></i>    menu-up-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-message-alert"></i>    message-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-message-alert-outline"></i>    message-alert-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-message-bulleted"></i>    message-bulleted</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-message-bulleted-off"></i>    message-bulleted-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-message-draw"></i>    message-draw</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-message-image"></i>    message-image</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-message-outline"></i>    message-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-message-plus"></i>    message-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-message-processing"></i>    message-processing</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-message-reply"></i>    message-reply</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-message-reply-text"></i>    message-reply-text</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-message-settings"></i>    message-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-message-settings-variant"></i>    message-settings-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-message-text"></i>    message-text</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-message-text-outline"></i>    message-text-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-message-video"></i>    message-video</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-metronome-tick"></i>    metronome-tick</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-micro-sd"></i>    micro-sd</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-microphone-minus"></i>    microphone-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-microphone-off"></i>    microphone-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-microphone-outline"></i>    microphone-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-microphone-plus"></i>    microphone-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-microphone-settings"></i>    microphone-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-microphone-variant"></i>    microphone-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-microphone-variant-off"></i>    microphone-variant-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-microsoft-dynamics"></i>    microsoft-dynamics</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-midi-port"></i>    midi-port</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-mini-sd"></i>    mini-sd</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-minus-box"></i>    minus-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-minus-box-outline"></i>    minus-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-minus-circle"></i>    minus-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-minus-circle-outline"></i>    minus-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-minus-network"></i>    minus-network</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-minus-network-outline"></i>    minus-network-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-mixed-martial-arts"></i>    mixed-martial-arts</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-mixed-reality"></i>    mixed-reality</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-monitor-cellphone"></i>    monitor-cellphone</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-monitor-cellphone-star"></i>    monitor-cellphone-star</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-monitor-dashboard"></i>    monitor-dashboard</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-monitor-lock"></i>    monitor-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-monitor-multiple"></i>    monitor-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-monitor-off"></i>    monitor-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-monitor-screenshot"></i>    monitor-screenshot</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-monitor-star"></i>    monitor-star</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-mother-nurse"></i>    mother-nurse</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-motion-sensor"></i>    motion-sensor</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-mouse-bluetooth"></i>    mouse-bluetooth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-mouse-off"></i>    mouse-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-mouse-variant"></i>    mouse-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-mouse-variant-off"></i>    mouse-variant-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-move-resize"></i>    move-resize</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-move-resize-variant"></i>    move-resize-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-movie-outline"></i>    movie-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-movie-roll"></i>    movie-roll</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-multiplication-box"></i>    multiplication-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-mushroom-outline"></i>    mushroom-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-music-box"></i>    music-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-music-box-outline"></i>    music-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-music-circle"></i>    music-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-music-circle-outline"></i>    music-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-music-note"></i>    music-note</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-music-note-bluetooth"></i>    music-note-bluetooth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-music-note-bluetooth-off"></i>    music-note-bluetooth-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-music-note-eighth"></i>    music-note-eighth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-music-note-half"></i>    music-note-half</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-music-note-off"></i>    music-note-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-music-note-plus"></i>    music-note-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-music-note-quarter"></i>    music-note-quarter</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-music-note-sixteenth"></i>    music-note-sixteenth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-music-note-whole"></i>    music-note-whole</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-music-off"></i>    music-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-nature-people"></i>    nature-people</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-near-me"></i>    near-me</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-network-off"></i>    network-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-network-off-outline"></i>    network-off-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-network-outline"></i>    network-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-network-strength-1"></i>    network-strength-1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-network-strength-1-alert"></i>    network-strength-1-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-network-strength-2"></i>    network-strength-2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-network-strength-2-alert"></i>    network-strength-2-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-network-strength-3"></i>    network-strength-3</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-network-strength-3-alert"></i>    network-strength-3-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-network-strength-4"></i>    network-strength-4</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-network-strength-4-alert"></i>    network-strength-4-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-network-strength-off"></i>    network-strength-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-network-strength-off-outline"></i>    network-strength-off-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-network-strength-outline"></i>    network-strength-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-new-box"></i>    new-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-nfc-off"></i>    nfc-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-nfc-search-variant"></i>    nfc-search-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-nfc-tap"></i>    nfc-tap</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-nfc-variant"></i>    nfc-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-nfc-variant-off"></i>    nfc-variant-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-nintendo-switch"></i>    nintendo-switch</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-not-equal"></i>    not-equal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-not-equal-variant"></i>    not-equal-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-note-multiple"></i>    note-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-note-multiple-outline"></i>    note-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-note-outline"></i>    note-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-note-plus"></i>    note-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-note-plus-outline"></i>    note-plus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-note-text"></i>    note-text</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-notebook-multiple"></i>    notebook-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-notification-clear-all"></i>    notification-clear-all</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-npm-variant"></i>    npm-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-npm-variant-outline"></i>    npm-variant-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-0"></i>    numeric-0</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-0-box"></i>    numeric-0-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-0-box-multiple-outline"></i>    numeric-0-box-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-0-box-outline"></i>    numeric-0-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-0-circle"></i>    numeric-0-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-0-circle-outline"></i>    numeric-0-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-1"></i>    numeric-1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-1-box"></i>    numeric-1-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-1-box-multiple-outline"></i>    numeric-1-box-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-1-box-outline"></i>    numeric-1-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-1-circle"></i>    numeric-1-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-1-circle-outline"></i>    numeric-1-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-2"></i>    numeric-2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-2-box"></i>    numeric-2-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-2-box-multiple-outline"></i>    numeric-2-box-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-2-box-outline"></i>    numeric-2-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-2-circle"></i>    numeric-2-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-2-circle-outline"></i>    numeric-2-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-3"></i>    numeric-3</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-3-box"></i>    numeric-3-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-3-box-multiple-outline"></i>    numeric-3-box-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-3-box-outline"></i>    numeric-3-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-3-circle"></i>    numeric-3-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-3-circle-outline"></i>    numeric-3-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-4"></i>    numeric-4</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-4-box"></i>    numeric-4-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-4-box-multiple-outline"></i>    numeric-4-box-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-4-box-outline"></i>    numeric-4-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-4-circle"></i>    numeric-4-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-4-circle-outline"></i>    numeric-4-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-5"></i>    numeric-5</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-5-box"></i>    numeric-5-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-5-box-multiple-outline"></i>    numeric-5-box-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-5-box-outline"></i>    numeric-5-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-5-circle"></i>    numeric-5-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-5-circle-outline"></i>    numeric-5-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-6"></i>    numeric-6</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-6-box"></i>    numeric-6-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-6-box-multiple-outline"></i>    numeric-6-box-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-6-box-outline"></i>    numeric-6-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-6-circle"></i>    numeric-6-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-6-circle-outline"></i>    numeric-6-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-7"></i>    numeric-7</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-7-box"></i>    numeric-7-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-7-box-multiple-outline"></i>    numeric-7-box-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-7-box-outline"></i>    numeric-7-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-7-circle"></i>    numeric-7-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-7-circle-outline"></i>    numeric-7-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-8"></i>    numeric-8</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-8-box"></i>    numeric-8-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-8-box-multiple-outline"></i>    numeric-8-box-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-8-box-outline"></i>    numeric-8-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-8-circle"></i>    numeric-8-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-8-circle-outline"></i>    numeric-8-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-9"></i>    numeric-9</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-9-box"></i>    numeric-9-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-9-box-multiple-outline"></i>    numeric-9-box-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-9-box-outline"></i>    numeric-9-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-9-circle"></i>    numeric-9-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-9-circle-outline"></i>    numeric-9-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-9-plus-box"></i>    numeric-9-plus-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-9-plus-box-multiple-outline"></i>    numeric-9-plus-box-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-9-plus-box-outline"></i>    numeric-9-plus-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-9-plus-circle"></i>    numeric-9-plus-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-numeric-9-plus-circle-outline"></i>    numeric-9-plus-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-octagon-outline"></i>    octagon-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-octagram-outline"></i>    octagram-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-office-building"></i>    office-building</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-oil-temperature"></i>    oil-temperature</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-one-up"></i>    one-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-open-in-app"></i>    open-in-app</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-open-in-new"></i>    open-in-new</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-open-source-initiative"></i>    open-source-initiative</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ornament-variant"></i>    ornament-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pac-man"></i>    pac-man</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-package-down"></i>    package-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-package-up"></i>    package-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-package-variant"></i>    package-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-package-variant-closed"></i>    package-variant-closed</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-page-first"></i>    page-first</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-page-last"></i>    page-last</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-page-layout-body"></i>    page-layout-body</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-page-layout-footer"></i>    page-layout-footer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-page-layout-header"></i>    page-layout-header</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-page-layout-sidebar-left"></i>    page-layout-sidebar-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-page-layout-sidebar-right"></i>    page-layout-sidebar-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-page-next"></i>    page-next</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-page-next-outline"></i>    page-next-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-page-previous"></i>    page-previous</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-page-previous-outline"></i>    page-previous-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-palette-advanced"></i>    palette-advanced</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-palette-outline"></i>    palette-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-palette-swatch"></i>    palette-swatch</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pan-bottom-left"></i>    pan-bottom-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pan-bottom-right"></i>    pan-bottom-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pan-down"></i>    pan-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pan-horizontal"></i>    pan-horizontal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pan-left"></i>    pan-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pan-right"></i>    pan-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pan-top-left"></i>    pan-top-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pan-top-right"></i>    pan-top-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pan-up"></i>    pan-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pan-vertical"></i>    pan-vertical</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-panorama-fisheye"></i>    panorama-fisheye</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-panorama-horizontal"></i>    panorama-horizontal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-panorama-vertical"></i>    panorama-vertical</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-panorama-wide-angle"></i>    panorama-wide-angle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-paper-cut-vertical"></i>    paper-cut-vertical</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-parachute-outline"></i>    parachute-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-passport-biometric"></i>    passport-biometric</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pause-circle"></i>    pause-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pause-circle-outline"></i>    pause-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pause-octagon"></i>    pause-octagon</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pause-octagon-outline"></i>    pause-octagon-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-paw-off"></i>    paw-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pdf-box"></i>    pdf-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pen-lock"></i>    pen-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pen-minus"></i>    pen-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pen-off"></i>    pen-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pen-plus"></i>    pen-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pen-remove"></i>    pen-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pencil-box"></i>    pencil-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pencil-box-outline"></i>    pencil-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pencil-circle"></i>    pencil-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pencil-circle-outline"></i>    pencil-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pencil-lock"></i>    pencil-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pencil-lock-outline"></i>    pencil-lock-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pencil-minus"></i>    pencil-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pencil-minus-outline"></i>    pencil-minus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pencil-off"></i>    pencil-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pencil-off-outline"></i>    pencil-off-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pencil-outline"></i>    pencil-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pencil-plus"></i>    pencil-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pencil-plus-outline"></i>    pencil-plus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pencil-remove"></i>    pencil-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pencil-remove-outline"></i>    pencil-remove-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pentagon-outline"></i>    pentagon-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-periodic-table"></i>    periodic-table</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-periodic-table-co2"></i>    periodic-table-co2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-perspective-less"></i>    perspective-less</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-perspective-more"></i>    perspective-more</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-bluetooth"></i>    phone-bluetooth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-classic"></i>    phone-classic</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-forward"></i>    phone-forward</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-hangup"></i>    phone-hangup</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-in-talk"></i>    phone-in-talk</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-incoming"></i>    phone-incoming</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-lock"></i>    phone-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-log"></i>    phone-log</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-minus"></i>    phone-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-missed"></i>    phone-missed</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-off"></i>    phone-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-outgoing"></i>    phone-outgoing</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-outline"></i>    phone-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-paused"></i>    phone-paused</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-plus"></i>    phone-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-return"></i>    phone-return</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-rotate-landscape"></i>    phone-rotate-landscape</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-rotate-portrait"></i>    phone-rotate-portrait</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-settings"></i>    phone-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-phone-voip"></i>    phone-voip</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pi-box"></i>    pi-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pi-hole"></i>    pi-hole</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-picture-in-picture-bottom-right"></i>    picture-in-picture-bottom-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-picture-in-picture-bottom-right-outline"></i>    picture-in-picture-bottom-right-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-picture-in-picture-top-right"></i>    picture-in-picture-top-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-picture-in-picture-top-right-outline"></i>    picture-in-picture-top-right-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pier-crane"></i>    pier-crane</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pin-off"></i>    pin-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pin-off-outline"></i>    pin-off-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pin-outline"></i>    pin-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pine-tree"></i>    pine-tree</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pine-tree-box"></i>    pine-tree-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pinterest-box"></i>    pinterest-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pinwheel-outline"></i>    pinwheel-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pipe-disconnected"></i>    pipe-disconnected</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pipe-leak"></i>    pipe-leak</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-play-box-outline"></i>    play-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-play-circle"></i>    play-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-play-circle-outline"></i>    play-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-play-network"></i>    play-network</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-play-network-outline"></i>    play-network-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-play-pause"></i>    play-pause</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-play-protected-content"></i>    play-protected-content</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-play-speed"></i>    play-speed</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-playlist-check"></i>    playlist-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-playlist-edit"></i>    playlist-edit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-playlist-minus"></i>    playlist-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-playlist-music"></i>    playlist-music</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-playlist-music-outline"></i>    playlist-music-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-playlist-play"></i>    playlist-play</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-playlist-plus"></i>    playlist-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-playlist-remove"></i>    playlist-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-playlist-star"></i>    playlist-star</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-plus-box"></i>    plus-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-plus-box-outline"></i>    plus-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-plus-circle"></i>    plus-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-plus-circle-multiple-outline"></i>    plus-circle-multiple-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-plus-circle-outline"></i>    plus-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-plus-minus"></i>    plus-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-plus-minus-box"></i>    plus-minus-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-plus-network"></i>    plus-network</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-plus-network-outline"></i>    plus-network-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-plus-one"></i>    plus-one</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-plus-outline"></i>    plus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-podium-bronze"></i>    podium-bronze</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-podium-gold"></i>    podium-gold</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-podium-silver"></i>    podium-silver</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-point-of-sale"></i>    point-of-sale</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pokemon-go"></i>    pokemon-go</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-poker-chip"></i>    poker-chip</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-poll-box"></i>    poll-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-postage-stamp"></i>    postage-stamp</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pot-mix"></i>    pot-mix</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-pound-box"></i>    pound-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-power-cycle"></i>    power-cycle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-power-off"></i>    power-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-power-on"></i>    power-on</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-power-plug"></i>    power-plug</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-power-plug-off"></i>    power-plug-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-power-settings"></i>    power-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-power-sleep"></i>    power-sleep</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-power-socket"></i>    power-socket</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-power-socket-au"></i>    power-socket-au</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-power-socket-eu"></i>    power-socket-eu</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-power-socket-uk"></i>    power-socket-uk</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-power-socket-us"></i>    power-socket-us</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-power-standby"></i>    power-standby</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-presentation-play"></i>    presentation-play</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-printer-3d"></i>    printer-3d</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-printer-3d-nozzle"></i>    printer-3d-nozzle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-printer-3d-nozzle-outline"></i>    printer-3d-nozzle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-printer-alert"></i>    printer-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-printer-off"></i>    printer-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-printer-settings"></i>    printer-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-printer-wireless"></i>    printer-wireless</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-priority-high"></i>    priority-high</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-priority-low"></i>    priority-low</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-professional-hexagon"></i>    professional-hexagon</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-progress-alert"></i>    progress-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-progress-check"></i>    progress-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-progress-clock"></i>    progress-clock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-progress-download"></i>    progress-download</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-progress-upload"></i>    progress-upload</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-progress-wrench"></i>    progress-wrench</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-projector-screen"></i>    projector-screen</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-puzzle-outline"></i>    puzzle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-qrcode-edit"></i>    qrcode-edit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-qrcode-scan"></i>    qrcode-scan</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-quality-high"></i>    quality-high</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-quality-low"></i>    quality-low</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-quality-medium"></i>    quality-medium</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-racing-helmet"></i>    racing-helmet</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-radiator-disabled"></i>    radiator-disabled</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-radiator-off"></i>    radiator-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-radio-am"></i>    radio-am</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-radio-fm"></i>    radio-fm</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-radio-handheld"></i>    radio-handheld</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-radio-tower"></i>    radio-tower</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-radiobox-blank"></i>    radiobox-blank</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-radiobox-marked"></i>    radiobox-marked</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-radius-outline"></i>    radius-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-raspberry-pi"></i>    raspberry-pi</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ray-end"></i>    ray-end</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ray-end-arrow"></i>    ray-end-arrow</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ray-start"></i>    ray-start</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ray-start-arrow"></i>    ray-start-arrow</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ray-start-end"></i>    ray-start-end</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ray-vertex"></i>    ray-vertex</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-record-player"></i>    record-player</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-record-rec"></i>    record-rec</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-rectangle-outline"></i>    rectangle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-redo-variant"></i>    redo-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-reflect-horizontal"></i>    reflect-horizontal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-reflect-vertical"></i>    reflect-vertical</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-registered-trademark"></i>    registered-trademark</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-relative-scale"></i>    relative-scale</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-remote-desktop"></i>    remote-desktop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-rename-box"></i>    rename-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-reorder-horizontal"></i>    reorder-horizontal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-reorder-vertical"></i>    reorder-vertical</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-repeat-off"></i>    repeat-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-repeat-once"></i>    repeat-once</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-reply-all"></i>    reply-all</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-resistor-nodes"></i>    resistor-nodes</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-resize-bottom-right"></i>    resize-bottom-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-restart-off"></i>    restart-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-restore-clock"></i>    restore-clock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-rewind-10"></i>    rewind-10</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-rewind-30"></i>    rewind-30</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-rewind-outline"></i>    rewind-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-rhombus-medium"></i>    rhombus-medium</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-rhombus-outline"></i>    rhombus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-rhombus-split"></i>    rhombus-split</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-road-variant"></i>    road-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-robot-industrial"></i>    robot-industrial</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-robot-vacuum"></i>    robot-vacuum</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-robot-vacuum-variant"></i>    robot-vacuum-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-roller-skate"></i>    roller-skate</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-room-service"></i>    room-service</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-room-service-outline"></i>    room-service-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-rotate-3d"></i>    rotate-3d</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-rotate-left"></i>    rotate-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-rotate-left-variant"></i>    rotate-left-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-rotate-orbit"></i>    rotate-orbit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-rotate-right"></i>    rotate-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-rotate-right-variant"></i>    rotate-right-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-rounded-corner"></i>    rounded-corner</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-router-wireless"></i>    router-wireless</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-router-wireless-settings"></i>    router-wireless-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-rss-box"></i>    rss-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ruler-square"></i>    ruler-square</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-run-fast"></i>    run-fast</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sack-percent"></i>    sack-percent</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-safety-goggles"></i>    safety-goggles</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-satellite-uplink"></i>    satellite-uplink</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-satellite-variant"></i>    satellite-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-saw-blade"></i>    saw-blade</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-scale-balance"></i>    scale-balance</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-scale-bathroom"></i>    scale-bathroom</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-scanner-off"></i>    scanner-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-scissors-cutting"></i>    scissors-cutting</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-screen-rotation"></i>    screen-rotation</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-screen-rotation-lock"></i>    screen-rotation-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-screw-flat-top"></i>    screw-flat-top</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-screw-lag"></i>    screw-lag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-screw-machine-flat-top"></i>    screw-machine-flat-top</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-screw-machine-round-top"></i>    screw-machine-round-top</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-screw-round-top"></i>    screw-round-top</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-script-outline"></i>    script-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-script-text"></i>    script-text</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-script-text-outline"></i>    script-text-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-search-web"></i>    search-web</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-seat-flat"></i>    seat-flat</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-seat-flat-angled"></i>    seat-flat-angled</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-seat-individual-suite"></i>    seat-individual-suite</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-seat-legroom-extra"></i>    seat-legroom-extra</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-seat-legroom-normal"></i>    seat-legroom-normal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-seat-legroom-reduced"></i>    seat-legroom-reduced</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-seat-outline"></i>    seat-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-seat-recline-extra"></i>    seat-recline-extra</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-seat-recline-normal"></i>    seat-recline-normal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-security-network"></i>    security-network</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-seed-outline"></i>    seed-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-select-all"></i>    select-all</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-select-color"></i>    select-color</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-select-compare"></i>    select-compare</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-select-drag"></i>    select-drag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-select-inverse"></i>    select-inverse</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-select-off"></i>    select-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-selection-drag"></i>    selection-drag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-selection-ellipse"></i>    selection-ellipse</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-selection-off"></i>    selection-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-send-circle"></i>    send-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-send-circle-outline"></i>    send-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-send-lock"></i>    send-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-serial-port"></i>    serial-port</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-server-minus"></i>    server-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-server-network"></i>    server-network</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-server-network-off"></i>    server-network-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-server-off"></i>    server-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-server-plus"></i>    server-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-server-remove"></i>    server-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-server-security"></i>    server-security</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-set-all"></i>    set-all</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-set-center"></i>    set-center</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-set-center-right"></i>    set-center-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-set-left"></i>    set-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-set-left-center"></i>    set-left-center</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-set-left-right"></i>    set-left-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-set-none"></i>    set-none</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-set-right"></i>    set-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-set-top-box"></i>    set-top-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-settings-box"></i>    settings-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-settings-helper"></i>    settings-helper</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-settings-outline"></i>    settings-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shape-circle-plus"></i>    shape-circle-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shape-outline"></i>    shape-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shape-plus"></i>    shape-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shape-polygon-plus"></i>    shape-polygon-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shape-rectangle-plus"></i>    shape-rectangle-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shape-square-plus"></i>    shape-square-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-share-outline"></i>    share-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-share-variant"></i>    share-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-account"></i>    shield-account</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-account-outline"></i>    shield-account-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-airplane"></i>    shield-airplane</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-airplane-outline"></i>    shield-airplane-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-check"></i>    shield-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-check-outline"></i>    shield-check-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-cross"></i>    shield-cross</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-cross-outline"></i>    shield-cross-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-half-full"></i>    shield-half-full</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-home"></i>    shield-home</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-home-outline"></i>    shield-home-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-key"></i>    shield-key</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-key-outline"></i>    shield-key-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-link-variant"></i>    shield-link-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-link-variant-outline"></i>    shield-link-variant-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-lock"></i>    shield-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-lock-outline"></i>    shield-lock-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-off"></i>    shield-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-off-outline"></i>    shield-off-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-outline"></i>    shield-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-plus"></i>    shield-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-plus-outline"></i>    shield-plus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-remove"></i>    shield-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-remove-outline"></i>    shield-remove-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shield-search"></i>    shield-search</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ship-wheel"></i>    ship-wheel</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shoe-formal"></i>    shoe-formal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shoe-heel"></i>    shoe-heel</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shoe-print"></i>    shoe-print</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shopping-music"></i>    shopping-music</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shovel-off"></i>    shovel-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shower-head"></i>    shower-head</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shuffle-disabled"></i>    shuffle-disabled</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-shuffle-variant"></i>    shuffle-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sigma-lower"></i>    sigma-lower</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sign-caution"></i>    sign-caution</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sign-direction"></i>    sign-direction</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sign-text"></i>    sign-text</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-signal-2g"></i>    signal-2g</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-signal-3g"></i>    signal-3g</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-signal-4g"></i>    signal-4g</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-signal-5g"></i>    signal-5g</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-signal-cellular-1"></i>    signal-cellular-1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-signal-cellular-2"></i>    signal-cellular-2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-signal-cellular-3"></i>    signal-cellular-3</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-signal-cellular-outline"></i>    signal-cellular-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-signal-distance-variant"></i>    signal-distance-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-signal-hspa"></i>    signal-hspa</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-signal-hspa-plus"></i>    signal-hspa-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-signal-off"></i>    signal-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-signal-variant"></i>    signal-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-signature-freehand"></i>    signature-freehand</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-signature-image"></i>    signature-image</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-signature-text"></i>    signature-text</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-silverware-fork"></i>    silverware-fork</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-silverware-fork-knife"></i>    silverware-fork-knife</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-silverware-spoon"></i>    silverware-spoon</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-silverware-variant"></i>    silverware-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sim-alert"></i>    sim-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sim-off"></i>    sim-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sina-weibo"></i>    sina-weibo</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-skew-less"></i>    skew-less</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-skew-more"></i>    skew-more</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-skip-backward"></i>    skip-backward</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-skip-forward"></i>    skip-forward</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-skip-next"></i>    skip-next</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-skip-next-circle"></i>    skip-next-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-skip-next-circle-outline"></i>    skip-next-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-skip-previous"></i>    skip-previous</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-skip-previous-circle"></i>    skip-previous-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-skip-previous-circle-outline"></i>    skip-previous-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-skull-crossbones"></i>    skull-crossbones</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-skull-crossbones-outline"></i>    skull-crossbones-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-skull-outline"></i>    skull-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-skype-business"></i>    skype-business</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sleep-off"></i>    sleep-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-slope-downhill"></i>    slope-downhill</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-slope-uphill"></i>    slope-uphill</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-smoke-detector"></i>    smoke-detector</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-smoking-off"></i>    smoking-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-soccer-field"></i>    soccer-field</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-solar-panel"></i>    solar-panel</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-solar-panel-large"></i>    solar-panel-large</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-solar-power"></i>    solar-power</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sort-alphabetical"></i>    sort-alphabetical</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sort-ascending"></i>    sort-ascending</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sort-descending"></i>    sort-descending</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sort-numeric"></i>    sort-numeric</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sort-variant"></i>    sort-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sort-variant-lock"></i>    sort-variant-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sort-variant-lock-open"></i>    sort-variant-lock-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-source-branch"></i>    source-branch</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-source-commit"></i>    source-commit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-source-commit-end"></i>    source-commit-end</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-source-commit-end-local"></i>    source-commit-end-local</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-source-commit-local"></i>    source-commit-local</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-source-commit-next-local"></i>    source-commit-next-local</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-source-commit-start"></i>    source-commit-start</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-source-commit-start-next-local"></i>    source-commit-start-next-local</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-source-fork"></i>    source-fork</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-source-merge"></i>    source-merge</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-source-pull"></i>    source-pull</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-source-repository"></i>    source-repository</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-source-repository-multiple"></i>    source-repository-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-soy-sauce"></i>    soy-sauce</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-spa-outline"></i>    spa-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-space-invaders"></i>    space-invaders</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-speaker-bluetooth"></i>    speaker-bluetooth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-speaker-multiple"></i>    speaker-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-speaker-off"></i>    speaker-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-speaker-wireless"></i>    speaker-wireless</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-spider-web"></i>    spider-web</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-spotlight-beam"></i>    spotlight-beam</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-spray-bottle"></i>    spray-bottle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sprout-outline"></i>    sprout-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-square-edit-outline"></i>    square-edit-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-square-inc"></i>    square-inc</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-square-inc-cash"></i>    square-inc-cash</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-square-medium"></i>    square-medium</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-square-medium-outline"></i>    square-medium-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-square-outline"></i>    square-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-square-root"></i>    square-root</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-square-root-box"></i>    square-root-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-square-small"></i>    square-small</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-stack-exchange"></i>    stack-exchange</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-stack-overflow"></i>    stack-overflow</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-standard-definition"></i>    standard-definition</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-star-box"></i>    star-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-star-box-outline"></i>    star-box-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-star-circle"></i>    star-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-star-circle-outline"></i>    star-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-star-face"></i>    star-face</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-star-four-points"></i>    star-four-points</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-star-four-points-outline"></i>    star-four-points-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-star-half"></i>    star-half</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-star-off"></i>    star-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-star-outline"></i>    star-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-star-three-points"></i>    star-three-points</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-star-three-points-outline"></i>    star-three-points-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-steam-box"></i>    steam-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-steering-off"></i>    steering-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-step-backward"></i>    step-backward</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-step-backward-2"></i>    step-backward-2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-step-forward"></i>    step-forward</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-step-forward-2"></i>    step-forward-2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sticker-emoji"></i>    sticker-emoji</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-stop-circle"></i>    stop-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-stop-circle-outline"></i>    stop-circle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-store-24-hour"></i>    store-24-hour</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-subdirectory-arrow-left"></i>    subdirectory-arrow-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-subdirectory-arrow-right"></i>    subdirectory-arrow-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-subtitles-outline"></i>    subtitles-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-subway-alert-variant"></i>    subway-alert-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-subway-variant"></i>    subway-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-surround-sound"></i>    surround-sound</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-surround-sound-2-0"></i>    surround-sound-2-0</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-surround-sound-3-1"></i>    surround-sound-3-1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-surround-sound-5-1"></i>    surround-sound-5-1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-surround-sound-7-1"></i>    surround-sound-7-1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-swap-horizontal"></i>    swap-horizontal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-swap-horizontal-bold"></i>    swap-horizontal-bold</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-swap-horizontal-variant"></i>    swap-horizontal-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-swap-vertical"></i>    swap-vertical</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-swap-vertical-bold"></i>    swap-vertical-bold</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-swap-vertical-variant"></i>    swap-vertical-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sword-cross"></i>    sword-cross</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sync-alert"></i>    sync-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-sync-off"></i>    sync-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tab-minus"></i>    tab-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tab-plus"></i>    tab-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tab-remove"></i>    tab-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tab-unselected"></i>    tab-unselected</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-border"></i>    table-border</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-column"></i>    table-column</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-column-plus-after"></i>    table-column-plus-after</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-column-plus-before"></i>    table-column-plus-before</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-column-remove"></i>    table-column-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-column-width"></i>    table-column-width</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-edit"></i>    table-edit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-large"></i>    table-large</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-merge-cells"></i>    table-merge-cells</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-of-contents"></i>    table-of-contents</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-plus"></i>    table-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-remove"></i>    table-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-row"></i>    table-row</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-row-height"></i>    table-row-height</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-row-plus-after"></i>    table-row-plus-after</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-row-plus-before"></i>    table-row-plus-before</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-row-remove"></i>    table-row-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-search"></i>    table-search</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-settings"></i>    table-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-table-tennis"></i>    table-tennis</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tablet-android"></i>    tablet-android</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tablet-cellphone"></i>    tablet-cellphone</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tablet-ipad"></i>    tablet-ipad</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tag-faces"></i>    tag-faces</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tag-heart"></i>    tag-heart</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tag-heart-outline"></i>    tag-heart-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tag-minus"></i>    tag-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tag-multiple"></i>    tag-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tag-outline"></i>    tag-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tag-plus"></i>    tag-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tag-remove"></i>    tag-remove</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tag-text-outline"></i>    tag-text-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tape-measure"></i>    tape-measure</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-target-account"></i>    target-account</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-target-variant"></i>    target-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tea-outline"></i>    tea-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-television-box"></i>    television-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-television-classic"></i>    television-classic</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-television-classic-off"></i>    television-classic-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-television-guide"></i>    television-guide</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-television-off"></i>    television-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-temperature-celsius"></i>    temperature-celsius</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-temperature-fahrenheit"></i>    temperature-fahrenheit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-temperature-kelvin"></i>    temperature-kelvin</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tennis-ball"></i>    tennis-ball</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-test-tube"></i>    test-tube</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-test-tube-empty"></i>    test-tube-empty</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-test-tube-off"></i>    test-tube-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-text-shadow"></i>    text-shadow</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-text-short"></i>    text-short</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-text-subject"></i>    text-subject</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-text-to-speech"></i>    text-to-speech</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-text-to-speech-off"></i>    text-to-speech-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-textbox-password"></i>    textbox-password</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-theme-light-dark"></i>    theme-light-dark</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-thermometer-alert"></i>    thermometer-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-thermometer-chevron-down"></i>    thermometer-chevron-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-thermometer-chevron-up"></i>    thermometer-chevron-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-thermometer-lines"></i>    thermometer-lines</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-thermometer-minus"></i>    thermometer-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-thermometer-plus"></i>    thermometer-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-thermostat-box"></i>    thermostat-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-thought-bubble"></i>    thought-bubble</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-thought-bubble-outline"></i>    thought-bubble-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-thumb-down"></i>    thumb-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-thumb-down-outline"></i>    thumb-down-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-thumb-up"></i>    thumb-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-thumb-up-outline"></i>    thumb-up-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-thumbs-up-down"></i>    thumbs-up-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ticket-account"></i>    ticket-account</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ticket-confirmation"></i>    ticket-confirmation</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ticket-outline"></i>    ticket-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ticket-percent"></i>    ticket-percent</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-timeline-outline"></i>    timeline-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-timeline-text"></i>    timeline-text</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-timeline-text-outline"></i>    timeline-text-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-timer-10"></i>    timer-10</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-timer-3"></i>    timer-3</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-timer-off"></i>    timer-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-timer-sand"></i>    timer-sand</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-timer-sand-empty"></i>    timer-sand-empty</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-timer-sand-full"></i>    timer-sand-full</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-toaster-oven"></i>    toaster-oven</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-toggle-switch"></i>    toggle-switch</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-toggle-switch-off"></i>    toggle-switch-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-toggle-switch-off-outline"></i>    toggle-switch-off-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-toggle-switch-outline"></i>    toggle-switch-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-toolbox-outline"></i>    toolbox-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tooltip-account"></i>    tooltip-account</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tooltip-edit"></i>    tooltip-edit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tooltip-image"></i>    tooltip-image</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tooltip-image-outline"></i>    tooltip-image-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tooltip-outline"></i>    tooltip-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tooltip-plus"></i>    tooltip-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tooltip-plus-outline"></i>    tooltip-plus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tooltip-text"></i>    tooltip-text</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tooltip-text-outline"></i>    tooltip-text-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tooth-outline"></i>    tooth-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tower-beach"></i>    tower-beach</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tower-fire"></i>    tower-fire</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-track-light"></i>    track-light</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-trackpad-lock"></i>    trackpad-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-traffic-light"></i>    traffic-light</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-train-car"></i>    train-car</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-train-variant"></i>    train-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-transcribe-close"></i>    transcribe-close</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-transfer-down"></i>    transfer-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-transfer-left"></i>    transfer-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-transfer-right"></i>    transfer-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-transfer-up"></i>    transfer-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-transit-connection"></i>    transit-connection</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-transit-connection-variant"></i>    transit-connection-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-transit-transfer"></i>    transit-transfer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-transition-masked"></i>    transition-masked</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-translate-off"></i>    translate-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-transmission-tower"></i>    transmission-tower</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-trash-can"></i>    trash-can</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-trash-can-outline"></i>    trash-can-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-treasure-chest"></i>    treasure-chest</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tree-outline"></i>    tree-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-trending-down"></i>    trending-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-trending-neutral"></i>    trending-neutral</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-trending-up"></i>    trending-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-triangle-outline"></i>    triangle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-trophy-award"></i>    trophy-award</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-trophy-broken"></i>    trophy-broken</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-trophy-outline"></i>    trophy-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-trophy-variant"></i>    trophy-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-trophy-variant-outline"></i>    trophy-variant-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-truck-check"></i>    truck-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-truck-delivery"></i>    truck-delivery</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-truck-fast"></i>    truck-fast</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-truck-trailer"></i>    truck-trailer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tshirt-crew"></i>    tshirt-crew</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tshirt-crew-outline"></i>    tshirt-crew-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tshirt-v"></i>    tshirt-v</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tshirt-v-outline"></i>    tshirt-v-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tumble-dryer"></i>    tumble-dryer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tumblr-box"></i>    tumblr-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tumblr-reblog"></i>    tumblr-reblog</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-tune-vertical"></i>    tune-vertical</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-turnstile-outline"></i>    turnstile-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-twitter-box"></i>    twitter-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-twitter-circle"></i>    twitter-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-twitter-retweet"></i>    twitter-retweet</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-two-factor-authentication"></i>    two-factor-authentication</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-ultra-high-definition"></i>    ultra-high-definition</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-umbrella-closed"></i>    umbrella-closed</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-umbrella-outline"></i>    umbrella-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-undo-variant"></i>    undo-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-unfold-less-horizontal"></i>    unfold-less-horizontal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-unfold-less-vertical"></i>    unfold-less-vertical</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-unfold-more-horizontal"></i>    unfold-more-horizontal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-unfold-more-vertical"></i>    unfold-more-vertical</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-upload-multiple"></i>    upload-multiple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-upload-network"></i>    upload-network</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-upload-network-outline"></i>    upload-network-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-upload-outline"></i>    upload-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-van-passenger"></i>    van-passenger</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-van-utility"></i>    van-utility</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-arrange-above"></i>    vector-arrange-above</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-arrange-below"></i>    vector-arrange-below</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-bezier"></i>    vector-bezier</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-circle"></i>    vector-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-circle-variant"></i>    vector-circle-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-combine"></i>    vector-combine</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-curve"></i>    vector-curve</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-difference"></i>    vector-difference</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-difference-ab"></i>    vector-difference-ab</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-difference-ba"></i>    vector-difference-ba</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-ellipse"></i>    vector-ellipse</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-intersection"></i>    vector-intersection</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-line"></i>    vector-line</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-point"></i>    vector-point</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-polygon"></i>    vector-polygon</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-polyline"></i>    vector-polyline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-radius"></i>    vector-radius</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-rectangle"></i>    vector-rectangle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-selection"></i>    vector-selection</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-square"></i>    vector-square</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-triangle"></i>    vector-triangle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vector-union"></i>    vector-union</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vibrate-off"></i>    vibrate-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-video-3d"></i>    video-3d</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-video-4k-box"></i>    video-4k-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-video-account"></i>    video-account</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-video-image"></i>    video-image</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-video-input-antenna"></i>    video-input-antenna</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-video-input-component"></i>    video-input-component</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-video-input-hdmi"></i>    video-input-hdmi</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-video-input-svideo"></i>    video-input-svideo</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-video-minus"></i>    video-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-video-off"></i>    video-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-video-off-outline"></i>    video-off-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-video-outline"></i>    video-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-video-plus"></i>    video-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-video-stabilization"></i>    video-stabilization</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-video-switch"></i>    video-switch</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-video-vintage"></i>    video-vintage</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-agenda"></i>    view-agenda</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-array"></i>    view-array</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-carousel"></i>    view-carousel</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-column"></i>    view-column</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-comfy"></i>    view-comfy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-compact"></i>    view-compact</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-compact-outline"></i>    view-compact-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-dashboard"></i>    view-dashboard</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-dashboard-outline"></i>    view-dashboard-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-dashboard-variant"></i>    view-dashboard-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-day"></i>    view-day</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-grid"></i>    view-grid</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-headline"></i>    view-headline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-list"></i>    view-list</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-module"></i>    view-module</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-parallel"></i>    view-parallel</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-quilt"></i>    view-quilt</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-sequential"></i>    view-sequential</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-split-horizontal"></i>    view-split-horizontal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-split-vertical"></i>    view-split-vertical</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-stream"></i>    view-stream</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-view-week"></i>    view-week</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-virtual-reality"></i>    virtual-reality</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-visual-studio"></i>    visual-studio</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-visual-studio-code"></i>    visual-studio-code</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vk-box"></i>    vk-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vk-circle"></i>    vk-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-volume-high"></i>    volume-high</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-volume-low"></i>    volume-low</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-volume-medium"></i>    volume-medium</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-volume-minus"></i>    volume-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-volume-mute"></i>    volume-mute</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-volume-off"></i>    volume-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-volume-plus"></i>    volume-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-volume-variant-off"></i>    volume-variant-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-vote-outline"></i>    vote-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wall-sconce"></i>    wall-sconce</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wall-sconce-flat"></i>    wall-sconce-flat</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wall-sconce-variant"></i>    wall-sconce-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wallet-giftcard"></i>    wallet-giftcard</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wallet-membership"></i>    wallet-membership</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wallet-outline"></i>    wallet-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wallet-travel"></i>    wallet-travel</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-washing-machine"></i>    washing-machine</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-watch-export"></i>    watch-export</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-watch-export-variant"></i>    watch-export-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-watch-import"></i>    watch-import</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-watch-import-variant"></i>    watch-import-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-watch-variant"></i>    watch-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-watch-vibrate"></i>    watch-vibrate</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-watch-vibrate-off"></i>    watch-vibrate-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-water-off"></i>    water-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-water-outline"></i>    water-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-water-percent"></i>    water-percent</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-water-pump"></i>    water-pump</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weather-cloudy"></i>    weather-cloudy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weather-cloudy-arrow-right"></i>    weather-cloudy-arrow-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weather-fog"></i>    weather-fog</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weather-hail"></i>    weather-hail</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weather-hurricane"></i>    weather-hurricane</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weather-lightning"></i>    weather-lightning</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weather-lightning-rainy"></i>    weather-lightning-rainy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weather-night"></i>    weather-night</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weather-partlycloudy"></i>    weather-partlycloudy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weather-pouring"></i>    weather-pouring</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weather-rainy"></i>    weather-rainy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weather-snowy"></i>    weather-snowy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weather-snowy-rainy"></i>    weather-snowy-rainy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weather-sunny"></i>    weather-sunny</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weather-sunset"></i>    weather-sunset</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weather-sunset-down"></i>    weather-sunset-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weather-sunset-up"></i>    weather-sunset-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weather-windy"></i>    weather-windy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weather-windy-variant"></i>    weather-windy-variant</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weight-gram"></i>    weight-gram</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weight-kilogram"></i>    weight-kilogram</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-weight-pound"></i>    weight-pound</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wheelchair-accessibility"></i>    wheelchair-accessibility</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-white-balance-auto"></i>    white-balance-auto</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-white-balance-incandescent"></i>    white-balance-incandescent</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-white-balance-iridescent"></i>    white-balance-iridescent</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-white-balance-sunny"></i>    white-balance-sunny</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wifi-off"></i>    wifi-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wifi-star"></i>    wifi-star</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wifi-strength-1"></i>    wifi-strength-1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wifi-strength-1-alert"></i>    wifi-strength-1-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wifi-strength-1-lock"></i>    wifi-strength-1-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wifi-strength-2"></i>    wifi-strength-2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wifi-strength-2-alert"></i>    wifi-strength-2-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wifi-strength-2-lock"></i>    wifi-strength-2-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wifi-strength-3"></i>    wifi-strength-3</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wifi-strength-3-alert"></i>    wifi-strength-3-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wifi-strength-3-lock"></i>    wifi-strength-3-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wifi-strength-4"></i>    wifi-strength-4</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wifi-strength-4-alert"></i>    wifi-strength-4-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wifi-strength-4-lock"></i>    wifi-strength-4-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wifi-strength-alert-outline"></i>    wifi-strength-alert-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wifi-strength-lock-outline"></i>    wifi-strength-lock-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wifi-strength-off"></i>    wifi-strength-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wifi-strength-off-outline"></i>    wifi-strength-off-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wifi-strength-outline"></i>    wifi-strength-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wind-turbine"></i>    wind-turbine</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-window-close"></i>    window-close</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-window-closed"></i>    window-closed</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-window-maximize"></i>    window-maximize</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-window-minimize"></i>    window-minimize</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-window-open"></i>    window-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-window-restore"></i>    window-restore</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-windows-classic"></i>    windows-classic</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wiper-wash"></i>    wiper-wash</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wrap-disabled"></i>    wrap-disabled</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-wrench-outline"></i>    wrench-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-xamarin-outline"></i>    xamarin-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-xbox-controller"></i>    xbox-controller</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-xbox-controller-battery-alert"></i>    xbox-controller-battery-alert</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-xbox-controller-battery-charging"></i>    xbox-controller-battery-charging</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-xbox-controller-battery-empty"></i>    xbox-controller-battery-empty</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-xbox-controller-battery-full"></i>    xbox-controller-battery-full</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-xbox-controller-battery-low"></i>    xbox-controller-battery-low</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-xbox-controller-battery-medium"></i>    xbox-controller-battery-medium</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-xbox-controller-battery-unknown"></i>    xbox-controller-battery-unknown</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-xbox-controller-menu"></i>    xbox-controller-menu</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-xbox-controller-off"></i>    xbox-controller-off</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-xbox-controller-view"></i>    xbox-controller-view</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-xing-box"></i>    xing-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-xing-circle"></i>    xing-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-yin-yang"></i>    yin-yang</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-youtube-creator-studio"></i>    youtube-creator-studio</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-youtube-gaming"></i>    youtube-gaming</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-youtube-subscription"></i>    youtube-subscription</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-youtube-tv"></i>    youtube-tv</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-z-wave"></i>    z-wave</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-zip-box"></i>    zip-box</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-zip-disk"></i>    zip-disk</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-zodiac-aquarius"></i>    zodiac-aquarius</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-zodiac-aries"></i>    zodiac-aries</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-zodiac-cancer"></i>    zodiac-cancer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-zodiac-capricorn"></i>    zodiac-capricorn</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-zodiac-gemini"></i>    zodiac-gemini</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-zodiac-leo"></i>    zodiac-leo</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-zodiac-libra"></i>    zodiac-libra</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-zodiac-pisces"></i>    zodiac-pisces</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-zodiac-sagittarius"></i>    zodiac-sagittarius</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-zodiac-scorpio"></i>    zodiac-scorpio</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-zodiac-taurus"></i>    zodiac-taurus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="mdi mdi-zodiac-virgo"></i>    zodiac-virgo</div>
                                </section>
                        `;

            modal.open({
              title: "Icon Palette",
              content: `${iconForm.outerHTML}`,
            });
          } else if (blockId.startsWith("pe7-icon-palette")) {
            console.log("inside pe7-icon-palette");

            // GRAPESJS MODAL LOGIC
            const iconForm = document.createElement("div");
            iconForm.setAttribute("class", "icon-form");
            iconForm.innerHTML = `
                                <link rel="stylesheet" type="text/css" href="/assets/css/pe7-icon.css">

                                <section>
                                    <div class="col-lg-4 col-sm-6"><i class="pe-7s-album"></i> pe-7s-album</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-arc"></i> pe-7s-arc</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-back-2"></i> pe-7s-back-2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-bandaid"></i> pe-7s-bandaid</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-car"></i> pe-7s-car</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-diamond"></i> pe-7s-diamond</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-door-lock"></i> pe-7s-door-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-eyedropper"></i> pe-7s-eyedropper</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-female"></i> pe-7s-female</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-gym"></i> pe-7s-gym</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-hammer"></i> pe-7s-hammer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-headphones"></i> pe-7s-headphones</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-helm"></i> pe-7s-helm</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-hourglass"></i> pe-7s-hourglass</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-leaf"></i> pe-7s-leaf</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-magic-wand"></i> pe-7s-magic-wand</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-male"></i> pe-7s-male</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-map-2"></i> pe-7s-map-2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-next-2"></i> pe-7s-next-2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-paint-bucket"></i> pe-7s-paint-bucket</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-pendrive"></i> pe-7s-pendrive</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-photo"></i> pe-7s-photo</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-piggy"></i> pe-7s-piggy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-plugin"></i> pe-7s-plugin</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-refresh-2"></i> pe-7s-refresh-2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-rocket"></i> pe-7s-rocket</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-settings"></i> pe-7s-settings</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-shield"></i> pe-7s-shield</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-smile"></i> pe-7s-smile</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-usb"></i> pe-7s-usb</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-vector"></i> pe-7s-vector</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-wine"></i> pe-7s-wine</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-cloud-upload"></i> pe-7s-cloud-upload</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-cash"></i> pe-7s-cash</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-close"></i> pe-7s-close</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-bluetooth"></i> pe-7s-bluetooth</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-cloud-download"></i> pe-7s-cloud-download</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-way"></i> pe-7s-way</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-close-circle"></i> pe-7s-close-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-id"></i> pe-7s-id</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-angle-up"></i> pe-7s-angle-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-wristwatch"></i> pe-7s-wristwatch</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-angle-up-circle"></i> pe-7s-angle-up-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-world"></i> pe-7s-world</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-angle-right"></i> pe-7s-angle-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-volume"></i> pe-7s-volume</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-angle-right-circle"></i> pe-7s-angle-right-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-users"></i> pe-7s-users</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-angle-left"></i> pe-7s-angle-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-user-female"></i> pe-7s-user-female</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-angle-left-circle"></i> pe-7s-angle-left-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-up-arrow"></i> pe-7s-up-arrow</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-angle-down"></i> pe-7s-angle-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-switch"></i> pe-7s-switch</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-angle-down-circle"></i> pe-7s-angle-down-circle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-scissors"></i> pe-7s-scissors</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-wallet"></i> pe-7s-wallet</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-safe"></i> pe-7s-safe</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-volume2"></i> pe-7s-volume2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-volume1"></i> pe-7s-volume1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-voicemail"></i> pe-7s-voicemail</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-video"></i> pe-7s-video</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-user"></i> pe-7s-user</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-upload"></i> pe-7s-upload</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-unlock"></i> pe-7s-unlock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-umbrella"></i> pe-7s-umbrella</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-trash"></i> pe-7s-trash</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-tools"></i> pe-7s-tools</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-timer"></i> pe-7s-timer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-ticket"></i> pe-7s-ticket</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-target"></i> pe-7s-target</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-sun"></i> pe-7s-sun</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-study"></i> pe-7s-study</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-stopwatch"></i> pe-7s-stopwatch</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-star"></i> pe-7s-star</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-speaker"></i> pe-7s-speaker</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-signal"></i> pe-7s-signal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-shuffle"></i> pe-7s-shuffle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-shopbag"></i> pe-7s-shopbag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-share"></i> pe-7s-share</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-server"></i> pe-7s-server</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-search"></i> pe-7s-search</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-film"></i> pe-7s-film</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-science"></i> pe-7s-science</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-disk"></i> pe-7s-disk</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-ribbon"></i> pe-7s-ribbon</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-repeat"></i> pe-7s-repeat</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-refresh"></i> pe-7s-refresh</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-add-user"></i> pe-7s-add-user</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-refresh-cloud"></i> pe-7s-refresh-cloud</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-paperclip"></i> pe-7s-paperclip</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-radio"></i> pe-7s-radio</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-note2"></i> pe-7s-note2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-print"></i> pe-7s-print</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-network"></i> pe-7s-network</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-prev"></i> pe-7s-prev</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-mute"></i> pe-7s-mute</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-power"></i> pe-7s-power</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-medal"></i> pe-7s-medal</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-portfolio"></i> pe-7s-portfolio</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-like2"></i> pe-7s-like2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-plus"></i> pe-7s-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-left-arrow"></i> pe-7s-left-arrow</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-play"></i> pe-7s-play</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-key"></i> pe-7s-key</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-plane"></i> pe-7s-plane</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-joy"></i> pe-7s-joy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-photo-gallery"></i> pe-7s-photo-gallery</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-pin"></i> pe-7s-pin</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-phone"></i> pe-7s-phone</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-plug"></i> pe-7s-plug</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-pen"></i> pe-7s-pen</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-right-arrow"></i> pe-7s-right-arrow</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-paper-plane"></i> pe-7s-paper-plane</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-delete-user"></i> pe-7s-delete-user</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-paint"></i> pe-7s-paint</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-bottom-arrow"></i> pe-7s-bottom-arrow</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-notebook"></i> pe-7s-notebook</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-note"></i> pe-7s-note</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-next"></i> pe-7s-next</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-news-paper"></i> pe-7s-news-paper</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-musiclist"></i> pe-7s-musiclist</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-music"></i> pe-7s-music</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-mouse"></i> pe-7s-mouse</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-more"></i> pe-7s-more</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-moon"></i> pe-7s-moon</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-monitor"></i> pe-7s-monitor</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-micro"></i> pe-7s-micro</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-menu"></i> pe-7s-menu</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-map"></i> pe-7s-map</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-map-marker"></i> pe-7s-map-marker</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-mail"></i> pe-7s-mail</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-mail-open"></i> pe-7s-mail-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-mail-open-file"></i> pe-7s-mail-open-file</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-magnet"></i> pe-7s-magnet</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-loop"></i> pe-7s-loop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-look"></i> pe-7s-look</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-lock"></i> pe-7s-lock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-lintern"></i> pe-7s-lintern</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-link"></i> pe-7s-link</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-like"></i> pe-7s-like</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-light"></i> pe-7s-light</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-less"></i> pe-7s-less</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-keypad"></i> pe-7s-keypad</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-junk"></i> pe-7s-junk</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-info"></i> pe-7s-info</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-home"></i> pe-7s-home</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-help2"></i> pe-7s-help2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-help1"></i> pe-7s-help1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-graph3"></i> pe-7s-graph3</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-graph2"></i> pe-7s-graph2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-graph1"></i> pe-7s-graph1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-graph"></i> pe-7s-graph</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-global"></i> pe-7s-global</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-gleam"></i> pe-7s-gleam</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-glasses"></i> pe-7s-glasses</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-gift"></i> pe-7s-gift</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-folder"></i> pe-7s-folder</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-flag"></i> pe-7s-flag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-filter"></i> pe-7s-filter</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-file"></i> pe-7s-file</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-expand1"></i> pe-7s-expand1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-exapnd2"></i> pe-7s-exapnd2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-edit"></i> pe-7s-edit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-drop"></i> pe-7s-drop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-drawer"></i> pe-7s-drawer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-download"></i> pe-7s-download</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-display2"></i> pe-7s-display2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-display1"></i> pe-7s-display1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-diskette"></i> pe-7s-diskette</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-date"></i> pe-7s-date</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-cup"></i> pe-7s-cup</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-culture"></i> pe-7s-culture</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-crop"></i> pe-7s-crop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-credit"></i> pe-7s-credit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-copy-file"></i> pe-7s-copy-file</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-config"></i> pe-7s-config</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-compass"></i> pe-7s-compass</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-comment"></i> pe-7s-comment</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-coffee"></i> pe-7s-coffee</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-cloud"></i> pe-7s-cloud</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-clock"></i> pe-7s-clock</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-check"></i> pe-7s-check</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-chat"></i> pe-7s-chat</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-cart"></i> pe-7s-cart</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-camera"></i> pe-7s-camera</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-call"></i> pe-7s-call</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-calculator"></i> pe-7s-calculator</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-browser"></i> pe-7s-browser</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-box2"></i> pe-7s-box2</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-box1"></i> pe-7s-box1</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-bookmarks"></i> pe-7s-bookmarks</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-bicycle"></i> pe-7s-bicycle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-bell"></i> pe-7s-bell</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-battery"></i> pe-7s-battery</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-ball"></i> pe-7s-ball</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-back"></i> pe-7s-back</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-attention"></i> pe-7s-attention</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-anchor"></i> pe-7s-anchor</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-albums"></i> pe-7s-albums</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-alarm"></i> pe-7s-alarm</div>
                                      <div class="col-lg-4 col-sm-6"><i class="pe-7s-airplay"></i> pe-7s-airplay</div>
                                </section>
                        `;

            modal.open({
              title: "Icon Palette",
              content: `${iconForm.outerHTML}`,
            });
          } else if (blockId.startsWith("typicons-icon-palette")) {
            console.log("inside typicons-icon-palette");

            // GRAPESJS MODAL LOGIC
            const iconForm = document.createElement("div");
            iconForm.setAttribute("class", "icon-form");
            iconForm.innerHTML = `
                                <link rel="stylesheet" type="text/css" href="/assets/css/typicon-icon.css">

                                <section>
                                    <div class="col-lg-4 col-sm-6"><i class="typcn typcn-adjust-brightness"></i>typcn-adjust-brightness</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-adjust-contrast"></i>typcn-adjust-contrast</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-anchor-outline"></i>typcn-anchor-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-anchor"></i>typcn-anchor</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-archive"></i>typcn-archive</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-back-outline"></i>typcn-arrow-back-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-back"></i>typcn-arrow-back</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-down-outline"></i>typcn-arrow-down-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-down-thick"></i>typcn-arrow-down-thick</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-down"></i>typcn-arrow-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-forward-outline"></i>typcn-arrow-forward-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-forward"></i>typcn-arrow-forward</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-left-outline"></i>typcn-arrow-left-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-left-thick"></i>typcn-arrow-left-thick</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-left"></i>typcn-arrow-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-loop-outline"></i>typcn-arrow-loop-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-loop"></i>typcn-arrow-loop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-maximise-outline"></i>typcn-arrow-maximise-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-maximise"></i>typcn-arrow-maximise</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-minimise-outline"></i>typcn-arrow-minimise-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-minimise"></i>typcn-arrow-minimise</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-move-outline"></i>typcn-arrow-move-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-move"></i>typcn-arrow-move</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-repeat-outline"></i>typcn-arrow-repeat-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-repeat"></i>typcn-arrow-repeat</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-right-outline"></i>typcn-arrow-right-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-right-thick"></i>typcn-arrow-right-thick</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-right"></i>typcn-arrow-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-shuffle"></i>typcn-arrow-shuffle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-sorted-down"></i>typcn-arrow-sorted-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-sorted-up"></i>typcn-arrow-sorted-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-sync-outline"></i>typcn-arrow-sync-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-sync"></i>typcn-arrow-sync</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-unsorted"></i>typcn-arrow-unsorted</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-up-outline"></i>typcn-arrow-up-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-up-thick"></i>typcn-arrow-up-thick</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-arrow-up"></i>typcn-arrow-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-at"></i>typcn-at</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-attachment-outline"></i>typcn-attachment-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-attachment"></i>typcn-attachment</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-backspace-outline"></i>typcn-backspace-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-backspace"></i>typcn-backspace</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-battery-charge"></i>typcn-battery-charge</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-battery-full"></i>typcn-battery-full</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-battery-high"></i>typcn-battery-high</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-battery-low"></i>typcn-battery-low</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-battery-mid"></i>typcn-battery-mid</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-beaker"></i>typcn-beaker</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-beer"></i>typcn-beer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-bell"></i>typcn-bell</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-book"></i>typcn-book</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-bookmark"></i>typcn-bookmark</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-briefcase"></i>typcn-briefcase</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-brush"></i>typcn-brush</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-business-card"></i>typcn-business-card</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-calculator"></i>typcn-calculator</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-calendar-outline"></i>typcn-calendar-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-calendar"></i>typcn-calendar</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-camera-outline"></i>typcn-camera-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-camera"></i>typcn-camera</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-cancel-outline"></i>typcn-cancel-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-cancel"></i>typcn-cancel</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-chart-area-outline"></i>typcn-chart-area-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-chart-area"></i>typcn-chart-area</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-chart-bar-outline"></i>typcn-chart-bar-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-chart-bar"></i>typcn-chart-bar</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-chart-line-outline"></i>typcn-chart-line-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-chart-line"></i>typcn-chart-line</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-chart-pie-outline"></i>typcn-chart-pie-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-chart-pie"></i>typcn-chart-pie</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-chevron-left-outline"></i>typcn-chevron-left-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-chevron-left"></i>typcn-chevron-left</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-chevron-right-outline"></i>typcn-chevron-right-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-chevron-right"></i>typcn-chevron-right</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-clipboard"></i>typcn-clipboard</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-cloud-storage"></i>typcn-cloud-storage</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-cloud-storage-outline"></i>typcn-cloud-storage-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-code-outline"></i>typcn-code-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-code"></i>typcn-code</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-coffee"></i>typcn-coffee</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-cog-outline"></i>typcn-cog-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-cog"></i>typcn-cog</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-compass"></i>typcn-compass</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-contacts"></i>typcn-contacts</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-credit-card"></i>typcn-credit-card</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-css3"></i>typcn-css3</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-database"></i>typcn-database</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-delete-outline"></i>typcn-delete-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-delete"></i>typcn-delete</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-device-desktop"></i>typcn-device-desktop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-device-laptop"></i>typcn-device-laptop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-device-phone"></i>typcn-device-phone</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-device-tablet"></i>typcn-device-tablet</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-directions"></i>typcn-directions</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-divide-outline"></i>typcn-divide-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-divide"></i>typcn-divide</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-document-add"></i>typcn-document-add</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-document-delete"></i>typcn-document-delete</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-document-text"></i>typcn-document-text</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-document"></i>typcn-document</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-download-outline"></i>typcn-download-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-download"></i>typcn-download</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-dropbox"></i>typcn-dropbox</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-edit"></i>typcn-edit</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-eject-outline"></i>typcn-eject-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-eject"></i>typcn-eject</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-equals-outline"></i>typcn-equals-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-equals"></i>typcn-equals</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-export-outline"></i>typcn-export-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-export"></i>typcn-export</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-eye-outline"></i>typcn-eye-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-eye"></i>typcn-eye</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-feather"></i>typcn-feather</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-film"></i>typcn-film</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-filter"></i>typcn-filter</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-flag-outline"></i>typcn-flag-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-flag"></i>typcn-flag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-flash-outline"></i>typcn-flash-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-flash"></i>typcn-flash</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-flow-children"></i>typcn-flow-children</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-flow-merge"></i>typcn-flow-merge</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-flow-parallel"></i>typcn-flow-parallel</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-flow-switch"></i>typcn-flow-switch</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-folder-add"></i>typcn-folder-add</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-folder-delete"></i>typcn-folder-delete</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-folder-open"></i>typcn-folder-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-folder"></i>typcn-folder</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-gift"></i>typcn-gift</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-globe-outline"></i>typcn-globe-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-globe"></i>typcn-globe</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-group-outline"></i>typcn-group-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-group"></i>typcn-group</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-headphones"></i>typcn-headphones</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-heart-full-outline"></i>typcn-heart-full-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-heart-half-outline"></i>typcn-heart-half-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-heart-outline"></i>typcn-heart-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-heart"></i>typcn-heart</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-home-outline"></i>typcn-home-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-home"></i>typcn-home</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-html5"></i>typcn-html5</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-image-outline"></i>typcn-image-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-image"></i>typcn-image</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-infinity-outline"></i>typcn-infinity-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-infinity"></i>typcn-infinity</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-info-large-outline"></i>typcn-info-large-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-info-large"></i>typcn-info-large</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-info-outline"></i>typcn-info-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-info"></i>typcn-info</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-input-checked-outline"></i>typcn-input-checked-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-input-checked"></i>typcn-input-checked</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-key-outline"></i>typcn-key-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-key"></i>typcn-key</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-keyboard"></i>typcn-keyboard</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-leaf"></i>typcn-leaf</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-lightbulb"></i>typcn-lightbulb</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-link-outline"></i>typcn-link-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-link"></i>typcn-link</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-location-arrow-outline"></i>typcn-location-arrow-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-location-arrow"></i>typcn-location-arrow</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-location-outline"></i>typcn-location-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-location"></i>typcn-location</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-lock-closed-outline"></i>typcn-lock-closed-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-lock-closed"></i>typcn-lock-closed</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-lock-open-outline"></i>typcn-lock-open-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-lock-open"></i>typcn-lock-open</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-mail"></i>typcn-mail</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-map"></i>typcn-map</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-media-eject-outline"></i>typcn-media-eject-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-media-eject"></i>typcn-media-eject</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-media-fast-forward-outline"></i>typcn-media-fast-forward-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-media-fast-forward"></i>typcn-media-fast-forward</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-media-pause-outline"></i>typcn-media-pause-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-media-pause"></i>typcn-media-pause</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-media-play-outline"></i>typcn-media-play-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-media-play-reverse-outline"></i>typcn-media-play-reverse-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-media-play-reverse"></i>typcn-media-play-reverse</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-media-play"></i>typcn-media-play</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-media-record-outline"></i>typcn-media-record-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-media-record"></i>typcn-media-record</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-media-rewind-outline"></i>typcn-media-rewind-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-media-rewind"></i>typcn-media-rewind</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-media-stop-outline"></i>typcn-media-stop-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-media-stop"></i>typcn-media-stop</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-message-typing"></i>typcn-message-typing</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-message"></i>typcn-message</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-messages"></i>typcn-messages</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-microphone-outline"></i>typcn-microphone-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-microphone"></i>typcn-microphone</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-minus-outline"></i>typcn-minus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-minus"></i>typcn-minus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-mortar-board"></i>typcn-mortar-board</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-news"></i>typcn-news</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-notes-outline"></i>typcn-notes-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-notes"></i>typcn-notes</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-pen"></i>typcn-pen</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-pencil"></i>typcn-pencil</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-phone-outline"></i>typcn-phone-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-phone"></i>typcn-phone</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-pi-outline"></i>typcn-pi-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-pi"></i>typcn-pi</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-pin-outline"></i>typcn-pin-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-pin"></i>typcn-pin</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-pipette"></i>typcn-pipette</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-plane-outline"></i>typcn-plane-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-plane"></i>typcn-plane</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-plug"></i>typcn-plug</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-plus-outline"></i>typcn-plus-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-plus"></i>typcn-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-point-of-interest-outline"></i>typcn-point-of-interest-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-point-of-interest"></i>typcn-point-of-interest</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-power-outline"></i>typcn-power-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-power"></i>typcn-power</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-printer"></i>typcn-printer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-puzzle-outline"></i>typcn-puzzle-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-puzzle"></i>typcn-puzzle</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-radar-outline"></i>typcn-radar-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-radar"></i>typcn-radar</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-refresh-outline"></i>typcn-refresh-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-refresh"></i>typcn-refresh</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-rss-outline"></i>typcn-rss-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-rss"></i>typcn-rss</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-scissors-outline"></i>typcn-scissors-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-scissors"></i>typcn-scissors</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-shopping-bag"></i>typcn-shopping-bag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-shopping-cart"></i>typcn-shopping-cart</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-at-circular"></i>typcn-social-at-circular</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-dribbble-circular"></i>typcn-social-dribbble-circular</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-dribbble"></i>typcn-social-dribbble</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-facebook-circular"></i>typcn-social-facebook-circular</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-facebook"></i>typcn-social-facebook</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-flickr-circular"></i>typcn-social-flickr-circular</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-flickr"></i>typcn-social-flickr</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-github-circular"></i>typcn-social-github-circular</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-github"></i>typcn-social-github</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-google-plus-circular"></i>typcn-social-google-plus-circular</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-google-plus"></i>typcn-social-google-plus</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-instagram-circular"></i>typcn-social-instagram-circular</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-instagram"></i>typcn-social-instagram</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-last-fm-circular"></i>typcn-social-last-fm-circular</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-last-fm"></i>typcn-social-last-fm</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-linkedin-circular"></i>typcn-social-linkedin-circular</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-linkedin"></i>typcn-social-linkedin</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-pinterest-circular"></i>typcn-social-pinterest-circular</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-pinterest"></i>typcn-social-pinterest</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-skype-outline"></i>typcn-social-skype-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-skype"></i>typcn-social-skype</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-tumbler-circular"></i>typcn-social-tumbler-circular</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-tumbler"></i>typcn-social-tumbler</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-twitter-circular"></i>typcn-social-twitter-circular</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-twitter"></i>typcn-social-twitter</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-vimeo-circular"></i>typcn-social-vimeo-circular</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-vimeo"></i>typcn-social-vimeo</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-youtube-circular"></i>typcn-social-youtube-circular</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-social-youtube"></i>typcn-social-youtube</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-sort-alphabetically-outline"></i>typcn-sort-alphabetically-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-sort-alphabetically"></i>typcn-sort-alphabetically</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-sort-numerically-outline"></i>typcn-sort-numerically-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-sort-numerically"></i>typcn-sort-numerically</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-spanner-outline"></i>typcn-spanner-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-spanner"></i>typcn-spanner</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-spiral"></i>typcn-spiral</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-star-full-outline"></i>typcn-star-full-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-star-half-outline"></i>typcn-star-half-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-star-half"></i>typcn-star-half</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-star-outline"></i>typcn-star-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-star"></i>typcn-star</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-starburst-outline"></i>typcn-starburst-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-starburst"></i>typcn-starburst</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-stopwatch"></i>typcn-stopwatch</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-support"></i>typcn-support</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-tabs-outline"></i>typcn-tabs-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-tag"></i>typcn-tag</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-tags"></i>typcn-tags</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-th-large-outline"></i>typcn-th-large-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-th-large"></i>typcn-th-large</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-th-list-outline"></i>typcn-th-list-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-th-list"></i>typcn-th-list</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-th-menu-outline"></i>typcn-th-menu-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-th-menu"></i>typcn-th-menu</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-th-small-outline"></i>typcn-th-small-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-th-small"></i>typcn-th-small</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-thermometer"></i>typcn-thermometer</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-thumbs-down"></i>typcn-thumbs-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-thumbs-ok"></i>typcn-thumbs-ok</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-thumbs-up"></i>typcn-thumbs-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-tick-outline"></i>typcn-tick-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-tick"></i>typcn-tick</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-ticket"></i>typcn-ticket</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-time"></i>typcn-time</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-times-outline"></i>typcn-times-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-times"></i>typcn-times</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-trash"></i>typcn-trash</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-tree"></i>typcn-tree</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-upload-outline"></i>typcn-upload-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-upload"></i>typcn-upload</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-user-add-outline"></i>typcn-user-add-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-user-add"></i>typcn-user-add</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-user-delete-outline"></i>typcn-user-delete-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-user-delete"></i>typcn-user-delete</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-user-outline"></i>typcn-user-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-user"></i>typcn-user</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-vendor-android"></i>typcn-vendor-android</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-vendor-apple"></i>typcn-vendor-apple</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-vendor-microsoft"></i>typcn-vendor-microsoft</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-video-outline"></i>typcn-video-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-video"></i>typcn-video</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-volume-down"></i>typcn-volume-down</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-volume-mute"></i>typcn-volume-mute</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-volume-up"></i>typcn-volume-up</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-volume"></i>typcn-volume</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-warning-outline"></i>typcn-warning-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-warning"></i>typcn-warning</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-watch"></i>typcn-watch</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-waves-outline"></i>typcn-waves-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-waves"></i>typcn-waves</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-weather-cloudy"></i>typcn-weather-cloudy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-weather-downpour"></i>typcn-weather-downpour</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-weather-night"></i>typcn-weather-night</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-weather-partly-sunny"></i>typcn-weather-partly-sunny</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-weather-shower"></i>typcn-weather-shower</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-weather-snow"></i>typcn-weather-snow</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-weather-stormy"></i>typcn-weather-stormy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-weather-sunny"></i>typcn-weather-sunny</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-weather-windy-cloudy"></i>typcn-weather-windy-cloudy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-weather-windy"></i>typcn-weather-windy</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-wi-fi-outline"></i>typcn-wi-fi-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-wi-fi"></i>typcn-wi-fi</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-wine"></i>typcn-wine</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-world-outline"></i>typcn-world-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-world"></i>typcn-world</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-zoom-in-outline"></i>typcn-zoom-in-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-zoom-in"></i>typcn-zoom-in</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-zoom-out-outline"></i>typcn-zoom-out-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-zoom-out"></i>typcn-zoom-out</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-zoom-outline"></i>typcn-zoom-outline</div>
                                      <div class="col-lg-4 col-sm-6"><i class="typcn typcn-zoom"></i>typcn-zoom</div>
                                </section>
                        `;

            modal.open({
              title: "Icon Palette",
              content: `${iconForm.outerHTML}`,
            });
          }

          // else if (blockId.startsWith('text-regular-form')) {
          //     console.log('inside text-regular-form');

          //     const allTraits = document.getElementsByClassName('gjs-field-text');
          //     console.log('allTraits:', allTraits);

          // }

          // data-grid block
          // STEP 2
          else if (blockId.startsWith("data-grid")) {
            console.log("inside data-grid");

            console.log("customTablesRef.current:", customTablesRef.current);

            const pagesAndProjectsForm = document.createElement("div");
            pagesAndProjectsForm.setAttribute("class", "pagesAndProjects-form");

            const formTitle = document.createElement("p");
            formTitle.innerHTML += "Project tables:<br>";
            pagesAndProjectsForm.appendChild(formTitle);

            const innerDiv = document.createElement("div");

            customTablesRef.current.forEach((table) => {
              const button = document.createElement("button");
              button.innerHTML += `${table.table_name}`;
              innerDiv.appendChild(button);
            });

            pagesAndProjectsForm.appendChild(innerDiv);

            modal.open({
              title: "Data Form",
              content: `${pagesAndProjectsForm.outerHTML}`,
            });
          }

          // connection-grid block
          else if (blockId.startsWith("connection-grid")) {
            console.log("inside connection-grid");

            const connectionForm = document.createElement("form");
            connectionForm.setAttribute("class", "connection-form");

            // url div
            const urlDiv = document.createElement("div");

            const urlLabel = document.createElement("label");
            urlLabel.setAttribute("for", "urlInput");
            urlLabel.innerHTML = "URL:";
            urlDiv.appendChild(urlLabel);

            const urlInput = document.createElement("input");
            urlInput.setAttribute("type", "url");
            urlInput.setAttribute("id", "urlInput");
            urlInput.setAttribute("name", "urlInput");
            urlInput.setAttribute("size", "80");
            urlDiv.appendChild(urlInput);

            connectionForm.appendChild(urlDiv);

            // method div
            const methodDiv = document.createElement("div");

            const methodLabel = document.createElement("label");
            methodLabel.setAttribute("for", "methodSelectInput");
            methodLabel.innerHTML = "Method:";
            methodDiv.appendChild(methodLabel);

            const methodSelectInput = document.createElement("select");
            methodSelectInput.setAttribute("id", "methodSelectInput");
            methodSelectInput.setAttribute("name", "methodSelectInput");

            const methodOptions = [
              "GET",
              "POST",
              "PUT",
              "PATCH",
              "DELETE",
              "COPY",
              "HEAD",
              "OPTIONS",
              "LINK",
              "UNLINK",
              "PURGE",
              "LOCK",
              "UNLOCK",
              "PROPFIND",
              "VIEW",
            ];
            methodOptions.forEach((action) => {
              let methodOptionInput = document.createElement("option");
              methodOptionInput.setAttribute("value", `${action}`);
              methodOptionInput.innerHTML = `${action}`;

              methodSelectInput.appendChild(methodOptionInput);
            });
            methodDiv.appendChild(methodSelectInput);

            connectionForm.appendChild(methodDiv);

            // body div
            const bodyDiv = document.createElement("div");

            const bodyLabel = document.createElement("label");
            bodyLabel.setAttribute("for", "bodyInput");
            bodyLabel.innerHTML += "Body:";
            bodyDiv.appendChild(bodyLabel);

            const bodyInput = document.createElement("textarea");
            bodyInput.setAttribute("id", "bodyInput");
            bodyInput.setAttribute("name", "bodyInput");
            bodyInput.setAttribute("rows", "5");
            bodyInput.setAttribute("cols", "50");
            bodyDiv.appendChild(bodyInput);

            connectionForm.appendChild(bodyDiv);

            // content-type div
            const contentTypeDiv = document.createElement("div");

            const contentTypeLabel = document.createElement("label");
            contentTypeLabel.setAttribute("for", "contentTypeSelectInput");
            contentTypeLabel.innerHTML = "Content-Type:";
            contentTypeDiv.appendChild(contentTypeLabel);

            const contentTypeSelectInput = document.createElement("select");
            contentTypeSelectInput.setAttribute("id", "contentTypeSelectInput");
            contentTypeSelectInput.setAttribute(
              "name",
              "contentTypeSelectInput"
            );

            // https://stackoverflow.com/questions/23714383/what-are-all-the-possible-values-for-http-content-type-header
            const contentTypeOptions = [
              "application/java-archive",
              "application/EDI-X12",
              "application/EDIFACT",
              "application/javascript",
              "application/octet-stream",
              "application/ogg",
              "application/pdf",
              "application/xhtml+xml",
              "application/x-shockwave-flash",
              "application/json",
              "application/ld+json",
              "application/xml",
              "application/zip",
              "application/x-www-form-urlencoded",
              "text/css",
              "text/csv",
              "text/html",
              "text/plain",
              "text/xml",
              "audio/mpeg",
              "audio/x-ms-wma",
              "audio/vnd.rn-realaudio",
              "audio/x-wav",
              "image/gif",
              "image/jpeg",
              "image/png",
              "image/tiff",
              "image/vnd.microsoft.icon",
              "image/x-icon",
              "image/vnd.djvu",
              "image/svg+xml",
              "video/mpeg",
              "video/mp4",
              "video/quicktime",
              "video/x-ms-wmv",
              "video/x-msvideo",
              "video/x-flv",
              "video/webm",
              "multipart/mixed",
              "multipart/alternative",
              "multipart/form-data",
              "application/vnd.android.package-archive",
              "application/vnd.oasis.opendocument.text",
              "application/vnd.oasis.opendocument.spreadsheet",
              "application/vnd.oasis.opendocument.presentation",
              "application/vnd.oasis.opendocument.graphics",
              "application/vnd.ms-excel",
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              "application/vnd.ms-powerpoint",
              "application/vnd.openxmlformats-officedocument.presentationml.presentation",
              "application/msword",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
              "application/vnd.mozilla.xul+xml",
            ];
            contentTypeOptions.forEach((action) => {
              let contentTypeOptionInput = document.createElement("option");
              contentTypeOptionInput.setAttribute("value", `${action}`);
              contentTypeOptionInput.innerHTML = `${action}`;

              contentTypeSelectInput.appendChild(contentTypeOptionInput);
            });
            contentTypeDiv.appendChild(contentTypeSelectInput);

            connectionForm.appendChild(contentTypeDiv);

            // API-KEY div
            const apiKeyDiv = document.createElement("div");

            const apiKeyLabel = document.createElement("label");
            apiKeyLabel.setAttribute("for", "apiKeyVal");
            apiKeyLabel.innerHTML = "API Key:";
            apiKeyDiv.appendChild(apiKeyLabel);

            const apiKeyVal = document.createElement("input");
            apiKeyVal.setAttribute("type", "text");
            apiKeyVal.setAttribute("id", "apiKeyVal");
            apiKeyVal.setAttribute("name", "apiKeyVal");
            apiKeyVal.setAttribute("size", "80");
            apiKeyDiv.appendChild(apiKeyVal);

            connectionForm.appendChild(apiKeyDiv);

            // auth div
            const authDiv = document.createElement("div");

            const authLabel = document.createElement("label");
            authLabel.setAttribute("for", "authInput");
            authLabel.innerHTML = "Authentication:";
            authDiv.appendChild(authLabel);

            const authUsername = document.createElement("input");
            authUsername.setAttribute("type", "text");
            authUsername.setAttribute("id", "authUsername");
            authUsername.setAttribute("name", "authUsername");
            authUsername.setAttribute("placeholder", "Username");
            authDiv.appendChild(authUsername);

            const authPassword = document.createElement("input");
            authPassword.setAttribute("type", "password");
            authPassword.setAttribute("id", "authPassword");
            authPassword.setAttribute("name", "authPassword");
            authPassword.setAttribute("placeholder", "Password");
            authDiv.appendChild(authPassword);

            connectionForm.appendChild(authDiv);

            // BEARER TOKEN div
            const bearerTokenDiv = document.createElement("div");

            const bearerTokenLabel = document.createElement("label");
            bearerTokenLabel.setAttribute("for", "bearerTokenInput");
            bearerTokenLabel.innerHTML = "Bearer token:";
            bearerTokenDiv.appendChild(bearerTokenLabel);

            const bearerTokenInput = document.createElement("input");
            bearerTokenInput.setAttribute("type", "text");
            bearerTokenInput.setAttribute("id", "bearerTokenInput");
            bearerTokenInput.setAttribute("name", "bearerTokenInput");
            bearerTokenInput.setAttribute("size", "80");
            bearerTokenInput.setAttribute("placeholder", "Bearer");
            bearerTokenDiv.appendChild(bearerTokenInput);

            connectionForm.appendChild(bearerTokenDiv);

            // submit button div
            const submitBtn = document.createElement("button");
            submitBtn.setAttribute("class", "connectionForm-btn");
            submitBtn.innerHTML = "Submit";

            connectionForm.appendChild(submitBtn);

            modal.open({
              title: "Connection Form",
              content: `${connectionForm.outerHTML}`,
            });
          } else if (block.attributes.type === "stellar-button") {
            console.log("stellar-button block:", block);
          }
        } catch (e) {
          // statements
          console.log(e);
          toast.warning(
            `Could not read the component. Please try dragging again.`,
            successTheme
          );
        }
      });

      editor.on("modal:open", (props) => {
        if (
          document.getElementsByClassName("gjs-mdl-content")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("regular-form")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("regular-form")[0]
            .getElementsByClassName("regular-form-btn")[0] !== undefined
        ) {
          const basicFormButton = document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("regular-form")[0]
            .getElementsByClassName("regular-form-btn")[0];
          console.log("BF: ", basicFormButton);
          // basicFormButton.addEventListener('click', () => {
          //     createBasicForm(editor);
          // });
        } else if (
          document.getElementsByClassName("gjs-mdl-content")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("table-btn")[0] !== undefined
        ) {
          const tableButton = document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("table-btn")[0];
          console.log("TB: ", tableButton);
          tableButton.addEventListener("click", () => {
            createTable(editor);
          });
        } else if (
          document.getElementsByClassName("gjs-mdl-content")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("grid-btn")[0] !== undefined
        ) {
          const gridButton = document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("grid-btn")[0];
          console.log("GB: ", gridButton);
          gridButton.addEventListener("click", () => {
            createGrid(editor);
          });
        } else if (
          document.getElementsByClassName("gjs-mdl-content")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("carousel-form")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("carousel-form")[0]
            .getElementsByClassName("carousel-btn")[0] !== undefined
        ) {
          const carouselButton = document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("carousel-form")[0]
            .getElementsByClassName("carousel-btn")[0];
          console.log("CB: ", carouselButton);
          carouselButton.addEventListener("click", () => {
            createCarousel(editor);
          });
        } else if (
          document.getElementsByClassName("gjs-mdl-content")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("carousel-form")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("carousel-form")[0]
            .getElementsByClassName("arr-nav-carousel-btn")[0] !== undefined
        ) {
          const arrNavCarouselButton = document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("carousel-form")[0]
            .getElementsByClassName("arr-nav-carousel-btn")[0];
          console.log("ANCB: ", arrNavCarouselButton);
          arrNavCarouselButton.addEventListener("click", () => {
            createArrNavCarousel(editor);
          });
        } else if (
          document.getElementsByClassName("gjs-mdl-content")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("carousel-form")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("carousel-form")[0]
            .getElementsByClassName("caption-carousel-btn")[0] !== undefined
        ) {
          const captionCarouselButton = document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("carousel-form")[0]
            .getElementsByClassName("caption-carousel-btn")[0];
          console.log("CCB: ", captionCarouselButton);
          captionCarouselButton.addEventListener("click", () => {
            createCaptionCarousel(editor);
          });
        } else if (
          document.getElementsByClassName("gjs-mdl-content")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("accordion-form")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("accordion-form")[0]
            .getElementsByClassName("accordion-btn")[0] !== undefined
        ) {
          const accordionButton = document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("accordion-form")[0]
            .getElementsByClassName("accordion-btn")[0];
          console.log("AB: ", accordionButton);
          accordionButton.addEventListener("click", () => {
            createAccordion(editor);
          });
        } else if (
          document.getElementsByClassName("gjs-mdl-content")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("accordion-form")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("accordion-form")[0]
            .getElementsByClassName("mobBasicAccordionForm-btn")[0] !==
            undefined
        ) {
          const mobBasicAccordionButton = document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("accordion-form")[0]
            .getElementsByClassName("mobBasicAccordionForm-btn")[0];
          console.log("MBAB: ", mobBasicAccordionButton);
          mobBasicAccordionButton.addEventListener("click", () => {
            createMobBasicAccordion(editor);
          });
        } else if (
          document.getElementsByClassName("gjs-mdl-content")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("accordion-form")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("accordion-form")[0]
            .getElementsByClassName("mobInsetXBasicAccordionForm-btn")[0] !==
            undefined
        ) {
          const mobInsetXBasicAccordionButton = document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("accordion-form")[0]
            .getElementsByClassName("mobInsetXBasicAccordionForm-btn")[0];
          console.log("MIXBAB: ", mobInsetXBasicAccordionButton);
          mobInsetXBasicAccordionButton.addEventListener("click", () => {
            createMobInsetXBasicAccordion(editor);
          });
        } else if (
          document.getElementsByClassName("gjs-mdl-content")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("accordion-form")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("accordion-form")[0]
            .getElementsByClassName("mobMultipleAccordionForm-btn")[0] !==
            undefined
        ) {
          const mobMultipleAccordionButton = document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("accordion-form")[0]
            .getElementsByClassName("mobMultipleAccordionForm-btn")[0];
          console.log("MMAB: ", mobMultipleAccordionButton);
          mobMultipleAccordionButton.addEventListener("click", () => {
            createMobMultipleAccordion(editor);
          });
        } else if (
          document.getElementsByClassName("gjs-mdl-content")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("segment-btn-form")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("segment-btn-form")[0]
            .getElementsByClassName("mobSegmentBtnForm-btn")[0] !== undefined
        ) {
          const segmentButton = document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("segment-btn-form")[0]
            .getElementsByClassName("mobSegmentBtnForm-btn")[0];
          console.log("SB: ", segmentButton);
          segmentButton.addEventListener("click", () => {
            createSegmentButton(editor);
          });
        } else if (
          document.getElementsByClassName("gjs-mdl-content")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("pagesAndProjects-form")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("pagesAndProjects-form")[0]
            .getElementsByTagName("button") !== undefined
        ) {
          // for page data grid
          // Step 3
          const getCustomTableButtons = document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("pagesAndProjects-form")[0]
            .getElementsByTagName("button");
          console.log("GCTBs: ", getCustomTableButtons);

          for (let button of getCustomTableButtons) {
            // console.log('button:', button.innerHTML);
            button.addEventListener("click", async () => {
              const projectTable = customTablesRef.current.filter(
                (ele) => ele.table_name === button.innerHTML
              )[0];
              console.log("projectTable clicked:", projectTable);
              const config = {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${userInfo.token}`,
                },
              };
              const table_name = projectTable.table_name;

              const { data } = await axios.get(
                `${API_HOST}customroutes/data_grid/${table_name}`,
                config
              );
              console.log("data---", data);

              if (data.message) {
                toast.info(
                  `This project table is empty.\nPlease try another table, create a new one or provide values to this table.`,
                  infoTheme
                );
                console.log("empty table:", data.message);
              } else {
                console.log("here1111111111111:");
                setTableData(data);
                createProjectTable(editor, data);
                setGridTableName(table_name);
                // editor.getSelected().append({ type: 'dataGrid' })
                toast.success(
                  `This project table has been added\nsuccessfully to the editor.`,
                  successTheme
                );
              }
            });
          }
        } else if (
          document.getElementsByClassName("gjs-mdl-content")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("dynamic-form")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("dynamic-form")[0]
            .getElementsByTagName("button") !== undefined
        ) {
          // for page data grid
          const getCustomTableButtons = document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("dynamic-form")[0]
            .getElementsByTagName("button");
          console.log("GCTBs: ", getCustomTableButtons);

          for (let button of getCustomTableButtons) {
            // console.log('button:', button.innerHTML);

            button.addEventListener("click", async () => {
              const projectTable = customTablesRef.current.filter(
                (ele) => ele.table_name === button.innerHTML
              )[0];

              const config = {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${userInfo.token}`,
                },
              };
              const table_name = projectTable.table_name;

              const { data } = await axios.get(
                `${API_HOST}customroutes/table_data/${table_name}`,
                config
              );

              setFormData(data);
              setTableName(table_name);
              setDynamicFormData(projectTable);
              createFormTable(editor);
              toast.success(
                `This Dynamic Form has been added\nsuccessfully to the editor.`,
                successTheme
              );
            });
          }
        } else if (
          document.getElementsByClassName("gjs-mdl-content")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("icon-form")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("icon-form")[0]
            .getElementsByTagName("div") !== undefined
        ) {
          const icons = document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("icon-form")[0]
            .getElementsByTagName("div");
          console.log("icons...");
          for (var x = 0; x < icons.length; x++) {
            const iCON = icons[x];
            iCON.addEventListener("click", (event) => {
              appendIcon(editor, iCON);
            });
          }
        } else if (
          document.getElementsByClassName("gjs-mdl-content")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("connection-form")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("connection-form")[0]
            .getElementsByClassName("connectionForm-btn") !== undefined
        ) {
          const connectionFormBtn = document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("connection-form")[0]
            .getElementsByClassName("connectionForm-btn")[0];
          console.log("CFB: ", connectionFormBtn);
          connectionFormBtn.addEventListener("click", (event) => {
            event.preventDefault();
            const urlData = storeConnectionForm(editor);
            dynamicApiCall(urlData);
          });
        } else if (
          document.getElementsByClassName("gjs-mdl-content")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("connection-form-add")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("connection-form-add")[0]
            .getElementsByClassName("connectionForm-btn") !== undefined
        ) {
          const connectionFormBtn = document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("connection-form-add")[0]
            .getElementsByClassName("connectionForm-btn")[0];
          console.log("CFB: ", connectionFormBtn);
          connectionFormBtn.addEventListener("click", (event) => {
            event.preventDefault();
            const urlData = storeConnectionForm2(editor);
            dynamicApiCall2(editor, urlData);
          });
        } else if (
          document.getElementsByClassName("gjs-mdl-content")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("patchup-form")[0] !== undefined &&
          document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("patchup-form")[0] !== undefined
        ) {
          let patchupFormOptions = document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("patchup-form")[0]
            .getElementsByClassName("patchup-form-options")[0];
          console.log("patchupFormOptions:", patchupFormOptions);

          let patchupForm = document
            .getElementsByClassName("gjs-mdl-content")[0]
            .getElementsByClassName("patchup-form")[0];
          console.log("patchupForm:", patchupForm);

          patchupFormOptions.addEventListener("change", async (event) => {
            event.preventDefault();
            let selectedServerID = event.target.value;
            console.log("selectedServerID:", event.target.value);

            // making a fetch call to the api
            let response = await fetch(`${API_HOST}user/get_server_poc`);

            let serverData;
            if (response.ok) {
              serverData = await response.json();
              console.log("serverData received ok:", serverData);
            } else {
              console.error("Error receiving serverData:", response.statusText);
            }

            // filtering the server data
            let selectedServer = serverData.filter(
              (x) => x._id == selectedServerID
            );
            console.log("selectedServer:", selectedServer);

            // if there is a time-slot-container already there then remove it first
            if (
              document
                .getElementsByClassName("gjs-mdl-content")[0]
                .getElementsByClassName("patchup-form")[0]
                .getElementsByClassName("time-slot-container")[0]
            ) {
              document
                .getElementsByClassName("gjs-mdl-content")[0]
                .getElementsByClassName("patchup-form")[0]
                .getElementsByClassName("time-slot-container")[0]
                .remove();
            }

            // creating radio buttons for available time slots
            const timeSlotContainer = document.createElement("div");
            timeSlotContainer.setAttribute("class", "time-slot-container");

            selectedServer[0].available_timeslots.forEach((slot) => {
              // getting unique IDs for radio buttons for timeslots
              const uniqueId = uniqid("time-slot-");
              console.log("time-slot option ID for class:", uniqueId);

              // creating timeslot radio buttons
              let slotOption = document.createElement("input");
              slotOption.setAttribute("type", "radio");
              slotOption.setAttribute("id", `${uniqueId}`);
              slotOption.setAttribute("name", "patch-time-slots");
              slotOption.setAttribute("value", `${slot}`);

              timeSlotContainer.appendChild(slotOption);

              // creating <label> for radio button
              let slotOptionLabel = document.createElement("label");
              slotOptionLabel.setAttribute("for", `${uniqueId}`);
              slotOptionLabel.style.marginRight = "5%";
              slotOptionLabel.innerHTML = `${slot}`;

              timeSlotContainer.appendChild(slotOptionLabel);
            });

            patchupForm.appendChild(timeSlotContainer);

            // if there is a time-slot-container already there then remove it first
            if (
              document
                .getElementsByClassName("gjs-mdl-content")[0]
                .getElementsByClassName("patchup-form")[0]
                .getElementsByClassName("patchup-form-btns")[0]
            ) {
              document
                .getElementsByClassName("gjs-mdl-content")[0]
                .getElementsByClassName("patchup-form")[0]
                .getElementsByClassName("patchup-form-btns")[0]
                .remove();
            }

            // submit and cancel buttons
            const formButtons = document.createElement("div");
            formButtons.setAttribute("class", "patchup-form-btns");
            formButtons.style.display = "flex";

            // submit button
            const submitBtn = document.createElement("button");
            submitBtn.setAttribute("type", "submit");
            submitBtn.style.padding = "0.3em";
            submitBtn.style.borderRadius = "10px";
            submitBtn.style.marginRight = "5%";
            submitBtn.innerHTML = "Submit";

            // submit the form values and close the modal on clicking on submit button
            submitBtn.addEventListener("click", (event) => {
              event.preventDefault();

              if (
                document
                  .getElementsByClassName("gjs-mdl-content")[0]
                  .getElementsByClassName("patchup-form")[0]
                  .getElementsByClassName("time-slot-container")[0]
              ) {
                const slotOptions =
                  document.getElementsByName("patch-time-slots");
                const checkedSlot = Array.from(slotOptions).find(
                  (radio) => radio.checked
                );
                const checkedSlotValue = checkedSlot.value;

                // sending the form data to the plugin (by storing them in local storage and deleting them from the access point (plugin))
                console.log(
                  "selectedServer:",
                  selectedServer,
                  "\ncheckedSlotValue:",
                  checkedSlotValue
                );
                localStorage.setItem(
                  "selectedServer",
                  `${JSON.stringify(selectedServer)}`
                );
                localStorage.setItem("checkedSlotValue", `${checkedSlotValue}`);
                console.log("data stored in local storage");
              }

              editor.Modal.close();
            });

            formButtons.appendChild(submitBtn);

            // cancel button
            const cancelBtn = document.createElement("button");
            cancelBtn.style.padding = "0.3em";
            cancelBtn.style.borderRadius = "10px";
            cancelBtn.innerHTML = "Cancel";

            // reset the form and close the modal on clicking on cancel button
            cancelBtn.addEventListener("click", (event) => {
              patchupForm.reset();
              event.preventDefault();
              editor.Modal.close();
            });

            formButtons.appendChild(cancelBtn);

            patchupForm.appendChild(formButtons);
          });
        }
      });

      editorRef.current = editor;
      setEditor(editor);
      // setGJSEditor(editor);

      const script = function (props) {
        const myLibOpts = {
          prop1: props.myprop1,
          prop2: props.myprop2,
        };
        console.log("My lib options: " + JSON.stringify(myLibOpts));

        if (props.Page) {
          document
            .querySelector(`#${this.id}`)
            .addEventListener("click", async () => {
              alert(`hey I'm ${props.Page}`);
            });
        }
      };

      editor.Components.addType("regularform", {
        model: {
          defaults: {
            script,
            // Define default values for your custom properties
            myprop1: "value1",
            myprop2: "10",
            // Define traits, in order to change your properties
            traits: [
              {
                type: "select",
                name: "myprop1",
                changeProp: true,
                options: [
                  { value: "value1", name: "Value 1" },
                  { value: "value2", name: "Value 2" },
                ],
              },
              {
                type: "number",
                name: "myprop2",
                changeProp: true,
              },
            ],
            "script-props": ["myprop1", "myprop2"],
            // Add some style, just to make the component visible
            style: {
              width: "100px",
              height: "100px",
              background: "red",
            },
            components: `
                    <h3>Form subject</h3>
                    <div class="childDiv">
                        <div class="innerDiv">
                            <label for="name">Name:</label>
                            <input type="text" id="name" name="name" placeholder="Type your name, here">
                        </div>

                        <div class="innerDiv">
                            <label for="emailID">Email ID:</label>
                            <input type="email" id="emailID" name="emailID" placeholder="Type your email ID, here">
                        </div>

                        <div class="innerDiv">
                            <label for="pwd">Password:</label>
                            <input type="password" id="pwd" name="pwd" placeholder="Type your password, here">
                        </div>
                    </div>
                    <div class="childDiv">
                        <input type="radio" id="option" name="option" value="option1">
                        <label for="option">option1</label><br>
                        <input type="radio" id="option" name="option" value="option2">
                        <label for="option">option2</label><br>
                        <input type="radio" id="option" name="option" value="option3">
                        <label for="option">option3</label>
                    </div>

                    <div class="childDiv">
                        <input type="checkbox" name="option4" value="option4">
                        <label for="option4">option4</label><br>
                        <input type="checkbox" name="option5" value="option5">
                        <label for="option5">option5</label><br>
                        <input type="checkbox" name="option6" value="option6">
                        <label for="option6">option6</label>
                    </div>

                    <div class="childDiv">
                        <label for="date">Date:</label><br>
                        <input type="date" id="date" name="date">
                    </div>

                    <div class="childDiv">
                        <label for="url">URL:</label><br>
                        <input type="url" id="url" name="url" placeholder="(http)https://www.google.com/">
                    </div>
                    <button type="submit">Submit</button>

                    `,
          },
          //       content: `<div class="el-X">
          //     <div data-gjs-name="Component Y" data-gjs-draggable=".el-X" class="el-Y el-A">Element A</div>
          //     <div data-gjs-name="Component Y" data-gjs-draggable=".el-X" class="el-Y el-B">Element B</div>
          //     <div data-gjs-name="Component Y" data-gjs-draggable=".el-X" class="el-Y el-C">Element C</div>
          //   </div>`
          content: `
                `,
        },
      });

      editor.TraitManager.addType("hrefNext", {
        // eventCapture: [inputSelectScript], // you can use multiple events in the array

        // Expects as return a simple HTML string or an HTML element
        createInput({ trait }) {
          // Here we can decide to use properties from the trait
          const traitOpts = trait.get("options") || [];
          const options = traitOpts.length
            ? traitOpts
            : [
                { id: "url", name: "URL" },
                { id: "email", name: "Email" },
              ];

          // Create a new element container and add some content
          const el = document.createElement("div");
          el.innerHTML = `
                    <select class="href-next__type">
                      ${options
                        .map(
                          (opt) =>
                            `<option value="${opt.id}">${opt.name}</option>`
                        )
                        .join("")}
                    </select>
                    <div class="href-next__url-inputs">
                      <input class="href-next__url" placeholder="Insert URL"/>
                    </div>
                    <div class="href-next__email-inputs">
                      <input class="href-next__email" placeholder="Insert email"/>
                      <input class="href-next__email-subject" placeholder="Insert subject"/>
                    </div>
                  `;

          // Let's make our content interactive
          const inputsUrl = el.querySelector(".href-next__url-inputs");
          const inputsEmail = el.querySelector(".href-next__email-inputs");
          const inputType = el.querySelector(".href-next__type");
          inputType.addEventListener("change", (ev) => {
            switch (ev.target.value) {
              case "url":
                inputsUrl.style.display = "";
                inputsEmail.style.display = "none";
                break;
              case "email":
                inputsUrl.style.display = "none";
                inputsEmail.style.display = "";
                break;
            }
          });

          return el;
        },

        createLabel({ label }) {
          return `<div>
                      <div>Before</div>
                      ${label}
                      <div>After</div>
                    </div>`;
        },

        //             return el;
        //         },

        // templateInput: '',
        // Use a new one, by specifying with `data-input` attribute where to place the input container
        templateInput: `<div class="custom-input-wrapper">
                    Before input
                    <div data-input></div>
                    After input
                </div>`,
        // // It might also be a function, expects an HTML string as the result
        // templateInput({ trait }) {
        //     return '<div ...';
        // },

        //         createLabel({ label }) {
        //             return `<div>
        //       <div>Before</div>
        //       ${label}
        //       <div>After</div>
        //     </div>`;
        //         },

        // Update the component based on element changes
        // `elInput` is the result HTMLElement you get from `createInput`
        onEvent({ elInput, component, event }) {
          const inputType = elInput.querySelector(".href-next__type");
          let href = "";

          switch (inputType.value) {
            case "url":
              const valUrl = elInput.querySelector(".href-next__url").value;
              href = valUrl;
              break;
            case "email":
              const valEmail = elInput.querySelector(".href-next__email").value;
              const valSubj = elInput.querySelector(
                ".href-next__email-subject"
              ).value;
              href = `mailto:${valEmail}${
                valSubj ? `?subject=${valSubj}` : ""
              }`;
              break;
          }
          // inputSelectScript({ href })
          component.addAttributes({ href });
        },

        onValueChange() {
          var traitModel = this.model;
          var selectedComponent = this.target;
          var inputValue = traitModel.get("value");
          //... eg. update attributes
          selectedComponent.set("attributes", { inputValue });
        },

        // Update elements on the component change
        onUpdate({ elInput, component }) {
          const href = component.getAttributes().href || "";
          const inputType = elInput.querySelector(".href-next__type");
          let type = "url";

          if (href.indexOf("mailto:") === 0) {
            const inputEmail = elInput.querySelector(".href-next__email");
            const inputSubject = elInput.querySelector(
              ".href-next__email-subject"
            );
            const mailTo = href.replace("mailto:", "").split("?");
            const email = mailTo[0];
            const params = (mailTo[1] || "").split("&").reduce((acc, item) => {
              const items = item.split("=");
              acc[items[0]] = items[1];
              return acc;
            }, {});
            type = "email";

            inputEmail.value = email || "";
            inputSubject.value = params.subject || "";
          } else {
            elInput.querySelector(".href-next__url").value = href;
          }

          inputType.value = type;
          // inputSelectScript(inputType)
          inputType.dispatchEvent(new CustomEvent("change"));
        },
      });
    }

    initializeEditor();
    setIsEditorLoading(false);

    // return () => {
    //     editor.destroy();
    // };
  };

  useEffect(() => {
    // Form Components:
    if (
      editorRef.current !== null &&
      editorRef.current?.DomComponents !== undefined
    ) {
      // if (editor) {
      console.log("editorRef:::::::::::::::::", editorRef.current);
      const tableInsideProject = customTablesRef.current?.filter(
        (x) => x.project === project_id
      );
      let tableName = tableInsideProject?.map((x) => {
        let arr = {
          name: x.table_name,
        };
        return arr;
      });
      tableName?.push({
        name: "none",
      });

      editorRef.current.DomComponents.addType("dynamicForm", {
        // editor.DomComponents.addType('dynamicForm', {
        model: {
          defaults: {
            components: createDynamicForm(editorRef.current),
            // components: createDynamicForm(editor),
          },
        },
      });

      // editorRef.current.DomComponents.addType("login_universal", {
      //   // editor.DomComponents.addType('login_universal', {
      //   model: {
      //     defaults: {
      //       components: `
      //               <div class="grid grid-cols-5 gap-x-4 items-center h-full">
      //                 <div class="col-span-3">
      //                   <div class="w-full h-full relative">

      //                   <img src="https://images.unsplash.com/photo-1510074377623-8cf13fb86c08?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1172&q=80" class="h-full"/>

      //                   <div class=" z-20 p-8 heroHeadCircle text-white bg-gradient-to-b from-gray-800 via-teal-500 to-teal-800 flex justify-center items-center absolute top-20 right-20 w-2/3 h-2/3 rounded-full" >
      //                   <p class="tracking-wider text-center">
      //                   <strong class="text-lg">Bin Picking</strong> is a robot vision solution that guides your robot to pick and place a wide range of products for various service
      //                   </p>
      //                   </div>

      //                   </div>

      //                 </div>
      //                 <div class="col-span-2">
      //                  <div class="w-full flex justify-end mb-8">
      //                   <p class="w-10 h-10 rounded-full bg-green-500"></p>
      //                  </div>

      //                  <div class="flex space-x-4 items-center justify-start mb-4">

      //                  <div class="flex items-end space-x-2 justify-start">
      //                  <p class="w-6 h-8 bg-blue-500"></p>
      //                  <p class="font-bold text-xl tracking-wider">Fraunhofer</p>
      //                  </div>

      //                  <p class="w-1 h-8 rounded-lg bg-gray-400"></p>

      //                  <div class="relative">
      //                  <p class="w-8 h-8 bg-yellow-400 rounded-full absolute top-0 left-4 " style="z-index:-1"></p>
      //                  <p class="font-bold text-xl tracking-wider" style="z-index:1">Bin Picking</p>
      //                  </div>

      //                  </div>

      //                 <div id="showLogin">
      //                 <p class="text-gray-500 tracking-wider text-md mb-4">Welcome back! Please login to your account.</p>

      //                 <div class="space-y-2 mb-4">
      //                 <label for="username">User Name</label>
      //                 <input id="username" type="text" placeholder="Enter Your Username" class="w-full px-2 py-1 border boder-gray-400 rounded-md text-gray-500 outline-none"/>
      //                 </div>

      //                 <div class="space-y-2 mb-4">
      //                 <label for="password">Password</label>
      //                 <input id="password" type="password" placeholder="Enter Your Password" class="w-full px-2 py-1 border boder-gray-400 rounded-md text-gray-500 outline-none"/>
      //                 </div>
      //                 </div>

      //                 <div id="showSignUp" class="hidden">
      //                 <p class="text-gray-500 tracking-wider text-md mb-4">Please Provide Below Credentials for Registration</p>

      //                 <div class="space-y-2 mb-4">
      //                 <label for="username1">User Name</label>
      //                 <input id="username1" type="text" placeholder="Enter Your Username" class="w-full px-2 py-1 border boder-gray-400 rounded-md text-gray-500 outline-none"/>
      //                 </div>

      //                 <div class="space-y-2 mb-4">
      //                 <label for="email">Email</label>
      //                 <input id="email" type="email" placeholder="Enter Your Email" class="w-full px-2 py-1 border boder-gray-400 rounded-md text-gray-500 outline-none"/>
      //                 </div>

      //                 <div class="space-y-2 mb-4">
      //                 <label for="password1">Password</label>
      //                 <input id="password1" type="password" placeholder="Enter Your Password" class="w-full px-2 py-1 border boder-gray-400 rounded-md text-gray-500 outline-none"/>
      //                 </div>
      //                 </div>

      //                  <div class="flex justify-between items-center ">

      //                    <p id="registerText">Don't Have an Account? <span id="signUpOpen">Register</span></p>
      //                    <p id="loginText" class="hidden">Already Have an Account? <span id="signInOpen">Sign In</span></p>

      //                  <button id="submitButton" class="text-teal-100 bg-teal-500 px-6 py-2 rounded-md hover:text-teal-500 hover:bg-teal-100 transition duration-300 hover:shadow-xl">
      //                  Sign In
      //                  </button>
      //                  <button id="submitButton1" class="text-teal-100 bg-teal-500 px-6 py-2 rounded-md hover:text-teal-500 hover:bg-teal-100 transition duration-300 hover:shadow-xl hidden">
      //                  Register
      //                  </button>

      //                  </div>

      //                 </div>

      //               </div>

      //               <script type="text/javascript">

      //               const usernameInput = document.getElementById('username');
      //               usernameInput.addEventListener('input', () => {
      //                 console.log('Username:', usernameInput.value);
      //               });

      //               const passwordInput = document.getElementById('password');
      //               passwordInput.addEventListener('input', () => {
      //                 console.log('Password:', passwordInput.value);
      //               });

      //               const usernameInput1 = document.getElementById('username1');
      //               usernameInput1.addEventListener('input', () => {
      //                 console.log('Username:', usernameInput1.value);
      //               });

      //               const passwordInput1 = document.getElementById('password1');
      //               passwordInput1.addEventListener('input', () => {
      //                 console.log('Password:', passwordInput1.value);
      //               });

      //               const emailInput = document.getElementById('email');
      //               emailInput.addEventListener('input', () => {
      //                 console.log('Password:', emailInput.value);
      //               });

      //               const registerButton=document.getElementById('signUpOpen');
      //               registerButton.addEventListener('click', () => {
      //                   const loginForm = document.getElementById('showLogin');
      //                   const signUpForm = document.getElementById('showSignUp');
      //                   const registerText = document.getElementById('registerText');
      //                   const loginText = document.getElementById('loginText');
      //                   const signInBtn = document.getElementById('submitButton');
      //                   const signUpBtn = document.getElementById('submitButton1');
      //                   loginForm.style.display='none';
      //                   signUpForm.style.display='block';
      //                   registerText.style.display='none';
      //                   loginText.style.display='block';
      //                   signInBtn.style.display='none';
      //                   signUpBtn.style.display='block';
      //                 });

      //                 const loginBtn=document.getElementById('signInOpen');
      //                 loginBtn.addEventListener('click', () => {
      //                   const loginForm = document.getElementById('showLogin');
      //                   const signUpForm = document.getElementById('showSignUp');
      //                   const registerText = document.getElementById('registerText');
      //                   const loginText = document.getElementById('loginText');
      //                   const signInBtn = document.getElementById('submitButton');
      //                   const signUpBtn = document.getElementById('submitButton1');
      //                   loginForm.style.display='block';
      //                   signUpForm.style.display='none';
      //                   registerText.style.display='block';
      //                   loginText.style.display='none';
      //                   signInBtn.style.display='block';
      //                   signUpBtn.style.display='none';
      //                 });

      //               const signInButton = document.querySelector('#submitButton');
      //               signInButton.addEventListener('click', () => {
      //                 const username = usernameInput.value;
      //                 const password = passwordInput.value;

      //                 if (username.trim() === '' || password.trim() === '') {
      //                   alert('Please enter both username and password');
      //                   return;
      //                 }

      //                 fetch('${API_HOST}customroutes/universal_login/${project_id}', {
      //                   method: 'POST',
      //                   body: JSON.stringify({ username, password }),
      //                   headers: {
      //                     'Content-Type': 'application/json',
      //                   },
      //                 })
      //                   .then((response) => response.json())
      //                   .then((data) => {
      //                     // Handle the API response
      //                      window.location.href="https://unsplash.com/photos/1HplMDoRvTo"

      //                   })
      //                   .catch((error) => {
      //                     // Handle any errors
      //                     console.error(error);
      //                   });
      //               });

      //               const signInButton1 = document.querySelector('#submitButton1');
      //               signInButton1.addEventListener('click', () => {
      //                 const username = usernameInput1.value;
      //                 const password = passwordInput1.value;
      //                 const email = emailInput.value;

      //                 if (username.trim() === '' || password.trim() === '' || email.trim()=== '') {
      //                   alert('Please enter All The Fields');
      //                   return;
      //                 }

      //                 fetch('${API_HOST}customroutes/universal_signUp/${project_id}', {
      //                   method: 'POST',
      //                   body: JSON.stringify( {
      //                       to_insert: {
      //                           username: username,
      //                           password:password,
      //                           email: email,
      //                       }
      //                   }),
      //                   headers: {
      //                     'Content-Type': 'application/json',
      //                   },
      //                 })
      //                   .then((response) => response.text())
      //                   .then((data) => {
      //                     // Handle the API response
      //                     console.log(data);
      //                   })
      //                   .catch((error) => {
      //                     // Handle any errors
      //                     console.error(error);
      //                   });
      //               });
      //             </script>

      //               `,
      //     },
      //   },
      //   view: {
      //     init({ model }) {},
      //     onRender() {},
      //   },
      // });

      // editorRef.current.DomComponents.addType('empty-form-container', {
      // // editor.DomComponents.addType('empty-form-container', {
      //     model: {
      //         defaults: {
      //             tagName: 'form',
      //             attributes: { id: 'empty-form-container' },
      //             styles: `
      //           #empty-form-container {
      //             width: 100%;
      //             height: 50%;
      //             padding: 1em;
      //           }
      //         `,
      //             Functions: "",
      //             traits: [
      //                 {
      //                     type: 'select',
      //                     name: 'Functions',
      //                     label: 'Functions',
      //                     changeProp: true,
      //                     options: functionList && functionList.current !== null ? [
      //                         ...functionList.current.map((x) => ({
      //                             value: x._id,
      //                             name: x.name,
      //                         })),
      //                         { value: 'none', name: 'None' },
      //                     ] : '',
      //                 }
      //             ],
      //             'script-props': ['Functions'],
      //         },
      //     },
      //     view: {
      //         init() {
      //             this.listenTo(this.model, 'change:Functions', this.handleFunctionChange);
      //         },
      //         handleFunctionChange() {
      //             var selectedFunction = this.model.get('Functions');
      //             const components = this.model.components();

      //             let allSelectedVariables = []

      //             let functionToBeExecuted = functionList.current.find((a) => a._id === selectedFunction);
      //             console.log('components FORM', components)

      //             if (functionToBeExecuted) {
      //                 components.forEach((component) => {
      //                     console.log('inside COMP', component)
      //                     if (component.attributes.attributes.id !== 'submit-regular' && component.attributes.TempVar && component.attributes.TempVar !== 'none') {
      //                         let findTempVarName = tempVarList.current.find((a) => a._id === component.attributes.TempVar);
      //                         let userInputValue = component.view.$el.find('input').val()
      //                         if (findTempVarName && userInputValue) {
      //                             let renderedName = {
      //                                 name: findTempVarName.name,
      //                                 value: userInputValue
      //                             };
      //                             return allSelectedVariables.push(renderedName);
      //                         }
      //                     }

      //                     if (component.attributes.attributes.id === 'submit-regular') {
      //                         component.view.$el.on('click', function () {

      //                             console.log('allSelectedVariables', allSelectedVariables);
      //                             console.log('functionToBeExecuted', functionToBeExecuted);

      //                         });
      //                     }
      //                 });
      //             }

      //         },
      //     },
      // });

      // editorRef.current.DomComponents.addType('submit-regular-form', {
      // // editor.DomComponents.addType('submit-regular-form', {
      //     model: {
      //         defaults: {
      //             tagName: 'div',
      //             attributes: { id: 'submit-regular' },

      //             styles: `
      //                 #submit-regular {
      //                     display: flex;
      //                     column-gap: 0.5em;
      //                     align-items: center;
      //                 }
      //             `,

      //             components: [{
      //                 type: 'text',
      //                 content: `<input type="submit" contenteditable="true">`,
      //             }],

      //             // traits
      //             TempVar: "",

      //             traits: [
      //                 {
      //                     type: 'select',
      //                     name: 'TempVar',
      //                     label: 'TempVar',
      //                     changeProp: true,
      //                     options: tempVarList && tempVarList.current !== null ? [
      //                         ...tempVarList.current.map((x) => ({
      //                             value: x._id,
      //                             name: x.name,
      //                         })),
      //                         { value: 'none', name: 'None' },
      //                     ] : '',
      //                 }
      //             ],

      //             'script-props': ['TempVar'],
      //         },
      //     },

      //     view: {
      //         events: {
      //             click: function (event) {
      //                 var selectedFunction = this.model.get('TempVar');
      //                 console.log("selectedFunction", selectedFunction);

      //             }
      //         },
      //     },
      // });

      // editorRef.current.DomComponents.addType('label-regular-form', {
      // // editor.DomComponents.addType('label-regular-form', {
      //     model: {
      //         defaults: {
      //             tagName: 'label',
      //             attributes: { id: 'label-regular' },
      //             styles: `
      //           #label-regular {
      //             width: 100%;
      //             padding: 0.5em;
      //             display: block;
      //           }
      //         `,
      //             components:
      //             {
      //                 type: 'text',
      //                 content: 'Label for this input:',
      //                 attributes: {
      //                     contenteditable: true, // Make the content editable
      //                 },
      //             },
      //             TempVar: "",
      //             traits: [
      //                 {
      //                     type: 'select',
      //                     name: 'TempVar',
      //                     label: 'TempVar',
      //                     changeProp: true,
      //                     options: tempVarList && tempVarList.current !== null ? [
      //                         ...tempVarList.current.map((x) => ({
      //                             value: x._id,
      //                             name: x.name,
      //                         })),
      //                         { value: 'none', name: 'None' },
      //                     ] : '',
      //                 },
      //             ],
      //             'script-props': ['TempVar'],
      //         },

      //     },
      //     view: {
      //         events: {
      //             click: function (event) {
      //                 var selectedFunction = this.model.get('TempVar');
      //                 console.log('selectedFunction', selectedFunction);
      //             }
      //         },
      //     },
      // });

      // editorRef.current.DomComponents.addType('text-regular-form', {
      // // editor.DomComponents.addType('text-regular-form', {
      //     model: {
      //         defaults: {
      //             // script: ,
      //             tagName: 'div',
      //             attributes: { id: 'text-regular' },

      //             styles: `
      //                 #text-regular {
      //                     display: flex;
      //                     flex-direction: column;
      //                     row-gap: 0.5em;
      //                     width:100%
      //                 }
      //             `,

      //             components: [
      //                 {
      //                     type: 'text',
      //                     content: `<label for="text" contenteditable="true">Name:</label>
      //                             <input type="text" id="text" name="text" placeholder="Type your name, here" contenteditable="true">`,
      //                 },
      //             ],

      //             // traits
      //             TempVar: "",

      //             traits: [
      //                 {
      //                     type: 'select',
      //                     name: 'TempVar',
      //                     label: 'TempVar',
      //                     changeProp: true,
      //                     options: tempVarList && tempVarList.current !== null ? [
      //                         ...tempVarList.current.map((x) => ({
      //                             value: x._id,
      //                             name: x.name,
      //                         })),
      //                         { value: 'none', name: 'None' },
      //                     ] : '',
      //                 }
      //             ],

      //             'script-props': ['TempVar'],
      //         },
      //     },
      //     view: {
      //         events: {
      //             click: function (event) {
      //                 var selectedFunction = this.model.get('TempVar');
      //                 console.log('selectedFunction', selectedFunction);
      //             }
      //         },
      //     },

      // });

      // editorRef.current.DomComponents.addType('email-regular-form', {
      // // editor.DomComponents.addType('email-regular-form', {
      //     model: {
      //         defaults: {
      //             // script: ,
      //             tagName: 'div',
      //             attributes: { id: 'email-regular' },

      //             styles: `
      //                 #email-regular {
      //                     display: flex;
      //                     flex-direction: column;
      //                     row-gap: 0.5em;
      //                     width:100%
      //                 }
      //             `,

      //             components: [
      //                 {
      //                     type: 'text',
      //                     content: `<label for="email" style="margin-right: 0.5em;" contenteditable="true">Enter your email:</label>
      //                     <input type="email" id="email" name="email" placeholder="Type your email, here" contenteditable="true">`,
      //                 }
      //             ],

      //             // traits
      //             TempVar: "",

      //             traits: [
      //                 {
      //                     type: 'select',
      //                     name: 'TempVar',
      //                     label: 'TempVar',
      //                     changeProp: true,
      //                     options: tempVarList && tempVarList.current !== null ? [
      //                         ...tempVarList.current.map((x) => ({
      //                             value: x._id,
      //                             name: x.name,
      //                         })),
      //                         { value: 'none', name: 'None' },
      //                     ] : '',
      //                 }
      //             ],

      //             'script-props': ['TempVar'],
      //         },
      //     },

      //     view: {
      //         events: {
      //             click: function (event) {
      //                 var selectedFunction = this.model.get('TempVar');
      //                 console.log("selectedFunction", selectedFunction);

      //             }
      //         },
      //     },
      // });

      // editorRef.current.DomComponents.addType('pwd-regular-form', {
      // // editor.DomComponents.addType('pwd-regular-form', {
      //     model: {
      //         defaults: {
      //             // script: ,
      //             tagName: 'div',
      //             attributes: { id: 'pwd-regular' },

      //             styles: `
      //                 #pwd-regular {
      //                     display: flex;
      //                     flex-direction: column;
      //                     row-gap: 0.5em;
      //                     width:100%
      //                 }
      //             `,

      //             components: [{
      //                 type: "text",
      //                 content: ` <label for="password" contenteditable="true">Password:</label>
      //                 <input type="password" id="password" name="password" contenteditable="true">`,
      //             }],

      //             // traits
      //             TempVar: "",

      //             traits: [
      //                 {
      //                     type: 'select',
      //                     name: 'TempVar',
      //                     label: 'TempVar',
      //                     changeProp: true,
      //                     options: tempVarList && tempVarList.current !== null ? [
      //                         ...tempVarList.current.map((x) => ({
      //                             value: x._id,
      //                             name: x.name,
      //                         })),
      //                         { value: 'none', name: 'None' },
      //                     ] : '',
      //                 }
      //             ],

      //             'script-props': ['TempVar'],
      //         },
      //     },

      //     view: {
      //         events: {
      //             click: function (event) {
      //                 var selectedFunction = this.model.get('TempVar');
      //                 console.log("selectedFunction", selectedFunction);

      //             }
      //         },
      //     },
      // });

      // editorRef.current.DomComponents.addType('tele-regular-form', {
      // // editor.DomComponents.addType('tele-regular-form', {
      //     model: {
      //         defaults: {
      //             // script:
      //             tagName: 'div',
      //             attributes: { id: 'tele-regular' },

      //             styles: `
      //                 #tele-regular {
      //                     display: flex;
      //                     flex-direction: column;
      //                     row-gap: 0.5em;
      //                     width:100%
      //                 }
      //             `,

      //             components: [
      //                 {
      //                     type: 'text',
      //                     content: `  <label for="phone" style="margin-right: 0.5em;" contenteditable="true">Enter your phone number:</label>
      //                     <input type="tel" id="phone" name="phone" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" contenteditable="true">
      //                     <small>Format: +091-012-345-6789</small>`,
      //                 }
      //             ],

      //             // traits
      //             TempVar: "",

      //             traits: [
      //                 {
      //                     type: 'select',
      //                     name: 'TempVar',
      //                     label: 'TempVar',
      //                     changeProp: true,
      //                     options: tempVarList && tempVarList.current !== null ? [
      //                         ...tempVarList.current.map((x) => ({
      //                             value: x._id,
      //                             name: x.name,
      //                         })),
      //                         { value: 'none', name: 'None' },
      //                     ] : '',
      //                 }
      //             ],

      //             'script-props': ['TempVar'],
      //         },
      //     },

      //     view: {
      //         events: {
      //             click: function (event) {
      //                 var selectedFunction = this.model.get('TempVar');
      //                 console.log("selectedFunction", selectedFunction);

      //             }
      //         },
      //     },
      // });

      // editorRef.current.DomComponents.addType('url-regular-form', {
      // // editor.DomComponents.addType('url-regular-form', {
      //     model: {
      //         defaults: {
      //             // script: ,
      //             tagName: 'div',
      //             attributes: { id: 'url-regular' },

      //             styles: `
      //                 #url-regular {
      //                     display: flex;
      //                     flex-direction: column;
      //                     row-gap: 0.5em;
      //                     width:100%
      //                 }
      //             `,

      //             components: [{
      //                 type: 'text',
      //                 content: `   <label contenteditable="true" for="url" style="margin-right: 0.5em;">Enter a URL:</label>
      //                 <input contenteditable="true" type="url" id="url" name="url" placeholder="(http)https://www.google.com/" pattern="^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$">`,
      //             }],

      //             // traits
      //             TempVar: "",

      //             traits: [
      //                 {
      //                     type: 'select',
      //                     name: 'TempVar',
      //                     label: 'TempVar',
      //                     changeProp: true,
      //                     options: tempVarList && tempVarList.current !== null ? [
      //                         ...tempVarList.current.map((x) => ({
      //                             value: x._id,
      //                             name: x.name,
      //                         })),
      //                         { value: 'none', name: 'None' },
      //                     ] : '',
      //                 }
      //             ],

      //             'script-props': ['TempVar'],
      //         },
      //     },

      //     view: {
      //         events: {
      //             click: function (event) {
      //                 var selectedFunction = this.model.get('TempVar');
      //                 console.log("selectedFunction", selectedFunction);

      //             }
      //         },
      //     },
      // });

      // editorRef.current.DomComponents.addType('radio-regular-form', {
      // // editor.DomComponents.addType('radio-regular-form', {
      //     model: {
      //         defaults: {
      //             tagName: 'div',
      //             attributes: { id: 'radio-regular' },

      //             styles: `
      //                 #radio-regular {
      //                     display: flex;
      //                      column-gap: 0.5em;
      //                 }
      //             `,

      //             components: [{
      //                 type: "text",
      //                 content: `    <div>
      //                 <input contenteditable="true" type="radio" id="option" name="option" value="option1" style="margin-right: 0.1em;">
      //                 <label contenteditable="true" for="option">option1</label>
      //                 <input contenteditable="true" type="radio" id="option" name="option" value="option2" style="margin-right: 0.1em;">
      //                 <label contenteditable="true" for="option">option2</label>
      //             </div>`,
      //             }],

      //             // traits
      //             TempVar: "",

      //             traits: [
      //                 {
      //                     type: 'select',
      //                     name: 'TempVar',
      //                     label: 'TempVar',
      //                     changeProp: true,
      //                     options: tempVarList && tempVarList.current !== null ? [
      //                         ...tempVarList.current.map((x) => ({
      //                             value: x._id,
      //                             name: x.name,
      //                         })),
      //                         { value: 'none', name: 'None' },
      //                     ] : '',
      //                 }
      //             ],

      //             'script-props': ['TempVar'],
      //         },
      //     },

      //     view: {
      //         events: {
      //             click: function (event) {
      //                 var selectedFunction = this.model.get('TempVar');
      //                 console.log("selectedFunction", selectedFunction);

      //             }
      //         },
      //     },
      // });

      // editorRef.current.DomComponents.addType('colorPalette-regular-form', {
      // // editor.DomComponents.addType('colorPalette-regular-form', {
      //     model: {
      //         defaults: {

      //             tagName: 'div',
      //             attributes: { id: 'colorPalette-regular-form' },

      //             styles: `
      //                 #colorPalette-regular-form {
      //                     display: flex;
      //                     column-gap: 0.5em;
      //                     align-items: center;
      //                 }
      //             `,

      //             components: [{
      //                 type: 'text',
      //                 content: `     <label contenteditable="true" for="color">Select a color:</label>
      //                 <input type="color" id="color" name="color" value="#ff0000" contenteditable="true">`,
      //             }],

      //             // traits
      //             TempVar: "",

      //             traits: [
      //                 {
      //                     type: 'select',
      //                     name: 'TempVar',
      //                     label: 'TempVar',
      //                     changeProp: true,
      //                     options: tempVarList && tempVarList.current !== null ? [
      //                         ...tempVarList.current.map((x) => ({
      //                             value: x._id,
      //                             name: x.name,
      //                         })),
      //                         { value: 'none', name: 'None' },
      //                     ] : '',
      //                 }
      //             ],

      //             'script-props': ['TempVar'],
      //         },
      //     },

      //     view: {
      //         events: {
      //             click: function (event) {
      //                 var selectedFunction = this.model.get('TempVar');
      //                 console.log("selectedFunction", selectedFunction);

      //             }
      //         },
      //     },
      // });

      // editorRef.current.DomComponents.addType('week-regular-form', {
      // // editor.DomComponents.addType('week-regular-form', {
      //     model: {
      //         defaults: {
      //             tagName: 'div',
      //             attributes: { id: 'week-regular' },

      //             styles: `
      //                 #week-regular {
      //                     display: flex;
      //                     column-gap: 0.5em;
      //                     align-items: center;
      //                 }
      //             `,

      //             components: [{
      //                 type: 'text',
      //                 content: `<label contenteditable="true" for="week" style="margin-right: 0.5em;">Select a week:</label>
      //                 <input type="week" id="week" name="week" contenteditable="true">`,
      //             }],

      //             // traits
      //             TempVar: "",

      //             traits: [
      //                 {
      //                     type: 'select',
      //                     name: 'TempVar',
      //                     label: 'TempVar',
      //                     changeProp: true,
      //                     options: tempVarList && tempVarList.current !== null ? [
      //                         ...tempVarList.current.map((x) => ({
      //                             value: x._id,
      //                             name: x.name,
      //                         })),
      //                         { value: 'none', name: 'None' },
      //                     ] : '',
      //                 }
      //             ],

      //             'script-props': ['TempVar'],
      //         },
      //     },

      //     view: {
      //         events: {
      //             click: function (event) {
      //                 var selectedFunction = this.model.get('TempVar');
      //                 console.log("selectedFunction", selectedFunction);

      //             }
      //         },
      //     },
      // });

      // editorRef.current.DomComponents.addType('monthYear-regular-form', {
      // // editor.DomComponents.addType('monthYear-regular-form', {
      //     model: {
      //         defaults: {
      //             tagName: 'div',
      //             attributes: { id: 'monthYear-regular' },

      //             styles: `
      //                 #monthYear-regular {
      //                     display: flex;
      //                     column-gap: 0.5em;
      //                     align-items: center;
      //                 }
      //             `,

      //             components: [{
      //                 type: 'text',
      //                 content: `  <label contenteditable="true" for="month" style="margin-right: 0.5em;">Month & Year:</label>
      //                 <input type="month" id="month" name="month" contenteditable="true">`,
      //             }],

      //             // traits
      //             TempVar: "",

      //             traits: [
      //                 {
      //                     type: 'select',
      //                     name: 'TempVar',
      //                     label: 'TempVar',
      //                     changeProp: true,
      //                     options: tempVarList && tempVarList.current !== null ? [
      //                         ...tempVarList.current.map((x) => ({
      //                             value: x._id,
      //                             name: x.name,
      //                         })),
      //                         { value: 'none', name: 'None' },
      //                     ] : '',
      //                 }
      //             ],

      //             'script-props': ['TempVar'],
      //         },
      //     },

      //     view: {
      //         events: {
      //             click: function (event) {
      //                 var selectedFunction = this.model.get('TempVar');
      //                 console.log("selectedFunction", selectedFunction);

      //             }
      //         },
      //     },
      // });

      // editorRef.current.DomComponents.addType('time-regular-form', {
      // // editor.DomComponents.addType('time-regular-form', {
      //     model: {
      //         defaults: {
      //             tagName: 'div',
      //             attributes: { id: 'time-regular' },

      //             styles: `
      //                 #time-regular {
      //                     display: flex;
      //                     column-gap: 0.5em;
      //                     align-items: center;
      //                 }
      //             `,

      //             components: [{
      //                 type: "text",
      //                 content: ` <label contenteditable="true" for="appt" style="margin-right: 0.5em;">Select a time:</label>
      //                 <input type="time" id="appt" name="appt" contenteditable="true">`,
      //             }],

      //             // traits
      //             TempVar: "",

      //             traits: [
      //                 {
      //                     type: 'select',
      //                     name: 'TempVar',
      //                     label: 'TempVar',
      //                     changeProp: true,
      //                     options: tempVarList && tempVarList.current !== null ? [
      //                         ...tempVarList.current.map((x) => ({
      //                             value: x._id,
      //                             name: x.name,
      //                         })),
      //                         { value: 'none', name: 'None' },
      //                     ] : '',
      //                 }
      //             ],

      //             'script-props': ['TempVar'],
      //         },
      //     },

      //     view: {
      //         events: {
      //             click: function (event) {
      //                 var selectedFunction = this.model.get('TempVar');
      //                 console.log("selectedFunction", selectedFunction);

      //             }
      //         },
      //     },
      // });

      // editorRef.current.DomComponents.addType('file-regular-form', {
      // // editor.DomComponents.addType('file-regular-form', {
      //     model: {
      //         defaults: {
      //             tagName: 'div',
      //             attributes: { id: 'file-regular' },

      //             styles: `
      //                 #file-regular {
      //                     display: flex;
      //                     column-gap: 0.5em;
      //                     align-items: center;
      //                 }
      //             `,

      //             components: [{
      //                 type: 'text',
      //                 content: ` <label contenteditable="true" for="myfile" style="margin-right: 0.5em;">Select a file:</label>
      //                 <input type="file" id="myfile" name="myfile" contenteditable="true">`,
      //             }],

      //             // traits
      //             TempVar: "",

      //             traits: [
      //                 {
      //                     type: 'select',
      //                     name: 'TempVar',
      //                     label: 'TempVar',
      //                     changeProp: true,
      //                     options: tempVarList && tempVarList.current !== null ? [
      //                         ...tempVarList.current.map((x) => ({
      //                             value: x._id,
      //                             name: x.name,
      //                         })),
      //                         { value: 'none', name: 'None' },
      //                     ] : '',
      //                 }
      //             ],

      //             'script-props': ['TempVar'],
      //         },
      //     },

      //     view: {
      //         events: {
      //             click: function (event) {
      //                 var selectedFunction = this.model.get('TempVar');
      //                 console.log("selectedFunction", selectedFunction);

      //             }
      //         },
      //     },
      // });

      // editorRef.current.DomComponents.addType('upload-file', {
      // // editor.DomComponents.addType('upload-file', {
      //     model: {
      //         defaults: {
      //             tagName: 'div',
      //             attributes: { id: 'upload' },

      //             styles: `
      //                 #upload {
      //                     min-width: 100%;
      //                      min-height: 5px;
      //                      padding: 0.5em;
      //                 }
      //             `,

      //             // traits
      //             TempVar: "",

      //             traits: [
      //                 {
      //                     type: 'select',
      //                     name: 'TempVar',
      //                     label: 'TempVar',
      //                     changeProp: true,
      //                     options: tempVarList && tempVarList.current !== null ? [
      //                         ...tempVarList.current.map((x) => ({
      //                             value: x._id,
      //                             name: x.name,
      //                         })),
      //                         { value: 'none', name: 'None' },
      //                     ] : '',
      //                 }
      //             ],

      //             'script-props': ['TempVar'],
      //         },
      //     },

      //     view: {
      //         events: {
      //             click: function (event) {
      //                 var selectedFunction = this.model.get('TempVar');
      //                 console.log("selectedFunction", selectedFunction);

      //             }
      //         },
      //     },
      // });

      // editorRef.current.DomComponents.addType('number-regular-form', {
      // // editor.DomComponents.addType('number-regular-form', {
      //     model: {
      //         defaults: {
      //             tagName: 'div',
      //             attributes: { id: 'number-regular' },

      //             styles: `
      //                 #number-regular {
      //                     display: flex;
      //                     column-gap: 0.5em;
      //                     align-items: center;
      //                 }
      //             `,

      //             components: [{
      //                 type: 'text',
      //                 content: `<label contenteditable="true" for="number" style="margin-right: 0.5em;">Quantity (between 1 and 5):</label>
      //                 <input type="number" id="number" name="number" placeholder="4.3" contenteditable="true">`,
      //             }],

      //             // traits
      //             TempVar: "",

      //             traits: [
      //                 {
      //                     type: 'select',
      //                     name: 'TempVar',
      //                     label: 'TempVar',
      //                     changeProp: true,
      //                     options: tempVarList && tempVarList.current !== null ? [
      //                         ...tempVarList.current.map((x) => ({
      //                             value: x._id,
      //                             name: x.name,
      //                         })),
      //                         { value: 'none', name: 'None' },
      //                     ] : '',
      //                 }
      //             ],

      //             'script-props': ['TempVar'],
      //         },
      //     },

      //     view: {
      //         events: {
      //             click: function (event) {
      //                 var selectedFunction = this.model.get('TempVar');
      //                 console.log("selectedFunction", selectedFunction);

      //             }
      //         },
      //     },
      // });

      // editorRef.current.DomComponents.addType('range-regular-form', {
      // // editor.DomComponents.addType('range-regular-form', {
      //     model: {
      //         defaults: {
      //             tagName: 'div',
      //             attributes: { id: 'range-regular' },

      //             styles: `
      //                 #range-regular {
      //                     display: flex;
      //                     column-gap: 0.5em;
      //                     align-items: center;
      //                 }
      //             `,

      //             components: [{
      //                 type: 'text',
      //                 content: `<label contenteditable="true" for="points" style="margin-right: 0.5em;">Points (between 0 and 10):</label>
      //                 <input type="range" id="points" name="points" min="0" max="10" contenteditable="true">`,

      //             }],

      //             // traits
      //             TempVar: "",

      //             traits: [
      //                 {
      //                     type: 'select',
      //                     name: 'TempVar',
      //                     label: 'TempVar',
      //                     changeProp: true,
      //                     options: tempVarList && tempVarList.current !== null ? [
      //                         ...tempVarList.current.map((x) => ({
      //                             value: x._id,
      //                             name: x.name,
      //                         })),
      //                         { value: 'none', name: 'None' },
      //                     ] : '',
      //                 }
      //             ],

      //             'script-props': ['TempVar'],
      //         },
      //     },

      //     view: {
      //         events: {
      //             click: function (event) {
      //                 var selectedFunction = this.model.get('TempVar');
      //                 console.log("selectedFunction", selectedFunction);

      //             }
      //         },
      //     },
      // });

      // editorRef.current.DomComponents.addType('reset-regular-form', {
      // // editor.DomComponents.addType('reset-regular-form', {
      //     model: {
      //         defaults: {
      //             tagName: 'div',
      //             attributes: { id: 'reset-regular' },

      //             styles: `
      //                 #reset-regular {
      //                     display: flex;
      //                     column-gap: 0.5em;
      //                     align-items: center;
      //                 }
      //             `,

      //             components: [{
      //                 type: 'text',
      //                 content: `<input type="reset" contenteditable="true">`,
      //             }],

      //             // traits
      //             TempVar: "",

      //             traits: [
      //                 {
      //                     type: 'select',
      //                     name: 'TempVar',
      //                     label: 'TempVar',
      //                     changeProp: true,
      //                     options: tempVarList && tempVarList.current !== null ? [
      //                         ...tempVarList.current.map((x) => ({
      //                             value: x._id,
      //                             name: x.name,
      //                         })),
      //                         { value: 'none', name: 'None' },
      //                     ] : '',
      //                 }
      //             ],

      //             'script-props': ['TempVar'],
      //         },
      //     },

      //     view: {
      //         events: {
      //             click: function (event) {
      //                 var selectedFunction = this.model.get('TempVar');
      //                 console.log("selectedFunction", selectedFunction);
      //             }
      //         },
      //     },
      // });
    }
  }, [formData]);

  useEffect(() => {
    if (!pageName) {
      let pageNameObj = pageByProjectData.find((x) => x._id === pageId);
      if (pageNameObj) {
        setPageName(pageNameObj.name);
      }
    }
  }, [pageId]);

  // FOR ESTABLISHING CONNECTION BETWEEN LEFT AND RIGHT SIDEBARS:
  useEffect(() => {
    if (editorRef.current) {
      // if (editor) {
      const bm = editorRef.current.Blocks;

      // If statement added to resolve the issues in commit d5ad599
      if (bm != undefined) {
        const all = bm.getAll();
        let filter = all;

        if (userSelectedActionFromLeftBar) {
          filter = all.filter((block) => {
            if (
              block.get("category").id.toLowerCase() ===
              userSelectedActionFromLeftBar.toLowerCase()
            ) {
              return block;
            }
          });
        } else {
          filter = all.filter(() => true);
        }

        bm.render(filter);
      }
    }
  }, [userSelectedActionFromLeftBar]);

  const trackStyles = {
    backgroundColor: "#eff6ff", // Change to your desired color
    width: "6px", // Change the width of the track
    borderRadius: "4px", // Adjust the border radius as needed
    display: hoverStart ? "block" : "none",
  };

  const thumbStyles = {
    backgroundColor: "#bfdbfe",
    width: "6px",
    borderRadius: "4px",
    display: hoverStart ? "block" : "none",
  };

  const rightScrollTrackStyles = {
    left: 0,
    right: "unset",
    backgroundColor: "#eff6ff",
    width: "6px",
    borderRadius: "4px",
  };

  const rightScrollThumbStyles = {
    left: 0,
    right: "unset",
    backgroundColor: "#eff6ff",
    width: "6px",
    borderRadius: "4px",
  };

  const hoverSidebarHandler = () => {
    if (!pinSidebar) {
      setHoverStart(true);
    }
  };

  const hoverExistHandler = () => {
    if (!pinSidebar) {
      setHoverStart(false);
    }
  };

  const handleSwitchChange = (event) => {
    // console.log("event.target.checked", event.target.checked);
    setPinSideBar(event.target.checked);
    setHoverStart(event.target.checked);
  };

  useEffect(() => {
    const parentContainer = document.getElementById("mainWrapperNew");

    parentContainer.scrollTop += 20;

    window.addEventListener("resize", () => {
      // console.log("parentContainer", parentContainer);
      parentContainer.scrollTop += 20;
    });
  }, [hoverStart]);

  const logOutHandler = () => {
    localStorage.removeItem("userInfo");
    navigate("/login");
  };

  return (
    <div>
      <Grid
        id="toolbarHead"
        container
        xs={12}
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          height: "5rem",
          pr: 5,
          position: "fixed",
          top: "0",
          bgcolor: "white",
          paddingLeft: "1.5vw",
          paddingRight: "1.5vw",
        }}
      >
        <Grid
          item
          xs={2}
          sx={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          <KeyboardBackspaceIcon
            onClick={() => navigate(-1)}
            sx={{
              mt: 2,
              color: "gray",
              cursor: "pointer",
              "&:hover": { color: "orange" },
            }}
          />
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              style={{ scale: "90%" }}
              alt="logo image"
              src="/templates/images/redSlingLogo.png"
            />
            <Typography
              sx={{
                color: "red",
                fontSize: "12px",
                fontWeiaght: 400,
                transform: "translateY(-16px)",
              }}
            >
              {pageName.toUpperCase()}
            </Typography>
          </Grid>
          <FormControlLabel
            sx={{ mt: 2, scale: "80%" }}
            control={
              <Switch checked={pinSidebar} onChange={handleSwitchChange} />
            }
          />
        </Grid>

        <Grid
          xs={10}
          sx={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              marginRight: "1rem",
            }}
          >
            {/*<div className="panel__devices"></div>*/}

            <Box
              sx={{
                width: "max-content",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "flex-end",
                marginRight: "5%",
              }}
            >
              {/* disable the button when editor is loading so that the user cannot change screens during editor initialization as it will give errors otherwise */}
              {!disableScreensBtn && (
                <Button
                  id="basic-button"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={(event) => setAnchorEl(event.currentTarget)}
                  sx={{ padding: "0", alignSelf: "flex-end" }}
                >
                  Screens
                </Button>
              )}

              {disableScreensBtn && (
                <Button
                  disabled
                  id="basic-button"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={(event) => setAnchorEl(event.currentTarget)}
                  sx={{ padding: "0", alignSelf: "flex-end" }}
                >
                  Screens
                </Button>
              )}

              <p
                style={{
                  fontSize: "0.7vw",
                  lineHeight: "0.9",
                  textAlign: "right",
                }}
              >
                {activeEditorScreen}
              </p>

              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip title="Default Browser Dimensions" arrow>
                    <LaptopMacIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() => resizeEditor(editor, "Desktop")}
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      Default
                    </Button>
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip title="Laptop - w:1024px, h:100%" arrow>
                    <LaptopMacIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() => resizeEditor(editor, "Laptop1024px")}
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      Laptop - 1024px
                    </Button>
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip title="MacBook Air - w:1280px, h:100%" arrow>
                    <LaptopMacIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() => resizeEditor(editor, "MacBookAir")}
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      MacBook Air - 1280px
                    </Button>
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip title="Laptop - w:1440px, h:100%" arrow>
                    <LaptopMacIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() => resizeEditor(editor, "Laptop1440px")}
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      Laptop - 1440px
                    </Button>
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip title="MacBook Pro 14 - w:1512px, h:100%" arrow>
                    <LaptopMacIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() => resizeEditor(editor, "MacBookPro14")}
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      MacBook Pro 14 - 1512px
                    </Button>
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip title="MacBook Pro 16 - w:1728px, h:100%" arrow>
                    <LaptopMacIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() => resizeEditor(editor, "MacBookPro16")}
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      MacBook Pro 16 - 1728px
                    </Button>
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip title="Desktop - w:2560px, h:100%" arrow>
                    <LaptopMacIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() => resizeEditor(editor, "Desktop2560px")}
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      Desktop - 2560px
                    </Button>
                  </Tooltip>
                </MenuItem>

                <Divider />

                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip title="Mobile - w:480px, h:100%" arrow>
                    <PhoneAndroidIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() => resizeEditor(editor, "Mobile")}
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      Mobile - 480px
                    </Button>
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip title="Android - w:360px, h:100%" arrow>
                    <PhoneAndroidIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() => resizeEditor(editor, "Android")}
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      Android - 360px
                    </Button>
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip title="iPhone SE - w:375px, h:667px" arrow>
                    <PhoneAndroidIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() => resizeEditor(editor, "iPhoneSE")}
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      iPhone SE - 375px, 667px
                    </Button>
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip title="iPhone XR - w:414px, h:896px" arrow>
                    <PhoneAndroidIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() => resizeEditor(editor, "iPhoneXR")}
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      iPhone XR - 414px, 896px
                    </Button>
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip title="iPhone 12 Pro - w:390px, h:844px" arrow>
                    <PhoneAndroidIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() => resizeEditor(editor, "iPhone12Pro")}
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      iPhone 12 Pro - 390px, 844px
                    </Button>
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip title="iPhone 13 Mini - w:375px, h:844px" arrow>
                    <PhoneAndroidIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() => resizeEditor(editor, "iPhone13Mini")}
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      iPhone 13 Mini - 375px, 844px
                    </Button>
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip title="iPhone 14 Plus - w:428px, h:926px" arrow>
                    <PhoneAndroidIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() => resizeEditor(editor, "iPhone14Plus")}
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      iPhone 14 Plus - 428px, 926px
                    </Button>
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip title="iPhone 14 Pro Max - w:430px, h:932px" arrow>
                    <PhoneAndroidIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() => resizeEditor(editor, "iPhone14ProMax")}
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      iPhone 14 Pro Max - 430px, 932px
                    </Button>
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip title="Pixel 7 - w:412px, h:915px" arrow>
                    <PhoneAndroidIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() => resizeEditor(editor, "Pixel7")}
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      Pixel 7 - 412px, 915px
                    </Button>
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip title="Samsung Galaxy S8+ - w:360px, h:740px" arrow>
                    <PhoneAndroidIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() => resizeEditor(editor, "SamsungGalaxyS8")}
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      Samsung Galaxy S8+ - 360px, 740px
                    </Button>
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip
                    title="Samsung Galaxy S20 Ultra - w:412px, h:915px"
                    arrow
                  >
                    <PhoneAndroidIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() =>
                        resizeEditor(editor, "SamsungGalaxyS20Ultra")
                      }
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      Samsung Galaxy S20 Ultra - 412px, 915px
                    </Button>
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip title="Galaxy Fold - w:280px, h:653px" arrow>
                    <PhoneAndroidIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() => resizeEditor(editor, "GalaxyFold")}
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      Galaxy Fold - 280px, 653px
                    </Button>
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  onClick={() => setAnchorEl(null)}
                  sx={{ paddingRight: "2em" }}
                >
                  <Tooltip
                    title="Samsung Galaxy A51/71 - w:412px, h:914px"
                    arrow
                  >
                    <PhoneAndroidIcon
                      sx={{
                        color: "black",
                        marginRight: "5%",
                        "&:hover": { color: "orange" },
                      }}
                    />
                    <Button
                      onClick={() => resizeEditor(editor, "SamsungGalaxyA5171")}
                      sx={{
                        backgroundColor: "transparent",
                        width: "max-content",
                        padding: "0",
                      }}
                    >
                      Samsung Galaxy A51/71 - 412px, 914px
                    </Button>
                  </Tooltip>
                </MenuItem>
              </Menu>
            </Box>

            <div className="panel__editor"></div>
            {/* File input element */}
            <input
              type="file"
              id="file-input"
              accept=".csv, .xlsx"
              ref={xlFileInputRef}
              style={{ display: "none" }} // Hide the input element
            />
            <div className="panel__basic-actions"></div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              marginLeft: "1.5rem",
            }}
          >
            {/*<Tooltip title="Mobile Preview" arrow>
              <Paper elevation={3} sx={{ padding: "0.5rem", mr: 2 }}>
                <Link to={`/mobile_preview/${pageId}`} target="_blank">
                  <PhoneAndroidIcon
                    sx={{ color: "black", "&:hover": { color: "orange" } }}
                  />
                </Link>
              </Paper>
            </Tooltip>*/}

            {/*<Tooltip title="Tablet Preview" arrow>
              <Paper elevation={3} sx={{ padding: "0.5rem", mr: 2 }}>
                <Link to={`/tab_preview/${pageId}`} target="_blank">
                  <TabletIcon
                    sx={{ color: "black", "&:hover": { color: "orange" } }}
                  />
                </Link>
              </Paper>
            </Tooltip>*/}

            <Tooltip title="Preview" arrow>
              <Paper elevation={3} sx={{ padding: "0.5rem", mr: 2 }}>
                <Link to={`/large_preview/${pageId}`} target="_blank">
                  <PreviewIcon
                    sx={{ color: "black", "&:hover": { color: "orange" } }}
                  />
                </Link>
              </Paper>
            </Tooltip>

            {/*<div>
              <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                Preview
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                <MenuItem onClick={() => setAnchorEl(null)}>
                  <Tooltip title="Default Browser Dimensions" arrow>
                    <Link to={`/large_preview/${pageId}`} target="_blank" style={{textDecoration: "none", color: "blue", "&:hover": {color: "orange"}}}>
                      <LaptopMacIcon
                        sx={{ color: "black", marginRight: "5%", "&:hover": { color: "orange" } }}
                      />
                      Default
                    </Link>
                  </Tooltip>
                </MenuItem>

                <MenuItem onClick={() => setAnchorEl(null)}>
                  <Tooltip title="Laptop - w:1024px, h:100%" arrow>
                    <Link to={`/large_preview/1024px/${pageId}`} target="_blank" style={{textDecoration: "none", color: "blue", "&:hover": {color: "orange"}}}>
                      <LaptopMacIcon
                        sx={{ color: "black", marginRight: "5%", "&:hover": { color: "orange" } }}
                      />
                      Laptop - 1024px
                    </Link>
                  </Tooltip>
                </MenuItem>
                
                <MenuItem onClick={() => setAnchorEl(null)}>
                  <Tooltip title="Laptop - w:1440px, h:100%" arrow>
                    <Link to={`/large_preview/1440px/${pageId}`} target="_blank" style={{textDecoration: "none", color: "blue", "&:hover": {color: "orange"}}}>
                      <LaptopMacIcon
                        sx={{ color: "black", marginRight: "5%", "&:hover": { color: "orange" } }}
                      />
                      Laptop - 1440px
                    </Link>
                  </Tooltip>
                </MenuItem>
                
                <MenuItem onClick={() => setAnchorEl(null)}>
                  <Tooltip title="Laptop - w:2560px, h:100%" arrow>
                    <Link to={`/large_preview/2560px/${pageId}`} target="_blank" style={{textDecoration: "none", color: "blue", "&:hover": {color: "orange"}}}>
                      <LaptopMacIcon
                        sx={{ color: "black", marginRight: "5%", "&:hover": { color: "orange" } }}
                      />
                      Laptop - 2560px
                    </Link>
                  </Tooltip>
                </MenuItem>

                <Divider />
                
                <MenuItem onClick={() => setAnchorEl(null)}>
                  <Tooltip title="iPhone SE - w:375px, h:667px" arrow>
                    <Link to={`/large_preview/375px/667px/${pageId}`} target="_blank" style={{textDecoration: "none", color: "blue", "&:hover": {color: "orange"}}}>
                      <PhoneAndroidIcon
                        sx={{ color: "black", marginRight: "5%", "&:hover": { color: "orange" } }}
                      />
                      iPhone SE
                    </Link>
                  </Tooltip>
                </MenuItem>
                
                <MenuItem onClick={() => setAnchorEl(null)}>
                  <Tooltip title="iPhone XR - w:414px, h:896px" arrow>
                    <Link to={`/large_preview/414px/896px/${pageId}`} target="_blank" style={{textDecoration: "none", color: "blue", "&:hover": {color: "orange"}}}>
                      <PhoneAndroidIcon
                        sx={{ color: "black", marginRight: "5%", "&:hover": { color: "orange" } }}
                      />
                      iPhone XR
                    </Link>
                  </Tooltip>
                </MenuItem>
                
                <MenuItem onClick={() => setAnchorEl(null)}>
                  <Tooltip title="iPhone 12 Pro - w:390px, h:844px" arrow>
                    <Link to={`/large_preview/390px/844px/${pageId}`} target="_blank" style={{textDecoration: "none", color: "blue", "&:hover": {color: "orange"}}}>
                      <PhoneAndroidIcon
                        sx={{ color: "black", marginRight: "5%", "&:hover": { color: "orange" } }}
                      />
                      iPhone 12 Pro
                    </Link>
                  </Tooltip>
                </MenuItem>
                
                <MenuItem onClick={() => setAnchorEl(null)}>
                  <Tooltip title="iPhone 14 Pro Max - w:430px, h:932px" arrow>
                    <Link to={`/large_preview/430px/932px/${pageId}`} target="_blank" style={{textDecoration: "none", color: "blue", "&:hover": {color: "orange"}}}>
                      <PhoneAndroidIcon
                        sx={{ color: "black", marginRight: "5%", "&:hover": { color: "orange" } }}
                      />
                      iPhone 14 Pro Max
                    </Link>
                  </Tooltip>
                </MenuItem>
              </Menu>
            </div>*/}
          </div>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "start",
              marginLeft: "0.5rem",
            }}
          >
            <Avatar sx={{ bgcolor: "orange" }}>
              {userInfoFromStorage?.name.split("")[0]}
            </Avatar>
            <Box sx={{ ml: 1 }}>
              <Typography
                sx={{
                  fontFamily: "Mont-Heavy",
                  fontSize: "0.9rem",
                  fontWeight: "800",
                  letterSpacing: "0.1rem",
                }}
              >
                {userInfoFromStorage?.name}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Mont-Regular",
                  fontSize: "0.8rem",
                  color: "gray",
                }}
              >
                {userInfoFromStorage?.is_admin ? "ADMIN" : "Employee"}
              </Typography>
            </Box>
            <LogoutIcon
              onClick={logOutHandler}
              sx={{
                marginLeft: "0.5rem",
                cursor: "pointer",
                "&:hover": { color: "orange" },
              }}
            />
          </Box>
        </Grid>

        {/*<Grid id="basic-actions" item xs={10} sx={{ display: 'flex', justifyContent: 'flex-end', height: '100%', alignItems: 'center' }}>*/}
        {/*<Tooltip title="Save" arrow>
                        <Paper onClick={handleSaveDb} elevation={3} sx={{ padding: '0.5rem', mr: 2 }}>
                            <SaveAsIcon sx={{ color: 'gray', '&:hover': { color: 'orange' } }} />
                        </Paper>
                    </Tooltip>
                    <Tooltip title="Clear Canvas" arrow>
                        <Paper onClick={clearCanvas} elevation={3} sx={{ padding: '0.5rem', mr: 2 }}>
                            <DeleteIcon sx={{ color: 'gray', '&:hover': { color: 'orange' } }} />
                        </Paper>
                    </Tooltip>
                    <Tooltip title="Undo" arrow>
                        <Paper onClick={undoCanvas} elevation={3} sx={{ padding: '0.5rem', mr: 2 }}>
                            <RestoreIcon sx={{ color: 'gray', '&:hover': { color: 'orange' } }} />
                        </Paper>
                    </Tooltip>
                    <Tooltip title="Redo" arrow>
                        <Paper onClick={resetCanvas} elevation={3} sx={{ padding: '0.5rem', mr: 2 }}>
                            <UpdateIcon sx={{ color: 'gray', '&:hover': { color: 'orange' } }} />
                        </Paper>
                    </Tooltip>
                    <Tooltip title="Download" arrow>
                        <Paper onClick={exportFiles} elevation={3} sx={{ padding: '0.5rem', mr: 2 }}>
                            <SimCardDownloadIcon sx={{ color: 'gray', '&:hover': { color: 'orange' } }} />
                        </Paper>
                    </Tooltip>*/}

        {/*<Tooltip title="Mobile Preview" arrow>
                        <Paper elevation={3} sx={{ padding: '0.5rem', mr: 2 }}>
                            <Link to={`/mobile_preview/${pageId}`} target="_blank"  >
                                <PhoneAndroidIcon sx={{ color: 'gray', '&:hover': { color: 'orange' } }} />
                            </Link>
                        </Paper>
                    </Tooltip>
                    <Tooltip title="Tablet Preview" arrow>
                        <Paper elevation={3} sx={{ padding: '0.5rem', mr: 2 }}>
                            <Link to={`/tab_preview/${pageId}`} target="_blank" >
                                <TabletIcon sx={{ color: 'gray', '&:hover': { color: 'orange' } }} />
                            </Link>
                        </Paper>
                    </Tooltip>
                    <Tooltip title="Laptop Preview" arrow>
                        <Paper elevation={3} sx={{ padding: '0.5rem', mr: 2 }}>
                            <Link to={`/large_preview/${pageId}`} target="_blank" >
                                <LaptopMacIcon sx={{ color: 'gray', '&:hover': { color: 'orange' } }} />
                            </Link>
                        </Paper>
                    </Tooltip>*/}
        {/*</Grid>*/}
      </Grid>

      <Grid
        container
        id="mainWrapperNew"
        xs={12}
        sx={{ width: "100%", mt: "5rem", position: "relative" }}
      >
        <Grid
          onMouseOut={hoverExistHandler}
          onMouseOver={hoverSidebarHandler}
          item
          md={hoverStart ? 2.5 : 0.48}
          xl={hoverStart ? 2 : 0.48}
          sx={{
            height: "89vh",
            transitionDuration: "0.5s",
          }}
        >
          <Scrollbar
            trackYProps={{ style: trackStyles }}
            thumbYProps={{ style: thumbStyles }}
            style={{ height: "100%" }}
          >
            <Box
              onClick={() => {
                setShowDashboardSub(!showDashboardSub);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderTop: "1px solid #d1d5db",
                borderBottom: "1px solid #d1d5db",
                bgcolor: showDashboardSub ? "#a5f3fc" : "",
                cursor: "pointer",
              }}
            >
              <CottageIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Dashboard
              </Typography>
              {showDashboardSub ? (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: showDashboardSub ? "#0e7490" : "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                    transform: "rotate(90deg)",
                  }}
                />
              ) : (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                  }}
                />
              )}
            </Box>

            {/* DASHBOARD SUB CATEGORY */}
            {showDashboardSub && (
              <>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Business");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Business
                  </Typography>
                </Box>
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Helpdesk");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Helpdesk
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Social");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Social
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Enterprise");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Enterprise
                  </Typography>
                </Box>*/}
              </>
            )}

            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(!showWidgetSub);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showWidgetSub ? "#a5f3fc" : "",
                cursor: "pointer",
              }}
            >
              <WidgetsIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Widgets
              </Typography>
              {showWidgetSub ? (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: showWidgetSub ? "#0e7490" : "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                    transform: "rotate(90deg)",
                  }}
                />
              ) : (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                  }}
                />
              )}
            </Box>

            {/* WIDGETS SUB CATEGORY */}
            {showWidgetSub && (
              <>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Basic");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - General
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Extra");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Calendar
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Charts");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Chart
                  </Typography>
                </Box>
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Google");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Analytics
                  </Typography>
                </Box>*/}
              </>
            )}

            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(!showUiKitSub);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showUiKitSub ? "#a5f3fc" : "",
                cursor: "pointer",
              }}
            >
              <ConstructionIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Ui Kits
              </Typography>
              {showUiKitSub ? (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: showUiKitSub ? "#0e7490" : "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                    transform: "rotate(90deg)",
                  }}
                />
              ) : (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                  }}
                />
              )}
            </Box>

            {/* UI KITS SUB CATEGORY */}
            {showUiKitSub && (
              <>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Typography");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Typography
                  </Typography>
                </Box>
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Avatar");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Avatars
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Helper Classes");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Helper classes
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Grid");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Grid
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Tag & pills");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Tag & pills
                  </Typography>
                </Box>*/}
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Progress");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Progress
                  </Typography>
                </Box>
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Modal");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Modal
                  </Typography>
                </Box>*/}
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Alert");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Alert
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Popover");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Popover
                  </Typography>
                </Box>
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Tooltip");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Tooltip
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Spinners");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Spinners
                  </Typography>
                </Box>*/}
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Dropdown");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Dropdown
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Accordion");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Accordion
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Tabs");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Tabs
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Navs");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Navs
                  </Typography>
                </Box>
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Shadow");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Shadow
                  </Typography>
                </Box>*/}
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Lists");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Lists
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Menus");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Menus
                  </Typography>
                </Box>
              </>
            )}

            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(!showBonusSub);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showBonusSub ? "#a5f3fc" : "",
                cursor: "pointer",
              }}
            >
              <RedeemIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Bonus Ui
              </Typography>
              {showBonusSub ? (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: showBonusSub ? "#0e7490" : "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                    transform: "rotate(90deg)",
                  }}
                />
              ) : (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                  }}
                />
              )}
            </Box>

            {/* BONUS SUB CATEGORY */}
            {showBonusSub && (
              <>
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Scrollable");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Scrollable
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Tree View");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Tree view
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Bootstrap Notify");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Bootstrap Notify
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Rating");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Rating
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("dropzone");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Dropzone
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Tour");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Tour
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("SweetAlert2");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - SweetAlert2
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Animated Modal");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Animated Modal
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Owl Carousel");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Owl Carousel
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Ribbons");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Ribbons
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Pagination");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Pagination
                  </Typography>
                </Box>*/}
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Steps");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Steps
                  </Typography>
                </Box>
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Breadcrumb");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Breadcrumb
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Range Slider");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Range Slider
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Image Cropper");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Image cropper
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Sticky");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Sticky
                  </Typography>
                </Box>*/}
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Basic Card");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Basic Card
                  </Typography>
                </Box>
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Creative Card");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Creative Card
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Tabbed Card");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Tabbed Card
                  </Typography>
                </Box>*/}
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Draggable Card");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Draggable Card
                  </Typography>
                </Box>
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Timeline");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Timeline
                  </Typography>
                </Box>*/}
              </>
            )}
            {/* 
                        <Box onClick={() => {
                            setShowDashboardSub(false)
                            setShowWidgetSub(false)
                            setShowAnimationSub(false)
                            setShowBonusSub(false)
                            setShowBuilderSub(false)
                            setShowButtons(false)
                            setShowChartSub(false)
                            setShowFormSub(false)
                            setShowIconSub(false)
                            setShowLayoutSub(!showLayoutSub)
                            setShowPagesSub(false)
                            setShowTableSub(false)
                            setShowUiKitSub(false)
                        }} sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', py: 1.6, px: 1, borderBottom: '1px solid #d1d5db', bgcolor: showLayoutSub ? '#a5f3fc' : '', cursor: 'pointer' }}>
                            <AutoAwesomeMosaicIcon sx={{ fontSize: hoverStart ? '1.2rem' : '2rem', color: '#6b7280', width: hoverStart ? '20%' : '100%' }} />
                            <Typography sx={{ fontFamily: 'Mont-Regular', mt: 0.5, width: '60%', display: hoverStart ? 'block' : 'none' }}>Page Layout</Typography>
                            {
                                showLayoutSub ? <KeyboardDoubleArrowRightIcon sx={{ fontSize: '1.2rem', color: showLayoutSub ? '#0e7490' : '#6b7280', width: '20%', display: hoverStart ? 'block' : 'none', transform: 'rotate(90deg)' }} /> : <KeyboardDoubleArrowRightIcon sx={{ fontSize: '1.2rem', color: '#6b7280', width: '20%', display: hoverStart ? 'block' : 'none' }} />
                            }
                        </Box> */}

            {/* LAYOUT SUB CATEGORY */}
            {/* {
                            showLayoutSub && <>
                                <Box sx={{ justifyContent: 'space-around', alignItems: 'center', py: 1.6, px: 1, borderBottom: '1px solid #d1d5db', display: hoverStart ? 'flex' : 'none' }}>
                                    <Typography sx={{ fontFamily: 'Mont-Regular', mt: 0.5, width: '60%', fontSize: '0.9rem', color: 'gray' }}>- Boxed</Typography>
                                </Box>
                                <Box sx={{ justifyContent: 'space-around', alignItems: 'center', py: 1.6, px: 1, borderBottom: '1px solid #d1d5db', display: hoverStart ? 'flex' : 'none' }}>
                                    <Typography sx={{ fontFamily: 'Mont-Regular', mt: 0.5, width: '60%', fontSize: '0.9rem', color: 'gray' }}>- RTL</Typography>
                                </Box>
                                <Box sx={{ justifyContent: 'space-around', alignItems: 'center', py: 1.6, px: 1, borderBottom: '1px solid #d1d5db', display: hoverStart ? 'flex' : 'none' }}>
                                    <Typography sx={{ fontFamily: 'Mont-Regular', mt: 0.5, width: '60%', fontSize: '0.9rem', color: 'gray' }}>- Light Layout</Typography>
                                </Box>
                                <Box sx={{ justifyContent: 'space-around', alignItems: 'center', py: 1.6, px: 1, borderBottom: '1px solid #d1d5db', display: hoverStart ? 'flex' : 'none' }}>
                                    <Typography sx={{ fontFamily: 'Mont-Regular', mt: 0.5, width: '60%', fontSize: '0.9rem', color: 'gray' }}>- Dark Layout</Typography>
                                </Box>
                                <Box sx={{ justifyContent: 'space-around', alignItems: 'center', py: 1.6, px: 1, borderBottom: '1px solid #d1d5db', display: hoverStart ? 'flex' : 'none' }}>
                                    <Typography sx={{ fontFamily: 'Mont-Regular', mt: 0.5, width: '60%', fontSize: '0.9rem', color: 'gray' }}>- Hide Nav Scroll</Typography>
                                </Box>
                                <Box sx={{ justifyContent: 'space-around', alignItems: 'center', py: 1.6, px: 1, borderBottom: '1px solid #d1d5db', display: hoverStart ? 'flex' : 'none' }}>
                                    <Typography sx={{ fontFamily: 'Mont-Regular', mt: 0.5, width: '60%', fontSize: '0.9rem', color: 'gray' }}>- Footer Light</Typography>
                                </Box>
                                <Box sx={{ justifyContent: 'space-around', alignItems: 'center', py: 1.6, px: 1, borderBottom: '1px solid #d1d5db', display: hoverStart ? 'flex' : 'none' }}>
                                    <Typography sx={{ fontFamily: 'Mont-Regular', mt: 0.5, width: '60%', fontSize: '0.9rem', color: 'gray' }}>- Footer Dark</Typography>
                                </Box>
                                <Box sx={{ justifyContent: 'space-around', alignItems: 'center', py: 1.6, px: 1, borderBottom: '1px solid #d1d5db', display: hoverStart ? 'flex' : 'none' }}>
                                    <Typography sx={{ fontFamily: 'Mont-Regular', mt: 0.5, width: '60%', fontSize: '0.9rem', color: 'gray' }}>- Footer Fixed</Typography>
                                </Box>

                            </>
                        } */}

            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(!showBuilderSub);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showBuilderSub ? "#a5f3fc" : "",
                cursor: "pointer",
              }}
            >
              <BorderColorIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Builders
              </Typography>
              {showBuilderSub ? (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: showBuilderSub ? "#0e7490" : "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                    transform: "rotate(90deg)",
                  }}
                />
              ) : (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                  }}
                />
              )}
            </Box>

            {/* BUILDER SUB CATEGORY */}
            {showBuilderSub && (
              <>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Form-Control");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Form Builder 1
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Form-Control");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Form Builder 2
                  </Typography>
                </Box>
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Page Builder");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Page Builder
                  </Typography>
                </Box>*/}
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Buttons");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Button Builder
                  </Typography>
                </Box>
              </>
            )}

            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(!showAnimationSub);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showAnimationSub ? "#a5f3fc" : "",
                cursor: "pointer",
              }}
            >
              <ThunderstormIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Animation
              </Typography>
              {showAnimationSub ? (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: showAnimationSub ? "#0e7490" : "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                    transform: "rotate(90deg)",
                  }}
                />
              ) : (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                  }}
                />
              )}
            </Box>

            {/* ANIMATION SUB CATEGORY */}
            {showAnimationSub && (
              <>
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Animate");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Animate
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Scroll Reveal");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Scroll Reveal
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("AOS animation");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - AOS animation
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Tilt Animation");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Tilt Animation
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Wow Animation");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Wow Animation
                  </Typography>
                </Box>*/}
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("3D Simulation");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - 3D Simulation
                  </Typography>
                </Box>
              </>
            )}

            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(!showIconSub);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showIconSub ? "#a5f3fc" : "",
                cursor: "pointer",
              }}
            >
              <AddReactionIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Icons
              </Typography>
              {showIconSub ? (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: showIconSub ? "#0e7490" : "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                    transform: "rotate(90deg)",
                  }}
                />
              ) : (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                  }}
                />
              )}
            </Box>

            {/* ICONS SUB CATEGORY */}
            {showIconSub && (
              <>
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Icons");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Flag Icon
                  </Typography>
                </Box>*/}
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Font Awesome");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Font Awesome
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Ico Icon");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Ico Icon
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Themify Icon");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Themify Icon
                  </Typography>
                </Box>
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Feather Icon");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Feather Icon
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Whether Icon");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Whether Icon
                  </Typography>
                </Box>*/}
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Simple Line Icon");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Simple Line Icon
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Material Design Icon");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Material Design Icon
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("pe7 Icon");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Pe7 Icon
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Typicons Icon");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Typicons Icon
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Ionic Icon");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Ionic Icon
                  </Typography>
                </Box>
              </>
            )}

            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(!showButtons);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showButtons ? "#a5f3fc" : "",
              }}
            >
              <SmartButtonIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: showButtons ? "#0e7490" : "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                  color: showButtons ? "#0e7490" : "",
                }}
              >
                Buttons
              </Typography>
              {showButtons ? (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: showButtons ? "#0e7490" : "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                    transform: "rotate(90deg)",
                  }}
                />
              ) : (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                  }}
                />
              )}
            </Box>

            {/* BUTTONS SUB CATEGORY */}
            {showButtons && (
              <>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Buttons");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Default Style
                  </Typography>
                </Box>
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Flat Style");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Flat Style
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Edge Style");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Edge Style
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Raised Style");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Raised Style
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Button Group");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Button Group
                  </Typography>
                </Box>*/}
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Floating");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Floating
                  </Typography>
                </Box>
              </>
            )}

            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(!showFormSub);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showFormSub ? "#a5f3fc" : "",
              }}
            >
              <InsertDriveFileIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Forms
              </Typography>
              {showFormSub ? (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: showFormSub ? "#0e7490" : "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                    transform: "rotate(90deg)",
                  }}
                />
              ) : (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                  }}
                />
              )}
            </Box>

            {/* FORM SUB CATEGORY */}
            {showFormSub && (
              <>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Form-Control");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Form Controls
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Form Widgets");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Form Widgets
                  </Typography>
                </Box>
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Form-layout");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Form layout
                  </Typography>
                </Box>*/}
              </>
            )}

            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(!showTableSub);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showTableSub ? "#a5f3fc" : "",
              }}
            >
              <DnsIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Tables
              </Typography>
              {showTableSub ? (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: showTableSub ? "#0e7490" : "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                    transform: "rotate(90deg)",
                  }}
                />
              ) : (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                  }}
                />
              )}
            </Box>

            {/* TABLE SUB CATEGORY */}
            {showTableSub && (
              <>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Bootstrap Tables");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Bootstrap Tables
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Data-Table");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Data Tables
                  </Typography>
                </Box>
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Ex. Data Tables");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Ex. Data Tables
                  </Typography>
                </Box>*/}
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Js-Data-Table");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Js Data Table
                  </Typography>
                </Box>
              </>
            )}

            {/*<Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(!showChartSub);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showChartSub ? "#a5f3fc" : "",
              }}>
              <AddchartIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}>
                Charts
              </Typography>
              {showChartSub ? (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: showChartSub ? "#0e7490" : "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                    transform: "rotate(90deg)",
                  }}
                />
              ) : (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                  }}
                />
              )}
            </Box>*/}

            {/* CHARTS SUB CATEGORY */}
            {/*{showChartSub && (
              <>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Charts");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Apex Chart
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Google Chart");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Google Chart
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Sparkline Chart");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Sparkline Chart
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Flot Chart");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Flot Chart
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Knob Chart");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Knob Chart
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Morris Chart");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Morris Chart
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Charts");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - ChartJs Charts
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Chartist Chart");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Chartist Chart
                  </Typography>
                </Box>
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Peity Chart");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Peity Chart
                  </Typography>
                </Box>
              </>
            )}*/}

            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(!showPagesSub);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showPagesSub ? "#a5f3fc" : "",
              }}
            >
              <WindowIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Pages
              </Typography>
              {showPagesSub ? (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: showPagesSub ? "#0e7490" : "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                    transform: "rotate(90deg)",
                  }}
                />
              ) : (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: "#6b7280",
                    width: "20%",
                    display: hoverStart ? "block" : "none",
                  }}
                />
              )}
            </Box>

            {/* PAGES SUB CATEGORY */}
            {showPagesSub && (
              <>
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Landing Page");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Landing Page
                  </Typography>
                </Box>*/}
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Sample Page");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Sample Page
                  </Typography>
                </Box>*/}
                <Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Login Page");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}
                  >
                    - Login Page
                  </Typography>
                </Box>
                {/*<Box
                  onClick={() => {
                    setShowRightSideBar(true);
                    setUserSelectedActionFromLeftBar("Progressive Page");
                  }}
                  sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1.6,
                    px: 1,
                    borderBottom: "1px solid #d1d5db",
                    display: hoverStart ? "flex" : "none",
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Mont-Regular",
                      mt: 0.5,
                      width: "60%",
                      fontSize: "0.9rem",
                      color: "gray",
                    }}>
                    - Progressive Page
                  </Typography>
                </Box>*/}
              </>
            )}

            {/* BLOGS */}
            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showPagesSub ? "#a5f3fc" : "",
              }}
            >
              <WindowIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                onClick={() => {
                  setShowRightSideBar(true);
                  setUserSelectedActionFromLeftBar("Blog");
                }}
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Blogs
              </Typography>
              <KeyboardDoubleArrowRightIcon
                sx={{
                  fontSize: "1.2rem",
                  color: "#6b7280",
                  width: "20%",
                  display: hoverStart ? "block" : "none",
                }}
              />
            </Box>

            {/* CONTACT */}
            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showPagesSub ? "#a5f3fc" : "",
              }}
            >
              <WindowIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                onClick={() => {
                  setShowRightSideBar(true);
                  setUserSelectedActionFromLeftBar("Contact");
                }}
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Contact Form
              </Typography>
              <KeyboardDoubleArrowRightIcon
                sx={{
                  fontSize: "1.2rem",
                  color: "#6b7280",
                  width: "20%",
                  display: hoverStart ? "block" : "none",
                }}
              />
            </Box>

            {/* Content */}
            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showPagesSub ? "#a5f3fc" : "",
              }}
            >
              <WindowIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                onClick={() => {
                  setShowRightSideBar(true);
                  setUserSelectedActionFromLeftBar("Content");
                }}
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Content
              </Typography>
              <KeyboardDoubleArrowRightIcon
                sx={{
                  fontSize: "1.2rem",
                  color: "#6b7280",
                  width: "20%",
                  display: hoverStart ? "block" : "none",
                }}
              />
            </Box>

            {/* CTA */}
            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showPagesSub ? "#a5f3fc" : "",
              }}
            >
              <WindowIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                onClick={() => {
                  setShowRightSideBar(true);
                  setUserSelectedActionFromLeftBar("CTA");
                }}
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                CTA
              </Typography>
              <KeyboardDoubleArrowRightIcon
                sx={{
                  fontSize: "1.2rem",
                  color: "#6b7280",
                  width: "20%",
                  display: hoverStart ? "block" : "none",
                }}
              />
            </Box>

            {/* Commerce */}
            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showPagesSub ? "#a5f3fc" : "",
              }}
            >
              <WindowIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                onClick={() => {
                  setShowRightSideBar(true);
                  setUserSelectedActionFromLeftBar("Commerce");
                }}
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Commerce
              </Typography>
              <KeyboardDoubleArrowRightIcon
                sx={{
                  fontSize: "1.2rem",
                  color: "#6b7280",
                  width: "20%",
                  display: hoverStart ? "block" : "none",
                }}
              />
            </Box>

            {/* Features */}
            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showPagesSub ? "#a5f3fc" : "",
              }}
            >
              <WindowIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                onClick={() => {
                  setShowRightSideBar(true);
                  setUserSelectedActionFromLeftBar("Features");
                }}
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Features
              </Typography>
              <KeyboardDoubleArrowRightIcon
                sx={{
                  fontSize: "1.2rem",
                  color: "#6b7280",
                  width: "20%",
                  display: hoverStart ? "block" : "none",
                }}
              />
            </Box>

            {/* Footer */}
            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showPagesSub ? "#a5f3fc" : "",
              }}
            >
              <WindowIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                onClick={() => {
                  setShowRightSideBar(true);
                  setUserSelectedActionFromLeftBar("Footer");
                }}
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Footer
              </Typography>
              <KeyboardDoubleArrowRightIcon
                sx={{
                  fontSize: "1.2rem",
                  color: "#6b7280",
                  width: "20%",
                  display: hoverStart ? "block" : "none",
                }}
              />
            </Box>

            {/* Gallery */}
            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showPagesSub ? "#a5f3fc" : "",
              }}
            >
              <WindowIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                onClick={() => {
                  setShowRightSideBar(true);
                  setUserSelectedActionFromLeftBar("Gallery");
                }}
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Gallery
              </Typography>
              <KeyboardDoubleArrowRightIcon
                sx={{
                  fontSize: "1.2rem",
                  color: "#6b7280",
                  width: "20%",
                  display: hoverStart ? "block" : "none",
                }}
              />
            </Box>

            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showPagesSub ? "#a5f3fc" : "",
              }}
            >
              <WindowIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                onClick={() => {
                  setShowRightSideBar(true);
                  setUserSelectedActionFromLeftBar("Header");
                }}
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Header
              </Typography>
              <KeyboardDoubleArrowRightIcon
                sx={{
                  fontSize: "1.2rem",
                  color: "#6b7280",
                  width: "20%",
                  display: hoverStart ? "block" : "none",
                }}
              />
            </Box>

            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showPagesSub ? "#a5f3fc" : "",
              }}
            >
              <WindowIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                onClick={() => {
                  setShowRightSideBar(true);
                  setUserSelectedActionFromLeftBar("Hero");
                }}
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Hero
              </Typography>
              <KeyboardDoubleArrowRightIcon
                sx={{
                  fontSize: "1.2rem",
                  color: "#6b7280",
                  width: "20%",
                  display: hoverStart ? "block" : "none",
                }}
              />
            </Box>

            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showPagesSub ? "#a5f3fc" : "",
              }}
            >
              <WindowIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                onClick={() => {
                  setShowRightSideBar(true);
                  setUserSelectedActionFromLeftBar("Pricing");
                }}
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Pricing
              </Typography>
              <KeyboardDoubleArrowRightIcon
                sx={{
                  fontSize: "1.2rem",
                  color: "#6b7280",
                  width: "20%",
                  display: hoverStart ? "block" : "none",
                }}
              />
            </Box>

            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showPagesSub ? "#a5f3fc" : "",
              }}
            >
              <WindowIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                onClick={() => {
                  setShowRightSideBar(true);
                  setUserSelectedActionFromLeftBar("Statistics");
                }}
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Statistics
              </Typography>
              <KeyboardDoubleArrowRightIcon
                sx={{
                  fontSize: "1.2rem",
                  color: "#6b7280",
                  width: "20%",
                  display: hoverStart ? "block" : "none",
                }}
              />
            </Box>

            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showPagesSub ? "#a5f3fc" : "",
              }}
            >
              <WindowIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                onClick={() => {
                  setShowRightSideBar(true);
                  setUserSelectedActionFromLeftBar("Steps");
                }}
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Steps
              </Typography>
              <KeyboardDoubleArrowRightIcon
                sx={{
                  fontSize: "1.2rem",
                  color: "#6b7280",
                  width: "20%",
                  display: hoverStart ? "block" : "none",
                }}
              />
            </Box>

            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showPagesSub ? "#a5f3fc" : "",
              }}
            >
              <WindowIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                onClick={() => {
                  setShowRightSideBar(true);
                  setUserSelectedActionFromLeftBar("Team");
                }}
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Team
              </Typography>
              <KeyboardDoubleArrowRightIcon
                sx={{
                  fontSize: "1.2rem",
                  color: "#6b7280",
                  width: "20%",
                  display: hoverStart ? "block" : "none",
                }}
              />
            </Box>

            <Box
              onClick={() => {
                setShowDashboardSub(false);
                setShowWidgetSub(false);
                setShowAnimationSub(false);
                setShowBonusSub(false);
                setShowBuilderSub(false);
                setShowButtons(false);
                setShowChartSub(false);
                setShowFormSub(false);
                setShowIconSub(false);
                setShowLayoutSub(false);
                setShowPagesSub(false);
                setShowTableSub(false);
                setShowUiKitSub(false);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderBottom: "1px solid #d1d5db",
                bgcolor: showPagesSub ? "#a5f3fc" : "",
              }}
            >
              <WindowIcon
                sx={{
                  fontSize: hoverStart ? "1.2rem" : "2rem",
                  color: "#6b7280",
                  width: hoverStart ? "20%" : "100%",
                }}
              />
              <Typography
                onClick={() => {
                  setShowRightSideBar(true);
                  setUserSelectedActionFromLeftBar("Testimonials");
                }}
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "60%",
                  display: hoverStart ? "block" : "none",
                }}
              >
                Testimonials
              </Typography>
              <KeyboardDoubleArrowRightIcon
                sx={{
                  fontSize: "1.2rem",
                  color: "#6b7280",
                  width: "20%",
                  display: hoverStart ? "block" : "none",
                }}
              />
            </Box>

            {/* <Box sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', py: 1.6, px: 1, borderBottom: '1px solid #d1d5db' }}>
                            <Groups2Icon sx={{ fontSize: hoverStart ? '1.2rem' : '2rem', color: '#6b7280', width: hoverStart ? '20%' : '100%' }} />
                            <Typography sx={{ fontFamily: 'Mont-Regular', mt: 0.5, width: '60%', display: hoverStart ? 'block' : 'none' }}>Apps</Typography>
                            <KeyboardDoubleArrowRightIcon sx={{ fontSize: '1.2rem', color: '#6b7280', width: '20%', display: hoverStart ? 'block' : 'none' }} />
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', py: 1.6, px: 1, borderBottom: '1px solid #d1d5db' }}>
                            <AnchorIcon sx={{ fontSize: hoverStart ? '1.2rem' : '2rem', color: '#6b7280', width: hoverStart ? '20%' : '100%' }} />
                            <Typography sx={{ fontFamily: 'Mont-Regular', mt: 0.5, width: '60%', display: hoverStart ? 'block' : 'none' }}>Starter Kit</Typography>
                            <KeyboardDoubleArrowRightIcon sx={{ fontSize: '1.2rem', color: '#6b7280', width: '20%', display: hoverStart ? 'block' : 'none' }} />
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', py: 1.6, px: 1, borderBottom: '1px solid #d1d5db' }}>
                            <LayersIcon sx={{ fontSize: hoverStart ? '1.2rem' : '2rem', color: '#6b7280', width: hoverStart ? '20%' : '100%' }} />
                            <Typography sx={{ fontFamily: 'Mont-Regular', mt: 0.5, width: '60%', display: hoverStart ? 'block' : 'none' }}>Others</Typography>
                            <KeyboardDoubleArrowRightIcon sx={{ fontSize: '1.2rem', color: '#6b7280', width: '20%', display: hoverStart ? 'block' : 'none' }} />
                        </Box> */}
          </Scrollbar>
        </Grid>

        {/* MIDDLE SECTION FOR EDITOR */}
        <Grid
          id="mainWrapper"
          item
          md={
            showRightSideBar && hoverStart
              ? 7
              : showRightSideBar && !hoverStart
              ? 9.02
              : !showRightSideBar && hoverStart
              ? 9.02
              : 11.52
          }
          xl={
            showRightSideBar && hoverStart
              ? 8
              : showRightSideBar && !hoverStart
              ? 9.52
              : !showRightSideBar && hoverStart
              ? 9.52
              : 11.52
          }
          sx={{
            bgcolor: "rgba(246, 246, 246, 0.6)",
            transitionDuration: "0.8s",
            pb: 2,
            height: "89vh",
          }}
        >
          {isEditorLoading && <LinearProgress />}
          <Box ref={editorRef} id="fragmentEditor"></Box>

          {printPDF && (
            <div
              style={{ overflow: "hidden", height: 0, marginRight: "37.5%" }}
            >
              <PdfPreview
                ref={componentRef}
                showPrintDialog={showPrintDialog}
                printHTML={editor.getHtml()}
                printCSS={editor.getCss()}
              />
            </div>
          )}
        </Grid>

        {/* THE RIGHT SIDEBAR */}
        <Grid
          item
          md={showRightSideBar ? 2.5 : 0}
          xl={showRightSideBar ? 2 : 0}
          sx={{
            height: "89vh",
            overflowY: "scroll",
            transitionDuration: "0.8s",
            position: "relative",
          }}
        >
          <Scrollbar
            trackYProps={{ style: rightScrollTrackStyles }}
            thumbYProps={{ style: rightScrollThumbStyles }}
            style={{ height: "100%" }}
          >
            <Box
              onClick={() => {
                setShowDesign(!showDesign);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderTop: "1px solid #d1d5db",
                borderBottom: "1px solid #d1d5db",
                bgcolor: showDesign ? "#a5f3fc" : "",
                cursor: "pointer",
              }}
            >
              <WindowIcon
                sx={{ fontSize: "1rem", color: "#6b7280", width: "15%" }}
              />
              <Typography
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "70%",
                  fontSize: "0.9rem",
                }}
              >
                Design/Layouts{" "}
              </Typography>
              {showDesign ? (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: showDesign ? "#0e7490" : "#6b7280",
                    width: "15%",
                    transform: "rotate(90deg)",
                  }}
                />
              ) : (
                <KeyboardDoubleArrowRightIcon
                  sx={{ fontSize: "1.2rem", color: "#6b7280", width: "15%" }}
                />
              )}
            </Box>
            {/* BUTTON BLOCKS */}

            <Box
              ref={designAndLayoutRef}
              style={showDesign ? { display: "block" } : { display: "none" }}
            ></Box>

            <Box
              onClick={() => {
                setIsTraits(!isTraits);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderTop: "1px solid #d1d5db",
                borderBottom: "1px solid #d1d5db",
                bgcolor: isTraits ? "#a5f3fc" : "",
                cursor: "pointer",
              }}
            >
              <SettingsIcon
                sx={{ fontSize: "1rem", color: "#6b7280", width: "15%" }}
              />
              <Typography
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "70%",
                  fontSize: "0.9rem",
                }}
              >
                Manage Traits
              </Typography>
              {isTraits ? (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: isTraits ? "#0e7490" : "#6b7280",
                    width: "15%",
                    transform: "rotate(90deg)",
                  }}
                />
              ) : (
                <KeyboardDoubleArrowRightIcon
                  sx={{ fontSize: "1.2rem", color: "#6b7280", width: "15%" }}
                />
              )}
            </Box>
            <Box
              id="trait-container"
              style={isTraits ? { display: "block" } : { display: "none" }}
            ></Box>

            <Box
              onClick={() => {
                setIsLayerManager(!isLayerManager);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderTop: "1px solid #d1d5db",
                borderBottom: "1px solid #d1d5db",
                bgcolor: isLayerManager ? "#a5f3fc" : "",
                cursor: "pointer",
              }}
            >
              <LayersIcon
                sx={{ fontSize: "1rem", color: "#6b7280", width: "15%" }}
              />
              <Typography
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "70%",
                  fontSize: "0.9rem",
                }}
              >
                Layer Manager
              </Typography>
              {isLayerManager ? (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: isLayerManager ? "#0e7490" : "#6b7280",
                    width: "15%",
                    transform: "rotate(90deg)",
                  }}
                />
              ) : (
                <KeyboardDoubleArrowRightIcon
                  sx={{ fontSize: "1.2rem", color: "#6b7280", width: "15%" }}
                />
              )}
            </Box>
            <Box
              id="layer-container"
              style={
                isLayerManager ? { display: "block" } : { display: "none" }
              }
            ></Box>

            <Box
              onClick={() => {
                setIsStyles(!isStyles);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderTop: "1px solid #d1d5db",
                borderBottom: "1px solid #d1d5db",
                bgcolor: isStyles ? "#a5f3fc" : "",
                cursor: "pointer",
              }}
            >
              <BorderColorIcon
                sx={{ fontSize: "1rem", color: "#6b7280", width: "15%" }}
              />
              <Typography
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "70%",
                  fontSize: "0.9rem",
                }}
              >
                Manage Styles
              </Typography>
              {isStyles ? (
                <KeyboardDoubleArrowRightIcon
                  sx={{
                    fontSize: "1.2rem",
                    color: isStyles ? "#0e7490" : "#6b7280",
                    width: "15%",
                    transform: "rotate(90deg)",
                  }}
                />
              ) : (
                <KeyboardDoubleArrowRightIcon
                  sx={{ fontSize: "1.2rem", color: "#6b7280", width: "15%" }}
                />
              )}
            </Box>
            <Box
              id="styles-container"
              style={isStyles ? { display: "block" } : { display: "none" }}
            ></Box>
            {/* <Box
              onClick={() => navigate(`/editor/${pageId}/logic`)}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: 1.6,
                px: 1,
                borderTop: "1px solid #d1d5db",
                borderBottom: "1px solid #d1d5db",
                bgcolor: isLayerManager ? "#a5f3fc" : "",
                cursor: "pointer",
              }}>
              <SettingsIcon
                sx={{ fontSize: "1rem", color: "#6b7280", width: "20%" }}
              />
              <Typography
                sx={{
                  fontFamily: "Mont-Regular",
                  mt: 0.5,
                  width: "80%",
                  fontSize: "0.9rem",
                }}>
                Logic Builder
              </Typography>
            </Box> */}
          </Scrollbar>
          <Grid
            onClick={() => setShowRightSideBar(false)}
            sx={{
              position: "absolute",
              bottom: "0",
              width: "100%",
              padding: "0.5rem",
              boxShadow: 20,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              bgcolor: "whitesmoke",
            }}
          >
            <Typography sx={{ cursor: "pointer" }}>Close</Typography>
          </Grid>
        </Grid>
      </Grid>

      <ToastContainer autoClose={2000} />
    </div>
  );
};

const mapStateToProps = (state) => {
  // console.log(state);
  return {
    allFunctions: state.functions.functions,
    user: state.userLogin.userInfo,
  };
};

const executeFunction = async (func, variables, userInfo, args) => {
  try {
    // Check if the function code contains variables from TempVariables
    const usedVariables = [];
    const variableNames = variables.map((variable) => variable.name);
    console.log("ARGS ==== ", args);

    const ast = acorn.parse(func.code);
    console.log("AST === ", ast);
    simple(ast, {
      Identifier(node) {
        console.log("Variable Names === ", variableNames);
        console.log("Node == ", node);
        if (variableNames.includes(node.name)) {
          usedVariables.push(node.name);
        }
      },
      VariableDeclarator(node) {
        console.log("Variable Declarator Node == ", node);
        if (variableNames.includes(node.id.name)) {
          usedVariables.push(node.id.name);
        }
      },
    });

    if (usedVariables.length === 0) {
      console.log("No variables from TempVariables used in the function code.");
      // return;
    }

    // Prepare variableValues object
    const variableValues = {};
    const funcParams = func.code
      .slice(func.code.indexOf("(") + 1, func.code.indexOf(")"))
      .split(",")
      .map((item) => item.trim());

    let undefinedVariables = usedVariables.filter(
      (val) => !funcParams.includes(val)
    );

    undefinedVariables.forEach((varName) => {
      const variable = variables.find((v) => v.name === varName);
      if (variable) {
        if (variable.typeOfVar === "integer") {
          variableValues[varName] = parseInt(variable.currentValue);
        } else {
          variableValues[varName] = variable.currentValue;
        }
      } else {
        variableValues[varName] = undefined;
      }
    });

    console.log("FUNCNCODE --- ", func.code);

    const funcBody = func.code
      .slice(func.code.indexOf("{") + 1, func.code.lastIndexOf("}"))
      .trim();

    let variableDeclarations = Object.keys(variableValues)
      .map((key) => `let ${key} = ${JSON.stringify(variableValues[key])};`)
      .join(" ");

    console.log("FUCN PARAMS -- ", funcParams);
    console.log("Variablv ebvasless ---- ", variableValues);
    const dynamicFunc = new Function(
      ...funcParams,
      `
          ${variableDeclarations}
          ${funcBody}
          return variableValues;
      `
    );

    // Execute the dynamic function
    const result = await dynamicFunc(...args);
    //   const userInfo = useSelector()
    // Update the currentValue of variables in the variables array
    for (const varName in result) {
      if (result.hasOwnProperty(varName)) {
        const variable = variables.find((v) => v.name === varName);
        if (variable) {
          console.log("variable ", variable);
          console.log("varname" + varName + "" + result[varName]);
          variable.currentValue = result[varName];
          console.log("BEfoer updateeee");
          const config = {
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${userInfo.token}`,
            },
          };
          if (result[varName]) {
            axios
              .put(
                `${API_HOST}temp_vars/update/${varName}`,
                { currentValue: result[varName] },
                config
              )
              .then((res) => {
                console.log("PUT sfsdfjsl ", res);
                console.log("updated variable values  ", result);
                // if(result[varname]) {
                window.alert("Updated : " + varName + " : " + result[varName]);
                // }
                console.log("Function executed successfully.");
              });
          }
        }
      }
    }
  } catch (error) {
    console.error("An error occurred while executing the function:", error);
  }
};

export default connect(mapStateToProps, { getAllFunctionsOfProject })(
  FragmentEditor
);
